import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { ChangeDetectorRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from 'src/libs/portal/season/service';

type LinkItem = {
    label: string;
    path: string;
    description?: string;
    icon?: string;
    external?: boolean;
};

type ServicePageId =
    'service-overview'
    | 'aida'
    | 'narda'
    | 'hosting-intro'
    | 'hosting-manage'
    | 'hosting-apply'
    | 'hosting-applications'
    | 'hosting-public'
    | 'open-api'
    | 'api-apply'
    | 'oai-pmh'
    | 'mcp'
    | 'community-my'
    | 'community-list';

type ServicePageAccessTone = 'public' | 'login' | 'external' | 'key' | 'blocked';

type ServicePage = LinkItem & {
    id: ServicePageId;
    category: string;
    officialPath: string;
    accessLabel: string;
    accessTone: ServicePageAccessTone;
    paths?: string[];
    originalStatus?: string;
};

type ServiceMenuLink = LinkItem & {
    officialPath: string;
    accessLabel: string;
};

type ServiceMenuGroup = {
    title: string;
    path: string;
    links: ServiceMenuLink[];
};

type LanguageCode = 'ko' | 'en';

const DATAON_SUBMIT_ROLE_STORAGE_KEY = 'DATAON_SUBMIT_ROLE';

type RuntimeTranslationMeta = {
    original: string;
    translated: string;
};

type MenuSection = LinkItem & {
    children: LinkItem[];
};

type MenuGroup = LinkItem & {
    children: LinkItem[];
    sections?: MenuSection[];
};

type DatasetItem = {
    title: string;
    date: string;
    tags: string[];
    icon: string;
};

type HomeStatCard = {
    label: string;
    value: string;
    unit?: string;
    description?: string;
    icon: string;
    path: string;
};

type HomeProviderTabId = 'domestic' | 'global';

type HomeProvider = {
    name: string;
    datasets: string;
    field: string;
    files?: string;
    path: string;
};

type HomeProviderTab = {
    id: HomeProviderTabId;
    label: string;
    totalLabel: string;
    totalValue: string;
    fileCount?: string;
    capacity?: string;
    items: HomeProvider[];
};

type HomeScienceField = {
    label: string;
    icon: string;
    path: string;
};

type HomeBoardTabId = 'notice' | 'news' | 'resources' | 'events';

type HomeBoardItem = {
    category: string;
    title: string;
    summary: string;
    date: string;
    path: string;
};

type HomeBoardTab = {
    id: HomeBoardTabId;
    label: string;
    path: string;
    items: HomeBoardItem[];
};

type HomeDataTabId = 'latest' | 'popular';

type HomeDataCard = {
    category: string;
    title: string;
    summary: string;
    path: string;
    metaLabel?: string;
    metaValue?: string;
    logo?: string;
    logoAlt?: string;
};

type HomeDataTab = {
    id: HomeDataTabId;
    label: string;
    items: HomeDataCard[];
};

type HomeUsageCard = {
    eyebrow: string;
    title: string;
    path: string;
};

type HomeLogoLink = {
    label: string;
    logo: string;
    path?: string;
    external?: boolean;
};

type HomeLogoSlide = {
    titleLines: string[];
    logos: HomeLogoLink[];
};

type SearchHelpItem = {
    operator: string;
    description: string;
    example: string;
};

type OfficialRelatedSearchTerm = {
    label: string;
    value: string;
};

type SearchTypeHelpItem = {
    label: string;
    description: string;
    icon: string;
};

type DatasetSearchConditionMode = 'all' | 'any';
type DatasetSearchAdvancedFieldKey =
    'searchScope'
    | 'searchTarget'
    | 'subject'
    | 'fileType'
    | 'createdYear'
    | 'createdYearStart'
    | 'createdYearEnd'
    | 'accessRight'
    | 'publisher'
    | 'creator'
    | 'contributor'
    | 'manager'
    | 'provider'
    | 'repository'
    | 'projectName'
    | 'principalInvestigator'
    | 'performingOrganization'
    | 'ministry'
    | 'researcherNumber'
    | 'ntisProjectNumber';
type DatasetSearchAdvancedFieldType = 'single' | 'multi' | 'text';

type DatasetSearchAdvancedOption = {
    label: string;
    value: string;
    count?: number;
};

type DatasetSearchAdvancedField = {
    key: DatasetSearchAdvancedFieldKey;
    label: string;
    type: DatasetSearchAdvancedFieldType;
    placeholder?: string;
    options?: DatasetSearchAdvancedOption[];
};

type DatasetSearchAdvancedValues = Record<DatasetSearchAdvancedFieldKey, string[]>;

type DatasetSearchAppliedFilter = {
    key: DatasetSearchAdvancedFieldKey;
    label: string;
    value: string;
    displayValue: string;
};

type DatasetSearchSummaryFilter = {
    key: DatasetSearchAdvancedFieldKey;
    label: string;
    values: string[];
    displayValue: string;
};

type ResultFilterReviewItem = {
    key: string;
    label: string;
    value: string;
    displayValue: string;
};

type DatasetSearchSort = 'relevance' | 'latest' | 'created' | 'downloads';
type SemanticSearchMode = 'keyword' | 'semantic';
type SearchMenuPageId =
    'datasets'
    | 'software'
    | 'integrated'
    | 'detail'
    | 'providers'
    | 'semantic'
    | 'issues'
    | 'issue-covid'
    | 'issue-gpcc'
    | 'issue-kaggle';
type SearchMenuPageConfig = {
    id: SearchMenuPageId;
    label: string;
    title: string;
    sectionLabel: string;
    path: string;
    aliases?: string[];
    description: string;
    placeholder: string;
    allResultsLabel: string;
    chips: string[];
    searchTargets?: string[];
    requiredKeywords?: string[];
    forceSemantic?: boolean;
    openAdvanced?: boolean;
};
type ContentTopSearchModeId = 'integrated' | 'detail' | 'map' | 'semantic';
type ContentTopSearchMode = {
    id: ContentTopSearchModeId;
    label: string;
    path: string;
    icon: string;
    placeholder: string;
};
type MapSearchSort = 'relevance' | 'latest' | 'title';
type MapSearchLoadState = 'idle' | 'loading' | 'ready' | 'error';
type MapSearchLocationState = 'idle' | 'locating' | 'ready' | 'error';
type MapSearchFilterKey = 'provider' | 'dataType' | 'registeredYear';

type DatasetSearchAssistItem = {
    type: 'correction' | 'synonym';
    label: string;
    value: string;
};

type DatasetSemanticRecommendation = {
    score: number;
    reason: string;
    keywords: string[];
};

type DatasetSearchSynonymSource = 'sample' | 'external-glossary' | 'admin';
type DatasetSearchApprovalStatus = 'candidate' | 'approved' | 'rejected';
type DatasetSearchTermSource = 'title' | 'keyword' | 'organization';

type DatasetSearchSynonymEntry = {
    canonical: string;
    synonyms: string[];
    related: string[];
    reason: string;
    source: DatasetSearchSynonymSource;
    status: DatasetSearchApprovalStatus;
    externalSource?: string;
    approvedBy?: string;
};

type DatasetSearchSynonymRule = {
    canonical: string;
    terms: string[];
    related: string[];
    reason: string;
    source: DatasetSearchSynonymSource;
    status: DatasetSearchApprovalStatus;
};

type DatasetSearchTermCandidate = {
    term: string;
    normalized: string;
    sources: DatasetSearchTermSource[];
    weight: number;
    count: number;
};

type DatasetSearchCorrectionMatch = {
    candidate: DatasetSearchTermCandidate;
    score: number;
    editDistance: number;
    jamoSimilarity: number;
};

type MapSearchBounds = {
    south: number;
    north: number;
    west: number;
    east: number;
};

type MapSearchDataset = {
    id: string;
    title: string;
    provider: string;
    region: string;
    address: string;
    latitude: number;
    longitude: number;
    dataType: string;
    registeredYear: string;
    createdYear: string;
    summary: string;
    keywords: string[];
    path: string;
    views: number;
    downloads: number;
};

type MapSearchRegion = {
    label: string;
    latitude: number;
    longitude: number;
    level: number;
    bounds: MapSearchBounds;
    aliases: string[];
};

type MapSearchUserLocation = {
    latitude: number;
    longitude: number;
    accuracy: number;
};

type DatasetSearchResult = {
    id: string;
    title: string;
    titleEn: string;
    summary: string;
    path: string;
    provider: string;
    repository: string;
    searchTarget: string;
    accessRight: string;
    createdAt: string;
    updatedAt: string;
    creators: string[];
    managers: string[];
    keywords: string[];
    badges: string[];
    fileTypes: string[];
    license: string;
    dataType: string;
    createdYear: string;
    domesticOrInternational: string;
    subject: string;
    publisher: string;
    contributors: string[];
    projectName: string;
    principalInvestigator: string;
    performingOrganization: string;
    ministry: string;
    researcherNumber: string;
    ntisProjectNumber: string;
    totalFiles: number;
    totalSamples: number;
    views: number;
    downloads: number;
};

type SubmitStepId = 'notice' | 'collection' | 'form' | 'review';
type SubmitManageTabId = 'draft' | 'archived';
type SubmitApprovalTabId = 'pending' | 'approved' | 'rejected';

type SubmitCollection = {
    id: string;
    name: string;
    shortName: string;
    description: string;
    field: string;
    datasets: string;
    files?: string;
    logo?: string;
};

type SubmitCollectionGroup = {
    label: string;
    items: SubmitCollection[];
};

type SubmitRecord = {
    id: number;
    title: string;
    files: number;
    modifiedAt: string;
    status: string;
    statusClass: string;
    tool: string;
};

type SubmitStatRow = {
    label: string;
    value: number;
    ratio: number;
    color: string;
};

type SubmitApprovalRecord = {
    id: string;
    title: string;
    submitter: string;
    organization: string;
    collection: string;
    files: number;
    requestedAt: string;
    status: SubmitApprovalTabId;
    statusLabel: string;
};

type JoinStepId = 'verify' | 'terms' | 'role' | 'complete';
type JoinRoleId = 'general' | 'manager';
type FieldMessageTone = '' | 'error' | 'success';
type JoinFieldKey = 'name' | 'organization' | 'email' | 'code';
type DatasetTabId = 'overview' | 'files' | 'metadata' | 'relations' | 'knowledgeGraph' | 'citation' | 'recommendations';
type DatasetFileType = 'folder' | 'image' | 'archive';
type DatasetFileViewMode = 'list' | 'thumbnail';
type DatasetFileFilter = 'all' | 'image' | 'archive';
type DatasetCitationStyle = 'BibTeX' | 'APA' | 'MLA' | 'Chicago';
type DatasetRecommendationTab = '논문' | '데이터' | '표준분류';
type DatasetLooseRecord = any;
type KnowledgeGraphNodeType = 'dataset' | 'project' | 'paper' | 'researcher' | 'organization' | 'keyword' | 'equipment';
type KnowledgeGraphFilterType = 'all' | KnowledgeGraphNodeType;

type KnowledgeGraphFilter = {
    type: KnowledgeGraphFilterType;
    label: string;
};

type KnowledgeGraphMetadataRow = {
    label: string;
    value: string;
};

type KnowledgeGraphNode = {
    id: string;
    type: KnowledgeGraphNodeType;
    label: string;
    shortLabel: string;
    dataonId: string;
    source: string;
    pathLabel: string;
    metadata: KnowledgeGraphMetadataRow[];
};

type KnowledgeGraphEdge = {
    id: string;
    source: string;
    target: string;
    label: string;
    dataonId: string;
    sourceName: string;
    metadata: KnowledgeGraphMetadataRow[];
};

type KnowledgeGraphPoint = {
    x: number;
    y: number;
};

type DatasetTab = {
    id: DatasetTabId;
    label: string;
};

type DatasetFile = {
    id: string;
    type: DatasetFileType;
    name: string;
    folder?: string;
    children?: number;
    extension?: string;
    size?: string;
    resolution?: string;
    capturedAt?: string;
    coordinates?: {
        longitude: number;
        latitude: number;
    };
    previewUrl?: string;
    previewAvailable?: boolean;
};

type DatasetDetail = {
    datasetId: string;
    title: {
        ko: string;
        en: string;
    };
    summary: string;
    description: {
        ko: string;
        en: string;
    };
    badges: string[];
    provider: {
        name: string;
        repository: string;
        logo: string;
    };
    doi: string;
    license: {
        code: string;
        label: string;
        url: string;
    };
    createdAt: string;
    updatedAt: string;
    stats: {
        views: number;
        downloads: number;
        originalLinks: number;
        recommendations: number;
        shares: number;
        citations: number;
    };
    creators: {
        nameKo: string;
        nameEn: string;
        organizationKo: string;
        organizationEn: string;
        role: string;
    }[];
    keywords: string[];
    classification: {
        nationalScienceTechnologyCode: string;
        nationalScienceTechnologyLabel: string;
        subject: string;
        domesticOrInternational: string;
    };
    composition: {
        totalFiles: number;
        totalSamples: number;
        groups: {
            key: string;
            label: string;
            count: number;
        }[];
        pairing: {
            fullyPaired: number;
            kompsatAndSen2LabelOnly: number;
            kompsatOnly: number;
        };
    };
    preview: {
        defaultFileId: string;
        viewerType: string;
        supportedActions: string[];
    };
    files: DatasetFile[];
    relatedProject: {
        titleKo: string;
        titleEn: string;
        year: number;
        ministry: string;
        organization: string;
        principalInvestigator: {
            nameKo: string;
            nameEn: string;
        };
        relationship: string;
    };
    relations: {
        nodes: {
            id: string;
            type: string;
            label: string;
        }[];
        edges: {
            source: string;
            target: string;
            label: string;
        }[];
    };
    citation: {
        apa: string;
        bibtex: string;
    };
    aiRecommendations: {
        type: string;
        title: string;
        source: string;
        similarity: number;
    }[];
    ui: {
        tabs: DatasetTab[];
        primaryActions: string[];
    };
};

const DATAON_LANGUAGE_STORAGE_KEY = 'dataon.prototype.language';

const DATAON_EN_TRANSLATIONS: Record<string, string> = {
    '마이페이지': 'My Page',
    '사용자 가이드': 'Guide',
    '사용자가이드': 'User Guide',
    '로그인': 'Login',
    '로그아웃': 'Logout',
    '전체 메뉴': 'All Menu',
    '전체메뉴': 'All Menu',
    '전체메뉴 닫기': 'Close All Menu',
    '모바일 메뉴': 'Mobile Menu',
    'DataON 홈': 'DataON Home',
    'DataON 연구데이터 플랫폼': 'DataON Research Data Platform',
    '주요 메뉴': 'Main Menu',
    '홈': 'Home',
    '메인': 'Home',
    '소개': 'Introduction',
    'DataON 개요': 'DataON Overview',
    'DataON 관리정책': 'Management Policy',
    '연혁': 'History',
    '연계기관': 'Partner Organizations',
    'CI/BI': 'CI/BI',
    '데이터 현황': 'Data Status',
    '데이터 현황 통계': 'Data Stats',
    '데이터 활용 통계': 'Usage Stats',
    '이용안내': 'Help',
    '자료실': 'Resources',
    'FAQ': 'FAQ',
    '사이트 오류 신고': 'Report Site Error',
    '알림': 'Notice',
    '공지사항': 'Notices',
    '뉴스': 'News',
    '행사안내': 'Events',
    '우수활용사례': 'Best Practices',
    '검색': 'Search',
    '콘텐츠별 검색': 'Content Search',
    '데이터셋 검색': 'Dataset Search',
    '소프트웨어 검색': 'Software',
    '통합 검색': 'Integrated',
    '상세 검색': 'Advanced',
    '제공처 검색': 'Providers',
    '맵 검색': 'Map',
    'MAP 검색': 'Map',
    '의미검색': 'Semantic',
    '이슈&데이터': 'Issues & Data',
    '코로나 바이러스': 'Coronavirus',
    '등록': 'Submit',
    '제출': 'Submit',
    '데이터 관리': 'Data Mgmt.',
    '제출 데이터 통계': 'Submission Stats',
    '데이터 승인': 'Data Approval',
    '분석': 'Analysis',
    '분석(CANVAS)': 'Analysis (CANVAS)',
    '내 분석 바로가기': 'My Analysis',
    'JupyterLab 이용': 'Use JupyterLab',
    'Software 검색': 'Software Search',
    'CANVAS 가이드': 'CANVAS Guide',
    '서비스': 'Services',
    '분야별 리포지터리': 'Field Repositories',
    '리포지터리 호스팅': 'Hosting',
    '내 리포지터리 관리': 'My Repositories',
    '신청': 'Apply',
    '신청목록': 'Application List',
    '공개 리포지터리 현황': 'Public Repositories',
    'API 활용': 'API Usage',
    'MCP소개': 'MCP Introduction',
    '커뮤니티': 'Community',
    '나의 커뮤니티': 'My Community',
    '전체 커뮤니티': 'All Communities',
    '경진대회': 'Competition',
    '대회소개': 'Overview',
    '지난대회보기': 'Past Events',
    '대회진행': 'Status',
    '참가신청': 'Apply to Participate',
    '서류접수 상태': 'Documents',
    '워크샵 갤러리': 'Workshop Gallery',
    '최종발표평가': 'Final Review',
    '1차 서류평가': 'First Review',
    '시상식 갤러리': 'Awards Gallery',
    '대회소통방': 'Board',
    '자주하는 질문': 'FAQ',
    'QnA': 'Q&A',
    '국가연구데이터플랫폼': 'Research Data Platform',
    '은': '',
    '새로운 연구문화를 만듭니다.': 'creates a new research culture.',
    '연구데이터 검색': 'Data Search',
    '주요 서비스': 'Key Services',
    '마이드라이브': 'My Drive',
    '찾고 싶은 데이터를 입력해주세요.': 'Enter the data you want to find.',
    '검색 도움말': 'Help',
    '검색 도움말 닫기': 'Close Search Help',
    '추천 검색어': 'Keywords',
    '검색 연산자': 'Search Operator',
    '기능': 'Function',
    '검색시 예': 'Search Example',
    '공백': 'Space',
    '두 개의 검색어(식)을 모두 포함하고 있는 문서 검색': 'Find documents containing both search terms or expressions.',
    '우선순위가 가장 높은 연산자': 'Operator with the highest priority.',
    '두 개의 검색어(식) 중 하나 이상 포함하고 있는문서 검색': 'Find documents containing one or more of two search terms or expressions.',
    'NOT 이후에 있는 검색어가 포함된 문서는 제외': 'Exclude documents containing the term after NOT.',
    '검색어의 *란에 0개 이상의 임의의 문자가 포함된 문서 검색': 'Find documents where * represents zero or more arbitrary characters.',
    '따옴표 내의 구문과 완전히 일치하는 문서만 검색': 'Find only documents matching the phrase inside quotation marks.',
    '아마존': 'Amazon',
    '산림벌채': 'Deforestation',
    '위성영상': 'Satellite Imagery',
    '인공지능': 'AI',
    '상세조건': 'Conditions',
    '적용 조건': 'Applied',
    '선택 조건': 'Selected',
    '모든 조건 충족': 'Match All Conditions',
    '하나 이상 충족': 'Match Any Condition',
    '전체 초기화': 'Reset All',
    '시작연도': 'Start Year',
    '종료연도': 'End Year',
    '기관·인물 조건': 'Organizations & People',
    '과제·식별정보 조건': 'Projects & IDs',
    '추가 조건 보기': 'More Conditions',
    '선택된 상세조건': 'Selected Conditions',
    '조건:': 'Conditions:',
    '조건 없음': 'No Conditions',
    '초기화': 'Reset',
    '선택 조건 적용': 'Apply Selected',
    '닫기': 'Close',
    '데이터셋': 'Datasets',
    '파일개수 / 용량': 'Files/Cap.',
    '파일 개수': 'Files',
    '파일 개수/용량': 'Files/Cap.',
    '용량': 'Capacity',
    '국내': 'Domestic',
    '해외': 'Global',
    '분야': 'Field',
    '연구데이터 과학기술분류': 'Science & Technology Classification',
    '건설/교통': 'Construction / Transportation',
    '기계': 'Mechanical Engineering',
    '농림수산식품': 'Agriculture, Forestry, Fisheries & Food',
    '물리학': 'Physics',
    '보건의료': 'Health Care',
    '생명과학': 'Life Science',
    '수학': 'Mathematics',
    '에너지/자원': 'Energy / Resources',
    '원자력': 'Nuclear Energy',
    '인문사회': 'Humanities & Social Sciences',
    '재료': 'Materials',
    '전기/전자': 'Electrical / Electronics',
    '정보/통신': 'Information / Communications',
    '지구과학': 'Earth Science',
    '화공': 'Chemical Engineering',
    '화학': 'Chemistry',
    '환경': 'Environment',
    '기타': 'Other',
    '최신데이터': 'Latest Data',
    '인기데이터': 'Popular Data',
    '연구데이터 활용': 'Research Data Use',
    '코로나19': 'COVID-19',
    '기후위기': 'Climate Crisis',
    '매칭 커뮤니티': 'Matching Community',
    '수요 컨설팅': 'Demand Consulting',
    '연구데이터': 'Research Data',
    '글로벌 주요국과 연구데이터 연계': 'Research Data Linkage with Major Global Countries',
    '국내 연구기관, 데이터전문센터와': 'Domestic Research Institutes and Data Centers',
    '연구데이터 연계': 'Research Data Linkage',
    '국가R&D과제정보, 과학기술정보 등': 'National R&D and Science Information',
    '참조 정보 연계': 'Reference Information Linkage',
    '한국과학기술정보연구원': 'KISTI',
    '한국항공우주연구원': 'KARI',
    '더보기': 'View More',
    '이전': 'Previous',
    '다음': 'Next',
    '로그인 페이지로 이동': 'Go to Login',
    '아이디': 'ID',
    '비밀번호': 'Password',
    '아이디를 입력하세요.': 'Enter your ID.',
    '비밀번호를 입력하세요.': 'Enter your password.',
    '아이디 저장': 'Save ID',
    '아이디/비밀번호 찾기': 'Find ID / Password',
    '회원가입': 'Sign Up',
    '또는': 'or',
    '회원 유형 선택': 'Select Member Type',
    '일반 사용자': 'General User',
    '데이터 검색과 활용 중심': 'Search and use research data',
    '기관 데이터 관리자': 'Institution Data Manager',
    '기관 데이터 등록과 관리': 'Register and manage institutional data',
    '회원 유형': 'Member Type',
    '가입 유형 선택': 'Select Join Type',
    '약관 동의': 'Agree to Terms',
    '필수 정책 확인': 'Confirm Required Policies',
    '이메일 인증': 'Email Verification',
    '계정 정보 확인': 'Confirm Account Information',
    '승인 요청': 'Approval Request',
    '관리자 검토 접수': 'Submitted for Admin Review',
    '이용약관 동의': 'Agree to Terms of Use',
    '개인정보처리방침 동의': 'Agree to Privacy Policy',
    '관리자 승인 절차 확인': 'Confirm Admin Approval Process',
    '전체 동의': 'Agree to All',
    '이름': 'Name',
    '소속기관': 'Organization',
    '이메일': 'Email',
    '이름을 입력하세요.': 'Enter your name.',
    '소속기관을 입력하세요.': 'Enter your organization.',
    '이메일 주소를 바르게 입력해 주세요.': 'Enter a valid email address.',
    '인증번호 요청': 'Request Verification Code',
    '인증번호': 'Verification Code',
    '인증번호를 입력하세요.': 'Enter the verification code.',
    '관리자 승인 요청이 접수되었습니다': 'Your admin approval request has been submitted.',
    '승인 후 서비스 이용이 가능합니다.': 'You can use the service after approval.',
    '새 가입 요청': 'New Sign-up Request',
    '연구데이터 키워드와 조건을 조합해 데이터셋을 탐색합니다.': 'Explore datasets by combining research data keywords and conditions.',
    '검색 범위': 'Search Scope',
    '데이터셋 검색어': 'Dataset Keyword',
    '아마존, 산림, 벌채, 위성 등 검색어를 입력하세요': 'Enter keywords such as Amazon, forest, deforestation, or satellite.',
    '검색어 지우기': 'Clear Keyword',
    '검색 방식': 'Search Mode',
    '일반 검색': 'Keyword Search',
    '적용된 상세조건': 'Applied Conditions',
    '생성년도': 'Created Year',
    '등록년도': 'Registered Year',
    '시작': 'Start',
    '종료': 'End',
    '상세조건 닫기': 'Close Conditions',
    '조건 적용': 'Apply Conditions',
    '정렬': 'Sort',
    '관련도순': 'Relevance',
    '최신순': 'Latest',
    '다운로드순': 'Downloads',
    '결과 내 키워드 검색': 'Search Within Results',
    '검색 결과 목록 다운로드': 'Download Search Results',
    '전체선택': 'Select All',
    '생산자': 'Creator',
    '제공처': 'Provider',
    '리포지터리': 'Repository',
    '라이선스': 'License',
    '조회': 'Views',
    '다운로드': 'Downloads',
    '인용': 'Citations',
    '공개': 'Open',
    '비공개': 'Private',
    '연구데이터 상세': 'Research Data Detail',
    '개요': 'Overview',
    '파일': 'Files',
    '메타데이터': 'Metadata',
    '지식그래프': 'Knowledge Graph',
    '연관정보': 'Related Information',
    '인용·공유': 'Citation & Sharing',
    'AI 추천': 'AI Recommendations',
    '파일 미리보기': 'File Preview',
    '바로 분석': 'Analyze Now',
    '마이드라이브 저장': 'Save to My Drive',
    '관심 데이터': 'Favorite Data',
    '데이터 설명': 'Data Description',
    '접기': 'Collapse',
    '파일 구성': 'File Structure',
    '선택 파일 메타정보': 'Selected File Metadata',
    '파일명': 'File Name',
    '포맷': 'Format',
    '카테고리': 'Category',
    '해상도': 'Resolution',
    '촬영일시': 'Captured At',
    '경도': 'Longitude',
    '위도': 'Latitude',
    '매칭 상태': 'Matching Status',
    '지원 확장자·용량 제한': 'Supported Extensions & Size Limits',
    '원본 영상': 'Original Image',
    '라벨 영상': 'Label Image',
    '원본 JSON 보기': 'View Raw JSON',
    'JSON 닫기': 'Close JSON',
    '다국어 정보': 'Multilingual Information',
    '한글 설명': 'Korean Description',
    '한글 키워드': 'Korean Keywords',
    '영문 키워드': 'English Keywords',
    '인물정보': 'People Information',
    '역할': 'Role',
    '관계명': 'Relationship',
    'DataON 고유번호': 'DataON ID',
    '출처': 'Source',
    '연결': 'Connection',
    '주요 메타데이터': 'Key Metadata',
    '선택 관계': 'Selected Relationship',
    '연결 관계': 'Connected Relationships',
    '상세보기': 'View Details',
    '이 개체를 중심으로 보기': 'Center on This Entity',
    '관련 과제 상세정보': 'Related Project Details',
    '관계': 'Relationship',
    '과제명': 'Project Name',
    '부처': 'Ministry',
    '식별자': 'Identifier',
    '연구기간': 'Research Period',
    '총연구비': 'Total Research Budget',
    '책임자': 'Principal Investigator',
    '관리기관': 'Managing Organization',
    '수행기관': 'Performing Organization',
    '국가': 'Country',
    '논문정보': 'Paper Information',
    '등록된 논문정보 없음': 'No paper information registered.',
    '관련 인물·기관 및 관계 설명': 'Related People, Organizations, and Relationship Description',
    '인물': 'People',
    '기관': 'Organizations',
    '유발 관계': 'Induced Relationship',
    '관련 관계': 'Related Relationship',
    '인용 스타일': 'Citation Style',
    '복사': 'Copy',
    'URL 복사': 'Copy URL',
    '라이선스·공유': 'License & Sharing',
    '커뮤니티 공유': 'Community Sharing',
    '사용자 공유': 'User Sharing',
    '공유 URL': 'Share URL',
    '이용 통계 및 액션': 'Usage Statistics & Actions',
    '추천 논문·데이터셋·표준분류': 'AI Recommendations',
    '선택한 메뉴의 상세 콘텐츠가 표시될 예정인 페이지입니다.': 'Detailed content for the selected menu will be displayed here.',
    '메인으로': 'Go to Home',
    '전체 메뉴 보기': 'View All Menu',
    '이용약관': 'Terms of Use',
    '개인정보처리방침': 'Privacy Policy',
    '기관소개': 'About KISTI',
    '데이터온 로고': 'DataON Logo',
    '푸터 링크': 'Footer Links',
    '(우)34141 대전광역시 유성구 대학로 245': '245 Daehak-ro, Yuseong-gu, Daejeon 34141, Republic of Korea',
    '한국과학기술정보연구원.': 'Korea Institute of Science and Technology Information.',
    '문의메일 : dataon@kisti.re.kr': 'Contact: dataon@kisti.re.kr',
    'DataON Repository re3data 페이지': 'DataON Repository re3data Page',
    '선택 없음': 'None Selected',
    '동의': 'Agreed',
    '미동의': 'Not Agreed',
};

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
@charset "UTF-8";
:host {
  display: block;
}

:host * {
  box-sizing: border-box;
  letter-spacing: 0;
}

:host button {
  border: 0;
  font: inherit;
  cursor: pointer;
  min-width: 0;
}

.dataon-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  background: #F6F7FB;
  color: #0B1733;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dataon-page > main {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
}

.dataon-container,
.dataon-service-grid,
.dataon-content-grid,
.dataon-bottom-grid {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding-right: 24px;
  padding-left: 24px;
}

.dataon-header {
  position: relative;
  z-index: 2000;
  flex-shrink: 0;
  color: #0B1733;
  border-bottom: 1px solid #E6EDF5;
  background: #FFFFFF;
  box-shadow: 0 2px 12px rgba(6, 42, 95, 0.04);
}

.dataon-header .dataon-container {
  max-width: 1440px;
}

.dataon-header button:focus-visible,
.dataon-sitemap button:focus-visible {
  outline: 3px solid rgba(0, 103, 214, 0.22);
  outline-offset: 3px;
}

.dataon-header-inner {
  display: flex;
  height: 72px;
  align-items: center;
  justify-content: space-between;
  gap: 34px;
}

.dataon-logo-button {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: 0;
  background: transparent;
}

.dataon-logo {
  width: auto;
  height: 42px;
}

.dataon-nav {
  display: none;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: clamp(28px, 3vw, 52px);
}

.dataon-nav-button,
.dataon-auth-button,
.dataon-lang-button {
  color: currentColor;
  font-weight: 800;
  background: transparent;
  transition: color 160ms ease;
}

.dataon-nav-button {
  position: relative;
  display: inline-flex;
  min-height: 72px;
  align-items: center;
  padding: 0 2px;
  font-size: 16px;
  white-space: nowrap;
}

.dataon-nav-button::after {
  position: absolute;
  right: 0;
  bottom: 15px;
  left: 0;
  height: 3px;
  border-radius: 999px;
  background: #0067D6;
  content: "";
  opacity: 0;
  transform: translateY(5px);
  transition: opacity 160ms ease, transform 160ms ease;
}

.dataon-nav-group {
  position: relative;
}

.dataon-nav-panel {
  position: fixed;
  z-index: 2001;
  top: 72px;
  right: 0;
  left: 0;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(138px, 176px);
  justify-content: center;
  width: 100vw;
  min-width: 0;
  gap: clamp(22px, 2.7vw, 42px);
  padding: 34px clamp(32px, 13vw, 210px);
  visibility: hidden;
  border: 1px solid #E6EDF5;
  border-right: 0;
  border-left: 0;
  border-radius: 0;
  background: #FFFFFF;
  box-shadow: 0 18px 42px rgba(6, 42, 95, 0.13);
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 160ms ease, transform 160ms ease, visibility 160ms ease;
}

.dataon-nav-panel.is-active {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}

.dataon-nav-panel-section {
  display: grid;
  align-content: start;
  gap: 8px;
  min-width: 0;
}

.dataon-nav-panel-section + .dataon-nav-panel-section {
  padding-top: 0;
  border-top: 0;
}

.dataon-nav-panel-heading {
  width: 100%;
  min-height: 32px;
  overflow: hidden;
  color: #0B1733;
  font-size: 17px;
  font-weight: 920;
  line-height: 1.3;
  text-align: left;
  background: transparent;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-nav-panel-link {
  width: 100%;
  min-height: 28px;
  padding: 0;
  overflow: hidden;
  color: #4B5B73;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  text-align: left;
  border-radius: 4px;
  background: transparent;
  text-overflow: ellipsis;
  white-space: normal;
}

.dataon-nav-panel-heading:hover,
.dataon-nav-panel-heading:focus-visible,
.dataon-nav-panel-link:hover,
.dataon-nav-panel-link:focus-visible {
  color: #0067D6;
  background: transparent;
}

.dataon-nav-group.is-active .dataon-nav-button,
.dataon-nav-button:hover,
.dataon-nav-button:focus-visible,
.dataon-auth-button:hover,
.dataon-auth-button:focus-visible,
.dataon-lang-button:hover,
.dataon-lang-button:focus-visible {
  color: #0067D6;
}

.dataon-nav-group.is-active .dataon-nav-button::after,
.dataon-nav-button:hover::after,
.dataon-nav-button:focus-visible::after {
  opacity: 1;
  transform: translateY(0);
}

.dataon-auth {
  display: none;
  flex-shrink: 0;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

.dataon-auth-button {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  color: #26364D;
  border: 1px solid #D8E1EC;
  border-radius: 999px;
  background: #FFFFFF;
  transition: color 160ms ease, border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.dataon-auth-button:hover,
.dataon-auth-button:focus-visible {
  border-color: #A9CDF7;
  background: #F4FAFF;
  box-shadow: 0 8px 18px rgba(0, 103, 214, 0.1);
}

.dataon-divider {
  width: 1px;
  height: 12px;
  background: #E6EDF5;
}

.dataon-lang-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.dataon-lang-button .fa-globe {
  font-size: 16px;
}

.dataon-lang-button .fa-chevron-down {
  font-size: 11px;
}

.dataon-sitemap-toggle {
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  color: #26364D;
  border: 1px solid #D8E1EC;
  border-radius: 999px;
  background: #FFFFFF;
  transition: color 160ms ease, border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.dataon-mobile-button {
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  color: currentColor;
  border: 1px solid #E6EDF5;
  border-radius: 999px;
  background: transparent;
}

.dataon-sitemap-toggle:hover,
.dataon-sitemap-toggle:focus-visible,
.dataon-mobile-button:hover,
.dataon-mobile-button:focus-visible {
  color: #0067D6;
  border-color: #A9CDF7;
  background: #F4FAFF;
  box-shadow: 0 8px 18px rgba(0, 103, 214, 0.1);
}

.dataon-sitemap {
  position: absolute;
  top: 72px;
  right: 0;
  left: 0;
  color: #0B1733;
  border-top: 1px solid #E6EDF5;
  background: #FFFFFF;
  box-shadow: 0 18px 42px rgba(6, 42, 95, 0.14);
  animation: dataon-menu-drop 180ms ease both;
}

.dataon-menu-head {
  display: none;
  border-bottom: 1px solid #E1E6EF;
  background: #FFFFFF;
}

.dataon-menu-head-inner {
  display: flex;
  min-height: 88px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.dataon-menu-logo-button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  padding: 0;
  background: transparent;
}

.dataon-menu-logo-button img {
  display: block;
  width: 138px;
  max-width: 100%;
  height: auto;
}

.dataon-menu-mobile-auth {
  display: none;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.dataon-menu-mobile-auth button {
  min-height: 34px;
  padding: 0 10px;
  color: #26364D;
  font-size: 13px;
  font-weight: 850;
  border: 1px solid #D8E1EC;
  border-radius: 999px;
  background: #FFFFFF;
}

.dataon-menu-mobile-auth button:hover,
.dataon-menu-mobile-auth button:focus-visible {
  color: #0067D6;
  border-color: #A9CDF7;
  background: #F4FAFF;
}

.dataon-menu-close {
  display: inline-flex;
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  color: #26364D;
  font-size: 28px;
  background: transparent;
}

.dataon-sitemap-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
  padding-top: 40px;
  padding-bottom: 48px;
}

.dataon-sitemap-group {
  display: grid;
  align-content: start;
  min-width: 0;
  gap: 24px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  opacity: 0;
  transform: translateY(10px);
  animation: dataon-menu-item 220ms ease forwards;
  animation-delay: calc(var(--menu-index, 0) * 30ms);
}

.dataon-sitemap-title {
  position: relative;
  display: inline-flex;
  width: 100%;
  min-height: 76px;
  align-items: center;
  margin-bottom: 0;
  padding: 0 0 18px;
  overflow: hidden;
  color: #0B1733;
  font-size: 42px;
  font-weight: 1000;
  line-height: 1.08;
  text-shadow: 0.45px 0 0 currentColor;
  -webkit-text-stroke: 0.18px currentColor;
  text-align: left;
  border-bottom: 0;
  border-radius: 0;
  background: transparent;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-sitemap-title::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  background: #0B1733;
  content: "";
}

.dataon-sitemap-section-list {
  display: grid;
  gap: 26px;
  min-width: 0;
}

.dataon-sitemap-section {
  display: grid;
  gap: 9px;
  min-width: 0;
}

.dataon-sitemap-section-title {
  min-height: 30px;
  overflow: hidden;
  color: #252A33;
  font-size: 19px;
  font-weight: 900;
  line-height: 1.32;
  text-align: left;
  background: transparent;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-sitemap-link {
  min-height: 26px;
  overflow: hidden;
  padding: 0;
  color: #7A7F88;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  text-align: left;
  border-radius: 0;
  background: transparent;
  text-overflow: ellipsis;
  white-space: normal;
}

.dataon-sitemap-title:hover,
.dataon-sitemap-title:focus-visible,
.dataon-sitemap-section-title:hover,
.dataon-sitemap-section-title:focus-visible,
.dataon-sitemap-link:hover,
.dataon-sitemap-link:focus-visible {
  color: #0067D6;
}

.dataon-mobile-menu-panel {
  display: none;
}

@keyframes dataon-menu-drop {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dataon-menu-item {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.dataon-service-card,
.dataon-panel,
.dataon-stat-card,
.dataon-data-item,
.dataon-field-item,
.dataon-notice-item,
.dataon-bottom-link {
  overflow: hidden;
}

.dataon-hero {
  position: relative;
  overflow: visible;
  height: 580px;
  color: #FFFFFF;
  background: #011438;
}

.dataon-hero-backdrop {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-color: #021F4F;
  background-image: radial-gradient(circle at 42% 44%, #19396B 0%, rgba(25, 57, 107, 0.28) 18%, transparent 38%), linear-gradient(90deg, #011031 0%, rgba(1, 20, 56, 0.84) 48%, rgba(2, 31, 79, 0.28) 100%), url("/assets/dataon/main_bg.png");
  background-position: center center, center center, center -156px;
  background-size: cover;
}

.dataon-hero-grid {
  position: relative;
  display: grid;
  height: 100%;
  min-height: 0;
  align-items: center;
  justify-items: center;
  gap: 40px;
  padding-bottom: 64px;
  text-align: center;
}

.dataon-hero-copy {
  display: grid;
  width: 100%;
  max-width: 820px;
  justify-items: center;
  min-width: 0;
}

.dataon-hero-title {
  margin: 0;
  font-size: 32px;
  font-weight: 800;
  line-height: 1.25;
}

.dataon-accent {
  color: #00AEEF;
}

.dataon-hero-description {
  margin: 24px 0 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
}

.dataon-search-block {
  position: relative;
  z-index: 1200;
  width: 100%;
  max-width: 876px;
  margin: 32px auto 0;
}

.dataon-search-primary-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.dataon-search {
  position: relative;
  z-index: 1201;
  width: 100%;
  max-width: none;
  margin: 0;
}

.dataon-search-shell {
  position: relative;
  z-index: 1202;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 132px 98px;
  overflow: hidden;
  padding: 0;
  border-radius: 999px;
  background: #FFFFFF;
  box-shadow: 0 18px 45px rgba(0, 51, 118, 0.28);
  outline: 2px solid #1D8FFF;
}

.dataon-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.dataon-search-scope-select,
.dataon-results-scope-select {
  width: 100%;
  min-width: 0;
  height: 66px;
  padding: 0 12px;
  color: #0B1733;
  font: inherit;
  font-size: 14px;
  font-weight: 900;
  text-align: center;
  text-align-last: center;
  border: 0;
  border-right: 1px solid #D6E4F3;
  outline: 0;
  background: #F8FBFF;
}

.dataon-search-input {
  width: 100%;
  min-width: 0;
  height: 66px;
  padding: 0 18px;
  color: #0B1733;
  font-size: 17px;
  font-weight: 700;
  border: 0;
  border-radius: 0;
  background: #FFFFFF;
}

.dataon-search-input::placeholder {
  color: #9AA6B8;
}

.dataon-search-input:focus {
  outline: 0;
  box-shadow: none;
}

.dataon-search-help-toggle {
  position: absolute;
  top: 50%;
  right: 246px;
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  color: #5D6B82;
  border-radius: 999px;
  background: #F4F8FC;
  transform: translateY(-50%);
  transition: color 160ms ease, background 160ms ease;
}

.dataon-search-help-toggle:hover,
.dataon-search-help-toggle[aria-expanded=true] {
  color: #0067D6;
  background: #EAF6FF;
}

.dataon-search-help-toggle i {
  font-size: 18px;
}

.dataon-search-detail-toggle {
  position: relative;
  display: inline-flex;
  min-width: 120px;
  height: 66px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  color: #0057B8;
  font-size: 13px;
  font-weight: 900;
  border-left: 1px solid #D6E4F3;
  border-radius: 0;
  background: #EAF6FF;
  transition: color 160ms ease, background 160ms ease;
}

.dataon-search-detail-toggle img {
  width: 19px;
  height: 19px;
  object-fit: contain;
}

.dataon-search-detail-toggle em {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  color: #FFFFFF;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  border-radius: 999px;
  background: #008BD2;
}

.dataon-search-detail-toggle:hover,
.dataon-search-detail-toggle.is-active {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-search-detail-toggle:hover em,
.dataon-search-detail-toggle.is-active em {
  color: #0057B8;
  background: #FFFFFF;
}

.dataon-search-button {
  display: inline-flex;
  min-width: 98px;
  height: 66px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 18px;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 900;
  border-radius: 0 999px 999px 0;
  background: #0067D6;
  box-shadow: none;
  transition: background 160ms ease, box-shadow 160ms ease;
}

.dataon-search-button:hover {
  background: #0057B8;
  box-shadow: 0 12px 26px rgba(0, 103, 214, 0.32);
}

.dataon-search-button i {
  font-size: 16px;
}

.dataon-search-help-popover {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  z-index: 1000;
  width: min(520px, 100vw - 48px);
  max-height: min(520px, 100vh - 220px);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 16px 16px 18px;
  color: #0B1733;
  border: 1px solid #DDE7F3;
  border-radius: 14px;
  background: #FFFFFF;
  box-shadow: 0 18px 45px rgba(0, 35, 82, 0.22);
  scrollbar-gutter: stable;
}

.dataon-search-help-popover::before {
  position: absolute;
  top: -7px;
  right: 260px;
  width: 14px;
  height: 14px;
  border-top: 1px solid #DDE7F3;
  border-left: 1px solid #DDE7F3;
  background: #FFFFFF;
  content: "";
  transform: rotate(45deg);
}

.dataon-search-help-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.dataon-search-help-head strong {
  font-size: 15px;
  font-weight: 900;
}

.dataon-search-help-head button {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  color: #6A7890;
  border-radius: 999px;
  background: #F6F7FB;
}

.dataon-search-help-section + .dataon-search-help-section {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #E8EEF6;
}

.dataon-search-help-title {
  margin: 0 0 9px;
  color: #0B1733;
  font-size: 13px;
  font-weight: 900;
}

.dataon-search-type-list,
.dataon-search-operator-list {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-search-type-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dataon-search-type-list li {
  display: flex;
  min-width: 0;
  gap: 8px;
  padding: 9px;
  border: 1px solid #E8EEF6;
  border-radius: 10px;
  background: #F8FBFF;
}

.dataon-search-type-list i {
  display: inline-flex;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  color: #0067D6;
  font-size: 12px;
  border-radius: 999px;
  background: #EAF6FF;
}

.dataon-search-type-list span {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.dataon-search-type-list strong,
.dataon-search-type-list small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dataon-search-type-list strong {
  color: #0B1733;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.dataon-search-type-list small {
  color: #4B5B73;
  font-size: 11px;
  font-weight: 650;
  line-height: 1.35;
}

.dataon-search-operator-list li {
  display: grid;
  grid-template-columns: 82px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.45;
}

.dataon-search-operator-list code {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  color: #0067D6;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 12px;
  font-weight: 900;
  border-radius: 8px;
  background: #EAF6FF;
}

.dataon-search-assist {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.dataon-search-assist-button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 8px;
  padding: 0 11px;
  color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  background: rgba(2, 31, 79, 0.38);
  backdrop-filter: blur(8px);
  transition: color 160ms ease, border-color 160ms ease, background 160ms ease;
}

.dataon-search-assist-button i {
  flex: 0 0 auto;
  color: #28C6E8;
  font-size: 13px;
}

.dataon-search-assist-button:hover {
  color: #FFFFFF;
  border-color: rgba(40, 198, 232, 0.66);
  background: rgba(0, 103, 214, 0.36);
}

.dataon-search-assist-text {
  display: inline-flex;
  min-width: 0;
  align-items: baseline;
  gap: 6px;
}

.dataon-search-assist-text strong,
.dataon-search-assist-text small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-search-assist-text strong {
  font-size: 13px;
  font-weight: 900;
}

.dataon-search-assist-text small {
  color: rgba(255, 255, 255, 0.68);
  font-size: 11px;
  font-weight: 700;
}

.dataon-search-applied-row,
.dataon-results-applied-row {
  max-width: 1040px;
  margin-top: 10px;
}

.dataon-search-block .dataon-advanced-search-panel,
.dataon-results-search-block .dataon-advanced-search-panel {
  position: absolute;
  right: 0;
  left: 0;
  z-index: 1300;
  width: 100%;
  margin-top: 0;
}

.dataon-search-block .dataon-advanced-search-panel {
  top: 74px;
}

.dataon-results-search-block .dataon-advanced-search-panel {
  top: 66px;
}

.dataon-advanced-search-panel {
  position: relative;
  z-index: 1300;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  width: 100%;
  max-height: min(640px, 100vh - 170px);
  overflow: hidden;
  margin-top: 12px;
  color: #0B1733;
  border: 1px solid #CFE0F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 18px 44px rgba(0, 35, 82, 0.2);
}

.dataon-advanced-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  padding: 14px 16px;
  border-bottom: 1px solid #E6EDF5;
  background: #FFFFFF;
}

.dataon-advanced-title {
  display: flex;
  flex: 1 1 auto;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.dataon-advanced-head h2 {
  margin: 0;
  color: #0B1733;
  font-size: 18px;
  font-weight: 900;
  line-height: 1.25;
  white-space: nowrap;
}

.dataon-advanced-title span {
  min-width: 0;
  overflow: hidden;
  color: #6A7890;
  font-size: 12px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-advanced-match {
  display: inline-flex;
  flex: 0 0 auto;
  overflow: hidden;
  border: 1px solid #CAD7E8;
  border-radius: 6px;
  background: #F8FBFF;
}

.dataon-advanced-match button {
  min-height: 34px;
  padding: 0 12px;
  color: #4B5B73;
  font-size: 12px;
  font-weight: 900;
  background: transparent;
  white-space: nowrap;
}

.dataon-advanced-match button em {
  margin-left: 6px;
  padding: 2px 6px;
  color: inherit;
  font-size: 10px;
  font-style: normal;
  border-radius: 999px;
  background: rgba(0, 87, 184, 0.1);
}

.dataon-advanced-match button.is-active em {
  background: rgba(255, 255, 255, 0.18);
}

.dataon-advanced-match button + button {
  border-left: 1px solid #CAD7E8;
}

.dataon-advanced-match button.is-active {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-advanced-scroll {
  display: grid;
  gap: 12px;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 16px;
  background: #FFFFFF;
  overscroll-behavior: contain;
}

.dataon-advanced-condition-list {
  display: grid;
  min-width: 0;
  border-top: 1px solid #E6EDF5;
  border-bottom: 1px solid #E6EDF5;
}

.dataon-advanced-condition-row {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr);
  gap: 16px;
  align-items: start;
  min-width: 0;
  padding: 16px 0;
}

.dataon-advanced-condition-row + .dataon-advanced-condition-row {
  border-top: 1px solid #EEF3F8;
}

.dataon-advanced-condition-name {
  color: #0B1733;
  font-size: 14px;
  font-weight: 900;
  line-height: 34px;
  white-space: nowrap;
}

.dataon-advanced-condition-control {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.dataon-advanced-grid,
.dataon-advanced-project-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  min-width: 0;
}

.dataon-advanced-field {
  display: grid;
  align-content: start;
  gap: 10px;
  min-width: 0;
  padding: 14px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-advanced-field.is-wide {
  grid-column: 1/-1;
}

.dataon-advanced-field-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.dataon-advanced-field-title h3,
.dataon-advanced-text-field span {
  margin: 0;
  color: #0B1733;
  font-size: 14px;
  font-weight: 900;
  line-height: 1.35;
}

.dataon-advanced-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.dataon-advanced-options button {
  display: inline-flex;
  max-width: 100%;
  min-height: 32px;
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  color: #26364D;
  font-size: 13px;
  font-weight: 850;
  border: 1px solid #CAD7E8;
  border-radius: 999px;
  background: #FFFFFF;
}

.dataon-advanced-options button.is-selected {
  color: #FFFFFF;
  border-color: #0057B8;
  background: #0057B8;
}

.dataon-advanced-text-field {
  display: grid;
  gap: 7px;
  min-width: 0;
}

.dataon-advanced-input-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
  min-width: 0;
  border: 1px solid #CAD7E8;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-advanced-input-shell i {
  padding-left: 12px;
  color: #7A8AA0;
  font-size: 12px;
}

.dataon-advanced-input-shell.is-autocomplete {
  grid-template-columns: auto minmax(0, 1fr);
  box-shadow: inset 0 0 0 1px rgba(0, 103, 214, 0.04);
}

.dataon-advanced-text-field input,
.dataon-advanced-year-range input {
  width: 100%;
  height: 42px;
  min-width: 0;
  padding: 0 12px;
  color: #0B1733;
  font: inherit;
  font-size: 14px;
  font-weight: 750;
  border: 0;
  outline: 0;
  background: #FFFFFF;
}

.dataon-advanced-text-field input::placeholder,
.dataon-advanced-year-range input::placeholder {
  color: #9AA6B8;
}

.dataon-advanced-year-range {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  min-width: 0;
}

.dataon-advanced-year-range label {
  display: grid;
  gap: 6px;
  min-width: 0;
}

.dataon-advanced-year-range span {
  color: #4B5B73;
  font-size: 12px;
  font-weight: 850;
}

.dataon-advanced-year-range input {
  border: 1px solid #CAD7E8;
  border-radius: 6px;
}

.dataon-advanced-accordion {
  display: grid;
  gap: 10px;
  min-width: 0;
  padding: 12px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-advanced-accordion-head {
  display: grid;
  grid-template-columns: minmax(140px, auto) minmax(0, 1fr) auto;
  min-height: 42px;
  align-items: center;
  gap: 10px;
  padding: 0 2px;
  color: #0B1733;
  font-size: 14px;
  font-weight: 900;
  background: transparent;
}

.dataon-advanced-accordion-head span {
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-advanced-accordion-head strong {
  min-width: 0;
  overflow: hidden;
  color: #4B5B73;
  font-size: 12px;
  font-weight: 850;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-advanced-more-fields {
  grid-column: 1/-1;
  min-width: 0;
}

.dataon-advanced-more-fields summary {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  margin-top: 2px;
  color: #0057B8;
  font-size: 13px;
  font-weight: 900;
  cursor: pointer;
  list-style: none;
}

.dataon-advanced-more-fields summary::-webkit-details-marker {
  display: none;
}

.dataon-advanced-more-fields[open] summary {
  margin-bottom: 10px;
}

.dataon-advanced-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 14px;
  border-top: 1px solid #E6EDF5;
}

.dataon-advanced-button-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
}

.dataon-advanced-button-row button {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 900;
  border-radius: 6px;
}

.dataon-advanced-reset {
  display: inline-flex;
  flex: 0 0 auto;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  color: #0057B8;
  font-size: 12px;
  font-weight: 900;
  border: 1px solid #B9D7F7;
  border-radius: 6px;
  background: #F4FAFF;
}

.dataon-advanced-reset:hover {
  color: #FFFFFF;
  border-color: #004899;
  background: #004899;
}

.dataon-advanced-apply {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-advanced-apply:hover {
  background: #003F88;
}

.dataon-advanced-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px 14px;
  border-top: 1px solid #E6EDF5;
  background: #FFFFFF;
  box-shadow: 0 -8px 18px rgba(6, 42, 95, 0.06);
}

.dataon-advanced-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
}

.dataon-advanced-summary > span,
.dataon-advanced-summary-empty {
  color: #6A7890;
  font-size: 12px;
  font-weight: 850;
  white-space: nowrap;
}

.dataon-advanced-summary button {
  display: inline-flex;
  max-width: 100%;
  min-height: 28px;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  color: #0057B8;
  font-size: 12px;
  font-weight: 900;
  border: 1px solid #B9D7F7;
  border-radius: 999px;
  background: #F4FAFF;
}

.dataon-advanced-summary button em {
  min-width: 0;
  overflow: hidden;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-advanced-cancel {
  color: #26364D;
  border: 1px solid #CAD7E8;
  background: #FFFFFF;
}

.dataon-advanced-cancel:hover {
  color: #0057B8;
  border-color: #B9D7F7;
  background: #F4FAFF;
}

.dataon-chip-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 720px;
  margin-top: 12px;
  overflow: visible;
}

.dataon-chip-label {
  flex: 0 0 auto;
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.dataon-chip-list {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  scrollbar-width: none;
}

.dataon-chip-list::-webkit-scrollbar,
.dataon-results-keyword-list::-webkit-scrollbar {
  display: none;
}

.dataon-chip-track {
  display: flex;
  width: max-content;
  min-width: 100%;
  animation: dataon-keyword-slide 34s linear infinite;
  will-change: transform;
}

.dataon-chip-row:hover .dataon-chip-track,
.dataon-results-keywords:hover .dataon-chip-track,
.dataon-chip-row:focus-within .dataon-chip-track,
.dataon-results-keywords:focus-within .dataon-chip-track {
  animation-play-state: paused;
}

.dataon-chip-group {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  min-width: 0;
  padding-right: 6px;
}

.dataon-chip {
  flex: 0 0 auto;
  height: 28px;
  padding: 0 10px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 12px;
  font-weight: 800;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  transition: background 160ms ease, border-color 160ms ease;
}

.dataon-chip:hover {
  border-color: #28C6E8;
  background: rgba(0, 103, 214, 0.4);
}

.dataon-map-quick-button {
  display: inline-flex;
  flex: 0 0 auto;
  min-width: 128px;
  height: 66px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 18px;
  color: #0057B8;
  border: 1px solid #4C9BE8;
  border-radius: 999px;
  background: #FFFFFF;
  box-shadow: 0 10px 24px rgba(0, 51, 118, 0.16);
  font-size: 14px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease, box-shadow 160ms ease;
}

.dataon-map-quick-button:hover,
.dataon-map-quick-button:focus-visible {
  color: #004894;
  border-color: #0067D6;
  background: #F4FAFF;
  box-shadow: 0 12px 26px rgba(0, 103, 214, 0.2);
}

@keyframes dataon-keyword-slide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .dataon-chip-track {
    animation: none;
    transform: none;
  }
}
.dataon-service-section {
  position: relative;
  z-index: 10;
  margin-top: -56px;
}

.dataon-service-grid {
  display: grid;
  gap: 24px;
}

.dataon-service-card {
  display: flex;
  min-height: 136px;
  align-items: center;
  gap: 18px;
  padding: 22px;
  text-align: left;
  border-radius: 20px;
  background: #FFFFFF;
  box-shadow: 0 12px 32px rgba(6, 42, 95, 0.1);
  outline: 1px solid #E6EDF5;
  transition: box-shadow 160ms ease, transform 160ms ease;
}

.dataon-service-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(6, 42, 95, 0.14);
}

.dataon-service-icon {
  display: flex;
  flex: 0 0 auto;
  width: 56px;
  height: 56px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border-radius: 999px;
  background: #0067D6;
  box-shadow: 0 12px 26px rgba(11, 86, 198, 0.28);
}

.dataon-service-card:nth-child(2) .dataon-service-icon {
  background: #28C6E8;
}

.dataon-service-card:nth-child(3) .dataon-service-icon {
  background: #5B5CF6;
}

.dataon-service-card:nth-child(4) .dataon-service-icon {
  background: #1D8FFF;
}

.dataon-service-icon i {
  font-size: 28px;
}

.dataon-service-body {
  min-width: 0;
  flex: 1;
}

.dataon-service-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.dataon-service-title-row h3 {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 18px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-service-title-row i {
  color: #0067D6;
  font-size: 24px;
  transition: transform 160ms ease;
}

.dataon-service-card:hover .dataon-service-title-row i {
  transform: translateX(4px);
}

.dataon-service-body p {
  display: -webkit-box;
  overflow: hidden;
  margin: 8px 0 0;
  color: #4B5B73;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.dataon-content-section {
  padding-top: 40px;
  padding-bottom: 56px;
}

.dataon-content-grid {
  display: grid;
  gap: 24px;
}

.dataon-panel {
  min-width: 0;
  padding: 26px;
  border-radius: 20px;
  background: #FFFFFF;
  box-shadow: 0 12px 32px rgba(6, 42, 95, 0.1);
  outline: 1px solid #E6EDF5;
}

.dataon-status-panel {
  color: #FFFFFF;
  background: #062A5F;
  outline-color: transparent;
}

.dataon-panel-head {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
}

.dataon-panel-head h2 {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 24px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-status-panel .dataon-panel-head h2 {
  color: #FFFFFF;
}

.dataon-panel-head button {
  flex-shrink: 0;
  color: #8A96A8;
  font-size: 14px;
  font-weight: 800;
  background: transparent;
  white-space: nowrap;
}

.dataon-panel-head button:hover {
  color: #0067D6;
}

.dataon-status-panel .dataon-panel-head button {
  color: rgba(255, 255, 255, 0.8);
}

.dataon-status-panel .dataon-panel-head button:hover {
  color: #FFFFFF;
}

.dataon-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.dataon-stat-card {
  padding: 18px;
  color: #FFFFFF;
  text-align: left;
  border-radius: 18px;
  background: #092F69;
  outline: 1px solid #123E78;
  transition: background 160ms ease;
}

.dataon-stat-card:hover {
  background: #123E78;
}

.dataon-stat-card i {
  display: flex;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  color: #28C6E8;
  font-size: 25px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
}

.dataon-stat-card p {
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 14px;
  font-weight: 700;
}

.dataon-stat-card strong {
  display: block;
  margin-top: 4px;
  color: #FFFFFF;
  font-size: 30px;
  font-weight: 900;
  line-height: 1.2;
}

.dataon-stat-card strong span {
  margin-left: 4px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 800;
}

.dataon-list {
  display: grid;
}

.dataon-data-item,
.dataon-notice-item {
  width: 100%;
  text-align: left;
  background: transparent;
}

.dataon-data-item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 58px;
  padding: 10px 0;
  border-bottom: 1px solid #E6EDF5;
}

.dataon-data-item:last-child,
.dataon-notice-item:last-child {
  border-bottom: 0;
}

.dataon-data-icon {
  display: flex;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  color: #0067D6;
  border: 1px solid #E6EDF5;
  border-radius: 999px;
  background: #FCFCFD;
}

.dataon-data-body {
  min-width: 0;
  flex: 1;
}

.dataon-data-body h3 {
  margin: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 16px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.dataon-tag {
  display: inline-flex;
  max-width: 100%;
  height: 24px;
  align-items: center;
  overflow: hidden;
  padding: 0 10px;
  color: #8A96A8;
  font-size: 12px;
  font-weight: 800;
  border-radius: 999px;
  border: 1px solid #E6EDF5;
  background: #FCFCFD;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-tag-row .dataon-tag:nth-child(1) {
  color: #0067D6;
  border-color: #EAF6FF;
  background: #EAF6FF;
}

.dataon-tag-row .dataon-tag:nth-child(2) {
  color: #168A4A;
  border-color: #EEF7F2;
  background: #EEF7F2;
}

.dataon-tag-row .dataon-tag:nth-child(3) {
  color: #3154D4;
  border-color: #F0F4FF;
  background: #F0F4FF;
}

.dataon-data-date {
  flex: 0 0 auto;
  color: #8A96A8;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.dataon-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.dataon-field-item {
  display: flex;
  min-height: 80px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #0B1733;
  font-size: 14px;
  font-weight: 900;
  text-align: center;
  border: 1px solid #E6EDF5;
  border-radius: 18px;
  background: #FFFFFF;
  transition: background 160ms ease, color 160ms ease;
}

.dataon-field-item:hover {
  color: #0067D6;
  background: #EAF6FF;
}

.dataon-field-item i {
  color: #0067D6;
  font-size: 30px;
}

.dataon-notice-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 52px;
  padding: 10px 0;
  border-bottom: 1px solid #E6EDF5;
}

.dataon-notice-item span {
  min-width: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 16px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-notice-item time {
  flex: 0 0 auto;
  color: #8A96A8;
  font-size: 13px;
  font-weight: 600;
}

.dataon-bottom-section {
  color: #FFFFFF;
  background: linear-gradient(90deg, #011438, #021F4F);
}

.dataon-bottom-grid {
  display: grid;
}

.dataon-bottom-link {
  display: flex;
  min-height: 104px;
  align-items: center;
  gap: 20px;
  padding: 16px 20px;
  color: #FFFFFF;
  text-align: left;
  background: transparent;
  transition: background 160ms ease;
}

.dataon-bottom-link:hover {
  background: rgba(255, 255, 255, 0.05);
}

.dataon-bottom-icon {
  display: flex;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 999px;
}

.dataon-bottom-icon i {
  font-size: 30px;
}

.dataon-bottom-link > span:last-child {
  min-width: 0;
}

.dataon-bottom-link strong,
.dataon-bottom-link small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-bottom-link strong {
  font-size: 16px;
  font-weight: 900;
}

.dataon-bottom-link small {
  margin-top: 4px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  font-weight: 600;
}

.dataon-auth-section {
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  min-height: 0;
  padding: clamp(38px, 6vh, 72px) 0;
  background: linear-gradient(180deg, rgba(234, 246, 255, 0.85), rgba(246, 247, 251, 0) 260px), #F6F7FB;
}

.dataon-auth-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dataon-login-card,
.dataon-join-card-compact {
  display: grid;
  width: min(100%, 460px);
  min-width: 0;
  gap: 20px;
  padding: 34px;
  text-align: center;
  border: 1px solid #E1EAF5;
  border-radius: 18px;
  background: #FFFFFF;
  box-shadow: 0 18px 44px rgba(6, 42, 95, 0.12);
}

.dataon-join-card-compact {
  width: min(100%, 720px);
  text-align: left;
}

.dataon-login-logo {
  display: inline-flex;
  justify-self: center;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: transparent;
}

.dataon-login-logo img {
  display: block;
  width: 176px;
  max-width: 100%;
  height: auto;
}

.dataon-login-card h1,
.dataon-join-card-compact > h1 {
  margin: 0;
  color: #0B1733;
  font-size: 28px;
  font-weight: 900;
  line-height: 1.25;
  text-align: center;
}

.dataon-login-submit {
  width: 100%;
}

.dataon-auth-link-row-center {
  justify-content: center;
}

.dataon-auth-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #8A96A8;
  font-size: 13px;
  font-weight: 800;
}

.dataon-auth-divider::before,
.dataon-auth-divider::after {
  flex: 1 1 auto;
  height: 1px;
  background: #E1EAF5;
  content: "";
}

.dataon-kafe-login-button {
  display: flex;
  min-height: 54px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 16px;
  color: #0B1733;
  font-size: 15px;
  font-weight: 900;
  text-decoration: none;
  border: 1px solid #DCE6F2;
  border-radius: 999px;
  background: #FFFFFF;
  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.dataon-kafe-login-button:hover {
  color: #0067D6;
  border-color: #74B5F5;
  background: #F4FAFF;
  box-shadow: 0 10px 22px rgba(0, 103, 214, 0.12);
}

.dataon-kafe-login-button img {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.dataon-join-pane {
  display: grid;
  gap: 18px;
}

.dataon-join-pane h2 {
  margin: 0;
  color: #0B1733;
  font-size: 22px;
  font-weight: 900;
  line-height: 1.35;
  text-align: center;
}

.dataon-auth-page-head {
  max-width: 820px;
  margin-bottom: 28px;
}

.dataon-auth-kicker {
  margin: 0 0 10px;
  color: #0067D6;
  font-size: 13px;
  font-weight: 900;
}

.dataon-auth-page-head h1 {
  margin: 0;
  color: #0B1733;
  font-size: 34px;
  font-weight: 900;
  line-height: 1.25;
}

.dataon-auth-page-head p {
  margin: 12px 0 0;
  color: #4B5B73;
  font-size: 16px;
  font-weight: 650;
  line-height: 1.7;
}

.dataon-auth-layout {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 390px), 1fr));
  gap: 20px;
  align-items: start;
}

.dataon-auth-card,
.dataon-auth-guide,
.dataon-join-card {
  min-width: 0;
  border: 1px solid #E1EAF5;
  border-radius: 18px;
  background: #FFFFFF;
  box-shadow: 0 14px 36px rgba(6, 42, 95, 0.09);
}

.dataon-auth-card {
  display: grid;
  gap: 22px;
  padding: 28px;
}

.dataon-auth-card-alt {
  background: linear-gradient(180deg, #FFFFFF 0%, #F8FBFF 100%);
}

.dataon-auth-card-head,
.dataon-join-card-head {
  display: flex;
  gap: 14px;
  min-width: 0;
}

.dataon-auth-card-icon {
  display: inline-flex;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border-radius: 14px;
  background: #0067D6;
  box-shadow: 0 10px 22px rgba(0, 103, 214, 0.24);
}

.dataon-auth-card-alt .dataon-auth-card-icon {
  background: #062A5F;
}

.dataon-auth-card-head h2,
.dataon-join-card-head h2 {
  margin: 0;
  color: #0B1733;
  font-size: 22px;
  font-weight: 900;
  line-height: 1.3;
}

.dataon-auth-card-head p,
.dataon-join-card-head p {
  margin: 6px 0 0;
  color: #4B5B73;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.55;
}

.dataon-auth-form,
.dataon-join-form,
.dataon-profile-form {
  display: grid;
  gap: 10px;
}

.dataon-auth-form label,
.dataon-join-form label,
.dataon-profile-form label {
  color: #0B1733;
  font-size: 13px;
  font-weight: 900;
}

.dataon-auth-form input,
.dataon-join-form input,
.dataon-profile-form input,
.dataon-profile-form textarea {
  width: 100%;
  min-width: 0;
  min-height: 48px;
  padding: 0 14px;
  color: #0B1733;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid #DCE6F2;
  border-radius: 10px;
  background: #FFFFFF;
  outline: 0;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.dataon-profile-form textarea {
  min-height: 92px;
  padding-top: 12px;
  resize: vertical;
}

.dataon-auth-form input:focus,
.dataon-join-form input:focus,
.dataon-profile-form input:focus,
.dataon-profile-form textarea:focus {
  border-color: #0067D6;
  box-shadow: 0 0 0 3px rgba(0, 103, 214, 0.12);
}

.dataon-form-option-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  color: #6A7890;
  font-size: 12px;
  font-weight: 700;
}

.dataon-check-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #4B5B73;
}

.dataon-check-label input,
.dataon-term-item input {
  width: 18px;
  min-width: 18px;
  height: 18px;
  min-height: 18px;
  accent-color: #0067D6;
}

.dataon-auth-primary-button,
.dataon-auth-secondary-button,
.dataon-auth-primary-link {
  display: inline-flex;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 18px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 900;
  text-align: center;
  text-decoration: none;
  border-radius: 999px;
  transition: background 160ms ease, color 160ms ease, border-color 160ms ease, opacity 160ms ease;
}

.dataon-auth-primary-button,
.dataon-auth-primary-link {
  color: #FFFFFF;
  background: #0067D6;
  box-shadow: 0 10px 22px rgba(0, 103, 214, 0.24);
}

.dataon-auth-primary-button:hover,
.dataon-auth-primary-link:hover {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-auth-primary-button:disabled {
  cursor: not-allowed;
  opacity: 0.42;
}

.dataon-auth-secondary-button {
  color: #0067D6;
  border: 1px solid #B9D7F7;
  background: #FFFFFF;
}

.dataon-auth-secondary-button:hover {
  border-color: #0067D6;
  background: #EAF6FF;
}

.dataon-form-message {
  margin: 0;
  padding: 12px 14px;
  color: #0B3A78;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.5;
  border: 1px solid #CFE2F8;
  border-radius: 10px;
  background: #F0F7FF;
}

.dataon-auth-link-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 4px;
}

.dataon-auth-link-row button {
  min-height: 36px;
  padding: 0 12px;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 800;
  border: 1px solid #E1EAF5;
  border-radius: 999px;
  background: #FFFFFF;
}

.dataon-auth-link-row button:hover {
  color: #0067D6;
  border-color: #B9D7F7;
  background: #F4FAFF;
}

.dataon-federated-panel {
  display: grid;
  gap: 14px;
  padding: 18px;
  border: 1px solid #DCE6F2;
  border-radius: 16px;
  background: #FFFFFF;
}

.dataon-kafe-mark {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 54px;
  padding: 12px 14px;
  color: #FFFFFF;
  border-radius: 12px;
  background: #062A5F;
}

.dataon-kafe-mark strong {
  font-size: 22px;
  font-weight: 900;
}

.dataon-kafe-mark span {
  min-width: 0;
  overflow: hidden;
  color: rgba(255, 255, 255, 0.76);
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-auth-inline-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
}

.dataon-auth-inline-links a {
  color: #0067D6;
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}

.dataon-auth-inline-links a:hover {
  text-decoration: underline;
}

.dataon-global-login {
  display: grid;
  gap: 10px;
  padding: 18px;
  border: 1px solid #E1EAF5;
  border-radius: 16px;
  background: #F8FBFF;
}

.dataon-global-login h3 {
  margin: 0;
  color: #0B1733;
  font-size: 17px;
  font-weight: 900;
}

.dataon-global-login p {
  margin: 0;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.55;
}

.dataon-global-login-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.dataon-global-login-grid button {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #0B1733;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid #DCE6F2;
  border-radius: 10px;
  background: #FFFFFF;
}

.dataon-global-login-grid button:hover {
  color: #0067D6;
  border-color: #B9D7F7;
}

.dataon-auth-guide {
  grid-column: 1/-1;
  padding: 24px;
}

.dataon-auth-guide h2 {
  margin: 0 0 16px;
  color: #0B1733;
  font-size: 20px;
  font-weight: 900;
}

.dataon-auth-guide ul {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-auth-guide li {
  display: flex;
  min-width: 0;
  gap: 12px;
  padding: 14px;
  border: 1px solid #E6EDF5;
  border-radius: 14px;
  background: #FCFCFD;
}

.dataon-auth-guide i {
  display: inline-flex;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  color: #0067D6;
  border-radius: 999px;
  background: #EAF6FF;
}

.dataon-auth-guide span,
.dataon-term-item span {
  min-width: 0;
}

.dataon-auth-guide strong,
.dataon-auth-guide small {
  display: block;
}

.dataon-auth-guide strong {
  color: #0B1733;
  font-size: 14px;
  font-weight: 900;
}

.dataon-auth-guide small {
  margin-top: 4px;
  color: #4B5B73;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.5;
}

.dataon-stepper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 190px), 1fr));
  gap: 10px;
  margin: 0 0 22px;
  padding: 0;
  list-style: none;
}

.dataon-stepper li {
  display: flex;
  min-width: 0;
  gap: 10px;
  padding: 13px;
  color: #6A7890;
  border: 1px solid #E1EAF5;
  border-radius: 14px;
  background: #FFFFFF;
}

.dataon-stepper li.is-active {
  color: #0B1733;
  border-color: #74B5F5;
  background: #F0F7FF;
}

.dataon-stepper li.is-complete {
  color: #0E6A3A;
  border-color: #C9EBD8;
  background: #F2FBF6;
}

.dataon-step-index {
  display: inline-flex;
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 900;
  border-radius: 999px;
  background: #8A96A8;
}

.dataon-stepper li.is-active .dataon-step-index {
  background: #0067D6;
}

.dataon-stepper li.is-complete .dataon-step-index {
  background: #168A4A;
}

.dataon-step-copy {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.dataon-step-copy strong,
.dataon-step-copy small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dataon-step-copy strong {
  color: currentColor;
  font-size: 14px;
  font-weight: 900;
  white-space: nowrap;
}

.dataon-step-copy small {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
}

.dataon-join-stage {
  max-width: 1060px;
}

.dataon-join-card {
  display: grid;
  gap: 22px;
  padding: 28px;
}

.dataon-auth-method-grid,
.dataon-role-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 260px), 1fr));
  gap: 14px;
}

.dataon-auth-method,
.dataon-role-card {
  display: grid;
  min-width: 0;
  gap: 10px;
  padding: 18px;
  color: #0B1733;
  text-align: left;
  border: 1px solid #DCE6F2;
  border-radius: 16px;
  background: #FFFFFF;
  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.dataon-auth-method:hover,
.dataon-auth-method.is-selected,
.dataon-role-card:hover,
.dataon-role-card.is-selected {
  border-color: #0067D6;
  background: #F4FAFF;
  box-shadow: 0 12px 28px rgba(0, 103, 214, 0.12);
}

.dataon-auth-method i,
.dataon-role-card i {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  color: #0067D6;
  font-size: 20px;
  border-radius: 999px;
  background: #EAF6FF;
}

.dataon-auth-method strong {
  font-size: 17px;
  font-weight: 900;
}

.dataon-auth-method span,
.dataon-role-card p,
.dataon-role-card span {
  color: #4B5B73;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.55;
}

.dataon-email-action-row,
.dataon-institution-actions,
.dataon-join-action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.dataon-email-action-row input {
  flex: 1 1 240px;
}

.dataon-email-action-row button:not(.dataon-auth-primary-button),
.dataon-institution-actions button {
  min-height: 48px;
  padding: 0 16px;
  color: #0067D6;
  font-size: 14px;
  font-weight: 900;
  border: 1px solid #B9D7F7;
  border-radius: 999px;
  background: #FFFFFF;
}

.dataon-email-action-row button:not(.dataon-auth-primary-button):hover,
.dataon-institution-actions button:hover {
  background: #EAF6FF;
}

.dataon-institution-verify {
  gap: 14px;
  padding: 18px;
  border: 1px solid #E1EAF5;
  border-radius: 16px;
  background: #F8FBFF;
}

.dataon-institution-verify p,
.dataon-institution-verify small {
  margin: 0;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.6;
}

.dataon-terms-list {
  display: grid;
  gap: 10px;
}

.dataon-term-item {
  display: flex;
  gap: 12px;
  padding: 16px;
  border: 1px solid #E1EAF5;
  border-radius: 14px;
  background: #FCFCFD;
}

.dataon-term-item strong,
.dataon-term-item small {
  display: block;
}

.dataon-term-item strong {
  color: #0B1733;
  font-size: 15px;
  font-weight: 900;
}

.dataon-term-item small {
  margin-top: 4px;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.5;
}

.dataon-role-card h3 {
  margin: 0;
  color: #0B1733;
  font-size: 18px;
  font-weight: 900;
}

.dataon-role-card p {
  margin: 0;
}

.dataon-role-card span {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  min-height: 28px;
  align-items: center;
  padding: 0 10px;
  color: #0067D6;
  font-size: 12px;
  font-weight: 900;
  border-radius: 999px;
  background: #EAF6FF;
}

.dataon-profile-form {
  grid-template-columns: 1fr;
  padding-top: 4px;
}

.dataon-join-card-compact {
  justify-self: center;
  width: min(100%, 720px);
  padding: 34px;
}

.dataon-join-card-compact .dataon-stepper {
  margin-bottom: 0;
}

.dataon-join-card-compact .dataon-role-card {
  justify-items: center;
  text-align: center;
}

.dataon-join-card-compact .dataon-role-card i {
  margin: 0 auto;
}

.dataon-join-card-compact .dataon-term-item {
  align-items: center;
}

.dataon-join-card-compact .dataon-term-item span {
  color: #0B1733;
  font-size: 14px;
  font-weight: 900;
}

.dataon-join-action-center {
  justify-content: center;
}

.dataon-auth-section {
  align-items: flex-start;
  padding: 72px 0 96px;
  background: #FFFFFF;
}

.dataon-auth-center {
  align-items: flex-start;
}

.dataon-login-card,
.dataon-join-card-compact {
  width: min(100%, 620px);
  gap: 26px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.dataon-join-card-compact {
  width: min(100%, 860px);
}

.dataon-auth-title {
  padding-bottom: 18px;
  text-align: center;
  border-bottom: 2px solid #0B1733;
}

.dataon-auth-title h1 {
  margin: 0;
  color: #0B1733;
  font-size: 32px;
  font-weight: 900;
  line-height: 1.25;
}

.dataon-auth-switch {
  display: flex;
  justify-content: flex-end;
  margin-top: -10px;
}

.dataon-auth-switch button {
  min-height: 38px;
  padding: 0 14px;
  color: #0057B8;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid #AFCBEC;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-auth-switch button:hover {
  color: #FFFFFF;
  border-color: #004899;
  background: #004899;
}

.dataon-auth-form input,
.dataon-join-form input,
.dataon-profile-form input,
.dataon-profile-form textarea {
  border-radius: 6px;
}

.dataon-auth-primary-button,
.dataon-auth-secondary-button,
.dataon-auth-link-row button,
.dataon-email-action-row button:not(.dataon-auth-primary-button),
.dataon-institution-actions button {
  border-radius: 6px;
}

.dataon-auth-primary-button {
  background: #0057B8;
  box-shadow: none;
}

.dataon-auth-primary-button:hover {
  background: #003F88;
}

.dataon-auth-secondary-button {
  color: #0057B8;
  border-color: #AFCBEC;
}

.dataon-auth-secondary-button:hover,
.dataon-auth-link-row button:hover,
.dataon-email-action-row button:not(.dataon-auth-primary-button):hover,
.dataon-institution-actions button:hover {
  color: #FFFFFF;
  border-color: #004899;
  background: #004899;
}

.dataon-kafe-login-button {
  width: 100%;
  min-height: 72px;
  padding: 8px 18px;
  border-color: #B7C4D6;
  border-radius: 6px;
  box-shadow: none;
}

.dataon-kafe-login-button:hover {
  border-color: #004899;
  background: #EAF3FF;
  box-shadow: none;
}

.dataon-kafe-login-button img {
  width: min(100%, 360px);
  height: auto;
}

.dataon-stepper li,
.dataon-term-item,
.dataon-role-card,
.dataon-complete-summary,
.dataon-form-message {
  border-radius: 6px;
}

.dataon-stepper li.is-active {
  border-color: #004899;
  background: #EAF3FF;
}

.dataon-role-card {
  border: 2px solid #CAD7E8;
}

.dataon-role-card:hover {
  border-color: #0057B8;
  background: #EAF3FF;
}

.dataon-role-card.is-selected {
  border-color: #003F88;
  background: #E6F1FF;
  box-shadow: inset 0 0 0 1px #003F88;
}

.dataon-auth-complete {
  justify-items: center;
  text-align: center;
}

.dataon-complete-icon {
  display: flex;
  width: 64px;
  height: 64px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 26px;
  border-radius: 999px;
  background: #168A4A;
  box-shadow: 0 14px 26px rgba(22, 138, 74, 0.24);
}

.dataon-auth-complete h2 {
  margin: 0;
  color: #0B1733;
  font-size: 28px;
  font-weight: 900;
  line-height: 1.3;
}

.dataon-auth-complete p {
  max-width: 680px;
  margin: 0;
  color: #4B5B73;
  font-size: 16px;
  font-weight: 650;
  line-height: 1.7;
}

.dataon-complete-summary {
  display: grid;
  width: min(100%, 720px);
  gap: 0;
  margin: 0;
  overflow: hidden;
  border: 1px solid #E1EAF5;
  border-radius: 14px;
  background: #FFFFFF;
}

.dataon-complete-summary div {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  min-width: 0;
  border-bottom: 1px solid #E1EAF5;
}

.dataon-complete-summary div:last-child {
  border-bottom: 0;
}

.dataon-complete-summary dt,
.dataon-complete-summary dd {
  min-width: 0;
  margin: 0;
  padding: 14px 16px;
  color: #0B1733;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}

.dataon-complete-summary dt {
  font-weight: 900;
  background: #F8FBFF;
}

.dataon-complete-summary dd {
  font-weight: 700;
}

.dataon-complete-notice {
  display: flex;
  max-width: 720px;
  gap: 10px;
  padding: 14px 16px;
  color: #0B3A78;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.55;
  text-align: left;
  border: 1px solid #CFE2F8;
  border-radius: 12px;
  background: #F0F7FF;
}

.dataon-complete-notice i {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #0067D6;
}

.dataon-auth-section {
  align-items: flex-start;
  padding: 0;
  background: #FFFFFF;
}

.dataon-auth-center {
  align-items: flex-start;
  justify-content: center;
  max-width: none;
  padding-right: 0;
  padding-left: 0;
}

.dataon-auth-panel,
.dataon-auth-panel.dataon-join-card,
.dataon-auth-panel.dataon-join-card-compact {
  display: grid;
  width: 100%;
  min-width: 0;
  gap: 0;
  padding: 0;
  overflow: visible;
  text-align: left;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.dataon-join-panel,
.dataon-auth-panel.dataon-join-card-compact {
  width: 100%;
}

.dataon-auth-visual {
  display: flex;
  min-height: 230px;
  align-items: center;
  justify-content: center;
  padding: 44px 34px;
  color: #FFFFFF;
  text-align: center;
  border-bottom: 4px solid #0B1733;
  background-color: #021F4F;
  background-image: linear-gradient(90deg, rgba(1, 20, 56, 0.86), rgba(0, 87, 184, 0.62)), url("/assets/dataon/main_bg.png");
  background-position: center;
  background-size: cover;
}

.dataon-auth-visual-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.dataon-auth-visual-copy {
  display: grid;
  gap: 0;
  max-width: 680px;
}

.dataon-auth-visual h1 {
  margin: 0;
  color: #FFFFFF;
  font-size: 38px;
  font-weight: 900;
  line-height: 1.22;
}

.dataon-auth-visual p {
  display: none;
}

.dataon-auth-body {
  display: grid;
  width: 100%;
  max-width: 1280px;
  gap: 36px;
  justify-self: center;
  margin: 0 auto;
  padding: 84px 24px 70px;
  background: #FFFFFF;
}

.dataon-login-panel .dataon-auth-body {
  width: 100%;
  max-width: 1280px;
  justify-items: center;
}

.dataon-login-panel .dataon-auth-form,
.dataon-login-panel .dataon-auth-link-row,
.dataon-login-panel .dataon-auth-divider {
  width: min(100%, 880px);
}

.dataon-auth-form,
.dataon-profile-form {
  gap: 24px;
}

.dataon-form-field {
  display: grid;
  gap: 10px;
  min-width: 0;
  text-align: left;
}

.dataon-form-field > label {
  color: #0B1733;
  font-size: 15px;
  font-weight: 900;
  line-height: 1.45;
  text-align: left;
}

.dataon-auth-form input,
.dataon-profile-form input,
.dataon-email-action-row input {
  min-height: 54px;
  padding: 0 16px;
  font-size: 16px;
  font-weight: 700;
  border-color: #C8D4E4;
  border-radius: 6px;
}

.dataon-email-action-row {
  gap: 10px;
}

.dataon-email-action-row button:not(.dataon-auth-primary-button) {
  min-height: 54px;
  padding: 0 18px;
  font-size: 15px;
}

.dataon-field-message {
  margin: 0;
  color: #0B5CAD;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.45;
}

.dataon-field-message.is-error {
  color: #B42318;
}

.dataon-field-message.is-success {
  color: #0B6E3D;
}

.dataon-form-option-row {
  justify-content: flex-start;
  gap: 10px;
  color: #4B5B73;
  font-size: 14px;
}

.dataon-check-label {
  gap: 10px;
  line-height: 1.4;
}

.dataon-check-label span {
  color: #26364D;
  font-size: 14px;
  font-weight: 850;
}

.dataon-check-label input[type=checkbox],
.dataon-term-item input[type=checkbox] {
  appearance: none;
  flex: 0 0 24px;
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
  margin: 0;
  border: 2px solid #8EA0B7;
  border-radius: 7px;
  background: #FFFFFF;
  cursor: pointer;
}

.dataon-check-label input[type=checkbox]:checked,
.dataon-term-item input[type=checkbox]:checked {
  border-color: #0057B8;
  background: #0057B8;
  box-shadow: inset 0 0 0 4px #FFFFFF;
}

.dataon-auth-primary-button,
.dataon-auth-secondary-button,
.dataon-auth-link-row button,
.dataon-email-action-row button:not(.dataon-auth-primary-button),
.dataon-institution-actions button {
  min-height: 52px;
  padding: 0 22px;
  font-size: 15px;
  border-radius: 6px;
}

.dataon-auth-primary-button {
  background: #0057B8;
  box-shadow: none;
}

.dataon-auth-primary-button:hover {
  background: #003F88;
}

.dataon-auth-secondary-button,
.dataon-auth-link-row button,
.dataon-email-action-row button:not(.dataon-auth-primary-button),
.dataon-institution-actions button {
  color: #0057B8;
  border-color: #AFCBEC;
  background: #FFFFFF;
}

.dataon-auth-secondary-button:hover,
.dataon-auth-link-row button:hover,
.dataon-email-action-row button:not(.dataon-auth-primary-button):hover,
.dataon-institution-actions button:hover {
  color: #FFFFFF;
  border-color: #004899;
  background: #004899;
}

.dataon-login-submit {
  width: 100%;
}

.dataon-auth-link-row {
  gap: 10px;
  padding-top: 0;
}

.dataon-auth-link-row-center {
  justify-content: center;
}

.dataon-auth-link-row button {
  min-width: 154px;
}

.dataon-auth-divider {
  gap: 14px;
  color: #6A7890;
  font-size: 14px;
}

.dataon-kafe-login-button {
  width: 176px;
  min-height: 44px;
  justify-self: center;
  padding: 4px 14px;
  border-color: #B7C4D6;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: none;
}

.dataon-kafe-login-button:hover {
  border-color: #004899;
  background: #F1F6FD;
  box-shadow: none;
}

.dataon-kafe-login-button img {
  display: block;
  width: 108px;
  height: auto;
  object-fit: contain;
}

.dataon-stepper {
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 12px;
  margin: 0;
  overflow-x: auto;
  scrollbar-width: thin;
}

.dataon-stepper li {
  flex-wrap: nowrap;
  padding: 15px;
  border-radius: 6px;
}

.dataon-step-copy strong {
  font-size: 15px;
}

.dataon-step-copy small {
  font-size: 13px;
  white-space: nowrap;
}

.dataon-join-pane {
  gap: 24px;
}

.dataon-join-pane h2 {
  font-size: 24px;
}

.dataon-role-grid {
  gap: 16px;
}

.dataon-role-card {
  gap: 12px;
  padding: 24px;
  border: 2px solid #CAD7E8;
  border-radius: 6px;
}

.dataon-role-card:hover {
  border-color: #0057B8;
  background: #EAF3FF;
}

.dataon-role-card.is-selected {
  border-color: #003F88;
  background: #E6F1FF;
  box-shadow: inset 0 0 0 1px #003F88;
}

.dataon-role-card h3 {
  font-size: 20px;
}

.dataon-role-card p {
  font-size: 15px;
  line-height: 1.6;
}

.dataon-terms-list {
  gap: 14px;
}

.dataon-term-item {
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  border-color: #D5E0ED;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-term-copy {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.dataon-join-card-compact .dataon-term-item .dataon-term-copy {
  color: #0B1733;
  font-size: inherit;
  font-weight: inherit;
}

.dataon-term-copy strong {
  color: #0B1733;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}

.dataon-term-copy small {
  color: #4B5B73;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.65;
}

.dataon-terms-all {
  display: flex;
  justify-content: flex-end;
}

.dataon-join-action-row {
  gap: 12px;
  justify-content: flex-end;
}

.dataon-join-action-center {
  justify-content: center;
}

.dataon-auth-switch-bottom {
  justify-content: center;
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
}

.dataon-auth-switch button {
  min-height: 44px;
  padding: 0 18px;
  font-size: 14px;
}

@media (max-width: 640px) {
  .dataon-auth-section {
    padding: 0;
  }
  .dataon-auth-visual {
    min-height: 184px;
    padding: 32px 22px;
  }
  .dataon-auth-visual h1 {
    font-size: 30px;
  }
  .dataon-auth-visual p {
    font-size: 15px;
  }
  .dataon-auth-body {
    gap: 28px;
    padding: 64px 20px 46px;
  }
  .dataon-auth-link-row button,
  .dataon-join-action-row button {
    width: 100%;
  }
  .dataon-email-action-row {
    display: grid;
  }
  .dataon-terms-all,
  .dataon-join-action-row {
    justify-content: stretch;
  }
}
.dataon-dataset-detail {
  flex: 1 0 auto;
  background: #F3F6FA;
}

.dataon-dataset-hero {
  color: #FFFFFF;
  border-bottom: 1px solid #DCE6F2;
  background: linear-gradient(90deg, rgba(3, 32, 78, 0.96), rgba(0, 87, 184, 0.78)), url("/assets/dataon/main_bg.png");
  background-position: center;
  background-size: cover;
}

.dataon-dataset-hero-inner {
  display: grid;
  gap: 22px;
  padding-top: 24px;
  padding-bottom: 34px;
}

.dataon-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 13px;
  font-weight: 800;
}

.dataon-breadcrumb button {
  color: inherit;
  background: transparent;
}

.dataon-breadcrumb button:hover {
  color: #FFFFFF;
}

.dataon-breadcrumb i {
  font-size: 10px;
}

.dataon-breadcrumb span {
  color: #FFFFFF;
}

.dataon-dataset-title-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 22px;
  align-items: start;
}

.dataon-dataset-title-copy {
  display: grid;
  gap: 12px;
  min-width: 0;
}

.dataon-dataset-kicker {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dataon-dataset-kicker span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  padding: 0 10px;
  color: #D8ECFF;
  font-size: 12px;
  font-weight: 900;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 6px;
  background: rgba(2, 31, 79, 0.34);
}

.dataon-dataset-title-copy h1 {
  margin: 0;
  color: #FFFFFF;
  font-size: clamp(30px, 4vw, 46px);
  font-weight: 900;
  line-height: 1.18;
}

.dataon-dataset-title-en {
  margin: 0;
  color: #9DD7FF;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.45;
}

.dataon-dataset-summary {
  max-width: 860px;
  margin: 0;
  color: rgba(255, 255, 255, 0.88);
  font-size: 16px;
  font-weight: 650;
  line-height: 1.75;
}

.dataon-dataset-badges,
.dataon-keyword-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  min-width: 0;
}

.dataon-dataset-badges span,
.dataon-keyword-list span {
  display: inline-flex;
  max-width: 100%;
  min-height: 28px;
  align-items: center;
  overflow: hidden;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 900;
  border-radius: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-dataset-badges span {
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.12);
}

.dataon-dataset-action-panel,
.dataon-side-box,
.dataon-detail-section {
  min-width: 0;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 14px 34px rgba(6, 42, 95, 0.08);
}

.dataon-dataset-action-panel {
  display: grid;
  gap: 16px;
  padding: 18px;
  color: #0B1733;
}

.dataon-dataset-action-head {
  display: flex;
  gap: 12px;
  align-items: center;
  min-width: 0;
}

.dataon-provider-mark {
  display: inline-flex;
  flex: 0 0 auto;
  width: 56px;
  height: 56px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 900;
  border-radius: 8px;
  background: #0E6A3A;
}

.dataon-dataset-action-head div {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.dataon-dataset-action-head strong,
.dataon-dataset-action-head small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-dataset-action-head strong {
  color: #0B1733;
  font-size: 16px;
  font-weight: 900;
}

.dataon-dataset-action-head small {
  color: #5D6B82;
  font-size: 12px;
  font-weight: 750;
}

.dataon-dataset-action-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.dataon-dataset-action-grid button {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 10px;
  color: #0057B8;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid #B9D7F7;
  border-radius: 6px;
  background: #F4FAFF;
}

.dataon-dataset-action-grid button:hover {
  color: #FFFFFF;
  border-color: #004899;
  background: #004899;
}

.dataon-dataset-action-message {
  margin: 0;
  padding: 10px 12px;
  color: #0B5CAD;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.45;
  border: 1px solid #CFE2F8;
  border-radius: 6px;
  background: #F0F7FF;
}

.dataon-dataset-tabs-wrap {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #DCE6F2;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(10px);
}

.dataon-dataset-tabs {
  display: flex;
  gap: 2px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0;
  scrollbar-width: thin;
}

.dataon-dataset-tabs button {
  position: relative;
  flex: 0 0 auto;
  min-height: 54px;
  padding: 0 18px;
  color: #4B5B73;
  font-size: 15px;
  font-weight: 900;
  background: transparent;
  white-space: nowrap;
}

.dataon-dataset-tabs button::after {
  position: absolute;
  right: 12px;
  bottom: 0;
  left: 12px;
  height: 3px;
  background: transparent;
  content: "";
}

.dataon-dataset-tabs button.is-active {
  color: #0057B8;
}

.dataon-dataset-tabs button.is-active::after {
  background: #0057B8;
}

.dataon-dataset-body {
  padding: 28px 0 64px;
}

.dataon-dataset-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}

.dataon-dataset-content,
.dataon-dataset-side {
  display: grid;
  min-width: 0;
  gap: 18px;
}

.dataon-detail-section {
  display: grid;
  gap: 22px;
  padding: 22px;
}

.dataon-detail-section-head {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  border-bottom: 1px solid #E6EDF5;
}

.dataon-detail-section-head h2 {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 22px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-detail-section-head span,
.dataon-detail-section-head a {
  flex: 0 0 auto;
  color: #5D6B82;
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
  white-space: nowrap;
}

.dataon-detail-section-head a:hover {
  color: #0057B8;
}

.dataon-description-block {
  display: grid;
  gap: 10px;
}

.dataon-description-block p {
  margin: 0;
  color: #26364D;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.75;
}

.dataon-composition-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.dataon-composition-grid article {
  display: grid;
  gap: 4px;
  min-width: 0;
  padding: 16px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-composition-grid span,
.dataon-composition-grid small {
  color: #5D6B82;
  font-size: 12px;
  font-weight: 800;
}

.dataon-composition-grid strong {
  color: #0B1733;
  font-size: 28px;
  font-weight: 900;
  line-height: 1.1;
}

.dataon-group-list,
.dataon-pairing-list,
.dataon-creator-list,
.dataon-file-list,
.dataon-recommendation-list {
  display: grid;
  gap: 10px;
  min-width: 0;
}

.dataon-group-list article,
.dataon-pairing-list article,
.dataon-creator-list article {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-group-list div,
.dataon-creator-list div {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.dataon-group-list strong,
.dataon-creator-list strong,
.dataon-file-name strong,
.dataon-relation-nodes strong,
.dataon-recommendation-list strong {
  min-width: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 14px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-group-list small,
.dataon-creator-list small,
.dataon-file-name small,
.dataon-relation-nodes small,
.dataon-recommendation-list span {
  min-width: 0;
  overflow: hidden;
  color: #6A7890;
  font-size: 12px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-group-list article > span,
.dataon-pairing-list strong {
  flex: 0 0 auto;
  color: #0057B8;
  font-size: 18px;
  font-weight: 900;
}

.dataon-pairing-list article {
  border-left-width: 5px;
}

.dataon-pairing-list article.is-strong {
  border-left-color: #0057B8;
}

.dataon-pairing-list article.is-medium {
  border-left-color: #168A4A;
}

.dataon-pairing-list article.is-light {
  border-left-color: #B7791F;
}

.dataon-pairing-list span {
  min-width: 0;
  overflow: hidden;
  color: #26364D;
  font-size: 14px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-creator-list article {
  justify-content: flex-start;
}

.dataon-creator-list i {
  display: inline-flex;
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  color: #0057B8;
  border-radius: 999px;
  background: #EAF3FF;
}

.dataon-creator-list p {
  margin: 0;
  overflow: hidden;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-creator-list article > span {
  flex: 0 0 auto;
  margin-left: auto;
  color: #168A4A;
  font-size: 12px;
  font-weight: 900;
}

.dataon-preview-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 14px;
}

.dataon-preview-panel {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #CAD7E8;
  border-radius: 8px;
  background: #0B1733;
}

.dataon-preview-toolbar {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  color: #FFFFFF;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  background: #17233A;
}

.dataon-preview-toolbar > div:first-child {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.dataon-preview-toolbar strong,
.dataon-preview-toolbar span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-preview-toolbar strong {
  font-size: 14px;
  font-weight: 900;
}

.dataon-preview-toolbar span {
  color: rgba(255, 255, 255, 0.68);
  font-size: 12px;
  font-weight: 750;
}

.dataon-preview-tools {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
}

.dataon-preview-tools button {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
}

.dataon-preview-tools button:hover {
  background: #0057B8;
}

.dataon-preview-canvas {
  position: relative;
  display: flex;
  min-height: 460px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 28px;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%), linear-gradient(-45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%), #081222;
  background-size: 22px 22px;
}

.dataon-preview-image {
  position: relative;
  width: min(100%, 520px);
  aspect-ratio: 1;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.32);
  transform-origin: center;
  transition: transform 160ms ease;
}

.dataon-preview-canvas.is-kompsat .dataon-preview-image {
  background: radial-gradient(circle at 28% 32%, rgba(77, 156, 74, 0.72), transparent 24%), radial-gradient(circle at 72% 62%, rgba(19, 92, 45, 0.82), transparent 28%), radial-gradient(circle at 48% 76%, rgba(149, 117, 59, 0.74), transparent 22%), linear-gradient(135deg, #0E3A2A, #2F5D3A 42%, #7B6B3F 70%, #133E32);
}

.dataon-preview-canvas.is-sentinel .dataon-preview-image {
  background: radial-gradient(circle at 60% 28%, rgba(64, 128, 186, 0.62), transparent 24%), radial-gradient(circle at 35% 60%, rgba(50, 142, 82, 0.74), transparent 28%), linear-gradient(135deg, #183A5A, #2D7A4F 52%, #9A874E);
}

.dataon-preview-canvas.is-label .dataon-preview-image {
  background: linear-gradient(120deg, transparent 0 34%, rgba(245, 87, 87, 0.88) 34% 45%, transparent 45% 62%, rgba(245, 87, 87, 0.76) 62% 72%, transparent 72%), radial-gradient(circle at 32% 64%, rgba(245, 87, 87, 0.94), transparent 18%), #10251D;
}

.dataon-preview-image::after {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: repeating-linear-gradient(0deg, rgba(255, 255, 255, 0.05) 0 1px, transparent 1px 42px), repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0 1px, transparent 1px 42px);
  content: "";
}

.dataon-preview-grid-line {
  position: absolute;
  background: rgba(255, 255, 255, 0.34);
}

.dataon-preview-grid-line:nth-child(1) {
  top: 50%;
  right: 0;
  left: 0;
  height: 1px;
}

.dataon-preview-grid-line:nth-child(2) {
  top: 0;
  bottom: 0;
  left: 50%;
  width: 1px;
}

.dataon-preview-label,
.dataon-preview-coordinate {
  position: absolute;
  left: 14px;
  z-index: 2;
  max-width: calc(100% - 28px);
  overflow: hidden;
  color: #FFFFFF;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}

.dataon-preview-label {
  top: 14px;
  font-size: 15px;
}

.dataon-preview-coordinate {
  bottom: 14px;
  font-size: 12px;
}

.dataon-preview-meta {
  min-width: 0;
  padding: 16px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-preview-meta dl,
.dataon-side-box dl,
.dataon-project-panel dl {
  display: grid;
  gap: 0;
  margin: 0;
}

.dataon-preview-meta div,
.dataon-side-box dl div,
.dataon-project-panel dl div {
  display: grid;
  grid-template-columns: 104px minmax(0, 1fr);
  gap: 10px;
  min-width: 0;
  padding: 10px 0;
  border-bottom: 1px solid #E1EAF5;
}

.dataon-preview-meta div:last-child,
.dataon-side-box dl div:last-child,
.dataon-project-panel dl div:last-child {
  border-bottom: 0;
}

.dataon-preview-meta dt,
.dataon-side-box dt,
.dataon-project-panel dt,
.dataon-metadata-grid dt {
  color: #5D6B82;
  font-size: 12px;
  font-weight: 900;
}

.dataon-preview-meta dd,
.dataon-side-box dd,
.dataon-project-panel dd,
.dataon-metadata-grid dd {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.45;
  text-overflow: ellipsis;
}

.dataon-file-list button {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  min-width: 0;
  min-height: 58px;
  padding: 10px 12px;
  text-align: left;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-file-list button:hover,
.dataon-file-list button.is-active {
  border-color: #0057B8;
  background: #F0F7FF;
}

.dataon-file-list i {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  color: #0057B8;
  border-radius: 6px;
  background: #EAF3FF;
}

.dataon-file-name {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.dataon-file-size {
  color: #4B5B73;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.dataon-metadata-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  overflow: hidden;
  margin: 0;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
}

.dataon-metadata-grid div {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  min-width: 0;
  border-right: 1px solid #E1EAF5;
  border-bottom: 1px solid #E1EAF5;
}

.dataon-metadata-grid div:nth-child(2n) {
  border-right: 0;
}

.dataon-metadata-grid dt,
.dataon-metadata-grid dd {
  min-width: 0;
  margin: 0;
  padding: 12px 14px;
}

.dataon-metadata-grid dt {
  background: #F8FBFF;
}

.dataon-keyword-panel,
.dataon-project-panel {
  display: grid;
  gap: 12px;
  min-width: 0;
}

.dataon-keyword-panel h3,
.dataon-project-panel h3,
.dataon-citation-card h3,
.dataon-recommendation-list h3 {
  margin: 0;
  color: #0B1733;
  font-size: 17px;
  font-weight: 900;
}

.dataon-keyword-list span {
  color: #0057B8;
  border: 1px solid #CFE2F8;
  background: #F0F7FF;
}

.dataon-project-panel {
  padding: 16px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-relation-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.42fr) minmax(0, 0.58fr);
  gap: 14px;
}

.dataon-relation-nodes,
.dataon-relation-edges {
  display: grid;
  align-content: start;
  gap: 10px;
  min-width: 0;
}

.dataon-relation-nodes article {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-relation-nodes i {
  display: inline-flex;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border-radius: 6px;
  background: #0057B8;
}

.dataon-relation-nodes div {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.dataon-relation-edges article {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 12px;
  color: #4B5B73;
  border: 1px dashed #CAD7E8;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-relation-edges span,
.dataon-relation-edges strong {
  min-width: 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-relation-edges strong {
  color: #0057B8;
}

.dataon-relation-edges i {
  color: #8A96A8;
  font-size: 10px;
}

.dataon-citation-card {
  display: grid;
  gap: 10px;
  min-width: 0;
  padding: 16px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-citation-card p,
.dataon-citation-card pre {
  min-width: 0;
  margin: 0;
  overflow: auto;
  color: #26364D;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.65;
  white-space: pre-wrap;
}

.dataon-citation-card pre {
  padding: 14px;
  color: #FFFFFF;
  border-radius: 6px;
  background: #17233A;
}

.dataon-recommendation-list {
  gap: 12px;
}

.dataon-recommendation-list article {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  padding: 14px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-recommendation-list article div {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.dataon-recommendation-list em {
  display: inline-flex;
  flex: 0 0 auto;
  min-height: 30px;
  align-items: center;
  padding: 0 10px;
  color: #0E6A3A;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
  border-radius: 999px;
  background: #ECF8F1;
}

.dataon-side-box {
  display: grid;
  gap: 12px;
  padding: 16px;
}

.dataon-side-box h2 {
  margin: 0;
  color: #0B1733;
  font-size: 17px;
  font-weight: 900;
}

.dataon-usage-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.dataon-usage-grid div {
  display: grid;
  gap: 4px;
  min-width: 0;
  padding: 12px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-usage-grid span {
  color: #5D6B82;
  font-size: 12px;
  font-weight: 850;
}

.dataon-usage-grid strong {
  color: #0B1733;
  font-size: 22px;
  font-weight: 900;
}

.dataon-quick-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  min-height: 42px;
  padding: 0 10px;
  color: #26364D;
  text-align: left;
  border: 1px solid #E1EAF5;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-quick-file:hover,
.dataon-quick-file.is-active {
  color: #0057B8;
  border-color: #0057B8;
  background: #F0F7FF;
}

.dataon-quick-file span,
.dataon-quick-file strong {
  min-width: 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 980px) {
  .dataon-dataset-title-grid {
    grid-template-columns: minmax(0, 1fr) 360px;
  }
  .dataon-dataset-layout {
    grid-template-columns: minmax(0, 1fr) 300px;
  }
  .dataon-dataset-side {
    position: sticky;
    top: 74px;
  }
  .dataon-preview-layout {
    grid-template-columns: minmax(0, 1fr) 260px;
  }
}
@media (max-width: 900px) {
  .dataon-composition-grid,
  .dataon-metadata-grid,
  .dataon-relation-grid {
    grid-template-columns: 1fr;
  }
  .dataon-metadata-grid div,
  .dataon-metadata-grid div:nth-child(2n) {
    border-right: 0;
  }
}
@media (max-width: 720px) {
  .dataon-dataset-hero-inner {
    padding-top: 18px;
    padding-bottom: 24px;
  }
  .dataon-dataset-title-copy h1 {
    font-size: 30px;
  }
  .dataon-dataset-action-grid {
    grid-template-columns: 1fr;
  }
  .dataon-detail-section {
    padding: 16px;
  }
  .dataon-detail-section-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataon-dataset-tabs button {
    min-height: 48px;
    padding: 0 14px;
    font-size: 14px;
  }
  .dataon-preview-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .dataon-preview-tools {
    overflow-x: auto;
    padding-bottom: 2px;
  }
  .dataon-preview-canvas {
    min-height: 320px;
    padding: 18px;
  }
  .dataon-file-list button {
    grid-template-columns: 34px minmax(0, 1fr);
  }
  .dataon-file-size {
    grid-column: 2;
  }
  .dataon-metadata-grid div,
  .dataon-preview-meta div,
  .dataon-side-box dl div,
  .dataon-project-panel dl div {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  .dataon-recommendation-list article,
  .dataon-group-list article,
  .dataon-pairing-list article {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 520px) {
  .dataon-dataset-hero-inner,
  .dataon-dataset-body {
    padding-right: 0;
    padding-left: 0;
  }
  .dataon-dataset-title-en,
  .dataon-dataset-summary {
    font-size: 14px;
  }
  .dataon-composition-grid strong {
    font-size: 24px;
  }
  .dataon-creator-list article {
    align-items: flex-start;
  }
  .dataon-creator-list article > span {
    margin-left: 0;
  }
  .dataon-preview-canvas {
    min-height: 270px;
  }
}
.dataon-prototype-detail {
  flex: 1 0 auto;
  background: #F4F7FB;
}

.dataon-prototype-loading {
  padding: 80px 0;
  color: #26364D;
  font-size: 15px;
  font-weight: 800;
}

.dataon-prototype-hero {
  color: #FFFFFF;
  background: linear-gradient(90deg, rgba(2, 31, 79, 0.96), rgba(0, 87, 184, 0.78)), url("/assets/dataon/main_bg.png");
  background-position: center;
  background-size: cover;
}

.dataon-prototype-hero-inner {
  display: grid;
  gap: 18px;
  padding-top: 22px;
  padding-bottom: 28px;
}

.dataon-prototype-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 12px;
  font-weight: 850;
}

.dataon-prototype-breadcrumb button {
  color: inherit;
  background: transparent;
}

.dataon-prototype-breadcrumb button:hover,
.dataon-prototype-breadcrumb span {
  color: #FFFFFF;
}

.dataon-prototype-breadcrumb i {
  font-size: 10px;
}

.dataon-prototype-hero-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 22px;
  align-items: end;
}

.dataon-prototype-title {
  display: grid;
  min-width: 0;
  gap: 10px;
}

.dataon-prototype-title h1 {
  margin: 0;
  color: #FFFFFF;
  font-size: 38px;
  font-weight: 900;
  line-height: 1.18;
}

.dataon-prototype-title-en,
.dataon-prototype-summary {
  max-width: 900px;
  margin: 0;
  line-height: 1.6;
}

.dataon-prototype-title-en {
  color: #9DD7FF;
  font-size: 16px;
  font-weight: 850;
}

.dataon-prototype-summary {
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  font-weight: 700;
}

.dataon-prototype-badges,
.dataon-prototype-creators,
.dataon-prototype-keyword-block,
.dataon-prototype-inline-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.dataon-prototype-badges span,
.dataon-prototype-creators span {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  padding: 0 8px;
  overflow: hidden;
  font-size: 11px;
  font-weight: 900;
  border-radius: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-badges span {
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.12);
}

.dataon-prototype-creators span {
  color: #D8ECFF;
  border: 1px solid rgba(157, 215, 255, 0.28);
  background: rgba(2, 31, 79, 0.36);
}

.dataon-prototype-action,
.dataon-prototype-section,
.dataon-prototype-file-sidebar,
.dataon-prototype-viewer,
.dataon-prototype-file-meta,
.dataon-prototype-node-detail {
  min-width: 0;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 12px 28px rgba(6, 42, 95, 0.08);
}

.dataon-prototype-action {
  display: grid;
  gap: 14px;
  padding: 16px;
  color: #0B1733;
}

.dataon-prototype-action-meta {
  display: grid;
  gap: 3px;
}

.dataon-prototype-action-meta strong,
.dataon-prototype-action-meta span,
.dataon-prototype-action-meta small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-action-meta strong {
  color: #0B1733;
  font-size: 16px;
  font-weight: 900;
}

.dataon-prototype-action-meta span,
.dataon-prototype-action-meta small {
  color: #5D6B82;
  font-size: 12px;
  font-weight: 800;
}

.dataon-prototype-action-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.dataon-prototype-action-grid button,
.dataon-prototype-inline-actions button,
.dataon-prototype-file-actions button,
.dataon-prototype-text-toggle {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  color: #0057B8;
  font-size: 12px;
  font-weight: 900;
  border: 1px solid #B9D7F7;
  border-radius: 6px;
  background: #F4FAFF;
}

.dataon-prototype-action-grid button:hover,
.dataon-prototype-inline-actions button:hover,
.dataon-prototype-file-actions button:hover,
.dataon-prototype-text-toggle:hover {
  color: #FFFFFF;
  border-color: #004899;
  background: #004899;
}

.dataon-prototype-action p,
.dataon-prototype-copy-message {
  margin: 0;
  padding: 9px 10px;
  color: #0B5CAD;
  font-size: 12px;
  font-weight: 850;
  line-height: 1.45;
  border: 1px solid #CFE2F8;
  border-radius: 6px;
  background: #F0F7FF;
}

.dataon-prototype-sticky {
  position: sticky;
  top: 0;
  z-index: 30;
  border-bottom: 1px solid #DCE6F2;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
}

.dataon-prototype-sticky-inner {
  display: grid;
  grid-template-columns: minmax(220px, 0.34fr) minmax(0, 0.66fr);
  gap: 16px;
  align-items: center;
}

.dataon-prototype-sticky-title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
}

.dataon-prototype-sticky-title strong {
  min-width: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 14px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-sticky-title span {
  flex: 0 0 auto;
  padding: 2px 6px;
  color: #0057B8;
  font-size: 10px;
  font-weight: 900;
  border-radius: 5px;
  background: #EAF3FF;
}

.dataon-prototype-tabs {
  display: flex;
  justify-content: flex-end;
  gap: 2px;
  min-width: 0;
  overflow-x: auto;
}

.dataon-prototype-tabs button {
  position: relative;
  flex: 0 0 auto;
  min-height: 54px;
  padding: 0 14px;
  color: #4B5B73;
  font-size: 14px;
  font-weight: 900;
  background: transparent;
  white-space: nowrap;
}

.dataon-prototype-tabs button::after {
  position: absolute;
  right: 10px;
  bottom: 0;
  left: 10px;
  height: 3px;
  background: transparent;
  content: "";
}

.dataon-prototype-tabs button.is-active {
  color: #0057B8;
}

.dataon-prototype-tabs button.is-active::after {
  background: #0057B8;
}

.dataon-prototype-body {
  padding: 28px 0 64px;
}

.dataon-prototype-tab-panel {
  display: grid;
  gap: 18px;
}

.dataon-prototype-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}

.dataon-prototype-section-head h2 {
  margin: 0;
  color: #0B1733;
  font-size: 24px;
  font-weight: 900;
}

.dataon-prototype-section-head span,
.dataon-prototype-section-head button {
  color: #5D6B82;
  font-size: 13px;
  font-weight: 850;
}

.dataon-prototype-section-head button {
  min-height: 34px;
  padding: 0 10px;
  border: 1px solid #CAD7E8;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-prototype-section {
  display: grid;
  gap: 16px;
  padding: 20px;
}

.dataon-prototype-section h3,
.dataon-prototype-file-meta h3,
.dataon-prototype-node-detail h3 {
  margin: 0;
  color: #0B1733;
  font-size: 18px;
  font-weight: 900;
}

.dataon-prototype-section h4 {
  margin: 0;
  color: #26364D;
  font-size: 13px;
  font-weight: 900;
}

.dataon-prototype-lead {
  margin: 0;
  color: #26364D;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.7;
}

.dataon-prototype-description-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.dataon-prototype-description-grid > div {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.dataon-prototype-description-grid pre,
.dataon-prototype-json,
.dataon-prototype-citation-text {
  min-width: 0;
  margin: 0;
  overflow: auto;
  white-space: pre-wrap;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dataon-prototype-description-grid pre {
  max-height: 420px;
  padding: 14px;
  color: #26364D;
  font: 700 13px/1.7 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-prototype-text-toggle {
  justify-self: start;
}

.dataon-prototype-metric-grid,
.dataon-prototype-usage-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.dataon-prototype-metric-grid div,
.dataon-prototype-usage-grid div {
  display: grid;
  gap: 5px;
  min-width: 0;
  padding: 14px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-prototype-metric-grid span,
.dataon-prototype-usage-grid span {
  color: #5D6B82;
  font-size: 12px;
  font-weight: 850;
}

.dataon-prototype-metric-grid strong,
.dataon-prototype-usage-grid strong {
  overflow: hidden;
  color: #0B1733;
  font-size: 22px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-table {
  display: grid;
  overflow: hidden;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
}

.dataon-prototype-table-row {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr) 100px;
  min-width: 0;
  border-bottom: 1px solid #E1EAF5;
}

.dataon-prototype-table-row:last-child {
  border-bottom: 0;
}

.dataon-prototype-table-row span {
  min-width: 0;
  overflow: hidden;
  padding: 11px 12px;
  color: #26364D;
  font-size: 13px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-table-row.is-head span {
  color: #0B1733;
  font-weight: 900;
  background: #F0F7FF;
}

.dataon-prototype-rule-grid,
.dataon-prototype-pairing {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.dataon-prototype-rule-grid div,
.dataon-prototype-pairing article {
  min-width: 0;
  padding: 14px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-prototype-rule-grid strong,
.dataon-prototype-pairing span {
  display: block;
  color: #0B1733;
  font-size: 13px;
  font-weight: 900;
}

.dataon-prototype-rule-grid p {
  margin: 7px 0 0;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.6;
}

.dataon-prototype-pairing strong {
  display: block;
  margin-top: 6px;
  color: #0057B8;
  font-size: 22px;
  font-weight: 900;
}

.dataon-prototype-keyword-block {
  gap: 14px;
}

.dataon-prototype-keyword-block > div {
  display: flex;
  flex: 1 1 280px;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.dataon-prototype-keyword-block h4 {
  flex: 0 0 100%;
}

.dataon-prototype-keyword-block span {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  padding: 0 8px;
  color: #0057B8;
  font-size: 12px;
  font-weight: 900;
  border: 1px solid #CFE2F8;
  border-radius: 6px;
  background: #F0F7FF;
}

.dataon-prototype-definition-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  overflow: hidden;
  margin: 0;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
}

.dataon-prototype-definition-grid.is-single {
  grid-template-columns: 1fr;
}

.dataon-prototype-definition-grid div {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  min-width: 0;
  border-right: 1px solid #E1EAF5;
  border-bottom: 1px solid #E1EAF5;
}

.dataon-prototype-definition-grid div:nth-child(2n),
.dataon-prototype-definition-grid.is-single div {
  border-right: 0;
}

.dataon-prototype-definition-grid dt,
.dataon-prototype-definition-grid dd {
  min-width: 0;
  margin: 0;
  padding: 11px 12px;
  font-size: 13px;
  line-height: 1.55;
}

.dataon-prototype-definition-grid dt {
  color: #5D6B82;
  font-weight: 900;
  background: #F8FBFF;
}

.dataon-prototype-definition-grid dd {
  overflow: hidden;
  color: #0B1733;
  font-weight: 750;
  text-overflow: ellipsis;
}

.dataon-prototype-file-workspace {
  display: grid;
  grid-template-columns: 290px minmax(0, 1fr) 300px;
  gap: 14px;
  align-items: start;
}

.dataon-prototype-file-workspace.is-fullscreen {
  position: fixed;
  inset: 18px;
  z-index: 100;
  overflow: auto;
  padding: 16px;
  background: #F4F7FB;
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.28);
}

.dataon-prototype-file-sidebar,
.dataon-prototype-file-meta {
  display: grid;
  gap: 12px;
  padding: 14px;
}

.dataon-prototype-file-controls {
  display: grid;
  gap: 8px;
}

.dataon-prototype-file-controls input {
  width: 100%;
  min-height: 38px;
  padding: 0 10px;
  color: #0B1733;
  font-size: 13px;
  font-weight: 750;
  border: 1px solid #CAD7E8;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-prototype-segment {
  display: flex;
  gap: 4px;
  min-width: 0;
  padding: 3px;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-prototype-segment.is-inline {
  width: fit-content;
  max-width: 100%;
  overflow-x: auto;
}

.dataon-prototype-segment button {
  min-height: 30px;
  padding: 0 9px;
  color: #4B5B73;
  font-size: 12px;
  font-weight: 900;
  border-radius: 6px;
  background: transparent;
  white-space: nowrap;
}

.dataon-prototype-segment button.is-active {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-prototype-folder-list,
.dataon-prototype-file-list {
  display: grid;
  gap: 8px;
}

.dataon-prototype-folder-list article,
.dataon-prototype-archive,
.dataon-prototype-file-list button {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  min-width: 0;
  padding: 9px;
  text-align: left;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-prototype-folder-list i,
.dataon-prototype-archive i,
.dataon-prototype-file-list i {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  color: #0057B8;
  border-radius: 6px;
  background: #EAF3FF;
}

.dataon-prototype-folder-list div,
.dataon-prototype-archive div,
.dataon-prototype-file-list span {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.dataon-prototype-folder-list strong,
.dataon-prototype-archive strong,
.dataon-prototype-file-list strong {
  overflow: hidden;
  color: #0B1733;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-folder-list span,
.dataon-prototype-archive span,
.dataon-prototype-file-list small,
.dataon-prototype-file-list em,
.dataon-prototype-folder-list em {
  overflow: hidden;
  color: #6A7890;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-file-list button:hover,
.dataon-prototype-file-list button.is-active {
  border-color: #0057B8;
  background: #F0F7FF;
}

.dataon-prototype-file-list.is-thumbnail {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dataon-prototype-file-list.is-thumbnail button {
  grid-template-columns: 1fr;
  justify-items: start;
}

.dataon-prototype-viewer {
  overflow: hidden;
  background: #0B1733;
}

.dataon-prototype-viewer-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  padding: 12px;
  color: #FFFFFF;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  background: #17233A;
}

.dataon-prototype-viewer-toolbar > div:first-child {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.dataon-prototype-viewer-toolbar strong,
.dataon-prototype-viewer-toolbar span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-viewer-toolbar strong {
  font-size: 13px;
  font-weight: 900;
}

.dataon-prototype-viewer-toolbar span {
  color: rgba(255, 255, 255, 0.68);
  font-size: 11px;
  font-weight: 750;
}

.dataon-prototype-viewer-tools {
  display: flex;
  flex: 0 0 auto;
  gap: 5px;
}

.dataon-prototype-viewer-tools button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
}

.dataon-prototype-viewer-tools button:hover,
.dataon-prototype-viewer-tools button.is-active {
  background: #0057B8;
}

.dataon-prototype-canvas {
  position: relative;
  display: flex;
  min-height: 500px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 28px;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%), linear-gradient(-45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%), #081222;
  background-size: 24px 24px;
}

.dataon-prototype-preview-image {
  position: relative;
  width: min(100%, 520px);
  aspect-ratio: 1;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 8px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.32);
  transform-origin: center;
  transition: transform 160ms ease;
}

.dataon-prototype-canvas.is-kompsat .dataon-prototype-preview-image,
.dataon-prototype-compare-panel .is-kompsat {
  background: radial-gradient(circle at 28% 32%, rgba(77, 156, 74, 0.72), transparent 24%), radial-gradient(circle at 72% 62%, rgba(19, 92, 45, 0.82), transparent 28%), radial-gradient(circle at 48% 76%, rgba(149, 117, 59, 0.74), transparent 22%), linear-gradient(135deg, #0E3A2A, #2F5D3A 42%, #7B6B3F 70%, #133E32);
}

.dataon-prototype-canvas.is-sentinel .dataon-prototype-preview-image {
  background: radial-gradient(circle at 60% 28%, rgba(64, 128, 186, 0.62), transparent 24%), radial-gradient(circle at 35% 60%, rgba(50, 142, 82, 0.74), transparent 28%), linear-gradient(135deg, #183A5A, #2D7A4F 52%, #9A874E);
}

.dataon-prototype-canvas.is-label .dataon-prototype-preview-image,
.dataon-prototype-compare-panel .is-label {
  background: linear-gradient(120deg, transparent 0 34%, rgba(245, 87, 87, 0.88) 34% 45%, transparent 45% 62%, rgba(245, 87, 87, 0.76) 62% 72%, transparent 72%), radial-gradient(circle at 32% 64%, rgba(245, 87, 87, 0.94), transparent 18%), #10251D;
}

.dataon-prototype-canvas.is-archive .dataon-prototype-preview-image {
  background: #17233A;
}

.dataon-prototype-preview-image::after {
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(0deg, rgba(255, 255, 255, 0.05) 0 1px, transparent 1px 42px), repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0 1px, transparent 1px 42px);
  content: "";
}

.dataon-prototype-map-label,
.dataon-prototype-map-coordinate {
  position: absolute;
  left: 14px;
  z-index: 2;
  max-width: calc(100% - 28px);
  overflow: hidden;
  color: #FFFFFF;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}

.dataon-prototype-map-label {
  top: 14px;
  font-size: 14px;
}

.dataon-prototype-map-coordinate {
  bottom: 14px;
  font-size: 12px;
}

.dataon-prototype-compare-panel {
  position: absolute;
  right: 20px;
  bottom: 20px;
  display: grid;
  grid-template-columns: repeat(2, 120px);
  gap: 8px;
  z-index: 3;
}

.dataon-prototype-compare-panel div {
  display: flex;
  aspect-ratio: 1;
  align-items: flex-end;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 8px;
}

.dataon-prototype-compare-panel span {
  color: #FFFFFF;
  font-size: 11px;
  font-weight: 900;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}

.dataon-prototype-file-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: #17233A;
}

.dataon-prototype-file-meta dl {
  display: grid;
  gap: 0;
  margin: 0;
}

.dataon-prototype-file-meta dl div {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 8px;
  min-width: 0;
  padding: 9px 0;
  border-bottom: 1px solid #E1EAF5;
}

.dataon-prototype-file-meta dt {
  color: #5D6B82;
  font-size: 12px;
  font-weight: 900;
}

.dataon-prototype-file-meta dd {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.5;
  text-overflow: ellipsis;
}

.dataon-prototype-policy {
  display: grid;
  gap: 8px;
  padding-top: 4px;
}

.dataon-prototype-policy h4 {
  margin: 0;
  color: #0B1733;
  font-size: 13px;
  font-weight: 900;
}

.dataon-prototype-policy p,
.dataon-prototype-policy small {
  margin: 0;
  color: #4B5B73;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.5;
}

.dataon-prototype-policy div {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.dataon-prototype-policy span {
  padding: 2px 6px;
  color: #0057B8;
  font-size: 10px;
  font-weight: 900;
  border-radius: 5px;
  background: #EAF3FF;
}

.dataon-prototype-person-table {
  display: grid;
  overflow: hidden;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
}

.dataon-prototype-person-table > div {
  display: grid;
  grid-template-columns: 1.1fr 1.6fr 1.2fr 0.7fr;
  min-width: 0;
  border-bottom: 1px solid #E1EAF5;
}

.dataon-prototype-person-table > div:last-child {
  border-bottom: 0;
}

.dataon-prototype-person-table span {
  min-width: 0;
  overflow: hidden;
  padding: 11px 12px;
  color: #26364D;
  font-size: 12px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-person-table .is-head span {
  color: #0B1733;
  font-weight: 900;
  background: #F0F7FF;
}

.dataon-prototype-json,
.dataon-prototype-citation-text {
  max-height: 520px;
  padding: 14px;
  color: #FFFFFF;
  font: 700 12px/1.65 ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  border-radius: 8px;
  background: #17233A;
}

.dataon-prototype-relation-layout,
.dataon-prototype-citation-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 14px;
  align-items: start;
}

.dataon-prototype-graph {
  display: grid;
  gap: 12px;
  min-width: 0;
}

.dataon-prototype-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.dataon-prototype-legend span {
  padding: 4px 7px;
  color: #4B5B73;
  font-size: 11px;
  font-weight: 850;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-prototype-node-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.dataon-prototype-node-grid button {
  display: grid;
  min-width: 0;
  gap: 6px;
  justify-items: start;
  min-height: 112px;
  padding: 12px;
  text-align: left;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-prototype-node-grid button:hover,
.dataon-prototype-node-grid button.is-active {
  border-color: #0057B8;
  background: #F0F7FF;
}

.dataon-prototype-node-grid i {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border-radius: 6px;
  background: #0057B8;
}

.dataon-prototype-node-grid strong,
.dataon-prototype-node-grid span,
.dataon-prototype-node-detail strong,
.dataon-prototype-node-detail span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-node-grid strong,
.dataon-prototype-node-detail strong {
  color: #0B1733;
  font-size: 13px;
  font-weight: 900;
}

.dataon-prototype-node-grid span,
.dataon-prototype-node-detail span {
  color: #5D6B82;
  font-size: 11px;
  font-weight: 850;
}

.dataon-prototype-edge-list {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.dataon-prototype-edge-list article {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  min-width: 0;
  padding: 10px;
  border: 1px dashed #CAD7E8;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-prototype-edge-list span,
.dataon-prototype-edge-list strong {
  min-width: 0;
  overflow: hidden;
  font-size: 11px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-prototype-edge-list span {
  color: #5D6B82;
}

.dataon-prototype-edge-list strong {
  color: #0057B8;
}

.dataon-prototype-edge-list i {
  color: #8A96A8;
  font-size: 10px;
}

.dataon-prototype-node-detail {
  display: grid;
  gap: 10px;
  padding: 16px;
}

.dataon-kg-layout {
  display: grid;
  grid-template-columns: minmax(0, 7fr) minmax(300px, 3fr);
  gap: 14px;
  align-items: start;
}

.dataon-kg-layout.is-fullscreen {
  position: fixed;
  inset: 18px;
  z-index: 120;
  overflow: auto;
  padding: 16px;
  border: 1px solid #C9D8EA;
  border-radius: 8px;
  background: #F4F7FB;
  box-shadow: 0 18px 60px rgba(11, 23, 51, 0.24);
}

.dataon-kg-main,
.dataon-kg-detail {
  min-width: 0;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 12px 28px rgba(6, 42, 95, 0.08);
}

.dataon-kg-main {
  display: grid;
  gap: 12px;
  padding: 14px;
}

.dataon-kg-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}

.dataon-kg-filter-row,
.dataon-kg-tools,
.dataon-kg-path,
.dataon-kg-legend,
.dataon-kg-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.dataon-kg-filter-row {
  flex: 1 1 auto;
}

.dataon-kg-filter-row button {
  min-height: 34px;
  padding: 0 11px;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid #D8E4F1;
  border-radius: 6px;
  background: #F8FBFF;
  white-space: nowrap;
}

.dataon-kg-filter-row button:hover,
.dataon-kg-filter-row button.is-active {
  color: #FFFFFF;
  border-color: #0057B8;
  background: #0057B8;
}

.dataon-kg-tools {
  flex: 0 0 auto;
  justify-content: flex-end;
}

.dataon-kg-tools button {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #26364D;
  border: 1px solid #D8E4F1;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-kg-tools button:hover,
.dataon-kg-tools button.is-active {
  color: #FFFFFF;
  border-color: #0057B8;
  background: #0057B8;
}

.dataon-kg-zoom-label {
  display: inline-flex;
  min-width: 48px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #0B1733;
  font-size: 12px;
  font-weight: 900;
  border: 1px solid #D8E4F1;
  border-radius: 6px;
  background: #F8FBFF;
}

.dataon-kg-path {
  padding: 10px;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-kg-path button {
  min-height: 28px;
  padding: 0 8px;
  color: #356EA8;
  font-size: 12px;
  font-weight: 900;
  border-radius: 6px;
  background: transparent;
}

.dataon-kg-path button:hover,
.dataon-kg-path button.is-current {
  color: #FFFFFF;
  background: #356EA8;
}

.dataon-kg-path i {
  color: #8A96A8;
  font-size: 10px;
}

.dataon-kg-canvas {
  min-height: 620px;
  overflow: auto;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: linear-gradient(#EEF4FA 1px, transparent 1px), linear-gradient(90deg, #EEF4FA 1px, transparent 1px), #FBFDFF;
  background-size: 32px 32px;
}

.dataon-kg-svg {
  display: block;
  width: 100%;
  min-width: 820px;
  height: 620px;
  transform-origin: center;
  transition: transform 160ms ease;
}

.dataon-kg-edge,
.dataon-kg-node {
  cursor: pointer;
}

.dataon-kg-edge-hit {
  fill: none;
  stroke: transparent;
  stroke-linecap: round;
  stroke-width: 22;
}

.dataon-kg-edge-line {
  fill: none;
  stroke: #9AABC0;
  stroke-linecap: round;
  stroke-width: 2.5;
}

.dataon-kg-edge.is-active .dataon-kg-edge-line {
  stroke: #0057B8;
  stroke-width: 4;
}

.dataon-kg-edge-label-bg {
  fill: #FFFFFF;
  stroke: #D8E4F1;
  stroke-width: 1;
}

.dataon-kg-edge.is-active .dataon-kg-edge-label-bg {
  fill: #0057B8;
  stroke: #0057B8;
}

.dataon-kg-edge-label {
  fill: #0057B8;
  font-size: 13px;
  font-weight: 900;
  dominant-baseline: middle;
  pointer-events: none;
}

.dataon-kg-edge.is-active .dataon-kg-edge-label {
  fill: #FFFFFF;
}

.dataon-kg-center-ring {
  display: none;
  fill: rgba(0, 87, 184, 0.07);
  stroke: #0057B8;
  stroke-dasharray: 8 7;
  stroke-width: 2;
}

.dataon-kg-node.is-center .dataon-kg-center-ring {
  display: block;
}

.dataon-kg-node-aura {
  fill: rgba(0, 87, 184, 0.08);
  stroke: rgba(0, 87, 184, 0.12);
  stroke-width: 1;
}

.dataon-kg-node-shape {
  stroke: #FFFFFF;
  stroke-width: 4;
  filter: drop-shadow(0 14px 20px rgba(11, 23, 51, 0.18));
}

.dataon-kg-node-mark {
  fill: #FFFFFF;
  opacity: 0.9;
}

.dataon-kg-node.is-active .dataon-kg-node-shape {
  stroke: #0B1733;
  stroke-width: 5;
}

.dataon-kg-node.is-dataset .dataon-kg-node-shape,
.dataon-kg-type-chip.is-dataset,
.dataon-kg-legend .is-dataset i {
  fill: #0057B8;
  background: #0057B8;
}

.dataon-kg-node.is-project .dataon-kg-node-shape,
.dataon-kg-type-chip.is-project,
.dataon-kg-legend .is-project i {
  fill: #0067D6;
  background: #0067D6;
}

.dataon-kg-node.is-paper .dataon-kg-node-shape,
.dataon-kg-type-chip.is-paper,
.dataon-kg-legend .is-paper i {
  fill: #2D7CC5;
  background: #2D7CC5;
}

.dataon-kg-node.is-researcher .dataon-kg-node-shape,
.dataon-kg-type-chip.is-researcher,
.dataon-kg-legend .is-researcher i {
  fill: #174B8A;
  background: #174B8A;
}

.dataon-kg-node.is-organization .dataon-kg-node-shape,
.dataon-kg-type-chip.is-organization,
.dataon-kg-legend .is-organization i {
  fill: #0B355F;
  background: #0B355F;
}

.dataon-kg-node.is-keyword .dataon-kg-node-shape,
.dataon-kg-type-chip.is-keyword,
.dataon-kg-legend .is-keyword i {
  fill: #3D8EDB;
  background: #3D8EDB;
}

.dataon-kg-node.is-equipment .dataon-kg-node-shape,
.dataon-kg-type-chip.is-equipment,
.dataon-kg-legend .is-equipment i {
  fill: #526D8E;
  background: #526D8E;
}

.dataon-kg-node-label {
  fill: #FFFFFF;
  font-weight: 900;
  pointer-events: none;
}

.dataon-kg-node-label {
  font-size: 19px;
  dominant-baseline: middle;
}

.dataon-kg-node.is-center .dataon-kg-node-label {
  font-size: 22px;
}

.dataon-kg-legend {
  padding: 2px 0 0;
}

.dataon-kg-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 0 8px;
  color: #4B5B73;
  font-size: 12px;
  font-weight: 900;
  border: 1px solid #E1EAF5;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-kg-legend i {
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 10px;
  border-radius: 5px;
}

.dataon-kg-detail {
  position: sticky;
  top: 92px;
  display: grid;
  gap: 14px;
  padding: 16px;
}

.dataon-kg-layout.is-fullscreen .dataon-kg-detail {
  top: 16px;
}

.dataon-kg-detail-head {
  display: grid;
  gap: 7px;
  min-width: 0;
}

.dataon-kg-type-chip {
  display: inline-flex;
  justify-self: start;
  min-height: 26px;
  align-items: center;
  padding: 0 8px;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 900;
  border-radius: 6px;
}

.dataon-kg-detail-head strong {
  color: #0B1733;
  font-size: 21px;
  font-weight: 900;
  line-height: 1.35;
}

.dataon-kg-detail-head small {
  color: #5D6B82;
  font-size: 12px;
  font-weight: 850;
  overflow-wrap: anywhere;
}

.dataon-kg-detail-grid,
.dataon-kg-meta-box dl,
.dataon-kg-relation-box dl {
  display: grid;
  gap: 0;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
}

.dataon-kg-detail-grid div,
.dataon-kg-meta-box dl div,
.dataon-kg-relation-box dl div {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr);
  min-width: 0;
  border-bottom: 1px solid #E1EAF5;
}

.dataon-kg-detail-grid div:last-child,
.dataon-kg-meta-box dl div:last-child,
.dataon-kg-relation-box dl div:last-child {
  border-bottom: 0;
}

.dataon-kg-detail-grid dt,
.dataon-kg-detail-grid dd,
.dataon-kg-meta-box dt,
.dataon-kg-meta-box dd,
.dataon-kg-relation-box dt,
.dataon-kg-relation-box dd {
  min-width: 0;
  margin: 0;
  padding: 10px;
  font-size: 13px;
  line-height: 1.5;
}

.dataon-kg-detail-grid dt,
.dataon-kg-meta-box dt,
.dataon-kg-relation-box dt {
  color: #5D6B82;
  font-weight: 900;
  background: #F8FBFF;
}

.dataon-kg-detail-grid dd,
.dataon-kg-meta-box dd,
.dataon-kg-relation-box dd {
  color: #0B1733;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.dataon-kg-meta-box,
.dataon-kg-relation-box {
  display: grid;
  gap: 9px;
  min-width: 0;
}

.dataon-kg-meta-box h3,
.dataon-kg-relation-box h3 {
  margin: 0;
  color: #0B1733;
  font-size: 15px;
  font-weight: 900;
}

.dataon-kg-relation-box button {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  width: 100%;
  min-height: 38px;
  padding: 8px;
  text-align: left;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-kg-relation-box button:hover {
  border-color: #0057B8;
  background: #F0F7FF;
}

.dataon-kg-relation-box button span {
  color: #0057B8;
  font-size: 12px;
  font-weight: 900;
}

.dataon-kg-relation-box button strong {
  min-width: 0;
  overflow: hidden;
  color: #26364D;
  font-size: 12px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-kg-actions {
  align-items: stretch;
}

.dataon-kg-actions button {
  display: inline-flex;
  flex: 1 1 150px;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  color: #0057B8;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid #B9D7F7;
  border-radius: 6px;
  background: #F4FAFF;
}

.dataon-kg-actions button:hover:not(:disabled) {
  color: #FFFFFF;
  border-color: #004899;
  background: #004899;
}

.dataon-kg-actions button:disabled {
  color: #8A96A8;
  cursor: not-allowed;
  border-color: #D8E4F1;
  background: #F3F6FA;
}

.dataon-prototype-check-list {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-prototype-check-list li {
  color: #26364D;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.55;
}

.dataon-prototype-empty {
  margin: 0;
  padding: 18px;
  color: #5D6B82;
  font-size: 14px;
  font-weight: 850;
  text-align: center;
  border: 1px dashed #CAD7E8;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-prototype-recommendation-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.dataon-prototype-recommendation-grid article {
  display: grid;
  gap: 8px;
  min-width: 0;
  padding: 16px;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-prototype-recommendation-grid span {
  color: #0057B8;
  font-size: 12px;
  font-weight: 900;
}

.dataon-prototype-recommendation-grid strong {
  color: #0B1733;
  font-size: 15px;
  font-weight: 900;
  line-height: 1.45;
}

.dataon-prototype-recommendation-grid p {
  margin: 0;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.65;
}

@media (max-width: 1180px) {
  .dataon-prototype-hero-grid,
  .dataon-prototype-file-workspace,
  .dataon-prototype-relation-layout,
  .dataon-prototype-citation-layout {
    grid-template-columns: 1fr;
  }
  .dataon-prototype-sticky-inner {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .dataon-prototype-tabs {
    justify-content: flex-start;
  }
}
@media (max-width: 860px) {
  .dataon-prototype-title h1 {
    font-size: 30px;
  }
  .dataon-prototype-description-grid,
  .dataon-prototype-metric-grid,
  .dataon-prototype-usage-grid,
  .dataon-prototype-rule-grid,
  .dataon-prototype-pairing,
  .dataon-prototype-definition-grid,
  .dataon-prototype-recommendation-grid,
  .dataon-prototype-node-grid {
    grid-template-columns: 1fr;
  }
  .dataon-prototype-definition-grid div,
  .dataon-prototype-definition-grid div:nth-child(2n) {
    border-right: 0;
  }
  .dataon-prototype-table-row,
  .dataon-prototype-person-table > div {
    grid-template-columns: 1fr;
  }
  .dataon-prototype-viewer-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .dataon-prototype-viewer-tools {
    overflow-x: auto;
    padding-bottom: 2px;
  }
}
@media (max-width: 560px) {
  .dataon-prototype-action-grid,
  .dataon-prototype-file-list.is-thumbnail {
    grid-template-columns: 1fr;
  }
  .dataon-prototype-canvas {
    min-height: 320px;
    padding: 16px;
  }
  .dataon-prototype-compare-panel {
    right: 12px;
    bottom: 12px;
    grid-template-columns: repeat(2, 86px);
  }
  .dataon-prototype-section {
    padding: 16px;
  }
}
.dataon-prototype-detail {
  color: #0B1733;
  font-size: 16px;
}

.dataon-prototype-visual {
  display: flex;
  min-height: 230px;
  align-items: center;
  padding: 44px 0;
  color: #FFFFFF;
  border-bottom: 4px solid #0B1733;
  background-color: #021F4F;
  background-image: linear-gradient(90deg, rgba(1, 20, 56, 0.88), rgba(0, 87, 184, 0.62)), url("/assets/dataon/main_bg.png");
  background-position: center;
  background-size: cover;
}

.dataon-prototype-visual-inner {
  display: flex;
  min-height: 142px;
  flex-direction: column;
  justify-content: center;
}

.dataon-prototype-visual-copy {
  display: grid;
  gap: 10px;
  text-align: center;
}

.dataon-prototype-visual-copy h1 {
  margin: 0;
  color: #FFFFFF;
  font-size: 38px;
  font-weight: 900;
  line-height: 1.22;
}

.dataon-prototype-visual-copy p {
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.5;
}

.dataon-prototype-visual .dataon-prototype-breadcrumb {
  align-self: flex-end;
  margin-top: auto;
  font-size: 14px;
}

.dataon-prototype-body {
  padding: 36px 0 72px;
  background: #F4F7FB;
}

.dataon-prototype-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 22px;
  align-items: start;
}

.dataon-prototype-side-nav {
  position: sticky;
  top: 20px;
  z-index: 20;
  display: grid;
  grid-column: 1;
  gap: 12px;
  padding: 16px;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 12px 28px rgba(6, 42, 95, 0.08);
}

.dataon-prototype-side-nav > strong {
  color: #0B1733;
  font-size: 17px;
  font-weight: 900;
}

.dataon-prototype-tabs {
  display: grid;
  justify-content: stretch;
  gap: 8px;
  overflow: visible;
}

.dataon-prototype-tabs button {
  display: flex;
  width: 100%;
  min-height: 48px;
  align-items: center;
  justify-content: flex-start;
  padding: 0 14px;
  color: #26364D;
  font-size: 16px;
  font-weight: 900;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
}

.dataon-prototype-tabs button::after {
  content: none;
}

.dataon-prototype-tabs button:hover,
.dataon-prototype-tabs button.is-active {
  color: #FFFFFF;
  border-color: #0057B8;
  background: #0057B8;
}

.dataon-prototype-dataset-card,
.dataon-prototype-top-tabs,
.dataon-prototype-tab-panel {
  grid-column: 1;
}

.dataon-prototype-top-tabs {
  position: sticky;
  top: 0;
  z-index: 30;
  padding: 10px;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 28px rgba(6, 42, 95, 0.08);
  backdrop-filter: blur(10px);
}

.dataon-prototype-top-tabs .dataon-prototype-tabs {
  display: flex;
  justify-content: stretch;
  gap: 8px;
  overflow-x: auto;
}

.dataon-prototype-top-tabs .dataon-prototype-tabs button {
  flex: 1 0 130px;
  width: auto;
  min-height: 50px;
  justify-content: center;
  padding: 0 14px;
  text-align: center;
  white-space: nowrap;
}

.dataon-prototype-dataset-card {
  display: grid;
  gap: 18px;
  min-width: 0;
  padding: 24px;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 12px 28px rgba(6, 42, 95, 0.08);
}

.dataon-prototype-dataset-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 460px;
  gap: 24px;
  align-items: start;
}

.dataon-prototype-dataset-title {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.dataon-prototype-dataset-title h2 {
  margin: 0;
  color: #0B1733;
  font-size: 30px;
  font-weight: 900;
  line-height: 1.25;
}

.dataon-prototype-dataset-title p {
  margin: 0;
  color: #356EA8;
  font-size: 17px;
  font-weight: 850;
  line-height: 1.45;
}

.dataon-prototype-fact-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  overflow: hidden;
  margin: 0;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
}

.dataon-prototype-fact-grid div {
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  min-width: 0;
  border-right: 1px solid #E1EAF5;
  border-bottom: 1px solid #E1EAF5;
}

.dataon-prototype-fact-grid div:nth-child(2n) {
  border-right: 0;
}

.dataon-prototype-fact-grid dt,
.dataon-prototype-fact-grid dd {
  min-width: 0;
  margin: 0;
  padding: 13px 14px;
  font-size: 15px;
  line-height: 1.55;
}

.dataon-prototype-fact-grid dt {
  color: #5D6B82;
  font-weight: 900;
  background: #F8FBFF;
}

.dataon-prototype-fact-grid dd {
  color: #0B1733;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.dataon-prototype-section-head h2 {
  font-size: 27px;
}

.dataon-prototype-section-head span,
.dataon-prototype-section-head button {
  font-size: 15px;
}

.dataon-prototype-section {
  gap: 18px;
  padding: 24px;
}

.dataon-prototype-section h3,
.dataon-prototype-file-meta h3,
.dataon-prototype-node-detail h3 {
  font-size: 21px;
}

.dataon-prototype-section h4 {
  font-size: 16px;
}

.dataon-prototype-lead {
  font-size: 17px;
  line-height: 1.78;
}

.dataon-prototype-description-block {
  display: grid;
  gap: 10px;
  min-width: 0;
}

.dataon-prototype-description-block pre,
.dataon-prototype-description-grid pre {
  max-height: none;
  padding: 16px;
  color: #26364D;
  font: 750 15px/1.8 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  border: 1px solid #E1EAF5;
  border-radius: 8px;
  background: #F8FBFF;
  white-space: pre-wrap;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dataon-prototype-action-grid button,
.dataon-prototype-inline-actions button,
.dataon-prototype-file-actions button,
.dataon-prototype-text-toggle {
  min-height: 42px;
  font-size: 14px;
}

.dataon-prototype-table-row span,
.dataon-prototype-definition-grid dt,
.dataon-prototype-definition-grid dd,
.dataon-prototype-person-table span,
.dataon-prototype-file-meta dt,
.dataon-prototype-file-meta dd {
  font-size: 15px;
}

.dataon-prototype-table-row span,
.dataon-prototype-definition-grid dd,
.dataon-prototype-person-table span,
.dataon-prototype-file-meta dd {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dataon-prototype-rule-grid p,
.dataon-prototype-recommendation-grid p,
.dataon-prototype-policy p,
.dataon-prototype-policy small {
  font-size: 15px;
  line-height: 1.7;
}

.dataon-prototype-file-workspace {
  grid-template-columns: 300px minmax(0, 1fr) 320px;
}

.dataon-prototype-file-controls input,
.dataon-prototype-segment button,
.dataon-prototype-folder-list span,
.dataon-prototype-archive span,
.dataon-prototype-file-list small,
.dataon-prototype-file-list em,
.dataon-prototype-folder-list em {
  font-size: 14px;
}

@media (max-width: 1180px) {
  .dataon-prototype-dataset-head {
    grid-template-columns: 1fr;
  }
  .dataon-prototype-side-nav {
    position: static;
  }
  .dataon-prototype-top-tabs .dataon-prototype-tabs button {
    flex-basis: 150px;
  }
}
@media (max-width: 860px) {
  .dataon-prototype-visual-copy h1 {
    font-size: 30px;
  }
  .dataon-prototype-visual-copy p {
    font-size: 16px;
  }
  .dataon-prototype-fact-grid {
    grid-template-columns: 1fr;
  }
  .dataon-prototype-fact-grid div,
  .dataon-prototype-fact-grid div:nth-child(2n) {
    border-right: 0;
  }
}
@media (max-width: 560px) {
  .dataon-prototype-dataset-card {
    padding: 18px;
  }
  .dataon-prototype-dataset-title h2 {
    font-size: 24px;
  }
}
.dataon-search-results-page {
  flex: 1 0 auto;
  background: #F4F7FB;
}

.dataon-results-visual {
  color: #FFFFFF;
  border-bottom: 1px solid #DCE6F2;
  background: linear-gradient(90deg, rgba(2, 31, 79, 0.94), rgba(0, 87, 184, 0.72)), url("/assets/dataon/main_bg.png");
  background-position: center;
  background-size: cover;
}

.dataon-results-visual-inner {
  display: grid;
  gap: 12px;
  padding-top: 18px;
  padding-bottom: 22px;
}

.dataon-results-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 13px;
  font-weight: 850;
}

.dataon-results-breadcrumb button {
  color: inherit;
  background: transparent;
}

.dataon-results-breadcrumb button:hover,
.dataon-results-breadcrumb span {
  color: #FFFFFF;
}

.dataon-results-breadcrumb i {
  font-size: 10px;
}

.dataon-results-title-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  align-items: end;
}

.dataon-results-title-row h1 {
  margin: 0;
  color: #FFFFFF;
  font-size: 32px;
  font-weight: 900;
  line-height: 1.2;
}

.dataon-results-title-row p {
  margin: 6px 0 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
}

.dataon-search-menu-tabs {
  display: flex;
  width: 100%;
  min-width: 0;
  gap: 7px;
  padding: 4px 0 2px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.dataon-search-menu-tabs button {
  display: inline-flex;
  flex: 0 0 auto;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  padding: 0 13px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  font-weight: 850;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  transition: color 160ms ease, border-color 160ms ease, background 160ms ease;
  white-space: nowrap;
}

.dataon-search-menu-tabs button:hover,
.dataon-search-menu-tabs button:focus-visible,
.dataon-search-menu-tabs button.is-active {
  color: #0B1733;
  border-color: #FFFFFF;
  background: #FFFFFF;
}

.dataon-search-menu-tabs.is-official {
  padding-top: 16px;
}

.dataon-official-search-page {
  flex: 1 0 auto;
  background: #FFFFFF;
}

.dataon-official-sub-top {
  min-height: 230px;
  color: #FFFFFF;
  background: linear-gradient(90deg, rgba(2, 31, 79, 0.88), rgba(0, 87, 184, 0.58)), url("/assets/dataon/main_bg.png") center/cover no-repeat;
}

.dataon-official-sub-inner {
  display: grid;
  align-content: center;
  min-height: 230px;
  gap: 12px;
  padding-top: 34px;
  padding-bottom: 28px;
}

.dataon-official-sub-inner h2 {
  margin: 0;
  color: #FFFFFF;
  font-size: clamp(34px, 4vw, 48px);
  font-weight: 900;
  text-align: center;
}

.dataon-official-location {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin: 0;
  padding: 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  font-weight: 750;
  list-style: none;
}

.dataon-official-location li + li::before {
  padding-right: 8px;
  color: rgba(255, 255, 255, 0.58);
  content: ">";
}

.dataon-official-main {
  padding: 48px 0 72px;
}

.dataon-official-index-form {
  display: grid;
  gap: 12px;
  margin-bottom: 24px;
  padding: 22px;
  border: 1px solid #DCE5F2;
  background: #F7FAFE;
}

.dataon-official-index-search {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 96px;
  border: 2px solid #0057B8;
  background: #FFFFFF;
}

.dataon-official-index-search input,
.dataon-official-provider-form input,
.dataon-official-provider-form select,
.dataon-official-detail-form input,
.dataon-official-detail-form select {
  min-width: 0;
  height: 42px;
  padding: 0 12px;
  color: #333333;
  font-size: 15px;
  border: 1px solid #D7DDE8;
  border-radius: 0;
  background: #FFFFFF;
}

.dataon-official-index-search input {
  height: 52px;
  border: 0;
}

.dataon-official-index-search button,
.dataon-official-search-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 42px;
  color: #FFFFFF;
  font-weight: 800;
  background: #0057B8;
}

.dataon-official-related {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  color: #5C687A;
  font-size: 14px;
  font-weight: 750;
}

.dataon-official-related button {
  color: #0067D6;
  background: transparent;
}

.dataon-official-totsch {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 30px;
  align-items: start;
}

.dataon-official-left,
.dataon-official-result-panel,
.dataon-official-right {
  min-width: 0;
}

.dataon-official-left {
  display: grid;
  gap: 14px;
}

.dataon-official-left .sch_selectInfo,
.dataon-official-left .totSch_row,
.dataon-official-left .totSch_rowWrap_btn {
  border: 1px solid #DDE5EF;
  background: #FFFFFF;
}

.dataon-official-left .sch_selectInfo {
  padding: 18px;
}

.dataon-official-left h3,
.dataon-official-left h4 {
  margin: 0;
  color: #222222;
  font-weight: 850;
}

.dataon-official-left .totSch_rowWrap_btn {
  padding: 16px 18px;
  font-size: 17px;
}

.dataon-official-left .totSch_row {
  padding: 18px;
}

.dataon-official-left .totSch_btnBox {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 40px;
}

.dataon-official-left .totSch_btnBox input {
  min-width: 0;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #D7DDE8;
}

.dataon-official-left .schBtn,
.dataon-official-left .schAddBtn {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-official-left .stat_list,
.dataon-official-left .list {
  display: grid;
  gap: 8px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.dataon-official-left .stat_list {
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) 34px;
  align-items: center;
}

.dataon-official-left .list_time {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  border: 1px solid #D7DDE8;
}

.dataon-official-left .list_time input {
  width: 100%;
  height: 36px;
  border: 0;
}

.dataon-official-left .list_time i {
  padding-right: 8px;
  color: #7A8798;
}

.dataon-official-left label {
  display: flex;
  gap: 7px;
  align-items: center;
  color: #333333;
  font-size: 14px;
  line-height: 1.35;
}

.dataon-official-left label span {
  margin-left: auto;
  color: #0067D6;
  font-weight: 800;
}

.dataon-official-left .sch_more {
  display: inline-flex;
  margin-top: 12px;
  color: #0067D6;
  font-size: 14px;
  font-weight: 800;
}

.dataon-official-totsch-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.dataon-official-rst-count {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: 0;
}

.dataon-official-rst-count dt {
  color: #222222;
  font-size: 20px;
  font-weight: 900;
}

.dataon-official-rst-count dd {
  margin: 0;
  color: #0057B8;
  font-size: 20px;
  font-weight: 900;
}

.dataon-official-sort {
  display: flex;
  gap: 5px;
}

.dataon-official-sort button {
  min-height: 34px;
  padding: 0 12px;
  color: #5C687A;
  border: 1px solid #D5DDE8;
  background: #FFFFFF;
}

.dataon-official-sort button.is-active {
  color: #FFFFFF;
  border-color: #0057B8;
  background: #0057B8;
}

.dataon-official-index-guide {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
  padding: 14px 16px;
  color: #37668E;
  border: 1px solid #C8E0FF;
  background: #EFF6FF;
}

.dataon-official-search-result-list,
.dataon-official-repository-data {
  display: grid;
  gap: 18px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-search-result-card,
.dataon-official-repository-list {
  display: grid;
  gap: 18px;
  padding: 24px;
  border: 1px solid #E1E6EE;
  background: #FFFFFF;
}

.dataon-official-search-result-card {
  transition: background 180ms ease;
}

.dataon-official-search-result-card:hover {
  background: #F6FBFF;
}

.dataon-official-result-card-head {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.dataon-official-result-type,
.dataon-official-repository-title .country {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  padding: 0 10px;
  color: #FFFFFF;
  font-size: 13px;
  font-style: normal;
  font-weight: 800;
  background: #0067D6;
}

.dataon-official-result-card-head button,
.dataon-official-repository-title button {
  color: #222222;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.35;
  text-align: left;
  background: transparent;
}

.dataon-official-data-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 22px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-data-list li {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr);
  gap: 8px;
  color: #4F5C6D;
  font-size: 14px;
}

.dataon-official-data-list strong,
.dataon-official-result-text strong {
  color: #222222;
  font-weight: 850;
}

.dataon-official-result-text {
  display: grid;
  gap: 8px;
}

.dataon-official-result-text p {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: #495057;
  font-size: 15px;
  line-height: 1.7;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.dataon-official-result-tags,
.dataon-official-result-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.dataon-official-result-tags span {
  padding: 5px 9px;
  color: #0067D6;
  font-size: 13px;
  font-weight: 750;
  background: #EEF6FF;
}

.dataon-official-result-stats span {
  color: #667284;
  font-size: 13px;
}

.dataon-official-provider .dataon-official-result-panel {
  max-width: 100%;
}

.dataon-official-provider-form {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.dataon-official-provider-form select {
  width: 154px;
}

.dataon-official-provider-form input {
  width: min(260px, 100%);
}

.dataon-official-repository-list {
  grid-template-columns: minmax(0, 1fr) 270px;
}

.dataon-official-repository-left,
.dataon-official-repository-right,
.dataon-official-repository-info,
.dataon-official-repository-etc {
  min-width: 0;
}

.dataon-official-repository-title {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 16px;
}

.dataon-official-repository-img {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 96px;
  margin-bottom: 14px;
  border: 1px solid #E2E8F0;
  background: #FFFFFF;
}

.dataon-official-repository-img img {
  max-width: 180px;
  max-height: 74px;
  object-fit: contain;
}

.dataon-official-rst-count-box {
  border: 1px solid #DDE5EF;
}

.dataon-official-content-count {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px;
  padding: 14px;
  border-bottom: 1px solid #E4EAF2;
}

.dataon-official-content-count span:first-child {
  color: #5C687A;
}

.dataon-official-content-count strong {
  color: #0057B8;
  font-size: 22px;
  font-weight: 900;
}

.dataon-official-content-count .rst_count_more {
  grid-column: 1/-1;
  color: #0067D6;
  font-size: 13px;
  font-weight: 800;
}

.dataon-official-rst-count-box ul {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-rst-count-box li {
  display: grid;
  gap: 3px;
  padding: 10px;
  color: #667284;
  font-size: 12px;
  border-right: 1px solid #E4EAF2;
  border-bottom: 1px solid #E4EAF2;
}

.dataon-official-rst-count-box li strong {
  color: #222222;
  font-size: 15px;
  font-weight: 900;
}

.dataon-official-semantic {
  max-width: 1120px;
  margin: 0 auto;
}

.dataon-official-semantic .result_tit,
.dataon-official-detail-wrap .centerTit {
  margin: 0 0 20px;
  color: #333333;
  font-size: 25px;
  font-weight: 900;
}

.dataon-official-semantic-info {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #C8E0FF;
  border-radius: 8px;
  background: #EFF6FF;
}

.dataon-official-semantic-info .info_title,
.dataon-official-semantic-info .info_item {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.dataon-official-semantic-info .info_title {
  color: #2E81EA;
  font-size: 16px;
  font-weight: 900;
}

.dataon-official-semantic-info .info_item {
  margin-left: 14px;
  color: #555555;
  font-weight: 700;
}

.dataon-official-semantic-info .info_dot,
.dataon-official-semantic-card .dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.dataon-official-semantic-info .color_green,
.dataon-official-semantic-card .class_exact .dot.fill {
  background: #20C997;
}

.dataon-official-semantic-info .color_blue,
.dataon-official-semantic-card .class_similar .dot.fill {
  background: #5B8DEF;
}

.dataon-official-semantic-info .color_yellow,
.dataon-official-semantic-card .class_partial .dot.fill {
  background: #FBBC05;
}

.dataon-official-semantic-info .color_gray,
.dataon-official-semantic-card .class_low .dot.fill {
  background: #ADB5BD;
}

.dataon-official-semantic-info .txt {
  margin: 0;
  color: #2B3441;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.65;
}

.dataon-official-semantic-info .sub_tit {
  font-size: 22px;
  font-weight: 900;
}

.dataon-official-semantic-info .mt_10 {
  margin-top: 10px;
}

.dataon-official-semantic-use {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 18px !important;
}

.dataon-official-semantic-bullet {
  margin: 0 0 10px 15px;
  color: #2B3441;
  font-size: 16px;
}

.dataon-official-semantic-card {
  margin-bottom: 20px;
  padding: 20px 30px;
  border: 1px solid #E9ECEF;
  border-radius: 8px;
  background: #FFFFFF;
}

.dataon-official-semantic-card .card_header {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;
}

.dataon-official-semantic-card .similarity_score_box {
  display: flex;
  gap: 5px;
  align-items: end;
}

.dataon-official-semantic-card .similarity_score {
  color: #333333;
  font-size: 36px;
  font-weight: 600;
}

.dataon-official-semantic-card .score_unit {
  color: #666666;
  font-size: 20px;
}

.dataon-official-semantic-card .similarity_dot_box {
  display: grid;
  gap: 5px;
}

.dataon-official-semantic-card .similarity_dots {
  display: flex;
  gap: 5px;
}

.dataon-official-semantic-card .dot {
  border: 1px solid #CBDCED;
  background: #F1F3F5;
}

.dataon-official-semantic-card .similarity_label {
  width: max-content;
  padding: 7px 10px;
  font-size: 15px;
  font-weight: 900;
  border-radius: 5px;
}

.dataon-official-semantic-card .similarity_label.class_exact {
  color: #20C997;
  background: rgba(32, 201, 151, 0.15);
}

.dataon-official-semantic-card .similarity_label.class_similar {
  color: #5B8DEF;
  background: rgba(91, 141, 239, 0.15);
}

.dataon-official-semantic-card .similarity_label.class_partial {
  color: #D99500;
  background: rgba(251, 188, 5, 0.15);
}

.dataon-official-semantic-card .similarity_label.class_low {
  color: #7C848D;
  background: rgba(173, 181, 189, 0.15);
}

.dataon-official-semantic-card .card_title {
  margin: 0 0 15px;
}

.dataon-official-semantic-card .card_title button {
  color: #333333;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.5;
  text-align: left;
  background: transparent;
}

.dataon-official-semantic-card .card_meta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
  color: #666666;
  font-size: 15px;
}

.dataon-official-semantic-card .card_summary {
  display: -webkit-box;
  height: 77px;
  margin: 0;
  overflow: hidden;
  color: #495057;
  font-size: 16px;
  line-height: 1.6;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.dataon-official-detail-wrap {
  max-width: 1120px;
  margin: 0 auto;
}

.dataon-official-detail-wrap .gray_box {
  margin-bottom: 20px;
  padding: 28px;
  background: #F5F7FA;
}

.dataon-official-detail-wrap .totSch_detail h3 {
  margin: 0 0 16px;
  color: #222222;
  font-size: 20px;
  font-weight: 900;
}

.dataon-official-detail-wrap dl,
.dataon-official-detail-wrap dd {
  margin: 0;
}

.dataon-official-detail-wrap .totSch_ctgrAdd {
  display: grid;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-detail-wrap .totSch_ctgrItem {
  display: grid;
  grid-template-columns: 170px minmax(0, 1fr) 100px;
  gap: 8px;
}

.dataon-official-detail-wrap .totSch_sel {
  color: #333333;
  font-weight: 800;
  background: #EEF2F7;
}

.dataon-official-detail-wrap .warning_txt {
  margin: 14px 0 0;
  color: #D14A2E;
  font-size: 14px;
}

.dataon-official-detail-wrap .float_wrap {
  display: grid;
  grid-template-columns: minmax(0, 320px) minmax(0, 1fr);
  gap: 24px;
  align-items: center;
}

.dataon-official-detail-wrap .dateWrap {
  display: flex;
  gap: 8px;
  align-items: center;
}

.dataon-official-detail-wrap .dateWrap input {
  width: 140px;
}

.dataon-official-detail-wrap .ex_box {
  color: #5C687A;
  font-size: 14px;
}

.dataon-official-detail-wrap .ex_box span {
  color: #0057B8;
  font-weight: 900;
}

.dataon-official-detail-wrap .ex_box i {
  display: block;
  margin-top: 4px;
  color: #D14A2E;
  font-style: normal;
}

.dataon-official-detail-help {
  margin: 8px 0 22px;
  text-align: right;
}

.dataon-official-detail-help button {
  color: #0057B8;
  font-weight: 800;
  background: transparent;
}

.dataon-official-detail-wrap .btn_area {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.dataon-official-detail-wrap .btn {
  min-width: 98px;
  min-height: 42px;
  padding: 0 18px;
  font-weight: 900;
}

.dataon-official-detail-wrap .btn-primary-detailSearch {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-official-detail-wrap .btn-outline-detailSearch-secondary {
  color: #333333;
  border: 1px solid #AEB8C6;
  background: #FFFFFF;
}

@media (max-width: 960px) {
  .dataon-official-main {
    padding: 36px 0 56px;
  }
  .dataon-official-totsch,
  .dataon-official-repository-list,
  .dataon-official-detail-wrap .float_wrap {
    grid-template-columns: 1fr;
  }
  .dataon-official-provider-form,
  .dataon-official-index-search,
  .dataon-official-detail-wrap .totSch_ctgrItem {
    display: grid;
    grid-template-columns: 1fr;
  }
  .dataon-official-provider-form select,
  .dataon-official-provider-form input,
  .dataon-official-provider-form button,
  .dataon-official-detail-wrap .totSch_ctgrItem input,
  .dataon-official-detail-wrap .totSch_ctgrItem select,
  .dataon-official-detail-wrap .dateWrap input {
    width: 100%;
  }
  .dataon-official-index-search button {
    min-height: 48px;
  }
}
@media (max-width: 640px) {
  .dataon-official-sub-top,
  .dataon-official-sub-inner {
    min-height: 190px;
  }
  .dataon-official-sub-inner h2 {
    font-size: 30px;
  }
  .dataon-official-index-form,
  .dataon-official-search-result-card,
  .dataon-official-repository-list,
  .dataon-official-detail-wrap .gray_box {
    padding: 18px;
  }
  .dataon-official-data-list,
  .dataon-official-rst-count-box ul {
    grid-template-columns: 1fr;
  }
  .dataon-official-data-list li {
    grid-template-columns: 78px minmax(0, 1fr);
  }
  .dataon-official-semantic-info .info_title,
  .dataon-official-semantic-info .info_item,
  .dataon-official-semantic-card .card_header,
  .dataon-official-detail-wrap .dateWrap {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataon-official-semantic-card {
    padding: 18px;
  }
  .dataon-official-semantic-card .card_summary {
    height: auto;
  }
}
.dataon-official-clone {
  color: #020202;
  font-family: "Noto Sans KR", "NanumSquare", Arial, sans-serif;
  background: #FFFFFF;
}

.dataon-official-clone .dataon-container {
  width: 100%;
  max-width: 80rem;
  margin: 0 auto;
}

.dataon-official-clone .dataon-official-sub-top {
  position: relative;
  min-height: 22.125rem;
  color: #FFFFFF;
  background: url("/assets/dataon/official/layout/bg_search_new.jpg") center/cover no-repeat;
}

.dataon-official-clone .dataon-official-sub-top::after {
  position: absolute;
  top: 59%;
  right: -4.1rem;
  z-index: 2;
  display: block;
  width: 11.4375rem;
  height: 3.375rem;
  color: #FFFFFF;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 3.375rem;
  text-align: center;
  content: "SEARCH";
  border-radius: 0 0 1rem 1rem;
  background: linear-gradient(to left, #0E468D, #106ADC);
  transform: rotate(90deg);
}

.dataon-official-clone .dataon-official-sub-inner {
  display: table;
  width: 100%;
  min-height: 22.125rem;
  padding: 0;
}

.dataon-official-clone .dataon-official-sub-inner h2 {
  display: table-cell;
  padding-top: 5.1875rem;
  color: #FFFFFF;
  font-family: "NanumSquare", "Noto Sans KR", sans-serif;
  font-size: 2.25rem;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
}

.dataon-official-clone .dataon-official-location {
  position: absolute;
  right: 0;
  bottom: 1.125rem;
  z-index: 1;
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-clone .dataon-official-location li {
  position: relative;
  float: left;
  margin-left: 0.25rem;
  padding-left: 1.1875rem;
  color: #FFFFFF;
  font-size: 0.9375rem;
  line-height: 1;
}

.dataon-official-clone .dataon-official-location li::before {
  position: absolute;
  top: 0;
  left: 0;
  content: ">";
}

.dataon-official-clone .dataon-official-location li:first-child {
  margin-left: 0;
  padding-left: 0;
}

.dataon-official-clone .dataon-official-location li:first-child::before {
  content: "";
}

.dataon-official-clone .dataon-search-menu-tabs.is-official {
  display: none;
}

.dataon-official-clone .dataon-official-index-form {
  display: none;
}

.dataon-official-clone .dataon-official-main {
  padding: 0;
}

.dataon-official-clone .dataon-official-main > .dataon-container {
  box-sizing: border-box;
  min-height: 75vh;
  padding: 3.125rem 0;
}

.dataon-official-clone .totSch::after,
.dataon-official-clone .repository_list::after,
.dataon-official-clone .totsch_info::after,
.dataon-official-clone .float_wrap::after {
  display: block;
  clear: both;
  content: "";
}

.dataon-official-clone .totSch .totSch_left {
  position: relative;
  float: left;
  width: 19.375rem;
  margin-right: 4.125rem;
}

.dataon-official-clone .totSch .totSch_right {
  min-width: 0;
  overflow: hidden;
}

.dataon-official-clone .totsch_info {
  margin-bottom: 2.125rem;
}

.dataon-official-clone .totsch_info .rst_cnt {
  float: left;
  margin: 0;
}

.dataon-official-clone .totsch_info .rst_cnt dt,
.dataon-official-clone .totsch_info .rst_cnt dd {
  float: left;
  color: #333333;
  font-size: 1.25rem;
  line-height: 2.5rem;
}

.dataon-official-clone .totsch_info .rst_cnt dd {
  position: relative;
  margin: 0 0 0 0.75rem;
  padding-left: 0.75rem;
}

.dataon-official-clone .totsch_info .rst_cnt dd::before {
  position: absolute;
  top: 42%;
  left: 0;
  height: 1rem;
  margin-top: -0.3125rem;
  content: "";
  border-left: 1px solid #BEBEBE;
}

.dataon-official-clone .totsch_form {
  float: right;
  display: flex;
  gap: 4px;
  align-items: center;
}

.dataon-official-clone .totsch_form select,
.dataon-official-clone .totsch_form input[type=text] {
  height: 2.5rem;
  padding: 0 0.75rem;
  color: #333333;
  font-size: 0.9375rem;
  border: 1px solid #D1D1D1;
  border-radius: 0;
  background: #FFFFFF;
}

.dataon-official-clone .brd_schBtn {
  display: inline-block;
  min-width: 4.375rem;
  height: 2.5rem;
  padding: 0 1rem;
  color: #FFFFFF;
  line-height: 2.5rem;
  text-align: center;
  border: 1px solid #3B3D3D;
  background: #3B3D3D;
}

.dataon-official-clone .repository_data {
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 2px solid #222222;
  border-bottom: 2px solid #222222;
}

.dataon-official-clone .repository_data > li {
  padding: 2rem 0.5rem;
  border-top: 1px solid #DDDDDD;
  transition: all 0.3s;
}

.dataon-official-clone .repository_data > li:first-child {
  border-top: 0;
}

.dataon-official-clone .repository_list {
  display: block;
  padding: 0;
  border: 0;
  background: transparent;
}

.dataon-official-clone .repository_list .repository_left {
  float: left;
  width: 63%;
  margin-right: 2%;
}

.dataon-official-clone .repository_list .repository_right {
  overflow: hidden;
}

.dataon-official-clone .repository_list .title {
  display: -webkit-box;
  max-height: 3.5625rem;
  margin-bottom: 0.8rem;
  overflow: hidden;
  color: #222222;
  font-family: "NanumSquare", "Noto Sans KR", Arial, sans-serif;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 2em;
  word-break: keep-all;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dataon-official-clone .repository_list .title .country {
  display: inline-block;
  min-height: 0;
  margin-right: 0.25rem;
  padding: 0 0.8125rem;
  color: #0E4B98;
  font-size: 1.05rem;
  font-style: normal;
  font-weight: inherit;
  line-height: 1.5625rem;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #0E4B98;
  background: #FFFFFF;
}

.dataon-official-clone .repository_list .title a {
  color: #222222;
}

.dataon-official-clone .rst_dataList {
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-clone .rst_dataList > li {
  position: relative;
  min-height: 1.45rem;
  margin-top: 0.1rem;
  padding-left: 8rem;
  overflow: hidden;
  color: #000000;
  font-size: 0.9375rem;
  font-weight: 400;
}

.dataon-official-clone .rst_dataList > li:first-child {
  margin-top: 0;
}

.dataon-official-clone .rst_dataList > li > strong,
.dataon-official-clone .schRst_Text strong {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 7.5rem;
  margin-right: 0.5rem;
  padding-right: 1px;
  color: #000000;
  font-size: 0.9375rem;
  font-weight: 500;
}

.dataon-official-clone .rst_dataList > li > strong::after,
.dataon-official-clone .schRst_Text strong::after {
  position: absolute;
  top: 0.45rem;
  right: 0;
  height: 0.8125rem;
  content: "";
  border-right: 1px solid #E0E0E0;
}

.dataon-official-clone .rst_dataList > li > span,
.dataon-official-clone .rst_dataList > li a {
  color: #555555 !important;
}

.dataon-official-clone .schRst_Text {
  position: relative;
  margin-top: 0.35rem;
  padding-left: 8rem;
  color: #555555;
  font-weight: 400;
}

.dataon-official-clone .schRst_Text p {
  display: -webkit-box;
  max-height: 4.8rem;
  margin: 0;
  overflow: hidden;
  color: #555555;
  font-size: 0.9375rem;
  line-height: 1.6rem;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.dataon-official-clone .repository_info_sup {
  border: 1px solid #DDDDDD;
}

.dataon-official-clone .repository_info .repository_img {
  display: table;
  width: 100%;
  height: 10.625rem;
  border: 0;
  background: #FFFFFF;
}

.dataon-official-clone .repository_info .repository_img a {
  position: relative;
  display: table-cell;
  padding: 0 1rem;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
}

.dataon-official-clone .repository_info .repository_img a img {
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 80%;
  max-height: 80%;
  transform: translate(-50%, -50%);
}

.dataon-official-clone .repository_info .repository_etc {
  padding: 0;
  text-align: center;
  background: #F8F8F8;
}

.dataon-official-clone .repository_info .repository_etc .rst_count {
  position: relative;
  margin: 0;
  overflow: hidden;
}

.dataon-official-clone .rst_count {
  margin: 0;
  padding: 0;
  overflow: hidden;
  list-style: none;
}

.dataon-official-clone .rst_count.sup_count > div {
  position: relative;
  width: 100%;
  height: 2.9375rem;
  padding: 0.5rem;
  border: 1px solid #DDDDDD;
  border-right: none;
  border-bottom: none;
  border-left: none;
}

.dataon-official-clone .rst_count > div span,
.dataon-official-clone .rst_count li span {
  display: inline-block;
  color: #898989;
  font-size: 0.875rem;
  font-weight: 300;
}

.dataon-official-clone .rst_count > div strong,
.dataon-official-clone .rst_count li strong {
  display: inline-block;
  color: #111111;
  font-family: "Montserrat", serif;
  font-size: 1.25rem;
  line-height: 1.875rem;
  vertical-align: baseline;
}

.dataon-official-clone .rst_count.sup_count > div > .rst_count_more {
  position: absolute;
  top: 50%;
  right: 1rem;
  color: #428BCA;
  font-size: 0.85rem;
  cursor: pointer;
  transform: translateY(-50%);
}

.dataon-official-clone .rst_count.sup_count ul {
  position: absolute;
  left: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  visibility: hidden;
  list-style: none;
}

.dataon-official-clone .rst_count.sup_count li {
  position: relative;
  float: left;
  width: 100%;
  height: 3rem;
  padding: 0.5rem 0;
  color: #111111;
  text-align: center;
  border: none;
}

.dataon-official-clone .rst_count.sup_count li::after {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: block;
  width: 90%;
  height: 1px;
  content: "";
  background: #DDDDDD;
  transform: translateX(-50%);
}

.dataon-official-clone .rst_count.sup_count li:last-child::after {
  display: none;
}

.dataon-official-clone .rst_count.sup_count li:nth-child(1),
.dataon-official-clone .rst_count.sup_count li:nth-child(2) {
  width: 50%;
  height: auto;
  padding: 1.5rem 0;
}

.dataon-official-clone .rst_count.sup_count li:nth-child(1)::after,
.dataon-official-clone .rst_count.sup_count li:nth-child(2)::after {
  display: none;
}

.dataon-official-clone .rst_count.sup_count li:nth-child(1) span,
.dataon-official-clone .rst_count.sup_count li:nth-child(2) span {
  position: static;
  display: inline-block;
  margin-left: 0.5rem;
}

.dataon-official-clone .rst_count.sup_count li:nth-child(1) strong,
.dataon-official-clone .rst_count.sup_count li:nth-child(2) strong {
  position: static;
  display: block;
}

.dataon-official-clone .rst_count.sup_count li:nth-child(n+3) span {
  position: absolute;
  left: 3rem;
  margin-top: 0.25rem;
}

.dataon-official-clone .rst_count.sup_count li:nth-child(n+3) strong {
  position: absolute;
  right: 3rem;
}

.dataon-official-clone .board_pager {
  margin: 1.8rem auto 1rem;
  text-align: center;
}

.dataon-official-clone .board_pager .pagination {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-clone .board_pager .page-link {
  position: relative;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  margin: 0 0.1rem;
  padding: 0;
  color: #888888;
  font-size: 1rem;
  line-height: 2rem;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  border: 1px solid transparent;
  border-radius: 50%;
  background: transparent;
}

.dataon-official-clone .board_pager .page-item.active .page-link,
.dataon-official-clone .board_pager .page-item.active .page-link:hover {
  color: #FFFFFF;
  border-color: #0E4B98;
  background-color: #0E4B98;
}

.dataon-official-clone .board_pager .page-item.active .page-link strong,
.dataon-official-clone .board_pager .page-item.active .page-link span {
  color: #FFFFFF;
  font-weight: 500;
}

.dataon-official-clone .board_pager .page-link > span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.dataon-official-clone .result_tit {
  margin: 0 0 20px;
  color: #333333;
  font-size: 1.5625rem;
  font-weight: 700;
}

.dataon-official-clone .similar_info_wrap {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #C8E0FF;
  border-radius: 8px;
  background-color: #EFF6FF;
}

.dataon-official-clone .similar_info_wrap .info_title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2E81EA;
  font-size: 1rem;
  font-weight: 700;
}

.dataon-official-clone .similar_info_wrap .info_item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 15px;
  color: #555555;
  font-size: 0.9375rem;
}

.dataon-official-clone .similar_info_wrap .info_dot,
.dataon-official-clone .result_card .dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.dataon-official-clone .similar_info_wrap .color_green,
.dataon-official-clone .result_card .similarity_dots.class_exact .dot.fill {
  background-color: #20C997;
}

.dataon-official-clone .similar_info_wrap .color_blue,
.dataon-official-clone .result_card .similarity_dots.class_similar .dot.fill {
  background-color: #5B8DEF;
}

.dataon-official-clone .similar_info_wrap .color_yellow,
.dataon-official-clone .result_card .similarity_dots.class_partial .dot.fill {
  background-color: #FBBC05;
}

.dataon-official-clone .similar_info_wrap .color_gray,
.dataon-official-clone .result_card .similarity_dots.class_low .dot.fill {
  background-color: #ADB5BD;
}

.dataon-official-clone .similar_info_wrap .txt {
  margin: 0;
  color: #2B3441;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: normal;
}

.dataon-official-clone .similar_info_wrap .sub_tit {
  font-size: 1.35rem;
  font-weight: 700;
}

.dataon-official-clone .similar_info_wrap .mt_10 {
  margin-top: 10px;
}

.dataon-official-clone .result_card {
  margin-bottom: 20px;
  padding: 20px 30px;
  border: 1px solid #E9ECEF;
  border-radius: 8px;
  background-color: #FFFFFF;
  transition: all 0.3s ease-in-out;
}

.dataon-official-clone .result_card .card_header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.dataon-official-clone .result_card .similarity_score {
  color: #333333;
  font-size: 2.25rem;
  font-weight: 500;
}

.dataon-official-clone .result_card .score_unit {
  color: #666666;
  font-size: 1.25rem;
}

.dataon-official-clone .result_card .dot {
  background-color: #F1F3F5;
  border: 1px solid #CBDCED;
}

.dataon-official-clone .result_card .card_summary {
  display: -webkit-box;
  height: 77px;
  overflow: hidden;
  color: #495057;
  font-size: 1rem;
  line-height: 1.6;
  word-wrap: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.dataon-official-clone .centerTit {
  margin: 0 0 1.375rem;
  color: #020202;
  font-family: "NanumSquare", "Noto Sans KR", sans-serif;
  font-size: 1.6875rem;
  line-height: 1.875rem;
  text-align: center;
}

.dataon-official-clone .gray_box {
  margin-top: 1.25rem;
  padding: 1.875rem 3.125rem;
  text-align: left;
  background: #F8F8F8;
}

.dataon-official-clone .totSch_wrap .totSch_detail {
  max-width: 60.5625rem;
  margin: 0 auto;
}

.dataon-official-clone .totSch_wrap .totSch_detail h3 {
  margin: 0 0 16px;
  color: #222222;
  font-size: 20px;
  font-weight: 900;
}

.dataon-official-clone .totSch_wrap .totSch_ctgrAdd {
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-clone .totSch_wrap .totSch_ctgrAdd li {
  position: relative;
  margin-top: 0.5rem;
  padding-right: 5.5625rem;
}

.dataon-official-clone .totSch_wrap .totSch_ctgrAdd li:first-child {
  margin-top: 0;
}

.dataon-official-clone .totSch_wrap .totSch_ctgrItem {
  position: relative;
  display: block;
  padding: 0 5.4375rem 0 12.75rem;
}

.dataon-official-clone .totSch_wrap .totSch_ctgrItem input,
.dataon-official-clone .totSch_wrap .totSch_ctgrItem select {
  width: 100%;
  height: 35px;
  vertical-align: top;
}

.dataon-official-clone .totSch_wrap .totSch_ctgrItem .totSch_sel {
  position: absolute;
  top: 0;
  left: 0;
  width: 12.75rem;
  height: 35px;
  color: #3C3C3C;
  font-weight: 500;
  text-align: center;
  background-color: initial;
}

.dataon-official-clone .totSch_wrap .totSch_ctgrItem .totSch_sel2 {
  position: absolute;
  top: 0;
  right: 0;
  width: 5.4375rem;
  height: 35px;
  color: #FFFFFF;
  border-color: gray;
  background-color: gray;
  background-image: url("/assets/dataon/official/sub/icon_select_white.png");
}

.dataon-official-clone .totSch_wrap .warning_txt {
  margin: 1.875rem 0 0;
  color: #D14A2E;
  font-size: 0.9375rem;
}

.dataon-official-clone .float_wrap > div {
  width: 50%;
}

.dataon-official-clone .float_wrap .f_left {
  float: left;
}

.dataon-official-clone .float_wrap .f_right {
  float: right;
}

.dataon-official-clone .dateWrap input[type=text] {
  width: calc(50% - 0.5rem);
}

.dataon-official-clone .ex_box {
  position: relative;
  margin-left: 2rem;
  padding-left: 4rem;
  color: #333333;
  font-size: 0.875rem;
}

.dataon-official-clone .ex_box span {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  min-width: 3.625rem;
  height: 1.6875rem;
  padding: 0 0.25rem;
  color: #121212;
  line-height: 1.6875rem;
  text-align: center;
  background: #B1B1B1;
}

.dataon-official-clone .ex_box i {
  display: block;
  color: #333333;
  font-style: normal;
}

.dataon-official-clone .search_tooltip_div_detail_page {
  position: relative;
  margin-top: 8px;
  text-align: right;
}

.dataon-official-clone .search_tooltip_button_detail_page {
  color: #0E4B98;
  font-weight: 600;
  background: transparent;
}

.dataon-official-clone .search_tooltip_detail_page {
  display: none;
}

.dataon-official-clone .flex_center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dataon-official-clone .btn_area {
  margin-top: 1.25rem;
}

.dataon-official-clone .btn_area .btn:first-child {
  margin-right: 5px;
}

.dataon-official-clone .btn-primary-detailSearch {
  color: #FFFFFF !important;
  font-weight: 600;
  border-color: #0E4B98;
  background-color: #0E4B98;
}

.dataon-official-clone .btn-outline-detailSearch-secondary {
  color: #333333;
  border: 1px solid #AEB8C6;
  background: #FFFFFF;
}

.dataon-official-clone .totSch .totSch_left h3 {
  height: 3.25rem;
  color: #FFFFFF;
  font-size: 1.1875rem;
  line-height: 3.25rem;
  text-align: center;
  background: #FD8D25;
}

.dataon-official-clone .totSch .totSch_left .sch_selectInfo h3 {
  margin-top: -1px;
  padding: 0 1rem;
  font-size: 1.125rem;
  text-align: left;
  background: #1053C8;
}

.dataon-official-clone .totSch .totSch_left .totSch_rowWrap {
  border: 1px solid #DDDDDD;
  border-top: 0;
  background: #FDFDFD;
}

.dataon-official-clone .totSch .totSch_left .totSch_rowWrap .totSch_row {
  position: relative;
  padding: 1.4375rem 1.2rem;
  border-top: 1px solid #DDDDDD;
}

.dataon-official-clone .totSch .totSch_left .totSch_rowWrap .totSch_row:first-child {
  border-top: 0;
}

.dataon-official-clone .totSch .totSch_left .totSch_row h4 {
  margin: 0 0 0.5rem;
  color: #343434;
  font-size: 1.125rem;
  line-height: 1;
}

.dataon-official-clone .totSch .totSch_left .totSch_row .list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-clone .totSch .totSch_left .totSch_row .list li {
  color: #333333;
  font-size: 0.9375rem;
}

.dataon-official-clone .totSch .totSch_left .totSch_row .list li label {
  position: relative;
  display: block;
  padding-right: 4.25rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dataon-official-clone .totSch .totSch_left .totSch_row .list li label > span {
  position: absolute;
  top: 0;
  right: 0.1rem;
  color: #1343B9;
}

@media (max-width: 1024px) {
  .dataon-official-clone .dataon-official-main > .dataon-container {
    padding: 3rem 0.5rem;
  }
  .dataon-official-clone .totSch .totSch_left {
    float: none;
    width: 100%;
    margin: 0 0 2rem;
  }
  .dataon-official-clone .repository_list .repository_left {
    float: none;
    width: 100%;
  }
  .dataon-official-clone .repository_list .repository_right {
    margin-top: 0.8rem;
  }
}
@media (max-width: 640px) {
  .dataon-official-clone .dataon-official-sub-top,
  .dataon-official-clone .dataon-official-sub-inner {
    min-height: 18rem;
  }
  .dataon-official-clone .dataon-official-sub-inner h2 {
    padding-top: 4rem;
    font-size: 1.8rem;
  }
  .dataon-official-clone .dataon-official-sub-top::after {
    top: 11.5rem;
    right: -1.65rem;
    width: 6rem;
    height: 2.7rem;
    font-size: 0.9rem;
    line-height: 2.7rem;
  }
  .dataon-official-clone .totsch_form {
    float: none;
    width: 100%;
    margin-top: 1rem;
    flex-wrap: wrap;
  }
  .dataon-official-clone .totsch_form select,
  .dataon-official-clone .totsch_form input[type=text] {
    flex: 1 1 100%;
  }
  .dataon-official-clone .rst_dataList > li,
  .dataon-official-clone .schRst_Text {
    padding-left: 0;
  }
  .dataon-official-clone .rst_dataList > li > strong,
  .dataon-official-clone .schRst_Text strong {
    position: relative;
    display: block;
    width: 100%;
  }
  .dataon-official-clone .rst_dataList > li > strong::after,
  .dataon-official-clone .schRst_Text strong::after {
    display: none;
  }
  .dataon-official-clone .gray_box {
    padding: 1.5rem 1.2rem;
  }
  .dataon-official-clone .totSch_wrap .totSch_ctgrAdd li {
    padding-top: 0.8rem;
    padding-right: 0;
    margin-top: 0.8rem;
    border-top: 1px solid #DDDDDD;
  }
  .dataon-official-clone .totSch_wrap .totSch_ctgrAdd li:first-child {
    padding-top: 0;
    margin-top: 0;
    border-top: 0;
  }
  .dataon-official-clone .totSch_wrap .totSch_ctgrItem {
    padding: 0;
  }
  .dataon-official-clone .totSch_wrap .totSch_ctgrItem .totSch_sel,
  .dataon-official-clone .totSch_wrap .totSch_ctgrItem .totSch_sel2 {
    position: relative;
    width: 100%;
  }
  .dataon-official-clone .totSch_wrap .totSch_ctgrItem input[type=text] {
    margin: 0.25rem 0;
  }
  .dataon-official-clone .float_wrap .f_left,
  .dataon-official-clone .float_wrap .f_right {
    float: none;
    width: 100%;
  }
  .dataon-official-clone .ex_box {
    margin: 1rem 0 0;
  }
}
.dataon-results-search-block {
  position: relative;
  z-index: 1200;
  display: grid;
  width: min(100%, 1040px);
  gap: 0;
  min-width: 0;
}

.dataon-results-search {
  position: relative;
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) auto;
  width: 100%;
  overflow: hidden;
  border: 2px solid #0057B8;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 16px 34px rgba(0, 20, 60, 0.24);
}

.dataon-results-scope-select {
  height: 58px;
}

.dataon-results-search input {
  width: 100%;
  height: 58px;
  min-width: 0;
  padding: 0 58px 0 20px;
  color: #0B1733;
  font: inherit;
  font-size: 17px;
  font-weight: 750;
  border: 0;
  outline: none;
  background: #FFFFFF;
}

.dataon-results-search input::placeholder {
  color: #8796AB;
}

.dataon-results-clear {
  position: absolute;
  top: 50%;
  right: 118px;
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #6A7890;
  border-radius: 999px;
  background: #EEF4FB;
  transform: translateY(-50%);
}

.dataon-results-clear:hover {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-results-submit {
  display: inline-flex;
  min-width: 108px;
  height: 58px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 20px;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 900;
  background: #0057B8;
}

.dataon-results-submit:hover {
  background: #003F88;
}

.dataon-results-keywords {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(100%, 1040px);
  min-width: 0;
  margin-top: 8px;
  overflow: hidden;
}

.dataon-results-keywords span {
  flex: 0 0 auto;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
  font-weight: 850;
  white-space: nowrap;
}

.dataon-results-keyword-list {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  scrollbar-width: none;
}

.dataon-results-keywords button {
  flex: 0 0 auto;
  min-height: 26px;
  padding: 0 9px;
  color: #D8ECFF;
  font-size: 12px;
  font-weight: 850;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  background: rgba(2, 31, 79, 0.36);
}

.dataon-results-keywords button:hover {
  color: #FFFFFF;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(0, 103, 214, 0.48);
}

.dataon-search-mode-row {
  display: grid;
  gap: 10px;
  width: min(100%, 1040px);
  min-width: 0;
  margin-top: 12px;
}

.dataon-search-mode-toggle {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 6px;
  background: rgba(2, 31, 79, 0.38);
}

.dataon-search-mode-toggle button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 13px;
  font-weight: 900;
  background: transparent;
}

.dataon-search-mode-toggle button + button {
  border-left: 1px solid rgba(255, 255, 255, 0.18);
}

.dataon-search-mode-toggle button.is-active {
  color: #0B1733;
  background: #FFFFFF;
}

.dataon-results-body {
  padding: 22px 0 56px;
}

.dataon-results-layout {
  display: grid;
  grid-template-columns: 252px minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}

.dataon-results-applied-strip {
  display: flex;
  grid-column: 1/-1;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 8px 20px rgba(6, 42, 95, 0.05);
}

.dataon-applied-reset {
  flex: 0 0 auto;
  min-height: 32px;
  padding: 0 11px;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid #CAD7E8;
  border-radius: 999px;
  background: #FFFFFF;
}

.dataon-filter-column {
  position: sticky;
  z-index: 45;
  top: 86px;
  min-width: 0;
  align-self: start;
}

.dataon-result-card,
.dataon-result-empty {
  min-width: 0;
  border: 1px solid #DCE6F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 12px 28px rgba(6, 42, 95, 0.08);
}

.dataon-search-filter-panel {
  position: static;
  display: grid;
  overflow: hidden;
  min-width: 0;
  border: 1px solid #E1E7F0;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 10px 24px rgba(6, 42, 95, 0.06);
}

.dataon-filter-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid #E8EEF6;
  background: #FFFFFF;
}

.dataon-filter-panel-head div {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.dataon-filter-panel-head h2 {
  margin: 0;
  color: #0B1733;
  font-size: 17px;
  font-weight: 900;
  line-height: 1.25;
}

.dataon-filter-panel-head span {
  color: #6A7890;
  font-size: 12px;
  font-weight: 850;
}

.dataon-filter-panel-close {
  display: none;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #4B5B73;
  border-radius: 6px;
  background: #F3F7FC;
}

.dataon-filter-accordion {
  display: grid;
  min-width: 0;
  border-bottom: 1px solid #E8EEF6;
}

.dataon-filter-accordion:last-of-type {
  border-bottom: 0;
}

.dataon-filter-accordion-head {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  padding: 0 16px;
  color: #0B1733;
  font-size: 14px;
  font-weight: 950;
  background: #FFFFFF;
}

.dataon-filter-accordion-head i {
  flex: 0 0 auto;
  color: #8A96A8;
  font-size: 12px;
}

.dataon-filter-accordion-body {
  display: grid;
  gap: 9px;
  min-width: 0;
  padding: 0 16px 16px;
}

.dataon-filter-range-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto;
  gap: 6px;
  align-items: center;
}

.dataon-filter-range-row input {
  width: 100%;
  min-width: 0;
  height: 34px;
  padding: 0 10px;
  color: #26364D;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #CAD4E3;
  border-radius: 3px;
  background: #FFFFFF;
}

.dataon-filter-apply-icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border: 0;
  border-radius: 3px;
  background: #0057B8;
}

.dataon-filter-apply-icon:hover {
  background: #003E87;
}

.dataon-filter-range-row span {
  color: #7A8799;
  font-size: 12px;
  font-weight: 800;
}

.dataon-filter-option {
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr) auto;
  gap: 7px;
  align-items: center;
  min-width: 0;
  color: #26364D;
  cursor: pointer;
}

.dataon-filter-option input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.dataon-filter-check {
  display: inline-flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  color: transparent;
  border: 1px solid #AEBBCC;
  border-radius: 2px;
  background: #FFFFFF;
}

.dataon-filter-option input:checked + .dataon-filter-check {
  color: #FFFFFF;
  border-color: #0057B8;
  background: #0057B8;
}

.dataon-filter-check i {
  font-size: 9px;
}

.dataon-filter-label {
  min-width: 0;
  overflow: hidden;
  font-size: 13px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-filter-option em {
  color: #6A7890;
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
}

.dataon-filter-panel-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
  padding: 14px 16px 16px;
  border-top: 1px solid #E8EEF6;
  background: #FAFCFF;
}

.dataon-filter-panel-actions button {
  min-height: 38px;
  font-size: 13px;
  font-weight: 950;
  border-radius: 6px;
}

.dataon-filter-panel-actions .is-reset {
  color: #4B5B73;
  border: 1px solid #CAD7E8;
  background: #FFFFFF;
}

.dataon-filter-panel-actions .is-submit {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-search-result-area {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 16px;
  min-width: 0;
}

.dataon-mobile-filter-button {
  display: none;
}

.dataon-result-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
  padding: 0 0 2px;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.dataon-result-toolbar div:first-child {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.dataon-result-toolbar h2 {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #0B1733;
  font-size: 22px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-result-sort {
  display: inline-flex;
  flex: 0 0 auto;
  overflow: hidden;
  border: 1px solid #CAD7E8;
  border-radius: 6px;
  background: #F8FBFF;
}

.dataon-result-sort button {
  min-height: 38px;
  padding: 0 14px;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 900;
  background: transparent;
}

.dataon-result-sort button + button {
  border-left: 1px solid #CAD7E8;
}

.dataon-result-sort button.is-active {
  color: #FFFFFF;
  background: #0057B8;
}

.dataon-applied-filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.dataon-applied-filter-row button {
  display: inline-flex;
  max-width: 100%;
  min-height: 32px;
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  color: #0057B8;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid #B9D7F7;
  border-radius: 999px;
  background: #F4FAFF;
}

.dataon-applied-filter-row span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-applied-filter-row i {
  flex: 0 0 auto;
  font-size: 11px;
}

.dataon-result-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  padding: 4px 0;
}

.dataon-pagination-summary {
  flex: 0 0 auto;
  color: #6A7890;
  font-size: 13px;
  font-weight: 850;
  white-space: nowrap;
}

.dataon-pagination-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  min-width: 0;
}

.dataon-pagination-controls button,
.dataon-pagination-gap {
  display: inline-flex;
  min-width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #4B5B73;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid #D4DEE9;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-pagination-controls button:hover:not(:disabled),
.dataon-pagination-controls button:focus-visible {
  color: #0057B8;
  border-color: #9CC6F4;
  background: #F4FAFF;
}

.dataon-pagination-controls button.is-active {
  color: #FFFFFF;
  border-color: #0057B8;
  background: #0057B8;
}

.dataon-pagination-controls button:disabled {
  color: #A8B3C2;
  cursor: not-allowed;
  background: #F4F7FB;
}

.dataon-pagination-gap {
  min-width: 20px;
  color: #98A4B5;
  border: 0;
  background: transparent;
}

.dataon-result-end {
  display: grid;
  justify-items: center;
  min-width: 0;
  margin-top: 14px;
  padding: 4px 0 0;
  color: #8A96A8;
  text-align: center;
}

.dataon-result-end-line {
  display: grid;
  width: 100%;
  grid-template-columns: minmax(32px, 1fr) auto minmax(32px, 1fr);
  align-items: center;
  gap: 14px;
}

.dataon-result-end-line span {
  height: 1px;
  background: #DCE4EE;
}

.dataon-result-end-line strong {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #7E8A9B;
  font-size: 16px;
  font-weight: 850;
  line-height: 1.4;
  white-space: nowrap;
}

.dataon-result-list {
  display: grid;
  gap: 14px;
  min-width: 0;
}

.dataon-result-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 150px;
  gap: 18px;
  width: 100%;
  padding: 22px;
  color: #0B1733;
  text-align: left;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.dataon-result-card:hover {
  border-color: #0057B8;
  box-shadow: 0 18px 36px rgba(0, 87, 184, 0.16);
  transform: translateY(-2px);
}

.dataon-result-card-main {
  display: grid;
  gap: 10px;
  min-width: 0;
}

.dataon-result-card-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #6A7890;
  font-size: 13px;
  font-weight: 850;
}

.dataon-result-type {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  padding: 0 9px;
  color: #0057B8;
  font-size: 12px;
  font-weight: 900;
  border-radius: 6px;
  background: #EAF3FF;
}

.dataon-result-score {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  padding: 0 9px;
  color: #17633A;
  font-size: 12px;
  font-weight: 950;
  border: 1px solid #CBE7D4;
  border-radius: 6px;
  background: #F0FAF3;
}

.dataon-result-card h3 {
  min-width: 0;
  margin: 0;
  color: #0B1733;
  font-size: 24px;
  font-weight: 900;
  line-height: 1.35;
}

.dataon-result-title-en,
.dataon-result-summary {
  min-width: 0;
  margin: 0;
  line-height: 1.6;
}

.dataon-result-title-en {
  color: #0067D6;
  font-size: 14px;
  font-weight: 850;
}

.dataon-result-summary {
  color: #26364D;
  font-size: 15px;
  font-weight: 700;
}

.dataon-result-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.dataon-result-tags span {
  display: inline-flex;
  max-width: 100%;
  min-height: 26px;
  align-items: center;
  overflow: hidden;
  padding: 0 9px;
  color: #17633A;
  font-size: 12px;
  font-weight: 900;
  border: 1px solid #CBE7D4;
  border-radius: 999px;
  background: #F0FAF3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-result-semantic-reason {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 8px 10px;
  min-width: 0;
  padding: 12px;
  color: #184D31;
  border: 1px solid #CBE7D4;
  border-radius: 8px;
  background: #F6FCF8;
}

.dataon-result-semantic-reason > i {
  padding-top: 2px;
  color: #17633A;
}

.dataon-result-semantic-reason > span {
  min-width: 0;
  color: #184D31;
  font-size: 13px;
  font-weight: 850;
  line-height: 1.45;
}

.dataon-result-semantic-reason > div {
  display: flex;
  grid-column: 2;
  flex-wrap: wrap;
  gap: 5px;
  min-width: 0;
}

.dataon-result-semantic-reason em {
  display: inline-flex;
  max-width: 100%;
  min-height: 22px;
  align-items: center;
  padding: 0 7px;
  overflow: hidden;
  color: #17633A;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  border-radius: 999px;
  background: #E7F6EC;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-result-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 14px;
  min-width: 0;
  margin: 4px 0 0;
}

.dataon-result-meta div {
  display: grid;
  grid-template-columns: 74px minmax(0, 1fr);
  gap: 8px;
  min-width: 0;
}

.dataon-result-meta dt,
.dataon-result-meta dd {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  font-size: 13px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-result-meta dt {
  color: #6A7890;
  font-weight: 900;
}

.dataon-result-meta dd {
  color: #0B1733;
  font-weight: 800;
}

.dataon-result-card-side {
  display: grid;
  align-content: center;
  gap: 10px;
  min-width: 0;
  padding-left: 18px;
  border-left: 1px solid #E6EDF5;
}

.dataon-result-card-side div {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.dataon-result-card-side span {
  color: #6A7890;
  font-size: 12px;
  font-weight: 900;
}

.dataon-result-card-side strong {
  color: #0B1733;
  font-size: 24px;
  font-weight: 900;
  line-height: 1.1;
}

.dataon-result-card-side i {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border-radius: 999px;
  background: #0057B8;
}

.dataon-result-empty {
  display: grid;
  justify-items: center;
  gap: 12px;
  min-height: 320px;
  align-content: center;
  padding: 40px 22px;
  text-align: center;
}

.dataon-result-empty > i {
  display: inline-flex;
  width: 58px;
  height: 58px;
  align-items: center;
  justify-content: center;
  color: #0057B8;
  border-radius: 999px;
  background: #EAF3FF;
}

.dataon-result-empty h2 {
  margin: 0;
  color: #0B1733;
  font-size: 22px;
  font-weight: 900;
}

.dataon-result-empty p {
  margin: 0;
  color: #5D6B82;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.6;
}

.dataon-result-empty-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 6px;
}

.dataon-result-empty-actions button {
  min-height: 38px;
  padding: 0 14px;
  color: #0057B8;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid #B9D7F7;
  border-radius: 6px;
  background: #F4FAFF;
}

.dataon-result-empty-actions button:hover {
  color: #FFFFFF;
  border-color: #004899;
  background: #004899;
}

@media (max-width: 900px) {
  .dataon-results-layout {
    grid-template-columns: 1fr;
  }
  .dataon-filter-column {
    position: static;
    min-height: 0;
  }
  .dataon-filter-backdrop {
    position: fixed;
    z-index: 2190;
    inset: 0;
    background: rgba(3, 18, 40, 0.42);
  }
  .dataon-search-filter-panel {
    position: fixed;
    z-index: 2200;
    top: 0;
    right: 0;
    bottom: 0;
    width: min(88vw, 360px);
    overflow: auto;
    border-radius: 0;
    transform: translateX(110%);
    transition: transform 180ms ease;
  }
  .dataon-search-filter-panel.is-open {
    transform: translateX(0);
  }
  .dataon-filter-panel-close,
  .dataon-mobile-filter-button {
    display: inline-flex;
  }
  .dataon-mobile-filter-button {
    width: fit-content;
    min-height: 38px;
    align-items: center;
    gap: 8px;
    padding: 0 13px;
    color: #0057B8;
    font-size: 13px;
    font-weight: 950;
    border: 1px solid #B9D7F7;
    border-radius: 999px;
    background: #FFFFFF;
  }
  .dataon-mobile-filter-button em {
    display: inline-flex;
    min-width: 20px;
    height: 20px;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 11px;
    font-style: normal;
    border-radius: 999px;
    background: #0057B8;
  }
}
@media (max-width: 760px) {
  .dataon-results-title-row,
  .dataon-result-card,
  .dataon-result-meta {
    grid-template-columns: 1fr;
  }
  .dataon-result-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .dataon-result-sort {
    width: 100%;
  }
  .dataon-result-sort button {
    flex: 1 1 0;
  }
  .dataon-result-pagination {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataon-pagination-controls {
    justify-content: flex-start;
  }
  .dataon-results-applied-strip {
    align-items: stretch;
    flex-direction: column;
  }
  .dataon-advanced-head {
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .dataon-advanced-title {
    flex: 1 1 180px;
  }
  .dataon-advanced-match {
    width: 100%;
  }
  .dataon-advanced-match button {
    flex: 1 1 0;
    padding-right: 10px;
    padding-left: 10px;
  }
  .dataon-advanced-condition-row {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 14px 0;
  }
  .dataon-advanced-condition-name {
    line-height: 1.35;
  }
  .dataon-advanced-accordion-head {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .dataon-advanced-accordion-head strong {
    grid-column: 1/-1;
    grid-row: 2;
    text-align: left;
  }
  .dataon-advanced-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .dataon-advanced-button-row {
    width: 100%;
  }
  .dataon-result-card-side {
    grid-template-columns: repeat(2, minmax(0, 1fr)) auto;
    align-items: center;
    padding-top: 14px;
    padding-left: 0;
    border-top: 1px solid #E6EDF5;
    border-left: 0;
  }
}
@media (max-width: 560px) {
  .dataon-results-visual-inner {
    padding-top: 20px;
    padding-bottom: 24px;
  }
  .dataon-results-title-row h1 {
    font-size: 30px;
  }
  .dataon-results-title-row p {
    font-size: 14px;
  }
  .dataon-results-search {
    grid-template-columns: 88px minmax(0, 1fr) 52px;
  }
  .dataon-results-scope-select {
    height: 54px;
    padding: 0 10px;
    font-size: 13px;
  }
  .dataon-results-search input {
    height: 54px;
    padding: 0 46px 0 14px;
    font-size: 15px;
  }
  .dataon-results-clear {
    right: 58px;
    width: 30px;
    height: 30px;
  }
  .dataon-results-submit {
    width: 52px;
    min-width: 52px;
    height: 54px;
    padding: 0;
  }
  .dataon-results-submit span {
    display: none;
  }
  .dataon-search-mode-toggle {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataon-search-mode-toggle button {
    min-width: 0;
    padding-right: 8px;
    padding-left: 8px;
  }
  .dataon-search-mode-toggle button span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .dataon-filter-group,
  .dataon-result-card-side {
    grid-template-columns: 1fr;
  }
  .dataon-result-card {
    padding: 18px;
  }
  .dataon-result-card h3 {
    font-size: 21px;
  }
  .dataon-result-meta div {
    grid-template-columns: 1fr;
    gap: 2px;
  }
}
.dataon-subpage-section {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  background: #FFFFFF;
}

.dataon-subpage-visual {
  display: flex;
  min-height: 230px;
  align-items: center;
  justify-content: center;
  padding: 44px 0;
  color: #FFFFFF;
  text-align: center;
  border-bottom: 4px solid #0B1733;
  background-color: #021F4F;
  background-image: linear-gradient(90deg, rgba(1, 20, 56, 0.88), rgba(0, 87, 184, 0.62)), url("/assets/dataon/main_bg.png");
  background-position: center;
  background-size: cover;
}

.dataon-subpage-visual-inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dataon-subpage-visual h1 {
  margin: 0;
  color: #FFFFFF;
  font-size: 38px;
  font-weight: 900;
  line-height: 1.22;
}

.dataon-subpage-body {
  flex: 1 0 auto;
  padding: 64px 0 72px;
  background: #FFFFFF;
}

.dataon-subpage-container {
  display: grid;
}

.dataon-placeholder-card {
  display: grid;
  gap: 16px;
  width: 100%;
  max-width: none;
  min-height: 340px;
  align-content: center;
  padding: 48px;
  overflow: hidden;
  border: 1px solid #E6EDF5;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: none;
}

.dataon-placeholder-path {
  margin: 0;
  overflow: hidden;
  color: #0067D6;
  font-size: 14px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-placeholder-card p {
  max-width: 680px;
  margin: 0;
  color: #4B5B73;
  font-size: 16px;
  line-height: 1.7;
}

.dataon-placeholder-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.dataon-placeholder-actions button {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  padding: 0 18px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 800;
  border-radius: 999px;
  background: #0067D6;
}

.dataon-placeholder-actions button + button {
  color: #0067D6;
  border: 1px solid #1D8FFF;
  background: #FFFFFF;
}

@media (max-width: 640px) {
  .dataon-subpage-visual {
    min-height: 184px;
    padding: 32px 0;
  }
  .dataon-subpage-visual h1 {
    font-size: 30px;
  }
  .dataon-subpage-body {
    padding: 42px 0 48px;
  }
  .dataon-placeholder-card {
    min-height: 280px;
    padding: 28px 20px;
  }
}
.dataon-service-page {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  background: #FFFFFF;
}

.dataon-service-page-body {
  flex: 1 0 auto;
  padding: 54px 0 76px;
  background: #FFFFFF;
}

.dataon-service-page-layout {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  align-items: start;
  gap: 36px;
}

.dataon-service-side {
  position: sticky;
  top: 24px;
  display: grid;
  gap: 18px;
  padding: 26px 22px;
  border: 1px solid #DDE6F1;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-service-side-title {
  color: #0B1733;
  font-size: 22px;
  font-weight: 900;
}

.dataon-service-side-group {
  display: grid;
  gap: 6px;
  padding-top: 16px;
  border-top: 1px solid #E6EDF5;
}

.dataon-service-side-heading,
.dataon-service-side-link {
  width: 100%;
  min-height: 34px;
  padding: 0;
  color: #0B1733;
  text-align: left;
  background: transparent;
}

.dataon-service-side-heading {
  font-size: 16px;
  font-weight: 900;
}

.dataon-service-side-link {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  color: #4B5B73;
  font-size: 14px;
  font-weight: 700;
  border-radius: 6px;
}

.dataon-service-side-link span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-service-side-link em {
  color: #61718A;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.dataon-service-side-link:hover,
.dataon-service-side-link:focus-visible,
.dataon-service-side-link.is-active {
  color: #005FC6;
  background: #EEF6FF;
}

.dataon-service-content {
  min-width: 0;
}

.dataon-service-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 22px;
  color: #6B7C93;
  font-size: 14px;
  font-weight: 800;
}

.dataon-service-breadcrumb span:not(:last-child)::after {
  margin-left: 8px;
  color: #B1BECC;
  content: ">";
}

.dataon-service-breadcrumb .is-current {
  color: #0B1733;
}

.dataon-service-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 24px;
  margin-bottom: 16px;
  padding-bottom: 28px;
  border-bottom: 2px solid #0B1733;
}

.dataon-service-kicker {
  margin: 0 0 8px;
  color: #0067D6;
  font-size: 15px;
  font-weight: 900;
}

.dataon-service-head h2 {
  margin: 0;
  color: #111827;
  font-size: 34px;
  font-weight: 900;
  line-height: 1.25;
}

.dataon-service-head p:last-child {
  max-width: 780px;
  margin: 12px 0 0;
  color: #4B5B73;
  font-size: 16px;
  line-height: 1.7;
}

.dataon-service-origin-link {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  color: #005FC6;
  font-size: 14px;
  font-weight: 900;
  text-decoration: none;
  border: 1px solid #BFD8F7;
  border-radius: 6px;
  background: #F5FAFF;
}

.dataon-service-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;
  padding: 14px 16px;
  color: #26364D;
  border: 1px solid #DDE6F1;
  border-radius: 6px;
  background: #F8FAFD;
}

.dataon-service-status strong {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  padding: 0 11px;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 900;
  border-radius: 999px;
  background: #0067D6;
}

.dataon-service-status.is-login strong {
  background: #C04A00;
}

.dataon-service-status.is-external strong {
  background: #0B8E7A;
}

.dataon-service-status.is-key strong {
  background: #6D5BD0;
}

.dataon-service-status.is-blocked strong {
  background: #7B2334;
}

.dataon-service-status span {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.55;
}

.dataon-service-panel {
  display: grid;
  gap: 18px;
  padding: 30px;
  border: 1px solid #DDE6F1;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-service-panel + .dataon-service-panel {
  margin-top: 22px;
}

.dataon-service-panel h3,
.dataon-service-panel h4 {
  margin: 0;
  color: #111827;
  font-weight: 900;
  line-height: 1.35;
}

.dataon-service-panel h3 {
  font-size: 25px;
}

.dataon-service-panel h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
  font-size: 21px;
}

.dataon-service-panel h4 i {
  color: #0067D6;
}

.dataon-service-panel p {
  margin: 0;
  color: #4B5B73;
  font-size: 16px;
  line-height: 1.75;
}

.dataon-service-lead {
  max-width: 880px;
}

.dataon-service-note {
  color: #5D6D84;
  font-size: 14px !important;
}

.dataon-service-overview-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.dataon-service-overview-group {
  display: grid;
  align-content: start;
  gap: 8px;
  min-height: 180px;
  padding: 22px;
  border: 1px solid #E1E9F3;
  border-radius: 6px;
  background: #F8FAFD;
}

.dataon-service-overview-group h4 {
  margin: 0 0 6px;
  font-size: 18px;
}

.dataon-service-overview-group button {
  display: flex;
  min-height: 36px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
  color: #26364D;
  font-size: 14px;
  font-weight: 800;
  text-align: left;
  background: transparent;
}

.dataon-service-overview-group em {
  color: #0067D6;
  font-size: 12px;
  font-style: normal;
}

.dataon-service-state-table {
  display: grid;
  border-top: 1px solid #0B1733;
}

.dataon-service-state-table div {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr) 112px minmax(180px, 0.8fr);
  gap: 16px;
  padding: 13px 0;
  border-bottom: 1px solid #E6EDF5;
}

.dataon-service-state-table span,
.dataon-service-state-table em,
.dataon-service-state-table small {
  color: #4B5B73;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
}

.dataon-service-state-table strong {
  min-width: 0;
  color: #111827;
  font-size: 15px;
  font-weight: 900;
}

.dataon-aida-panel {
  min-height: 280px;
  align-content: center;
  text-align: center;
}

.dataon-aida-redirect-form {
  display: flex;
  justify-content: center;
}

.dataon-aida-redirect-form button,
.dataon-service-action-row button,
.dataon-official-login-box button {
  display: inline-flex;
  min-height: 46px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 22px;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 900;
  border-radius: 6px;
  background: #0067D6;
}

.dataon-narda-link-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.dataon-narda-link-grid a {
  display: flex;
  min-height: 46px;
  align-items: center;
  padding: 0 14px;
  color: #005FC6;
  font-size: 14px;
  font-weight: 900;
  text-decoration: none;
  border: 1px solid #CFE0F5;
  border-radius: 6px;
  background: #F5FAFF;
}

.dataon-official-title,
.dataon-overview-title {
  position: relative;
  padding-left: 12px;
  border-left: 6px solid #0F66D4;
}

.dataon-hosting-box,
.dataon-hosting-list {
  padding: 22px 24px;
  color: #4B5B73;
  font-size: 16px;
  line-height: 1.8;
  border: 1px solid #E1E9F3;
  border-radius: 6px;
  background: #F8FAFD;
}

.dataon-hosting-list ul,
.dataon-official-list,
.dataon-code-example ul,
.dataon-login-copy ul {
  display: grid;
  gap: 9px;
  margin: 0;
  padding-left: 22px;
}

.dataon-hosting-list li,
.dataon-official-list li,
.dataon-code-example li,
.dataon-login-copy li {
  color: #4B5B73;
  font-size: 16px;
  line-height: 1.65;
}

.dataon-service-action-row {
  display: flex;
  justify-content: center;
  padding-top: 12px;
}

.dataon-login-required-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 400px);
  gap: 28px;
  align-items: start;
}

.dataon-login-copy {
  display: grid;
  gap: 16px;
}

.dataon-official-login-box {
  display: grid;
  gap: 14px;
  padding: 24px;
  border: 1px solid #DDE6F1;
  border-radius: 6px;
  background: #F8FAFD;
}

.dataon-official-login-box label {
  display: grid;
  gap: 7px;
  color: #26364D;
  font-size: 13px;
  font-weight: 900;
}

.dataon-official-login-box input {
  width: 100%;
  min-height: 44px;
  padding: 0 13px;
  color: #6B7C93;
  border: 1px solid #D8E1EC;
  border-radius: 6px;
  background: #FFFFFF;
}

.dataon-login-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  color: #6B7C93;
  font-size: 13px;
  font-weight: 800;
}

.dataon-login-links a,
.dataon-kafe-box a {
  color: #005FC6;
  text-decoration: none;
}

.dataon-kafe-box {
  display: grid;
  gap: 8px;
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid #DDE6F1;
}

.dataon-kafe-box h4 {
  margin: 0;
  font-size: 17px;
}

.dataon-kafe-box p,
.dataon-kafe-box a {
  font-size: 13px;
  font-weight: 800;
  line-height: 1.6;
}

.dataon-permission-panel {
  justify-items: center;
  min-height: 280px;
  align-content: center;
  text-align: center;
}

.dataon-permission-icon {
  display: grid;
  width: 62px;
  height: 62px;
  place-items: center;
  color: #FFFFFF;
  font-size: 26px;
  border-radius: 999px;
  background: #7B2334;
}

.dataon-service-form {
  display: grid;
  gap: 18px;
}

.dataon-form-section-title {
  padding: 14px 18px;
  color: #111827;
  font-size: 18px;
  font-weight: 900;
  border-top: 2px solid #0B1733;
  border-bottom: 1px solid #DDE6F1;
  background: #F7F9FC;
}

.dataon-form-section-title.is-sub {
  margin-top: 10px;
  font-size: 16px;
  border-top-width: 1px;
}

.dataon-form-section-title em,
.dataon-form-field em {
  color: #D2461F;
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
}

.dataon-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 18px;
}

.dataon-form-field {
  display: grid;
  min-width: 0;
  gap: 8px;
  color: #26364D;
  font-size: 14px;
  font-weight: 900;
}

.dataon-form-field.is-full {
  grid-column: 1/-1;
}

.dataon-form-field input,
.dataon-form-field select,
.dataon-form-field textarea,
.dataon-community-search input,
.dataon-community-search select {
  width: 100%;
  min-height: 42px;
  padding: 0 12px;
  color: #39475B;
  font-size: 14px;
  border: 1px solid #D3DEEA;
  border-radius: 4px;
  background: #FFFFFF;
}

.dataon-form-field textarea {
  min-height: 136px;
  padding-top: 12px;
  resize: vertical;
}

.dataon-form-field input:disabled,
.dataon-form-field select:disabled,
.dataon-form-field textarea:disabled,
.dataon-community-search input:disabled,
.dataon-community-search select:disabled {
  color: #6D7B8F;
  opacity: 1;
  background: #F7F9FC;
}

.dataon-form-field small {
  color: #6B7C93;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.55;
}

.dataon-form-inline {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) minmax(130px, 0.65fr);
  align-items: center;
  gap: 8px;
}

.dataon-form-inline.is-phone {
  grid-template-columns: minmax(64px, 0.5fr) auto minmax(80px, 1fr) auto minmax(80px, 1fr);
}

.dataon-form-inline b {
  color: #53647A;
  font-size: 14px;
}

.dataon-form-inline button,
.dataon-form-actions button,
.dataon-openapi-item button,
.dataon-community-toolbar button,
.dataon-community-card button,
.dataon-community-empty-card button {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 16px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 900;
  border-radius: 4px;
  background: #0067D6;
}

.dataon-form-inline button.is-secondary,
.dataon-form-actions button.is-secondary {
  color: #FFFFFF;
  background: #2F3A4A;
}

.dataon-check-row,
.dataon-license-row,
.dataon-agree-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  min-height: 42px;
  color: #39475B;
  font-size: 14px;
  font-weight: 800;
}

.dataon-check-row label,
.dataon-agree-row {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.dataon-check-row input,
.dataon-license-row input,
.dataon-agree-row input {
  width: 16px;
  height: 16px;
}

.dataon-service-warning {
  display: grid;
  gap: 9px;
  padding: 18px 20px;
  color: #4B5B73;
  font-size: 14px;
  line-height: 1.65;
  border: 1px solid #E1E9F3;
  border-radius: 4px;
  background: #F8FAFD;
}

.dataon-service-warning strong {
  color: #111827;
  font-weight: 900;
}

.dataon-service-warning ul {
  display: grid;
  gap: 6px;
  margin: 0;
  padding-left: 18px;
}

.dataon-form-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 9px;
  padding-top: 6px;
}

.dataon-board-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #DDE6F1;
  padding-bottom: 14px;
}

.dataon-board-title h3 {
  margin-right: auto;
}

.dataon-board-title p {
  color: #4B5B73;
  font-size: 15px;
  font-weight: 800;
}

.dataon-board-title strong {
  color: #111827;
  font-weight: 900;
}

.dataon-board-title a {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  padding: 0 13px;
  color: #005FC6;
  font-size: 13px;
  font-weight: 900;
  text-decoration: none;
  border: 1px solid #BFD8F7;
  border-radius: 4px;
  background: #F5FAFF;
}

.dataon-board-list {
  display: grid;
  border-top: 2px solid #0B1733;
}

.dataon-board-row {
  display: grid;
  grid-template-columns: 0.7fr 1.8fr repeat(6, minmax(82px, 1fr));
  border-bottom: 1px solid #DDE6F1;
}

.dataon-board-row span {
  min-height: 46px;
  padding: 13px 8px;
  color: #111827;
  font-size: 13px;
  font-weight: 900;
  text-align: center;
  border-right: 1px solid #E7EEF6;
  background: #F1F5FA;
}

.dataon-board-empty {
  min-height: 58px;
  padding: 19px;
  color: #6B7C93;
  font-size: 14px;
  font-weight: 800;
  text-align: center;
  border-bottom: 1px solid #DDE6F1;
}

.dataon-board-pager {
  justify-self: center;
  min-width: 34px;
  min-height: 34px;
  padding: 7px 10px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 900;
  text-align: center;
  border-radius: 4px;
  background: #0067D6;
}

.dataon-openapi-list {
  display: grid;
  border-top: 2px solid #0B1733;
}

.dataon-openapi-item {
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr) 120px;
  align-items: center;
  gap: 18px;
  padding: 22px 0;
  border-bottom: 1px solid #DDE6F1;
}

.dataon-openapi-no {
  color: #111827;
  font-size: 34px;
  font-weight: 900;
  text-align: center;
}

.dataon-openapi-copy {
  display: grid;
  gap: 6px;
}

.dataon-openapi-copy a {
  color: #111827;
  font-size: 18px;
  font-weight: 900;
  text-decoration: none;
}

.dataon-openapi-copy small {
  color: #6B7C93;
  font-size: 13px;
  font-weight: 800;
}

.dataon-openapi-copy p {
  font-size: 14px;
}

.dataon-openapi-copy ul {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin: 0;
  padding: 0;
}

.dataon-openapi-copy li {
  color: #4B5B73;
  font-size: 13px;
  font-weight: 800;
}

.dataon-community-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border: 1px solid #D8E1EC;
}

.dataon-community-tabs button {
  min-height: 52px;
  color: #53647A;
  font-size: 15px;
  font-weight: 900;
  background: #FFFFFF;
}

.dataon-community-tabs button + button {
  border-left: 1px solid #D8E1EC;
}

.dataon-community-tabs button.is-active {
  color: #FFFFFF;
  background: #0067D6;
}

.dataon-community-empty-card {
  display: grid;
  width: min(100%, 360px);
  min-height: 160px;
  align-content: center;
  gap: 18px;
  padding: 28px;
  color: #6B7C93;
  border: 1px solid #DDE6F1;
  border-radius: 4px;
  background: #F8FAFD;
}

.dataon-community-empty-card .small {
  font-size: 14px;
  font-weight: 800;
}

.dataon-community-toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 14px;
  align-items: center;
}

.dataon-community-search {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr) 86px;
  gap: 8px;
}

.dataon-community-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.dataon-community-card {
  display: grid;
  min-height: 230px;
  align-content: start;
  gap: 12px;
  padding: 22px;
  border: 1px solid #DDE6F1;
  border-radius: 4px;
  background: #FFFFFF;
}

.dataon-community-card h3 {
  font-size: 18px;
}

.dataon-community-card p {
  font-size: 14px;
}

.dataon-community-meta {
  display: grid;
  gap: 5px;
  margin-top: auto;
  color: #53647A;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.5;
}

.dataon-community-card button {
  justify-self: start;
  margin-top: 4px;
}

.dataon-service-table {
  width: 100%;
  overflow-x: auto;
}

.dataon-service-table table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
  border-top: 2px solid #0B1733;
}

.dataon-service-table caption {
  overflow: hidden;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  clip: rect(0, 0, 0, 0);
}

.dataon-service-table th,
.dataon-service-table td {
  padding: 15px 14px;
  color: #26364D;
  font-size: 15px;
  line-height: 1.6;
  text-align: left;
  border: 1px solid #DDE6F1;
}

.dataon-service-table th {
  color: #111827;
  font-weight: 900;
  background: #F1F5FA;
}

.dataon-xml-error,
.dataon-code-wrap pre {
  margin: 0;
  padding: 18px;
  overflow-x: auto;
  color: #E6EDF5;
  font-size: 13px;
  line-height: 1.55;
  border-radius: 6px;
  background: #101827;
}

.dataon-code-example {
  display: grid;
  gap: 16px;
  margin-top: 4px;
  padding: 20px;
  border: 1px dashed #C8D3E0;
  border-radius: 6px;
  background: #FAFCFF;
}

.dataon-code-example > p {
  color: #111827;
  font-weight: 900;
}

.dataon-code-wrap {
  position: relative;
}

.dataon-code-wrap span {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  padding: 3px 10px;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 800;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
}

.dataon-highlight {
  display: inline-block;
  padding: 1px 6px;
  color: #0B1733;
  border-radius: 5px;
  background: #FFF34D;
}

.mt15 {
  margin-top: 15px !important;
}

@media (max-width: 1024px) {
  .dataon-service-page-layout {
    grid-template-columns: 1fr;
  }
  .dataon-service-side {
    position: static;
  }
  .dataon-service-overview-grid,
  .dataon-login-required-grid,
  .dataon-form-grid,
  .dataon-community-toolbar {
    grid-template-columns: 1fr;
  }
  .dataon-community-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 720px) {
  .dataon-service-page-body {
    padding: 36px 0 52px;
  }
  .dataon-service-head {
    grid-template-columns: 1fr;
  }
  .dataon-service-head h2 {
    font-size: 28px;
  }
  .dataon-service-panel {
    padding: 22px 18px;
  }
  .dataon-service-state-table div {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  .dataon-narda-link-grid {
    grid-template-columns: 1fr;
  }
  .dataon-form-inline,
  .dataon-form-inline.is-phone,
  .dataon-community-search,
  .dataon-openapi-item,
  .dataon-community-grid {
    grid-template-columns: 1fr;
  }
  .dataon-board-list {
    overflow-x: auto;
  }
  .dataon-board-row {
    min-width: 760px;
  }
  .dataon-community-tabs {
    grid-template-columns: 1fr;
  }
  .dataon-community-tabs button + button {
    border-top: 1px solid #D8E1EC;
    border-left: 0;
  }
}
.dataon-footer {
  flex-shrink: 0;
  color: #C9D3E6;
  background: #06153A;
}

.dataon-footer-wrap {
  display: grid;
  gap: 24px;
  padding-top: 40px;
  padding-bottom: 40px;
}

.dataon-footer-logo {
  min-width: 0;
}

.dataon-footer-logo img {
  display: block;
  width: 213px;
  max-width: 100%;
  height: auto;
}

.dataon-footer-content {
  display: grid;
  gap: 22px;
  min-width: 0;
}

.dataon-footer-info {
  min-width: 0;
}

.dataon-footer-policy {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 0;
  margin-bottom: 14px;
}

.dataon-footer-policy a {
  position: relative;
  flex: 0 0 auto;
  margin-right: 14px;
  padding-right: 14px;
  color: #DCE6F6;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.7;
  text-decoration: none;
}

.dataon-footer-policy a:nth-child(2) {
  color: #81E7FF;
}

.dataon-footer-policy a:not(:last-child)::after {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.32);
  content: "";
  transform: translateY(-50%);
}

.dataon-footer-policy a:hover {
  color: #FFFFFF;
}

.dataon-footer-address {
  display: flex;
  flex-wrap: wrap;
  gap: 0 4px;
  margin: 0;
  color: #AEBAD1;
  font-size: 14px;
  font-style: normal;
  line-height: 1.7;
}

.dataon-footer-copy {
  margin: 0;
  color: #AEBAD1;
  font-size: 14px;
  line-height: 1.7;
}

.dataon-footer-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.dataon-footer-badges a {
  display: inline-flex;
  flex: 0 1 auto;
}

.dataon-footer-badges img {
  display: block;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

.dataon-footer-badges a img {
  height: 48px;
}

.dataon-footer-badges > img {
  height: 64px;
}

@media (max-width: 560px) {
  .dataon-search-block .dataon-advanced-search-panel {
    top: 70px;
  }
  .dataon-results-search-block .dataon-advanced-search-panel {
    top: 62px;
  }
  .dataon-search-primary-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .dataon-search-shell {
    grid-template-columns: minmax(0, 1fr) 46px 46px;
    border-radius: 16px;
  }
  .dataon-search-scope-select {
    height: 60px;
    padding: 0 10px;
    font-size: 13px;
  }
  .dataon-search-input {
    height: 60px;
    padding: 0 10px;
    font-size: 15px;
  }
  .dataon-search-help-toggle {
    right: 110px;
    width: 34px;
    height: 34px;
  }
  .dataon-search-detail-toggle {
    width: 46px;
    min-width: 46px;
    height: 60px;
    padding: 0;
  }
  .dataon-search-detail-toggle span {
    display: none;
  }
  .dataon-search-button {
    width: 46px;
    min-width: 46px;
    height: 60px;
    padding: 0;
    border-radius: 0;
  }
  .dataon-search-button span {
    display: none;
  }
  .dataon-search-help-popover {
    right: auto;
    left: 0;
    width: min(100%, 100vw - 48px);
    max-height: min(500px, 100vh - 150px);
  }
  .dataon-search-help-popover::before {
    right: 124px;
  }
  .dataon-search-type-list {
    grid-template-columns: 1fr;
  }
  .dataon-search-operator-list li {
    grid-template-columns: 72px minmax(0, 1fr);
  }
  .dataon-search-assist {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
  }
  .dataon-search-assist::-webkit-scrollbar {
    display: none;
  }
  .dataon-search-assist-button {
    flex: 0 0 auto;
  }
  .dataon-chip-row {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    gap: 8px;
  }
  .dataon-map-quick-button {
    width: 100%;
    height: 52px;
  }
  .dataon-advanced-search-panel {
    padding: 0;
  }
  .dataon-advanced-grid,
  .dataon-advanced-project-grid,
  .dataon-advanced-year-range {
    grid-template-columns: 1fr;
  }
  .dataon-advanced-actions {
    justify-content: stretch;
  }
  .dataon-advanced-button-row button {
    flex: 1 1 0;
  }
  .dataon-chip-label {
    font-size: 12px;
  }
  .dataon-chip {
    height: 26px;
    padding: 0 9px;
    font-size: 11px;
  }
}
@media (min-width: 480px) {
  .dataon-field-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 640px) {
  .dataon-hero-title {
    font-size: 40px;
  }
}
@media (min-width: 768px) {
  .dataon-sitemap-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataon-service-grid,
  .dataon-content-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataon-bottom-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .dataon-footer-wrap {
    grid-template-columns: 213px minmax(0, 1fr);
    gap: 56px;
    align-items: start;
  }
  .dataon-footer-content {
    grid-template-columns: minmax(0, 1fr) minmax(190px, 0.4fr);
    align-items: start;
  }
  .dataon-footer-badges {
    justify-content: flex-end;
  }
  .dataon-bottom-link {
    border-left: 1px solid rgba(255, 255, 255, 0.1);
  }
  .dataon-bottom-link:first-child {
    border-left: 0;
  }
}
@media (min-width: 1025px) {
  .dataon-container,
  .dataon-service-grid,
  .dataon-content-grid,
  .dataon-bottom-grid,
  .dataon-sitemap-grid,
  .dataon-footer-wrap {
    padding-right: 40px;
    padding-left: 40px;
  }
  .dataon-auth-body {
    padding-right: 40px;
    padding-left: 40px;
  }
  .dataon-auth {
    display: flex;
  }
  .dataon-nav {
    display: flex;
    flex: 1 1 auto;
  }
  .dataon-mobile-button {
    display: none;
  }
  .dataon-sitemap-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: clamp(22px, 2.1vw, 38px);
  }
  .dataon-hero-grid {
    grid-template-columns: minmax(0, 1fr);
    justify-items: center;
  }
  .dataon-hero-title {
    font-size: 44px;
  }
  .dataon-hero-description {
    font-size: 18px;
  }
  .dataon-search-input {
    font-size: 17px;
  }
}
@media (min-width: 1200px) {
  .dataon-sitemap-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .dataon-content-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataon-field-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .dataon-footer-wrap {
    grid-template-columns: 20% minmax(0, 1fr);
  }
}
@media (min-width: 1280px) {
  .dataon-service-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 1024px) {
  .dataon-header {
    z-index: 2000;
  }
  .dataon-sitemap {
    position: fixed;
    inset: 0;
    z-index: 2100;
    overflow-y: auto;
    border-top: 0;
    box-shadow: none;
    animation: dataon-menu-fade 180ms ease both;
  }
  .dataon-menu-head {
    display: block;
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .dataon-sitemap-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 28px;
    padding-top: 42px;
    padding-bottom: 92px;
  }
  .dataon-sitemap-group {
    align-content: start;
    gap: 22px;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }
  .dataon-sitemap-title {
    display: inline-flex;
    width: 100%;
    min-height: 70px;
    align-items: center;
    margin-bottom: 0;
    padding: 0 0 17px;
    color: #252A33;
    font-size: 36px;
    font-weight: 1000;
    line-height: 1.1;
    text-shadow: 0.4px 0 0 currentColor;
    -webkit-text-stroke: 0.16px currentColor;
    border-bottom: 0;
    border-radius: 0;
  }
  .dataon-sitemap-title::after {
    background: #252A33;
  }
  .dataon-sitemap-section-list {
    gap: 24px;
  }
  .dataon-sitemap-section {
    gap: 9px;
  }
  .dataon-sitemap-section-title {
    min-height: 30px;
    font-size: 18px;
    font-weight: 900;
  }
  .dataon-sitemap-link {
    min-height: 29px;
    padding: 0;
    color: #7A7F88;
    font-size: 15px;
    font-weight: 700;
    border-radius: 0;
    white-space: normal;
  }
  .dataon-sitemap-link:hover {
    color: #0B1733;
  }
  .dataon-menu-head-inner {
    min-height: 88px;
  }
}
@media (max-width: 760px) {
  .dataon-sitemap-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .dataon-menu-head-inner {
    min-height: 78px;
    align-items: flex-start;
    flex-wrap: wrap;
    padding-top: 16px;
    padding-right: 58px;
    padding-bottom: 14px;
  }
  .dataon-menu-logo-button img {
    width: 116px;
  }
  .dataon-menu-mobile-auth {
    display: flex;
    justify-content: flex-start;
    flex: 1 1 160px;
  }
  .dataon-menu-close {
    position: absolute;
    top: 12px;
    right: 14px;
    width: 42px;
    height: 42px;
    font-size: 25px;
  }
  .dataon-sitemap-grid {
    display: none;
  }
  .dataon-mobile-menu-panel {
    display: grid;
    grid-template-columns: minmax(118px, 0.44fr) minmax(0, 0.56fr);
    gap: 18px;
    min-height: calc(100vh - 78px);
    padding-top: 22px;
    padding-bottom: 42px;
  }
  .dataon-mobile-major-menu,
  .dataon-mobile-minor-menu {
    display: grid;
    align-content: start;
    gap: 8px;
    min-width: 0;
  }
  .dataon-mobile-major-menu button {
    min-height: 48px;
    padding: 0 12px;
    color: #4B5B73;
    font-size: 28px;
    font-weight: 1000;
    text-shadow: 0.35px 0 0 currentColor;
    -webkit-text-stroke: 0.14px currentColor;
    text-align: left;
    border-radius: 6px;
    background: transparent;
    transition: color 160ms ease, background 160ms ease, transform 160ms ease;
  }
  .dataon-mobile-major-menu button.is-active {
    color: #0B1733;
    background: #F0F5FB;
    transform: translateX(4px);
  }
  .dataon-mobile-minor-title {
    min-height: 42px;
    margin-bottom: 8px;
    color: #0B1733;
    font-size: 17px;
    font-weight: 900;
    text-align: left;
    border-bottom: 1px solid #0B1733;
    background: transparent;
  }
  .dataon-mobile-minor-section {
    display: grid;
    gap: 6px;
    min-width: 0;
  }
  .dataon-mobile-minor-section + .dataon-mobile-minor-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #E6EDF5;
  }
  .dataon-mobile-section-title {
    min-height: 34px;
    color: #252A33;
    font-size: 17px;
    font-weight: 900;
    text-align: left;
    background: transparent;
  }
  .dataon-mobile-minor-link {
    min-height: 37px;
    padding: 0;
    color: #6A7280;
    font-size: 15px;
    font-weight: 700;
    text-align: left;
    background: transparent;
    transition: color 160ms ease, transform 160ms ease;
  }
  .dataon-mobile-minor-link:hover {
    color: #0067D6;
    transform: translateX(3px);
  }
  .dataon-mobile-section-title:hover,
  .dataon-mobile-section-title:focus-visible {
    color: #0067D6;
  }
}
@media (max-width: 1180px) {
  .dataon-kg-layout,
  .dataon-kg-layout.is-fullscreen {
    grid-template-columns: 1fr;
  }
  .dataon-kg-detail {
    position: static;
  }
}
@media (max-width: 860px) {
  .dataon-kg-topbar {
    align-items: stretch;
    flex-direction: column;
  }
  .dataon-kg-tools {
    justify-content: flex-start;
  }
  .dataon-kg-canvas {
    min-height: 540px;
  }
  .dataon-kg-svg {
    min-width: 760px;
    height: 560px;
  }
}
@media (max-width: 560px) {
  .dataon-kg-layout.is-fullscreen {
    inset: 8px;
    padding: 10px;
  }
  .dataon-kg-main,
  .dataon-kg-detail {
    padding: 12px;
  }
  .dataon-kg-detail-grid div,
  .dataon-kg-meta-box dl div,
  .dataon-kg-relation-box dl div,
  .dataon-kg-relation-box button {
    grid-template-columns: 1fr;
  }
}
@keyframes dataon-menu-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.dataon-auth-section > .dataon-auth-center {
  max-width: none;
  padding-right: 0;
  padding-left: 0;
}

.dataon-login-panel .dataon-kafe-login-button {
  width: 240px;
  min-height: 48px;
  padding: 5px 16px;
}

.dataon-login-panel .dataon-kafe-login-button img {
  width: 142px;
}

.dataon-auth-form .dataon-check-label input[type=checkbox],
.dataon-save-id-label input[type=checkbox] {
  inline-size: 24px;
  block-size: 24px;
  width: 24px;
  min-width: 24px;
  max-width: 24px;
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  flex: 0 0 24px;
  padding: 0;
  border-radius: 7px;
}

.dataon-header .dataon-sitemap-toggle:not(:hover):not(:focus-visible),
.dataon-header .dataon-mobile-button:not(:hover):not(:focus-visible) {
  border-color: #AFC0D4;
}

.dataon-map-search-page {
  flex: 1 0 auto;
  background: #F3F6FA;
}

.dataon-map-search-visual {
  color: #FFFFFF;
  background: #062A5F;
}

.dataon-map-search-visual-inner {
  display: grid;
  gap: 12px;
  padding-top: 20px;
  padding-bottom: 22px;
}

.dataon-map-search-visual .dataon-results-breadcrumb {
  justify-self: start;
  color: rgba(255, 255, 255, 0.66);
  font-size: 13px;
  font-weight: 650;
}

.dataon-map-search-visual .dataon-results-breadcrumb button,
.dataon-map-search-visual .dataon-results-breadcrumb span,
.dataon-map-search-visual .dataon-results-breadcrumb i {
  color: inherit;
}

.dataon-map-search-title-row {
  display: grid;
  justify-items: center;
  gap: 6px;
  text-align: center;
}

.dataon-map-search-title-row h1 {
  margin: 0;
  font-size: clamp(30px, 3vw, 40px);
  font-weight: 920;
  line-height: 1.08;
}

.dataon-map-search-title-row p {
  max-width: 620px;
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 15px;
  font-weight: 650;
  line-height: 1.55;
}

.dataon-map-search-body {
  padding: 18px 0 44px;
}

.dataon-map-search-workspace {
  display: grid;
  gap: 12px;
  max-width: 1440px;
}

.dataon-map-integrated-panel {
  display: grid;
  gap: 12px;
  padding: 16px;
  border: 1px solid #DDE7F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 14px 30px rgba(6, 42, 95, 0.06);
}

.dataon-map-search-row {
  display: grid;
  grid-template-columns: minmax(420px, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.dataon-map-search-layout {
  display: grid;
  grid-template-columns: minmax(0, 65fr) minmax(440px, 35fr);
  align-items: stretch;
  gap: 18px;
  max-width: 1440px;
}

.dataon-map-panel,
.dataon-map-result-panel {
  min-width: 0;
}

.dataon-map-panel {
  overflow: hidden;
  border: 1px solid #DDE7F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 18px 42px rgba(6, 42, 95, 0.08);
  height: 650px;
}

.dataon-map-region-form {
  min-width: 0;
}

.dataon-map-region-input {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr) auto;
  align-items: center;
  min-height: 46px;
  gap: 10px;
  padding: 0 6px 0 14px;
  border: 1px solid #C9D8EA;
  border-radius: 8px;
  background: #F8FBFE;
}

.dataon-map-region-input i {
  color: #0067D6;
}

.dataon-map-region-input input {
  width: 100%;
  min-width: 0;
  border: 0;
  color: #13233A;
  font: inherit;
  font-size: 15px;
  font-weight: 700;
  outline: 0;
  background: transparent;
}

.dataon-map-region-input button,
.dataon-map-tool-buttons button,
.dataon-map-control-stack button,
.dataon-map-reset-button,
.dataon-map-state button,
.dataon-map-detail-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 0 13px;
  border-radius: 7px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 850;
  background: #0067D6;
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.dataon-map-region-input button:hover,
.dataon-map-region-input button:focus-visible,
.dataon-map-tool-buttons button:hover,
.dataon-map-tool-buttons button:focus-visible,
.dataon-map-control-stack button:hover,
.dataon-map-control-stack button:focus-visible,
.dataon-map-reset-button:hover,
.dataon-map-reset-button:focus-visible,
.dataon-map-state button:hover,
.dataon-map-state button:focus-visible,
.dataon-map-detail-button:hover,
.dataon-map-detail-button:focus-visible {
  background: #0057B8;
  box-shadow: 0 10px 20px rgba(0, 103, 214, 0.18);
  transform: translateY(-1px);
}

.dataon-map-tool-buttons {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

.dataon-map-tool-buttons button {
  min-width: 98px;
  padding: 0 14px;
  color: #0067D6;
  border: 1px solid #BFD8F5;
  background: #FFFFFF;
}

.dataon-map-tool-buttons button:hover,
.dataon-map-tool-buttons button:focus-visible {
  color: #0067D6;
  background: #F4FAFF;
}

.dataon-map-tool-buttons button:disabled {
  color: #8A98AA;
  border-color: #E1E8F0;
  background: #F4F7FA;
  box-shadow: none;
  cursor: wait;
  transform: none;
}

.dataon-map-tool-buttons button.is-location-active {
  color: #0A7B6F;
  border-color: #A7D8D2;
  background: #ECFAF8;
}

.dataon-map-filter-row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid #E6EDF5;
}

.dataon-map-filter-fields {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.dataon-map-reset-button {
  flex: 0 0 auto;
  min-height: 38px;
  color: #0067D6;
  border: 1px solid #CBE0F7;
  background: #F4FAFF;
}

.dataon-map-reset-button:hover,
.dataon-map-reset-button:focus-visible {
  color: #0057B8;
  background: #EAF4FF;
}

.dataon-map-reset-button:disabled {
  color: #A4AFBD;
  border-color: #E1E8F0;
  background: #F7F9FC;
  box-shadow: none;
  cursor: default;
  transform: none;
}

.dataon-map-inline-error {
  margin: 0;
  padding: 10px 14px;
  color: #B42318;
  font-size: 13px;
  font-weight: 800;
  border: 1px solid #F6D7D4;
  border-radius: 8px;
  background: #FFF4F2;
}

.dataon-map-inline-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 10px 14px;
  color: #0B5F57;
  font-size: 13px;
  font-weight: 800;
  border: 1px solid #C9ECE8;
  border-radius: 8px;
  background: #F0FBFA;
}

.dataon-map-inline-status.is-error {
  color: #B42318;
  border-bottom-color: #F6D7D4;
  background: #FFF4F2;
}

.dataon-map-canvas {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: #DCE8F4;
}

.dataon-map-control-stack {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 7;
  display: grid;
  overflow: hidden;
  border: 1px solid rgba(19, 35, 58, 0.14);
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 10px 22px rgba(6, 42, 95, 0.16);
}

.dataon-map-control-stack button {
  width: 40px;
  min-height: 40px;
  padding: 0;
  color: #17314F;
  border: 0;
  border-bottom: 1px solid #E4ECF5;
  border-radius: 0;
  background: #FFFFFF;
}

.dataon-map-control-stack button:last-child {
  border-bottom: 0;
}

.dataon-map-control-stack button:hover,
.dataon-map-control-stack button:focus-visible {
  color: #0067D6;
  background: #F4FAFF;
}

.dataon-map-canvas.is-fallback {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.72) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.72) 1px, transparent 1px), #DCE8F4;
  background-size: 42px 42px;
}

.dataon-map-fallback {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.dataon-map-fallback-grid {
  position: absolute;
  inset: 6%;
  border: 1px solid rgba(6, 42, 95, 0.14);
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(0, 103, 214, 0.08), transparent 42%), linear-gradient(315deg, rgba(10, 123, 111, 0.12), transparent 46%);
}

.dataon-map-fallback-marker {
  position: absolute;
  z-index: 3;
  display: inline-flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #FFFFFF;
  border: 3px solid #FFFFFF;
  border-radius: 50%;
  background: #0067D6;
  box-shadow: 0 12px 24px rgba(6, 42, 95, 0.24);
  transform: translate(-50%, -50%);
}

.dataon-map-fallback-marker span {
  font-size: 12px;
  font-weight: 900;
}

.dataon-map-fallback-marker.is-selected {
  width: 54px;
  height: 54px;
  background: #0067D6;
  box-shadow: 0 0 0 7px rgba(0, 103, 214, 0.18), 0 16px 32px rgba(0, 64, 128, 0.26);
}

.dataon-map-user-marker {
  position: absolute;
  z-index: 5;
  width: 18px;
  height: 18px;
  border: 4px solid #FFFFFF;
  border-radius: 50%;
  background: #0A7B6F;
  box-shadow: 0 0 0 9px rgba(10, 123, 111, 0.18), 0 10px 22px rgba(6, 42, 95, 0.24);
  transform: translate(-50%, -50%);
}

.dataon-map-user-marker::after {
  position: absolute;
  inset: -14px;
  border: 1px solid rgba(10, 123, 111, 0.42);
  border-radius: 50%;
  content: "";
}

.dataon-map-fallback-message {
  position: absolute;
  right: 18px;
  bottom: 18px;
  z-index: 4;
  display: inline-flex;
  max-width: min(420px, 100% - 36px);
  align-items: center;
  gap: 9px;
  padding: 12px 14px;
  color: #17314F;
  border: 1px solid #D5E2F0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 10px 22px rgba(6, 42, 95, 0.12);
  font-size: 13px;
  font-weight: 800;
}

.dataon-map-fallback-message i {
  color: #0A7B6F;
}

.dataon-map-result-panel {
  display: flex;
  min-height: 0;
  height: 650px;
  flex-direction: column;
}

.dataon-map-result-section,
.dataon-map-state,
.dataon-map-result-card {
  border: 1px solid #DDE7F2;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 14px 28px rgba(6, 42, 95, 0.06);
}

.dataon-map-select-field {
  display: grid;
  flex: 1 1 220px;
  gap: 5px;
  min-width: 0;
}

.dataon-map-select-field span {
  color: #435169;
  font-size: 12px;
  font-weight: 850;
}

.dataon-map-select-field select {
  width: 100%;
  min-height: 38px;
  padding: 0 30px 0 10px;
  color: #13233A;
  border: 1px solid #CEDBEA;
  border-radius: 7px;
  background: #FFFFFF;
  font: inherit;
  font-size: 13px;
  font-weight: 750;
}

.dataon-map-result-section {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}

.dataon-map-result-head {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px 12px;
  border-bottom: 1px solid #E6EDF5;
}

.dataon-map-result-head h2 {
  min-width: 0;
  margin: 0;
  color: #13233A;
  font-size: 17px;
  font-weight: 920;
  line-height: 1.25;
}

.dataon-map-sort-field {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  color: #66758B;
  font-size: 12px;
  font-weight: 850;
}

.dataon-map-sort-field select {
  min-height: 34px;
  padding: 0 28px 0 10px;
  color: #13233A;
  border: 1px solid #CEDBEA;
  border-radius: 7px;
  background: #FFFFFF;
  font: inherit;
  font-size: 12px;
  font-weight: 800;
}

.dataon-map-result-list {
  display: grid;
  flex: 1 1 auto;
  min-height: 0;
  gap: 10px;
  overflow: auto;
  padding: 12px 14px 14px;
}

.dataon-map-result-card {
  display: grid;
  overflow: hidden;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.dataon-map-result-card.is-selected {
  border-color: #0067D6;
  background: #F4FAFF;
  box-shadow: 0 14px 28px rgba(0, 103, 214, 0.14);
}

.dataon-map-result-main {
  display: grid;
  width: 100%;
  gap: 10px;
  padding: 16px;
  color: inherit;
  text-align: left;
  background: transparent;
}

.dataon-map-result-main:hover,
.dataon-map-result-main:focus-visible {
  background: #F8FBFE;
}

.dataon-map-result-bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
}

.dataon-map-result-bottom span {
  display: inline-flex;
  min-height: 23px;
  align-items: center;
  padding: 0 8px;
  color: #0067D6;
  border-radius: 999px;
  background: #EAF4FF;
  font-size: 11px;
  font-weight: 900;
}

.dataon-map-result-bottom em {
  color: #66758B;
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
}

.dataon-map-result-main h3 {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: #13233A;
  font-size: 16px;
  font-weight: 920;
  line-height: 1.4;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dataon-map-result-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  color: #4B5B73;
  font-size: 12px;
  font-weight: 750;
}

.dataon-map-result-meta span {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  gap: 5px;
}

.dataon-map-result-meta i {
  color: #0067D6;
  font-size: 11px;
}

.dataon-map-detail-button {
  width: calc(100% - 28px);
  min-height: 34px;
  margin: 0 14px 14px;
}

.dataon-map-state {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;
  gap: 10px;
  margin: 12px;
  padding: 36px 22px;
  color: #4B5B73;
  text-align: center;
}

.dataon-map-state > i {
  color: #0067D6;
  font-size: 34px;
}

.dataon-map-state.is-error > i {
  color: #B42318;
}

.dataon-map-state h2 {
  margin: 0;
  color: #13233A;
  font-size: 20px;
  font-weight: 920;
}

.dataon-map-state p {
  max-width: 300px;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
}

.dataon-map-state-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

:host ::ng-deep .dataon-map-info-window {
  display: grid;
  min-width: 230px;
  gap: 5px;
  padding: 13px 14px;
  color: #13233A;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

:host ::ng-deep .dataon-map-info-window strong {
  font-size: 14px;
  font-weight: 900;
  line-height: 1.35;
}

:host ::ng-deep .dataon-map-info-window span,
:host ::ng-deep .dataon-map-info-window em {
  color: #4B5B73;
  font-size: 12px;
  font-style: normal;
  font-weight: 750;
}

:host ::ng-deep .dataon-map-info-window a {
  display: inline-flex;
  width: max-content;
  min-height: 28px;
  align-items: center;
  margin-top: 4px;
  padding: 0 10px;
  color: #FFFFFF;
  border-radius: 6px;
  background: #0067D6;
  font-size: 12px;
  font-weight: 850;
  text-decoration: none;
}

@media (max-width: 1180px) {
  .dataon-map-search-layout {
    grid-template-columns: 1fr;
  }
  .dataon-map-search-row {
    grid-template-columns: 1fr;
  }
  .dataon-map-tool-buttons {
    justify-content: flex-start;
  }
  .dataon-map-panel,
  .dataon-map-result-panel {
    height: 620px;
  }
}
@media (max-width: 760px) {
  .dataon-map-tool-buttons {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }
  .dataon-map-tool-buttons button {
    width: 100%;
    min-width: 0;
    padding: 0 8px;
  }
  .dataon-map-filter-row {
    align-items: stretch;
    flex-direction: column;
  }
  .dataon-map-reset-button {
    width: 100%;
  }
  .dataon-map-panel,
  .dataon-map-result-panel {
    height: 580px;
  }
}
@media (max-width: 520px) {
  .dataon-map-search-visual-inner,
  .dataon-map-search-workspace,
  .dataon-map-search-layout {
    padding-right: 16px;
    padding-left: 16px;
  }
  .dataon-map-region-input {
    grid-template-columns: 20px minmax(0, 1fr);
    padding: 0 12px;
  }
  .dataon-map-region-input button {
    grid-column: 1/-1;
    width: 100%;
    margin-bottom: 10px;
  }
  .dataon-map-panel,
  .dataon-map-result-panel {
    height: 540px;
  }
  .dataon-map-fallback-message {
    right: 12px;
    bottom: 12px;
    max-width: calc(100% - 24px);
  }
}
/* DataON main clone */
.dataon-page {
  background: #F5F7FA;
}

.dataon-hero {
  min-height: 640px;
  height: auto;
  overflow: hidden;
  background: #07163C;
}

.dataon-hero-backdrop {
  background-color: #07163C;
  background-image: linear-gradient(90deg, rgba(2, 16, 45, 0.96) 0%, rgba(7, 28, 73, 0.74) 45%, rgba(4, 22, 58, 0.18) 100%), linear-gradient(180deg, rgba(0, 7, 24, 0.16) 0%, rgba(0, 7, 24, 0.78) 100%), url("/assets/dataon/main_bg.png");
  background-position: center center, center center, center center;
  background-size: cover, cover, cover;
}

.dataon-hero-grid {
  min-height: 640px;
  align-content: center;
  align-items: center;
  padding-top: 38px;
  padding-bottom: 120px;
}

.dataon-hero-shortcuts {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.dataon-hero-shortcuts button,
.dataon-search-action-row button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 16px;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 999px;
  background: rgba(4, 20, 55, 0.42);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.14);
  backdrop-filter: blur(8px);
  font-size: 14px;
  font-weight: 800;
  transition: border-color 160ms ease, background 160ms ease;
}

.dataon-hero-shortcuts button:hover,
.dataon-hero-shortcuts button:focus-visible,
.dataon-search-action-row button:hover,
.dataon-search-action-row button:focus-visible,
.dataon-search-action-row button.is-active {
  border-color: rgba(111, 213, 255, 0.78);
  background: rgba(0, 103, 214, 0.52);
}

.dataon-hero-shortcuts img,
.dataon-search-action-row img {
  width: 21px;
  height: 21px;
  object-fit: contain;
}

.dataon-hero-copy {
  max-width: 900px;
  margin-top: 18px;
}

.dataon-hero-title {
  color: #FFFFFF;
  font-size: clamp(38px, 4vw, 58px);
  font-weight: 700;
  line-height: 1.24;
  text-shadow: 0 10px 28px rgba(0, 0, 0, 0.24);
}

.dataon-hero-title strong {
  color: #58D5FF;
  font-weight: 900;
}

.dataon-hero-description {
  margin-top: 18px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 18px;
  font-weight: 600;
}

.dataon-search-block {
  max-width: 850px;
  margin-top: 26px;
}

.dataon-search-shell {
  grid-template-columns: minmax(0, 1fr) 128px 86px;
  border-radius: 999px;
  outline: 0;
  box-shadow: 0 20px 48px rgba(0, 16, 50, 0.42);
}

.dataon-search-input,
.dataon-search-detail-toggle,
.dataon-search-button {
  height: 64px;
}

.dataon-search-input {
  border-radius: 999px 0 0 999px;
}

.dataon-search-button {
  min-width: 86px;
  border-radius: 0 999px 999px 0;
  background: #0B77E3;
}

.dataon-search-detail-toggle {
  min-width: 128px;
  padding: 0 14px;
  color: #0057B8;
  border-left: 1px solid #D9E7F5;
  background: #F2F8FF;
  box-shadow: none;
}

.dataon-search-button span {
  display: none;
}

.dataon-search-action-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}

.dataon-chip-row {
  justify-content: center;
  max-width: 760px;
  margin-right: auto;
  margin-left: auto;
}

.dataon-chip-track {
  width: auto;
  animation: none;
}

.dataon-chip-group[aria-hidden=true] {
  display: none;
}

.dataon-search-help-popover {
  left: 50%;
  right: auto;
  width: min(620px, 100vw - 48px);
  transform: translateX(-50%);
}

.dataon-search-help-popover::before {
  right: 50%;
  transform: translateX(50%) rotate(45deg);
}

.dataon-search-help-table {
  width: 100%;
  border-collapse: collapse;
  color: #2C3E59;
  font-size: 13px;
  line-height: 1.45;
}

.dataon-search-help-table th,
.dataon-search-help-table td {
  padding: 10px 12px;
  border: 1px solid #D8E2EF;
  text-align: center;
  vertical-align: middle;
}

.dataon-search-help-table th {
  color: #0D285E;
  background: #F2F7FC;
  font-weight: 900;
}

.dataon-search-help-table td:nth-child(2) {
  text-align: left;
}

.dataon-hero-stats {
  position: absolute;
  right: 24px;
  bottom: 0;
  left: 24px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: min(720px, 100% - 48px);
  margin: 0 auto;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -12px 34px rgba(0, 18, 58, 0.26);
}

.dataon-hero-stats button {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  min-height: 92px;
  padding: 18px 24px;
  color: #12213B;
  text-align: left;
  background: transparent;
}

.dataon-hero-stats button + button {
  border-left: 1px solid #DDE7F3;
}

.dataon-hero-stats img {
  width: 46px;
  height: 46px;
  object-fit: contain;
}

.dataon-hero-stats span {
  color: #44536A;
  font-size: 15px;
  font-weight: 800;
}

.dataon-hero-stats strong {
  color: #0B77E3;
  font-size: 30px;
  font-weight: 950;
  line-height: 1;
  white-space: nowrap;
}

.dataon-hero-stats em,
.dataon-hero-stats small {
  color: #66748A;
  font-style: normal;
  font-size: 15px;
  font-weight: 850;
  white-space: nowrap;
}

.dataon-floating-quick {
  position: fixed;
  z-index: 1200;
  top: 210px;
  right: 24px;
  display: grid;
  width: 96px;
  overflow: hidden;
  border: 1px solid #DDE7F3;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 14px 34px rgba(5, 35, 82, 0.18);
}

.dataon-floating-quick strong {
  display: grid;
  gap: 2px;
  padding: 12px 8px;
  color: #FFFFFF;
  text-align: center;
  background: #0A2A64;
  font-size: 14px;
  font-weight: 950;
  line-height: 1.1;
}

.dataon-floating-quick strong span {
  color: #7BE1FF;
  font-size: 12px;
}

.dataon-floating-quick button {
  display: grid;
  justify-items: center;
  gap: 5px;
  min-height: 70px;
  padding: 10px 8px;
  color: #24354F;
  border-bottom: 1px solid #EEF2F7;
  background: #FFFFFF;
  font-size: 12px;
  font-weight: 850;
  line-height: 1.24;
}

.dataon-floating-quick button:hover {
  color: #0B77E3;
  background: #F4FAFF;
}

.dataon-floating-quick img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.dataon-floating-quick .dataon-floating-top {
  min-height: 42px;
  color: #FFFFFF;
  border-bottom: 0;
  background: #0B77E3;
}

.dataon-provider-section,
.dataon-tech-section,
.dataon-board-section {
  padding: 76px 0;
}

.dataon-provider-section {
  background: #FFFFFF;
}

.dataon-tech-section {
  background: #F5F8FC;
}

.dataon-board-section {
  padding-top: 34px;
  background: #F5F8FC;
}

.dataon-section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;
}

.dataon-section-head h2,
.dataon-board-head h2 {
  margin: 0;
  color: #13223B;
  font-size: 30px;
  font-weight: 950;
  line-height: 1.25;
}

.dataon-section-head p {
  max-width: 520px;
  margin: 0;
  color: #66748A;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.6;
  text-align: right;
}

.dataon-home-tab-row,
.dataon-board-tabs {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border: 1px solid #DDE7F3;
  border-radius: 999px;
  background: #FFFFFF;
}

.dataon-home-tab-row {
  margin-bottom: 20px;
}

.dataon-home-tab-row button,
.dataon-board-tabs button {
  min-height: 38px;
  padding: 0 18px;
  color: #607089;
  border-radius: 999px;
  background: transparent;
  font-size: 14px;
  font-weight: 900;
}

.dataon-home-tab-row button.is-active,
.dataon-board-tabs button.is-active {
  color: #FFFFFF;
  background: #0B77E3;
}

.dataon-provider-layout {
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  gap: 24px;
}

.dataon-provider-carousel,
.dataon-tech-carousel {
  position: relative;
}

.dataon-provider-arrow,
.dataon-tech-arrow {
  position: absolute;
  z-index: 2;
  display: inline-grid;
  place-items: center;
  color: #0B77E3;
  border: 1px solid #D8E5F2;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0 8px 18px rgba(8, 38, 84, 0.12);
  font-size: 15px;
  transition: border-color 160ms ease, color 160ms ease;
}

.dataon-provider-arrow {
  top: -58px;
  width: 42px;
  height: 42px;
}

.dataon-provider-arrow.is-next {
  right: 0;
}

.dataon-provider-arrow.is-prev {
  right: 50px;
}

.dataon-provider-arrow:hover,
.dataon-provider-arrow:focus-visible,
.dataon-tech-arrow:hover,
.dataon-tech-arrow:focus-visible {
  color: #FFFFFF;
  border-color: #0B77E3;
  background: #0B77E3;
}

.dataon-provider-summary {
  display: grid;
  align-content: start;
  gap: 18px;
  min-height: 336px;
  padding: 30px 26px;
  color: #FFFFFF;
  border-radius: 8px;
  background: linear-gradient(160deg, #082A66 0%, #0B77E3 100%);
  box-shadow: 0 16px 34px rgba(0, 83, 168, 0.24);
}

.dataon-provider-summary span {
  color: rgba(255, 255, 255, 0.78);
  font-size: 15px;
  font-weight: 850;
}

.dataon-provider-summary strong {
  font-size: 48px;
  font-weight: 950;
  line-height: 1;
}

.dataon-provider-summary dl {
  display: grid;
  gap: 10px;
  margin: 4px 0 0;
}

.dataon-provider-summary dl div {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.24);
}

.dataon-provider-summary dt,
.dataon-provider-summary dd {
  margin: 0;
  font-size: 14px;
  font-weight: 800;
}

.dataon-provider-summary dd {
  color: #85EAFF;
}

.dataon-provider-summary button {
  justify-self: start;
  min-height: 42px;
  padding: 0 16px;
  color: #07306F;
  border-radius: 999px;
  background: #FFFFFF;
  font-size: 13px;
  font-weight: 900;
}

.dataon-provider-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.dataon-provider-grid button {
  display: grid;
  align-content: start;
  gap: 14px;
  min-height: 154px;
  padding: 20px;
  text-align: left;
  border: 1px solid #E1E9F3;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 8px 22px rgba(8, 38, 84, 0.06);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.dataon-provider-grid button:hover,
.dataon-provider-grid button:focus-visible {
  border-color: #9FD2FF;
  box-shadow: 0 14px 30px rgba(0, 103, 214, 0.14);
}

.dataon-provider-grid h3 {
  display: -webkit-box;
  min-height: 44px;
  overflow: hidden;
  margin: 0;
  color: #13223B;
  font-size: 17px;
  font-weight: 930;
  line-height: 1.32;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.dataon-provider-grid dl {
  display: grid;
  gap: 8px;
  margin: 0;
}

.dataon-provider-grid dl div {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr);
  gap: 8px;
}

.dataon-provider-grid dt,
.dataon-provider-grid dd {
  margin: 0;
  font-size: 13px;
  line-height: 1.35;
}

.dataon-provider-grid dt {
  color: #7A8799;
  font-weight: 800;
}

.dataon-provider-grid dd {
  min-width: 0;
  overflow: hidden;
  color: #24354F;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-tech-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 14px;
}

.dataon-tech-arrow {
  top: 50%;
  width: 42px;
  height: 42px;
  transform: translateY(-50%);
}

.dataon-tech-arrow.is-next {
  right: -54px;
}

.dataon-tech-arrow.is-prev {
  left: -54px;
}

.dataon-tech-grid button {
  display: grid;
  justify-items: center;
  gap: 12px;
  min-height: 136px;
  padding: 22px 10px;
  color: #1A2A44;
  border: 1px solid #E1E9F3;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 8px 20px rgba(8, 38, 84, 0.05);
  font-size: 15px;
  font-weight: 900;
  transition: color 160ms ease, border-color 160ms ease;
}

.dataon-tech-grid button:hover,
.dataon-tech-grid button:focus-visible {
  color: #0B77E3;
  border-color: #9FD2FF;
}

.dataon-tech-grid img {
  width: 52px;
  height: 52px;
  object-fit: contain;
}

.dataon-board-card {
  overflow: hidden;
  border: 1px solid #DDE7F3;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 14px 32px rgba(8, 38, 84, 0.08);
}

.dataon-board-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
  padding: 24px 28px;
  border-bottom: 1px solid #E7EEF7;
}

.dataon-board-more {
  display: inline-grid;
  place-items: center;
  width: 38px;
  min-height: 38px;
  padding: 0;
  color: #0B77E3;
  border: 1px solid #CFE3F7;
  border-radius: 50%;
  background: #F4FAFF;
  font-size: 14px;
  font-weight: 900;
}

.dataon-board-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dataon-board-list button {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 8px 12px;
  min-height: 132px;
  padding: 22px 28px;
  text-align: left;
  border-top: 1px solid #EEF2F7;
  background: #FFFFFF;
}

.dataon-board-list button:nth-child(-n+2) {
  border-top: 0;
}

.dataon-board-list button:nth-child(2n) {
  border-left: 1px solid #EEF2F7;
}

.dataon-board-list button:hover,
.dataon-board-list button:focus-visible {
  background: #F8FBFF;
}

.dataon-board-category {
  grid-column: 1/2;
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  color: #0B77E3;
  border-radius: 999px;
  background: #EAF6FF;
  font-size: 12px;
  font-weight: 900;
}

.dataon-board-list strong {
  grid-column: 2/3;
  min-width: 0;
  overflow: hidden;
  color: #13223B;
  font-size: 17px;
  font-weight: 920;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-board-list p {
  grid-column: 1/-1;
  display: -webkit-box;
  overflow: hidden;
  margin: 6px 0 0;
  color: #66748A;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.55;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.dataon-board-list time {
  grid-column: 3/4;
  grid-row: 1;
  color: #8794A8;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

@media (max-width: 1320px) {
  .dataon-floating-quick {
    display: none;
  }
}
@media (max-width: 1200px) {
  .dataon-tech-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 1080px) {
  .dataon-provider-layout {
    grid-template-columns: 1fr;
  }
  .dataon-provider-summary {
    min-height: 0;
  }
  .dataon-provider-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataon-tech-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .dataon-tech-arrow.is-next {
    right: 0;
  }
  .dataon-tech-arrow.is-prev {
    left: 0;
  }
}
@media (max-width: 760px) {
  .dataon-hero {
    min-height: 720px;
  }
  .dataon-hero-grid {
    min-height: 720px;
    padding-top: 28px;
    padding-bottom: 164px;
  }
  .dataon-hero-title {
    font-size: 34px;
  }
  .dataon-hero-description {
    font-size: 15px;
  }
  .dataon-search-shell {
    grid-template-columns: minmax(0, 1fr) 46px 54px;
    border-radius: 18px;
  }
  .dataon-search-input,
  .dataon-search-detail-toggle,
  .dataon-search-button {
    height: 58px;
  }
  .dataon-search-detail-toggle {
    width: 46px;
    min-width: 46px;
    padding: 0;
  }
  .dataon-search-detail-toggle span {
    display: none;
  }
  .dataon-search-detail-toggle em {
    position: absolute;
    top: 9px;
    right: 7px;
    min-width: 15px;
    height: 15px;
    padding: 0 4px;
    font-size: 9px;
  }
  .dataon-search-button {
    min-width: 54px;
    padding: 0;
  }
  .dataon-hero-stats {
    grid-template-columns: 1fr;
    width: min(420px, 100% - 32px);
    left: 16px;
    right: 16px;
  }
  .dataon-hero-stats button {
    grid-template-columns: 44px minmax(0, 1fr) auto;
    min-height: 76px;
    padding: 14px 16px;
  }
  .dataon-hero-stats button + button {
    border-top: 1px solid #DDE7F3;
    border-left: 0;
  }
  .dataon-hero-stats img {
    width: 38px;
    height: 38px;
  }
  .dataon-hero-stats strong {
    font-size: 24px;
  }
  .dataon-hero-stats em {
    grid-column: 3;
    font-size: 13px;
  }
  .dataon-provider-section,
  .dataon-tech-section,
  .dataon-board-section {
    padding: 48px 0;
  }
  .dataon-section-head {
    display: grid;
    gap: 8px;
  }
  .dataon-section-head h2,
  .dataon-board-head h2 {
    font-size: 24px;
  }
  .dataon-section-head p {
    text-align: left;
  }
  .dataon-provider-grid,
  .dataon-board-list {
    grid-template-columns: 1fr;
  }
  .dataon-board-list button:nth-child(2n),
  .dataon-board-list button:nth-child(-n+2) {
    border-left: 0;
    border-top: 1px solid #EEF2F7;
  }
  .dataon-board-list button:first-child {
    border-top: 0;
  }
  .dataon-tech-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .dataon-provider-arrow {
    top: -54px;
  }
  .dataon-board-head {
    grid-template-columns: 1fr;
    justify-items: start;
  }
}
@media (max-width: 520px) {
  .dataon-hero-title {
    font-size: 29px;
  }
  .dataon-hero-shortcuts,
  .dataon-search-action-row {
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 2px;
    scrollbar-width: none;
  }
  .dataon-hero-shortcuts::-webkit-scrollbar,
  .dataon-search-action-row::-webkit-scrollbar {
    display: none;
  }
  .dataon-hero-shortcuts button,
  .dataon-search-action-row button {
    flex: 0 0 auto;
    min-height: 38px;
    padding: 0 12px;
    font-size: 13px;
  }
  .dataon-search-block .dataon-advanced-search-panel {
    top: 68px;
  }
  .dataon-provider-grid button,
  .dataon-board-list button {
    padding: 18px;
  }
  .dataon-board-list button {
    grid-template-columns: minmax(0, 1fr);
  }
  .dataon-board-category,
  .dataon-board-list strong,
  .dataon-board-list p,
  .dataon-board-list time {
    grid-column: 1;
  }
  .dataon-board-list time {
    grid-row: auto;
  }
}
@media (max-width: 480px) {
  .dataon-tech-grid {
    grid-template-columns: 1fr;
  }
}
.dataon-page[data-language=en] {
  overflow-wrap: normal;
}

.dataon-page[data-language=en] .dataon-header-inner {
  gap: clamp(14px, 2vw, 26px);
}

.dataon-page[data-language=en] .dataon-nav {
  gap: clamp(16px, 2vw, 34px);
}

.dataon-page[data-language=en] .dataon-nav-button {
  font-size: 15px;
}

.dataon-page[data-language=en] .dataon-auth {
  gap: 6px;
  font-size: 12px;
}

.dataon-page[data-language=en] .dataon-auth-button {
  max-width: 96px;
  min-height: 34px;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page[data-language=en] .dataon-nav-panel {
  grid-auto-columns: minmax(146px, 190px);
  gap: clamp(16px, 2vw, 30px);
  padding-right: clamp(24px, 8vw, 120px);
  padding-left: clamp(24px, 8vw, 120px);
}

.dataon-page[data-language=en] .dataon-nav-panel-heading,
.dataon-page[data-language=en] .dataon-nav-panel-link,
.dataon-page[data-language=en] .dataon-sitemap-title,
.dataon-page[data-language=en] .dataon-sitemap-section-title,
.dataon-page[data-language=en] .dataon-sitemap-link,
.dataon-page[data-language=en] .dataon-mobile-major-menu button,
.dataon-page[data-language=en] .dataon-mobile-minor-title,
.dataon-page[data-language=en] .dataon-mobile-section-title,
.dataon-page[data-language=en] .dataon-mobile-minor-link {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page[data-language=en] .dataon-sitemap-grid {
  gap: clamp(20px, 2vw, 28px);
}

.dataon-page[data-language=en] .dataon-sitemap-title {
  min-height: 64px;
  font-size: clamp(24px, 2.3vw, 32px);
}

.dataon-page[data-language=en] .dataon-sitemap-section-title {
  font-size: 17px;
}

.dataon-page[data-language=en] .dataon-sitemap-link {
  font-size: 14px;
}

.dataon-page[data-language=en] .dataon-hero-title {
  max-width: 980px;
  font-size: clamp(34px, 3.25vw, 48px);
  line-height: 1.18;
}

.dataon-page[data-language=en] .dataon-hero-shortcuts,
.dataon-page[data-language=en] .dataon-search-action-row {
  flex-wrap: nowrap;
  justify-content: flex-start;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 2px;
  scrollbar-width: none;
}

.dataon-page[data-language=en] .dataon-hero-shortcuts::-webkit-scrollbar,
.dataon-page[data-language=en] .dataon-search-action-row::-webkit-scrollbar {
  display: none;
}

.dataon-page[data-language=en] .dataon-hero-shortcuts button,
.dataon-page[data-language=en] .dataon-search-action-row button {
  flex: 0 0 auto;
  padding: 0 13px;
  font-size: 13px;
  white-space: nowrap;
}

.dataon-page[data-language=en] .dataon-chip-label,
.dataon-page[data-language=en] .dataon-results-keywords span,
.dataon-page[data-language=en] .dataon-home-tab-row button,
.dataon-page[data-language=en] .dataon-board-tabs button,
.dataon-page[data-language=en] .dataon-prototype-tabs button,
.dataon-page[data-language=en] .dataon-prototype-segment button {
  white-space: nowrap;
}

.dataon-page[data-language=en] .dataon-home-tab-row button,
.dataon-page[data-language=en] .dataon-board-tabs button {
  min-width: 76px;
  padding: 0 14px;
}

.dataon-page[data-language=en] .dataon-provider-summary button,
.dataon-page[data-language=en] .dataon-email-action-row button:not(.dataon-auth-primary-button),
.dataon-page[data-language=en] .dataon-advanced-apply,
.dataon-page[data-language=en] .dataon-advanced-cancel,
.dataon-page[data-language=en] .dataon-filter-panel-actions button {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page[data-language=en] .dataon-provider-grid dl div {
  grid-template-columns: 86px minmax(0, 1fr);
}

.dataon-page[data-language=en] .dataon-provider-grid dt,
.dataon-page[data-language=en] .dataon-provider-grid dd,
.dataon-page[data-language=en] .dataon-hero-stats span,
.dataon-page[data-language=en] .dataon-hero-stats em,
.dataon-page[data-language=en] .dataon-hero-stats small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page[data-language=en] .dataon-tech-grid button span,
.dataon-page[data-language=en] .dataon-board-category,
.dataon-page[data-language=en] .dataon-board-list strong,
.dataon-page[data-language=en] .dataon-board-list time,
.dataon-page[data-language=en] .dataon-result-toolbar h2,
.dataon-page[data-language=en] .dataon-result-card-title,
.dataon-page[data-language=en] .dataon-result-meta span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 1180px) {
  .dataon-page[data-language=en] .dataon-nav {
    gap: clamp(12px, 1.5vw, 22px);
  }
  .dataon-page[data-language=en] .dataon-nav-button {
    font-size: 14px;
  }
  .dataon-page[data-language=en] .dataon-auth-button {
    max-width: 84px;
    padding: 0 8px;
  }
}
@media (max-width: 760px) {
  .dataon-page[data-language=en] .dataon-hero-title {
    font-size: 31px;
  }
  .dataon-page[data-language=en] .dataon-sitemap-title {
    min-height: 54px;
    font-size: 22px;
  }
}
/* ReviewOps yfhrkjantijyfrokjxckplteeggodaby: align public main page with DataON */
.dataon-page {
  background: #FFFFFF;
  color: #111111;
  font-family: "Noto Sans KR", "Noto Sans", Arial, sans-serif;
}

.dataon-container,
.dataon-service-grid,
.dataon-content-grid,
.dataon-bottom-grid {
  max-width: 1320px;
}

.dataon-header {
  position: relative;
  z-index: 2100;
  color: #111111;
  border-bottom: 1px solid #E6EAF0;
  background: #FFFFFF;
  box-shadow: none;
}

.dataon-header .dataon-container {
  max-width: 1440px;
}

.dataon-header-inner {
  height: 88px;
  gap: 28px;
}

.dataon-logo {
  height: 43px;
}

.dataon-nav {
  gap: clamp(34px, 4vw, 70px);
}

.dataon-nav-button {
  min-height: 88px;
  color: #111111;
  font-size: 18px;
  font-weight: 800;
}

.dataon-nav-button::after {
  bottom: 0;
  height: 4px;
  border-radius: 0;
  background: #0A67C8;
}

.dataon-nav-panel {
  top: 88px;
  border-color: #E5EAF1;
  box-shadow: 0 18px 34px rgba(17, 32, 62, 0.08);
}

.dataon-auth {
  gap: 0;
  color: #333333;
  font-size: 15px;
  font-weight: 700;
}

.dataon-auth-button {
  min-height: 88px;
  padding: 0 13px;
  color: #333333;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.dataon-auth-button + .dataon-auth-button {
  position: relative;
}

.dataon-auth-button + .dataon-auth-button::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 1px;
  height: 13px;
  background: #D1D7E0;
  content: "";
  transform: translateY(-50%);
}

.dataon-auth-button:hover,
.dataon-auth-button:focus-visible {
  color: #0A67C8;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.dataon-sitemap-toggle {
  width: auto;
  height: 88px;
  gap: 8px;
  padding: 0 0 0 14px;
  color: #111111;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  font-size: 15px;
  font-weight: 800;
}

.dataon-sitemap-toggle i {
  font-size: 22px;
}

.dataon-sitemap-toggle:hover,
.dataon-sitemap-toggle:focus-visible {
  color: #0A67C8;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.dataon-mobile-button {
  border-color: #D8E0EA;
  border-radius: 0;
}

.dataon-sitemap {
  top: 88px;
}

.dataon-hero {
  min-height: 612px;
  background: #05194A;
}

.dataon-hero-grid {
  min-height: 612px;
  align-content: center;
  gap: 22px;
  padding-top: 26px;
  padding-bottom: 106px;
}

.dataon-hero-shortcuts {
  justify-content: flex-end;
  max-width: 850px;
  margin: 0 auto;
}

.dataon-hero-shortcuts button {
  min-height: 38px;
  padding: 0 17px;
  border-color: rgba(255, 255, 255, 0.38);
  border-radius: 0;
  background: rgba(0, 25, 74, 0.18);
  box-shadow: none;
  font-size: 15px;
}

.dataon-hero-copy {
  margin-top: 6px;
}

.dataon-hero-title {
  font-size: clamp(34px, 3.3vw, 48px);
  font-weight: 500;
  line-height: 1.32;
  text-shadow: none;
}

.dataon-hero-title strong {
  color: #FFFFFF;
  font-weight: 900;
}

.dataon-search-block {
  max-width: 850px;
  margin-top: 12px;
}

.dataon-search-shell {
  grid-template-columns: minmax(0, 1fr) 128px 74px;
  overflow: visible;
  border: 3px solid #0A67C8;
  border-radius: 0;
  background: #FFFFFF;
  box-shadow: none;
}

.dataon-search-input,
.dataon-search-detail-toggle,
.dataon-search-button {
  height: 62px;
}

.dataon-search-input {
  padding: 0 24px;
  color: #111111;
  border-radius: 0;
  font-size: 18px;
  font-weight: 500;
}

.dataon-search-detail-toggle {
  min-width: 128px;
  color: #1B4F9C;
  border-left: 1px solid #D7E2F1;
  background: #FFFFFF;
  font-size: 15px;
  font-weight: 800;
}

.dataon-search-detail-toggle:hover,
.dataon-search-detail-toggle.is-active {
  color: #0A67C8;
  background: #F4F8FD;
}

.dataon-search-button {
  min-width: 74px;
  padding: 0;
  border-radius: 0;
  background: #0A67C8;
  box-shadow: none;
}

.dataon-search-button:hover {
  background: #004EA6;
  box-shadow: none;
}

.dataon-chip-row {
  width: 100%;
  max-width: none;
  margin: 10px 0 0;
  justify-content: flex-start;
  color: #FFFFFF;
}

.dataon-chip-label {
  min-height: 28px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 800;
}

.dataon-chip-list {
  max-width: calc(100% - 92px);
}

.dataon-chip-track {
  width: max-content;
  min-width: max-content;
  animation: dataon-keyword-slide 58s linear infinite;
}

.dataon-chip-group,
.dataon-chip-group[aria-hidden=true] {
  display: flex;
  gap: 8px;
  padding-right: 8px;
}

.dataon-chip {
  height: 28px;
  padding: 0 12px;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 0;
  background: rgba(5, 24, 68, 0.26);
  backdrop-filter: none;
  font-size: 13px;
  font-weight: 700;
}

.dataon-search-action-row {
  justify-content: flex-end;
  margin-top: 12px;
}

.dataon-search-action-row button {
  min-height: 40px;
  padding: 0 16px;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.52);
  border-radius: 0;
  background: rgba(5, 24, 68, 0.28);
  box-shadow: none;
  backdrop-filter: none;
  font-size: 15px;
  font-weight: 800;
}

.dataon-search-action-row button:hover,
.dataon-search-action-row button:focus-visible,
.dataon-search-action-row button.is-active {
  border-color: #FFFFFF;
  background: #0A67C8;
}

.dataon-search-help-popover {
  top: calc(100% + 8px);
  right: 0;
  left: auto;
  transform: none;
  border-radius: 0;
}

.dataon-search-help-popover::before {
  right: 34px;
  transform: rotate(45deg);
}

.dataon-hero-stats {
  width: min(692px, 100% - 48px);
  border: 1px solid #DCE4EF;
  border-bottom: 0;
  border-radius: 0;
  background: #FFFFFF;
  box-shadow: none;
}

.dataon-hero-stats button {
  min-height: 86px;
  padding: 16px 22px;
}

.dataon-hero-stats strong {
  color: #0A67C8;
}

.dataon-floating-quick {
  top: auto;
  right: 28px;
  bottom: 26px;
  border-radius: 0;
  box-shadow: 0 8px 24px rgba(13, 35, 70, 0.16);
}

.dataon-floating-quick strong,
.dataon-floating-quick .dataon-floating-top {
  background: #0A2C64;
}

.dataon-provider-section,
.dataon-tech-section,
.dataon-board-section {
  padding: 66px 0;
}

.dataon-provider-section,
.dataon-tech-section,
.dataon-board-section {
  background: #FFFFFF;
}

.dataon-home-tab-row,
.dataon-board-tabs {
  gap: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.dataon-home-tab-row button,
.dataon-board-tabs button {
  min-width: 78px;
  min-height: 42px;
  padding: 0 18px;
  color: #333333;
  border: 1px solid #D5DCE6;
  border-radius: 0;
  background: #FFFFFF;
  font-size: 16px;
  font-weight: 800;
}

.dataon-home-tab-row button + button,
.dataon-board-tabs button + button {
  margin-left: -1px;
}

.dataon-home-tab-row button.is-active,
.dataon-board-tabs button.is-active {
  color: #FFFFFF;
  border-color: #0A67C8;
  background: #0A67C8;
}

.dataon-provider-layout {
  grid-template-columns: 245px minmax(0, 1fr);
  gap: 22px;
}

.dataon-provider-summary {
  min-height: 316px;
  border-radius: 0;
  background: #0A67C8;
  box-shadow: none;
}

.dataon-provider-summary button,
.dataon-provider-grid button,
.dataon-tech-grid button,
.dataon-board-card,
.dataon-board-more {
  border-radius: 0;
  box-shadow: none;
}

.dataon-provider-grid button,
.dataon-tech-grid button {
  border-color: #DDE4ED;
}

.dataon-tech-section {
  border-top: 1px solid #EEF2F6;
}

.dataon-section-head h2,
.dataon-board-head h2 {
  color: #111111;
  font-size: 28px;
  font-weight: 900;
}

.dataon-board-section {
  padding-top: 22px;
}

.dataon-board-card {
  border-color: #DDE4ED;
}

.dataon-board-category {
  border-radius: 0;
}

.dataon-footer {
  color: #C6D0E2;
  background: #071537;
}

.dataon-footer-wrap {
  padding-top: 38px;
  padding-bottom: 38px;
}

.dataon-footer-policy a {
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 700;
}

.dataon-footer-policy a:nth-child(2) {
  color: #5FD7FF;
}

@media (max-width: 1320px) {
  .dataon-floating-quick {
    display: grid;
  }
}
@media (max-width: 1180px) {
  .dataon-auth {
    display: none;
  }
  .dataon-mobile-button {
    display: flex;
  }
}
@media (max-width: 1080px) {
  .dataon-hero-shortcuts {
    justify-content: center;
  }
  .dataon-provider-layout {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 760px) {
  .dataon-header-inner {
    height: 72px;
  }
  .dataon-logo {
    height: 36px;
  }
  .dataon-sitemap {
    top: 0;
  }
  .dataon-hero,
  .dataon-hero-grid {
    min-height: 700px;
  }
  .dataon-hero-grid {
    padding-bottom: 154px;
  }
  .dataon-search-shell {
    grid-template-columns: minmax(0, 1fr) 46px 54px;
  }
  .dataon-search-action-row {
    justify-content: flex-end;
  }
  .dataon-chip-list {
    max-width: calc(100% - 86px);
  }
  .dataon-floating-quick {
    display: none;
  }
}
@media (max-width: 520px) {
  .dataon-hero-shortcuts,
  .dataon-search-action-row {
    justify-content: flex-start;
  }
  .dataon-chip-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .dataon-chip-list {
    max-width: 100%;
  }
}
/* ReviewOps yfhrkjantijyfrokjxckplteeggodaby: restore missing lower main sections */
.dataon-lower-data-section {
  padding: 56px 0 64px;
  background: #FFFFFF;
}

.dataon-lower-tab-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
  padding-left: 20px;
}

.dataon-lower-tab-row button {
  position: relative;
  min-height: 34px;
  padding: 0;
  color: #999999;
  border: 0;
  background: transparent;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0;
}

.dataon-lower-tab-row button.is-active {
  color: #0092E5;
}

.dataon-lower-tab-row button.is-active::before {
  position: absolute;
  top: -10px;
  left: 50%;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #0092E5;
  content: "";
  transform: translateX(-50%);
}

.dataon-lower-data-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 25px;
  align-items: stretch;
}

.dataon-lower-data-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 360px;
  padding: 20px;
  text-align: left;
  color: #333333;
  border: 1px solid #CCCCCC;
  border-radius: 15px;
  background: #FFFFFF;
  box-shadow: none;
  transition: border-color 0.3s, transform 0.3s;
}

.dataon-lower-data-card:hover,
.dataon-lower-data-card:focus-visible {
  border-color: rgba(21, 56, 121, 0.5);
  transform: scale(1.02);
}

.dataon-lower-data-card:hover strong,
.dataon-lower-data-card:focus-visible strong {
  color: #153879;
  text-decoration: underline;
}

.dataon-lower-data-category {
  display: block;
  max-width: 100%;
  margin-bottom: 8px;
  overflow: hidden;
  color: #153879;
  font-size: 18px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-lower-data-card strong {
  display: -webkit-box;
  min-height: 56px;
  margin-bottom: 40px;
  overflow: hidden;
  color: #333333;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.4;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dataon-lower-data-card p {
  display: -webkit-box;
  height: 134px;
  margin: 0 0 14px;
  overflow: hidden;
  color: #777777;
  font-size: 15px;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

.dataon-lower-data-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
}

.dataon-lower-data-logo {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  border: 0;
}

.dataon-lower-data-logo img {
  max-width: 120px;
  height: 26px;
  object-fit: contain;
}

.dataon-lower-data-origin,
.dataon-lower-data-count {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 27px;
  padding: 1px 10px;
  color: #153879;
  border: 1px solid #153879;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.dataon-usage-section {
  overflow: hidden;
  padding: 50px 0;
  border-radius: 0 150px 150px 0;
  background: #F4FCFF;
}

.dataon-usage-section h2 {
  margin: 0 0 20px;
  padding-left: 15px;
  color: #333333;
  font-size: 20px;
  font-weight: 800;
}

.dataon-usage-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 25px;
}

.dataon-usage-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 340px;
  padding: 42px 30px;
  text-align: left;
  color: #FFFFFF;
  border: 0;
  border-radius: 15px;
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 100% 100%;
  box-shadow: none;
  letter-spacing: 0;
  transition: transform 0.3s;
}

.dataon-usage-card:hover,
.dataon-usage-card:focus-visible {
  transform: scale(1.03);
}

.dataon-usage-card span {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 400;
}

.dataon-usage-card strong {
  color: inherit;
  font-size: 24px;
  font-weight: 800;
}

.dataon-usage-card:nth-child(1) {
  background-image: url("/assets/dataon/official/main/2024/bg_use_card01.png");
}

.dataon-usage-card:nth-child(2) {
  background-image: url("/assets/dataon/official/main/2024/bg_use_card02.png");
}

.dataon-usage-card:nth-child(3) {
  background-image: url("/assets/dataon/official/main/2024/bg_use_card03.png");
}

.dataon-usage-card:nth-child(4),
.dataon-usage-card:nth-child(5) {
  grid-column: 4;
  grid-row: 1;
  color: #333333;
}

.dataon-usage-card:nth-child(4) {
  background-image: url("/assets/dataon/official/main/2024/bg_use_card04.png");
  animation: dataon-usage-primary 8s infinite;
}

.dataon-usage-card:nth-child(5) {
  background-image: url("/assets/dataon/official/main/2024/bg_use_card05.png");
  animation: dataon-usage-secondary 8s infinite;
}

@keyframes dataon-usage-primary {
  0%, 45% {
    opacity: 1;
    pointer-events: auto;
  }
  50%, 95% {
    opacity: 0;
    pointer-events: none;
  }
  100% {
    opacity: 1;
    pointer-events: auto;
  }
}
@keyframes dataon-usage-secondary {
  0%, 45% {
    opacity: 0;
    pointer-events: none;
  }
  50%, 95% {
    opacity: 1;
    pointer-events: auto;
  }
  100% {
    opacity: 0;
    pointer-events: none;
  }
}
.dataon-link-section {
  overflow: hidden;
  padding: 50px 0;
  border-radius: 0 130px 130px 0;
  background: #FFFFFF;
}

.dataon-link-container {
  position: relative;
}

.dataon-link-banner {
  min-height: 112px;
}

.dataon-link-slide {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 0 60px;
}

.dataon-link-slide h3 {
  flex: 0 0 330px;
  position: relative;
  margin: 0 0 30px;
  padding-bottom: 20px;
  color: #333333;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.42;
}

.dataon-link-slide h3::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100px;
  height: 3px;
  background: #153879;
  content: "";
}

.dataon-link-slide h3 span {
  display: block;
}

.dataon-link-logo-grid {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 100px;
  padding: 0 30px;
  border-radius: 10px;
  background: #FFFFFF;
}

.dataon-link-logo-grid a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  min-width: 0;
  margin: 5px 10px;
  text-align: center;
}

.dataon-link-logo-grid img {
  max-width: 100%;
  height: 40px;
  object-fit: contain;
}

.dataon-link-arrow-row {
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  gap: 8px;
  transform: translateY(-50%);
}

.dataon-link-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  color: #333333;
  border: 1px solid #D9DDE5;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: none;
}

.dataon-mark-section {
  padding: 50px 0;
  background: #F4FCFF;
}

.dataon-mark-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 25px;
}

.dataon-mark-grid a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  padding: 15px 0;
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: box-shadow 0.3s;
}

.dataon-mark-grid a:hover,
.dataon-mark-grid a:focus-visible {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}

.dataon-mark-grid img {
  max-width: 80%;
  height: 50px;
  object-fit: contain;
}

.dataon-footer {
  color: #C0C0C0;
  background: #2E2E2E;
}

.dataon-footer-wrap {
  max-width: 80rem;
  padding-top: 40px;
  padding-bottom: 40px;
}

.dataon-footer-logo {
  flex: 0 0 20%;
  margin-top: 12px;
}

.dataon-footer-policy a {
  color: #D1D1D1;
  font-size: 17px;
  font-weight: 500;
}

.dataon-footer-policy a:nth-child(2) {
  color: #FFD400;
}

.dataon-footer-address,
.dataon-footer-copy {
  color: #C0C0C0;
  font-size: 15px;
  line-height: 1.7;
}

.dataon-footer-badges {
  justify-content: flex-end;
}

.dataon-page[data-language=en] .dataon-header-inner {
  gap: 28px;
}

.dataon-page[data-language=en] .dataon-nav {
  gap: clamp(34px, 4vw, 70px);
}

.dataon-page[data-language=en] .dataon-nav-button {
  min-height: 88px;
  font-size: 18px;
}

.dataon-page[data-language=en] .dataon-auth {
  gap: 0;
  font-size: 15px;
}

.dataon-page[data-language=en] .dataon-auth-button {
  max-width: none;
  min-height: 88px;
  padding: 0 13px;
}

.dataon-page[data-language=en] .dataon-nav-panel {
  grid-auto-columns: minmax(150px, 1fr);
  gap: clamp(20px, 3vw, 44px);
  padding-right: clamp(32px, 7vw, 120px);
  padding-left: clamp(32px, 7vw, 120px);
}

.dataon-page[data-language=en] .dataon-hero-title {
  max-width: none;
  font-size: clamp(34px, 3.3vw, 48px);
  line-height: 1.32;
}

.dataon-page[data-language=en] .dataon-hero-shortcuts,
.dataon-page[data-language=en] .dataon-search-action-row {
  flex-wrap: wrap;
  overflow: visible;
  padding-bottom: 0;
}

.dataon-page[data-language=en] .dataon-search-action-row {
  justify-content: flex-end;
}

.dataon-page[data-language=en] .dataon-hero-shortcuts button,
.dataon-page[data-language=en] .dataon-search-action-row button {
  flex: initial;
  padding: 0 16px;
  font-size: 15px;
}

.dataon-page[data-language=en] .dataon-home-tab-row button,
.dataon-page[data-language=en] .dataon-board-tabs button {
  min-width: 78px;
  padding: 0 18px;
}

.dataon-page[data-language=en] .dataon-provider-grid dl div {
  grid-template-columns: 72px minmax(0, 1fr);
}

.dataon-page[data-language=en] .dataon-lower-tab-row button,
.dataon-page[data-language=en] .dataon-usage-card span,
.dataon-page[data-language=en] .dataon-usage-card strong,
.dataon-page[data-language=en] .dataon-link-slide h3,
.dataon-page[data-language=en] .dataon-footer-policy a {
  letter-spacing: 0;
}

.dataon-page[data-language=en] .dataon-lower-tab-row button {
  font-size: 20px;
}

.dataon-page[data-language=en] .dataon-usage-card span {
  font-size: 20px;
}

.dataon-page[data-language=en] .dataon-usage-card strong {
  font-size: 24px;
}

.dataon-page[data-language=en] .dataon-link-slide h3 {
  font-size: 19px;
}

.dataon-page[data-language=en] .dataon-footer-policy a {
  font-size: 17px;
}

@media (max-width: 1180px) {
  .dataon-page[data-language=en] .dataon-auth {
    display: none;
  }
}
@media (max-width: 1080px) {
  .dataon-lower-data-grid,
  .dataon-usage-grid,
  .dataon-mark-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataon-usage-card:nth-child(4),
  .dataon-usage-card:nth-child(5) {
    grid-column: 2;
    grid-row: 2;
  }
  .dataon-link-slide {
    display: grid;
    grid-template-columns: 1fr;
    padding: 0 24px;
  }
  .dataon-link-slide h3 {
    flex-basis: auto;
    width: 100%;
    margin-bottom: 0;
  }
  .dataon-link-arrow-row {
    position: static;
    justify-content: center;
    margin-top: 12px;
    transform: none;
  }
}
@media (max-width: 640px) {
  .dataon-lower-data-grid,
  .dataon-usage-grid,
  .dataon-mark-grid {
    grid-template-columns: 1fr;
  }
  .dataon-usage-card:nth-child(4),
  .dataon-usage-card:nth-child(5) {
    grid-column: 1;
    grid-row: 4;
  }
  .dataon-lower-data-card,
  .dataon-usage-card {
    height: 320px;
  }
  .dataon-link-logo-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    padding: 18px;
  }
  .dataon-footer-wrap {
    padding-right: 18px;
    padding-left: 18px;
  }
}
/* ReviewOps yfhrkjantijyfrokjxckplteeggodaby: official lower layout pass */
.dataon-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: #FFFFFF;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  background: #040110;
  transition: background-color 0.3s, border-color 0.3s;
}

.dataon-header:hover,
.dataon-header:focus-within,
.dataon-header:has(.dataon-nav-panel.is-active),
.dataon-header:has(.dataon-sitemap) {
  color: #333333;
  border-bottom-color: #F2F2F2;
  background: #FFFFFF;
}

.dataon-header-inner {
  height: 120px;
  max-width: 1440px;
  gap: 51px;
}

.dataon-logo {
  width: 142px;
  height: 50px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  content: url("/assets/dataon/main_logo_white.svg");
}

.dataon-header:hover .dataon-logo,
.dataon-header:focus-within .dataon-logo,
.dataon-header:has(.dataon-nav-panel.is-active) .dataon-logo,
.dataon-header:has(.dataon-sitemap) .dataon-logo {
  filter: none;
  content: url("/assets/dataon/main_logo_ori.svg");
}

.dataon-nav {
  width: 943px;
  gap: 0;
  justify-content: space-between;
}

.dataon-nav-button {
  min-height: 120px;
  padding: 0 10px;
  color: #FFFFFF;
  font-family: "Montserrat", "Noto Sans KR", sans-serif;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.25;
  text-align: center;
  white-space: normal;
}

.dataon-header:hover .dataon-nav-button,
.dataon-header:focus-within .dataon-nav-button,
.dataon-header:has(.dataon-nav-panel.is-active) .dataon-nav-button,
.dataon-header:has(.dataon-sitemap) .dataon-nav-button {
  color: #333333;
}

.dataon-nav-button:hover,
.dataon-nav-group.is-active .dataon-nav-button {
  color: #1792E5;
}

.dataon-nav-button::after {
  display: none;
}

.dataon-nav-panel {
  top: 120px;
  min-height: 262px;
  border-top: 1px solid #F2F2F2;
  border-bottom: 1px solid #DDDDDD;
  background: #FFFFFF;
  box-shadow: none;
}

.dataon-auth {
  width: 330px;
  justify-content: flex-end;
  gap: 10px;
}

.dataon-auth-button {
  min-width: 0;
  min-height: 25px;
  height: 25px;
  padding: 0 13px;
  color: #FFFFFF;
  border: 1px solid #FFFFFF;
  border-radius: 12px;
  background: transparent;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.06rem;
  white-space: normal;
  overflow-wrap: anywhere;
}

.dataon-auth-button + .dataon-auth-button::before {
  display: none;
}

.dataon-header:hover .dataon-auth-button,
.dataon-header:focus-within .dataon-auth-button,
.dataon-header:has(.dataon-nav-panel.is-active) .dataon-auth-button,
.dataon-header:has(.dataon-sitemap) .dataon-auth-button {
  color: #333333;
  border-color: #333333;
}

.dataon-sitemap-toggle {
  height: 34px;
  padding-left: 0;
  color: #FFFFFF;
  font-size: 0;
}

.dataon-sitemap-toggle span {
  display: none;
}

.dataon-sitemap-toggle i {
  font-size: 29px;
}

.dataon-header:hover .dataon-sitemap-toggle,
.dataon-header:focus-within .dataon-sitemap-toggle,
.dataon-header:has(.dataon-nav-panel.is-active) .dataon-sitemap-toggle,
.dataon-header:has(.dataon-sitemap) .dataon-sitemap-toggle {
  color: #333333;
}

.dataon-sitemap {
  top: 120px;
}

.dataon-hero {
  min-height: 919px;
}

.dataon-hero-grid {
  min-height: 919px;
  padding-top: 180px;
}

.dataon-provider-section {
  padding: 50px 0;
  background: #F4FCFF;
}

.dataon-provider-section > .dataon-container {
  max-width: 1300px;
  padding: 50px 45px;
  border: 1px solid #CCCCCC;
  border-radius: 10px;
  background: #FFFFFF;
}

.dataon-home-tab-row {
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 30px;
}

.dataon-home-tab-row button {
  position: relative;
  min-width: auto;
  min-height: 31px;
  padding: 0;
  color: #999999;
  border: 0;
  background: transparent;
  font-size: 22px;
  font-weight: 500;
}

.dataon-home-tab-row button + button {
  margin-left: 0;
}

.dataon-home-tab-row button.is-active {
  color: #0092E5;
  background: transparent;
  font-weight: 800;
}

.dataon-home-tab-row button.is-active::before {
  position: absolute;
  top: -15px;
  left: 50%;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #0092E5;
  content: "";
  transform: translateX(-50%);
}

.dataon-provider-layout {
  grid-template-columns: 250px minmax(0, 1fr);
  align-items: center;
  gap: 28px;
  min-height: 260px;
}

.dataon-provider-summary {
  min-height: 241px;
  padding: 5px;
  color: #333333;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.dataon-provider-summary span,
.dataon-provider-summary dt {
  color: #333333;
  font-size: 16px;
  font-weight: 500;
}

.dataon-provider-summary strong,
.dataon-provider-summary dd {
  color: #0092E5;
  font-size: 25px;
  font-weight: 800;
}

.dataon-provider-summary strong {
  display: block;
  margin: 22px 0 20px;
  line-height: 1.25;
}

.dataon-provider-summary dl {
  display: grid;
  gap: 20px;
  margin: 0;
}

.dataon-provider-summary dl div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.dataon-provider-summary button {
  display: none;
}

.dataon-provider-carousel {
  min-width: 0;
  padding: 5px;
}

.dataon-provider-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.dataon-provider-grid button {
  height: 260px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: border-color 0.3s, transform 0.3s;
}

.dataon-provider-grid button:hover,
.dataon-provider-grid button:focus-visible {
  border: 1px solid rgba(21, 56, 121, 0.5);
  transform: scale(1.02);
}

.dataon-provider-grid h3 {
  height: 55px;
  margin: 20px 20px 0;
  color: #333333;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: 0;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dataon-provider-grid button:hover h3,
.dataon-provider-grid button:focus-visible h3 {
  color: #153879;
  text-decoration: underline;
}

.dataon-provider-grid dl {
  display: grid;
  gap: 0;
  height: 157px;
  margin: 18px 10px 10px;
  padding: 20px;
  border: 1px solid #DDDDDD;
  border-radius: 10px;
}

.dataon-provider-grid dl div {
  display: grid;
  grid-template-columns: 118px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  min-width: 0;
}

.dataon-provider-grid dt,
.dataon-provider-grid dd {
  color: #333333;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.35;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dataon-provider-grid dt {
  position: relative;
  padding-left: 30px;
}

.dataon-provider-grid dl div:nth-child(1) dt {
  background: url("/assets/dataon/2024/icon_data.svg") left top/22px 20px no-repeat;
}

.dataon-provider-grid dl div:nth-child(2) dt {
  background: url("/assets/dataon/2024/icon_field.svg") left top/22px 22px no-repeat;
}

.dataon-provider-grid dl div:nth-child(3) dt {
  background: url("/assets/dataon/2024/icon_file.svg") left top/22px 16px no-repeat;
}

.dataon-provider-grid dd {
  color: #153879;
  font-weight: 800;
  letter-spacing: 0;
}

.dataon-provider-arrow {
  width: 44px;
  height: 44px;
  color: #263741;
  border: 0;
  background: transparent;
  box-shadow: none;
  font-size: 28px;
}

.dataon-provider-arrow.is-prev {
  left: -40px;
}

.dataon-provider-arrow.is-next {
  right: -40px;
}

.dataon-tech-section {
  padding: 50px 0;
  border-top: 0;
  border-radius: 0 130px 130px 0;
  background: #FFFFFF;
}

.dataon-tech-section .dataon-container {
  max-width: 1300px;
}

.dataon-section-head {
  margin-bottom: 20px;
}

.dataon-section-head h2 {
  margin: 0;
  padding-left: 15px;
  color: #333333;
  font-size: 20px;
  font-weight: 800;
}

.dataon-tech-carousel {
  height: 224px;
  padding: 0 110px;
  border: 1px solid #CCCCCC;
  border-radius: 15px;
  background: #FFFFFF;
  overflow: hidden;
}

.dataon-tech-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(100px, 1fr));
  align-items: center;
  gap: 0;
  height: 100%;
}

.dataon-tech-grid button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 180px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.dataon-tech-grid img {
  width: 100px;
  height: 100px;
  transition: transform 0.7s;
}

.dataon-tech-grid button:hover img,
.dataon-tech-grid button:focus-visible img {
  transform: rotateY(360deg);
}

.dataon-tech-grid button span {
  width: 110px;
  margin-top: 25px;
  color: #333333;
  font-size: 15px;
  font-weight: 400;
  text-align: center;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dataon-tech-grid button:hover span,
.dataon-tech-grid button:focus-visible span {
  color: #153879;
  font-weight: 800;
}

.dataon-tech-arrow {
  width: 50px;
  height: 100%;
  color: #263741;
  border: 0;
  border-radius: 0;
  background: #FFFFFF;
  box-shadow: none;
  font-size: 28px;
}

.dataon-tech-arrow.is-prev {
  left: 23px;
}

.dataon-tech-arrow.is-next {
  right: 23px;
}

.dataon-board-section {
  padding: 50px 0 70px;
  border-radius: 130px 0 0 130px;
  background: #F4FCFF;
}

.dataon-board-section .dataon-container,
.dataon-lower-data-section .dataon-container {
  max-width: 1310px;
}

.dataon-board-card {
  border: 0;
  background: transparent;
}

.dataon-board-head {
  margin-bottom: 10px;
  padding-left: 20px;
}

.dataon-board-tabs {
  gap: 20px;
}

.dataon-board-tabs button,
.dataon-lower-tab-row button {
  position: relative;
  min-width: auto;
  min-height: 34px;
  padding: 0;
  color: #999999;
  border: 0;
  background: transparent;
  font-size: 20px;
  font-weight: 800;
}

.dataon-board-tabs button + button {
  margin-left: 0;
}

.dataon-board-tabs button.is-active,
.dataon-lower-tab-row button.is-active {
  color: #0092E5;
  background: transparent;
}

.dataon-board-tabs button.is-active::before,
.dataon-lower-tab-row button.is-active::before {
  position: absolute;
  top: -15px;
  left: 50%;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #0092E5;
  content: "";
  transform: translateX(-50%);
}

.dataon-board-more {
  top: -6px;
  color: #333333;
  border: 0;
  background: transparent;
  box-shadow: none;
  font-size: 28px;
}

.dataon-board-list {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 25px;
  padding: 5px;
}

.dataon-board-list button,
.dataon-lower-data-card {
  height: 360px;
  padding: 20px;
  border: 1px solid #CCCCCC;
  border-radius: 15px;
  background: #FFFFFF;
  box-shadow: none;
  transition: border-color 0.3s, transform 0.3s;
}

.dataon-board-list button:hover,
.dataon-board-list button:focus-visible,
.dataon-lower-data-card:hover,
.dataon-lower-data-card:focus-visible {
  border-color: rgba(21, 56, 121, 0.5);
  transform: scale(1.02);
}

.dataon-board-category,
.dataon-lower-data-category {
  display: block;
  margin: 0 0 8px;
  padding: 0;
  color: #153879;
  border: 0;
  background: transparent;
  font-size: 18px;
  font-weight: 800;
  text-align: left;
}

.dataon-board-list strong,
.dataon-lower-data-card strong {
  display: -webkit-box;
  height: 56px;
  margin: 0 0 40px;
  overflow: hidden;
  color: #333333;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.4;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dataon-board-list p,
.dataon-lower-data-card p {
  display: -webkit-box;
  height: 134px;
  margin: 0 0 14px;
  overflow: hidden;
  color: #777777;
  font-size: 15px;
  line-height: 1.55;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

.dataon-board-list time {
  margin-top: auto;
  padding: 0;
  color: #777777;
  border: 0;
  background: transparent;
  font-size: 16px;
  font-weight: 400;
}

.dataon-lower-data-section {
  padding: 50px 0;
  border-radius: 130px 0 0 130px;
  background: #FFFFFF;
}

.dataon-lower-tab-row {
  gap: 20px;
  margin-bottom: 10px;
}

.dataon-lower-data-grid {
  gap: 25px;
  padding: 5px;
}

.dataon-page[data-language=en] .dataon-header-inner {
  height: 120px;
  gap: 51px;
}

.dataon-page[data-language=en] .dataon-nav {
  width: 943px;
  gap: 0;
}

.dataon-page[data-language=en] .dataon-nav-button {
  min-height: 120px;
  font-size: 18px;
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}

.dataon-page[data-language=en] .dataon-provider-grid h3,
.dataon-page[data-language=en] .dataon-provider-grid dt,
.dataon-page[data-language=en] .dataon-provider-grid dd,
.dataon-page[data-language=en] .dataon-tech-grid button span,
.dataon-page[data-language=en] .dataon-board-list strong,
.dataon-page[data-language=en] .dataon-board-list p,
.dataon-page[data-language=en] .dataon-lower-data-card strong,
.dataon-page[data-language=en] .dataon-lower-data-card p,
.dataon-page[data-language=en] .dataon-usage-card span,
.dataon-page[data-language=en] .dataon-usage-card strong,
.dataon-page[data-language=en] .dataon-link-slide h3 {
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}

@media (max-width: 1320px) {
  .dataon-header-inner {
    gap: 28px;
  }
  .dataon-nav,
  .dataon-page[data-language=en] .dataon-nav {
    width: min(760px, 58vw);
  }
  .dataon-auth {
    width: auto;
  }
}
@media (max-width: 1080px) {
  .dataon-provider-section > .dataon-container {
    padding: 36px 24px;
  }
  .dataon-provider-layout {
    grid-template-columns: 1fr;
  }
  .dataon-provider-summary {
    min-height: auto;
  }
  .dataon-provider-grid,
  .dataon-board-list,
  .dataon-lower-data-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataon-tech-grid {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }
}
@media (max-width: 760px) {
  .dataon-header {
    position: relative;
    background: #FFFFFF;
  }
  .dataon-header-inner,
  .dataon-page[data-language=en] .dataon-header-inner {
    height: 72px;
  }
  .dataon-logo {
    width: auto;
    height: 36px;
    filter: none;
    content: url("/assets/dataon/main_logo_ori.svg");
  }
  .dataon-mobile-button {
    color: #333333;
  }
  .dataon-hero,
  .dataon-hero-grid {
    min-height: 700px;
  }
  .dataon-hero-grid {
    padding-top: 26px;
  }
  .dataon-provider-grid,
  .dataon-board-list,
  .dataon-lower-data-grid,
  .dataon-tech-grid {
    grid-template-columns: 1fr;
  }
  .dataon-tech-carousel {
    height: auto;
    min-height: 224px;
    padding: 24px;
  }
}
/* ReviewOps yfhrkjantijyfrokjxckplteeggodaby: responsive alignment audit pass */
.dataon-provider-section.sec01 {
  padding: 50px 0;
  background: #F4FCFF;
}

.dataon-provider-section.sec01 > .sec_inner {
  max-width: 1300px;
  padding: 50px 45px;
  border: 1px solid #CCCCCC;
  border-radius: 10px;
  background: #FFFFFF;
}

.dataon-provider-layout.total_cnt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 260px;
  gap: 20px;
}

.dataon-provider-summary.total_head {
  flex: 0 0 240px;
  position: relative;
  height: 241px;
  min-height: 241px;
  margin-top: 35px;
  padding: 5px;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.dataon-provider-summary .total_tab_head {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 0;
}

.dataon-provider-summary .total_tab_head button {
  position: relative;
  min-width: 0;
  min-height: 34px;
  padding: 0;
  color: #999999;
  border: 0;
  background: transparent;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0;
}

.dataon-provider-summary .total_tab_head button.is-active {
  color: #0092E5;
  background: transparent;
}

.dataon-provider-summary .total_tab_head button.is-active::after {
  position: absolute;
  top: -15px;
  left: 50%;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #0092E5;
  content: "";
  transform: translateX(-50%);
}

.dataon-provider-summary .total_sum_cnt {
  margin-top: 30px;
}

.dataon-provider-summary .sum_cnt_row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 20px;
}

.dataon-provider-summary .sum_cnt_row p {
  margin: 0;
  color: #333333;
  font-size: 15.5px;
  line-height: 1.25;
  letter-spacing: 0;
}

.dataon-provider-summary .sum_cnt_row p:last-child {
  flex: 1 1 auto;
  color: #153879;
  font-weight: 800;
  text-align: right;
  white-space: normal;
  overflow-wrap: anywhere;
}

.dataon-provider-stat-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 138px;
  min-height: 38px;
  margin-top: 2px;
  padding: 8px 18px;
  color: #FFFFFF;
  border: 0;
  border-radius: 19px;
  background: #153879;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.25;
}

.dataon-provider-carousel.total_conts {
  flex: 0 0 950px;
  position: relative;
  width: 950px;
  height: 270px;
  padding: 5px;
  overflow: visible;
}

.dataon-provider-grid.total_tab02.on {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 300px));
  align-items: stretch;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.dataon-provider-grid.total_tab02 .cnt_card {
  display: flex;
  flex-direction: column;
  width: 300px;
  max-width: 300px;
  height: 260px;
  padding: 0;
  text-align: left;
  color: #333333;
  border: 1px solid transparent;
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: border-color 0.3s, transform 0.3s;
}

.dataon-provider-grid.total_tab02 .cnt_card:hover,
.dataon-provider-grid.total_tab02 .cnt_card:focus-visible {
  border-color: rgba(21, 56, 121, 0.5);
  transform: scale(1.02);
}

.dataon-provider-grid.total_tab02 .cnt_card h3 {
  display: -webkit-box;
  height: 55px;
  margin: 20px 20px 0;
  overflow: hidden;
  color: #333333;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: 0;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dataon-provider-grid.total_tab02 .cnt_card:hover h3,
.dataon-provider-grid.total_tab02 .cnt_card:focus-visible h3 {
  color: #153879;
  text-decoration: underline;
}

.dataon-provider-grid.total_tab02 .cnt_box {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  height: 157px;
  margin: 18px 10px 10px;
  padding: 20px;
  border: 1px solid #DDDDDD;
  border-radius: 10px;
}

.dataon-provider-grid.total_tab02 .cnt_box > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 0;
}

.dataon-provider-grid.total_tab02 .cnt_box p {
  min-height: 22px;
  margin: 0 0 26px;
  color: #333333;
  font-size: 15.5px;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: 0;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.dataon-provider-grid.total_tab02 .cnt_box p:last-child {
  margin-bottom: 0;
}

.dataon-provider-grid.total_tab02 .cnt_left p {
  padding-left: 30px;
}

.dataon-provider-grid.total_tab02 .cnt_left p.data {
  background: url("/assets/dataon/2024/icon_data.svg") left top/22px 20px no-repeat;
}

.dataon-provider-grid.total_tab02 .cnt_left p.field {
  background: url("/assets/dataon/2024/icon_field.svg") left top/22px 22px no-repeat;
}

.dataon-provider-grid.total_tab02 .cnt_left p.files {
  background: url("/assets/dataon/2024/icon_file.svg") left 2px/22px 16px no-repeat;
}

.dataon-provider-grid.total_tab02 .cnt_right {
  flex: 1 1 auto;
  text-align: right;
}

.dataon-provider-grid.total_tab02 .cnt_right p {
  width: 100%;
  color: #153879;
  font-weight: 800;
  text-align: right;
  word-break: normal;
}

.dataon-provider-arrow {
  position: absolute;
  top: calc(50% - 25px);
  z-index: 3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  color: #263741;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  font-size: 32px;
  transform: none;
}

.dataon-provider-arrow.is-prev {
  left: -54px;
}

.dataon-provider-arrow.is-next {
  right: -54px;
}

.dataon-tech-section.sec02 {
  padding: 0;
  border-radius: 0 130px 130px 0;
  background: #FFFFFF;
}

.dataon-tech-section.sec02 > .sec_inner {
  max-width: 1300px;
  padding: 50px 0;
}

.dataon-tech-section.sec02 .dataon-section-head {
  margin: 0 0 20px;
}

.dataon-tech-section.sec02 .dataon-section-head h2 {
  margin: 0;
  padding-left: 15px;
  color: #333333;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0;
}

.dataon-tech-carousel.classification {
  display: block;
  position: relative;
  width: 100%;
  height: 224px;
  padding: 0 110px;
  border: 1px solid #CCCCCC;
  border-radius: 15px;
  background: #FFFFFF;
  overflow: hidden;
}

.dataon-tech-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(100px, 1fr));
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: 0;
}

.dataon-tech-grid .item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 180px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.dataon-tech-grid .item img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  transition: transform 0.7s;
}

.dataon-tech-grid .item:hover img,
.dataon-tech-grid .item:focus-visible img {
  transform: rotateY(360deg);
}

.dataon-tech-grid .item span {
  display: block;
  width: 100px;
  margin-top: 25px;
  overflow: hidden;
  color: #333333;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.35;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-tech-grid .item:hover span,
.dataon-tech-grid .item:focus-visible span {
  color: #153879;
  font-weight: 800;
}

.dataon-tech-arrow {
  position: absolute;
  top: 0;
  z-index: 3;
  width: 50px;
  height: 100%;
  color: #263741;
  border: 0;
  border-radius: 0;
  background: #FFFFFF;
  box-shadow: none;
  font-size: 32px;
  transform: none;
}

.dataon-tech-arrow.is-prev {
  left: 23px;
}

.dataon-tech-arrow.is-next {
  right: 23px;
}

.dataon-board-section.sec07.sec_list {
  padding: 0;
  border-radius: 130px 0 0 130px;
  background: #F4FCFF;
}

.dataon-board-section.sec07.sec_list > .sec_inner,
.dataon-lower-data-section.sec04.sec_list > .sec_inner {
  max-width: 1310px;
  padding: 50px 0 70px;
}

.dataon-lower-data-section.sec04.sec_list {
  padding: 0;
  border-radius: 130px 0 0 130px;
  background: #FFFFFF;
}

.dataon-lower-data-section.sec04.sec_list > .sec_inner {
  padding-bottom: 50px;
}

.dataon-board-card.list_wrap {
  border: 0;
  background: transparent;
  box-shadow: none;
}

.dataon-board-head.list_tab_head,
.dataon-lower-tab-row.list_tab_head {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 45px;
  margin: 0 0 10px;
  padding-left: 15px;
}

.dataon-board-tabs,
.dataon-lower-tab-row.list_tab_head {
  display: flex;
  align-items: center;
  gap: 20px;
}

.dataon-lower-tab-row.list_tab_head {
  justify-content: flex-start;
}

.dataon-board-tabs button,
.dataon-lower-tab-row.list_tab_head button {
  position: relative;
  min-width: 0;
  min-height: 34px;
  padding: 0;
  color: #999999;
  border: 0;
  background: transparent;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: 0;
}

.dataon-board-tabs button.is-active,
.dataon-lower-tab-row.list_tab_head button.is-active {
  color: #0092E5;
  background: transparent;
}

.dataon-board-tabs button.is-active::before,
.dataon-lower-tab-row.list_tab_head button.is-active::before {
  position: absolute;
  top: -15px;
  left: 50%;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #0092E5;
  content: "";
  transform: translateX(-50%);
}

.dataon-board-more {
  position: absolute;
  top: -1px;
  right: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: #333333;
  border: 0;
  background: transparent;
  box-shadow: none;
  font-size: 29px;
}

.dataon-board-list.list_body,
.dataon-lower-data-grid.list_body {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 305px));
  align-items: stretch;
  justify-content: space-between;
  gap: 25px;
  padding: 5px;
}

.dataon-board-list.list_body .list_card,
.dataon-lower-data-grid.list_body .list_card {
  display: flex;
  flex-direction: column;
  width: 305px;
  max-width: 305px;
  height: 360px;
  min-height: 360px;
  padding: 20px;
  text-align: left;
  border: 1px solid #CCCCCC;
  border-radius: 15px;
  background: #FFFFFF;
  box-shadow: none;
  transition: border-color 0.3s, transform 0.3s;
}

.dataon-board-list.list_body .list_card:hover,
.dataon-board-list.list_body .list_card:focus-visible,
.dataon-lower-data-grid.list_body .list_card:hover,
.dataon-lower-data-grid.list_body .list_card:focus-visible {
  border-color: rgba(21, 56, 121, 0.5);
  transform: scale(1.02);
}

.dataon-board-category,
.dataon-lower-data-category {
  display: block;
  width: 100%;
  min-height: 24px;
  margin: 0 0 8px;
  padding: 0;
  overflow: hidden;
  color: #153879;
  border: 0;
  background: transparent;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.35;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-board-list.list_body .list_card strong,
.dataon-lower-data-grid.list_body .list_card strong {
  display: -webkit-box;
  height: 56px;
  margin: 0 0 40px;
  overflow: hidden;
  color: #333333;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.4;
  letter-spacing: 0;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dataon-board-list.list_body .list_card:hover strong,
.dataon-board-list.list_body .list_card:focus-visible strong,
.dataon-lower-data-grid.list_body .list_card:hover strong,
.dataon-lower-data-grid.list_body .list_card:focus-visible strong {
  color: #153879;
  text-decoration: underline;
}

.dataon-board-list.list_body .list_card p,
.dataon-lower-data-grid.list_body .list_card p {
  display: -webkit-box;
  height: 134px;
  margin: 0 0 14px;
  overflow: hidden;
  color: #777777;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.55;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

.dataon-board-list.list_body .list_card time {
  margin-top: auto;
  padding: 0;
  color: #777777;
  border: 0;
  background: transparent;
  font-size: 16px;
  font-weight: 400;
}

.dataon-lower-data-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 30px;
  margin-top: auto;
}

.dataon-lower-data-logo {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
}

.dataon-lower-data-logo img {
  max-width: 120px;
  height: 26px;
  object-fit: contain;
}

.dataon-lower-data-origin,
.dataon-lower-data-count {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 27px;
  padding: 1px 10px;
  color: #153879;
  border: 1px solid #153879;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.25;
  white-space: nowrap;
}

.dataon-usage-section.sec03 {
  overflow: hidden;
  padding: 0;
  border-radius: 0 150px 150px 0;
  background: #F4FCFF;
}

.dataon-usage-section.sec03 > .sec_inner {
  max-width: 1300px;
  padding: 50px 0;
}

.dataon-usage-section.sec03 h2 {
  margin: 0 0 20px;
  padding-left: 15px;
  color: #333333;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: 0;
}

.dataon-usage-grid.data_use {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 305px));
  align-items: stretch;
  justify-content: space-between;
  gap: 25px;
}

.dataon-usage-grid.data_use .dataon-usage-card {
  width: 305px;
  max-width: 305px;
  height: 340px;
  padding: 42px 30px;
  border-radius: 15px;
  color: #FFFFFF;
  background-position: left top;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.dataon-usage-grid.data_use .dataon-usage-card:nth-child(4),
.dataon-usage-grid.data_use .dataon-usage-card:nth-child(5) {
  grid-column: 4;
  grid-row: 1;
  color: #333333;
}

.dataon-link-section.sec06 {
  overflow: hidden;
  padding: 0;
  border-radius: 0 130px 130px 0;
  background: #FFFFFF;
}

.dataon-link-section.sec06 > .sec_inner {
  max-width: 1300px;
  position: relative;
  padding: 50px 0;
}

.dataon-link-banner.link_banner {
  min-height: 112px;
}

.dataon-link-slide.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 0 60px;
}

.dataon-link-slide.swiper-slide h3 {
  flex: 0 0 330px;
  position: relative;
  width: 330px;
  margin: 0 0 30px;
  padding-bottom: 20px;
  color: #333333;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.42;
  letter-spacing: 0;
}

.dataon-link-slide.swiper-slide h3::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100px;
  height: 3px;
  background: #153879;
  content: "";
}

.dataon-link-logo-grid.banner_logo {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 auto;
  min-width: 0;
  height: 100px;
  min-height: 100px;
  padding: 0 30px;
  border-radius: 10px;
  background: #FFFFFF;
}

.dataon-link-logo-grid.banner_logo a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 33.333%;
  min-width: 0;
  margin: 5px 10px;
  text-align: center;
}

.dataon-link-logo-grid.banner_logo img {
  max-width: 100%;
  height: 40px;
  object-fit: contain;
}

.dataon-link-arrow-row {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  pointer-events: none;
  transform: translateY(-50%);
}

.dataon-link-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: #333333;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  font-size: 32px;
  pointer-events: auto;
}

.dataon-mark-section.sec08 {
  padding: 0;
  background: #F4FCFF;
}

.dataon-mark-section.sec08 > .sec_inner {
  max-width: 1300px;
  padding: 50px 0;
}

.dataon-mark-grid.link_banner02 {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 305px));
  align-items: center;
  justify-content: space-between;
  gap: 25px;
}

.dataon-mark-grid.link_banner02 a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 305px;
  height: 80px;
  padding: 15px 0;
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: box-shadow 0.3s;
}

.dataon-mark-grid.link_banner02 a:hover,
.dataon-mark-grid.link_banner02 a:focus-visible {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}

.dataon-mark-grid.link_banner02 img {
  max-width: 80%;
  height: 50px;
  object-fit: contain;
}

.dataon-page[data-language=en] .dataon-provider-summary .total_tab_head button,
.dataon-page[data-language=en] .dataon-provider-summary .sum_cnt_row p,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_card h3,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box p,
.dataon-page[data-language=en] .dataon-board-tabs button,
.dataon-page[data-language=en] .dataon-lower-tab-row.list_tab_head button,
.dataon-page[data-language=en] .dataon-board-category,
.dataon-page[data-language=en] .dataon-lower-data-category,
.dataon-page[data-language=en] .dataon-board-list.list_body .list_card strong,
.dataon-page[data-language=en] .dataon-board-list.list_body .list_card p,
.dataon-page[data-language=en] .dataon-lower-data-grid.list_body .list_card strong,
.dataon-page[data-language=en] .dataon-lower-data-grid.list_body .list_card p,
.dataon-page[data-language=en] .dataon-usage-grid.data_use .dataon-usage-card span,
.dataon-page[data-language=en] .dataon-usage-grid.data_use .dataon-usage-card strong,
.dataon-page[data-language=en] .dataon-link-slide.swiper-slide h3 {
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}

.dataon-page[data-language=en] .dataon-tech-grid .item span {
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}

@media (max-width: 1380px) {
  .dataon-provider-section.sec01 > .sec_inner,
  .dataon-tech-section.sec02 > .sec_inner,
  .dataon-board-section.sec07.sec_list > .sec_inner,
  .dataon-lower-data-section.sec04.sec_list > .sec_inner,
  .dataon-usage-section.sec03 > .sec_inner,
  .dataon-link-section.sec06 > .sec_inner,
  .dataon-mark-section.sec08 > .sec_inner {
    width: calc(100% - 48px);
    max-width: 1300px;
  }
  .dataon-provider-carousel.total_conts {
    flex: 1 1 auto;
    width: auto;
    max-width: 950px;
  }
  .dataon-provider-arrow.is-prev {
    left: -34px;
  }
  .dataon-provider-arrow.is-next {
    right: -34px;
  }
}
@media (max-width: 1180px) {
  .dataon-provider-layout.total_cnt {
    height: auto;
    align-items: stretch;
  }
  .dataon-provider-summary.total_head {
    flex-basis: 230px;
    margin-top: 20px;
  }
  .dataon-provider-carousel.total_conts {
    height: auto;
    padding: 5px 34px;
  }
  .dataon-provider-grid.total_tab02.on {
    grid-template-columns: repeat(2, minmax(0, 300px));
    justify-content: center;
  }
  .dataon-provider-arrow.is-prev {
    left: -8px;
  }
  .dataon-provider-arrow.is-next {
    right: -8px;
  }
  .dataon-board-list.list_body,
  .dataon-lower-data-grid.list_body,
  .dataon-usage-grid.data_use,
  .dataon-mark-grid.link_banner02 {
    grid-template-columns: repeat(2, minmax(0, 305px));
    justify-content: center;
  }
  .dataon-usage-grid.data_use .dataon-usage-card:nth-child(4),
  .dataon-usage-grid.data_use .dataon-usage-card:nth-child(5) {
    grid-column: 2;
    grid-row: 2;
  }
  .dataon-tech-grid {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }
}
@media (max-width: 900px) {
  .dataon-provider-section.sec01 > .sec_inner {
    padding: 36px 24px;
  }
  .dataon-provider-layout.total_cnt {
    flex-direction: column;
    gap: 24px;
  }
  .dataon-provider-summary.total_head {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    min-height: 0;
    margin-top: 0;
  }
  .dataon-provider-carousel.total_conts {
    width: 100%;
    max-width: none;
    padding: 5px 34px;
  }
  .dataon-provider-grid.total_tab02.on {
    grid-template-columns: repeat(2, minmax(0, 300px));
  }
  .dataon-tech-carousel.classification {
    height: auto;
    min-height: 224px;
    padding: 24px 70px;
  }
  .dataon-tech-grid {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
    row-gap: 18px;
  }
  .dataon-link-slide.swiper-slide {
    flex-direction: column;
    align-items: stretch;
    padding: 0 48px;
  }
  .dataon-link-slide.swiper-slide h3 {
    flex: 0 0 auto;
    width: auto;
    margin-bottom: 12px;
  }
  .dataon-link-logo-grid.banner_logo {
    flex-wrap: wrap;
    height: auto;
    min-height: 100px;
    padding: 16px 20px;
  }
  .dataon-link-logo-grid.banner_logo a {
    flex: 1 1 calc(50% - 20px);
    width: calc(50% - 20px);
  }
}
@media (max-width: 680px) {
  .dataon-provider-section.sec01,
  .dataon-tech-section.sec02,
  .dataon-board-section.sec07.sec_list,
  .dataon-lower-data-section.sec04.sec_list,
  .dataon-usage-section.sec03,
  .dataon-link-section.sec06,
  .dataon-mark-section.sec08 {
    border-radius: 0;
  }
  .dataon-provider-section.sec01 > .sec_inner,
  .dataon-tech-section.sec02 > .sec_inner,
  .dataon-board-section.sec07.sec_list > .sec_inner,
  .dataon-lower-data-section.sec04.sec_list > .sec_inner,
  .dataon-usage-section.sec03 > .sec_inner,
  .dataon-link-section.sec06 > .sec_inner,
  .dataon-mark-section.sec08 > .sec_inner {
    width: calc(100% - 32px);
    padding-left: 0;
    padding-right: 0;
  }
  .dataon-provider-section.sec01 > .sec_inner {
    padding: 28px 18px;
  }
  .dataon-provider-grid.total_tab02.on,
  .dataon-board-list.list_body,
  .dataon-lower-data-grid.list_body,
  .dataon-usage-grid.data_use,
  .dataon-mark-grid.link_banner02 {
    grid-template-columns: minmax(0, 1fr);
    justify-content: stretch;
  }
  .dataon-provider-grid.total_tab02 .cnt_card,
  .dataon-board-list.list_body .list_card,
  .dataon-lower-data-grid.list_body .list_card,
  .dataon-usage-grid.data_use .dataon-usage-card,
  .dataon-mark-grid.link_banner02 a {
    width: 100%;
    max-width: none;
  }
  .dataon-provider-carousel.total_conts {
    padding: 5px 30px;
  }
  .dataon-provider-arrow {
    width: 34px;
    height: 44px;
    font-size: 24px;
  }
  .dataon-provider-arrow.is-prev {
    left: -6px;
  }
  .dataon-provider-arrow.is-next {
    right: -6px;
  }
  .dataon-tech-carousel.classification {
    padding: 24px 48px;
  }
  .dataon-tech-grid {
    grid-template-columns: 1fr;
  }
  .dataon-board-head.list_tab_head,
  .dataon-lower-tab-row.list_tab_head {
    align-items: flex-start;
    padding-right: 44px;
  }
  .dataon-board-tabs,
  .dataon-lower-tab-row.list_tab_head {
    flex-wrap: wrap;
  }
  .dataon-usage-grid.data_use .dataon-usage-card:nth-child(4),
  .dataon-usage-grid.data_use .dataon-usage-card:nth-child(5) {
    grid-column: 1;
    grid-row: auto;
  }
  .dataon-link-slide.swiper-slide {
    padding: 0 36px;
  }
  .dataon-link-logo-grid.banner_logo a {
    flex-basis: 100%;
    width: 100%;
    margin: 8px 0;
  }
}
/* ReviewOps i18n: keep controls in fixed slots across KO/EN text changes. */
.dataon-page .dataon-header-inner,
.dataon-page[data-language=en] .dataon-header-inner {
  gap: 28px;
}

.dataon-page .dataon-nav,
.dataon-page[data-language=en] .dataon-nav {
  flex: 1 1 auto;
  justify-content: center;
  gap: 0;
}

.dataon-page .dataon-nav-group,
.dataon-page[data-language=en] .dataon-nav-group {
  flex: 0 0 116px;
  min-width: 0;
}

.dataon-page .dataon-nav-button,
.dataon-page[data-language=en] .dataon-nav-button {
  justify-content: center;
  width: 100%;
  padding: 0 8px;
  overflow: hidden;
  font-size: 18px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page .dataon-auth,
.dataon-page[data-language=en] .dataon-auth {
  flex: 0 0 auto;
  gap: 0;
  font-size: 15px;
}

.dataon-page .dataon-auth-button,
.dataon-page[data-language=en] .dataon-auth-button {
  flex: 0 0 88px;
  justify-content: center;
  width: 88px;
  max-width: 88px;
  padding: 0 10px;
  overflow: hidden;
  font-size: 15px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page .dataon-sitemap-toggle,
.dataon-page[data-language=en] .dataon-sitemap-toggle {
  flex: 0 0 56px;
  justify-content: center;
  width: 56px;
  min-width: 56px;
  padding: 0;
}

.dataon-page .dataon-nav-panel,
.dataon-page[data-language=en] .dataon-nav-panel {
  grid-auto-columns: 176px;
  gap: 28px;
  padding-right: clamp(32px, 10vw, 160px);
  padding-left: clamp(32px, 10vw, 160px);
}

.dataon-page .dataon-nav-panel-heading,
.dataon-page .dataon-nav-panel-link,
.dataon-page .dataon-sitemap-title,
.dataon-page .dataon-sitemap-section-title,
.dataon-page .dataon-sitemap-link,
.dataon-page .dataon-mobile-major-menu button,
.dataon-page .dataon-mobile-minor-title,
.dataon-page .dataon-mobile-section-title,
.dataon-page .dataon-mobile-minor-link,
.dataon-page[data-language=en] .dataon-nav-panel-heading,
.dataon-page[data-language=en] .dataon-nav-panel-link,
.dataon-page[data-language=en] .dataon-sitemap-title,
.dataon-page[data-language=en] .dataon-sitemap-section-title,
.dataon-page[data-language=en] .dataon-sitemap-link,
.dataon-page[data-language=en] .dataon-mobile-major-menu button,
.dataon-page[data-language=en] .dataon-mobile-minor-title,
.dataon-page[data-language=en] .dataon-mobile-section-title,
.dataon-page[data-language=en] .dataon-mobile-minor-link {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page .dataon-sitemap-grid,
.dataon-page[data-language=en] .dataon-sitemap-grid {
  gap: 28px;
}

.dataon-page .dataon-sitemap-title,
.dataon-page[data-language=en] .dataon-sitemap-title {
  min-height: 64px;
  font-size: clamp(24px, 2.3vw, 32px);
}

.dataon-page .dataon-hero-title,
.dataon-page[data-language=en] .dataon-hero-title {
  max-width: 980px;
  font-size: clamp(34px, 3.3vw, 48px);
  line-height: 1.32;
}

.dataon-page .dataon-hero-shortcuts,
.dataon-page[data-language=en] .dataon-hero-shortcuts {
  flex-wrap: nowrap;
  justify-content: flex-end;
  max-width: 850px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.dataon-page .dataon-search-action-row,
.dataon-page[data-language=en] .dataon-search-action-row {
  flex-wrap: nowrap;
  justify-content: flex-end;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.dataon-page .dataon-hero-shortcuts::-webkit-scrollbar,
.dataon-page .dataon-search-action-row::-webkit-scrollbar,
.dataon-page[data-language=en] .dataon-hero-shortcuts::-webkit-scrollbar,
.dataon-page[data-language=en] .dataon-search-action-row::-webkit-scrollbar {
  display: none;
}

.dataon-page .dataon-hero-shortcuts button,
.dataon-page[data-language=en] .dataon-hero-shortcuts button {
  flex: 0 0 138px;
  width: 138px;
  padding: 0 12px;
  overflow: hidden;
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page .dataon-search-action-row button,
.dataon-page[data-language=en] .dataon-search-action-row button {
  flex: 0 0 132px;
  width: 132px;
  padding: 0 12px;
  overflow: hidden;
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page .dataon-home-tab-row button,
.dataon-page .dataon-board-tabs button,
.dataon-page[data-language=en] .dataon-home-tab-row button,
.dataon-page[data-language=en] .dataon-board-tabs button {
  flex: 0 0 96px;
  width: 96px;
  min-width: 96px;
  padding: 0 12px;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page .dataon-provider-summary button,
.dataon-page[data-language=en] .dataon-provider-summary button {
  width: 160px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-page .dataon-provider-grid dl div,
.dataon-page[data-language=en] .dataon-provider-grid dl div {
  grid-template-columns: 86px minmax(0, 1fr);
}

.dataon-page .dataon-provider-grid dt,
.dataon-page .dataon-provider-grid dd,
.dataon-page .dataon-hero-stats span,
.dataon-page .dataon-hero-stats em,
.dataon-page .dataon-hero-stats small,
.dataon-page .dataon-tech-grid button span,
.dataon-page .dataon-board-category,
.dataon-page .dataon-board-list strong,
.dataon-page .dataon-board-list time,
.dataon-page[data-language=en] .dataon-provider-grid dt,
.dataon-page[data-language=en] .dataon-provider-grid dd,
.dataon-page[data-language=en] .dataon-hero-stats span,
.dataon-page[data-language=en] .dataon-hero-stats em,
.dataon-page[data-language=en] .dataon-hero-stats small,
.dataon-page[data-language=en] .dataon-tech-grid button span,
.dataon-page[data-language=en] .dataon-board-category,
.dataon-page[data-language=en] .dataon-board-list strong,
.dataon-page[data-language=en] .dataon-board-list time {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 1320px) {
  .dataon-page .dataon-nav-group,
  .dataon-page[data-language=en] .dataon-nav-group {
    flex-basis: 98px;
  }
  .dataon-page .dataon-auth-button,
  .dataon-page[data-language=en] .dataon-auth-button {
    flex-basis: 78px;
    width: 78px;
    max-width: 78px;
    padding: 0 8px;
  }
}
@media (max-width: 1180px) {
  .dataon-page .dataon-nav-group,
  .dataon-page[data-language=en] .dataon-nav-group {
    flex-basis: 84px;
  }
  .dataon-page .dataon-nav-button,
  .dataon-page[data-language=en] .dataon-nav-button {
    font-size: 15px;
  }
}
@media (max-width: 1100px) {
  .dataon-page .dataon-header-inner,
  .dataon-page[data-language=en] .dataon-header-inner {
    gap: 16px;
  }
  .dataon-page .dataon-logo,
  .dataon-page[data-language=en] .dataon-logo {
    height: 38px;
  }
  .dataon-page .dataon-nav-group,
  .dataon-page[data-language=en] .dataon-nav-group {
    flex-basis: 74px;
  }
  .dataon-page .dataon-nav-button,
  .dataon-page[data-language=en] .dataon-nav-button {
    font-size: 14px;
  }
  .dataon-page .dataon-auth-button,
  .dataon-page[data-language=en] .dataon-auth-button {
    flex-basis: 68px;
    width: 68px;
    max-width: 68px;
    font-size: 13px;
  }
  .dataon-page .dataon-sitemap-toggle,
  .dataon-page[data-language=en] .dataon-sitemap-toggle {
    flex-basis: 48px;
    width: 48px;
    min-width: 48px;
  }
}
/* ReviewOps i18n: lock icon slots and keep labels readable without ellipsis. */
.dataon-page .dataon-tech-grid .item,
.dataon-page[data-language=en] .dataon-tech-grid .item {
  display: grid;
  grid-template-rows: 100px minmax(58px, auto);
  align-content: center;
  justify-items: center;
  row-gap: 14px;
  height: 180px;
  min-height: 180px;
  padding: 0 8px;
  overflow: visible;
}

.dataon-page .dataon-tech-grid .item img,
.dataon-page[data-language=en] .dataon-tech-grid .item img {
  grid-row: 1;
  align-self: center;
  justify-self: center;
  width: 100px;
  height: 100px;
  margin: 0;
}

.dataon-page .dataon-tech-grid .item span,
.dataon-page[data-language=en] .dataon-tech-grid .item span {
  grid-row: 2;
  align-self: center;
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 172px;
  min-height: 58px;
  height: auto;
  max-height: none;
  margin: 0;
  overflow: visible;
  line-height: 1.25;
  text-align: center;
  text-overflow: clip;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: break-word;
}

/* ReviewOps qifbssaedweinwzmetstkvexfnftrfmw: match DataON home tab/card polish and keep icon hover one-way. */
.dataon-page .dataon-provider-summary .total_tab_head button,
.dataon-page[data-language=en] .dataon-provider-summary .total_tab_head button {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
  max-width: none;
  min-height: 31px;
  padding: 0;
  overflow: visible;
  color: #999999;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  text-overflow: clip;
  white-space: nowrap;
}

.dataon-page .dataon-provider-summary .total_tab_head button.is-active,
.dataon-page[data-language=en] .dataon-provider-summary .total_tab_head button.is-active {
  color: #0092E5;
  font-weight: 800;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_card,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_card {
  text-align: center;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_card h3,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_card h3 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  margin: 18px 18px 0;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;
  -webkit-line-clamp: initial;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_box,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box {
  align-items: center;
  height: 154px;
  margin: 16px 10px 10px;
  padding: 18px 20px;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_box > div,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box > div {
  align-items: center;
  justify-content: center;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_box p,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box p {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  margin-bottom: 22px;
  font-size: 16.5px;
  line-height: 1.3;
  text-align: center;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_left p,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_left p {
  width: 100%;
  padding-left: 28px;
  background-position: calc(50% - 48px) center;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_left p.files,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_left p.files {
  background-position: calc(50% - 64px) center;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_right,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_right {
  text-align: center;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_right p,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_right p {
  color: #153879;
  font-size: 17px;
  font-weight: 800;
  text-align: center;
}

.dataon-page .dataon-tech-grid .item img,
.dataon-page[data-language=en] .dataon-tech-grid .item img {
  transform: rotateY(0deg);
  transition: none;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  will-change: transform;
}

.dataon-page .dataon-tech-grid .item:hover img,
.dataon-page .dataon-tech-grid .item:focus-visible img,
.dataon-page[data-language=en] .dataon-tech-grid .item:hover img,
.dataon-page[data-language=en] .dataon-tech-grid .item:focus-visible img {
  animation: dataon-tech-icon-spin 0.7s ease both;
}

.dataon-page .dataon-tech-grid .item span,
.dataon-page[data-language=en] .dataon-tech-grid .item span {
  font-size: 16px;
  font-weight: 500;
}

@keyframes dataon-tech-icon-spin {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
}
.dataon-page .dataon-nav-button,
.dataon-page .dataon-auth-button,
.dataon-page .dataon-nav-panel-heading,
.dataon-page .dataon-nav-panel-link,
.dataon-page .dataon-sitemap-title,
.dataon-page .dataon-sitemap-section-title,
.dataon-page .dataon-sitemap-link,
.dataon-page .dataon-mobile-major-menu button,
.dataon-page .dataon-mobile-minor-title,
.dataon-page .dataon-mobile-section-title,
.dataon-page .dataon-mobile-minor-link,
.dataon-page .dataon-home-tab-row button,
.dataon-page .dataon-board-tabs button,
.dataon-page .dataon-provider-summary button,
.dataon-page[data-language=en] .dataon-nav-button,
.dataon-page[data-language=en] .dataon-auth-button,
.dataon-page[data-language=en] .dataon-nav-panel-heading,
.dataon-page[data-language=en] .dataon-nav-panel-link,
.dataon-page[data-language=en] .dataon-sitemap-title,
.dataon-page[data-language=en] .dataon-sitemap-section-title,
.dataon-page[data-language=en] .dataon-sitemap-link,
.dataon-page[data-language=en] .dataon-mobile-major-menu button,
.dataon-page[data-language=en] .dataon-mobile-minor-title,
.dataon-page[data-language=en] .dataon-mobile-section-title,
.dataon-page[data-language=en] .dataon-mobile-minor-link,
.dataon-page[data-language=en] .dataon-home-tab-row button,
.dataon-page[data-language=en] .dataon-board-tabs button,
.dataon-page[data-language=en] .dataon-provider-summary button {
  text-overflow: clip;
}

.dataon-page .dataon-hero-shortcuts button,
.dataon-page[data-language=en] .dataon-hero-shortcuts button,
.dataon-page .dataon-search-action-row button,
.dataon-page[data-language=en] .dataon-search-action-row button {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: center;
  justify-content: stretch;
  justify-items: center;
  column-gap: 8px;
}

.dataon-page .dataon-hero-shortcuts button img,
.dataon-page .dataon-hero-shortcuts button i,
.dataon-page .dataon-search-action-row button img,
.dataon-page .dataon-search-action-row button i,
.dataon-page[data-language=en] .dataon-hero-shortcuts button img,
.dataon-page[data-language=en] .dataon-hero-shortcuts button i,
.dataon-page[data-language=en] .dataon-search-action-row button img,
.dataon-page[data-language=en] .dataon-search-action-row button i {
  grid-column: 1;
  justify-self: center;
  width: 24px;
  min-width: 24px;
  margin: 0;
  text-align: center;
}

.dataon-page .dataon-hero-shortcuts button span,
.dataon-page .dataon-search-action-row button span,
.dataon-page[data-language=en] .dataon-hero-shortcuts button span,
.dataon-page[data-language=en] .dataon-search-action-row button span {
  grid-column: 2;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  overflow: visible;
  line-height: 1.15;
  text-align: left;
  text-overflow: clip;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.dataon-page .dataon-floating-quick button:not(.dataon-floating-top),
.dataon-page[data-language=en] .dataon-floating-quick button:not(.dataon-floating-top) {
  display: grid;
  grid-template-rows: 30px minmax(20px, auto);
  align-content: center;
  justify-items: center;
  row-gap: 5px;
}

.dataon-page .dataon-floating-quick button:not(.dataon-floating-top) img,
.dataon-page[data-language=en] .dataon-floating-quick button:not(.dataon-floating-top) img {
  grid-row: 1;
  align-self: center;
  justify-self: center;
  width: 30px;
  height: 30px;
  margin: 0;
}

.dataon-page .dataon-floating-quick button:not(.dataon-floating-top) span,
.dataon-page[data-language=en] .dataon-floating-quick button:not(.dataon-floating-top) span {
  grid-row: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 20px;
  overflow: visible;
  line-height: 1.12;
  text-align: center;
  text-overflow: clip;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.dataon-page .dataon-map-region-input button,
.dataon-page .dataon-map-tool-buttons button,
.dataon-page .dataon-map-reset-button,
.dataon-page .dataon-lower-data-count,
.dataon-page[data-language=en] .dataon-map-region-input button,
.dataon-page[data-language=en] .dataon-map-tool-buttons button,
.dataon-page[data-language=en] .dataon-map-reset-button,
.dataon-page[data-language=en] .dataon-lower-data-count {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: center;
  justify-content: stretch;
  justify-items: center;
  column-gap: 7px;
}

.dataon-page .dataon-map-region-input button i,
.dataon-page .dataon-map-tool-buttons button i,
.dataon-page .dataon-map-reset-button i,
.dataon-page .dataon-lower-data-count i,
.dataon-page[data-language=en] .dataon-map-region-input button i,
.dataon-page[data-language=en] .dataon-map-tool-buttons button i,
.dataon-page[data-language=en] .dataon-map-reset-button i,
.dataon-page[data-language=en] .dataon-lower-data-count i {
  grid-column: 1;
  justify-self: center;
  width: 18px;
  min-width: 18px;
  margin: 0;
  text-align: center;
}

.dataon-page .dataon-map-region-input button span,
.dataon-page .dataon-map-tool-buttons button span,
.dataon-page .dataon-map-reset-button span,
.dataon-page[data-language=en] .dataon-map-region-input button span,
.dataon-page[data-language=en] .dataon-map-tool-buttons button span,
.dataon-page[data-language=en] .dataon-map-reset-button span {
  grid-column: 2;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  overflow: visible;
  line-height: 1.15;
  text-align: left;
  text-overflow: clip;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.dataon-page .dataon-lower-data-count,
.dataon-page[data-language=en] .dataon-lower-data-count {
  max-width: 120px;
  overflow: visible;
  line-height: 1.15;
  text-overflow: clip;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: break-word;
}

/* ReviewOps zthluqfwfwmydggwhvyqthxrvngbjsbi: responsive quick menu */
.dataon-page .dataon-floating-quick,
.dataon-page[data-language=en] .dataon-floating-quick {
  z-index: 9000;
}

.dataon-page .dataon-quick-panel,
.dataon-page[data-language=en] .dataon-quick-panel {
  display: grid;
}

.dataon-page .dataon-quick-close,
.dataon-page .dataon-mobile-quick-actions,
.dataon-page[data-language=en] .dataon-quick-close,
.dataon-page[data-language=en] .dataon-mobile-quick-actions {
  display: none;
}

@media (min-width: 1025px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    position: fixed;
    top: 210px;
    right: 24px;
    bottom: auto;
    display: grid !important;
    width: 96px;
    overflow: hidden;
    visibility: visible;
    border: 1px solid #DDE7F3;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0 14px 34px rgba(5, 35, 82, 0.18);
    opacity: 1;
    pointer-events: auto;
    transform: none;
  }
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    position: static;
    width: auto;
    overflow: visible;
    visibility: visible;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    opacity: 1;
    pointer-events: auto;
    transform: none;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-top,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-top {
    display: grid;
  }
}
@media (max-width: 1024px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    position: fixed;
    top: auto;
    right: 22px;
    bottom: calc(22px + env(safe-area-inset-bottom));
    display: block !important;
    width: auto;
    overflow: visible;
    visibility: hidden;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    opacity: 0;
    pointer-events: none;
    transform: translateY(12px);
    transition: opacity 180ms ease, transform 180ms ease, visibility 180ms ease;
  }
  .dataon-page .dataon-floating-quick.is-mobile-visible,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-visible {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    position: absolute;
    right: 0;
    bottom: 72px;
    display: grid;
    width: 112px;
    overflow: hidden;
    visibility: hidden;
    border: 1px solid #DDE7F3;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0 16px 36px rgba(5, 35, 82, 0.24);
    opacity: 0;
    pointer-events: none;
    transform: translateY(8px);
    transform-origin: right bottom;
    transition: opacity 160ms ease, transform 160ms ease, visibility 160ms ease;
  }
  .dataon-page .dataon-floating-quick.is-mobile-open .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-open .dataon-quick-panel {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
  .dataon-page .dataon-floating-quick strong,
  .dataon-page[data-language=en] .dataon-floating-quick strong {
    padding: 11px 8px 10px;
    background: #0A2A64;
    font-size: 13px;
  }
  .dataon-page .dataon-floating-quick strong span,
  .dataon-page[data-language=en] .dataon-floating-quick strong span {
    font-size: 11px;
  }
  .dataon-page .dataon-floating-quick .dataon-quick-close,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close {
    display: flex;
    min-height: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 0 8px;
    color: #43506A;
    border-bottom: 1px solid #EEF2F7;
    background: #F7FAFE;
    font-size: 12px;
    font-weight: 850;
    line-height: 1;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link {
    display: grid;
    grid-template-rows: 28px minmax(18px, auto);
    min-height: 64px;
    align-content: center;
    justify-items: center;
    row-gap: 4px;
    padding: 8px 7px;
    color: #24354F;
    border-bottom: 1px solid #EEF2F7;
    background: #FFFFFF;
    font-size: 11px;
    font-weight: 850;
    line-height: 1.12;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link img,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link img {
    width: 28px;
    height: 28px;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link span,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-width: 0;
    text-align: center;
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: break-word;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-top,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-top {
    display: none;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions {
    display: grid;
    grid-template-columns: repeat(2, 58px);
    gap: 10px;
    pointer-events: auto;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions button {
    display: inline-flex;
    width: 58px;
    min-width: 58px;
    height: 58px;
    min-height: 58px;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #FFFFFF;
    border: 1px solid rgba(255, 255, 255, 0.72);
    border-radius: 50%;
    font-size: 13px;
    font-weight: 950;
    line-height: 1;
    box-shadow: 0 12px 28px rgba(5, 35, 82, 0.24);
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-toggle,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-toggle {
    background: #0A2A64;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-toggle[aria-expanded=true],
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-toggle[aria-expanded=true] {
    background: #143C82;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-top-button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-top-button {
    background: #0B77E3;
  }
}
@media (max-width: 520px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    right: 16px;
    bottom: calc(18px + env(safe-area-inset-bottom));
  }
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    bottom: 66px;
    width: 108px;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions {
    grid-template-columns: repeat(2, 54px);
    gap: 8px;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions button {
    width: 54px;
    min-width: 54px;
    height: 54px;
    min-height: 54px;
    font-size: 12px;
  }
}
/* ReviewOps zthluqfwfwmydggwhvyqthxrvngbjsbi: follow-up alignment */
.dataon-page .dataon-hero-stats,
.dataon-page[data-language=en] .dataon-hero-stats {
  bottom: 28px;
  width: min(760px, 100% - 72px);
  padding: 8px;
  overflow: visible;
  border: 1px solid rgba(221, 231, 243, 0.92);
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 16px 36px rgba(0, 18, 58, 0.24);
}

.dataon-page .dataon-hero-stats button,
.dataon-page[data-language=en] .dataon-hero-stats button {
  display: grid;
  grid-template-columns: 50px minmax(0, 1fr);
  align-items: center;
  column-gap: 14px;
  min-height: 90px;
  padding: 16px 24px;
  border-radius: 11px;
  text-align: left;
}

.dataon-page .dataon-hero-stats button + button,
.dataon-page[data-language=en] .dataon-hero-stats button + button {
  border-left: 1px solid #DDE7F3;
}

.dataon-page .dataon-hero-stats img,
.dataon-page[data-language=en] .dataon-hero-stats img {
  width: 44px;
  height: 44px;
}

.dataon-page .dataon-hero-stat-copy,
.dataon-page[data-language=en] .dataon-hero-stat-copy {
  display: grid;
  min-width: 0;
  gap: 8px;
}

.dataon-page .dataon-hero-stats span,
.dataon-page[data-language=en] .dataon-hero-stats span {
  display: block;
  min-width: 0;
  color: #44536A;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.25;
  white-space: normal;
}

.dataon-page .dataon-hero-stat-value,
.dataon-page[data-language=en] .dataon-hero-stat-value {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 3px 6px;
  min-width: 0;
}

.dataon-page .dataon-hero-stats strong,
.dataon-page[data-language=en] .dataon-hero-stats strong {
  color: #0B77E3;
  font-size: 29px;
  font-weight: 950;
  line-height: 1.05;
  white-space: normal;
}

.dataon-page .dataon-hero-stats em,
.dataon-page .dataon-hero-stats small,
.dataon-page[data-language=en] .dataon-hero-stats em,
.dataon-page[data-language=en] .dataon-hero-stats small {
  color: #66748A;
  font-size: 15px;
  font-style: normal;
  font-weight: 850;
  line-height: 1.15;
  white-space: normal;
}

.dataon-page .dataon-provider-summary.total_head,
.dataon-page[data-language=en] .dataon-provider-summary.total_head {
  flex: 0 0 240px;
  height: 241px;
  min-height: 241px;
  margin-top: 22px;
  padding: 5px;
}

.dataon-page .dataon-provider-summary .total_tab_head,
.dataon-page[data-language=en] .dataon-provider-summary .total_tab_head {
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 0;
}

.dataon-page .dataon-provider-summary .total_tab_head button,
.dataon-page[data-language=en] .dataon-provider-summary .total_tab_head button {
  min-height: 34px;
  color: #999999;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.25;
}

.dataon-page .dataon-provider-summary .total_tab_head button.is-active,
.dataon-page[data-language=en] .dataon-provider-summary .total_tab_head button.is-active {
  color: #0092E5;
  font-weight: 800;
}

.dataon-page .dataon-provider-summary .total_sum_cnt,
.dataon-page[data-language=en] .dataon-provider-summary .total_sum_cnt {
  margin-top: 30px;
}

.dataon-page .dataon-provider-summary .sum_cnt_row,
.dataon-page[data-language=en] .dataon-provider-summary .sum_cnt_row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 22px;
}

.dataon-page .dataon-provider-summary .sum_cnt_row p,
.dataon-page[data-language=en] .dataon-provider-summary .sum_cnt_row p {
  margin: 0;
  color: #333333;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.25;
  white-space: nowrap;
}

.dataon-page .dataon-provider-summary .sum_cnt_row p:last-child,
.dataon-page[data-language=en] .dataon-provider-summary .sum_cnt_row p:last-child {
  color: #0092E5;
  font-size: 27px;
  font-weight: 800;
  text-align: right;
  white-space: nowrap;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_card,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_card {
  text-align: left;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_card h3,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_card h3 {
  display: -webkit-box;
  height: 58px;
  align-items: initial;
  justify-content: initial;
  margin: 20px 20px 0;
  overflow: hidden;
  color: #333333;
  font-size: 21px;
  font-weight: 600;
  line-height: 1.35;
  text-align: left;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_box,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box {
  align-items: flex-start;
  height: 157px;
  margin: 18px 10px 10px;
  padding: 20px;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_box > div,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box > div {
  align-items: flex-start;
  justify-content: flex-start;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_box p,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box p {
  display: block;
  min-height: 24px;
  margin: 0 0 24px;
  color: #333333;
  font-size: 16.5px;
  font-weight: 500;
  line-height: 1.3;
  text-align: left;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_left p,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_left p {
  width: auto;
  padding-left: 32px;
  background-position: left center;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_left p.data,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_left p.data {
  background: url("/assets/dataon/2024/icon_data.svg") left center/24px 22px no-repeat;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_left p.field,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_left p.field {
  background: url("/assets/dataon/2024/icon_field.svg") left center/24px 24px no-repeat;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_left p.files,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_left p.files {
  background: url("/assets/dataon/2024/icon_file.svg") left center/24px 18px no-repeat;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_right,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_right {
  flex: 1 1 auto;
  align-items: flex-end;
  text-align: right;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_right p,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_right p {
  width: 100%;
  color: #153879;
  font-size: 17px;
  font-weight: 800;
  text-align: right;
}

@media (max-width: 1440px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    position: fixed;
    top: auto;
    right: 28px;
    bottom: calc(30px + env(safe-area-inset-bottom));
    display: block !important;
    width: auto;
    overflow: visible;
    visibility: hidden;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    opacity: 0;
    pointer-events: none;
    transform: translateY(12px);
    transition: opacity 180ms ease, transform 180ms ease, visibility 180ms ease;
  }
  .dataon-page .dataon-floating-quick.is-mobile-visible,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-visible {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    position: absolute;
    right: 0;
    bottom: 148px;
    display: grid;
    width: 112px;
    overflow: hidden;
    visibility: hidden;
    border: 1px solid #DDE7F3;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0 16px 36px rgba(5, 35, 82, 0.24);
    opacity: 0;
    pointer-events: none;
    transform: translateY(8px);
    transform-origin: right bottom;
    transition: opacity 160ms ease, transform 160ms ease, visibility 160ms ease;
  }
  .dataon-page .dataon-floating-quick.is-mobile-open .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-open .dataon-quick-panel {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
  .dataon-page .dataon-floating-quick .dataon-floating-top,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-top {
    display: none;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions {
    display: grid;
    grid-template-columns: 64px;
    grid-auto-rows: 64px;
    gap: 8px;
    pointer-events: auto;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions button {
    display: inline-flex;
    width: 64px;
    min-width: 64px;
    height: 64px;
    min-height: 64px;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #FFFFFF;
    border: 0;
    border-radius: 50%;
    background: #153879;
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
    box-shadow: 0 10px 24px rgba(5, 35, 82, 0.24);
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-toggle,
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-toggle[aria-expanded=true],
  .dataon-page .dataon-floating-quick .dataon-mobile-top-button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-toggle,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-toggle[aria-expanded=true],
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-top-button {
    background: #153879;
  }
}
@media (max-width: 760px) {
  .dataon-page .dataon-hero-stats,
  .dataon-page[data-language=en] .dataon-hero-stats {
    bottom: 20px;
    width: min(680px, 100% - 36px);
    padding: 7px;
  }
  .dataon-page .dataon-hero-stats button,
  .dataon-page[data-language=en] .dataon-hero-stats button {
    grid-template-columns: 42px minmax(0, 1fr);
    min-height: 82px;
    padding: 13px 14px;
    column-gap: 10px;
  }
  .dataon-page .dataon-hero-stats img,
  .dataon-page[data-language=en] .dataon-hero-stats img {
    width: 38px;
    height: 38px;
  }
  .dataon-page .dataon-hero-stats strong,
  .dataon-page[data-language=en] .dataon-hero-stats strong {
    font-size: 24px;
  }
  .dataon-page .dataon-hero-stats em,
  .dataon-page .dataon-hero-stats small,
  .dataon-page[data-language=en] .dataon-hero-stats em,
  .dataon-page[data-language=en] .dataon-hero-stats small {
    font-size: 13px;
  }
}
/* ReviewOps qifbssaedweinwzmetstkvexfnftrfmw: final provider card text alignment guard. */
.dataon-page .dataon-provider-grid.total_tab02 .cnt_card,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_card {
  text-align: center;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_card h3,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_card h3 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  margin: 16px 18px 0;
  overflow: visible;
  color: #333333;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  -webkit-box-orient: initial;
  -webkit-line-clamp: unset;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_box,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box,
.dataon-page .dataon-provider-grid.total_tab02 .cnt_box > div,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box > div {
  align-items: center;
  justify-content: center;
}

.dataon-page .dataon-provider-grid.total_tab02 .cnt_box p,
.dataon-page[data-language=en] .dataon-provider-grid.total_tab02 .cnt_box p {
  font-size: 17px;
  text-align: center;
}

/* ReviewOps aegkxgxratdrqdyfbmbixzrslufrmpdz: official search result page. */
.dataon-official-search-page,
.dataon-official-search-page button,
.dataon-official-search-page input,
.dataon-official-search-page select {
  font-family: "NanumSquare", "Noto Sans KR", "SUIT", sans-serif;
  letter-spacing: 0;
}

.dataon-official-clone .dataon-official-content-tabs {
  display: flex;
  align-items: center;
  height: 3.625rem;
  margin: 0 0 1.75rem;
  border-bottom: 1px solid #D8D8D8;
}

.dataon-official-clone .dataon-official-content-tabs button {
  position: relative;
  min-width: 7.5rem;
  height: 3.625rem;
  padding: 0 1.55rem;
  color: #666666;
  border: 1px solid #D8D8D8;
  border-right: 0;
  border-bottom: 0;
  background: #FFFFFF;
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 3.625rem;
  text-align: center;
}

.dataon-official-clone .dataon-official-content-tabs button:last-child {
  border-right: 1px solid #D8D8D8;
}

.dataon-official-clone .dataon-official-content-tabs button.is-active {
  z-index: 1;
  color: #FFFFFF;
  border-color: #0E4B98;
  background: #0E4B98;
}

.dataon-official-clone .dataon-official-selected-keywords {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  min-height: 2rem;
  margin: 0.9rem 0 0.85rem;
}

.dataon-official-clone .dataon-official-selected-keywords span {
  display: inline-flex;
  max-width: 100%;
  min-height: 1.75rem;
  align-items: center;
  padding: 0 0.65rem;
  overflow: hidden;
  color: #18488F;
  border: 1px solid #C5D7EF;
  background: #F3F8FF;
  font-size: 0.875rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-official-clone .schSel_btnWrap {
  display: flex;
  gap: 0.375rem;
}

.dataon-official-clone .schSel_btnWrap button {
  min-width: 5.5rem;
  height: 2.25rem;
  padding: 0 0.75rem;
  font-size: 0.875rem;
  font-weight: 700;
}

.dataon-official-clone .schSel_btnWrap .btn_def.blue {
  color: #FFFFFF;
  background: #1053C8;
}

.dataon-official-clone .schSel_btnWrap .btn_reset {
  color: #333333;
  border: 1px solid #BFC8D6;
  background: #FFFFFF;
}

.dataon-official-clone .totSch .totSch_left .totSch_btnBox {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 2.5rem;
  width: 100%;
}

.dataon-official-clone .totSch .totSch_left .totSch_btnBox input {
  min-width: 0;
  height: 2.5rem;
  padding: 0 0.75rem;
  border: 1px solid #D1D1D1;
  border-right: 0;
  font-size: 0.9375rem;
}

.dataon-official-clone .totSch .totSch_left .totSch_btnBox .schBtn {
  width: 2.5rem;
  height: 2.5rem;
  background: #3B3D3D;
}

.dataon-official-clone .totSch .totSch_left .totSch_btnBox .schBtn::before {
  color: #FFFFFF;
  font-family: "Font Awesome 6 Free";
  font-size: 0.875rem;
  font-weight: 900;
  content: "\f002";
}

.dataon-official-clone .dataon-official-inner-reset {
  margin-top: 0.6rem;
  color: #0E4B98;
  font-size: 0.8125rem;
  font-weight: 700;
  background: transparent;
}

.dataon-official-clone .dataon-official-totsch-info {
  display: block;
  min-height: 2.5rem;
  margin: 0 0 1rem;
}

.dataon-official-clone .dataon-official-totsch-info .rst_cnt dd {
  color: #0E4B98;
  font-weight: 800;
}

.dataon-official-clone .dataon-official-sort-list {
  float: right;
  display: flex;
  align-items: center;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-clone .dataon-official-sort-list li {
  position: relative;
  padding: 0 0.7rem;
}

.dataon-official-clone .dataon-official-sort-list li + li::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 1px;
  height: 0.75rem;
  background: #D4D4D4;
  content: "";
  transform: translateY(-50%);
}

.dataon-official-clone .dataon-official-sort-list button {
  color: #777777;
  font-size: 0.9375rem;
  font-weight: 500;
  background: transparent;
}

.dataon-official-clone .dataon-official-sort-list button.is-active {
  color: #0E4B98;
  font-weight: 800;
}

.dataon-official-clone .dataon-official-search-results > li:hover {
  background: #F7FBFF;
}

.dataon-official-clone .dataon-official-search-list-item .title {
  display: block;
  max-height: none;
}

.dataon-official-clone .dataon-official-search-list-item .title button {
  display: inline;
  color: #222222;
  background: transparent;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.55;
  text-align: left;
  vertical-align: middle;
}

.dataon-official-clone .dataon-official-search-list-item .title button:hover,
.dataon-official-clone .dataon-official-search-list-item .title button:focus-visible {
  color: #0E4B98;
  text-decoration: underline;
}

.dataon-official-clone .dataon-official-result-tags {
  margin-top: 0.7rem;
}

.dataon-official-clone .dataon-official-result-tags span {
  height: 1.55rem;
  padding: 0 0.55rem;
  color: #0E4B98;
  border: 1px solid #D3E1F3;
  background: #F5F9FE;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.45rem;
}

.dataon-official-clone .dataon-official-search-side {
  border: 1px solid #DDDDDD;
  background: #FFFFFF;
}

.dataon-official-clone .dataon-official-search-side dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
  padding: 0;
}

.dataon-official-clone .dataon-official-search-side dl div {
  min-height: 4.625rem;
  padding: 0.85rem 0.4rem;
  text-align: center;
  border-right: 1px solid #E2E2E2;
  border-bottom: 1px solid #E2E2E2;
}

.dataon-official-clone .dataon-official-search-side dl div:nth-child(2n) {
  border-right: 0;
}

.dataon-official-clone .dataon-official-search-side dt {
  margin: 0 0 0.25rem;
  color: #777777;
  font-size: 0.8125rem;
  font-weight: 400;
}

.dataon-official-clone .dataon-official-search-side dd {
  margin: 0;
  color: #111111;
  font-family: "Montserrat", "NanumSquare", sans-serif;
  font-size: 1.125rem;
  font-weight: 800;
  line-height: 1.25;
}

.dataon-official-clone .dataon-official-search-side button {
  width: 100%;
  height: 2.75rem;
  color: #FFFFFF;
  background: #0E4B98;
  font-size: 0.9375rem;
  font-weight: 800;
}

.dataon-official-clone .dataon-official-no-result {
  display: grid;
  justify-items: center;
  gap: 0.5rem;
  padding: 4rem 1rem;
  color: #555555;
  text-align: center;
  border-top: 2px solid #222222;
  border-bottom: 2px solid #222222;
}

.dataon-official-clone .dataon-official-no-result i {
  color: #A7B0BC;
  font-size: 2rem;
}

.dataon-official-clone .dataon-official-no-result strong {
  color: #222222;
  font-size: 1.125rem;
}

.dataon-official-clone .dataon-official-section-empty {
  margin: 0;
  border-width: 2px 0;
}

.dataon-official-clone .board_pager .page-link:disabled {
  color: #C1C1C1;
  cursor: default;
}

.dataon-official-clone .board_pager .page-item:first-child .page-link,
.dataon-official-clone .board_pager .page-item:last-child .page-link {
  width: 3.35rem;
  border-radius: 1rem;
  font-size: 0.8125rem;
}

.dataon-official-clone .board_pager .page-item.disabled .page-link {
  color: #C1C1C1;
}

/* ReviewOps aegkxgxratdrqdyfbmbixzrslufrmpdz: DataON 2024 search result capture parity. */
.dataon-page:has(.dataon-official-search-page) {
  background: #FFFFFF;
}

.dataon-official-result-page {
  min-height: 100vh;
  background: #FFFFFF;
}

.dataon-official-result-page .dataon-container {
  box-sizing: border-box;
  width: calc(100% - 80px);
  max-width: 1280px;
  padding-right: 0;
  padding-left: 0;
}

.dataon-official-search-page .dataon-official-search-visual {
  min-height: 308px;
  background: #09071D url("/assets/dataon/official/layout/bg_search_new.jpg") center center/cover no-repeat;
}

.dataon-official-result-page .dataon-official-search-visual {
  min-height: 360px;
  background-color: #021F4F;
  background-image: radial-gradient(circle at 42% 44%, #19396B 0%, rgba(25, 57, 107, 0.28) 18%, transparent 38%), linear-gradient(90deg, #011031 0%, rgba(1, 20, 56, 0.84) 48%, rgba(2, 31, 79, 0.28) 100%), url("/assets/dataon/main_bg.png");
  background-position: center center, center center, center -156px;
  background-size: cover;
}

.dataon-official-search-page .dataon-official-search-visual-inner {
  display: grid;
  box-sizing: border-box;
  min-height: inherit;
  align-content: center;
  justify-items: center;
  padding-top: 120px;
  padding-bottom: 36px;
}

.dataon-official-result-page .dataon-official-search-visual-inner {
  box-sizing: border-box;
  min-height: inherit;
  align-content: center;
  padding-top: 120px;
  padding-bottom: 38px;
}

.dataon-official-search-page .dataon-official-search-mode-tabs {
  display: grid;
  width: 100%;
  max-width: 624px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: center;
  gap: 8px;
  margin-bottom: 22px;
}

.dataon-official-result-page .dataon-official-search-mode-tabs {
  display: flex;
  width: auto;
  max-width: 624px;
  justify-content: center;
  margin-bottom: 30px;
}

.dataon-official-search-page .dataon-official-search-mode-tabs button {
  position: relative;
  display: inline-flex;
  width: 100%;
  min-width: 0;
  height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 17px;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 999px;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
}

.dataon-official-result-page .dataon-official-search-mode-tabs button {
  width: auto;
  min-width: 112px;
  padding-right: 18px;
  padding-left: 18px;
}

.dataon-official-search-page .dataon-official-search-mode-tabs button.is-active {
  color: #151515;
  border-color: #FFC51C;
  background: #FFC51C;
  font-weight: 700;
}

.dataon-official-search-page .dataon-official-search-mode-tabs button.is-active::after {
  position: absolute;
  bottom: -8px;
  left: 50%;
  width: 0;
  height: 0;
  border-top: 9px solid #FFC51C;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
  content: "";
  transform: translateX(-50%);
}

.dataon-official-search-page .dataon-official-search-mode-tabs i {
  font-size: 13px;
}

.dataon-official-search-page .dataon-official-search-mode-tabs em {
  position: absolute;
  top: -12px;
  right: -10px;
  min-width: 42px;
  height: 21px;
  padding: 0 7px;
  color: #FFFFFF;
  border-radius: 999px;
  background: #FF5B68;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  line-height: 21px;
}

.dataon-official-search-page .dataon-official-hero-search {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 56px;
  width: 100%;
  max-width: 624px;
  height: 48px;
  overflow: hidden;
  border-radius: 3px;
  background: #FFFFFF;
}

.dataon-official-result-page .dataon-official-hero-search {
  grid-template-columns: minmax(0, 1fr) 60px;
  height: 54px;
}

.dataon-official-search-page .dataon-official-hero-search input {
  min-width: 0;
  height: 48px;
  padding: 0 20px;
  color: #333333;
  border: 0;
  background: #FFFFFF;
  font-size: 17px;
  font-weight: 500;
}

.dataon-official-result-page .dataon-official-hero-search input {
  height: 54px;
}

.dataon-official-search-page .dataon-official-hero-search input::placeholder {
  color: #A9A9A9;
}

.dataon-official-search-page .dataon-official-hero-search button {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2078E4;
  background: #FFFFFF;
  font-size: 18px;
}

.dataon-official-result-page .dataon-official-hero-search button {
  font-size: 20px;
}

.dataon-official-search-page .dataon-official-search-help {
  position: relative;
  display: flex;
  width: 100%;
  max-width: 624px;
  justify-content: flex-end;
  margin-top: 10px;
}

.dataon-official-search-page .dataon-official-search-help > button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #FFC51C;
  background: transparent;
  font-size: 14px;
  font-weight: 800;
}

.dataon-official-search-page .dataon-official-search-help-popover {
  position: absolute;
  top: 28px;
  right: 0;
  z-index: 30;
  width: 560px;
  padding: 18px;
  color: #333333;
  border: 1px solid #D8D8D8;
  background: #FFFFFF;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
}

.dataon-official-search-page .dataon-official-search-help-popover strong {
  display: block;
  margin-bottom: 10px;
  font-size: 16px;
}

.dataon-official-search-page .dataon-official-search-help-popover table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dataon-official-search-page .dataon-official-search-help-popover th,
.dataon-official-search-page .dataon-official-search-help-popover td {
  padding: 8px;
  border: 1px solid #E0E0E0;
  text-align: left;
}

.dataon-official-search-page .dataon-official-search-help-close {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #333333;
  background: transparent;
}

@media (max-width: 760px) {
  .dataon-official-search-page .dataon-official-search-visual {
    min-height: 248px;
  }
  .dataon-official-search-page .dataon-official-search-visual-inner {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .dataon-official-result-page .dataon-official-search-visual {
    min-height: 312px;
  }
  .dataon-official-result-page .dataon-official-search-visual-inner {
    padding-top: 38px;
    padding-bottom: 30px;
  }
  .dataon-official-result-page .dataon-official-search-mode-tabs {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-bottom: 24px;
  }
  .dataon-official-result-page .dataon-official-search-mode-tabs button {
    width: 100%;
    min-width: 0;
  }
}
.dataon-official-result-page .dataon-official-main {
  padding: 42px 0 90px;
}

.dataon-official-result-page .totSch.dataon-official-totsch {
  display: grid !important;
  width: 100%;
  grid-template-columns: 19.375rem minmax(0, 1fr);
  column-gap: 4.125rem;
  row-gap: 0;
  align-items: start;
}

.dataon-official-result-page .totSch.dataon-official-totsch::after {
  display: none;
  clear: none;
  content: none;
}

.dataon-official-result-page .totSch .totSch_left,
.dataon-official-result-page .totSch .totSch_right {
  float: none !important;
  width: auto !important;
  min-width: 0;
  margin: 0 !important;
  clear: none;
}

.dataon-official-result-page .dataon-official-left {
  display: block;
  width: 19.375rem !important;
  min-width: 0;
  border: 0;
  background: #FFFFFF;
}

.dataon-official-result-page .blind {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.dataon-official-result-page .dataon-official-left .sch_selectInfo_wrap {
  display: none;
}

.dataon-official-result-page .dataon-official-left .totSch_rowWrap_btn {
  position: relative;
  display: flex;
  height: 3.25rem;
  margin: 0;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border: 0;
  background: #FD8D25;
  font-size: 1.1875rem;
  font-weight: 800;
  line-height: 3.25rem;
  text-align: center;
}

.dataon-official-result-page .dataon-official-left .totSch_rowWrap {
  border: 1px solid #DDDDDD;
  border-top: 0;
  background: #FDFDFD;
}

.dataon-official-result-page .dataon-official-left .totSch_row {
  position: relative;
  padding: 1.4375rem 1.2rem;
  border-top: 1px solid #DDDDDD;
  background: #FFFFFF;
}

.dataon-official-result-page .dataon-official-left .totSch_row:first-child {
  border-top: 0;
}

.dataon-official-result-page .dataon-official-inner-search {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 40px;
  width: 100%;
  margin: 0;
}

.dataon-official-result-page .dataon-official-inner-search input {
  width: 100%;
  min-width: 0;
  height: 2.5rem;
  padding: 0 0.75rem;
  color: #333333;
  border: 1px solid #D1D1D1;
  border-right: 0;
  background: #F1F1F1;
  font-size: 0.9375rem;
}

.dataon-official-result-page .dataon-official-inner-search button {
  width: 2.5rem;
  height: 2.5rem;
  color: #FFFFFF;
  background: #2378E9;
}

.dataon-official-result-page .dataon-official-inner-search .schBtn::before {
  color: #FFFFFF;
  font-family: "Font Awesome 6 Free";
  font-size: 0.875rem;
  font-weight: 900;
  content: "\f002";
}

.dataon-official-result-page .dataon-official-selected-search {
  display: flex;
  width: 100%;
  height: 3.25rem;
  margin: 0;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #FFFFFF;
  border: 0;
  background: #1053C8 !important;
  font-size: 1.1875rem;
  font-weight: 800;
  line-height: 3.25rem;
}

.dataon-official-result-page .dataon-official-selected-search i {
  display: inline-flex;
  width: 1rem;
  height: 1rem;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 0.9375rem;
  line-height: 1;
}

.dataon-official-result-page .dataon-official-selected-search i::before {
  color: #FFFFFF;
  font-family: "DataON Icon Fallback", "Font Awesome 6 Free", Arial, sans-serif !important;
  font-weight: 900 !important;
  content: "\f245" !important;
}

.dataon-official-result-page .dataon-official-left .totSch_row h4,
.dataon-official-result-page .dataon-official-filter-title h4 {
  margin: 0 0 0.5rem;
  color: #343434;
  font-size: 1.125rem;
  font-weight: 800;
  line-height: 1;
}

.dataon-official-result-page .dataon-official-filter-title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  margin-bottom: 0.5rem;
}

.dataon-official-result-page .dataon-official-filter-title span {
  display: inline-flex;
  width: 15px;
  height: 15px;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border-radius: 50%;
  background: #FF6A21;
  font-size: 10px;
  font-weight: 800;
}

.dataon-official-result-page .dataon-official-filter-title button {
  margin-left: auto;
  color: #555555;
  background: transparent;
  font-size: 0.8125rem;
}

.dataon-official-result-page .dataon-official-left .stat_list {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) 32px;
  gap: 8px;
  align-items: center;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.dataon-official-result-page .dataon-official-left .list_time {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 22px;
  align-items: center;
  height: 1.625rem;
  border: 1px solid #D5D5D5;
  background: #FFFFFF;
}

.dataon-official-result-page .dataon-official-left .list_time input {
  width: 100%;
  height: 1.5rem;
  border: 0;
  background: transparent;
}

.dataon-official-result-page .dataon-official-left .list_time i {
  color: #666666;
  font-size: 12px;
}

.dataon-official-result-page .dataon-official-left .schAddBtn {
  width: 32px;
  height: 1.625rem;
  color: #FFFFFF;
  background: #2378E9;
}

.dataon-official-result-page .dataon-official-left .schAddBtn::before {
  color: #FFFFFF;
  font-size: 20px;
  line-height: 1;
  content: "+";
}

.dataon-official-result-page .dataon-official-left .schAddBtn span {
  display: none;
}

.dataon-official-result-page .dataon-official-left .list {
  display: grid;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-result-page .dataon-official-left .list li {
  color: #333333;
  font-size: 0.9375rem;
  line-height: 1.65;
}

.dataon-official-result-page .dataon-official-left label {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding-right: 4.25rem;
  overflow: hidden;
  color: #333333;
  font-size: 0.9375rem;
  line-height: 1.65;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-official-result-page .dataon-official-left input[type=checkbox] {
  width: 13px;
  height: 13px;
  margin: 0;
}

.dataon-official-result-page .dataon-official-check-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-official-result-page .dataon-official-left label > span,
.dataon-official-result-page .dataon-official-left label em {
  position: absolute;
  top: 0;
  right: 0.1rem;
  color: #1343B9;
  font-style: normal;
  font-weight: 500;
}

.dataon-official-result-page .dataon-official-fold-button {
  width: 100%;
  height: 36px;
  margin-top: 16px;
  color: #555555;
  background: #F3F3F3;
  font-size: 14px;
}

.dataon-official-result-page .dataon-official-fold-button::after {
  display: inline-block;
  margin-left: 8px;
  border-top: 6px solid #333333;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  content: "";
  vertical-align: 2px;
}

.dataon-official-result-page .dataon-official-fold-button.is-expanded::after {
  border-top: 0;
  border-bottom: 6px solid #333333;
  vertical-align: 4px;
}

.dataon-official-result-page .dataon-official-selected-keywords {
  gap: 6px;
  margin: 10px 0;
}

.dataon-official-result-page .dataon-official-right {
  min-width: 0;
  padding-top: 0;
  overflow: visible !important;
}

.dataon-official-result-page .dataon-official-search-condition {
  display: grid;
  gap: 16px;
  margin: 0 0 18px;
  color: #333333;
  font-size: 16px;
}

.dataon-official-result-page .dataon-official-search-condition dl,
.dataon-official-result-page .dataon-official-search-condition dd {
  margin: 0;
}

.dataon-official-result-page .dataon-official-search-condition dd {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.5rem;
}

.dataon-official-result-page .dataon-official-search-condition .h6 {
  color: #333333;
  font-size: 16px;
  font-weight: 500;
}

.dataon-official-result-page .dataon-official-condition-value {
  color: #111111;
  font-size: 16px;
  font-weight: 800;
}

.dataon-official-result-page .dataon-official-condition-empty {
  color: #777777;
  font-size: 15px;
}

.dataon-official-result-page .dataon-official-related-list {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  min-width: 0;
}

.dataon-official-result-page .dataon-official-related-keyword {
  display: inline-flex;
  min-height: 1.75rem;
  align-items: center;
  padding: 0 0.625rem;
  color: #0E4B98;
  border: 1px solid #C8D8EC;
  border-radius: 0;
  background: #F5F9FE;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1;
}

.dataon-official-result-page .dataon-official-related-keyword:hover,
.dataon-official-result-page .dataon-official-related-keyword:focus-visible {
  color: #FFFFFF;
  border-color: #0E4B98;
  background: #0E4B98;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-width: 275px;
  height: 52px;
  margin: 0;
  padding: 0;
  border: 1px solid #1D69D5;
  border-bottom-color: #1D69D5;
  list-style: none;
  line-height: 90%;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs li {
  min-width: 0;
  border-left: 1px solid #E5E5E5;
  cursor: pointer;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs li:first-child {
  border-left: 0;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs button {
  display: flex;
  width: 100%;
  height: 52px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #333333;
  background: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.15;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs button.is-active,
.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs li.on button {
  color: #1857C7;
  border: 1px solid #1D69D5;
  background: #FFFFFF;
  font-weight: 800;
  transform: translate(-1px, -1px);
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs span {
  color: inherit;
  font-size: 70%;
  font-style: normal;
  font-weight: 500;
}

.dataon-official-result-page .dataon-official-tab-guide {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 9px 0 24px;
  color: #777777;
  font-size: 14px;
}

.dataon-official-result-page .dataon-official-tab-guide i {
  color: #FF6A21;
}

.dataon-official-result-page .dataon-official-totsch-info {
  display: flex;
  justify-content: flex-end;
  min-height: 24px;
  margin: 0 0 26px;
}

.dataon-official-result-page .dataon-official-sort-list {
  display: flex;
  align-items: center;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-result-page .dataon-official-sort-list li {
  position: relative;
  padding: 0 12px;
}

.dataon-official-result-page .dataon-official-sort-list li + li::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 1px;
  height: 12px;
  background: #CFCFCF;
  content: "";
  transform: translateY(-50%);
}

.dataon-official-result-page .dataon-official-sort-list button {
  color: #777777;
  background: transparent;
  font-size: 15px;
  font-weight: 500;
}

.dataon-official-result-page .dataon-official-sort-list button.is-active {
  color: #111111;
  font-weight: 800;
}

.dataon-official-result-page .dataon-official-result-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  padding-bottom: 19px;
  border-bottom: 2px solid #222222;
}

.dataon-official-result-page .dataon-official-result-section-head .rst_tit {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.dataon-official-result-page .dataon-official-result-section-head h4 {
  margin: 0;
  color: #111111;
  font-size: 22px;
  font-weight: 900;
}

.dataon-official-result-page .dataon-official-result-section-head span {
  color: #666666;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}

.dataon-official-result-page .dataon-official-result-section-head button {
  width: 88px;
  height: 30px;
  color: #333333;
  border: 1px solid #9D9D9D;
  background: #FFFFFF;
  font-size: 14px;
}

.dataon-official-result-page .rst_data.dataon-official-search-results {
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-result-page .rst_data.dataon-official-search-results > li {
  padding: 0 8px 28px;
  margin-bottom: 28px;
  border-bottom: 1px solid #D8D8D8;
  background: #FFFFFF;
  box-sizing: border-box;
}

.dataon-official-result-page .rst_data.dataon-official-search-results > li > strong {
  display: block;
  margin: 0 0 6px;
  color: #111111;
  font-size: 17px;
  font-weight: 900;
  line-height: 1.35;
}

.dataon-official-result-page .rst_data.dataon-official-search-results .country {
  display: inline-block;
  min-height: 0;
  margin: 0 5px 8px 0;
  padding: 0 12px;
  color: #0054B8;
  border: 1px solid #0054B8;
  background: #FFFFFF;
  font-size: 15px;
  font-style: normal;
  font-weight: 800;
  line-height: 22px;
  text-align: center;
  vertical-align: middle;
}

.dataon-official-result-page .rst_data.dataon-official-search-results > li > strong a {
  display: inline-block;
  color: #111111;
  background: transparent;
  font-size: 17px;
  font-weight: 900;
  line-height: 1.35;
  text-align: left;
  text-decoration: none;
}

.dataon-official-result-page .rst_data.dataon-official-search-results > li > span,
.dataon-official-result-page .dataon-official-result-en {
  display: block;
  margin: 0 0 9px;
  color: #999999;
  font-size: 14px;
  line-height: 1.45;
}

.dataon-official-result-page .result_wrap,
.dataon-official-result-page .result_item {
  min-width: 0;
  overflow: visible;
}

.dataon-official-result-page .dataon-official-left .totSch_row .totSch_btnBox.dataon-official-inner-search {
  position: relative;
  display: block;
  padding-right: 2.5rem;
}

.dataon-official-result-page .dataon-official-left .totSch_row .totSch_btnBox.dataon-official-inner-search input[type=text] {
  width: 100%;
  height: 2.5rem;
  padding: 0 0.75rem;
  border: 0;
  background: #EFEFEF;
  font-size: 0.9375rem;
}

.dataon-official-result-page .dataon-official-left .totSch_row .totSch_btnBox.dataon-official-inner-search .schBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 2.5rem;
  height: 2.5rem;
  color: #FFFFFF;
  border: 1px solid #2E81EA;
  background: #2E81EA;
  text-align: center;
}

.dataon-official-result-page .dataon-official-left .totSch_row .totSch_btnBox.dataon-official-inner-search .schBtn::before {
  position: absolute;
  top: 0.68rem;
  left: 0.68rem;
  box-sizing: border-box;
  width: 0.78rem;
  height: 0.78rem;
  border: 2px solid #FFFFFF;
  border-radius: 50%;
  content: "" !important;
}

.dataon-official-result-page .dataon-official-left .totSch_row .totSch_btnBox.dataon-official-inner-search .schBtn::after {
  position: absolute;
  top: 1.48rem;
  left: 1.42rem;
  width: 0.55rem;
  height: 2px;
  background: #FFFFFF;
  content: "";
  transform: rotate(45deg);
  transform-origin: left center;
}

.dataon-official-result-page .dataon-official-left .totSch_row .totSch_btnBox.dataon-official-inner-search .schBtn:hover {
  color: #FFFFFF;
  background: #2E81EA;
}

.dataon-official-result-page .dataon-official-left .stat_list {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 0.75rem minmax(0, 1fr) 2.25rem;
  align-items: center;
  gap: 0.375rem;
}

.dataon-official-result-page .dataon-official-left .stat_list > span {
  margin: 0;
  color: #777777;
  font-size: 0.9375rem;
  line-height: 1;
  text-align: center;
}

.dataon-official-result-page .dataon-official-left .list_time {
  position: relative;
  display: inline-flex;
  width: 100%;
  height: 2.25rem;
  align-items: center;
  border: 1px solid #D5D5D5;
  background: #FFFFFF;
}

.dataon-official-result-page .dataon-official-left .list_time input {
  width: 100%;
  height: 100%;
  padding: 0 1.55rem 0 0.35rem;
  color: #444444;
  border: 0;
  background: transparent;
  font-size: 0.75rem;
}

.dataon-official-result-page .dataon-official-left .list_time i {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-flex;
  width: 1.5rem;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #666666;
  font-size: 1rem;
  pointer-events: none;
  text-align: center;
}

.dataon-official-result-page .dataon-official-left .list_time input[type=date]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  right: 0;
  width: 1.5rem;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.dataon-official-result-page .dataon-official-left .stat_sch_main .schAddBtn {
  position: relative !important;
  display: inline-flex;
  width: 2.25rem !important;
  min-width: 2.25rem;
  height: 2.25rem !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 2.25rem;
  aspect-ratio: 1/1;
  margin-left: 0 !important;
  color: #FFFFFF;
  border: 1px solid #2E81EA;
  background: #2E81EA;
}

.dataon-official-result-page .dataon-official-left .schAddBtn::before {
  color: currentColor;
  font-family: Arial, sans-serif;
  font-size: 1.05rem;
  font-weight: 400;
  line-height: 1;
  content: "+";
}

.dataon-official-result-page .dataon-official-left .schAddBtn:hover {
  color: #2E81EA;
  background: #FFFFFF;
}

.dataon-official-result-page .dataon-official-left .totSch_row h4 {
  display: block;
  min-height: 1.125rem;
  margin: 0 0 0.5rem;
  color: #343434;
  font-size: 1.125rem;
  font-weight: 800;
  line-height: 1;
}

.dataon-official-result-page .dataon-official-left .dataon-official-filter-empty {
  padding: 1.75rem 1.2rem;
  background: #FFFFFF;
}

.dataon-official-result-page .dataon-official-left .dataon-official-filter-empty p {
  min-height: 2.5rem;
  margin: 0;
  color: #777777;
  font-size: 0.9375rem;
  line-height: 2.5rem;
}

.dataon-official-result-page .dataon-official-left .help_more {
  display: inline-flex;
  width: 1.125rem;
  height: 1.125rem;
  align-items: center;
  justify-content: center;
  margin-left: 0.4rem;
  border-radius: 50%;
  background: #FD6D21;
  vertical-align: -0.12rem;
}

.dataon-official-result-page .dataon-official-left .help_more i {
  display: inline-flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  margin: 0;
  color: #FFFFFF;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1;
}

.dataon-official-result-page .dataon-official-left .help_more i::before {
  color: #FFFFFF;
  font-family: Arial, sans-serif !important;
  font-weight: 800 !important;
  content: "?" !important;
}

.dataon-official-result-page .dataon-official-left .list.scroll {
  max-height: 6.25rem;
  overflow-y: hidden;
}

.dataon-official-result-page .dataon-official-left .list.scroll.is-expanded {
  max-height: none;
  overflow-y: visible;
}

.dataon-official-result-page .dataon-official-left .list li {
  color: #333333;
  font-size: 0.9375rem;
  line-height: 1.55;
}

.dataon-official-result-page .dataon-official-left .list li label {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding-right: 4.25rem;
  overflow: hidden;
  color: #333333;
  line-height: 1.55;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-official-result-page .dataon-official-left .list li label input[type=checkbox] {
  flex: 0 0 auto;
  width: 13px !important;
  height: 13px !important;
  margin: 0 0.35rem 0 0;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  vertical-align: -2px;
}

.dataon-official-result-page .dataon-official-left .list li label > span {
  position: absolute;
  top: 0;
  right: 0.1rem;
  color: #1343B9;
}

.dataon-official-result-page .dataon-official-left .sch_more {
  position: absolute;
  top: 1.4375rem;
  right: 1.1rem;
  color: #343434;
  background: transparent;
  font-size: 0.9375rem;
  line-height: 1;
}

.dataon-official-result-page .dataon-official-left .sch_more::after {
  margin-left: 0.25rem;
  font-family: Arial, sans-serif;
  font-size: 1rem;
  font-weight: 700;
  content: "›";
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs {
  display: table;
  width: 100%;
  height: auto;
  min-width: 275px;
  padding-left: 1px;
  border: 0;
  line-height: 90%;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li {
  display: table;
  float: left;
  width: 33.33%;
  border: 1px solid #F2F4F7;
  border-bottom: 1px solid #3E7ECD;
  border-left: 0;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li:first-child {
  border-left: 1px solid #F2F4F7;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li > a,
.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li > button {
  display: table-cell;
  width: 100%;
  height: 3.25rem;
  color: #333333;
  border: 0;
  background: #FFFFFF;
  font-family: "NanumSquare", "Noto Sans KR", Arial, sans-serif;
  font-size: 1.125rem;
  font-weight: 800;
  line-height: 1.15;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li.on {
  border-width: 2px 2px 0;
  border-style: solid;
  border-color: #3E7ECD;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li.on > a,
.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li.on > button,
.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li > a.is-active,
.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li > button.is-active {
  color: #154886;
  border: 0;
  transform: none;
}

.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li > a span,
.dataon-official-result-page .totSch_rTab.dataon-official-content-tabs > li > button span {
  color: inherit;
  font-size: 70%;
  font-weight: 500;
}

.dataon-official-result-page .dataon-official-tab-guide.help_more {
  display: block;
  margin: 1.25rem 0 1.4rem;
  color: #777777;
  font-size: 0.9375rem;
}

.dataon-official-result-page .dataon-official-tab-guide.help_more i {
  position: relative;
  top: 0.1rem;
  margin-right: 0.3rem;
  color: #FD6D21;
  font-size: 1.125rem;
}

.dataon-official-result-page .dataon-official-result-section-head {
  display: block;
  overflow: hidden;
  margin-bottom: 1.1875rem;
  padding-bottom: 0;
  border-bottom: 0;
}

.dataon-official-result-page .dataon-official-result-section-head .rst_tit {
  float: left;
  margin-top: -0.3rem;
}

.dataon-official-result-page .dataon-official-result-section-head .rst_tit h4 {
  display: inline-block;
  color: #1A1A1A;
  font-family: "NanumSquare", "Noto Sans KR", Arial, sans-serif;
  font-size: 1.375rem;
  font-weight: 800;
}

.dataon-official-result-page .dataon-official-result-section-head .rst_tit span {
  display: inline-block;
  margin-left: 0.3125rem;
  color: #2E2E2E;
  font-size: 1rem;
}

.dataon-official-result-page .dataon-official-result-section-head .rst_util {
  float: right;
}

.dataon-official-result-page .dataon-official-result-section-head .rst_util select {
  height: 2.1875rem;
  margin-right: 0.4rem;
  padding: 0 1.75rem 0 0.5rem;
  color: #333333;
  border: 1px solid #A0A0A0;
  background-color: #FFFFFF;
  font-size: 0.9375rem;
  line-height: 2.1875rem;
}

.dataon-official-result-page .dataon-official-result-section-head .btn_more {
  position: relative;
  display: inline-flex;
  width: auto;
  min-width: 6.25rem;
  height: 2.1875rem;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.6875rem 0 0.875rem;
  color: #333333;
  border: 1px solid #A0A0A0;
  background: #FFFFFF;
  font-size: 1rem;
  line-height: 2.1875rem;
  text-align: left;
}

.dataon-official-result-page .dataon-official-result-section-head .btn_more::after {
  position: absolute;
  right: 0.7rem;
  font-family: Arial, sans-serif;
  font-weight: 700;
  content: "›";
}

.dataon-official-result-page .rst_data.dataon-official-search-results {
  margin: 0;
  padding: 0;
  border-width: 2px 0;
  border-style: solid;
  border-color: #222222;
  list-style: none;
}

.dataon-official-result-page .rst_data.dataon-official-search-results > li {
  position: relative;
  margin: 0;
  padding: 2rem 1.25rem 2rem 0.625rem;
  border-top: 1px solid #DDDDDD;
  border-bottom: 0;
  background: #FFFFFF;
}

.dataon-official-result-page .rst_data.dataon-official-search-results > li:first-child {
  border-top: 0;
}

.dataon-official-result-page .rst_data.dataon-official-search-results > li > strong {
  display: block;
  max-height: 4rem;
  margin: 0;
  overflow: hidden;
  color: #222222;
  font-family: "NanumSquare", "Noto Sans KR", Arial, sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2rem;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.dataon-official-result-page .rst_data.dataon-official-search-results .country {
  display: inline-block;
  margin-right: 0.25rem;
  margin-bottom: 0;
  padding: 0 0.8125rem;
  color: #0E4B98;
  border: 1px solid #0E4B98;
  background: #FFFFFF;
  font-size: 1.05rem;
  font-style: normal;
  line-height: 1.5625rem;
  text-align: center;
  vertical-align: middle;
}

.dataon-official-result-page .rst_data.dataon-official-search-results > li > strong a {
  display: block;
  margin-top: 0.25rem;
  color: #222222;
  font-family: "NanumSquare", "Noto Sans KR", Arial, sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2rem;
  text-decoration: none;
}

.dataon-official-result-page .rst_data.dataon-official-search-results > li > span {
  display: block;
  margin: 0 0 0.3125rem;
  padding-right: 1.9rem;
  color: #888888;
  font-size: 1rem;
}

.dataon-official-result-page .rst_dataList {
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-result-page .rst_dataList > li {
  position: relative;
  min-height: 1.45rem;
  margin-top: 0.28rem;
  padding-left: 8rem;
  overflow: hidden;
  color: #000000;
  font-size: 0.9375rem;
  font-weight: 400;
}

.dataon-official-result-page .rst_dataList > li.dataon-official-meta-subject {
  margin-top: 0.75rem;
}

.dataon-official-result-page .rst_dataList > li > strong {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 7.5rem;
  margin-right: 0.5rem;
  padding-right: 1px;
  color: #000000;
  font-size: 0.9375rem;
  font-weight: 500;
}

.dataon-official-result-page .rst_dataList > li > strong::after {
  position: absolute;
  top: 0.45rem;
  right: 0;
  height: 0.8125rem;
  border-right: 1px solid #E0E0E0;
  content: "";
}

.dataon-official-result-page .rst_dataList > li > span,
.dataon-official-result-page .rst_dataList > li a {
  color: #555555 !important;
}

.dataon-official-result-page .schRst_Text {
  position: relative;
  margin-top: 0.35rem;
  padding-left: 0;
  color: #555555;
  font-weight: 400;
}

.dataon-official-result-page .schRst_Text p {
  display: -webkit-box;
  max-height: 4.8rem;
  margin: 0;
  overflow: hidden;
  color: #555555;
  font-size: 0.9375rem;
  line-height: 1.6rem;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.dataon-official-result-page .soft_item {
  width: 100%;
}

.dataon-official-result-page .dataon-official-dataset-section + .dataon-official-software-section {
  margin-top: 2.5rem;
}

.dataon-official-result-page .rst_data.dataon-official-search-results.dataon-official-software-results {
  display: flex;
  flex-wrap: wrap;
}

.dataon-official-result-page .rst_data.dataon-official-search-results.dataon-official-software-results > li {
  width: 50%;
  padding: 2rem 1.25rem 2rem 0.625rem;
}

.dataon-official-result-page .dataon-official-software-results .result_twoLine {
  width: calc(100% - 0.5rem);
  margin-bottom: 1rem;
}

.dataon-official-result-page .dataon-official-software-results .rst_list {
  min-width: 0;
}

.dataon-official-result-page .dataon-official-software-results .rst_list > a {
  display: block;
  min-height: 7.25rem;
  color: inherit;
  text-decoration: none;
}

.dataon-official-result-page .dataon-official-software-results .rst_left {
  position: relative;
  z-index: 1;
  float: left;
  width: 6.5rem;
  height: 6.5rem;
  margin-top: 0.75rem;
  overflow: hidden;
  border-radius: 50%;
  background: #F1F1F1 url("/assets/dataon/2024/icon_data.svg") 50% 50%/42% no-repeat;
}

.dataon-official-result-page .dataon-official-software-results .rst_left::after {
  position: absolute;
  z-index: -1;
  display: block;
  width: 6.5rem;
  height: 6.5rem;
  border-radius: 50%;
  background: #FFFFFF;
  content: "";
}

.dataon-official-result-page .dataon-official-software-results .rst_left img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  min-height: 100%;
  background: #FFFFFF;
  transform: translate(-50%, -50%);
}

.dataon-official-result-page .dataon-official-software-results .rst_right {
  min-width: 0;
  padding-left: 8.5rem;
}

.dataon-official-result-page .dataon-official-software-results .rst_right h4 {
  margin: 0;
  padding-bottom: 0.5rem;
  overflow: hidden;
  color: #000000;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
}

.dataon-official-result-page .dataon-official-software-results .rst_right span {
  display: block;
  overflow: hidden;
  color: #555555;
  font-size: 0.9375rem;
  line-height: 1.55;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataon-official-result-page .dataon-official-software-results .rst_right span:last-child {
  color: #0075FF;
}

.dataon-official-result-page .dataon-official-software-results .rst_keyword {
  margin: 2.25rem 0 0;
  padding: 0;
  overflow: hidden;
  list-style: none;
}

.dataon-official-result-page .dataon-official-software-results .rst_keyword li {
  display: inline-block;
  float: left;
  margin-right: 0.3125rem;
  margin-bottom: 0.3125rem;
  padding: 0 0.4rem;
  border: 1px solid #F1F1F1;
  background: #F1F1F1;
}

.dataon-official-result-page .dataon-official-software-results .rst_keyword a {
  color: #555555;
  font-size: 0.875rem;
  line-height: 1.55;
  text-decoration: none;
}

@media (max-width: 1100px) {
  .dataon-official-result-page .totSch.dataon-official-totsch {
    grid-template-columns: 1fr;
    row-gap: 28px;
  }
  .dataon-official-result-page .dataon-official-left {
    width: 100% !important;
  }
}
@media (max-width: 1024px) {
  .dataon-official-clone .dataon-official-content-tabs {
    overflow-x: auto;
    overflow-y: hidden;
  }
  .dataon-official-clone .dataon-official-content-tabs button {
    flex: 0 0 auto;
  }
  .dataon-official-clone .dataon-official-sort-list {
    float: none;
    clear: both;
    justify-content: flex-end;
    padding-top: 0.6rem;
  }
  .dataon-official-clone .dataon-official-search-side {
    max-width: 28rem;
  }
}
@media (max-width: 640px) {
  .dataon-official-result-page .dataon-container {
    width: calc(100% - 32px);
  }
  .dataon-official-result-page .dataon-official-left .totSch_rowWrap_btn {
    cursor: pointer;
  }
  .dataon-official-result-page .dataon-official-left .totSch_rowWrap_btn::after {
    position: absolute;
    right: 1rem;
    font-family: Arial, sans-serif;
    font-size: 1rem;
    font-weight: 700;
    content: "∨";
  }
  .dataon-official-result-page .dataon-official-left .totSch_rowWrap_btn.is-mobile-open::after {
    content: "∧";
  }
  .dataon-official-result-page .dataon-official-left .totSch_rowWrap {
    display: none;
  }
  .dataon-official-result-page .dataon-official-left .totSch_rowWrap.is-mobile-open {
    display: block;
  }
  .dataon-official-clone .dataon-official-content-tabs {
    height: 3.2rem;
    margin-bottom: 1.25rem;
  }
  .dataon-official-clone .dataon-official-content-tabs button {
    min-width: 6.5rem;
    height: 3.2rem;
    padding: 0 1rem;
    font-size: 0.95rem;
    line-height: 3.2rem;
  }
  .dataon-official-clone .dataon-official-search-list-item .title button {
    font-size: 1.1rem;
  }
  .dataon-official-clone .dataon-official-search-side dl {
    grid-template-columns: 1fr 1fr;
  }
  .dataon-official-clone .dataon-official-sort-list {
    justify-content: flex-start;
  }
}
.dataon-register-page {
  background: #F6F7FB;
}

.dataon-register-page .dataon-subpage-visual {
  padding-top: 120px;
}

.dataon-register-body {
  padding: 46px 0 74px;
}

.dataon-register-layout {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  align-items: start;
  gap: 28px;
}

.dataon-register-side {
  display: grid;
  overflow: hidden;
  border: 1px solid #DCE5F0;
  border-radius: 4px;
  background: #FFFFFF;
}

.dataon-register-side strong {
  padding: 18px 20px;
  color: #FFFFFF;
  background: #1F3658;
  font-size: 18px;
  font-weight: 900;
}

.dataon-register-side button {
  min-height: 48px;
  padding: 0 20px;
  color: #27364D;
  border-top: 1px solid #E8EEF5;
  background: #FFFFFF;
  font-size: 15px;
  font-weight: 750;
  text-align: left;
}

.dataon-register-side button:hover,
.dataon-register-side button:focus-visible,
.dataon-register-side button.is-active {
  color: #005FC5;
  background: #EEF6FF;
}

.dataon-register-content {
  min-width: 0;
}

.dataon-register-page-head {
  margin-bottom: 22px;
}

.dataon-register-page-head h2 {
  position: relative;
  margin: 0 0 8px;
  padding-left: 16px;
  color: #111827;
  font-size: 32px;
  font-weight: 850;
  line-height: 1.24;
}

.dataon-register-page-head h2::before,
.dataon-register-title-line h3::before,
.dataon-register-form-section h4::before {
  position: absolute;
  top: 0.22em;
  bottom: 0.2em;
  left: 0;
  width: 5px;
  background: #126CE0;
  content: "";
}

.dataon-register-page-head p,
.dataon-register-title-line span {
  color: #68758A;
  font-size: 14px;
  font-weight: 650;
}

.dataon-register-flow {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-bottom: 18px;
  border: 1px solid #D8E2EF;
  border-radius: 4px;
  background: #FFFFFF;
}

.dataon-register-flow li {
  display: flex;
  min-height: 70px;
  align-items: center;
  gap: 12px;
  padding: 15px 18px;
  color: #66748A;
  border-left: 1px solid #E7EEF6;
  font-size: 15px;
  font-weight: 800;
}

.dataon-register-flow li:first-child {
  border-left: 0;
}

.dataon-register-flow span {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  color: #708097;
  border: 1px solid #D8E2EF;
  border-radius: 50%;
  background: #FFFFFF;
  font-size: 14px;
  font-weight: 900;
}

.dataon-register-flow li.is-active {
  color: #005FC5;
  background: #F1F7FF;
}

.dataon-register-flow li.is-active span,
.dataon-register-flow li.is-complete span {
  color: #FFFFFF;
  border-color: #126CE0;
  background: #126CE0;
}

.dataon-register-panel,
.dataon-register-workspace {
  border: 1px solid #DCE5F0;
  border-radius: 4px;
  background: #FFFFFF;
  box-shadow: 0 10px 28px rgba(8, 35, 75, 0.05);
}

.dataon-register-panel {
  padding: 28px;
}

.dataon-register-logo-row {
  display: flex;
  justify-content: center;
  margin-bottom: 22px;
}

.dataon-register-logo-row img {
  width: 150px;
  height: auto;
}

.dataon-register-redbox,
.dataon-register-agreebox {
  border: 2px solid #FF2A2A;
  background: #FFFFFF;
}

.dataon-register-redbox {
  display: grid;
  gap: 18px;
  padding: 24px 28px;
  color: #3D4A5F;
  font-size: 16px;
  font-weight: 650;
  line-height: 1.8;
}

.dataon-register-redbox strong {
  color: #E82222;
  font-weight: 900;
}

.dataon-register-agreebox {
  display: grid;
  gap: 14px;
  margin-top: 10px;
  padding: 15px 26px;
}

.dataon-register-agreebox label,
.dataon-register-radio {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #1B2738;
  font-size: 15px;
  font-weight: 760;
}

.dataon-register-agreebox strong:first-child {
  color: #E82222;
}

.dataon-register-agreebox label + label strong:first-child {
  color: #126CE0;
}

.dataon-register-message {
  margin-top: 14px;
  color: #D72727;
  font-size: 14px;
  font-weight: 800;
  text-align: center;
}

.dataon-register-message.is-success {
  color: #0067D6;
}

.dataon-register-bottom-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 22px;
}

.dataon-register-bottom-actions.is-center {
  justify-content: center;
}

.dataon-register-primary,
.dataon-register-secondary,
.dataon-register-danger,
.dataon-register-dark,
.dataon-register-blue-button,
.dataon-register-tool,
.dataon-register-table-button {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  color: #FFFFFF;
  border-radius: 3px;
  font-size: 15px;
  font-weight: 820;
  line-height: 1;
  white-space: nowrap;
}

.dataon-register-primary {
  background: #2478C7;
}

.dataon-register-secondary {
  color: #27364D;
  border: 1px solid #CAD6E5;
  background: #FFFFFF;
}

.dataon-register-danger {
  background: #E95061;
}

.dataon-register-dark,
.dataon-register-tool,
.dataon-register-table-button {
  background: #343A40;
}

.dataon-register-blue-button {
  background: #2B7EC7;
}

.dataon-register-primary:disabled {
  opacity: 0.45;
  cursor: default;
}

.dataon-register-danger:disabled,
.dataon-register-dark:disabled {
  opacity: 0.45;
  cursor: default;
}

.dataon-register-title-line {
  margin-bottom: 28px;
}

.dataon-register-title-line h3 {
  position: relative;
  margin: 0 0 6px;
  padding-left: 14px;
  color: #111827;
  font-size: 18px;
  font-weight: 900;
}

.dataon-register-collection-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
}

.dataon-register-collection-group {
  min-width: 0;
}

.dataon-register-collection-group h4 {
  margin: 0 0 9px;
  padding: 8px 13px;
  color: #034EA2;
  border-left: 4px solid #126CE0;
  border-radius: 3px;
  background: #E8F2FF;
  font-size: 17px;
  font-weight: 900;
}

.dataon-register-collection-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  overflow: visible;
  padding: 2px;
}

.dataon-register-collection-card {
  position: relative;
  display: flex;
  width: 100%;
  height: 96px;
  align-items: center;
  justify-content: center;
  padding: 12px 14px 24px;
  color: #27364D;
  border: 2px solid #AEBBCD;
  border-radius: 4px;
  background: #FAFCFF;
  overflow: hidden;
  text-align: center;
  box-shadow: 0 2px 6px rgba(10, 34, 65, 0.06);
  transition: border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
}

.dataon-register-collection-card:hover,
.dataon-register-collection-card:focus-visible,
.dataon-register-collection-card.is-selected {
  border-color: #126CE0;
  background: #F3F8FF;
  box-shadow: 0 0 0 3px rgba(18, 108, 224, 0.18);
  outline: 0;
}

.dataon-register-collection-logo {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  min-width: 0;
  background: #FFFFFF;
}

.dataon-register-collection-logo img {
  max-width: 118px;
  max-height: 58px;
  object-fit: contain;
}

.dataon-register-collection-logo i {
  color: #126CE0;
  font-size: 32px;
}

.dataon-register-collection-name {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  padding: 5px 7px;
  color: #FFFFFF;
  background: #126CE0;
  font-size: 11px;
  font-weight: 850;
  line-height: 1.22;
  opacity: 0;
  pointer-events: none;
  transform: translateY(100%);
  transition: opacity 140ms ease, transform 140ms ease;
}

.dataon-register-collection-card:hover .dataon-register-collection-name,
.dataon-register-collection-card:focus-visible .dataon-register-collection-name,
.dataon-register-collection-card.is-selected .dataon-register-collection-name {
  opacity: 1;
  transform: translateY(0);
}

.dataon-register-workspace {
  padding: 0 0 24px;
  background: #F2F4F7;
}

.dataon-register-editor-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 0 0 8px;
  padding: 14px 18px;
  border-bottom: 1px solid #DCE5F0;
  background: #FFFFFF;
}

.dataon-register-editor-head h3 {
  margin: 0;
  color: #0B1733;
  font-size: 20px;
  font-weight: 900;
}

.dataon-register-editor-head h3 span {
  position: relative;
  padding-left: 14px;
}

.dataon-register-editor-head h3 span::before {
  position: absolute;
  top: 0.18em;
  bottom: 0.16em;
  left: 0;
  width: 5px;
  background: #126CE0;
  content: "";
}

.dataon-register-editor-head h3 strong {
  margin-left: 7px;
  color: #126CE0;
}

.dataon-register-editor-caption {
  margin: 0;
  color: #68758A;
  font-size: 14px;
  font-weight: 700;
}

.dataon-register-editor-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.dataon-register-form-steps {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 0;
  margin: 0 16px 8px;
  padding: 0;
  list-style: none;
  border: 1px solid #D8E2EF;
  background: #FFFFFF;
}

.dataon-register-form-steps li {
  display: flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  color: #526174;
  border-left: 1px solid #E4EAF2;
  font-size: 13px;
  font-weight: 820;
  text-align: center;
}

.dataon-register-form-steps li:first-child {
  border-left: 0;
}

.dataon-register-form-section {
  margin: 8px 16px 0;
  padding: 18px 20px 20px;
  border: 1px solid #E0E6EE;
  background: #FFFFFF;
}

.dataon-register-form-section h4 {
  position: relative;
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: 0 0 16px;
  padding-left: 14px;
  color: #111827;
  font-size: 22px;
  font-weight: 900;
}

.dataon-register-form-section h4 span {
  color: #7A8799;
  font-size: 13px;
  font-weight: 750;
}

.dataon-register-fieldset {
  border-top: 2px solid #8D96A2;
}

.dataon-register-form-row {
  display: grid;
  grid-template-columns: 170px minmax(0, 1fr);
  min-height: 54px;
  border-bottom: 1px solid #E4E9F0;
}

.dataon-register-form-row > label {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  color: #536176;
  background: #F8FAFC;
  font-size: 14px;
  font-weight: 850;
}

.dataon-register-form-control {
  display: grid;
  align-content: center;
  gap: 8px;
  min-width: 0;
  padding: 8px 12px;
}

.dataon-register-form-control.is-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.dataon-register-form-control.is-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dataon-register-form-control.is-four {
  grid-template-columns: 120px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
}

.dataon-register-form-control input,
.dataon-register-form-control select,
.dataon-register-form-control textarea,
.dataon-register-table-search input,
.dataon-register-table-search select,
.dataon-register-file-meta input,
.dataon-register-file-meta select,
.dataon-register-review-box textarea {
  min-width: 0;
  width: 100%;
  border: 1px solid #D4DCE7;
  border-radius: 2px;
  background-color: #FFFFFF;
  color: #27364D;
  font-size: 14px;
  font-weight: 650;
}

.dataon-register-form-control input,
.dataon-register-form-control select,
.dataon-register-table-search input,
.dataon-register-table-search select,
.dataon-register-file-meta input,
.dataon-register-file-meta select {
  height: 38px;
  padding: 0 11px;
}

.dataon-register-form-control input[type=checkbox],
.dataon-register-form-control input[type=radio],
.dataon-register-agreebox input[type=checkbox],
.dataon-register-table input[type=checkbox] {
  width: 16px;
  min-width: 16px;
  height: 16px;
  padding: 0;
}

.dataon-register-radio span {
  white-space: nowrap;
}

.dataon-register-form-control textarea,
.dataon-register-review-box textarea {
  padding: 10px 11px;
  resize: vertical;
}

.dataon-register-square-button {
  display: inline-flex;
  width: 38px;
  min-width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  color: #126CE0;
  border: 1px solid #7FB0EA;
  border-radius: 2px;
  background: #FFFFFF;
}

.dataon-register-upload-box {
  border-top: 2px solid #8D96A2;
  padding-top: 14px;
}

.dataon-register-upload-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-bottom: 8px;
}

.dataon-register-upload-actions button {
  min-height: 36px;
  padding: 0 18px;
  color: #27364D;
  border: 1px solid #C9D3E0;
  border-radius: 2px;
  background: #FFFFFF;
  font-size: 14px;
  font-weight: 760;
}

.dataon-register-dropzone {
  display: flex;
  min-height: 88px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #8A96A8;
  border: 1px solid #DDE5EE;
  background: #FAFBFD;
  font-size: 14px;
  font-weight: 800;
}

.dataon-register-dropzone i {
  font-size: 24px;
}

.dataon-register-file-meta {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) 130px 130px 130px;
  gap: 8px;
  margin-top: 8px;
}

.dataon-register-empty-state {
  display: grid;
  justify-items: center;
  gap: 12px;
  min-height: 280px;
  align-content: center;
  color: #536176;
  text-align: center;
}

.dataon-register-empty-state i {
  color: #126CE0;
  font-size: 34px;
}

.dataon-register-empty-state strong {
  color: #111827;
  font-size: 20px;
  font-weight: 900;
}

.dataon-register-empty-state p {
  max-width: 520px;
  margin: 0;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.6;
}

.dataon-register-form-row.is-url {
  margin-top: 8px;
  border-top: 1px solid #E4E9F0;
}

.dataon-register-summary-grid {
  display: grid;
  margin: 0;
  border-top: 2px solid #8D96A2;
}

.dataon-register-summary-grid div {
  display: grid;
  grid-template-columns: 170px minmax(0, 1fr);
  border-bottom: 1px solid #E4E9F0;
}

.dataon-register-summary-grid dt,
.dataon-register-summary-grid dd {
  min-width: 0;
  margin: 0;
  padding: 13px 14px;
  color: #3D4A5F;
  font-size: 14px;
  font-weight: 720;
}

.dataon-register-summary-grid dt {
  color: #536176;
  background: #F8FAFC;
  font-weight: 900;
}

.dataon-register-list-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 16px;
}

.dataon-register-tabs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.dataon-register-tabs button {
  min-height: 42px;
  padding: 0 22px;
  color: #66748A;
  border: 1px solid transparent;
  border-radius: 2px;
  background: #FFFFFF;
  font-size: 17px;
  font-weight: 780;
}

.dataon-register-tabs button.is-active {
  color: #111827;
  border-color: #D5DEE9;
  background: #FFFFFF;
  box-shadow: inset 0 -3px 0 #126CE0;
}

.dataon-register-tabs span {
  color: #6A7687;
  font-size: 15px;
  font-weight: 680;
}

.dataon-register-tabs span strong {
  color: #111827;
  font-weight: 900;
}

.dataon-register-table-search {
  display: grid;
  grid-template-columns: 150px minmax(180px, 280px) 112px;
  gap: 6px;
}

.dataon-register-table-search button {
  color: #FFFFFF;
  background: #343A40;
  font-size: 16px;
  font-weight: 850;
}

.dataon-register-table-wrap {
  overflow-x: auto;
  border-top: 2px solid #7B8593;
  background: #FFFFFF;
}

.dataon-register-table {
  width: 100%;
  min-width: 780px;
  border-collapse: collapse;
  color: #4A5668;
  font-size: 15px;
}

.dataon-register-table th,
.dataon-register-table td {
  height: 58px;
  padding: 12px 14px;
  border-bottom: 1px solid #E1E7EF;
  text-align: center;
  vertical-align: middle;
}

.dataon-register-table th {
  color: #68758A;
  background: #FFFFFF;
  font-size: 15px;
  font-weight: 850;
}

.dataon-register-table tbody tr:nth-child(odd) {
  background: #FFFFFF;
}

.dataon-register-table tbody tr:nth-child(even) {
  background: #F2F2F2;
}

.dataon-register-table tbody tr.is-selected {
  outline: 2px solid #126CE0;
  outline-offset: -2px;
  background: #F0F7FF;
}

.dataon-register-title-button {
  color: #4A5668;
  background: transparent;
  font-size: 15px;
  font-weight: 760;
  text-align: left;
}

.dataon-register-title-button:hover,
.dataon-register-title-button:focus-visible {
  color: #0067D6;
}

.dataon-register-status {
  display: inline-flex;
  min-width: 84px;
  justify-content: center;
  padding: 7px 10px;
  border-radius: 2px;
  color: #6B7280;
  background: #F1F3F6;
  font-weight: 820;
}

.dataon-register-status.is-pending,
.dataon-register-status.is-created {
  color: #7C5B2C;
  background: #FFF4E0;
}

.dataon-register-status.is-rejected {
  color: #B42336;
  background: #FFE8EC;
}

.dataon-register-status.is-workspace {
  color: #005FC5;
  background: #E9F3FF;
}

.dataon-register-status.is-archived,
.dataon-register-status.is-approved {
  color: #087443;
  background: #E6F7EF;
}

.dataon-register-stat-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 18px;
  align-items: stretch;
}

.dataon-register-bar-chart,
.dataon-register-stat-table,
.dataon-register-approval-list,
.dataon-register-approval-detail {
  border: 1px solid #D8E0EA;
  background: #FFFFFF;
}

.dataon-register-bar-chart {
  display: grid;
  gap: 0;
  padding: 28px;
}

.dataon-register-bar-row {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr) 42px;
  align-items: center;
  min-height: 120px;
  gap: 16px;
  border-bottom: 1px solid #E5E9EF;
}

.dataon-register-bar-row:last-child {
  border-bottom: 0;
}

.dataon-register-bar-row > span {
  color: #6A7687;
  font-size: 16px;
  font-weight: 800;
  text-align: right;
}

.dataon-register-bar-track {
  position: relative;
  height: 58px;
  border-left: 1px solid #D8DEE8;
  background: repeating-linear-gradient(to right, #EEF1F5 0, #EEF1F5 1px, transparent 1px, transparent 10%);
}

.dataon-register-bar-track em {
  display: block;
  height: 100%;
  min-width: 2px;
}

.dataon-register-bar-row strong {
  color: #3D4A5F;
  font-size: 15px;
  font-weight: 900;
}

.dataon-register-stat-table {
  width: 100%;
  border-collapse: collapse;
}

.dataon-register-stat-table th,
.dataon-register-stat-table td {
  height: 132px;
  padding: 18px;
  border: 1px solid #D7DCE4;
  color: #566273;
  font-size: 18px;
  font-weight: 760;
  text-align: center;
}

.dataon-register-stat-table th {
  width: 55%;
  background: #F4F4F4;
}

.dataon-register-approval-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 18px;
}

.dataon-register-approval-list {
  min-width: 0;
  padding: 18px;
}

.dataon-register-approval-list .dataon-register-table {
  min-width: 0;
  table-layout: fixed;
  font-size: 14px;
}

.dataon-register-approval-list .dataon-register-table th,
.dataon-register-approval-list .dataon-register-table td {
  padding: 10px 8px;
}

.dataon-register-approval-list .dataon-register-table th:nth-child(1),
.dataon-register-approval-list .dataon-register-table td:nth-child(1) {
  width: 116px;
}

.dataon-register-approval-list .dataon-register-table th:nth-child(3),
.dataon-register-approval-list .dataon-register-table td:nth-child(3) {
  width: 72px;
}

.dataon-register-approval-list .dataon-register-table th:nth-child(4),
.dataon-register-approval-list .dataon-register-table td:nth-child(4) {
  width: 48px;
}

.dataon-register-approval-list .dataon-register-table th:nth-child(5),
.dataon-register-approval-list .dataon-register-table td:nth-child(5) {
  width: 88px;
}

.dataon-register-approval-list .dataon-register-table th:nth-child(6),
.dataon-register-approval-list .dataon-register-table td:nth-child(6) {
  width: 92px;
}

.dataon-register-approval-list .dataon-register-table td:nth-child(2) {
  text-align: left;
}

.dataon-register-approval-list .dataon-register-status {
  min-width: 74px;
  padding: 7px 8px;
  white-space: nowrap;
}

.dataon-register-approval-detail {
  padding: 20px;
}

.dataon-register-approval-detail h3 {
  margin: 0 0 16px;
  color: #111827;
  font-size: 21px;
  font-weight: 900;
}

.dataon-register-approval-detail dl {
  display: grid;
  gap: 0;
  margin: 0;
  border-top: 2px solid #7B8593;
}

.dataon-register-approval-detail dl div {
  display: grid;
  grid-template-columns: 94px minmax(0, 1fr);
  border-bottom: 1px solid #E4E9F0;
}

.dataon-register-approval-detail dt,
.dataon-register-approval-detail dd {
  min-width: 0;
  margin: 0;
  padding: 11px 10px;
  color: #4A5668;
  font-size: 14px;
  font-weight: 720;
}

.dataon-register-approval-detail dt {
  color: #536176;
  background: #F8FAFC;
  font-weight: 900;
}

.dataon-register-review-box {
  display: grid;
  gap: 8px;
  margin-top: 16px;
}

.dataon-register-review-box label {
  color: #27364D;
  font-size: 14px;
  font-weight: 900;
}

@media (max-width: 1120px) {
  .dataon-register-layout,
  .dataon-register-stat-layout,
  .dataon-register-approval-layout {
    grid-template-columns: 1fr;
  }
  .dataon-register-side {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .dataon-register-side strong {
    grid-column: 1/-1;
  }
  .dataon-register-collection-layout {
    grid-template-columns: 1fr;
  }
  .dataon-register-collection-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .dataon-register-body {
    padding: 28px 0 54px;
  }
  .dataon-register-side,
  .dataon-register-flow,
  .dataon-register-form-steps,
  .dataon-register-form-control.is-grid,
  .dataon-register-form-control.is-four,
  .dataon-register-file-meta,
  .dataon-register-list-head,
  .dataon-register-table-search {
    grid-template-columns: 1fr;
  }
  .dataon-register-flow li {
    border-top: 1px solid #E7EEF6;
    border-left: 0;
  }
  .dataon-register-flow li:first-child {
    border-top: 0;
  }
  .dataon-register-panel {
    padding: 18px;
  }
  .dataon-register-redbox {
    padding: 18px;
    font-size: 14px;
  }
  .dataon-register-collection-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataon-register-collection-card {
    height: 88px;
  }
  .dataon-register-form-steps li {
    justify-content: flex-start;
    border-top: 1px solid #E4EAF2;
    border-left: 0;
  }
  .dataon-register-form-steps li:first-child {
    border-top: 0;
  }
  .dataon-register-editor-head,
  .dataon-register-bottom-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .dataon-register-form-row,
  .dataon-register-summary-grid div,
  .dataon-register-approval-detail dl div,
  .dataon-register-bar-row {
    grid-template-columns: 1fr;
  }
  .dataon-register-form-row > label,
  .dataon-register-summary-grid dt,
  .dataon-register-approval-detail dt {
    min-height: 40px;
  }
  .dataon-register-bar-row {
    min-height: 96px;
  }
  .dataon-register-bar-row > span {
    text-align: left;
  }
}
/* ReviewOps lzpfxyjbzplfwgfgslkmthgajepuojnc: keep advanced search panel above hero overlays. */
.dataon-page .dataon-hero,
.dataon-page[data-language=en] .dataon-hero,
.dataon-page .dataon-hero-grid,
.dataon-page[data-language=en] .dataon-hero-grid {
  overflow: visible;
}

.dataon-page .dataon-search-block,
.dataon-page[data-language=en] .dataon-search-block {
  z-index: 11000;
}

.dataon-page .dataon-search-block.has-advanced-open,
.dataon-page[data-language=en] .dataon-search-block.has-advanced-open {
  z-index: 12000;
}

.dataon-page .dataon-search-block .dataon-advanced-search-panel,
.dataon-page[data-language=en] .dataon-search-block .dataon-advanced-search-panel {
  z-index: 12050;
  max-height: min(620px, 100vh - 180px);
}

@media (max-width: 760px) {
  .dataon-page .dataon-search-block .dataon-advanced-search-panel,
  .dataon-page[data-language=en] .dataon-search-block .dataon-advanced-search-panel {
    max-height: min(560px, 100vh - 112px);
  }
}
/* ReviewOps zthluqfwfwmydggwhvyqthxrvngbjsbi: DataON quick menu open state */
@media (max-width: 1440px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    right: 28px;
    bottom: calc(30px + env(safe-area-inset-bottom));
    z-index: 10000;
  }
  .dataon-page .dataon-floating-quick.is-mobile-visible,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-visible {
    pointer-events: auto;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions {
    display: grid;
    grid-template-columns: 64px;
    grid-auto-rows: 64px;
    gap: 8px;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions button {
    width: 64px;
    min-width: 64px;
    height: 64px;
    min-height: 64px;
    color: #FFFFFF;
    border: 0;
    border-radius: 50%;
    background: #252D45;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    box-shadow: 0 10px 24px rgba(5, 35, 82, 0.24);
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-toggle,
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-toggle[aria-expanded=true],
  .dataon-page .dataon-floating-quick .dataon-mobile-top-button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-toggle,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-toggle[aria-expanded=true],
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-top-button {
    background: #252D45;
  }
  .dataon-page .dataon-floating-quick.is-mobile-open .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-open .dataon-mobile-quick-actions {
    display: none;
  }
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    position: fixed;
    top: calc(50vh + 44px);
    right: 28px;
    bottom: auto;
    display: grid;
    width: 125px;
    max-height: calc(100vh - 32px);
    overflow-x: hidden;
    overflow-y: auto;
    visibility: hidden;
    border: 0;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0 14px 30px rgba(5, 35, 82, 0.18);
    opacity: 0;
    pointer-events: none;
    transform: translateY(-46%) scale(0.98);
    transform-origin: right center;
    transition: opacity 160ms ease, transform 160ms ease, visibility 160ms ease;
  }
  .dataon-page .dataon-floating-quick.is-mobile-open .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-open .dataon-quick-panel {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
    transform: translateY(-50%) scale(1);
  }
  .dataon-page .dataon-floating-quick strong,
  .dataon-page[data-language=en] .dataon-floating-quick strong {
    display: flex;
    flex-direction: column;
    height: 81px;
    align-items: center;
    justify-content: center;
    gap: 0;
    padding: 0;
    color: #FFFFFF;
    border-radius: 8px 8px 0 0;
    background: #252D45;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.25;
    text-align: center;
    white-space: pre-line;
  }
  .dataon-page .dataon-floating-quick strong span,
  .dataon-page[data-language=en] .dataon-floating-quick strong span {
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 700;
  }
  .dataon-page .dataon-floating-quick .dataon-quick-close,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close {
    position: absolute;
    z-index: 1;
    top: 9px;
    right: 8px;
    display: flex;
    width: 30px;
    min-width: 30px;
    height: 30px;
    min-height: 30px;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #FFFFFF;
    border: 0;
    background: transparent;
    box-shadow: none;
  }
  .dataon-page .dataon-floating-quick .dataon-quick-close i,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close i {
    font-size: 20px;
    line-height: 1;
  }
  .dataon-page .dataon-floating-quick .dataon-quick-close span,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close span {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link {
    display: grid;
    grid-template-rows: 35px minmax(22px, auto);
    min-height: 96px;
    align-content: center;
    justify-items: center;
    row-gap: 8px;
    padding: 12px 8px 10px;
    color: #333333;
    border-bottom: 1px solid #D1D5DD;
    background: #FFFFFF;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.2;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link img,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link img {
    width: 33px;
    height: 33px;
    object-fit: contain;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link span,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link span {
    align-items: center;
    justify-content: center;
    min-height: 22px;
    color: #333333;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
    white-space: normal;
    word-break: keep-all;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-top,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-top {
    display: flex;
    height: 53px;
    min-height: 53px;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #FFFFFF;
    border: 0;
    border-radius: 0 0 8px 8px;
    background: #252D45;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
  }
}
@media (max-width: 520px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    right: 16px;
    bottom: calc(18px + env(safe-area-inset-bottom));
  }
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    right: 16px;
    width: 125px;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions {
    grid-template-columns: 58px;
    grid-auto-rows: 58px;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions button {
    width: 58px;
    min-width: 58px;
    height: 58px;
    min-height: 58px;
    font-size: 13px;
  }
}
@media (max-width: 520px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    right: 16px;
    bottom: calc(18px + env(safe-area-inset-bottom));
  }
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    bottom: 130px;
    width: 108px;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions {
    grid-template-columns: 58px;
    grid-auto-rows: 58px;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions button {
    width: 58px;
    min-width: 58px;
    height: 58px;
    min-height: 58px;
    font-size: 13px;
  }
}
/* ReviewOps zthluqfwfwmydggwhvyqthxrvngbjsbi: final quick menu follow position override */
@media (max-width: 1440px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    --quick-menu-follow-y: 0px;
  }
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    top: 64vh;
    right: 28px;
    bottom: auto;
    width: 125px;
    transform: translateY(calc(-48% + var(--quick-menu-follow-y, 0px))) scale(0.98);
    transition: opacity 160ms ease, transform 360ms cubic-bezier(0.22, 1, 0.36, 1), visibility 160ms ease;
    will-change: transform;
  }
  .dataon-page .dataon-floating-quick.is-mobile-open .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-open .dataon-quick-panel {
    transform: translateY(calc(-48% + var(--quick-menu-follow-y, 0px))) scale(1);
  }
}
@media (max-width: 520px) {
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    top: 64vh;
    right: 16px;
    bottom: auto;
    width: 125px;
  }
}
@media (max-width: 1440px) and (max-height: 760px) {
  .dataon-page .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-quick-panel {
    top: 61vh;
    max-height: calc(100vh - 28px);
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link {
    min-height: 88px;
  }
}
/* ReviewOps zthluqfwfwmydggwhvyqthxrvngbjsbi: keep desktop quick menu below viewport center */
@media (min-width: 1441px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    --quick-menu-follow-y: 0px;
    top: 64vh;
    right: 24px;
    bottom: auto;
    z-index: 10000;
    transform: translateY(calc(-48% + var(--quick-menu-follow-y, 0px))) !important;
    transform-origin: right center;
    transition: transform 360ms cubic-bezier(0.22, 1, 0.36, 1);
    will-change: transform;
  }
}
@media (min-width: 1441px) and (max-height: 760px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    top: 61vh;
  }
}
/* ReviewOps uxhxejqxcqrkanifawjwlkhlkzryozky: hide search surfaces while top menu layers are open. */
.dataon-page:has(.dataon-sitemap) .dataon-search-block,
.dataon-page:has(.dataon-sitemap) .dataon-results-search-block,
.dataon-page:has(.dataon-sitemap) .dataon-content-top-search-panel,
.dataon-page:has(.dataon-sitemap) .dataon-content-top-search-toggle,
.dataon-page:has(.dataon-nav-panel.is-active) .dataon-search-block,
.dataon-page:has(.dataon-nav-panel.is-active) .dataon-results-search-block,
.dataon-page:has(.dataon-nav-panel.is-active) .dataon-content-top-search-panel,
.dataon-page:has(.dataon-nav-panel.is-active) .dataon-content-top-search-toggle,
.dataon-page[data-language=en]:has(.dataon-sitemap) .dataon-search-block,
.dataon-page[data-language=en]:has(.dataon-sitemap) .dataon-results-search-block,
.dataon-page[data-language=en]:has(.dataon-sitemap) .dataon-content-top-search-panel,
.dataon-page[data-language=en]:has(.dataon-sitemap) .dataon-content-top-search-toggle,
.dataon-page[data-language=en]:has(.dataon-nav-panel.is-active) .dataon-search-block,
.dataon-page[data-language=en]:has(.dataon-nav-panel.is-active) .dataon-results-search-block,
.dataon-page[data-language=en]:has(.dataon-nav-panel.is-active) .dataon-content-top-search-panel,
.dataon-page[data-language=en]:has(.dataon-nav-panel.is-active) .dataon-content-top-search-toggle {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

/* ReviewOps lzpfxyjbzplfwgfgslkmthgajepuojnc: advanced search detail refinements. */
.dataon-page .dataon-search-detail-toggle::before,
.dataon-page[data-language=en] .dataon-search-detail-toggle::before {
  content: "";
  display: inline-block;
  flex: 0 0 19px;
  width: 19px;
  height: 19px;
  background: currentColor;
  -webkit-mask: url("/assets/dataon/2024/icon_dtl_srch.svg") center/contain no-repeat;
  mask: url("/assets/dataon/2024/icon_dtl_srch.svg") center/contain no-repeat;
}

.dataon-page .dataon-search-detail-toggle img,
.dataon-page[data-language=en] .dataon-search-detail-toggle img {
  display: none;
}

.dataon-page .dataon-advanced-condition-name,
.dataon-page .dataon-advanced-field-title h3,
.dataon-page .dataon-advanced-text-field span,
.dataon-page .dataon-advanced-year-range span,
.dataon-page .dataon-advanced-accordion-head,
.dataon-page .dataon-advanced-more-fields summary,
.dataon-page[data-language=en] .dataon-advanced-condition-name,
.dataon-page[data-language=en] .dataon-advanced-field-title h3,
.dataon-page[data-language=en] .dataon-advanced-text-field span,
.dataon-page[data-language=en] .dataon-advanced-year-range span,
.dataon-page[data-language=en] .dataon-advanced-accordion-head,
.dataon-page[data-language=en] .dataon-advanced-more-fields summary {
  font-weight: 700;
}

.dataon-page .dataon-advanced-options button,
.dataon-page .dataon-advanced-summary button,
.dataon-page[data-language=en] .dataon-advanced-options button,
.dataon-page[data-language=en] .dataon-advanced-summary button {
  font-weight: 700;
}

.dataon-page .dataon-advanced-accordion-head strong,
.dataon-page[data-language=en] .dataon-advanced-accordion-head strong {
  font-weight: 650;
}

.dataon-page .dataon-advanced-match button,
.dataon-page[data-language=en] .dataon-advanced-match button {
  min-height: 38px;
  padding: 0 14px;
  font-size: 13px;
}

.dataon-page .dataon-advanced-match button em,
.dataon-page[data-language=en] .dataon-advanced-match button em {
  padding: 3px 7px;
  font-size: 11px;
}

.dataon-page .dataon-advanced-condition-name,
.dataon-page[data-language=en] .dataon-advanced-condition-name {
  font-size: 15px;
  line-height: 36px;
}

.dataon-page .dataon-advanced-project-grid,
.dataon-page[data-language=en] .dataon-advanced-project-grid {
  column-gap: 28px;
  row-gap: 14px;
}

.dataon-page .dataon-advanced-text-field,
.dataon-page[data-language=en] .dataon-advanced-text-field {
  grid-template-columns: max-content minmax(0, 1fr);
  align-items: center;
  column-gap: 8px;
  row-gap: 6px;
}

.dataon-page .dataon-advanced-text-field span,
.dataon-page[data-language=en] .dataon-advanced-text-field span {
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
}

.dataon-page .dataon-advanced-options button,
.dataon-page[data-language=en] .dataon-advanced-options button {
  min-height: 34px;
  padding: 0 12px;
  font-size: 14px;
}

.dataon-page .dataon-advanced-footer,
.dataon-page[data-language=en] .dataon-advanced-footer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.dataon-page .dataon-advanced-summary,
.dataon-page[data-language=en] .dataon-advanced-summary {
  flex-wrap: nowrap;
  min-width: 0;
  min-height: 42px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 2px;
  scrollbar-width: thin;
}

.dataon-page .dataon-advanced-summary > span,
.dataon-page .dataon-advanced-summary-empty,
.dataon-page[data-language=en] .dataon-advanced-summary > span,
.dataon-page[data-language=en] .dataon-advanced-summary-empty {
  font-size: 13px;
}

.dataon-page .dataon-advanced-summary button,
.dataon-page[data-language=en] .dataon-advanced-summary button {
  flex: 0 1 auto;
  max-width: 360px;
  min-width: 0;
  min-height: 31px;
  padding: 0 10px;
  font-size: 13px;
}

.dataon-page .dataon-advanced-summary button em,
.dataon-page[data-language=en] .dataon-advanced-summary button em {
  display: block;
}

.dataon-page .dataon-advanced-button-row,
.dataon-page[data-language=en] .dataon-advanced-button-row {
  flex: 0 0 auto;
  flex-wrap: nowrap;
  min-width: max-content;
}

.dataon-page .dataon-advanced-button-row button,
.dataon-page[data-language=en] .dataon-advanced-button-row button {
  flex: 0 0 auto;
  min-width: 96px;
  min-height: 44px;
  font-size: 15px;
  white-space: nowrap;
}

.dataon-page .dataon-advanced-apply,
.dataon-page[data-language=en] .dataon-advanced-apply {
  min-width: 156px;
}

@media (max-width: 760px) {
  .dataon-page .dataon-advanced-footer,
  .dataon-page[data-language=en] .dataon-advanced-footer {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
  .dataon-page .dataon-advanced-summary,
  .dataon-page[data-language=en] .dataon-advanced-summary {
    min-height: 36px;
  }
  .dataon-page .dataon-advanced-button-row,
  .dataon-page[data-language=en] .dataon-advanced-button-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    min-width: 0;
  }
  .dataon-page .dataon-advanced-button-row button,
  .dataon-page[data-language=en] .dataon-advanced-button-row button {
    width: 100%;
    min-width: 0;
  }
}
@media (max-width: 520px) {
  .dataon-page .dataon-advanced-text-field,
  .dataon-page[data-language=en] .dataon-advanced-text-field {
    grid-template-columns: 1fr;
    align-items: start;
  }
}
/* ReviewOps lzpfxyjbzplfwgfgslkmthgajepuojnc: restore home recommended keyword pills. */
.dataon-page .dataon-chip-row,
.dataon-page[data-language=en] .dataon-chip-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: none;
  margin: 10px 0 0;
  overflow: visible;
}

.dataon-page .dataon-chip-label,
.dataon-page[data-language=en] .dataon-chip-label {
  display: inline-flex;
  flex: 0 0 auto;
  min-height: 30px;
  align-items: center;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.dataon-page .dataon-chip-list,
.dataon-page[data-language=en] .dataon-chip-list {
  display: flex;
  flex: 1 1 auto;
  max-width: none;
  min-width: 0;
  height: 32px;
  align-items: center;
  overflow: hidden;
}

.dataon-page .dataon-chip-track,
.dataon-page[data-language=en] .dataon-chip-track {
  display: flex;
  width: max-content;
  min-width: max-content;
  align-items: center;
  animation: dataon-keyword-slide 58s linear infinite;
}

.dataon-page .dataon-chip-group,
.dataon-page .dataon-chip-group[aria-hidden=true],
.dataon-page[data-language=en] .dataon-chip-group,
.dataon-page[data-language=en] .dataon-chip-group[aria-hidden=true] {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  padding-right: 8px;
}

.dataon-page .dataon-chip,
.dataon-page[data-language=en] .dataon-chip {
  display: inline-flex;
  flex: 0 0 auto;
  min-width: 0;
  height: 30px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(8px);
}

.dataon-page .dataon-chip:hover,
.dataon-page[data-language=en] .dataon-chip:hover {
  border-color: rgba(255, 255, 255, 0.54);
  background: rgba(0, 103, 214, 0.38);
}

@media (max-width: 680px) {
  .dataon-page .dataon-chip-row,
  .dataon-page[data-language=en] .dataon-chip-row {
    gap: 8px;
  }
  .dataon-page .dataon-chip-label,
  .dataon-page[data-language=en] .dataon-chip-label {
    font-size: 13px;
  }
  .dataon-page .dataon-chip,
  .dataon-page[data-language=en] .dataon-chip {
    height: 28px;
    padding: 0 10px;
    font-size: 12px;
  }
}
@font-face {
  font-family: "NanumSquare";
  font-weight: 300;
  font-style: normal;
  font-display: swap;
  src: url("/assets/font/NanumSquare/NanumSquareL.woff2") format("woff2");
}
@font-face {
  font-family: "NanumSquare";
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  src: url("/assets/font/NanumSquare/NanumSquareR.woff2") format("woff2");
}
@font-face {
  font-family: "NanumSquare";
  font-weight: 700;
  font-style: normal;
  font-display: swap;
  src: url("/assets/font/NanumSquare/NanumSquareB.woff2") format("woff2");
}
@font-face {
  font-family: "NanumSquare";
  font-weight: 800;
  font-style: normal;
  font-display: swap;
  src: url("/assets/font/NanumSquare/NanumSquareEB.woff2") format("woff2");
}
/* ReviewOps ahfvtwtcvtjylsixmozgatvkfscazpoy: official content-top search toggle. */
.dataon-official-clone .dataon-official-sub-top,
.dataon-official-search-page .dataon-official-search-visual {
  position: relative;
  overflow: hidden;
  --dataon-content-search-header-offset: 120px;
  --dataon-content-search-tab-center: calc(var(--dataon-content-search-header-offset) + 7.3125rem);
}

.dataon-official-clone .dataon-official-sub-top::after,
.dataon-official-search-page .dataon-official-search-visual::after {
  display: none;
  content: none;
}

.dataon-official-clone .dataon-official-sub-inner,
.dataon-official-search-page .dataon-official-search-visual-inner {
  transition: opacity 0.28s ease, visibility 0.28s ease;
}

.dataon-official-clone .dataon-official-sub-top.has-content-search-open .dataon-official-sub-inner,
.dataon-official-search-page .dataon-official-search-visual.has-content-search-open .dataon-official-search-visual-inner {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.dataon-content-top-search-toggle {
  position: absolute;
  top: var(--dataon-content-search-tab-center);
  right: -4.1rem;
  z-index: 6;
  display: block;
  width: 11.4375rem;
  height: 3.375rem;
  align-items: center;
  justify-content: center;
  margin-top: -1.6875rem;
  color: #FFFFFF;
  border: 0;
  border-radius: 0 0 1rem 1rem;
  background: linear-gradient(to left, #0E468D, #106ADC);
  box-shadow: none;
  font-family: "NanumSquare", "Noto Sans KR", sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 3.375rem;
  letter-spacing: 0;
  text-align: center;
  transform: rotate(90deg);
  transition: background 0.4s, color 0.4s, opacity 0.28s ease, transform 0.4s;
}

.dataon-content-top-search-toggle:hover,
.dataon-content-top-search-toggle:focus-visible {
  background: linear-gradient(to left, #0A3E83, #0F61CE);
}

.dataon-content-top-search-toggle.is-active {
  color: #303030;
  background: linear-gradient(to left, #FF8115, #FECE32);
}

.dataon-content-top-search-toggle span {
  display: inline-block;
}

.dataon-content-top-search-toggle i {
  margin-left: 0.4rem;
  font-size: 1.25rem;
  transform: rotate(-90deg);
}

.dataon-content-top-search-panel {
  position: absolute;
  top: var(--dataon-content-search-header-offset);
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2.875rem 5.5rem 0 2rem;
  color: #FFFFFF;
  background: transparent;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(-0.625rem);
  transition: opacity 0.32s ease, visibility 0.32s ease, transform 0.32s ease;
}

.dataon-content-top-search-panel.is-active {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0);
}

.dataon-content-top-search-inner {
  display: grid;
  width: min(42rem, 100%);
  align-content: center;
  gap: 1.75rem;
  font-family: "NanumSquare", "Noto Sans KR", "SUIT", sans-serif;
}

.dataon-content-top-search-modes {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
}

.dataon-content-top-search-modes button {
  position: relative;
  display: inline-flex;
  min-width: 0;
  height: 2.8125rem;
  align-items: center;
  justify-content: center;
  padding: 0 1.125rem;
  color: #FFFFFF;
  border: 1px solid #FFFFFF;
  border-radius: 1.5rem;
  background: rgba(0, 0, 0, 0.12);
  font-family: "NanumSquare", "Noto Sans KR", "SUIT", sans-serif;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 2.6rem;
  white-space: nowrap;
  transition: color 0.2s, border-color 0.2s, background-color 0.2s;
}

.dataon-content-top-search-modes button i {
  margin-left: 0.45rem;
  color: currentColor;
  font-size: 0.75rem;
}

.dataon-content-top-search-modes button:hover,
.dataon-content-top-search-modes button:focus-visible,
.dataon-content-top-search-modes button.is-active {
  color: #07122A;
  border-color: transparent;
  background: linear-gradient(to right, #FED230, #FEBB3D);
  font-weight: 700;
}

.dataon-content-top-search-modes button.is-active::after {
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  width: 0;
  height: 0;
  border-width: 0.5rem 0.5rem 0;
  border-style: solid;
  border-color: #FEC637 transparent transparent;
  content: "";
  transform: translateX(-50%);
}

.dataon-content-top-search-modes button em {
  position: absolute;
  top: -0.625rem;
  right: -0.8125rem;
  display: inline-flex;
  min-width: 3.125rem;
  height: 1.5rem;
  align-items: center;
  justify-content: center;
  padding: 0 0.6875rem;
  color: #FFFFFF;
  border-radius: 0.75rem;
  background: #FF5D65;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1;
  text-align: center;
}

.dataon-content-top-search-form {
  position: relative;
  display: block;
  min-width: 0;
  width: 100%;
  max-width: 42rem;
  overflow: hidden;
  border: 0;
  border-radius: 0.3125rem;
  background: #FFFFFF;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.16);
}

.dataon-content-top-search-form input {
  min-width: 0;
  height: 3.75rem;
  width: 100%;
  padding: 0 4.25rem 0 1.5625rem;
  color: #222222;
  border: 0;
  border-radius: 0;
  background: #FFFFFF;
  font-family: "NanumSquare", "Noto Sans KR", "SUIT", sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
}

.dataon-content-top-search-form input::placeholder {
  color: #B2B2B2;
}

.dataon-content-top-search-form input:focus {
  outline: 0;
  box-shadow: none;
}

.dataon-content-top-search-submit {
  position: absolute;
  top: 50%;
  right: 0.95rem;
  display: inline-flex;
  width: 2.5rem;
  height: 2.5rem;
  align-items: center;
  justify-content: center;
  color: #2176DD;
  border: 0;
  background: transparent;
  font-size: 0;
  font-weight: 800;
  transform: translateY(-50%);
}

.dataon-content-top-search-submit:hover,
.dataon-content-top-search-submit:focus-visible {
  color: #004EBA;
  background: transparent;
}

.dataon-content-top-search-submit i {
  font-size: 1.5rem;
}

.dataon-content-top-search-help {
  position: relative;
  justify-self: end;
  margin-top: -0.875rem;
  margin-right: 0.5rem;
}

.dataon-content-top-search-help > button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #FFD02E;
  font-family: "NanumSquare", "Noto Sans KR", "SUIT", sans-serif;
  font-size: 1rem;
  font-weight: 700;
}

.dataon-content-top-search-help > button i {
  font-size: 1rem;
}

.dataon-content-top-search-help-popover {
  position: absolute;
  top: 2rem;
  right: 0;
  z-index: 8;
  width: min(36rem, 100vw - 3rem);
  padding: 1rem;
  color: #222222;
  border: 1px solid #DDE5EF;
  background: #FFFFFF;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.22);
}

.dataon-content-top-search-help-popover table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

.dataon-content-top-search-help-popover th,
.dataon-content-top-search-help-popover td {
  padding: 0.5rem;
  border: 1px solid #E4E9F0;
  text-align: left;
  vertical-align: top;
}

.dataon-content-top-search-help-popover th {
  color: #0B1733;
  background: #F4F8FC;
}

.dataon-content-top-search-help-close {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  width: 1.75rem;
  height: 1.75rem;
  color: #555555;
}

@media (max-width: 1320px) {
  .dataon-content-top-search-toggle {
    right: -4.1rem;
  }
}
@media (max-width: 980px) {
  .dataon-content-top-search-panel {
    padding-right: 4.75rem;
    padding-left: 1.25rem;
  }
}
@media (max-width: 760px) {
  .dataon-official-clone .dataon-official-sub-top,
  .dataon-official-search-page .dataon-official-search-visual {
    --dataon-content-search-header-offset: 72px;
    --dataon-content-search-tab-center: 11.5rem;
  }
  .dataon-content-top-search-toggle {
    right: -1.65rem;
    width: 6rem;
    height: 2.7rem;
    margin-top: 0;
    font-size: 0.9rem;
    line-height: 2.7rem;
  }
  .dataon-content-top-search-panel {
    padding: 2.25rem 3.75rem 1rem 1rem;
  }
  .dataon-content-top-search-inner {
    gap: 0.875rem;
  }
  .dataon-content-top-search-modes {
    gap: 0.375rem;
  }
  .dataon-content-top-search-modes button {
    height: 2.5rem;
    padding: 0 0.6rem;
    font-size: 0.9rem;
    line-height: 2.2rem;
  }
  .dataon-content-top-search-form input {
    height: 3rem;
    padding-right: 3.25rem;
    font-size: 1rem;
  }
  .dataon-content-top-search-submit {
    right: 0.45rem;
    width: 2.25rem;
    height: 2.25rem;
  }
  .dataon-content-top-search-submit i {
    font-size: 1rem;
  }
  .dataon-content-top-search-help {
    margin-top: -0.5rem;
    margin-right: 0;
  }
  .dataon-content-top-search-help > button {
    font-size: 0.8125rem;
  }
}
/* ReviewOps zthluqfwfwmydggwhvyqthxrvngbjsbi: match official DataON quick menu */
.dataon-page > main,
.dataon-page[data-language=en] > main {
  position: relative;
}

.dataon-page .dataon-floating-quick,
.dataon-page[data-language=en] .dataon-floating-quick {
  --quick-menu-follow-y: 0px;
  z-index: 22000;
  font-family: "NanumSquare", "Noto Sans KR", "SUIT", sans-serif;
}

.dataon-page .dataon-floating-quick .dataon-quick-panel,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-panel {
  border: 1px solid #262C41;
  border-radius: 10px;
  background-color: #262C41;
  box-shadow: none;
}

.dataon-page .dataon-floating-quick strong,
.dataon-page[data-language=en] .dataon-floating-quick strong {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0;
  color: #FFFFFF;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.35;
  text-align: center;
}

.dataon-page .dataon-floating-quick strong span,
.dataon-page[data-language=en] .dataon-floating-quick strong span {
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.35;
}

.dataon-page .dataon-floating-quick .dataon-quick-close,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  width: 30px;
  min-width: 30px;
  height: 30px;
  min-height: 30px;
  padding: 0;
  color: #FFFFFF;
  border: 0;
  background: transparent;
  box-shadow: none;
  outline: none;
}

.dataon-page .dataon-floating-quick .dataon-quick-close i,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close i {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
}

.dataon-page .dataon-floating-quick .dataon-quick-close span,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close span {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.dataon-page .dataon-floating-quick .dataon-floating-quick-link,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link {
  position: relative;
  display: block;
  width: 100%;
  height: 96px;
  min-height: 96px;
  padding: 0;
  color: #333333;
  border: 0;
  border-radius: 0;
  background: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  box-shadow: none;
}

.dataon-page .dataon-floating-quick .dataon-floating-quick-link:nth-of-type(-n+5)::after,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link:nth-of-type(-n+5)::after {
  position: absolute;
  bottom: -1px;
  left: 50%;
  z-index: 1;
  display: block;
  width: 80px;
  height: 1px;
  background-color: rgba(38, 44, 64, 0.35);
  content: "";
  transform: translateX(-50%);
}

.dataon-page .dataon-floating-quick .dataon-floating-quick-link:hover,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link:hover {
  color: #0092E5;
  background: #FFFFFF;
}

.dataon-page .dataon-floating-quick .dataon-floating-quick-link > span:last-child,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link > span:last-child {
  display: block;
  width: 100%;
  color: inherit;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  white-space: normal;
  word-break: keep-all;
}

.dataon-page .dataon-floating-quick .dataon-quick-link-icon,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-link-icon {
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto 10px;
}

.dataon-page .dataon-floating-quick .quick_icon01,
.dataon-page[data-language=en] .dataon-floating-quick .quick_icon01 {
  background: url("/assets/dataon/2024/icon_quick01.svg") center/26px 30px no-repeat;
}

.dataon-page .dataon-floating-quick .quick_icon02,
.dataon-page[data-language=en] .dataon-floating-quick .quick_icon02 {
  background: url("/assets/dataon/2024/icon_quick02.svg") center/30px 24px no-repeat;
}

.dataon-page .dataon-floating-quick .quick_icon03,
.dataon-page[data-language=en] .dataon-floating-quick .quick_icon03 {
  background: url("/assets/dataon/2024/icon_quick03.svg") center/30px 30px no-repeat;
}

.dataon-page .dataon-floating-quick .quick_icon04,
.dataon-page[data-language=en] .dataon-floating-quick .quick_icon04 {
  background: url("/assets/dataon/2024/icon_quick04.svg") center/30px 21px no-repeat;
}

.dataon-page .dataon-floating-quick .quick_icon05,
.dataon-page[data-language=en] .dataon-floating-quick .quick_icon05 {
  background: url("/assets/dataon/2024/icon_quick05.svg") center/30px 28px no-repeat;
}

.dataon-page .dataon-floating-quick .dataon-floating-top,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-top {
  display: flex;
  width: 100%;
  height: 51px;
  min-height: 51px;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #FFFFFF;
  border: 0;
  border-radius: 0 0 10px 10px;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  outline: none;
}

@media (min-width: 1758px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    position: absolute;
    top: 1020px;
    right: 80px;
    bottom: auto;
    display: block !important;
    width: 125px;
    height: 605px;
    overflow: visible;
    visibility: visible;
    border: 0;
    border-radius: 0;
    background: transparent;
    opacity: 1;
    pointer-events: auto;
    transform: none !important;
    transition: none;
  }
  .dataon-page .dataon-floating-quick.is-official-fixed,
  .dataon-page[data-language=en] .dataon-floating-quick.is-official-fixed {
    position: fixed;
    top: 100px;
  }
  .dataon-page .dataon-floating-quick .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-panel {
    position: static;
    display: block;
    width: 125px;
    height: 605px;
    max-height: none;
    overflow: hidden;
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
    transform: none !important;
    transition: none;
  }
  .dataon-page .dataon-floating-quick .dataon-quick-close,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close {
    display: none;
  }
  .dataon-page .dataon-floating-quick strong,
  .dataon-page[data-language=en] .dataon-floating-quick strong {
    height: 70px;
    padding: 0;
    border-radius: 10px 10px 0 0;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link {
    height: 96px;
    min-height: 96px;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link .dataon-quick-link-icon,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link .dataon-quick-link-icon {
    margin-top: 17px;
  }
}
@media (max-width: 1757px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    position: static;
    top: auto;
    right: auto;
    bottom: auto;
    display: block !important;
    width: 0;
    height: 0;
    overflow: visible;
    visibility: hidden;
    border: 0;
    border-radius: 0;
    background: transparent;
    opacity: 0;
    pointer-events: none;
    transform: none !important;
    transition: opacity 0.3s;
  }
  .dataon-page .dataon-floating-quick.is-mobile-visible,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-visible {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
  .dataon-page .dataon-floating-quick.is-mobile-open,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-open {
    opacity: 1;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions {
    position: fixed;
    right: 30px;
    bottom: 50px;
    z-index: 22001;
    display: flex;
    width: 70px;
    height: 150px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0 !important;
    opacity: 1;
    transition: opacity 0.3s;
  }
  .dataon-page .dataon-floating-quick.is-mobile-open .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-open .dataon-mobile-quick-actions {
    opacity: 0;
    pointer-events: none;
  }
  .dataon-page .dataon-floating-quick.is-mobile-closing .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-closing .dataon-mobile-quick-actions {
    opacity: 1 !important;
    pointer-events: auto;
    transition: none !important;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions button {
    display: flex;
    width: 70px;
    min-width: 70px;
    height: 70px;
    min-height: 70px;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #FFFFFF;
    border: 0;
    border-radius: 50%;
    background-color: #153879;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    box-shadow: none;
    outline: none;
    transform: none !important;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-toggle,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-toggle {
    margin-bottom: 10px;
  }
  .dataon-page .dataon-floating-quick .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-panel {
    position: absolute;
    top: calc(50% - 40px);
    right: -125px;
    bottom: auto;
    z-index: 22000;
    display: block;
    width: 125px;
    height: 616px;
    max-height: none;
    overflow: hidden;
    visibility: visible;
    opacity: 1;
    pointer-events: none;
    transform: translateY(-50%) !important;
    will-change: right;
    transition: right 0.38s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .dataon-page .dataon-floating-quick.is-official-fixed .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick.is-official-fixed .dataon-quick-panel {
    position: fixed;
    top: 50%;
    transform: translateY(-50%) !important;
  }
  .dataon-page .dataon-floating-quick.is-mobile-open .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-open .dataon-quick-panel {
    right: 10px;
    pointer-events: auto;
  }
  .dataon-page .dataon-floating-quick.is-mobile-closing .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-closing .dataon-quick-panel {
    right: -125px !important;
    pointer-events: none;
  }
  .dataon-page .dataon-floating-quick .dataon-quick-close,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close {
    display: block;
  }
  .dataon-page .dataon-floating-quick strong,
  .dataon-page[data-language=en] .dataon-floating-quick strong {
    height: 80px;
    padding-top: 10px;
    border-radius: 10px 10px 0 0;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link {
    height: 97px;
    min-height: 97px;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link .dataon-quick-link-icon,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link .dataon-quick-link-icon {
    margin-top: 17px;
  }
}
@media (max-width: 800px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    width: 55px;
    height: 120px;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions {
    width: 55px;
    height: 120px;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions button,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions button {
    width: 55px;
    min-width: 55px;
    height: 55px;
    min-height: 55px;
    font-size: 12px;
  }
  .dataon-page .dataon-floating-quick .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-panel {
    width: 95px;
    height: 530px;
    right: -95px;
  }
  .dataon-page .dataon-floating-quick.is-mobile-open .dataon-quick-panel,
  .dataon-page[data-language=en] .dataon-floating-quick.is-mobile-open .dataon-quick-panel {
    right: 10px;
  }
  .dataon-page .dataon-floating-quick strong,
  .dataon-page .dataon-floating-quick strong span,
  .dataon-page[data-language=en] .dataon-floating-quick strong,
  .dataon-page[data-language=en] .dataon-floating-quick strong span {
    font-size: 14px;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link {
    height: 79.8px;
    min-height: 79.8px;
    font-size: 14px;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link .dataon-quick-link-icon,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link .dataon-quick-link-icon {
    margin-top: 10px;
  }
  .dataon-page .dataon-floating-quick .dataon-floating-quick-link > span:last-child,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link > span:last-child,
  .dataon-page .dataon-floating-quick .dataon-floating-top,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-top {
    font-size: 14px;
  }
}
.dataon-page .dataon-floating-quick .dataon-quick-close,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-quick-close {
  display: none !important;
}

.dataon-page .dataon-floating-quick .dataon-floating-quick-link,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px !important;
}

.dataon-page .dataon-floating-quick .dataon-floating-quick-link .dataon-quick-link-icon,
.dataon-page[data-language=en] .dataon-floating-quick .dataon-floating-quick-link .dataon-quick-link-icon {
  flex: 0 0 30px;
  margin: 0 !important;
}

@media (max-width: 1757px) {
  .dataon-page .dataon-floating-quick,
  .dataon-page[data-language=en] .dataon-floating-quick {
    will-change: auto !important;
  }
  .dataon-page .dataon-floating-quick .dataon-mobile-quick-actions,
  .dataon-page[data-language=en] .dataon-floating-quick .dataon-mobile-quick-actions {
    top: auto !important;
    right: 30px !important;
    bottom: 50px !important;
    left: auto !important;
    will-change: auto !important;
    transform: none !important;
  }
}
.dataon-official-result-page .dataon-official-mobile-quick {
  display: none;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick {
  position: fixed;
  top: 436px;
  right: 58px;
  z-index: 22000;
  display: block;
  width: 100px;
  overflow: hidden;
  border: 1px solid #262C41;
  border-radius: 8px;
  background: #262C41;
  box-shadow: none;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick .quick_close {
  display: none;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick h3 {
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0;
  padding-top: 10px;
  color: #FFFFFF;
  background: #262C41;
  font-family: "NanumSquare", "Noto Sans KR", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.35;
  text-align: center;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick li {
  position: relative;
  margin: 0;
  padding: 0;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick li::after {
  position: absolute;
  right: 10px;
  bottom: 0;
  left: 10px;
  height: 1px;
  background: rgba(38, 44, 65, 0.35);
  content: "";
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick .dataon-official-sub-quick-link {
  display: flex;
  width: 100%;
  height: 82px;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #333333;
  border: 0;
  background: #FFFFFF;
  font-family: "NanumSquare", "Noto Sans KR", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick .menu_inner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 10px 0;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick .quick_icon {
  display: block;
  width: 30px;
  height: 30px;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick .quick_icon01 {
  background: url("/assets/dataon/2024/icon_quick01.svg") center/contain no-repeat;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick .quick_icon02 {
  background: url("/assets/dataon/2024/icon_quick02.svg") center/contain no-repeat;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick .quick_icon03 {
  background: url("/assets/dataon/2024/icon_quick03.svg") center/contain no-repeat;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick .quick_icon04 {
  background: url("/assets/dataon/2024/icon_quick04.svg") center/contain no-repeat;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick .quick_icon05 {
  background: url("/assets/dataon/2024/icon_quick05.svg") center/contain no-repeat;
}

.dataon-official-result-page .quick_menu.dataon-official-sub-quick #goToTop {
  display: flex;
  width: 100%;
  height: 41px;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #FFFFFF;
  border: 0;
  background: #262C41;
  font-family: "NanumSquare", "Noto Sans KR", sans-serif;
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 1024px) {
  .dataon-official-result-page .quick_menu.dataon-official-sub-quick {
    display: none;
  }
}
/* ReviewOps xdijtnioqiizvyidqhbvptbudqfisizj: common header/content/footer subpage top layout. */
.dataon-common-content-top,
.dataon-official-search-page .dataon-official-search-visual.dataon-common-content-top,
.dataon-official-result-page .dataon-official-search-visual.dataon-common-content-top {
  --dataon-content-top-height: 354px;
  --dataon-content-search-header-offset: 120px;
  --dataon-content-search-tab-center: 237px;
  position: relative;
  display: flex;
  box-sizing: border-box;
  height: var(--dataon-content-top-height);
  min-height: var(--dataon-content-top-height);
  max-height: var(--dataon-content-top-height);
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.dataon-common-content-top > .dataon-container {
  box-sizing: border-box;
  min-height: 100%;
  align-content: center;
  align-items: center;
  justify-content: center;
  padding-top: var(--dataon-content-search-header-offset) !important;
  padding-bottom: 0 !important;
  transition: opacity 0.28s ease, visibility 0.28s ease;
}

.dataon-common-content-top.has-content-search-open > .dataon-container {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.dataon-common-content-title {
  margin: 0;
  color: #FFFFFF;
  font-family: "NanumSquare", "Noto Sans KR", "SUIT", sans-serif;
  font-size: clamp(34px, 3vw, 44px);
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
}

.dataon-common-content-top .dataon-prototype-visual-inner,
.dataon-common-content-top .dataon-map-search-visual-inner,
.dataon-common-content-top .dataon-subpage-visual-inner,
.dataon-common-content-top .dataon-official-search-visual-inner {
  min-height: 100%;
}

.dataon-common-content-top .dataon-prototype-visual-inner {
  align-items: center;
}

.dataon-common-content-top .dataon-prototype-visual .dataon-prototype-breadcrumb,
.dataon-common-content-top .dataon-prototype-breadcrumb {
  align-self: center;
  margin-top: 14px;
}

.dataon-common-content-top .dataon-content-top-search-toggle {
  top: var(--dataon-content-search-tab-center);
}

.dataon-common-content-top .dataon-content-top-search-toggle i {
  margin-left: 0.9rem;
}

.dataon-common-content-top .dataon-content-top-search-panel {
  top: var(--dataon-content-search-header-offset);
  bottom: 0;
  align-items: center;
  justify-content: center;
  padding: 0 5.5rem 0 2rem;
}

.dataon-common-content-top .dataon-content-top-search-inner {
  position: relative;
  width: min(42rem, 100%);
  align-content: center;
  justify-items: center;
  gap: 1.25rem;
}

.dataon-common-content-top .dataon-content-top-search-modes,
.dataon-common-content-top .dataon-content-top-search-form {
  justify-self: center;
}

.dataon-common-content-top .dataon-content-top-search-help {
  position: absolute;
  top: calc(100% + 0.7rem);
  right: 0.25rem;
  margin: 0;
}

@media (max-width: 760px) {
  .dataon-common-content-top,
  .dataon-official-search-page .dataon-official-search-visual.dataon-common-content-top,
  .dataon-official-result-page .dataon-official-search-visual.dataon-common-content-top {
    --dataon-content-top-height: 246px;
    --dataon-content-search-header-offset: 0px;
    --dataon-content-search-tab-center: 50%;
  }
  .dataon-common-content-title,
  .dataon-subpage-visual h1,
  .dataon-prototype-visual-copy h1,
  .dataon-map-search-title-row h1 {
    font-size: 30px;
  }
  .dataon-common-content-top .dataon-content-top-search-panel {
    padding-right: 3.35rem;
    padding-left: 1rem;
  }
  .dataon-common-content-top .dataon-content-top-search-toggle i {
    margin-left: 0.6rem;
  }
  .dataon-common-content-top .dataon-content-top-search-help {
    top: calc(100% + 0.45rem);
    right: 0;
  }
}`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public searchText = '';
    public appliedSearchText = '';
    public resultWithinSearchText = '';
    public appliedResultWithinSearchText = '';
    public officialCreatedStartDate = '';
    public officialCreatedEndDate = '';
    public officialRegisteredStartDate = '';
    public officialRegisteredEndDate = '';
    public officialSearchFacetExpanded: Record<string, boolean> = {};
    public officialMobileInnerSearchOpen = false;
    public searchHelpOpen = false;
    public contentTopSearchOpen = false;
    public activeContentTopSearchMode: ContentTopSearchModeId = 'integrated';
    public mobileMenuOpen = false;
    public sitemapOpen = false;
    public mobileQuickMenuOpen = false;
    public mobileQuickMenuClosing = false;
    public mobileQuickMenuVisible = false;
    public quickMenuOfficialFixed = false;
    public quickMenuFollowOffset = 0;
    public selectedMenuIndex = 0;
    public activeHomeProviderTab: HomeProviderTabId = 'domestic';
    public activeHomeBoardTab: HomeBoardTabId = 'notice';
    public activeHomeDataTab: HomeDataTabId = 'latest';
    public activeHomeLinkSlideIndex = 0;
    public homeProviderSlideIndex = 0;
    public scienceSlideIndex = 0;
    public activeNavIndex: number | null = null;
    public suppressedNavIndex: number | null = null;
    public isHomePage = false;
    public isLoginPage = false;
    public isJoinPage = false;
    public isAuthPage = false;
    public isDatasetSearchPage = false;
    public isDatasetDetailPage = false;
    public isMapSearchPage = false;
    public isSubmitPage = false;
    public currentLanguage: LanguageCode = 'ko';
    public currentPath = '/';
    public currentPage: LinkItem = { label: '메인', path: '/', description: 'DataON 메인 페이지입니다.' };
    public activeDatasetTab: DatasetTabId = 'overview';
    private readonly runtimeTextTranslations = new WeakMap<Text, RuntimeTranslationMeta>();
    private readonly runtimeAttributeTranslations = new WeakMap<Element, Record<string, RuntimeTranslationMeta>>();
    public selectedDatasetFileId = 'file-001';
    public datasetPreviewZoom = 1;
    public datasetPreviewRotation = 0;
    public datasetActionMessage = '';
    public datasetPrototype: DatasetLooseRecord | null = null;
    public datasetPrototypeRawJson = '';
    public datasetPrototypeLoadError = '';
    public datasetDescriptionExpanded = false;
    public datasetFileSearch = '';
    public datasetFileFilter: DatasetFileFilter = 'all';
    private homeBoardAutoRollTimer: ReturnType<typeof setInterval> | null = null;
    private homeLinkAutoRollTimer: ReturnType<typeof setInterval> | null = null;
    private quickMenuFollowTimer: ReturnType<typeof setTimeout> | null = null;
    private quickMenuCloseTimer: ReturnType<typeof setTimeout> | null = null;
    private hideQuickMenuAfterClose = false;
    private lastQuickMenuScrollY = 0;
    private readonly handleHistoryRouteChange = () => {
        void this.syncCurrentRoute(window.location.pathname + window.location.search);
    };
    public datasetFileViewMode: DatasetFileViewMode = 'list';
    public datasetComparisonEnabled = false;
    public datasetFullscreenEnabled = false;
    public selectedCitationStyle: DatasetCitationStyle = 'BibTeX';
    public selectedRelationNodeId = 'dataset';
    public selectedKnowledgeGraphNodeId = 'kg-dataset-climate';
    public selectedKnowledgeGraphEdgeId = '';
    public knowledgeGraphCenterNodeId = 'kg-dataset-climate';
    public knowledgeGraphFilter: KnowledgeGraphFilterType = 'all';
    public knowledgeGraphZoom = 1;
    public knowledgeGraphFullscreen = false;
    public knowledgeGraphPathIds = ['kg-dataset-climate'];
    public knowledgeGraphActionMessage = '';
    public rawMetadataOpen = false;
    public copiedCitationMessage = '';
    public activeRecommendationTab: DatasetRecommendationTab = '논문';
    public datasetSearchSort: DatasetSearchSort = 'latest';
    public datasetSearchPage = 1;
    public readonly datasetSearchPageSize = 10;
    public semanticSearchMode: SemanticSearchMode = 'keyword';
    public advancedSearchOpen = false;
    public advancedOrganizationFieldsOpen = false;
    public advancedProjectIdentifierFieldsOpen = false;
    public advancedSearchDraftMatchMode: DatasetSearchConditionMode = 'all';
    public appliedAdvancedSearchMatchMode: DatasetSearchConditionMode = 'all';
    public advancedSearchDraft = this.createEmptyAdvancedSearchValues();
    public appliedAdvancedSearch = this.createEmptyAdvancedSearchValues();
    public mobileResultFiltersOpen = false;
    public resultFilterAccordionOpen: Record<string, boolean> = {
        createdYear: true,
        registeredYear: true,
        searchTarget: true,
        subject: true,
        provider: true,
        accessRight: true,
        fileType: true,
    };
    public registeredYearStart = '';
    public registeredYearEnd = '';
    public appliedRegisteredYearStart = '';
    public appliedRegisteredYearEnd = '';
    public mapSearchQuery = '';
    public mapSearchAppliedRegion = '전국';
    public mapSearchDatasets: MapSearchDataset[] = [];
    public mapSearchLoadState: MapSearchLoadState = 'idle';
    public mapSearchError = '';
    public mapSearchProvider = 'all';
    public mapSearchDataType = 'all';
    public mapSearchRegisteredYear = 'all';
    public mapSearchSort: MapSearchSort = 'relevance';
    public mapSearchSelectedId = '';
    public mapSearchBounds: MapSearchBounds | null = null;
    public mapSearchMapReady = false;
    public mapSearchMapMessage = '지도를 준비하고 있습니다.';
    public mapSearchLocationState: MapSearchLocationState = 'idle';
    public mapSearchLocationMessage = '';
    public mapSearchUserLocation: MapSearchUserLocation | null = null;
    public mapSearchFiltersOpen = true;
    public loginForm = {
        userId: '',
        password: '',
        remember: false,
    };
    public loginFieldMessages = {
        userId: '',
        password: '',
    };
    public joinStep: JoinStepId = 'role';
    public joinEmail = {
        address: '',
        code: '',
    };
    public joinEmailCodeSent = false;
    public joinAgreement = {
        terms: false,
        privacy: false,
        rolePolicy: false,
    };
    public joinRole: JoinRoleId = 'general';
    public submitUserRole: JoinRoleId = this.getInitialSubmitUserRole();
    public joinProfile = {
        name: '',
        organization: '',
        department: '',
        purpose: '',
    };
    public joinMessage = '';
    public joinFieldMessages = {
        name: '',
        organization: '',
        email: '',
        code: '',
    };
    public joinFieldMessageTone: Record<JoinFieldKey, FieldMessageTone> = {
        name: '',
        organization: '',
        email: '',
        code: '',
    };
    public activeSubmitStep: SubmitStepId = 'notice';
    public submitAgreement = {
        required: false,
        publicPortal: false,
    };
    public selectedSubmitCollectionId = '';
    public submitFormMessage = '';
    public submitForm = {
        domestic: '국내',
        mainLanguage: '한국어(KO)',
        subLanguage: '영어(EN)',
        identifier: 'DATAON-2026-CLM-0001',
        version: '1.0',
        dataType: '데이터셋',
        subjectCategory: '대기과학',
        titleKo: '기후변화 관측 데이터',
        titleEn: 'Climate change observation dataset',
        descriptionKo: '한반도 주요 관측지점에서 수집한 기온, 강수량, 풍속, 습도 관측 데이터입니다.',
        keywordsKo: '기후변화, 관측, 대기과학, 장기기온변동',
        scienceClass: '자연과학 > 지구과학 > 기후',
        createdAt: '2026-06-23',
        relationType: '연관과제',
        relationId: 'NTIS-2026-CLM-0421',
        projectTitle: '기후변화 적응형 관측체계 고도화 과제',
        projectManager: '한국과학기술정보연구원',
        projectPeriod: '2024-01-01 ~ 2026-12-31',
        personRole: '생산자',
        personName: '김민준',
        personOrganization: '한국과학기술정보연구원',
        personEmail: 'researcher@kisti.re.kr',
        researcherNumber: 'R-2026-000421',
        personOrcid: '0000-0002-2606-1515',
        collectionPeriod: '2024-01-01 ~ 2026-06-23',
        collectionRegion: '대전광역시 유성구',
        collectionMethod: '자동기상관측장비 관측값 수집',
        temporalCoverage: '일 단위 시계열',
        spatialResolution: '관측소 단위',
        instrument: 'AWS, 온습도 센서, 풍향풍속계',
        qualityMethod: '결측값 점검, 이상치 플래그, 중복 레코드 제거',
        fileFormat: 'CSV',
        openType: '메타데이터 공개',
        doiType: '승인 후 DOI 자동 발급',
        accessRights: '기관 승인 후 이용',
        embargoDate: '2026-12-31',
        privacyChecked: true,
        ethicsChecked: true,
        license: '저작자표시-비영리',
        fileAccess: '공개',
        fileName: 'climate_observation_2024_2026.csv',
        fileSize: '24.8 MB',
        fileDescription: '관측소별 일 단위 기후 관측값 원천 데이터',
        sourceUrl: 'https://dataon.kisti.re.kr/repository/sample/climate',
    };
    public activeSubmitManageTab: SubmitManageTabId = 'draft';
    public submitManageSearchText = '';
    public selectedSubmitManageIds: number[] = [];
    public submitManageMessage = '';
    public activeSubmitApprovalTab: SubmitApprovalTabId = 'pending';
    public selectedSubmitApprovalId = 'APR-2026-001';

    public get utilityLinks(): LinkItem[] {
        return [
            { label: '사용자 가이드', path: 'https://dataon.gitbook.io/dataon-user-guide', external: true },
            { label: this.currentLanguage === 'en' ? 'KOR' : 'ENG', path: this.currentLanguage === 'en' ? '/ko' : '/en' },
            { label: '로그인', path: '/login' },
        ];
    }

    public readonly navItems: MenuGroup[] = [
        {
            label: 'DataON',
            path: '/dataon/overview',
            description: '플랫폼 소개와 운영 정보를 확인하는 페이지입니다.',
            sections: [
                {
                    label: '소개',
                    path: '/dataon/overview',
                    children: [
                        { label: 'DataON 개요', path: '/dataon/overview' },
                        { label: 'DataON 관리정책', path: '/dataon/policy' },
                        { label: '연혁', path: '/dataon/history' },
                        { label: '연계기관', path: '/dataon/partners' },
                        { label: 'CI/BI', path: '/dataon/brand' },
                    ],
                },
                {
                    label: '데이터 현황',
                    path: '/dataon/statistics/data',
                    children: [
                        { label: '데이터 현황 통계', path: '/dataon/statistics/data' },
                        { label: '데이터 활용 통계', path: '/dataon/statistics/use' },
                    ],
                },
                {
                    label: '이용안내',
                    path: '/support/user-guide',
                    children: [
                        { label: '사용자가이드', path: 'https://dataon.gitbook.io/dataon-user-guide', external: true },
                        { label: '자료실', path: '/support/resources' },
                        { label: 'FAQ', path: '/support/faq' },
                        { label: '사이트 오류 신고', path: '/support/error-report' },
                    ],
                },
                {
                    label: '알림',
                    path: '/notice',
                    children: [
                        { label: '공지사항', path: '/notice' },
                        { label: '뉴스', path: '/news' },
                        { label: '행사안내', path: '/events' },
                        { label: '우수활용사례', path: '/case-studies' },
                    ],
                },
            ],
            children: [
                { label: 'DataON 개요', path: '/dataon/overview' },
                { label: 'DataON 관리정책', path: '/dataon/policy' },
                { label: '연혁', path: '/dataon/history' },
                { label: '연계기관', path: '/dataon/partners' },
                { label: 'CI/BI', path: '/dataon/brand' },
                { label: '데이터 현황 통계', path: '/dataon/statistics/data' },
                { label: '데이터 활용 통계', path: '/dataon/statistics/use' },
                { label: '사용자가이드', path: 'https://dataon.gitbook.io/dataon-user-guide', external: true },
                { label: '자료실', path: '/support/resources' },
                { label: 'FAQ', path: '/support/faq' },
                { label: '사이트 오류 신고', path: '/support/error-report' },
                { label: '공지사항', path: '/notice' },
                { label: '뉴스', path: '/news' },
                { label: '행사안내', path: '/events' },
                { label: '우수활용사례', path: '/case-studies' },
            ],
        },
        {
            label: '검색',
            path: '/search/integrated',
            description: '연구데이터와 소프트웨어를 통합 검색하는 페이지입니다.',
            sections: [
                {
                    label: '콘텐츠별 검색',
                    path: '/search/datasets',
                    children: [
                        { label: '데이터셋 검색', path: '/search/datasets' },
                        { label: '소프트웨어 검색', path: '/search/software' },
                    ],
                },
                {
                    label: '검색',
                    path: '/search/integrated',
                    children: [
                        { label: '통합 검색', path: '/search/integrated' },
                        { label: '상세 검색', path: '/search/detail' },
                        { label: '제공처 검색', path: '/search/providers' },
                        { label: '맵 검색', path: '/search/map' },
                        { label: '의미검색', path: '/search/semantic' },
                    ],
                },
                {
                    label: '이슈&데이터',
                    path: '/search/issues',
                    children: [
                        { label: '코로나 바이러스', path: '/search/issues/covid-19' },
                        { label: 'GPCC', path: '/search/issues/gpcc' },
                        { label: 'KAGGLE', path: '/search/issues/kaggle' },
                    ],
                },
            ],
            children: [
                { label: '데이터셋 검색', path: '/search/datasets' },
                { label: '소프트웨어 검색', path: '/search/software' },
                { label: '통합 검색', path: '/search/integrated' },
                { label: '상세 검색', path: '/search/detail' },
                { label: '제공처 검색', path: '/search/providers' },
                { label: '맵 검색', path: '/search/map' },
                { label: '의미검색', path: '/search/semantic' },
                { label: '코로나 바이러스', path: '/search/issues/covid-19' },
                { label: 'GPCC', path: '/search/issues/gpcc' },
                { label: 'KAGGLE', path: '/search/issues/kaggle' },
            ],
        },
        {
            label: '등록',
            path: '/submit',
            description: '연구데이터 제출과 관리 업무를 수행하는 페이지입니다.',
            sections: [
                {
                    label: '등록',
                    path: '/submit',
                    children: [
                        { label: '제출', path: '/submit' },
                        { label: '데이터 관리', path: '/submit/manage' },
                        { label: '제출 데이터 통계', path: '/submit/statistics' },
                        { label: '데이터 승인', path: '/submit/approval' },
                    ],
                },
            ],
            children: [
                { label: '제출', path: '/submit' },
                { label: '데이터 관리', path: '/submit/manage' },
                { label: '제출 데이터 통계', path: '/submit/statistics' },
                { label: '데이터 승인', path: '/submit/approval' },
            ],
        },
        {
            label: '분석',
            path: '/analysis/canvas',
            description: 'CANVAS 분석 환경과 워크플로우를 이용하는 페이지입니다.',
            sections: [
                {
                    label: '분석(CANVAS)',
                    path: '/analysis/canvas',
                    children: [
                        { label: '내 분석 바로가기', path: '/analysis/my' },
                        { label: 'Workflow', path: '/analysis/workflow' },
                        { label: 'JupyterLab 이용', path: '/analysis/jupyterlab' },
                        { label: 'Software 검색', path: '/analysis/software' },
                        { label: 'CANVAS 가이드', path: '/analysis/guide' },
                    ],
                },
            ],
            children: [
                { label: '내 분석 바로가기', path: '/analysis/my' },
                { label: 'Workflow', path: '/analysis/workflow' },
                { label: 'JupyterLab 이용', path: '/analysis/jupyterlab' },
                { label: 'Software 검색', path: '/analysis/software' },
                { label: 'CANVAS 가이드', path: '/analysis/guide' },
            ],
        },
        {
            label: '서비스',
            path: '/service/repository',
            description: '리포지터리, API, 커뮤니티 등 부가 서비스를 확인하는 페이지입니다.',
            sections: [
                {
                    label: '분야별 리포지터리',
                    path: '/service/aida',
                    children: [
                        { label: 'AI Data (AIDA)', path: '/service/aida' },
                    ],
                },
                {
                    label: '리포지터리 호스팅',
                    path: '/service/repository-hosting',
                    children: [
                        { label: '소개', path: '/service/repository-hosting' },
                        { label: '내 리포지터리 관리', path: '/service/repository/manage' },
                        { label: '신청', path: '/service/repository/apply' },
                        { label: '신청목록', path: '/service/repository/applications' },
                        { label: '공개 리포지터리 현황', path: '/service/repository/public' },
                    ],
                },
                {
                    label: 'API 활용',
                    path: '/service/api/open-api',
                    children: [
                        { label: 'Open API', path: '/service/api/open-api' },
                        { label: 'OAI-PMH', path: '/service/api/oai-pmh' },
                        { label: '신청', path: '/service/api/apply' },
                        { label: 'MCP소개', path: '/service/api/mcp' },
                    ],
                },
                {
                    label: '커뮤니티',
                    path: '/community',
                    children: [
                        { label: '나의 커뮤니티', path: '/community/my' },
                        { label: '전체 커뮤니티', path: '/community' },
                    ],
                },
            ],
            children: [
                { label: 'AI Data (AIDA)', path: '/service/aida' },
                { label: '소개', path: '/service/repository-hosting' },
                { label: '내 리포지터리 관리', path: '/service/repository/manage' },
                { label: '신청', path: '/service/repository/apply' },
                { label: '신청목록', path: '/service/repository/applications' },
                { label: '공개 리포지터리 현황', path: '/service/repository/public' },
                { label: 'Open API', path: '/service/api/open-api' },
                { label: 'OAI-PMH', path: '/service/api/oai-pmh' },
                { label: '신청', path: '/service/api/apply' },
                { label: 'MCP소개', path: '/service/api/mcp' },
                { label: '나의 커뮤니티', path: '/community/my' },
                { label: '커뮤니티', path: '/community' },
            ],
        },
        {
            label: '경진대회',
            path: '/competition/about',
            description: 'DataON 경진대회 안내와 진행 현황을 확인하는 페이지입니다.',
            sections: [
                {
                    label: '대회소개',
                    path: '/competition/about',
                    children: [
                        { label: '대회소개', path: '/competition/about' },
                        { label: '지난대회보기', path: '/competition/archive' },
                    ],
                },
                {
                    label: '대회진행',
                    path: '/competition/apply',
                    children: [
                        { label: '참가신청', path: '/competition/apply' },
                        { label: '서류접수 상태', path: '/competition/status' },
                        { label: '워크샵 갤러리', path: '/competition/workshop-gallery' },
                        { label: '최종발표평가', path: '/competition/final-evaluation' },
                        { label: '1차 서류평가', path: '/competition/first-review' },
                        { label: '시상식 갤러리', path: '/competition/award-gallery' },
                    ],
                },
                {
                    label: '대회소통방',
                    path: '/competition/notice',
                    children: [
                        { label: '공지사항', path: '/competition/notice' },
                        { label: '자주하는 질문', path: '/competition/faq' },
                        { label: 'QnA', path: '/competition/qna' },
                        { label: '자료실', path: '/competition/resources' },
                    ],
                },
            ],
            children: [
                { label: '대회소개', path: '/competition/about' },
                { label: '지난대회보기', path: '/competition/archive' },
                { label: '참가신청', path: '/competition/apply' },
                { label: '서류접수 상태', path: '/competition/status' },
                { label: '워크샵 갤러리', path: '/competition/workshop-gallery' },
                { label: '최종발표평가', path: '/competition/final-evaluation' },
                { label: '1차 서류평가', path: '/competition/first-review' },
                { label: '시상식 갤러리', path: '/competition/award-gallery' },
                { label: '공지사항', path: '/competition/notice' },
                { label: '자주하는 질문', path: '/competition/faq' },
                { label: 'QnA', path: '/competition/qna' },
                { label: '자료실', path: '/competition/resources' },
            ],
        },
    ];

    public readonly serviceMenuGroups: ServiceMenuGroup[] = [
        {
            title: '분야별 리포지터리',
            path: '/service/aida',
            links: [
                { label: 'AI Data (AIDA)', path: '/service/aida', officialPath: '/aida', accessLabel: '외부 연계' },
            ],
        },
        {
            title: '리포지터리 호스팅',
            path: '/service/repository-hosting',
            links: [
                { label: '소개', path: '/service/repository-hosting', officialPath: '/hosting/hostingIntro_R.do', accessLabel: '공개' },
                { label: '내 리포지터리 관리', path: '/service/repository/manage', officialPath: '#', accessLabel: '권한 제한' },
                { label: '신청', path: '/service/repository/apply', officialPath: '/hosting/hostingWrite_R.do', accessLabel: '로그인 확인' },
                { label: '신청목록', path: '/service/repository/applications', officialPath: '/hosting/hostingList_R.do', accessLabel: '로그인 확인' },
                { label: '공개 리포지터리 현황', path: '/service/repository/public', officialPath: '#', accessLabel: '권한 제한' },
            ],
        },
        {
            title: 'API 활용',
            path: '/service/api/open-api',
            links: [
                { label: 'Open API', path: '/service/api/open-api', officialPath: '/openApi/openApiList_R.do?apiKindCd=10', accessLabel: '로그인 확인' },
                { label: 'OAI-PMH', path: '/service/api/oai-pmh', officialPath: '/registry/oaipmh', accessLabel: '권한/키 필요' },
                { label: '신청', path: '/service/api/apply', officialPath: '/openApi/openApiReq_C.do?apiSn=65&apiNmKor=연구데이터 검색 API', accessLabel: '로그인 확인' },
                { label: 'MCP소개', path: '/service/api/mcp', officialPath: '/mcpIntr/index.do', accessLabel: '공개' },
            ],
        },
        {
            title: '커뮤니티',
            path: '/community',
            links: [
                { label: '나의 커뮤니티', path: '/community/my', officialPath: '/cmmnty/selectMyCmmntyList.do', accessLabel: '로그인 확인' },
                { label: '전체 커뮤니티', path: '/community', officialPath: '/cmmnty/selectCmmntyList.do', accessLabel: '로그인 확인' },
            ],
        },
    ];

    public readonly servicePages: ServicePage[] = [
        {
            id: 'service-overview',
            label: '서비스',
            path: '/service/repository',
            category: '서비스',
            officialPath: '/',
            accessLabel: '메뉴',
            accessTone: 'public',
            description: 'DataON 서비스 메뉴의 분야별 리포지터리, 리포지터리 호스팅, API 활용, 커뮤니티 하위 페이지를 확인합니다.',
            paths: ['/service', '/service/repository'],
        },
        {
            id: 'aida',
            label: 'AI Data (AIDA)',
            path: '/service/aida',
            category: '분야별 리포지터리',
            officialPath: '/aida',
            accessLabel: '외부 연계',
            accessTone: 'external',
            description: 'DataON에서 AIDA로 이동하는 외부 연계 페이지입니다.',
            paths: ['/service/aida', '/aida'],
            originalStatus: '공식 페이지는 로그인 세션 정보를 담은 AIDA 로그인 API POST 폼을 자동 제출합니다.',
        },
        {
            id: 'narda',
            label: 'DataON Repository(NARDA)',
            path: '/service/narda',
            category: '분야별 리포지터리',
            officialPath: '/idr/manual/ko/docs/',
            accessLabel: '공개 문서',
            accessTone: 'public',
            description: 'NaRDA 기관 연구데이터 리포지터리 매뉴얼로 연결되는 공개 문서입니다.',
            paths: ['/service/narda', '/idr/manual/ko/docs'],
        },
        {
            id: 'hosting-intro',
            label: '소개',
            path: '/service/repository-hosting',
            category: '리포지터리 호스팅',
            officialPath: '/hosting/hostingIntro_R.do',
            accessLabel: '공개',
            accessTone: 'public',
            description: '기관 연구데이터 리포지터리 호스팅 소개 페이지입니다.',
            paths: ['/service/repository-hosting', '/hosting/hostingIntro_R.do'],
        },
        {
            id: 'hosting-manage',
            label: '내 리포지터리 관리',
            path: '/service/repository/manage',
            category: '리포지터리 호스팅',
            officialPath: '#',
            accessLabel: '권한 제한',
            accessTone: 'blocked',
            description: '신청 승인 상태와 기관 저장소를 관리하는 로그인 후 메뉴입니다.',
            originalStatus: "공식 메뉴 클릭 시 '권한이 있는 사용자만 사용할 수 있는 메뉴입니다. 관리자에게 문의하세요.' 알림이 표시됩니다.",
        },
        {
            id: 'hosting-apply',
            label: '신청',
            path: '/service/repository/apply',
            category: '리포지터리 호스팅',
            officialPath: '/hosting/hostingWrite_R.do',
            accessLabel: '로그인 확인',
            accessTone: 'login',
            description: '기관 연구데이터 리포지터리 호스팅을 신청하는 로그인 후 메뉴입니다.',
            paths: ['/service/repository/apply', '/hosting/hostingWrite_R.do'],
            originalStatus: '제공된 계정으로 로그인 후 공식 신청 폼을 확인했습니다.',
        },
        {
            id: 'hosting-applications',
            label: '신청목록',
            path: '/service/repository/applications',
            category: '리포지터리 호스팅',
            officialPath: '/hosting/hostingList_R.do',
            accessLabel: '로그인 확인',
            accessTone: 'login',
            description: '리포지터리 호스팅 신청 내역을 확인하는 로그인 후 메뉴입니다.',
            paths: ['/service/repository/applications', '/hosting/hostingList_R.do'],
            originalStatus: '제공된 계정 기준 신청목록 총 건수는 0건입니다.',
        },
        {
            id: 'hosting-public',
            label: '공개 리포지터리 현황',
            path: '/service/repository/public',
            category: '리포지터리 호스팅',
            officialPath: '#',
            accessLabel: '권한 제한',
            accessTone: 'blocked',
            description: '공개 리포지터리 현황을 확인하는 로그인 후 메뉴입니다.',
            originalStatus: "공식 메뉴 클릭 시 '권한이 있는 사용자만 사용할 수 있는 메뉴입니다. 관리자에게 문의하세요.' 알림이 표시됩니다.",
        },
        {
            id: 'open-api',
            label: 'Open API',
            path: '/service/api/open-api',
            category: 'API 활용',
            officialPath: '/openApi/openApiList_R.do?apiKindCd=10',
            accessLabel: '로그인 확인',
            accessTone: 'login',
            description: 'API 이용신청과 인증키 발급, 연구데이터 검색/상세 API를 이용하는 로그인 후 메뉴입니다.',
            paths: ['/service/api/open-api', '/openApi/openApiList_R.do'],
            originalStatus: '제공된 계정으로 로그인 후 오픈 API 목록 2건을 확인했습니다.',
        },
        {
            id: 'api-apply',
            label: '신청',
            path: '/service/api/apply',
            category: 'API 활용',
            officialPath: '/openApi/openApiReq_C.do?apiSn=65&apiNmKor=연구데이터 검색 API',
            accessLabel: '로그인 확인',
            accessTone: 'login',
            description: 'Open API 이용 신청을 진행하는 로그인 후 메뉴입니다.',
            paths: ['/service/api/apply', '/openApi/openApiReq_C.do'],
            originalStatus: '오픈 API 목록의 활용신청 버튼으로 이동하는 공식 공유서비스 신청 폼입니다.',
        },
        {
            id: 'oai-pmh',
            label: 'OAI-PMH',
            path: '/service/api/oai-pmh',
            category: 'API 활용',
            officialPath: '/registry/oaipmh',
            accessLabel: '권한/키 필요',
            accessTone: 'key',
            description: '인증키 기반 OAI-PMH 수집 프로토콜 엔드포인트입니다.',
            paths: ['/service/api/oai-pmh', '/registry/oaipmh'],
            originalStatus: "공식 메뉴는 권한 알림이 표시되고, 엔드포인트 직접 접근 시 'key' 입력값 누락 XML 오류가 반환됩니다.",
        },
        {
            id: 'mcp',
            label: 'MCP소개',
            path: '/service/api/mcp',
            category: 'API 활용',
            officialPath: '/mcpIntr/index.do',
            accessLabel: '공개',
            accessTone: 'public',
            description: 'DataON MCP 서버 개념과 연결 방식을 안내하는 공개 페이지입니다.',
            paths: ['/service/api/mcp', '/mcpIntr/index.do'],
        },
        {
            id: 'community-my',
            label: '나의 커뮤니티',
            path: '/community/my',
            category: '커뮤니티',
            officialPath: '/cmmnty/selectMyCmmntyList.do',
            accessLabel: '로그인 확인',
            accessTone: 'login',
            description: '가입한 커뮤니티를 확인하는 로그인 후 메뉴입니다.',
            paths: ['/community/my', '/cmmnty/selectMyCmmntyList.do'],
            originalStatus: '제공된 계정 기준 내가 가입한 커뮤니티에는 해당 데이터가 없습니다.',
        },
        {
            id: 'community-list',
            label: '전체 커뮤니티',
            path: '/community',
            category: '커뮤니티',
            officialPath: '/cmmnty/selectCmmntyList.do',
            accessLabel: '로그인 확인',
            accessTone: 'login',
            description: '전체 커뮤니티를 검색하고 가입/생성하는 로그인 후 메뉴입니다.',
            paths: ['/community', '/cmmnty/selectCmmntyList.do'],
            originalStatus: '제공된 계정으로 로그인 후 전체 커뮤니티 목록 첫 페이지를 확인했습니다.',
        },
    ];

    public readonly servicePermissionAlertMessage = '권한이 있는 사용자만 사용할 수 있는 메뉴입니다. 관리자에게 문의하세요.';

    public readonly hostingApplicationHeaders = ['번호', '리포지터리명', '신청자', '소속기관', '등록일', '제공용량', '처리유형', '상태'];

    public readonly openApiItems = [
        {
            no: 2,
            title: '연구데이터 메타정보 상세 조회 API',
            createdAt: '2020-12-02 12:14',
            description: '연구데이터 메타정보를 상세 조회할 수 있습니다.',
            kind: 'APIS',
            type: 'REST',
            manager: '데이터온 관리자',
            detailPath: '/openApi/openApiView_R.do?apiSn=79&apiKindCd=10',
        },
        {
            no: 1,
            title: '연구데이터 검색 API',
            createdAt: '2020-08-07 10:35',
            description: 'DataON에서 서비스 되고 있는 연구데이터 메타정보를 검색할 수 있는 서비스입니다.',
            kind: 'APIS',
            type: 'REST',
            manager: '데이터온 관리자',
            detailPath: '/openApi/openApiView_R.do?apiSn=65&apiKindCd=10',
        },
    ];

    public readonly apiApplicationPurposeOptions = ['활용용도를 선택하세요.', '웹(앱)개발', '아이디어기획', '연구(논문 등)', '기타'];
    public readonly apiOrganizationOptions = ['기관 유형을 선택해 주세요.', '연구기관', '대학', '학술단체', '정부/지방/공공단체', '기업', '기타'];
    public readonly emailDomainOptions = ['직접입력', 'gmail.com', 'naver.com', 'daum.net', 'nate.com', 'yahoo.co.kr', 'hotmail.com'];

    public readonly communityCards = [
        {
            title: 'KISTI - 컴퓨터 연구 정보',
            description: '본 커뮤니티는 한국과학기술정보연구원의 컴퓨터 연구 정보를 가입회원과 공유하여, 구성원들...',
            fields: '정보/통신, 전기/전자, 기계',
            manager: 'hongws',
            createdAt: '2019-12-05',
            members: 232,
        },
        {
            title: 'KISTI 신뢰성 분석 플랫폼',
            description: 'KISTI 중소기업 제품제조 품질향상을 위한 신뢰성 분석 플랫폼 체계구축 연구',
            fields: '정보/통신',
            manager: 'dmseo',
            createdAt: '2021-10-11',
            members: 68,
        },
        {
            title: 'K-비건가죽',
            description: '가죽제품을 생산하는 과정에서 발생하는 유해물질과 폐기물을 완전하게 저감할 수 있도록 친...',
            fields: '환경, 재료, 농림수산식품',
            manager: 'kimbj1108',
            createdAt: '2021-06-11',
            members: 51,
        },
        {
            title: '위성데이터 분석 커뮤니티',
            description: '위성데이터 분석을 전문적으로 연구하는 커뮤니티',
            fields: '지구과학(지구/대기/해양/천문), 정보/통신, 정치/행정',
            manager: 'kistimini',
            createdAt: '2019-11-29',
            members: 120,
        },
        {
            title: '블록체인 연구 커뮤니티',
            description: '본 커뮤니티는 블록체인에 관련한 연구와 활성화에 의견을 교류하는 커뮤니티입니다.',
            fields: '정보/통신, 미디어/커뮤니케이션/문헌정보',
            manager: 'yab100',
            createdAt: '2021-11-26',
            members: 4,
        },
        {
            title: '연구데이터관리계획(DMP) 질의응답 게시판',
            description: '해당 게시판은 연구데이터관리계획에 대한 문의사항과 질의응답을 게시할 목적으로 만들어진 ...',
            fields: '정보/통신',
            manager: 'sunujh6',
            createdAt: '2021-10-14',
            members: 282,
        },
    ];

    public readonly hostingCoreFeatures = [
        '연구 데이터 제출, 승인, 출판, 검색, 관리 기능',
        'ORCID, KISTI KAFE, 기관 SSO등의 통합 인증 기능',
        '연구 데이터 공유/활용을 위한 외부 검색 시스템/리포지터리/분석 시스템과 연계 기능',
    ];

    public readonly hostingCharacteristics = [
        '신청 기관이 직접 운영하는 저장소입니다.',
        '저장소는 RDP를 구성하는 시스템에서 제공되며, 연구데이터를 안전하게 저장 관리합니다.',
        '신청 기관의 연구데이터를 업로드, 다운로드하는 방법은 저장소에서 제공하는 인터페이스를 통하여 이루어집니다.',
        '저장소는 24시간 운영됩니다.',
    ];

    public readonly oaiPmhMethods = [
        { name: 'Identify', description: '저장소 식별 정보와 운영 정보를 조회합니다.' },
        { name: 'ListSets', description: '수집 가능한 세트 목록을 조회합니다.' },
        { name: 'ListMetadataFormats', description: '지원 메타데이터 포맷을 확인합니다.' },
        { name: 'ListIdentifiers', description: '조건에 맞는 레코드 식별자를 조회합니다.' },
        { name: 'ListRecords', description: '조건에 맞는 레코드 목록을 수집합니다.' },
        { name: 'GetRecord', description: '개별 식별자의 메타데이터를 조회합니다.' },
    ];

    public readonly oaiPmhMissingKeyXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<OAI-PMH xmlns="http://www.openarchives.org/OAI/2.0/">
  <responseDate></responseDate>
  <error code="400" elapsedTime="6 ms">'key' 입력값이 누락되었습니다. ('key' is bad request)</error>
</OAI-PMH>`;

    public readonly mcpRemoteConfigExample = `{
    "mcpServers": {
        "dataon": {
            "command": "npx",
            "args": [
                "mcp-remote",
                "https://dataon.kisti.re.kr/mcp/mcp",
                "--header",
                "Authorization: Bearer \${DATAON_OPENAPI_KEY}"
            ]
        }
    }
}`;

    public readonly mcpRemoteCommandExample = 'npx mcp-remote https://dataon.kisti.re.kr/mcp/mcp --header "Authorization: Bearer ${DATAON_OPENAPI_KEY}"';

    public readonly mcpStreamableConfigExample = `{
    "mcpServers": {
        "dataon": {
            "type": "streamable-http",
            "url": "https://dataon.kisti.re.kr/mcp/mcp",
            "headers": {
                "Authorization": "Bearer \${DATAON_OPENAPI_KEY}"
            }
        }
    }
}`;

    public readonly nardaManualLinks: LinkItem[] = [
        { label: '시스템 개요', path: 'https://dataon.kisti.re.kr/idr/manual/ko/docs/system/', external: true },
        { label: '설치', path: 'https://dataon.kisti.re.kr/idr/manual/ko/docs/install/', external: true },
        { label: '관리자 매뉴얼', path: 'https://dataon.kisti.re.kr/idr/manual/ko/docs/manual-admin/', external: true },
        { label: '사용자 매뉴얼', path: 'https://dataon.kisti.re.kr/idr/manual/ko/docs/manual-user/', external: true },
        { label: 'OpenAPI 매뉴얼', path: 'https://dataon.kisti.re.kr/idr/manual/ko/docs/manual-openapi/', external: true },
    ];

    public readonly searchChips = ['아마존', '산림벌채', '위성영상', 'Sentinel-2', 'KOMPSAT', '인공지능'];

    public readonly contentTopSearchModes: ContentTopSearchMode[] = [
        { id: 'integrated', label: '통합 검색', path: '/search/integrated', icon: 'fa-magnifying-glass', placeholder: '검색어를 입력해 주세요.' },
        { id: 'detail', label: '상세 검색', path: '/search/detail', icon: 'fa-sliders', placeholder: '상세 검색어를 입력해 주세요.' },
        { id: 'map', label: 'MAP 검색', path: '/search/map', icon: 'fa-location-dot', placeholder: '지역명 또는 위치 키워드를 입력해 주세요.' },
        { id: 'semantic', label: '의미 검색', path: '/search/semantic', icon: 'fa-wand-magic-sparkles', placeholder: '찾고 싶은 데이터의 내용을 문장으로 입력해 주세요.' },
    ];

    public readonly searchActions: LinkItem[] = [
        { label: '상세 검색', path: '/search/detail', description: '조건 설정', icon: '/assets/dataon/2024/icon_dtl_srch.svg' },
        { label: 'MAP 검색', path: '/search/map', description: '위치 기반 탐색', icon: '/assets/dataon/2024/icon_map_srch.svg' },
    ];

    public get secondarySearchActions() {
        return this.searchActions.filter((action) => action.path !== '/search/detail');
    }

    public get activeContentTopSearchModeData() {
        return this.contentTopSearchModes.find((mode) => mode.id === this.activeContentTopSearchMode) || this.contentTopSearchModes[0];
    }

    public get contentTopSearchPlaceholder() {
        return this.activeContentTopSearchModeData.placeholder;
    }

    private getContentTopSearchModeForCurrentPage(): ContentTopSearchModeId {
        if (this.isMapSearchPage) return 'map';

        const pageId = this.currentSearchMenuPage.id;
        if (pageId === 'detail') return 'detail';
        if (pageId === 'semantic') return 'semantic';

        return 'integrated';
    }

    public readonly heroQuickLinks: LinkItem[] = [];

    public readonly quickMenuLinks: LinkItem[] = [
        { label: '사용자가이드', path: 'https://dataon.gitbook.io/dataon-user-guide', external: true, icon: '/assets/dataon/2024/icon_quick01.svg' },
        { label: '마이드라이브', path: '/my-drive', icon: '/assets/dataon/2024/icon_quick02.svg' },
        { label: '분석(CANVAS)', path: '/analysis/canvas', icon: '/assets/dataon/2024/icon_quick03.svg' },
        { label: '커뮤니티', path: '/community', icon: '/assets/dataon/2024/icon_quick04.svg' },
        { label: 'FAQ', path: '/support/faq', icon: '/assets/dataon/2024/icon_quick05.svg' },
    ];

    public readonly homeStatCards: HomeStatCard[] = [
        { label: '데이터셋', value: '7,516,228', icon: '/assets/dataon/2024/icon_data_set.svg', path: '/search/datasets' },
        { label: '파일개수 / 용량', value: '9,968', unit: '/ 3.62 TB', icon: '/assets/dataon/2024/icon_file_cnt.svg', path: '/dataon/statistics/data' },
    ];

    public readonly providerTabs: HomeProviderTab[] = [
        {
            id: 'domestic',
            label: '국내',
            totalLabel: '데이터셋',
            totalValue: '3,062,076',
            fileCount: '9,968',
            capacity: '3.62TB',
            items: [
                { name: '한국천문연구원', datasets: '3,019,486', field: '천문학', path: '/search/providers/kasi' },
                { name: '극지연구소', datasets: '31,848', field: '극지관측', path: '/search/providers/kopri' },
                { name: '한국지질자원연구원', datasets: '3,419', field: '지구과학', path: '/search/providers/kigam' },
                { name: '한국표준연구원 국가참조표준센터', datasets: '2,108', field: '참조표준', path: '/search/providers/kriss' },
                { name: '한국항공우주연구원', datasets: '1,579', field: '항공우주과학', files: '92 / 102.43 GB', path: '/search/providers/kari' },
                { name: '국립산림과학원', datasets: '1,389', field: '산림과학', path: '/search/providers/nifos' },
                { name: '국립생태원 Ecobank', datasets: '916', field: '전분야', path: '/search/providers/ecobank' },
                { name: '한국과학기술정보연구원', datasets: '379', field: '과학기술 전분야', files: '501 / 901.92 GB', path: '/search/providers/kisti' },
                { name: '한국이산화탄소포집및처리연구개발센터', datasets: '170', field: '대기/환경', files: '464 / 1.82 GB', path: '/search/providers/kcrc' },
                { name: '제주대학교 기초과학연구소', datasets: '140', field: '전분야', path: '/search/providers/jeju-basic-science' },
                { name: '국가연구데이터플랫폼', datasets: '110', field: '과학기술 전분야', files: '446 / 551.35 GB', path: '/search/providers/dataon' },
                { name: '한국기계연구원', datasets: '93', field: '과학기술 전분야', files: '252 / 13.89 GB', path: '/search/providers/kimm' },
                { name: 'KISTI 기계학습 데이터 공유 활용 서비스', datasets: '83', field: '기계학습', path: '/search/providers/ml' },
                { name: '한국한의학연구원', datasets: '62', field: '보건의료', path: '/search/providers/kiom' },
                { name: '한국해양과학기술원', datasets: '55', field: '해양과학', files: '182 / 50.73 GB', path: '/search/providers/kiost' },
                { name: '대구교육데이터연구소', datasets: '54', field: '전분야', path: '/search/providers/daegu-edu-data' },
                { name: '한국원자력연구원', datasets: '32', field: '과학기술 전분야', files: '7543 / 137.16 GB', path: '/search/providers/kaeri' },
                { name: '한국전자통신연구원', datasets: '23', field: '전분야', path: '/search/providers/etri' },
                { name: 'AI 허브', datasets: '21', field: '인공지능', path: '/search/providers/aihub' },
                { name: '국가독성과학연구소', datasets: '19', field: '독성', files: '184 / 7.76 GB', path: '/search/providers/nit' },
                { name: '한국기초과학지원연구원', datasets: '17', field: '과학기술 전분야', files: '35 / 31.78 GB', path: '/search/providers/kbsi' },
                { name: '한국환경연구원 데이터 포탈', datasets: '17', field: '전분야', path: '/search/providers/kei' },
                { name: '한국과학기술원', datasets: '11', field: '전분야', files: '154 / 1.62 TB', path: '/search/providers/kaist' },
                { name: 'GeoAI 데이터학회', datasets: '9', field: '전분야', files: '33 / 27.89 GB', path: '/search/providers/geoai' },
                { name: '한국원자력의학원', datasets: '6', field: '과학기술 전분야', files: '9 / 202.33 MB', path: '/search/providers/kirams' },
                { name: '한국핵융합에너지연구원', datasets: '5', field: '과학기술 전분야', files: '5 / 33 GB', path: '/search/providers/kfe' },
                { name: '국가보안기술연구소', datasets: '4', field: '전분야', files: '40 / 3.43 GB', path: '/search/providers/nsr' },
                { name: '한국건설기술연구원', datasets: '4', field: '과학기술 전분야', files: '12 / 13.39 MB', path: '/search/providers/kict' },
                { name: '국가녹색기술연구소', datasets: '4', field: '보건/기후', files: '7 / 1.35 MB', path: '/search/providers/nigt' },
                { name: '글로벌 대용량실험 데이터 허브센터', datasets: '4', field: '생명과학', path: '/search/providers/global-bigdata-hub' },
                { name: '울산과학기술원', datasets: '2', field: '전분야', files: '2 / 184.84 GB', path: '/search/providers/unist' },
                { name: '특허청', datasets: '1', field: '전분야', path: '/search/providers/kipo' },
                { name: '대구경북과학기술원', datasets: '1', field: '전분야', files: '3 / 586.88 MB', path: '/search/providers/dgist' },
                { name: '한국생산기술연구원', datasets: '1', field: '전분야', path: '/search/providers/kitech' },
                { name: '광주과학기술원', datasets: '1', field: '전분야', files: '1 / 162.08 MB', path: '/search/providers/gist' },
                { name: '한국화학연구원', datasets: '1', field: '과학기술 전분야', files: '2 / 1.32 GB', path: '/search/providers/krict' },
                { name: '한국식품연구원', datasets: '1', field: '사회과학', path: '/search/providers/kfri' },
                { name: '한국과학기술연구원', datasets: '1', field: '전분야', files: '1 / 114.79 KB', path: '/search/providers/kist' },
            ],
        },
        {
            id: 'global',
            label: '해외',
            totalLabel: '데이터셋',
            totalValue: '4,454,152',
            items: [
                { name: 'OpenAIRE', datasets: '3,839,287', field: '과학기술 전분야', path: '/search/providers/openaire' },
                { name: 'ARDC', datasets: '215,439', field: '과학기술 전분야', path: '/search/providers/ardc' },
                { name: 'Institutional Repositories DataBase', datasets: '129,940', field: '과학기술 전분야', path: '/search/providers/irdb' },
                { name: 'FRDR', datasets: '104,490', field: '전분야', path: '/search/providers/frdr' },
                { name: 'HARVARD Dataverse', datasets: '102,411', field: '사회과학', path: '/search/providers/harvard-dataverse' },
                { name: 'data govt nz', datasets: '39,289', field: '전분야', path: '/search/providers/data-govt-nz' },
                { name: '4TU', datasets: '20,644', field: '전분야', path: '/search/providers/4tu' },
                { name: 'FINNISH SOCIAL SCIENCE DATA ARCHIVE', datasets: '2,200', field: '사회과학', path: '/search/providers/fsd' },
                { name: 'DataON', datasets: '452', field: '전분야', path: '/search/providers/dataon-global' },
            ],
        },
    ];

    public readonly scienceFields: HomeScienceField[] = [
        { label: '건설/교통', icon: '/assets/dataon/2024/icon_tech01.svg', path: '/search/datasets?subject=건설/교통' },
        { label: '기계', icon: '/assets/dataon/2024/icon_tech02.svg', path: '/search/datasets?subject=기계' },
        { label: '농림수산식품', icon: '/assets/dataon/2024/icon_tech03.svg', path: '/search/datasets?subject=농림수산식품' },
        { label: '물리학', icon: '/assets/dataon/2024/icon_tech04.svg', path: '/search/datasets?subject=물리학' },
        { label: '보건의료', icon: '/assets/dataon/2024/icon_tech05.svg', path: '/search/datasets?subject=보건의료' },
        { label: '생명과학', icon: '/assets/dataon/2024/icon_tech06.svg', path: '/search/datasets?subject=생명과학' },
        { label: '수학', icon: '/assets/dataon/2024/icon_tech07.svg', path: '/search/datasets?subject=수학' },
        { label: '에너지/자원', icon: '/assets/dataon/2024/icon_tech08.svg', path: '/search/datasets?subject=에너지/자원' },
        { label: '원자력', icon: '/assets/dataon/2024/icon_tech09.svg', path: '/search/datasets?subject=원자력' },
        { label: '인문사회', icon: '/assets/dataon/2024/icon_tech10.svg', path: '/search/datasets?subject=인문사회' },
        { label: '재료', icon: '/assets/dataon/2024/icon_tech11.svg', path: '/search/datasets?subject=재료' },
        { label: '전기/전자', icon: '/assets/dataon/2024/icon_tech12.svg', path: '/search/datasets?subject=전기/전자' },
        { label: '정보/통신', icon: '/assets/dataon/2024/icon_tech13.svg', path: '/search/datasets?subject=정보/통신' },
        { label: '지구과학', icon: '/assets/dataon/2024/icon_tech14.svg', path: '/search/datasets?subject=지구과학' },
        { label: '화공', icon: '/assets/dataon/2024/icon_tech15.svg', path: '/search/datasets?subject=화공' },
        { label: '화학', icon: '/assets/dataon/2024/icon_tech16.svg', path: '/search/datasets?subject=화학' },
        { label: '환경', icon: '/assets/dataon/2024/icon_tech17.svg', path: '/search/datasets?subject=환경' },
        { label: '기타', icon: '/assets/dataon/2024/icon_tech18.svg', path: '/search/datasets?subject=기타' },
    ];

    public readonly boardTabs: HomeBoardTab[] = [
        {
            id: 'notice',
            label: '공지사항',
            path: '/notice',
            items: [
                {
                    category: '공지사항',
                    title: '[공지] DataON 서비스 개편에 따른 간헐적 서비스 일시 중지 현상 안내',
                    summary: 'DataON 서비스 개편 작업에 따라 2025년 12월 11일 18:00부터 21:00까지 간헐적 일시중지 현상이 있을 수 있습니다.',
                    date: '2025-12-11',
                    path: '/notice/noticeView_R.do?noticeSn=667',
                },
                {
                    category: '공지사항',
                    title: '[공지]DataON 인증서 교체에 따른 간헐적 서비스 일시 중지 현상 안내',
                    summary: 'dataon.kisti.re.kr 및 canvas.kisti.re.kr 인증서 교체 작업 안내입니다.',
                    date: '2025-11-11',
                    path: '/notice/noticeView_R.do?noticeSn=666',
                },
                {
                    category: '공지사항',
                    title: '[공지]DataON Canvas(분석 서비스) 인증서 교체 안내',
                    summary: 'Kubernetes 인증서 교체 작업으로 인해 작업 시간 동안 서비스 이용이 간헐적으로 중단될 수 있습니다.',
                    date: '2025-11-07',
                    path: '/notice/noticeView_R.do?noticeSn=665',
                },
                {
                    category: '공지사항',
                    title: '[공지] 서버 점검 안내에 따른 간헐적 서비스 일시 중지 현상 안내',
                    summary: '국가연구데이터플랫폼 서버 점검 작업으로 인한 간헐적 일시중지 현상 안내입니다.',
                    date: '2025-10-17',
                    path: '/notice/noticeView_R.do?noticeSn=664',
                },
            ],
        },
        {
            id: 'news',
            label: '뉴스',
            path: '/news',
            items: [
                {
                    category: '뉴스',
                    title: '보건의료데이터 활용 애로, 현장에서 해법 찾는다',
                    summary: '보건의료 분야 개인정보 규제 합리화를 위한 현장 간담회 개최 소식입니다.',
                    date: '2026-02-10',
                    path: '/news/newsView_R.do?newsSn=333',
                },
                {
                    category: '뉴스',
                    title: '한국인 뇌질환 데이터로 치매·파킨슨병 조기진단 연구성과 도출(1.23.금)',
                    summary: '뇌질환 연구기반 조성연구 사업의 치매·파킨슨병 조기 진단 연구성과 안내입니다.',
                    date: '2026-01-26',
                    path: '/news/newsView_R.do?newsSn=332',
                },
                {
                    category: '뉴스',
                    title: "출연연 AI 연구 총괄할 '국가과학 AI연구소', 6월 문 연다",
                    summary: '출연연 중심의 국가과학AI연구소 설립 준비와 연구 지원 허브 역할에 관한 소식입니다.',
                    date: '2026-01-13',
                    path: '/news/newsView_R.do?newsSn=331',
                },
                {
                    category: '뉴스',
                    title: '딥시크 쇼크 1년, 오픈소스·소버린 AI 시대 가속',
                    summary: '오픈소스 AI와 소버린 AI 전략 확산에 대한 산업 동향 소식입니다.',
                    date: '2026-01-13',
                    path: '/news/newsView_R.do?newsSn=330',
                },
            ],
        },
        {
            id: 'resources',
            label: '자료실',
            path: '/support/resources',
            items: [
                {
                    category: '자료실',
                    title: 'DataON 매뉴얼 영상',
                    summary: 'DataON 각 서비스를 통합해 설명하는 매뉴얼 영상입니다.',
                    date: '2024-04-30',
                    path: '/support/resources/dataon-manual-video',
                },
                {
                    category: '자료실',
                    title: 'DataON 홍보영상',
                    summary: 'DataON 서비스를 소개하는 약 4분 길이의 홍보영상입니다.',
                    date: '2024-04-30',
                    path: '/support/resources/dataon-promotion-video',
                },
                {
                    category: '자료실',
                    title: 'DataON 홍보영상(shorts)',
                    summary: 'DataON 서비스를 짧게 소개하는 쇼츠 영상입니다.',
                    date: '2024-04-29',
                    path: '/support/resources/dataon-shorts',
                },
                {
                    category: '자료실',
                    title: 'DataON 전문가 협의회 운영',
                    summary: 'DataON 사용 문제점과 활용 아이디어, 기술 조언을 수렴한 협의회 운영 자료입니다.',
                    date: '2023-05-26',
                    path: '/support/resources/expert-council',
                },
            ],
        },
        {
            id: 'events',
            label: '행사안내',
            path: '/events',
            items: [
                {
                    category: '행사안내',
                    title: '[한국과학기술정보연구원] 2025 미래연구정보포럼',
                    summary: 'KISTI 미래연구정보포럼 사전등록 안내입니다.',
                    date: '2025-11-20',
                    path: '/events/frif-2025',
                },
                {
                    category: '행사안내',
                    title: '[한국과학기술정보연구원] 2024 미래연구정보포럼',
                    summary: 'AI 시대의 오픈사이언스를 주제로 열리는 미래연구정보포럼입니다.',
                    date: '2024-11-12',
                    path: '/events/frif-2024',
                },
                {
                    category: '행사안내',
                    title: '[한국과학기술정보연구원] 2023 미래연구정보포럼',
                    summary: '데이터 중심의 오픈사이언스 생태계 구축을 주제로 한 포럼 안내입니다.',
                    date: '2023-11-28',
                    path: '/events/frif-2023',
                },
                {
                    category: '행사안내',
                    title: '2023 DATA·AI 분석 경진대회',
                    summary: '연구데이터와 AI 분석 활용을 촉진하기 위한 경진대회 안내입니다.',
                    date: '2023-05-31',
                    path: '/webinar/webinarView_R.do?webinarEduSn=69',
                },
            ],
        },
    ];

    public readonly homeDataTabs: HomeDataTab[] = [
        {
            id: 'latest',
            label: '최신데이터',
            items: [
                {
                    category: '해외',
                    title: 'BC Cumulative Effects Framework - Assessment Areas',
                    summary: 'The Assessment Areas dataset is produced and maintained by the BC Cumulative Effects Framework for use in the Assessment Portal.',
                    path: '/search/view.do?mode=02&svcId=ca39404a805bb8c2153801cdbc281a5f',
                    logo: '/assets/dataon/official/main/logo_track1_7.png',
                    logoAlt: 'FRDR',
                },
                {
                    category: '해외',
                    title: 'Comparative life cycle assessment of biodegradable PBAT vs HDPE films for animal carcass transport',
                    summary: 'This study evaluates the environmental impacts of biodegradable PBAT liners as an alternative to conventional HDPE liners for livestock carcass transport.',
                    path: '/search/view.do?mode=02&svcId=c16ab49795559253bea8044438731d4c',
                    logo: '/assets/dataon/official/main/logo_track1_7.png',
                    logoAlt: 'FRDR',
                },
                {
                    category: '해외',
                    title: 'Predicting Suitable Habitat for Stiff Yellow Flax in Eastern Georgian Bay: A MaxEnt and Random Forest Approach',
                    summary: 'Habitat suitability for Stiff Yellow Flax across Eastern Georgian Bay was mapped using MaxEnt and Random Forest models.',
                    path: '/search/view.do?mode=02&svcId=487ccc2cafc7025da55f33678f297185',
                    logo: '/assets/dataon/official/main/logo_track1_7.png',
                    logoAlt: 'FRDR',
                },
                {
                    category: '해외',
                    title: 'Global Sea-Ice Analysis System',
                    summary: 'Environment and Climate Change Canada provides global sea-ice analysis fields produced by its operational prediction system.',
                    path: '/search/view.do?mode=02&svcId=61a178340f7bda885fd074ebbe8fd28f',
                    logo: '/assets/dataon/official/main/logo_track1_7.png',
                    logoAlt: 'FRDR',
                },
            ],
        },
        {
            id: 'popular',
            label: '인기데이터',
            items: [
                {
                    category: '한국과학기술정보연구원',
                    title: 'UIUC Airfoil 형상데이터, 격자,  공기역학 시뮬레이션  Dataset',
                    summary: 'Wings are industrial products used in various industries. Aerodynamic characteristics analysis requires useful simulation and shape data.',
                    path: '/search/view.do?svcId=8459ad623007406ef383be344b6ac2c3',
                    metaLabel: '국내',
                    metaValue: '8,928',
                },
                {
                    category: 'DataON',
                    title: 'Worldview-3 위성 영상을 활용한 초해상화(x4)  학습 데이터셋',
                    summary: 'Worldview-3 위성 영상을 활용한 딥러닝 기반 초해상화(x4) 학습 데이터셋',
                    path: '/search/view.do?svcId=b6680bcd8ea1817d025484736c9c783c',
                    metaLabel: '국내',
                    metaValue: '1,120',
                },
                {
                    category: '한국항공우주연구원',
                    title: 'KFGOD: KOMPSAT 영상 기반 세부분류 객체탐지 데이터셋',
                    summary: 'KOMPSAT Fine-Grained Object Detection Dataset is a large-scale benchmark for object detection in high-resolution satellite imagery.',
                    path: '/search/view.do?svcId=c6ca9849ccfbf913f89891eaa82c04e5',
                    metaLabel: '국내',
                    metaValue: '1,093',
                },
                {
                    category: '한국항공우주연구원',
                    title: '해양·빙하 모니터링 및 토지 피복 변화 탐지 국가 위성 영상 AI 데이터셋',
                    summary: '해양·빙하 모니터링 및 토지 피복 변화 탐지 연구를 위해 구축된 국가 위성 영상 데이터셋입니다.',
                    path: '/search/view.do?svcId=dbe363cba656f6a35d5f82fd352d5c9f',
                    metaLabel: '국내',
                    metaValue: '인기',
                },
            ],
        },
    ];

    public readonly homeUsageCards: HomeUsageCard[] = [
        { eyebrow: '이슈&데이터', title: '코로나19', path: '/search/index.do?covidMode=Y' },
        { eyebrow: '이슈&데이터', title: '기후위기', path: '/search/index.do?gpccMode=Y' },
        { eyebrow: '이슈&데이터', title: '인공지능', path: '/search/index.do?kaggleMode=Y' },
        { eyebrow: '연구데이터', title: '매칭 커뮤니티', path: '/cmmnty/selectCmmntyList.do?searchCondition=02&searchKeyword=%EB%A7%A4%EC%B9%AD%20%EC%BB%A4%EB%AE%A4%EB%8B%88%ED%8B%B0' },
        { eyebrow: '연구데이터', title: '수요 컨설팅', path: '/cmmnty/selectCmmntyList.do?searchCondition=02&searchKeyword=%EC%88%98%EC%9A%94%20%EC%BB%A8%EC%84%A4%ED%8C%85' },
    ];

    public readonly homeLogoSlides: HomeLogoSlide[] = [
        {
            titleLines: ['글로벌 주요국과 연구데이터 연계'],
            logos: [
                { label: 'OpenAIRE 유럽', logo: '/assets/dataon/official/main/logo_track1_1.gif', path: 'https://www.openaire.eu/', external: true },
                { label: 'ARDC 호주', logo: '/assets/dataon/official/main/logo_track1_2.gif', path: 'https://ardc.edu.au/', external: true },
                { label: 'IRDB 일본', logo: '/assets/dataon/official/main/logo_track1_3.gif', path: 'https://irdb.nii.ac.jp/', external: true },
                { label: 'Finnish Social Science Data Archive 핀란드', logo: '/assets/dataon/official/main/logo_track1_4.png', path: 'https://www.fsd.tuni.fi/fi/', external: true },
            ],
        },
        {
            titleLines: ['글로벌 주요국과 연구데이터 연계'],
            logos: [
                { label: 'data govt.nz 뉴질랜드', logo: '/assets/dataon/official/main/logo_track1_5.png', path: 'https://www.data.govt.nz/', external: true },
                { label: 'HARVARD', logo: '/assets/dataon/official/main/logo_track1_6.png', path: 'https://dataverse.harvard.edu/', external: true },
                { label: 'FRDR', logo: '/assets/dataon/official/main/logo_track1_7.png', path: 'https://www.lunaris.ca/', external: true },
                { label: '4TU', logo: '/assets/dataon/official/main/logo_track1_8.png', path: 'https://data.4tu.nl/', external: true },
            ],
        },
        {
            titleLines: ['국내 연구기관, 데이터전문센터와', '연구데이터 연계'],
            logos: [
                { label: 'KIGAM 한국지질자원연구원', logo: '/assets/dataon/official/main/logo_track2_1.gif', path: 'https://www.kigam.re.kr/', external: true },
                { label: 'KRISS 한국표준과학연구원', logo: '/assets/dataon/official/main/logo_track2_2.gif', path: 'https://www.kriss.re.kr/', external: true },
                { label: 'KISTI 한국과학기술정보연구원', logo: '/assets/dataon/official/main/logo_track2_3.gif', path: 'https://www.kisti.re.kr/', external: true },
                { label: 'KISTI GSDC 대용량데이터허브센터', logo: '/assets/dataon/official/main/logo_track2_4.gif' },
                { label: 'NIA 한국정보화진흥원', logo: '/assets/dataon/official/main/logo_track2_5.gif', path: 'https://www.nia.or.kr/site/nia_kor/main.do', external: true },
                { label: '한국생산기술연구원', logo: '/assets/dataon/official/main/logo_track2_10.gif', path: 'https://www.kitech.re.kr/', external: true },
            ],
        },
        {
            titleLines: ['국내 연구기관, 데이터전문센터와', '연구데이터 연계'],
            logos: [
                { label: '국가바이오데이터스테이션', logo: '/assets/dataon/official/main/kbds-logo.png', path: 'https://kbds.re.kr', external: true },
                { label: 'AI Hub', logo: '/assets/dataon/official/main/logo_track2_6.png', path: 'https://www.aihub.or.kr/', external: true },
                { label: '천문연', logo: '/assets/dataon/official/main/logo_track2_8.png', path: 'https://www.kasi.re.kr/', external: true },
                { label: '한의한연구원', logo: '/assets/dataon/official/main/logo_track2_7.gif', path: 'https://www.kiom.re.kr/', external: true },
                { label: '항우연', logo: '/assets/dataon/official/main/logo_track2_9.png', path: 'https://www.kari.re.kr/', external: true },
                { label: '국립산림과학원', logo: '/assets/dataon/official/main/logo_track2_17.png', path: 'https://know.nifos.go.kr/', external: true },
            ],
        },
        {
            titleLines: ['국내 연구기관, 데이터전문센터와', '연구데이터 연계'],
            logos: [
                { label: '한국이산화탄소포집및처리연구개발센터', logo: '/assets/dataon/official/contents/1-4-3_logo_18.gif' },
                { label: '한국전자통신연구원', logo: '/assets/dataon/official/main/logo_track2_10.png' },
                { label: 'AIDA', logo: '/assets/dataon/official/contents/1-4-3_logo_17.gif', path: 'https://aida.kisti.re.kr/', external: true },
                { label: '극지연구소', logo: '/assets/dataon/official/contents/1-4-3_logo_19.gif' },
                { label: '한국식품연구원', logo: '/assets/dataon/official/main/logo_track2_14.png', path: 'https://www.kfri.re.kr/', external: true },
            ],
        },
        {
            titleLines: ['국내 연구기관, 데이터전문센터와', '연구데이터 연계'],
            logos: [
                { label: '한국해양과학기술원', logo: '/assets/dataon/official/contents/1-4-3_logo_22.png', path: 'https://www.kiost.ac.kr', external: true },
                { label: '한국환경연구원 데이터 포탈', logo: '/assets/dataon/official/main/logo_track2_12.png', path: 'https://data.kei.re.kr/', external: true },
                { label: '대구교육데이터연구소', logo: '/assets/dataon/official/main/logo_track2_13.png', path: 'https://www.dge.go.kr/dferi', external: true },
                { label: '국립생태원 Ecobank', logo: '/assets/dataon/official/main/logo_track2_11.png', path: 'https://www.nie-ecobank.kr/', external: true },
                { label: '특허청', logo: '/assets/dataon/official/main/logo_track2_15.png', path: 'https://plus.kipris.or.kr/', external: true },
            ],
        },
        {
            titleLines: ['국가R&D과제정보, 과학기술정보 등', '참조 정보 연계'],
            logos: [
                { label: 'NTIS 국가과학기술지식정보서비스', logo: '/assets/dataon/official/main/logo_track3_1.gif', path: 'https://www.ntis.go.kr/ThMain.do', external: true },
                { label: 'ScienceON KISTI 과학기술 지식인프라', logo: '/assets/dataon/official/main/logo_track3_2.gif', path: 'https://scienceon.kisti.re.kr/main/mainForm.do', external: true },
                { label: '바이오화학오픈데이터서비스', logo: '/assets/dataon/official/main/biochem_logo.png', path: 'https://biochem-dos.kr/', external: true },
            ],
        },
    ];

    public readonly homeFooterLogoLinks: HomeLogoLink[] = [
        { label: '국가과학기술지식정보서비스', logo: '/assets/dataon/official/main/logomark_ntis.png', path: 'https://www.ntis.go.kr/', external: true },
        { label: '국가오픈엑세스플랫폼', logo: '/assets/dataon/official/main/logomark_accesson.png', path: 'https://accesson.kisti.re.kr/', external: true },
        { label: '사이언스온', logo: '/assets/dataon/official/main/logomark_scienceon.png', path: 'https://scienceon.kisti.re.kr/', external: true },
        { label: 'DataOn 채널', logo: '/assets/dataon/official/main/logomark_youtube.png', path: 'https://www.youtube.com/@dataon4339/', external: true },
    ];

    public readonly searchNavigationTabs: LinkItem[] = [
        { label: '데이터셋 검색', path: '/search/datasets' },
        { label: '소프트웨어 검색', path: '/search/software' },
        { label: '통합 검색', path: '/search/integrated' },
        { label: '상세 검색', path: '/search/detail' },
        { label: '제공처 검색', path: '/search/providers' },
        { label: '맵 검색', path: '/search/map' },
        { label: '의미검색', path: '/search/semantic' },
        { label: '이슈&데이터', path: '/search/issues' },
        { label: '코로나 바이러스', path: '/search/issues/covid-19' },
        { label: 'GPCC', path: '/search/issues/gpcc' },
        { label: 'KAGGLE', path: '/search/issues/kaggle' },
    ];

    public readonly searchMenuPages: SearchMenuPageConfig[] = [
        {
            id: 'datasets',
            label: '데이터셋 검색',
            title: '데이터셋 검색',
            sectionLabel: '콘텐츠별 검색',
            path: '/search/datasets',
            aliases: ['/search/index.do'],
            description: '연구데이터 키워드와 조건을 조합해 데이터셋을 탐색합니다.',
            placeholder: '아마존, 산림, 벌채, 위성 등 검색어를 입력하세요',
            allResultsLabel: '전체 데이터셋',
            chips: ['위성정보', '기후변화', '미세먼지', '스마트시티', '해양관측'],
            searchTargets: ['데이터셋'],
        },
        {
            id: 'software',
            label: '소프트웨어 검색',
            title: '소프트웨어 검색',
            sectionLabel: '콘텐츠별 검색',
            path: '/search/software',
            description: '분석 도구, 코드, 워크플로우, CANVAS 연계 소프트웨어를 검색합니다.',
            placeholder: 'JupyterLab, Workflow, 분석 도구 등 검색어를 입력하세요',
            allResultsLabel: '전체 소프트웨어',
            chips: ['CANVAS', 'JupyterLab', '워크플로우', 'Python', '시각화'],
            searchTargets: ['소프트웨어'],
        },
        {
            id: 'integrated',
            label: '통합 검색',
            title: '통합 검색',
            sectionLabel: '검색',
            path: '/search/integrated',
            aliases: ['/search'],
            description: '데이터셋, 소프트웨어, 제공처 정보를 한 번에 검색합니다.',
            placeholder: '연구데이터, 소프트웨어, 제공처를 통합 검색하세요',
            allResultsLabel: '전체 통합 검색',
            chips: ['기후변화', 'AI', '제공처', '소프트웨어', '공개 데이터'],
        },
        {
            id: 'detail',
            label: '상세 검색',
            title: '상세 검색',
            sectionLabel: '검색',
            path: '/search/detail',
            description: '제목, 제공처, 생성연도, 파일유형, 과제정보를 조합해 정밀 검색합니다.',
            placeholder: '검색어 입력 후 상세조건을 선택하세요',
            allResultsLabel: '상세조건 검색 결과',
            chips: ['생성연도', '제공처', '파일유형', '과제명', '공개 여부'],
            aliases: ['/search/detail', '/search/searchDetail.do'],
            openAdvanced: true,
        },
        {
            id: 'providers',
            label: '제공처 검색',
            title: '제공처 검색',
            sectionLabel: '검색',
            path: '/search/providers',
            aliases: ['/search/providerSearch.do'],
            description: '국내외 연구데이터 제공기관과 리포지터리를 기관명, 분야, 설명으로 찾습니다.',
            placeholder: '한국천문연구원, KISTI, OpenAIRE 등 제공처를 입력하세요',
            allResultsLabel: '전체 제공처',
            chips: ['한국천문연구원', 'KISTI', 'OpenAIRE', 'AI 허브', '극지연구소'],
            searchTargets: ['제공처'],
        },
        {
            id: 'semantic',
            label: '의미검색',
            title: '의미검색',
            sectionLabel: '검색',
            path: '/search/semantic',
            aliases: ['/search/semanticSearch.do'],
            description: '키워드 일치뿐 아니라 문맥과 유사 개념을 기준으로 관련 데이터를 탐색합니다.',
            placeholder: '예: 도시 침수 위험 예측에 필요한 강우·지형 데이터',
            allResultsLabel: '전체 의미검색',
            chips: ['산림 변화', '도시 열환경', '농업기상', '침수재난', '해양 시계열'],
            forceSemantic: true,
        },
        {
            id: 'issues',
            label: '이슈&데이터',
            title: '이슈&데이터',
            sectionLabel: '이슈&데이터',
            path: '/search/issues',
            description: '코로나 바이러스, GPCC, KAGGLE 등 주요 이슈별 연구데이터를 한곳에서 확인합니다.',
            placeholder: '코로나, GPCC, Kaggle 등 이슈 키워드를 입력하세요',
            allResultsLabel: '전체 이슈&데이터',
            chips: ['코로나19', 'GPCC', 'Kaggle', '기후변화', '인공지능'],
            requiredKeywords: ['코로나', 'COVID', 'GPCC', 'Kaggle', '기후', '인공지능', '경진대회'],
        },
        {
            id: 'issue-covid',
            label: '코로나 바이러스',
            title: '코로나 바이러스',
            sectionLabel: '이슈&데이터',
            path: '/search/issues/covid-19',
            description: '코로나19 관련 공공데이터, 감염병 연구자료, 보건의료 분석 데이터를 모아 탐색합니다.',
            placeholder: '확진자, 감염병, 백신, 의료 등 검색어를 입력하세요',
            allResultsLabel: '코로나 바이러스 관련 데이터',
            chips: ['코로나19', '감염병', '확진자', '백신', '보건의료'],
            requiredKeywords: ['코로나', 'COVID', '감염병', '백신', '보건의료'],
        },
        {
            id: 'issue-gpcc',
            label: 'GPCC',
            title: 'GPCC',
            sectionLabel: '이슈&데이터',
            path: '/search/issues/gpcc',
            description: 'GPCC 기반 강수량, 기후 관측, 수문 분석 데이터를 이슈별로 확인합니다.',
            placeholder: 'GPCC, 강수량, 기후, 수문 등 검색어를 입력하세요',
            allResultsLabel: 'GPCC 관련 데이터',
            chips: ['GPCC', '강수량', '기후변화', '수문', '격자 데이터'],
            requiredKeywords: ['GPCC', '강수량', '기후', '수문', '격자'],
        },
        {
            id: 'issue-kaggle',
            label: 'KAGGLE',
            title: 'KAGGLE',
            sectionLabel: '이슈&데이터',
            path: '/search/issues/kaggle',
            description: 'Kaggle 연계 공개 데이터와 인공지능 학습·분석용 데이터를 탐색합니다.',
            placeholder: 'Kaggle, 머신러닝, 경진대회, 학습 데이터 등 검색어를 입력하세요',
            allResultsLabel: 'KAGGLE 관련 데이터',
            chips: ['Kaggle', '머신러닝', '경진대회', '학습데이터', '인공지능'],
            requiredKeywords: ['Kaggle', '머신러닝', '경진대회', '학습', '인공지능'],
        },
    ];

    public readonly searchScopeOptions: DatasetSearchAdvancedOption[] = [
        { label: '전체', value: 'all' },
        { label: '제목', value: 'title' },
        { label: '설명', value: 'summary' },
        { label: '키워드', value: 'keywords' },
        { label: '제공처', value: 'provider' },
    ];

    public readonly officialProviderCountryOptions = [
        '선택',
        '대한민국',
        '오스트레일리아',
        '캐나다',
        '유럽연합',
        '네덜란드',
        '뉴질랜드',
        '핀란드',
        '일본',
        '미국',
    ];

    public readonly officialProviderSearchCards = [
        {
            country: '대한민국',
            title: '국가연구데이터플랫폼',
            url: 'https://dataon.kisti.re.kr',
            startDate: '2019-01-01',
            collectDate: '',
            field: '',
            description: '국내외 연구데이터 정보를 한곳에서 서비스하는 국가연구데이터 포털입니다. 연구데이터를 검색·공유·관리 하는 것 뿐만 아니라 커뮤니티 연구자들끼리 데이터를 공유하고 공동 활용해 국가 R&D 투자 효율성을 높이고 연구 생산성 향상에 기여하는 것이 주 목적입니다.',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/1/dataon.png',
            contentLabel: '데이터셋',
            contentCount: '176',
            views: '120,388',
            downloads: '371,405',
            recommendations: '22',
            shares: '225',
        },
        {
            country: '대한민국',
            title: '한국항공우주연구원',
            url: '',
            startDate: '',
            collectDate: '',
            field: '',
            description: '한국항공우주연구원',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/446/kari.png',
            contentLabel: '데이터셋',
            contentCount: '1,579',
            views: '51,065',
            downloads: '5,285',
            recommendations: '14',
            shares: '37',
        },
        {
            country: '대한민국',
            title: '한국과학기술정보연구원',
            url: 'https://kisti.re.kr',
            startDate: '',
            collectDate: '',
            field: '',
            description: '한국과학기술정보연구원(KISTI)은 1962년 설립되어 우리나라 과학기술 발전의 역사와 함께해 온 국가 과학기술 정보분야의 대표 연구기관으로, 국내 최대의 과학기술정보와 세계적 수준의 슈퍼컴퓨팅, 데이터 분석 기술을 바탕으로 ‘지능정보사회’의 핵심 기반이 되는 과학기술 서비스를 제공하며 연구자들의 핵심 파트너로 성장하고 있습니다. 과학·기술 및 이와 관련된 산업정보의 종합적인 수집·분석·서비스 , 정보의 관리 및 유통에 관한 기술·정책·표준화 등의 전문적인 조사·연구, 첨단 정보 및 연구개발 인프라의 체계적인 구축·운영 서비스를 제공하고 있습니다.',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/6968287/kisti.gif',
            contentLabel: '데이터셋',
            contentCount: '379',
            views: '19,813',
            downloads: '3,444',
            recommendations: '0',
            shares: '222',
        },
        {
            country: '대한민국',
            title: 'DataON CANVAS',
            url: 'https://dataon.kisti.re.kr/canvas',
            startDate: '2020-10-20',
            collectDate: '',
            field: '',
            description: '국가 연구데이터 포털에서 제공하는 연구데이터 분석 및 결과 파일을 저장 서비스입니다.',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/5/canvas_cap.png',
            contentLabel: '소프트웨어',
            contentCount: '110',
            views: '23,914',
            downloads: '1,556',
            recommendations: '0',
            shares: '154',
        },
        {
            country: '대한민국',
            title: 'KISTI 기계학습 데이터 공유 활용 서비스',
            url: 'https://aida.kisti.re.kr/',
            startDate: '',
            collectDate: '',
            field: '',
            description: 'KISTI에서는 연구자들이 과학기술 분야의 기계학습 데이터에 원하는 방식으로 자유롭게 접근하여 처리, 분석하고 연구 결과 도출을 지원하기 위해 기계학습 데이터 공유/활용 서비스를 제공합니다.',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/334/machine_learning.png',
            contentLabel: '데이터셋',
            contentCount: '83',
            views: '16,888',
            downloads: '747',
            recommendations: '5',
            shares: '89',
        },
        {
            country: '대한민국',
            title: '한국지질자원연구원',
            url: 'https://www.kigam.re.kr/',
            startDate: '',
            collectDate: '2019-12-06',
            field: '',
            description: '국내외 육상·해저 지질조사, 지하자원 탐사·개발 활용, 지질재해 및 지구환경변화 대응을 통해 지속 가능한 국가발전에 기여하고 있습니다.',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/8/kigam.gif',
            contentLabel: '데이터셋',
            contentCount: '3,419',
            views: '98,614',
            downloads: '451',
            recommendations: '1',
            shares: '41',
        },
        {
            country: '대한민국',
            title: '국가참조표준센터',
            url: 'https://www.srd.re.kr/css/index.do',
            startDate: '',
            collectDate: '',
            field: '',
            description: '한국표준과학연구원내에 설립(2006년 8월)된 국가참조표준센터는 국가에서 필요로 하는 참조표준을 제공하기 위해 참조표준 제개정, 데이터센터 발굴육성 및 운영, 참조표준 보급 확산, 참조표준 신뢰성 평가 연구, 전문인력 양성 등 국가참조표준체계를 운영하는 핵심조직입니다.',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/10/ncsrd.png',
            contentLabel: '데이터셋',
            contentCount: '2,108',
            views: '65,180',
            downloads: '294',
            recommendations: '3',
            shares: '31',
        },
        {
            country: '대한민국',
            title: 'GeoAI 데이터학회',
            url: '',
            startDate: '',
            collectDate: '',
            field: '',
            description: '지구과학, 지구환경 및 지구공학분야의 AI데이터에 대한 공유 및 활용을 통하여 미래 4차산업의 발달과 학문의 발전에 이바지함을 목적으로 한다.',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/468/geoai_logo.png',
            contentLabel: '데이터셋',
            contentCount: '9',
            views: '2,426',
            downloads: '201',
            recommendations: '3',
            shares: '8',
        },
        {
            country: '대한민국',
            title: '한국이산화탄소포집및처리연구개발센터',
            url: 'http://www.kcrc.re.kr',
            startDate: '',
            collectDate: '',
            field: '',
            description: '한국이산화탄소포집및처리연구개발센터(Korea Carbon Capture & Sequestration R&D Center',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/6968298/kcrc.jpg',
            contentLabel: '데이터셋',
            contentCount: '170',
            views: '7,026',
            downloads: '174',
            recommendations: '0',
            shares: '2',
        },
        {
            country: '대한민국',
            title: '한국전자통신연구원',
            url: '',
            startDate: '',
            collectDate: '',
            field: '',
            description: '한국전자통신연구원 데이터리포지터리',
            logo: 'https://dataon.kisti.re.kr/search/imagePreview.do?filePath=/mnt/share/lustre/portal-upload/repository/logo/455/etri_logo.png',
            contentLabel: '데이터셋',
            contentCount: '23',
            views: '2,486',
            downloads: '172',
            recommendations: '0',
            shares: '1',
        },
    ];

    public readonly officialDetailSearchFields = [
        '제목',
        '내용',
        '키워드',
        '주제분류',
        '파일유형',
        '발행기관',
        '생성자',
        '기여자',
        '담당자',
        '과제명',
        '과제책임자',
        '과제수행기관',
        '부처',
        '데이터 제공처',
        '데이터 리포지터리',
        '국가연구자번호',
        'NTIS과제번호',
    ];

    public readonly officialSearchFacetGroups = [
        {
            title: '자료유형',
            hasHelp: false,
            hasMore: false,
            foldable: false,
            items: [
                { label: 'dataset', count: '7,519,026' },
                { label: 'software', count: '110' },
            ],
        },
        {
            title: '국내외구분',
            hasHelp: false,
            hasMore: false,
            foldable: false,
            items: [
                { label: '해외', count: '4,456,945' },
                { label: '국내', count: '3,062,191' },
            ],
        },
        {
            title: '데이터 제공처',
            hasHelp: true,
            hasMore: true,
            foldable: true,
            items: [
                { label: '한국환경연구원 데이터 포탈', count: '17' },
                { label: '한국화학연구원', count: '1' },
                { label: '한국핵융합에너지연구원', count: '5' },
                { label: '한국해양과학기술원', count: '55' },
            ],
        },
        {
            title: '데이터 리포지터리',
            hasHelp: true,
            hasMore: true,
            foldable: true,
            items: [
                { label: 'OpenAIRE', count: '3,839,287' },
                { label: '한국천문연구원', count: '3,019,486' },
                { label: 'ARDC', count: '215,439' },
                { label: 'FRDR', count: '107,283' },
            ],
        },
        {
            title: '과제수행기관',
            hasHelp: false,
            hasMore: true,
            foldable: true,
            items: [
                { label: '한국표준과학연구원', count: '1,574' },
                { label: '한국과학기술정보연구원', count: '365' },
                { label: '(재)한국이산화탄소포집및...', count: '169' },
                { label: '(재)한국표준과학연구원', count: '132' },
            ],
        },
        {
            title: '파일유형',
            hasHelp: false,
            hasMore: true,
            foldable: false,
            items: [
                { label: 'pdf', count: '7,510,583' },
                { label: 'csv', count: '2,133' },
                { label: 'json', count: '548' },
                { label: 'zip', count: '188' },
            ],
        },
    ];

    private readonly resultFilterFieldDefinitions: DatasetSearchAdvancedField[] = [
        { key: 'searchTarget', label: '자료유형', type: 'single' },
        { key: 'subject', label: '주제분류', type: 'multi' },
        { key: 'provider', label: '제공기관', type: 'text' },
        { key: 'accessRight', label: '접근권한', type: 'single' },
        { key: 'fileType', label: '파일유형', type: 'multi' },
    ];

    public readonly searchTypeHelpItems: SearchTypeHelpItem[] = [
        { label: '통합 검색', description: '데이터셋과 소프트웨어를 한 번에 찾습니다.', icon: 'fa-magnifying-glass' },
        { label: '데이터셋 검색', description: '연구데이터 목록과 패싯을 중심으로 탐색합니다.', icon: 'fa-database' },
        { label: '소프트웨어 검색', description: '분석 도구, 코드, 워크플로우 자료를 찾습니다.', icon: 'fa-code' },
        { label: '상세검색', description: '키워드 조건과 연도 범위를 조합해 좁힙니다.', icon: 'fa-sliders' },
        { label: '제공처 검색', description: '국가, 기관명, 설명 기준으로 제공처를 찾습니다.', icon: 'fa-building-columns' },
        { label: '지도 검색', description: '지도 영역과 위치 기준으로 공간 데이터를 찾습니다.', icon: 'fa-location-dot' },
        { label: '의미검색', description: '유사 개념과 문맥 기반으로 관련 데이터를 찾습니다.', icon: 'fa-wand-magic-sparkles' },
        { label: '이슈&데이터', description: '주요 이슈별로 미리 묶인 데이터를 탐색합니다.', icon: 'fa-bolt' },
    ];

    public readonly searchHelpItems: SearchHelpItem[] = [
        { operator: '공백', description: '두 개의 검색어(식)을 모두 포함하고 있는 문서 검색', example: '(데이터 기술)' },
        { operator: '()', description: '우선순위가 가장 높은 연산자', example: '(정확 (데이터|data))' },
        { operator: '|', description: '두 개의 검색어(식) 중 하나 이상 포함하고 있는문서 검색', example: '(항공 | 토양)' },
        { operator: '!', description: 'NOT 이후에 있는 검색어가 포함된 문서는 제외', example: '(데이터 !연구)' },
        { operator: '*', description: '검색어의 *란에 0개 이상의 임의의 문자가 포함된 문서 검색', example: 'data*' },
        { operator: '" "', description: '따옴표 내의 구문과 완전히 일치하는 문서만 검색', example: '"Transform"' },
    ];

    private datasetSearchTermCandidateCache: DatasetSearchTermCandidate[] | null = null;

    private readonly datasetSearchCandidateStopWords = [
        '데이터',
        '데이터셋',
        '자료',
        '분석',
        '관측',
        '기반',
        '위한',
        '공개',
        '국내',
        'dataset',
        'data',
        'analysis',
        'observations',
    ];

    private readonly datasetSearchSynonymEntries: DatasetSearchSynonymEntry[] = [
        {
            canonical: '아마존',
            synonyms: ['amazon', '열대우림', '브라질 열대우림', 'amazon rainforest'],
            related: ['산림벌채', '위성영상', 'KOMPSAT', 'Sentinel-2', '산림훼손'],
            reason: '아마존 열대우림과 산림 변화 감시 데이터 맥락이 연결됩니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
        {
            canonical: '산림벌채',
            synonyms: ['산림파괴', '산림훼손', '벌채', 'deforestation', 'forest'],
            related: ['아마존', '위성영상', 'KOMPSAT', 'Sentinel-2', '영상분할'],
            reason: '산림 변화 감시와 원격탐사 문맥이 유사합니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
        {
            canonical: '위성영상',
            synonyms: ['위성사진', '위성', '영상', '원격탐사', 'satellite', 'remote sensing'],
            related: ['KOMPSAT', 'Sentinel-2', '토지피복', '라벨', '분석'],
            reason: '위성 기반 관측과 이미지 분석 데이터입니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
        {
            canonical: '대기질',
            synonyms: ['미세먼지', '초미세먼지', 'PM2.5', 'PM10', '공기질', 'air quality'],
            related: ['관측망', '환경', '센서', '수도권'],
            reason: '환경 관측 지표와 대기 오염 분석 주제가 맞닿아 있습니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
        {
            canonical: '도시열섬',
            synonyms: ['열섬', '지표면온도', '도시 온도', 'urban heat'],
            related: ['토지피복', '위성영상', '도시', '기후'],
            reason: '도시 기후와 토지피복 변화 분석에 활용됩니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
        {
            canonical: '기후',
            synonyms: ['climate', '기후변화', '기후지수', '기후변동', '기후위기', '장기기후변동'],
            related: ['기후변화', '기후지수', '기후변동'],
            reason: 'DataON 연관검색어 기준에 따라 기후 관련 확장 키워드를 제공합니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
        {
            canonical: '교통량',
            synonyms: ['교통', '차량', '도로', '정체', '스마트시티', 'traffic'],
            related: ['센서', '속도', '도로구간', '세종'],
            reason: '도시 이동성과 센서 기반 교통 분석 문맥이 유사합니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
        {
            canonical: '해양관측',
            synonyms: ['해수면', '조위', '파고', '염분', '해양', 'ocean'],
            related: ['연안', '관측소', '인천', '수온'],
            reason: '연안 해양 지표와 시계열 관측 데이터입니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
        {
            canonical: '농업기상',
            synonyms: ['작물', '토양수분', '일사량', '생육', 'agriculture'],
            related: ['기온', '전주', '모델 검증', '관측'],
            reason: '작물 생육과 농업 환경 관측 조건이 연결됩니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
        {
            canonical: '침수재난',
            synonyms: ['침수', '재난', '홍수', '호우', '유속', 'flood'],
            related: ['시뮬레이션', '도시', '격자', '대구'],
            reason: '재난 위험 예측과 도시 공간 분석에 적합합니다.',
            source: 'sample',
            status: 'approved',
            approvedBy: 'prototype-curator',
        },
    ];

    public readonly serviceCards: LinkItem[] = [
        { label: '연구데이터 검색', path: '/search/datasets', description: '다양한 연구데이터를 쉽고 빠르게 검색하고 탐색하세요.', icon: 'fa-magnifying-glass' },
        { label: '데이터 등록', path: '/submit', description: '연구데이터를 안전하게 등록하고 메타데이터를 자동으로 관리하세요.', icon: 'fa-cloud-arrow-up' },
        { label: 'AI 기반 데이터 활용', path: '/analysis/canvas', description: 'AI 분석, 요약, 추천 등 다양한 기능으로 데이터를 활용하세요.', icon: 'fa-microchip' },
        { label: '통계 · 현황', path: '/dataon/statistics/data', description: '연구데이터 현황과 활용 통계를 한눈에 확인하세요.', icon: 'fa-chart-simple' },
    ];

    public readonly statusCards = [
        { label: '데이터셋', value: '123,456', unit: '건', icon: 'fa-layer-group' },
        { label: '파일 수', value: '1,234,567', unit: '건', icon: 'fa-folder-open' },
        { label: '연구기관', value: '567', unit: '개', icon: 'fa-building-columns' },
        { label: '사용자', value: '89,012', unit: '명', icon: 'fa-user' },
    ];

    public readonly datasets: DatasetItem[] = [
        { title: '아마존 산림벌채 위성영상 데이터셋', date: '2026.06.04', tags: ['위성정보', 'PNG·ZIP', '공개'], icon: 'fa-satellite' },
    ];

    public readonly fields = [
        { label: '자연과학', icon: 'fa-atom', path: '/search/field/natural-science' },
        { label: '생명과학', icon: 'fa-dna', path: '/search/field/life-science' },
        { label: '공학', icon: 'fa-gear', path: '/search/field/engineering' },
        { label: '의약학', icon: 'fa-briefcase-medical', path: '/search/field/medicine' },
        { label: '사회과학', icon: 'fa-users', path: '/search/field/social-science' },
        { label: '인문학', icon: 'fa-book-open', path: '/search/field/humanities' },
        { label: '농수해양', icon: 'fa-seedling', path: '/search/field/agro-ocean' },
        { label: '기타', icon: 'fa-ellipsis', path: '/search/field/etc' },
    ];

    public readonly notices = [
        { title: 'DataON 시스템 점검 안내', date: '2024.05.20', path: '/notice/system-maintenance' },
        { title: '연구데이터 등록 가이드 업데이트 안내', date: '2024.05.18', path: '/notice/register-guide' },
        { title: '2024년 연구데이터 활용 공모전 안내', date: '2024.05.15', path: '/notice/contest-2024' },
        { title: '데이터 제공 정책 변경 안내', date: '2024.05.10', path: '/notice/policy-update' },
    ];

    public readonly bottomLinks: LinkItem[] = [
        { label: '사용자 가이드', description: '이용 방법을 확인하세요', path: '/support/user-guide', icon: 'fa-clipboard-list' },
        { label: 'FAQ', description: '자주 묻는 질문', path: '/support/faq', icon: 'fa-comments' },
        { label: '자료실', description: '매뉴얼, 가이드, 서식 등', path: '/support/resources', icon: 'fa-file-lines' },
        { label: '문의하기', description: '문의사항을 남겨주세요', path: '/support/contact', icon: 'fa-headset' },
    ];

    public readonly footerLinks: LinkItem[] = [
        { label: '이용약관', path: 'https://dataon.kisti.re.kr/layout/termsOfUse.do', external: true },
        { label: '개인정보처리방침', path: 'https://dataon.kisti.re.kr/layout/privacyPolicy.do', external: true },
        { label: '기관소개', path: 'https://www.kisti.re.kr/intro/introduce/pageView/14', external: true },
    ];

    public readonly extraPages: LinkItem[] = [
        { label: '로그인', path: '/login', description: 'DataON 로그인 페이지입니다.' },
        { label: 'DataON 기존 로그인', path: '/user/userLogin.do', description: 'DataON 로그인 페이지입니다.' },
        { label: '추천 연구데이터', path: '/search/recommended', description: '추천 연구데이터 목록을 확인하는 페이지입니다.' },
        { label: '데이터셋 검색', path: '/search/datasets', description: '검색 조건에 맞는 데이터셋 목록을 확인하는 페이지입니다.' },
        { label: '연구데이터 상세', path: '/search/datasets/detail', description: '선택한 연구데이터의 상세 정보를 확인하는 페이지입니다.' },
        { label: '분야별 탐색', path: '/search/fields', description: '연구 분야별 데이터 탐색 페이지입니다.' },
        { label: '회원가입', path: '/join', description: 'DataON 회원가입 페이지입니다.' },
        { label: 'DataON 기존 회원가입', path: '/user/userEmailSend.do', description: 'DataON 회원가입 페이지입니다.' },
        { label: '관리자 승인 요청 완료', path: '/join/complete', description: '관리자 승인 요청 접수 완료 화면입니다.' },
        { label: '언어 설정', path: '/language/ko', description: '언어 설정 페이지입니다.' },
    ];

    public readonly joinSteps: { id: JoinStepId; index: string; label: string; description: string }[] = [
        { id: 'role', index: '1', label: '회원 유형', description: '가입 유형 선택' },
        { id: 'terms', index: '2', label: '약관 동의', description: '필수 정책 확인' },
        { id: 'verify', index: '3', label: '이메일 인증', description: '계정 정보 확인' },
        { id: 'complete', index: '4', label: '승인 요청', description: '관리자 검토 접수' },
    ];

    public readonly submitNavigationLinks: LinkItem[] = [
        { label: '제출', path: '/submit' },
        { label: '데이터 관리', path: '/submit/manage' },
        { label: '제출 데이터 통계', path: '/submit/statistics' },
        { label: '데이터 승인', path: '/submit/approval' },
    ];

    public readonly submitCollectionGroups: SubmitCollectionGroup[] = this.createSubmitInstitutionGroups();

    public submitDraftRecords: SubmitRecord[] = [
        { id: 132, title: '기후변화 관측 데이터', files: 4, modifiedAt: '2026-06-23', status: '승인대기', statusClass: 'pending', tool: '회수' },
        { id: 131, title: 'New_collection_test 1.3', files: 13, modifiedAt: '2026-06-10', status: '반려됨', statusClass: 'rejected', tool: '삭제' },
        { id: 130, title: 'Untitled', files: 0, modifiedAt: '2026-06-03', status: '작성대기', statusClass: 'created', tool: '삭제' },
        { id: 129, title: '해양 표층수온 장기 관측 데이터', files: 7, modifiedAt: '2026-05-28', status: '임시저장', statusClass: 'workspace', tool: '삭제' },
    ];

    public submitArchivedRecords: SubmitRecord[] = [
        { id: 128, title: 'KOMPSAT 영상 기반 객체탐지 데이터셋', files: 84, modifiedAt: '2026-05-21', status: '공개', statusClass: 'archived', tool: '이력' },
        { id: 127, title: '농업기상 관측망 원천 데이터', files: 44, modifiedAt: '2026-04-30', status: '공개', statusClass: 'archived', tool: '이력' },
    ];

    public readonly submitStatRows: SubmitStatRow[] = [
        { label: 'Draft', value: 129, ratio: 92, color: '#35C8B0' },
        { label: 'In Progress', value: 0, ratio: 0, color: '#7EA8FF' },
        { label: 'Rejected', value: 2, ratio: 2, color: '#FF7D93' },
        { label: 'Archived', value: 2, ratio: 2, color: '#1BAFC6' },
    ];

    public readonly submitApprovalRecords: SubmitApprovalRecord[] = [
        { id: 'APR-2026-001', title: '기후변화 관측 데이터', submitter: '김민준', organization: '한국과학기술정보연구원', collection: '국가연구데이터플랫폼', files: 4, requestedAt: '2026-06-23', status: 'pending', statusLabel: '승인대기' },
        { id: 'APR-2026-002', title: '해양 표층수온 장기 관측 데이터', submitter: '박서연', organization: '한국해양과학기술원', collection: '한국해양과학기술원', files: 7, requestedAt: '2026-06-20', status: 'pending', statusLabel: '승인대기' },
        { id: 'APR-2026-003', title: 'KOMPSAT 영상 기반 객체탐지 데이터셋', submitter: '이도윤', organization: '한국항공우주연구원', collection: '한국항공우주연구원', files: 84, requestedAt: '2026-06-15', status: 'approved', statusLabel: '승인완료' },
        { id: 'APR-2026-004', title: 'New_collection_test 1.3', submitter: '최지우', organization: 'GeoAI 데이터학회', collection: 'GeoAI 데이터학회', files: 13, requestedAt: '2026-06-10', status: 'rejected', statusLabel: '반려' },
    ];

    public readonly kafeLoginUrl = 'https://ds.kafe.or.kr/live/lookup?entityID=https%3A%2F%2Fdataon.kisti.re.kr%2Fsp%2Fspring&return=https%3A%2F%2Fdataon.kisti.re.kr%2Fsaml%2Flogin&returnIDParam=idp';
    public readonly knowledgeGraphFilters: KnowledgeGraphFilter[] = [
        { type: 'all', label: '전체' },
        { type: 'project', label: '과제' },
        { type: 'paper', label: '논문' },
        { type: 'researcher', label: '연구자' },
        { type: 'organization', label: '기관' },
        { type: 'keyword', label: '키워드' },
        { type: 'equipment', label: '기기' },
    ];
    public readonly knowledgeGraphNodes: KnowledgeGraphNode[] = [
        {
            id: 'kg-dataset-climate',
            type: 'dataset',
            label: '기후변화 관측 데이터',
            shortLabel: '기후 관측',
            dataonId: 'DATAON-DS-CLM-2026-001',
            source: 'DataON',
            pathLabel: '현재 데이터',
            metadata: [
                { label: '자료유형', value: '연구데이터' },
                { label: '생성일', value: '2026-06-04' },
                { label: 'DOI', value: '10.22711/dataon.climate.2026.001' },
                { label: '주제분류', value: '자연과학 > 지구과학 > 기후' },
                { label: '라이선스', value: 'CC BY-NC' },
            ],
        },
        {
            id: 'kg-project-observation',
            type: 'project',
            label: '기후변화 적응형 관측체계 고도화 과제',
            shortLabel: '관측 과제',
            dataonId: 'DATAON-PRJ-2024-0187',
            source: 'NTIS',
            pathLabel: '관련 과제',
            metadata: [
                { label: '부처', value: '과학기술정보통신부' },
                { label: '수행기관', value: '한국기상과학원' },
                { label: '연구기간', value: '2024-01-01 - 2026-12-31' },
                { label: '과제책임자', value: '김민준' },
                { label: '총연구비', value: '1,240,000,000원' },
            ],
        },
        {
            id: 'kg-paper-trend',
            type: 'paper',
            label: '한반도 기후변화 관측 자료의 장기 추세 분석',
            shortLabel: '추세 논문',
            dataonId: 'SCIENCEON-PAPER-2025-0312',
            source: 'ScienceON',
            pathLabel: '관련 논문',
            metadata: [
                { label: '학술지', value: 'Journal of Climate Observation' },
                { label: '발행연도', value: '2025' },
                { label: 'DOI', value: '10.1000/jco.2025.0312' },
                { label: '활용 데이터', value: '기후변화 관측 데이터' },
                { label: '인용수', value: '18' },
            ],
        },
        {
            id: 'kg-researcher-kim',
            type: 'researcher',
            label: '김민준',
            shortLabel: '김민준',
            dataonId: 'DATAON-RSR-2024-0042',
            source: '국가연구자정보',
            pathLabel: '연구자',
            metadata: [
                { label: '역할', value: '책임연구자 / 데이터 생성자' },
                { label: '소속', value: '한국기상과학원' },
                { label: '전문분야', value: '기후관측, 대기과학' },
                { label: 'ORCID', value: '0000-0002-2606-1515' },
                { label: '참여과제', value: '기후변화 적응형 관측체계 고도화 과제' },
            ],
        },
        {
            id: 'kg-organization-kma',
            type: 'organization',
            label: '한국기상과학원',
            shortLabel: '기상과학원',
            dataonId: 'DATAON-ORG-00045',
            source: 'DataON 기관 authority',
            pathLabel: '기관',
            metadata: [
                { label: '기관유형', value: '공공연구기관' },
                { label: '소재지', value: '대전광역시 유성구' },
                { label: '역할', value: '데이터 생산기관 / 과제 수행기관' },
                { label: '연계 리포지터리', value: '국가연구데이터플랫폼' },
                { label: '기관코드', value: 'ORG-KMA-045' },
            ],
        },
        {
            id: 'kg-keyword-climate',
            type: 'keyword',
            label: '기후변화',
            shortLabel: '기후변화',
            dataonId: 'DATAON-KWD-00012',
            source: 'DataON 주제어 authority',
            pathLabel: '키워드',
            metadata: [
                { label: '표준어', value: '기후변화' },
                { label: '동의어', value: 'Climate Change, 장기기후변동' },
                { label: '상위분류', value: '지구과학' },
                { label: '연결 데이터', value: '128건' },
                { label: '언어', value: 'ko/en' },
            ],
        },
        {
            id: 'kg-equipment-aws',
            type: 'equipment',
            label: 'AWS-OBS-204 자동기상관측장비',
            shortLabel: '관측장비',
            dataonId: 'DATAON-EQP-0204',
            source: '연구장비정보 연계',
            pathLabel: '기기',
            metadata: [
                { label: '장비유형', value: '자동기상관측장비' },
                { label: '관측항목', value: '기온, 강수량, 풍속, 습도' },
                { label: '설치위치', value: '태백산 관측소' },
                { label: '운영기관', value: '한국기상과학원' },
                { label: '운영시작', value: '2023-03-15' },
            ],
        },
        {
            id: 'kg-dataset-ocean',
            type: 'dataset',
            label: '해양 표층수온 장기 관측 데이터',
            shortLabel: '유사 데이터',
            dataonId: 'DATAON-DS-OCN-2025-018',
            source: 'DataON',
            pathLabel: '유사데이터',
            metadata: [
                { label: '자료유형', value: '연구데이터' },
                { label: '생성일', value: '2025-11-20' },
                { label: '주제분류', value: '해양과학 > 해양관측' },
                { label: '유사도', value: '0.86' },
                { label: '공통 키워드', value: '기후변화, 장기 관측' },
            ],
        },
        {
            id: 'kg-keyword-temperature',
            type: 'keyword',
            label: '장기기온변동',
            shortLabel: '기온변동',
            dataonId: 'DATAON-KWD-00079',
            source: 'DataON 주제어 authority',
            pathLabel: '키워드',
            metadata: [
                { label: '표준어', value: '장기기온변동' },
                { label: '동의어', value: 'Temperature Trend' },
                { label: '상위분류', value: '기후변화' },
                { label: '연결 데이터', value: '42건' },
                { label: '언어', value: 'ko/en' },
            ],
        },
    ];
    public readonly knowledgeGraphEdges: KnowledgeGraphEdge[] = [
        {
            id: 'kg-edge-project-dataset',
            source: 'kg-project-observation',
            target: 'kg-dataset-climate',
            label: '생산',
            dataonId: 'DATAON-REL-0001',
            sourceName: 'NTIS 과제-데이터 연계',
            metadata: [
                { label: '관계유형', value: '과제 산출 연구데이터' },
                { label: '검증상태', value: '큐레이터 확인' },
                { label: '생성일', value: '2026-06-04' },
            ],
        },
        {
            id: 'kg-edge-researcher-dataset',
            source: 'kg-researcher-kim',
            target: 'kg-dataset-climate',
            label: '생성',
            dataonId: 'DATAON-REL-0002',
            sourceName: 'DataON 메타데이터',
            metadata: [
                { label: '관계유형', value: '연구데이터 생성자' },
                { label: '기여역할', value: 'Data Curation, Investigation' },
                { label: '신뢰도', value: '상' },
            ],
        },
        {
            id: 'kg-edge-dataset-paper',
            source: 'kg-dataset-climate',
            target: 'kg-paper-trend',
            label: '활용',
            dataonId: 'DATAON-REL-0003',
            sourceName: 'ScienceON 인용 연계',
            metadata: [
                { label: '관계유형', value: '논문에서 데이터 활용' },
                { label: '활용위치', value: 'Methods / Dataset section' },
                { label: '연계일', value: '2026-06-10' },
            ],
        },
        {
            id: 'kg-edge-researcher-organization',
            source: 'kg-researcher-kim',
            target: 'kg-organization-kma',
            label: '소속',
            dataonId: 'DATAON-REL-0004',
            sourceName: '국가연구자정보',
            metadata: [
                { label: '관계유형', value: '연구자 소속기관' },
                { label: '부서', value: '기후관측연구센터' },
                { label: '기준일', value: '2026-06-01' },
            ],
        },
        {
            id: 'kg-edge-organization-dataset',
            source: 'kg-organization-kma',
            target: 'kg-dataset-climate',
            label: '생산',
            dataonId: 'DATAON-REL-0005',
            sourceName: 'DataON 제공처 메타데이터',
            metadata: [
                { label: '관계유형', value: '기관 데이터 생산' },
                { label: '기관역할', value: '데이터 생산기관' },
                { label: '공개상태', value: '공개' },
            ],
        },
        {
            id: 'kg-edge-dataset-keyword',
            source: 'kg-dataset-climate',
            target: 'kg-keyword-climate',
            label: '주제',
            dataonId: 'DATAON-REL-0006',
            sourceName: 'DataON 주제어 authority',
            metadata: [
                { label: '관계유형', value: '대표 키워드' },
                { label: '가중치', value: '0.94' },
                { label: '언어', value: 'ko/en' },
            ],
        },
        {
            id: 'kg-edge-equipment-dataset',
            source: 'kg-equipment-aws',
            target: 'kg-dataset-climate',
            label: '생성기기',
            dataonId: 'DATAON-REL-0007',
            sourceName: '연구장비정보 연계',
            metadata: [
                { label: '관계유형', value: '데이터 생성 장비' },
                { label: '관측주기', value: '10분' },
                { label: '검증상태', value: '장비식별자 확인' },
            ],
        },
        {
            id: 'kg-edge-dataset-similar',
            source: 'kg-dataset-climate',
            target: 'kg-dataset-ocean',
            label: '유사데이터',
            dataonId: 'DATAON-REL-0008',
            sourceName: 'DataON 의미검색',
            metadata: [
                { label: '관계유형', value: '메타데이터 유사도' },
                { label: '유사도', value: '0.86' },
                { label: '공통근거', value: '기후변화, 장기 관측, 공개 데이터' },
            ],
        },
        {
            id: 'kg-edge-project-researcher',
            source: 'kg-project-observation',
            target: 'kg-researcher-kim',
            label: '생성',
            dataonId: 'DATAON-REL-0009',
            sourceName: 'NTIS 연구책임자 정보',
            metadata: [
                { label: '관계유형', value: '과제 책임자' },
                { label: '참여기간', value: '2024-01-01 - 2026-12-31' },
                { label: '참여구분', value: '책임' },
            ],
        },
        {
            id: 'kg-edge-project-organization',
            source: 'kg-project-observation',
            target: 'kg-organization-kma',
            label: '생산',
            dataonId: 'DATAON-REL-0010',
            sourceName: 'NTIS 수행기관 정보',
            metadata: [
                { label: '관계유형', value: '과제 수행기관' },
                { label: '수행역할', value: '주관기관' },
                { label: '기관코드', value: 'ORG-KMA-045' },
            ],
        },
        {
            id: 'kg-edge-paper-researcher',
            source: 'kg-researcher-kim',
            target: 'kg-paper-trend',
            label: '생성',
            dataonId: 'DATAON-REL-0011',
            sourceName: 'ScienceON 저자 정보',
            metadata: [
                { label: '관계유형', value: '논문 저자' },
                { label: '저자순서', value: '1' },
                { label: '교신저자', value: '예' },
            ],
        },
        {
            id: 'kg-edge-paper-keyword',
            source: 'kg-paper-trend',
            target: 'kg-keyword-temperature',
            label: '주제',
            dataonId: 'DATAON-REL-0012',
            sourceName: 'ScienceON 키워드 연계',
            metadata: [
                { label: '관계유형', value: '논문 핵심 키워드' },
                { label: '가중치', value: '0.89' },
                { label: '추출방식', value: '저자 키워드' },
            ],
        },
        {
            id: 'kg-edge-equipment-organization',
            source: 'kg-equipment-aws',
            target: 'kg-organization-kma',
            label: '소속',
            dataonId: 'DATAON-REL-0013',
            sourceName: '연구장비정보 연계',
            metadata: [
                { label: '관계유형', value: '장비 운영기관' },
                { label: '운영상태', value: '운영중' },
                { label: '관리부서', value: '기후관측연구센터' },
            ],
        },
        {
            id: 'kg-edge-similar-keyword',
            source: 'kg-dataset-ocean',
            target: 'kg-keyword-climate',
            label: '주제',
            dataonId: 'DATAON-REL-0014',
            sourceName: 'DataON 주제어 authority',
            metadata: [
                { label: '관계유형', value: '대표 키워드' },
                { label: '가중치', value: '0.81' },
                { label: '언어', value: 'ko/en' },
            ],
        },
    ];
    private readonly datasetPrototypeUrl = '/assets/dataon/mock/dataon-dataset-mock-complete.json';
    private readonly mapSearchDataUrl = '/assets/dataon/mock/dataon-map-search-samples.json';
    private readonly koreaMapBounds: MapSearchBounds = {
        south: 33.0,
        north: 38.72,
        west: 124.45,
        east: 132.05,
    };
    private readonly defaultMapSearchCenter = {
        latitude: 36.3504,
        longitude: 127.3845,
    };
    private readonly mapSearchRegions: MapSearchRegion[] = [
        {
            label: '전국',
            latitude: 36.3504,
            longitude: 127.3845,
            level: 13,
            bounds: this.koreaMapBounds,
            aliases: ['대한민국', '한국', '전국'],
        },
        {
            label: '서울',
            latitude: 37.5665,
            longitude: 126.9780,
            level: 7,
            bounds: { south: 37.39, north: 37.72, west: 126.76, east: 127.20 },
            aliases: ['서울시', '서울특별시'],
        },
        {
            label: '인천',
            latitude: 37.4563,
            longitude: 126.7052,
            level: 8,
            bounds: { south: 37.25, north: 37.70, west: 126.35, east: 127.05 },
            aliases: ['인천시', '인천광역시'],
        },
        {
            label: '대전',
            latitude: 36.3504,
            longitude: 127.3845,
            level: 7,
            bounds: { south: 36.18, north: 36.50, west: 127.23, east: 127.52 },
            aliases: ['대전시', '대전광역시'],
        },
        {
            label: '세종',
            latitude: 36.4800,
            longitude: 127.2890,
            level: 8,
            bounds: { south: 36.38, north: 36.62, west: 127.15, east: 127.42 },
            aliases: ['세종시', '세종특별자치시'],
        },
        {
            label: '광주',
            latitude: 35.1595,
            longitude: 126.8526,
            level: 8,
            bounds: { south: 35.02, north: 35.27, west: 126.70, east: 127.02 },
            aliases: ['광주시', '광주광역시'],
        },
        {
            label: '대구',
            latitude: 35.8714,
            longitude: 128.6014,
            level: 8,
            bounds: { south: 35.72, north: 36.03, west: 128.42, east: 128.78 },
            aliases: ['대구시', '대구광역시'],
        },
        {
            label: '부산',
            latitude: 35.1796,
            longitude: 129.0756,
            level: 8,
            bounds: { south: 35.02, north: 35.31, west: 128.83, east: 129.27 },
            aliases: ['부산시', '부산광역시'],
        },
        {
            label: '강릉',
            latitude: 37.7519,
            longitude: 128.8761,
            level: 8,
            bounds: { south: 37.58, north: 37.88, west: 128.70, east: 129.08 },
            aliases: ['강릉시'],
        },
        {
            label: '전주',
            latitude: 35.8242,
            longitude: 127.1480,
            level: 8,
            bounds: { south: 35.70, north: 35.92, west: 126.98, east: 127.28 },
            aliases: ['전주시'],
        },
        {
            label: '제주',
            latitude: 33.4996,
            longitude: 126.5312,
            level: 8,
            bounds: { south: 33.20, north: 33.58, west: 126.15, east: 126.95 },
            aliases: ['제주시', '제주도', '제주특별자치도'],
        },
    ];
    private routerSub: any;
    private mapSearchMap: any = null;
    private mapSearchClusterer: any = null;
    private mapSearchMarkers: any[] = [];
    private mapSearchInfoWindow: any = null;
    private mapSearchUserMarker: any = null;
    private mapSearchUserAccuracyCircle: any = null;
    private mapSearchKakaoSdkPromise: Promise<void> | null = null;
    private mapSearchKakaoSdkAppKey = '';
    private mapSearchInitializationRequested = false;
    private mapSearchRouteQuery = '';
    private mapSearchAppliedRouteQuery = '';
    private lastDatasetSearchRouteState = '';

    public readonly advancedSearchPrimaryFields: DatasetSearchAdvancedField[] = [
        {
            key: 'searchTarget',
            label: '검색 대상',
            type: 'single',
            options: [
                { label: '전체', value: 'all' },
                { label: '데이터셋', value: '데이터셋' },
                { label: '소프트웨어', value: '소프트웨어' },
                { label: '제공처', value: '제공처' },
                { label: '파일', value: '파일' },
            ],
        },
        {
            key: 'subject',
            label: '주제분류',
            type: 'multi',
            options: [
                { label: '인공지능', value: '인공지능' },
                { label: '자연과학', value: '자연과학' },
                { label: '생명과학', value: '생명과학' },
                { label: '공학', value: '공학' },
                { label: '농수해양', value: '농수해양' },
            ],
        },
        {
            key: 'fileType',
            label: '파일 유형',
            type: 'multi',
            options: [
                { label: 'CSV', value: 'CSV' },
                { label: '이미지', value: '이미지' },
                { label: '문서', value: '문서' },
                { label: '영상', value: '영상' },
                { label: 'JSON', value: 'JSON' },
                { label: '압축파일', value: '압축파일' },
            ],
        },
        {
            key: 'createdYear',
            label: '생성연도',
            type: 'single',
            options: [
                { label: '최근 1년', value: 'recent1' },
                { label: '최근 3년', value: 'recent3' },
                { label: '최근 5년', value: 'recent5' },
                { label: '직접 설정', value: 'custom' },
            ],
        },
        {
            key: 'accessRight',
            label: '공개 여부',
            type: 'single',
            options: [
                { label: '전체', value: 'all' },
                { label: '공개', value: '공개' },
                { label: '제한공개', value: '제한공개' },
                { label: '비공개', value: '비공개' },
            ],
        },
    ];

    public readonly advancedSearchOrganizationFields: DatasetSearchAdvancedField[] = [
        { key: 'publisher', label: '발행기관', type: 'text', placeholder: '발행기관 입력' },
        { key: 'creator', label: '생성자', type: 'text', placeholder: '생성자 입력' },
        { key: 'contributor', label: '기여자', type: 'text', placeholder: '기여자 입력' },
        { key: 'manager', label: '담당자', type: 'text', placeholder: '담당자 입력' },
        { key: 'provider', label: '데이터 제공처', type: 'text', placeholder: '데이터 제공처 입력' },
        { key: 'repository', label: '데이터 리포지터리', type: 'text', placeholder: '데이터 리포지터리 입력' },
    ];

    public readonly advancedSearchProjectIdentityFields: DatasetSearchAdvancedField[] = [
        { key: 'projectName', label: '과제명', type: 'text', placeholder: '과제명 입력' },
        { key: 'principalInvestigator', label: '과제책임자', type: 'text', placeholder: '과제책임자 입력' },
        { key: 'performingOrganization', label: '과제수행기관', type: 'text', placeholder: '과제수행기관 입력' },
        { key: 'ministry', label: '부처', type: 'text', placeholder: '부처 입력' },
        { key: 'researcherNumber', label: '국가연구자번호', type: 'text', placeholder: '국가연구자번호 입력' },
        { key: 'ntisProjectNumber', label: 'NTIS 과제번호', type: 'text', placeholder: 'NTIS 과제번호 입력' },
    ];

    public get advancedSearchProjectFields(): DatasetSearchAdvancedField[] {
        return [...this.advancedSearchOrganizationFields, ...this.advancedSearchProjectIdentityFields];
    }

    public get advancedSearchOrganizationPrimaryFields(): DatasetSearchAdvancedField[] {
        return this.advancedSearchOrganizationFields.slice(0, 2);
    }

    public get advancedSearchOrganizationAdditionalFields(): DatasetSearchAdvancedField[] {
        return this.advancedSearchOrganizationFields.slice(2);
    }

    public get advancedSearchProjectPrimaryFields(): DatasetSearchAdvancedField[] {
        return this.getAdvancedFieldsByKeys(['projectName', 'performingOrganization', 'principalInvestigator']);
    }

    public get advancedSearchProjectAdditionalFields(): DatasetSearchAdvancedField[] {
        return this.getAdvancedFieldsByKeys(['researcherNumber', 'ntisProjectNumber', 'ministry']);
    }

    public get advancedOrganizationDraftSummary() {
        return this.getAdvancedGroupDraftSummary(this.advancedSearchOrganizationFields);
    }

    public get advancedProjectIdentifierDraftSummary() {
        return this.getAdvancedGroupDraftSummary(this.advancedSearchProjectIdentityFields);
    }

    public readonly datasetDetail: DatasetDetail = {
        datasetId: 'mock-amazon-deforestation-001',
        title: {
            ko: '아마존 산림벌채 위성영상 데이터셋',
            en: 'Amazon Deforestation Satellite Images',
        },
        summary: 'KOMPSAT 및 Sentinel-2 위성영상과 산림벌채 라벨로 구성된 영상분할·산림변화 분석용 데이터셋',
        description: {
            ko: '아마존 지역의 산림 파괴 감시를 위해 구축한 위성영상 데이터셋입니다. KOMPSAT 원본 영상, KOMPSAT 기반 이진 라벨, Sentinel-2 원본 영상, Sentinel-2 기반 이진 라벨을 포함하며 일부 샘플은 동일 위치·유사 시점 기준으로 매칭되어 있습니다.',
            en: 'A satellite imagery dataset for monitoring deforestation in the Amazon rainforest. It includes KOMPSAT imagery, binary labels, Sentinel-2 imagery, and Sentinel-2-based labels.',
        },
        badges: ['2026', '국내', '공개', 'ZIP', 'PNG', 'CC BY-NC', '한국어·영어'],
        provider: {
            name: 'GeoAI Data Society',
            repository: '국가연구데이터플랫폼',
            logo: '/assets/mock/geoai-logo.svg',
        },
        doi: '10.0000/dataon.mock.1434',
        license: {
            code: 'CC BY-NC',
            label: '저작자표시-비영리',
            url: 'https://creativecommons.org/licenses/by-nc/4.0/',
        },
        createdAt: '2026-06-04',
        updatedAt: '2026-06-10',
        stats: {
            views: 67,
            downloads: 0,
            originalLinks: 0,
            recommendations: 0,
            shares: 0,
            citations: 0,
        },
        creators: [
            {
                nameKo: '박강현',
                nameEn: 'Ganghyun Park',
                organizationKo: '한국항공우주연구원',
                organizationEn: 'Korea Aerospace Research Institute',
                role: '생성자',
            },
            {
                nameKo: '이돈구',
                nameEn: 'Dongoo Lee',
                organizationKo: '한국기술교육대학교',
                organizationEn: 'Korea University of Technology and Education',
                role: '생성자',
            },
            {
                nameKo: '최연주',
                nameEn: 'Yeonju Choi',
                organizationKo: '국방대학교',
                organizationEn: 'Korea National Defense University',
                role: '생성자',
            },
        ],
        keywords: [
            '위성정보',
            '아리랑 위성',
            'Sentinel-2',
            '아마존',
            '산림벌채',
            '영상분할',
            '인공지능',
            'Satellite Imagery',
            'Deforestation',
            'Image Segmentation',
        ],
        classification: {
            nationalScienceTechnologyCode: 'EE0108',
            nationalScienceTechnologyLabel: '인공지능',
            subject: '생명과학',
            domesticOrInternational: '국내',
        },
        composition: {
            totalFiles: 2297,
            totalSamples: 679,
            groups: [
                { key: 'Amazon_K3', label: 'KOMPSAT 원본 영상', count: 679 },
                { key: 'Amazon_K3_label', label: 'KOMPSAT 이진 라벨', count: 679 },
                { key: 'Amazon_Sen2', label: 'Sentinel-2 원본 영상', count: 448 },
                { key: 'Amazon_Sen2_label', label: 'Sentinel-2 이진 라벨', count: 491 },
            ],
            pairing: {
                fullyPaired: 448,
                kompsatAndSen2LabelOnly: 43,
                kompsatOnly: 188,
            },
        },
        preview: {
            defaultFileId: 'file-001',
            viewerType: 'image',
            supportedActions: ['zoomIn', 'zoomOut', 'fitToScreen', 'rotate', 'fullScreen', 'previous', 'next'],
        },
        files: [
            {
                id: 'folder-root',
                type: 'folder',
                name: 'Amazon_deforestation_dataset',
                children: 4,
            },
            {
                id: 'file-001',
                type: 'image',
                folder: 'Amazon_K3',
                name: '001_K3_20200729171647_43752_20760968_-54.58_-4.29.png',
                extension: 'png',
                size: '8.4 MB',
                resolution: '3631 x 3631',
                capturedAt: '2020-07-29 17:16:47',
                coordinates: {
                    longitude: -54.58,
                    latitude: -4.29,
                },
                previewUrl: '/assets/mock/amazon-k3-001.png',
            },
            {
                id: 'file-002',
                type: 'image',
                folder: 'Amazon_K3_label',
                name: '001_K3_label_20200729171647_43752_20760968_-54.58_-4.29.png',
                extension: 'png',
                size: '1.2 MB',
                resolution: '3631 x 3631',
                coordinates: {
                    longitude: -54.58,
                    latitude: -4.29,
                },
                previewUrl: '/assets/mock/amazon-k3-label-001.png',
            },
            {
                id: 'file-003',
                type: 'image',
                folder: 'Amazon_Sen2',
                name: '001_S2_20200729_-54.58_-4.29.png',
                extension: 'png',
                size: '4.1 MB',
                resolution: '3631 x 3631',
                capturedAt: '2020-07-29',
                coordinates: {
                    longitude: -54.58,
                    latitude: -4.29,
                },
                previewUrl: '/assets/mock/amazon-sen2-001.png',
            },
            {
                id: 'file-004',
                type: 'image',
                folder: 'Amazon_Sen2_label',
                name: '001_S2_label_20200729_-54.58_-4.29.png',
                extension: 'png',
                size: '0.9 MB',
                resolution: '3631 x 3631',
                coordinates: {
                    longitude: -54.58,
                    latitude: -4.29,
                },
                previewUrl: '/assets/mock/amazon-sen2-label-001.png',
            },
            {
                id: 'file-005',
                type: 'archive',
                folder: '/',
                name: 'Amazon_deforestation_dataset_v20260601.zip',
                extension: 'zip',
                size: '8.6 GB',
                previewAvailable: false,
            },
        ],
        relatedProject: {
            titleKo: '위성정보활용',
            titleEn: 'Satellite Data Applications',
            year: 2025,
            ministry: '우주항공청',
            organization: '한국항공우주연구원',
            principalInvestigator: {
                nameKo: '이선구',
                nameEn: 'Sun-Gu Lee',
            },
            relationship: '관련',
        },
        relations: {
            nodes: [
                { id: 'dataset', type: 'dataset', label: '아마존 산림벌채 데이터셋' },
                { id: 'creator-1', type: 'person', label: '박강현' },
                { id: 'creator-2', type: 'person', label: '이돈구' },
                { id: 'creator-3', type: 'person', label: '최연주' },
                { id: 'project', type: 'project', label: '위성정보활용' },
                { id: 'organization', type: 'organization', label: '한국항공우주연구원' },
                { id: 'repository', type: 'repository', label: '국가연구데이터플랫폼' },
            ],
            edges: [
                { source: 'creator-1', target: 'dataset', label: '데이터생산자' },
                { source: 'creator-2', target: 'dataset', label: '데이터생산자' },
                { source: 'creator-3', target: 'dataset', label: '데이터생산자' },
                { source: 'project', target: 'dataset', label: '프로젝트생산물' },
                { source: 'organization', target: 'project', label: '과제수행기관' },
                { source: 'repository', target: 'dataset', label: '데이터리포지터리' },
            ],
        },
        citation: {
            apa: 'Park, G., Lee, D., & Choi, Y. (2026). Amazon Deforestation Satellite Images. DataON.',
            bibtex: '@misc{dataon_mock_1434,\n  title={Amazon Deforestation Satellite Images},\n  author={Ganghyun Park and Dongoo Lee and Yeonju Choi},\n  year={2026},\n  doi={10.0000/dataon.mock.1434}\n}',
        },
        aiRecommendations: [
            {
                type: 'paper',
                title: 'KOMPSAT 위성 기반 영상 향상 기법에 따른 Semantic Segmentation 모델 성능 분석',
                source: 'ScienceON',
                similarity: 0.92,
            },
            {
                type: 'dataset',
                title: 'Landsat-5/-7/-8 및 Sentinel-2 광학 위성영상을 활용한 천지호 GeoAI 데이터셋',
                source: 'DataON',
                similarity: 0.87,
            },
        ],
        ui: {
            tabs: [
                { id: 'overview', label: '개요' },
                { id: 'files', label: '파일·미리보기' },
                { id: 'metadata', label: '메타데이터' },
                { id: 'relations', label: '연관정보' },
                { id: 'citation', label: '인용·활용' },
            ],
            primaryActions: ['파일 미리보기', '바로 분석', '마이드라이브 저장', '다운로드'],
        },
    };

    private readonly officialCapturedDatasetSearchResults: DatasetSearchResult[] = [
        {
            id: 'official-resonance-001',
            title: '공명과 비가역성을 통한 물질 형성의 재해석',
            titleEn: '[Research 25] "A Reinterpretation of Matter Formation through Resonance and Irreversibility"',
            summary: '본 연구는 절대온도(0 K)를 기준으로 우주의 구조와 물질 형성 과정을 해석하는 절대온도 전자기 회전 공명 우주론(EMRR)을 제안한다. 본 이론에서 공명은 물질과 에너지에 선행하는 근원적 균형 상태이며, 우주배경복사온도 범위를 공명의 평형 영역으로 해석한다.',
            path: '/search/datasets/detail',
            provider: '국가연구데이터플랫폼',
            repository: 'DataON',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2026-06-25',
            updatedAt: '2026-06-25',
            creators: ['전'],
            managers: ['DataON'],
            keywords: ['공명', '비가역성', '물질 형성', '우주론', '전자기 회전'],
            badges: ['2026', '국내', '공개', 'pdf', 'Korean'],
            fileTypes: ['pdf'],
            license: 'CC BY',
            dataType: '데이터셋',
            createdYear: '2026',
            domesticOrInternational: '국내',
            subject: '지구과학(지구/대기/해양/천문);',
            publisher: '국가연구데이터플랫폼',
            contributors: ['DataON'],
            projectName: 'Research 25',
            principalInvestigator: '전',
            performingOrganization: '국가연구데이터플랫폼',
            ministry: '과학기술정보통신부',
            researcherNumber: '10.22711/idr/1445',
            ntisProjectNumber: '1.1.0',
            totalFiles: 1,
            totalSamples: 1,
            views: 0,
            downloads: 0,
        },
        {
            id: 'official-bigbang-002',
            title: '빅뱅 및 허블상수의 전자기 회전공명 우주론적 재해석',
            titleEn: '[Research 24] "Reinterpreting the Big Bang and the Hubble Constant within the Framework of Electromagnetic Rotational Resonance Cosmology"',
            summary: '본 연구는 빅뱅 우주론의 핵심 전제인 특이점(singularity)과 허블상수 해석이 지니는 근본적 한계를 재검토한다. 특이점은 무한 밀도를 전제로 하나 물리적으로 비실재적인 수학적 발상이며, 허블상수 역시 관측 방법에 따라 상이한 값을 보이는 허블 텐션 문제를 통해 기존 해석의 불완전성을 드러내고 있다.',
            path: '/search/datasets/detail',
            provider: '국가연구데이터플랫폼',
            repository: 'DataON',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2026-06-24',
            updatedAt: '2026-06-24',
            creators: ['전'],
            managers: ['DataON'],
            keywords: ['빅뱅', '허블상수', '전자기 회전공명', '우주론', '허블 텐션'],
            badges: ['2026', '국내', '공개', 'pdf', 'Korean'],
            fileTypes: ['pdf'],
            license: 'CC BY',
            dataType: '데이터셋',
            createdYear: '2026',
            domesticOrInternational: '국내',
            subject: '지구과학(지구/대기/해양/천문);',
            publisher: '국가연구데이터플랫폼',
            contributors: ['DataON'],
            projectName: 'Research 24',
            principalInvestigator: '전',
            performingOrganization: '국가연구데이터플랫폼',
            ministry: '과학기술정보통신부',
            researcherNumber: '10.22711/idr/1444',
            ntisProjectNumber: '1.1.0',
            totalFiles: 1,
            totalSamples: 1,
            views: 0,
            downloads: 0,
        },
        {
            id: 'official-blackhole-003',
            title: '블랙홀의 선행업 연구',
            titleEn: '[Research 23] "A Prior Study on Black Holes"',
            summary: '블랙홀 형성과 중력 붕괴 과정의 기존 해석을 재검토하고, 우주 구조의 형성과 에너지 상태 변화를 공명 기반 관점에서 정리한 연구자료이다.',
            path: '/search/datasets/detail',
            provider: '국가연구데이터플랫폼',
            repository: 'DataON',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2026-06-23',
            updatedAt: '2026-06-23',
            creators: ['전'],
            managers: ['DataON'],
            keywords: ['블랙홀', '우주론', '공명', '중력', '천문'],
            badges: ['2026', '국내', '공개', 'pdf', 'Korean'],
            fileTypes: ['pdf'],
            license: 'CC BY',
            dataType: '데이터셋',
            createdYear: '2026',
            domesticOrInternational: '국내',
            subject: '지구과학(지구/대기/해양/천문);',
            publisher: '국가연구데이터플랫폼',
            contributors: ['DataON'],
            projectName: 'Research 23',
            principalInvestigator: '전',
            performingOrganization: '국가연구데이터플랫폼',
            ministry: '과학기술정보통신부',
            researcherNumber: '10.22711/idr/1443',
            ntisProjectNumber: '1.1.0',
            totalFiles: 1,
            totalSamples: 1,
            views: 0,
            downloads: 0,
        },
    ];

    private readonly supplementalDatasetSearchResults: DatasetSearchResult[] = [
        {
            id: 'sample-air-quality-001',
            title: '수도권 미세먼지 이동 관측 데이터',
            titleEn: 'Seoul Metropolitan Air Quality Transport Observations',
            summary: '수도권 대기질 관측망의 시간대별 PM2.5, PM10, 풍향, 풍속 관측 데이터',
            path: '/search/datasets/detail',
            provider: '국립환경과학원',
            repository: '환경데이터 리포지터리',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2025-12-18',
            updatedAt: '2026-05-28',
            creators: ['이민정(국립환경과학원)', '박서준(서울시립대학교)'],
            managers: ['환경데이터센터'],
            keywords: ['대기질', '미세먼지', 'PM2.5', 'PM10', '관측망', '수도권'],
            badges: ['2025', '국내', '공개', 'CSV', 'JSON'],
            fileTypes: ['CSV', 'JSON'],
            license: 'CC BY',
            dataType: '데이터셋',
            createdYear: '2025',
            domesticOrInternational: '국내',
            subject: '환경',
            publisher: '국립환경과학원',
            contributors: ['서울시 보건환경연구원'],
            projectName: '수도권 대기오염 이동 특성 분석',
            principalInvestigator: '이민정',
            performingOrganization: '국립환경과학원',
            ministry: '환경부',
            researcherNumber: 'R-2025-0008120',
            ntisProjectNumber: 'NTIS-2025-AIR-8120',
            totalFiles: 48,
            totalSamples: 360000,
            views: 412,
            downloads: 342,
        },
        {
            id: 'sample-urban-heat-002',
            title: '도시 열섬 위성영상 분석 데이터',
            titleEn: 'Urban Heat Island Satellite Image Analysis Dataset',
            summary: '도심 열섬 분석을 위한 지표면 온도와 토지피복 위성영상 패치 데이터',
            path: '/search/datasets/detail',
            provider: '한국건설기술연구원',
            repository: '도시기후 데이터허브',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2026-02-14',
            updatedAt: '2026-06-02',
            creators: ['정다은(한국건설기술연구원)', '최현우(연세대학교)'],
            managers: ['도시기후 데이터허브'],
            keywords: ['열섬', '위성영상', '지표면온도', '토지피복', '도시'],
            badges: ['2026', '국내', '공개', 'GeoTIFF', 'PNG'],
            fileTypes: ['TIF', 'PNG', 'CSV'],
            license: 'CC BY-NC',
            dataType: '데이터셋',
            createdYear: '2026',
            domesticOrInternational: '국내',
            subject: '환경',
            publisher: '한국건설기술연구원',
            contributors: ['기상청', '국토연구원'],
            projectName: '위성 기반 도시 열환경 정밀 분석',
            principalInvestigator: '정다은',
            performingOrganization: '한국건설기술연구원',
            ministry: '국토교통부',
            researcherNumber: 'R-2026-0002061',
            ntisProjectNumber: 'NTIS-2026-UHI-2061',
            totalFiles: 126,
            totalSamples: 42000,
            views: 351,
            downloads: 201,
        },
        {
            id: 'sample-traffic-003',
            title: '세종 스마트시티 교통량 센서 데이터',
            titleEn: 'Sejong Smart City Traffic Sensor Dataset',
            summary: '스마트시티 도로 구간별 교통량, 평균 속도, 정체 지표 센서 데이터',
            path: '/search/datasets/detail',
            provider: '세종특별자치시',
            repository: '스마트시티 데이터허브',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2024-11-01',
            updatedAt: '2026-04-15',
            creators: ['김태훈(세종특별자치시)', '오지은(한국교통연구원)'],
            managers: ['스마트시티 데이터허브'],
            keywords: ['스마트시티', '교통량', '센서', '도로', '정체', '세종'],
            badges: ['2024', '국내', '공개', 'CSV', 'API'],
            fileTypes: ['CSV', 'JSON'],
            license: '공공누리 1유형',
            dataType: '데이터셋',
            createdYear: '2024',
            domesticOrInternational: '국내',
            subject: '건설/교통',
            publisher: '세종특별자치시',
            contributors: ['한국교통연구원'],
            projectName: '스마트시티 교통 디지털 트윈 구축',
            principalInvestigator: '김태훈',
            performingOrganization: '세종특별자치시',
            ministry: '국토교통부',
            researcherNumber: 'R-2024-0006421',
            ntisProjectNumber: 'NTIS-2024-TRF-6421',
            totalFiles: 92,
            totalSamples: 820000,
            views: 538,
            downloads: 415,
        },
        {
            id: 'sample-ocean-004',
            title: '인천 연안 해수면 관측 데이터',
            titleEn: 'Incheon Coastal Sea Level Observation Dataset',
            summary: '인천 연안 조위, 해수면 온도, 염분, 파고 관측 데이터',
            path: '/search/datasets/detail',
            provider: '국립해양조사원',
            repository: '해양수산 연구데이터센터',
            searchTarget: '데이터셋',
            accessRight: '제한공개',
            createdAt: '2025-07-22',
            updatedAt: '2026-01-19',
            creators: ['한유진(국립해양조사원)', '송민규(인하대학교)'],
            managers: ['해양수산 연구데이터센터'],
            keywords: ['해양', '조위', '해수면', '염분', '파고', '인천'],
            badges: ['2025', '국내', '제한공개', 'CSV'],
            fileTypes: ['CSV', 'TXT'],
            license: '기관 승인 후 이용',
            dataType: '데이터셋',
            createdYear: '2025',
            domesticOrInternational: '국내',
            subject: '지구과학',
            publisher: '국립해양조사원',
            contributors: ['인하대학교 해양과학과'],
            projectName: '연안 해수면 변동성 장기 관측',
            principalInvestigator: '한유진',
            performingOrganization: '국립해양조사원',
            ministry: '해양수산부',
            researcherNumber: 'R-2025-0005198',
            ntisProjectNumber: 'NTIS-2025-SEA-5198',
            totalFiles: 36,
            totalSamples: 180000,
            views: 224,
            downloads: 121,
        },
        {
            id: 'sample-flood-005',
            title: '대구 도시 침수 시뮬레이션 데이터',
            titleEn: 'Daegu Urban Flood Simulation Dataset',
            summary: '집중호우 조건별 도시 침수 깊이와 유속을 격자 형태로 산출한 데이터',
            path: '/search/datasets/detail',
            provider: '국립재난안전연구원',
            repository: '재난안전 데이터뱅크',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2025-09-06',
            updatedAt: '2026-03-11',
            creators: ['문성호(국립재난안전연구원)', '권나래(경북대학교)'],
            managers: ['재난안전 데이터뱅크'],
            keywords: ['침수', '재난', '홍수', '시뮬레이션', '유속', '대구'],
            badges: ['2025', '국내', '공개', 'NetCDF', 'CSV'],
            fileTypes: ['CSV', 'NC', 'JSON'],
            license: 'CC BY',
            dataType: '데이터셋',
            createdYear: '2025',
            domesticOrInternational: '국내',
            subject: '건설/교통',
            publisher: '국립재난안전연구원',
            contributors: ['경북대학교 수자원연구실'],
            projectName: '도시 침수 위험 예측 모델 고도화',
            principalInvestigator: '문성호',
            performingOrganization: '국립재난안전연구원',
            ministry: '행정안전부',
            researcherNumber: 'R-2025-0003009',
            ntisProjectNumber: 'NTIS-2025-FLD-3009',
            totalFiles: 58,
            totalSamples: 96000,
            views: 287,
            downloads: 144,
        },
        {
            id: 'sample-agri-006',
            title: '전주 농업기상 관측 데이터',
            titleEn: 'Jeonju Agro-Meteorological Observation Dataset',
            summary: '작물 생육 모델 검증을 위한 기온, 일사량, 토양수분 농업기상 데이터',
            path: '/search/datasets/detail',
            provider: '농촌진흥청',
            repository: '농업과학 데이터센터',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2024-04-30',
            updatedAt: '2025-12-04',
            creators: ['장보라(농촌진흥청)', '임재훈(전북대학교)'],
            managers: ['농업과학 데이터센터'],
            keywords: ['농업기상', '작물', '토양수분', '일사량', '생육', '전주'],
            badges: ['2024', '국내', '공개', 'CSV'],
            fileTypes: ['CSV', 'XLSX'],
            license: 'CC BY',
            dataType: '데이터셋',
            createdYear: '2024',
            domesticOrInternational: '국내',
            subject: '농림수산식품',
            publisher: '농촌진흥청',
            contributors: ['전북대학교 농생명과학대학'],
            projectName: '작물 생육 예측을 위한 농업기상 관측망',
            principalInvestigator: '장보라',
            performingOrganization: '농촌진흥청',
            ministry: '농림축산식품부',
            researcherNumber: 'R-2024-0002338',
            ntisProjectNumber: 'NTIS-2024-AGR-2338',
            totalFiles: 44,
            totalSamples: 260000,
            views: 198,
            downloads: 132,
        },
        {
            id: 'sample-software-canvas-001',
            title: 'CANVAS 위성영상 분류 워크플로우',
            titleEn: 'CANVAS Satellite Image Classification Workflow',
            summary: 'DataON CANVAS에서 위성영상 전처리, 학습, 추론 단계를 실행할 수 있는 분석 워크플로우',
            path: '/analysis/software/canvas-satellite-workflow',
            provider: '한국과학기술정보연구원',
            repository: 'CANVAS Software Registry',
            searchTarget: '소프트웨어',
            accessRight: '공개',
            createdAt: '2026-03-22',
            updatedAt: '2026-06-12',
            creators: ['DataON 분석서비스팀'],
            managers: ['CANVAS 운영자'],
            keywords: ['CANVAS', '워크플로우', '위성영상', 'Python', '분류', '인공지능'],
            badges: ['2026', '국내', '공개', 'Workflow', 'Python'],
            fileTypes: ['JSON', 'PY'],
            license: 'Apache-2.0',
            dataType: '소프트웨어',
            createdYear: '2026',
            domesticOrInternational: '국내',
            subject: '정보/통신',
            publisher: '한국과학기술정보연구원',
            contributors: ['한국항공우주연구원'],
            projectName: '연구데이터 분석환경 고도화',
            principalInvestigator: 'DataON 운영자',
            performingOrganization: '한국과학기술정보연구원',
            ministry: '과학기술정보통신부',
            researcherNumber: 'SW-2026-0001',
            ntisProjectNumber: 'NTIS-2026-SW-0001',
            totalFiles: 14,
            totalSamples: 3,
            views: 684,
            downloads: 221,
        },
        {
            id: 'sample-software-jupyter-002',
            title: 'JupyterLab 기후자료 시각화 템플릿',
            titleEn: 'JupyterLab Climate Data Visualization Template',
            summary: '기후 관측 CSV와 NetCDF 파일을 불러와 지도, 시계열, 이상값을 확인하는 노트북 템플릿',
            path: '/analysis/software/jupyter-climate-template',
            provider: '한국기상산업기술원',
            repository: 'CANVAS Software Registry',
            searchTarget: '소프트웨어',
            accessRight: '공개',
            createdAt: '2025-10-08',
            updatedAt: '2026-05-18',
            creators: ['기후데이터 분석 커뮤니티'],
            managers: ['CANVAS 운영자'],
            keywords: ['JupyterLab', '기후변화', '시각화', 'NetCDF', 'Python', '강수량'],
            badges: ['2025', '국내', '공개', 'Notebook'],
            fileTypes: ['IPYNB', 'PY'],
            license: 'MIT',
            dataType: '소프트웨어',
            createdYear: '2025',
            domesticOrInternational: '국내',
            subject: '지구과학',
            publisher: '한국기상산업기술원',
            contributors: ['한국과학기술정보연구원'],
            projectName: '기후자료 활용 분석 템플릿 구축',
            principalInvestigator: '김하늘',
            performingOrganization: '한국기상산업기술원',
            ministry: '환경부',
            researcherNumber: 'SW-2025-0108',
            ntisProjectNumber: 'NTIS-2025-CLM-SW',
            totalFiles: 9,
            totalSamples: 5,
            views: 472,
            downloads: 188,
        },
        {
            id: 'sample-software-metadata-003',
            title: '연구데이터 메타데이터 품질 점검 도구',
            titleEn: 'Research Data Metadata Quality Checker',
            summary: '데이터셋 제목, 키워드, 라이선스, 파일 형식 입력 누락을 자동 점검하는 검증 도구',
            path: '/analysis/software/metadata-quality-checker',
            provider: 'DataON',
            repository: 'Software 검색',
            searchTarget: '소프트웨어',
            accessRight: '공개',
            createdAt: '2024-12-15',
            updatedAt: '2026-01-30',
            creators: ['DataON 큐레이션 담당자'],
            managers: ['DataON 운영자'],
            keywords: ['메타데이터', '품질점검', '검증', '등록', '소프트웨어'],
            badges: ['2024', '국내', '공개', 'CLI'],
            fileTypes: ['PY', 'JSON'],
            license: 'BSD-3-Clause',
            dataType: '소프트웨어',
            createdYear: '2024',
            domesticOrInternational: '국내',
            subject: '정보/통신',
            publisher: 'DataON',
            contributors: ['한국과학기술정보연구원'],
            projectName: 'DataON 데이터 등록 품질 개선',
            principalInvestigator: '정유림',
            performingOrganization: '한국과학기술정보연구원',
            ministry: '과학기술정보통신부',
            researcherNumber: 'SW-2024-1215',
            ntisProjectNumber: 'NTIS-2024-META-SW',
            totalFiles: 11,
            totalSamples: 4,
            views: 319,
            downloads: 97,
        },
        {
            id: 'sample-provider-kasi-001',
            title: '한국천문연구원 제공처',
            titleEn: 'Korea Astronomy and Space Science Institute Provider',
            summary: '천문 관측, 우주환경, 망원경 관측자료를 제공하는 DataON 국내 연계 제공처',
            path: '/search/providers/kasi',
            provider: '한국천문연구원',
            repository: 'DataON 제공처',
            searchTarget: '제공처',
            accessRight: '공개',
            createdAt: '2026-01-01',
            updatedAt: '2026-06-01',
            creators: ['한국천문연구원'],
            managers: ['DataON 연계기관 담당자'],
            keywords: ['제공처', '천문학', '우주환경', '망원경', '국내 제공기관'],
            badges: ['국내', '제공처', '천문학'],
            fileTypes: ['CSV', 'FITS'],
            license: '기관별 정책',
            dataType: '제공처',
            createdYear: '2026',
            domesticOrInternational: '국내',
            subject: '물리학',
            publisher: '한국천문연구원',
            contributors: ['DataON'],
            projectName: '국내 연구데이터 제공처 연계',
            principalInvestigator: '연계기관 담당자',
            performingOrganization: '한국천문연구원',
            ministry: '과학기술정보통신부',
            researcherNumber: 'PROVIDER-KASI',
            ntisProjectNumber: 'PROVIDER-2026-KASI',
            totalFiles: 3019486,
            totalSamples: 3019486,
            views: 1458,
            downloads: 0,
        },
        {
            id: 'sample-provider-kisti-002',
            title: '한국과학기술정보연구원 제공처',
            titleEn: 'KISTI DataON Provider',
            summary: '과학기술 전 분야 연구데이터, 분석 서비스, API 활용 데이터를 제공하는 DataON 운영기관',
            path: '/search/providers/kisti',
            provider: '한국과학기술정보연구원',
            repository: '국가연구데이터플랫폼',
            searchTarget: '제공처',
            accessRight: '공개',
            createdAt: '2026-01-01',
            updatedAt: '2026-06-10',
            creators: ['한국과학기술정보연구원'],
            managers: ['DataON 운영자'],
            keywords: ['KISTI', 'DataON', '제공처', 'Open API', 'MCP', '과학기술'],
            badges: ['국내', '제공처', '과학기술 전분야'],
            fileTypes: ['CSV', 'JSON', 'API'],
            license: '기관별 정책',
            dataType: '제공처',
            createdYear: '2026',
            domesticOrInternational: '국내',
            subject: '정보/통신',
            publisher: '한국과학기술정보연구원',
            contributors: ['DataON'],
            projectName: '국가연구데이터플랫폼 운영',
            principalInvestigator: 'DataON 운영자',
            performingOrganization: '한국과학기술정보연구원',
            ministry: '과학기술정보통신부',
            researcherNumber: 'PROVIDER-KISTI',
            ntisProjectNumber: 'PROVIDER-2026-KISTI',
            totalFiles: 501,
            totalSamples: 379,
            views: 2094,
            downloads: 0,
        },
        {
            id: 'sample-provider-openaire-003',
            title: 'OpenAIRE 제공처',
            titleEn: 'OpenAIRE Provider',
            summary: '유럽 연구데이터, 출판물, 프로젝트 정보를 연계하는 글로벌 오픈사이언스 제공처',
            path: '/search/providers/openaire',
            provider: 'OpenAIRE',
            repository: 'Global Repository',
            searchTarget: '제공처',
            accessRight: '공개',
            createdAt: '2025-01-01',
            updatedAt: '2026-04-20',
            creators: ['OpenAIRE'],
            managers: ['Global DataON 연계 담당자'],
            keywords: ['OpenAIRE', '글로벌', '제공처', '오픈사이언스', '국외 제공기관'],
            badges: ['국외', '제공처', '오픈사이언스'],
            fileTypes: ['XML', 'JSON', 'API'],
            license: '기관별 정책',
            dataType: '제공처',
            createdYear: '2025',
            domesticOrInternational: '국외',
            subject: '전분야',
            publisher: 'OpenAIRE',
            contributors: ['DataON'],
            projectName: '국외 연구데이터 제공처 연계',
            principalInvestigator: 'OpenAIRE',
            performingOrganization: 'OpenAIRE',
            ministry: 'Global',
            researcherNumber: 'PROVIDER-OPENAIRE',
            ntisProjectNumber: 'PROVIDER-2025-OPENAIRE',
            totalFiles: 3839287,
            totalSamples: 3839287,
            views: 1728,
            downloads: 0,
        },
        {
            id: 'sample-issue-covid-001',
            title: '코로나19 지역별 확진자 및 보건의료 대응 데이터',
            titleEn: 'COVID-19 Regional Cases and Healthcare Response Dataset',
            summary: '코로나 바이러스 확진자 추이, 의료자원, 감염병 대응 지표를 지역 단위로 정리한 데이터',
            path: '/search/datasets/detail',
            provider: '질병관리청',
            repository: '보건의료 연구데이터센터',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2024-08-21',
            updatedAt: '2026-02-18',
            creators: ['감염병 데이터 분석팀'],
            managers: ['보건의료 연구데이터센터'],
            keywords: ['코로나', '코로나19', 'COVID-19', '감염병', '확진자', '백신', '보건의료'],
            badges: ['국내', '공개', '이슈&데이터', 'CSV'],
            fileTypes: ['CSV', 'XLSX'],
            license: '공공누리 1유형',
            dataType: '데이터셋',
            createdYear: '2024',
            domesticOrInternational: '국내',
            subject: '보건의료',
            publisher: '질병관리청',
            contributors: ['국립보건연구원'],
            projectName: '감염병 대응 데이터 활용 기반 구축',
            principalInvestigator: '이수진',
            performingOrganization: '질병관리청',
            ministry: '보건복지부',
            researcherNumber: 'R-2024-COVID',
            ntisProjectNumber: 'NTIS-2024-COVID-001',
            totalFiles: 62,
            totalSamples: 125000,
            views: 901,
            downloads: 512,
        },
        {
            id: 'sample-issue-gpcc-001',
            title: 'GPCC 전지구 강수량 격자 데이터',
            titleEn: 'GPCC Global Precipitation Climatology Centre Gridded Data',
            summary: 'GPCC 월별 강수량 격자와 수문 분석 보조 변수를 활용한 기후변화 연구 데이터',
            path: '/search/datasets/detail',
            provider: 'Global Precipitation Climatology Centre',
            repository: 'Climate Data Repository',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2025-03-04',
            updatedAt: '2026-03-28',
            creators: ['GPCC'],
            managers: ['기후데이터 연계 담당자'],
            keywords: ['GPCC', '강수량', '기후', '기후변화', '수문', '격자 데이터', 'precipitation'],
            badges: ['국외', '공개', '이슈&데이터', 'NetCDF'],
            fileTypes: ['NC', 'CSV'],
            license: 'CC BY',
            dataType: '데이터셋',
            createdYear: '2025',
            domesticOrInternational: '국외',
            subject: '지구과학',
            publisher: 'GPCC',
            contributors: ['DataON'],
            projectName: '글로벌 기후자료 연계',
            principalInvestigator: 'Climate Data Curator',
            performingOrganization: 'Global Precipitation Climatology Centre',
            ministry: 'Global',
            researcherNumber: 'R-2025-GPCC',
            ntisProjectNumber: 'GLOBAL-2025-GPCC',
            totalFiles: 24,
            totalSamples: 720,
            views: 636,
            downloads: 307,
        },
        {
            id: 'sample-issue-kaggle-001',
            title: 'Kaggle 흉부 X-ray 폐렴 학습 데이터 메타정보',
            titleEn: 'Kaggle Chest X-Ray Pneumonia Training Data Metadata',
            summary: 'Kaggle 공개 학습데이터의 인공지능 모델 학습, 검증, 경진대회 활용을 위한 메타데이터',
            path: '/search/datasets/detail',
            provider: 'Kaggle',
            repository: 'Kaggle Open Dataset',
            searchTarget: '데이터셋',
            accessRight: '공개',
            createdAt: '2025-06-16',
            updatedAt: '2026-05-05',
            creators: ['Kaggle Community'],
            managers: ['DataON 글로벌 연계 담당자'],
            keywords: ['Kaggle', '머신러닝', '인공지능', '경진대회', '학습데이터', 'X-ray', '의료영상'],
            badges: ['국외', '공개', '이슈&데이터', 'AI'],
            fileTypes: ['CSV', 'PNG'],
            license: 'Kaggle Dataset License',
            dataType: '데이터셋',
            createdYear: '2025',
            domesticOrInternational: '국외',
            subject: '보건의료',
            publisher: 'Kaggle',
            contributors: ['DataON'],
            projectName: '글로벌 AI 학습데이터 메타정보 연계',
            principalInvestigator: 'Kaggle Community',
            performingOrganization: 'Kaggle',
            ministry: 'Global',
            researcherNumber: 'R-2025-KAGGLE',
            ntisProjectNumber: 'GLOBAL-2025-KAGGLE',
            totalFiles: 2,
            totalSamples: 5856,
            views: 774,
            downloads: 429,
        },
    ];

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private ref: ChangeDetectorRef,@Inject( Router)  private router: Router) {
        this.currentLanguage = this.getInitialLanguage();
        this.applyLanguage(this.currentLanguage, false);
        this.setCurrentPage(this.resolveCurrentPath(window.location.pathname + window.location.search));
        this.installHistoryRouteSync();
        window.addEventListener('dataon-locationchange', this.handleHistoryRouteChange);
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                await this.syncCurrentRoute(event.urlAfterRedirects || event.url);
            }
        });
    }

    public get menuOpen() {
        return this.mobileMenuOpen || this.sitemapOpen;
    }

    public get quickMenuFollowOffsetStyle() {
        return `${this.quickMenuFollowOffset}px`;
    }

    public get selectedMenu() {
        return this.navItems[this.selectedMenuIndex] || this.navItems[0];
    }

    public get selectedMenuSections() {
        return this.getMenuSections(this.selectedMenu);
    }

    public get currentServicePage() {
        return this.findServicePageByPath(this.currentPath);
    }

    public get isServicePage() {
        return Boolean(this.currentServicePage);
    }

    public get currentServiceBreadcrumb() {
        const page = this.currentServicePage;
        if (!page) return ['HOME', '서비스'];
        return page.category === '서비스'
            ? ['HOME', '서비스']
            : ['HOME', '서비스', page.category, page.label];
    }

    public get currentServiceLoginFeatures() {
        const page = this.currentServicePage;
        if (!page) return [];

        if (page.id === 'open-api' || page.id === 'api-apply') {
            return [
                'API 이용신청',
                '인증키 발급',
                '연구데이터 검색 API',
                '연구데이터 메타정보 상세조회 API',
            ];
        }

        if (page.id === 'community-my' || page.id === 'community-list') {
            return [
                '전체 커뮤니티 검색',
                '가입 신청',
                '나의 커뮤니티 확인',
                '커뮤니티 생성 및 회원 관리',
            ];
        }

        return [
            '기관 데이터관리자 신청',
            '신청/승인 상태 확인',
            '기관 저장소 관리',
            '호스팅 서비스 관리',
        ];
    }

    public get currentServiceOfficialUrl() {
        const page = this.currentServicePage;
        return this.getOfficialDataonUrl(page?.officialPath || '/');
    }

    public isCurrentServicePath(path: string) {
        const current = this.currentServicePage;
        return Boolean(current && this.normalizePath(current.path) === this.normalizePath(path));
    }

    public getOfficialDataonUrl(path: string = '/') {
        if (path === '#') return '#';
        if (/^(https?:)?\/\//.test(path)) return path;
        const normalized = path.startsWith('/') ? path : `/${path}`;
        return `https://dataon.kisti.re.kr${normalized}`;
    }

    public get isSubmitRootPage() {
        return this.currentPath === '/submit';
    }

    public get isSubmitManagePage() {
        return this.currentPath === '/submit/manage';
    }

    public get isSubmitStatisticsPage() {
        return this.currentPath === '/submit/statistics';
    }

    public get isSubmitApprovalPage() {
        return this.currentPath === '/submit/approval';
    }

    public get canManageSubmitApproval() {
        return this.submitUserRole === 'manager';
    }

    public get visibleSubmitNavigationLinks() {
        return this.submitNavigationLinks.filter((item) => item.path !== '/submit/approval' || this.canManageSubmitApproval);
    }

    public get selectedSubmitCollection(): SubmitCollection {
        for (const group of this.submitCollectionGroups) {
            const found = group.items.find((item) => item.id === this.selectedSubmitCollectionId);
            if (found) return found;
        }

        return this.submitCollectionGroups[0].items[0];
    }

    public get submitManageRecords() {
        const source = this.activeSubmitManageTab === 'archived' ? this.submitArchivedRecords : this.submitDraftRecords;
        const query = this.submitManageSearchText.trim().toLowerCase();
        if (!query) return source;
        return source.filter((record) => record.title.toLowerCase().includes(query) || record.status.toLowerCase().includes(query));
    }

    public get submitManageTabTotal() {
        return this.activeSubmitManageTab === 'archived' ? this.submitArchivedRecords.length : this.submitDraftRecords.length;
    }

    public get isAllSubmitManageRecordsSelected() {
        const records = this.submitManageRecords;
        return records.length > 0 && records.every((record) => this.selectedSubmitManageIds.includes(record.id));
    }

    public get submitApprovalTabRecords() {
        return this.submitApprovalRecords.filter((record) => record.status === this.activeSubmitApprovalTab);
    }

    public get selectedSubmitApprovalRecord(): SubmitApprovalRecord {
        return this.submitApprovalRecords.find((record) => record.id === this.selectedSubmitApprovalId) || this.submitApprovalRecords[0];
    }

    public get activeNavItem() {
        if (this.activeNavIndex === null) return null;
        return this.navItems[this.activeNavIndex] || null;
    }

    public get activeNavSections() {
        const item = this.activeNavItem;
        if (!item) return [];
        return this.getMenuSections(item);
    }

    public get activeNavPanelOpen() {
        return this.activeNavIndex !== null && this.suppressedNavIndex !== this.activeNavIndex && this.activeNavSections.length > 0;
    }

    public get activeHomeProviderTabData() {
        return this.providerTabs.find((tab) => tab.id === this.activeHomeProviderTab) || this.providerTabs[0];
    }

    public get activeHomeBoardTabData() {
        return this.boardTabs.find((tab) => tab.id === this.activeHomeBoardTab) || this.boardTabs[0];
    }

    public get activeHomeDataTabData() {
        return this.homeDataTabs.find((tab) => tab.id === this.activeHomeDataTab) || this.homeDataTabs[0];
    }

    public get activeHomeLogoSlide() {
        return this.homeLogoSlides[this.activeHomeLinkSlideIndex] || this.homeLogoSlides[0];
    }

    public get visibleHomeProviders() {
        return this.getCircularItems(this.activeHomeProviderTabData.items, this.homeProviderVisibleCount, this.homeProviderSlideIndex);
    }

    public get visibleScienceFields() {
        return this.getCircularItems(this.scienceFields, this.scienceVisibleCount, this.scienceSlideIndex);
    }

    public get homeProviderVisibleCount() {
        if (typeof window === 'undefined') return 3;
        if (window.innerWidth < 600) return 1;
        if (window.innerWidth < 1001) return 2;
        return 3;
    }

    public get scienceVisibleCount() {
        if (typeof window === 'undefined') return 6;
        if (window.innerWidth < 481) return 1;
        if (window.innerWidth < 801) return 3;
        if (window.innerWidth < 1201) return 4;
        return 6;
    }

    public getMenuSections(group: MenuGroup): MenuSection[] {
        if (group.sections?.length) return group.sections;
        return [{ label: group.label, path: group.path, children: group.children }];
    }

    private getCircularItems<T>(items: T[], count: number, startIndex: number): T[] {
        if (!items.length || count <= 0) return [];
        if (items.length <= count) return items;

        return Array.from({ length: count }, (_, offset) => items[(startIndex + offset) % items.length]);
    }

    public get prototypeTabs() {
        const tabs = (this.datasetPrototype?.page?.tabs || []) as { id: DatasetTabId; label: string; sections: string[] }[];
        if (tabs.some((tab) => tab.id === 'knowledgeGraph')) return tabs;

        const knowledgeGraphTab = { id: 'knowledgeGraph' as DatasetTabId, label: '지식그래프', sections: ['knowledgeGraph'] };
        const relationIndex = tabs.findIndex((tab) => tab.id === 'relations');
        if (relationIndex < 0) return [...tabs, knowledgeGraphTab];

        return [
            ...tabs.slice(0, relationIndex),
            knowledgeGraphTab,
            ...tabs.slice(relationIndex),
        ];
    }

    public get prototypeHeaderActions() {
        return (this.datasetPrototype?.page?.stickyHeader?.globalActions || []) as string[];
    }

    public get prototypeSummary() {
        return this.datasetPrototype?.overview?.summaryCard || {};
    }

    public get prototypeDescription() {
        return this.datasetPrototype?.overview?.description || {};
    }

    public get prototypeComposition() {
        return this.datasetPrototype?.overview?.datasetComposition || {};
    }

    public get prototypeKeywords() {
        return this.datasetPrototype?.overview?.keywords || {};
    }

    public get prototypeHistory() {
        return this.datasetPrototype?.overview?.historyAndClassification || {};
    }

    public get prototypeServiceSummary() {
        return this.datasetPrototype?.overview?.serviceSummary || {};
    }

    public get prototypeFiles() {
        return this.datasetPrototype?.files || {};
    }

    public get prototypeFileExplorer() {
        return this.prototypeFiles.fileExplorer || {};
    }

    public get prototypeSampleFiles() {
        const files = (this.prototypeFileExplorer.sampleFiles || []) as DatasetLooseRecord[];
        const query = this.datasetFileSearch.trim().toLowerCase();
        return files.filter((file) => {
            const matchesQuery = !query || `${file.name || ''} ${file.folder || ''}`.toLowerCase().includes(query);
            const matchesType = this.datasetFileFilter === 'all' || file.type === this.datasetFileFilter;
            return matchesQuery && matchesType;
        });
    }

    public get selectedPrototypeFile() {
        const files = (this.prototypeFileExplorer.sampleFiles || []) as DatasetLooseRecord[];
        return files.find((file) => file.id === this.selectedDatasetFileId) || files[0] || {};
    }

    public get selectedPrototypeFileIndex() {
        const files = (this.prototypeFileExplorer.sampleFiles || []) as DatasetLooseRecord[];
        return Math.max(0, files.findIndex((file) => file.id === this.selectedPrototypeFile.id));
    }

    public get selectedPrototypeFileMetadata() {
        const base = this.prototypeFiles.selectedFileMetadata || {};
        const file = this.selectedPrototypeFile;
        return {
            fileName: file.name || base.fileName || '-',
            format: (file.extension || base.format || '-').toString().toUpperCase(),
            category: this.getPrototypeFolderLabel(file.folder) || base.category || '-',
            resolution: base.resolution || '-',
            capturedAt: this.extractCapturedAt(file.name) || base.capturedAt || '-',
            longitude: this.extractCoordinate(file.name, 0) ?? base.longitude ?? '-',
            latitude: this.extractCoordinate(file.name, 1) ?? base.latitude ?? '-',
            matchingStatus: base.matchingStatus || '-',
        };
    }

    public get prototypePreviewPolicy() {
        return this.prototypeFiles.previewPolicy || {};
    }

    public get prototypeMetadata() {
        return this.datasetPrototype?.metadata || {};
    }

    public get metadataCategorySections() {
        const metadata = this.prototypeMetadata;
        return [
            {
                title: '기본정보',
                rows: [
                    { label: '한글 제목', value: metadata.basicMetadata?.title?.ko },
                    { label: '영문 제목', value: metadata.basicMetadata?.title?.en },
                    { label: '설명 형식(ko)', value: metadata.basicMetadata?.descriptionFormat?.ko },
                    { label: '설명 형식(en)', value: metadata.basicMetadata?.descriptionFormat?.en },
                    { label: '주 언어', value: metadata.basicMetadata?.language?.primary },
                    { label: '보조 언어', value: metadata.basicMetadata?.language?.secondary },
                    { label: '국내외 구분', value: metadata.basicMetadata?.domesticOrInternational },
                    { label: '데이터 생성일', value: metadata.basicMetadata?.dataCreatedAt },
                ],
            },
            {
                title: '분류·연계',
                rows: [
                    { label: '국가과학기술표준분류', value: metadata.basicMetadata?.nationalScienceTechnologyClassification },
                    { label: '주제분류', value: metadata.basicMetadata?.subjectClassification },
                    { label: '데이터포털 연계 동의', value: this.formatBoolean(metadata.basicMetadata?.dataPortalLinkConsent) },
                    { label: '원천 서비스 ID', value: metadata.providerMetadata?.sourceServiceId },
                ],
            },
            {
                title: '제공처',
                rows: [
                    { label: '제공처', value: metadata.providerMetadata?.provider },
                    { label: '리포지터리', value: metadata.providerMetadata?.repository },
                    { label: '데이터포털 연계 동의', value: this.formatBoolean(metadata.providerMetadata?.dataPortalLinkConsent) },
                    { label: '안내', value: metadata.providerMetadata?.notice },
                ],
            },
        ];
    }

    public get prototypeRelations() {
        return this.datasetPrototype?.relations || {};
    }

    public get relationNodes() {
        return (this.prototypeRelations.semanticRelations?.nodes || []) as DatasetLooseRecord[];
    }

    public get relationEdges() {
        return (this.prototypeRelations.semanticRelations?.edges || []) as DatasetLooseRecord[];
    }

    public get selectedRelationNode() {
        return this.relationNodes.find((node) => node.id === this.selectedRelationNodeId) || this.relationNodes[0] || {};
    }

    public get selectedRelationEdges() {
        const selectedId = this.selectedRelationNode.id;
        return this.relationEdges.filter((edge) => edge.source === selectedId || edge.target === selectedId);
    }

    public get knowledgeGraphCenterNode(): KnowledgeGraphNode {
        return this.getKnowledgeGraphNodeById(this.knowledgeGraphCenterNodeId) || (this.knowledgeGraphNodes[0] as KnowledgeGraphNode);
    }

    public get selectedKnowledgeGraphNode(): KnowledgeGraphNode {
        return this.getKnowledgeGraphNodeById(this.selectedKnowledgeGraphNodeId) || this.knowledgeGraphCenterNode;
    }

    public get selectedKnowledgeGraphEdge(): KnowledgeGraphEdge | null {
        return this.knowledgeGraphEdges.find((edge) => edge.id === this.selectedKnowledgeGraphEdgeId) || null;
    }

    public get visibleKnowledgeGraphEdges(): KnowledgeGraphEdge[] {
        const centerId = this.knowledgeGraphCenterNode.id;
        return this.knowledgeGraphEdges.filter((edge) => {
            const isDirect = edge.source === centerId || edge.target === centerId;
            return isDirect && this.matchesKnowledgeGraphFilter(edge);
        });
    }

    public get visibleRelatedKnowledgeGraphNodes(): KnowledgeGraphNode[] {
        const centerId = this.knowledgeGraphCenterNode.id;
        const relatedIds = new Set(this.visibleKnowledgeGraphEdges.map((edge) => this.getKnowledgeGraphOtherNodeId(edge, centerId)));
        return this.knowledgeGraphNodes.filter((node) => relatedIds.has(node.id));
    }

    public get visibleKnowledgeGraphNodes(): KnowledgeGraphNode[] {
        return [this.knowledgeGraphCenterNode, ...this.visibleRelatedKnowledgeGraphNodes.filter((node) => node.id !== this.knowledgeGraphCenterNode.id)];
    }

    public get selectedKnowledgeGraphDetailRows(): KnowledgeGraphMetadataRow[] {
        const node = this.selectedKnowledgeGraphNode;
        return [
            { label: '개체 유형', value: this.getKnowledgeGraphTypeLabel(node.type) },
            { label: '명칭', value: node.label },
            { label: 'DataON 고유번호', value: node.dataonId },
            { label: '출처', value: node.source },
            { label: '연결 관계 수', value: `${this.getKnowledgeGraphNodeRelationCount(node)}개` },
        ];
    }

    public get selectedKnowledgeGraphNodeEdges(): KnowledgeGraphEdge[] {
        const nodeId = this.selectedKnowledgeGraphNode.id;
        return this.knowledgeGraphEdges.filter((edge) => edge.source === nodeId || edge.target === nodeId);
    }

    public get knowledgeGraphPathNodes(): KnowledgeGraphNode[] {
        return this.knowledgeGraphPathIds
            .map((id) => this.getKnowledgeGraphNodeById(id))
            .filter((node): node is KnowledgeGraphNode => Boolean(node));
    }

    public get knowledgeGraphTransform() {
        return `scale(${this.knowledgeGraphZoom})`;
    }

    public get knowledgeGraphZoomLabel() {
        return `${Math.round(this.knowledgeGraphZoom * 100)}%`;
    }

    public get prototypeCitation() {
        return this.datasetPrototype?.citationAndSharing || {};
    }

    public get selectedCitationText() {
        const citation = this.prototypeCitation.citationGenerator || {};
        const title = this.prototypeSummary.title || {};
        const doi = this.prototypeCitation.doi?.value || this.prototypeServiceSummary.doi || '';
        const creators = (this.prototypeSummary.creatorsDisplay || []) as string[];
        const creatorNames = creators.map((creator) => creator.split('(')[0]).join(', ');
        const titleEn = title.en || title.ko || '';

        if (this.selectedCitationStyle === 'BibTeX') return citation.bibtex || '';
        if (this.selectedCitationStyle === 'MLA') return `${creatorNames}. "${titleEn}." DataON, 2026, doi:${doi}.`;
        if (this.selectedCitationStyle === 'Chicago') return `${creatorNames}. 2026. "${titleEn}." DataON. https://doi.org/${doi}.`;
        return `${creatorNames}. (2026). ${titleEn}. DataON. https://doi.org/${doi}`;
    }

    public get usageStatItems() {
        const stats = this.prototypeCitation.usageStats || {};
        return [
            { label: '조회', value: stats.views },
            { label: '다운로드', value: stats.downloads },
            { label: '원문 이동', value: stats.originalLinks },
            { label: '추천', value: stats.recommendations },
            { label: '공유', value: stats.shares },
            { label: '인용', value: stats.citations },
        ];
    }

    public get activeRecommendationItems() {
        const recommendations = this.datasetPrototype?.recommendations || {};
        if (this.activeRecommendationTab === '데이터') return recommendations.recommendedDatasets || [];
        if (this.activeRecommendationTab === '표준분류') return recommendations.recommendedClassifications || [];
        return recommendations.recommendedPapers || [];
    }

    public get shortKoDescription() {
        return this.getDescriptionText('ko');
    }

    public get shortEnDescription() {
        return this.getDescriptionText('en');
    }

    public get datasetTabs() {
        return this.datasetDetail.ui.tabs;
    }

    public get datasetPrimaryActions() {
        return this.datasetDetail.ui.primaryActions;
    }

    public get datasetSearchResults(): DatasetSearchResult[] {
        const detail = this.datasetDetail;

        return [
            ...this.officialCapturedDatasetSearchResults,
            {
                id: detail.datasetId,
                title: detail.title.ko,
                titleEn: detail.title.en,
                summary: detail.summary,
                path: '/search/datasets/detail',
                provider: detail.provider.name,
                repository: detail.provider.repository,
                searchTarget: '데이터셋',
                accessRight: '공개',
                createdAt: detail.createdAt,
                updatedAt: detail.updatedAt,
                creators: detail.creators.map((creator) => `${creator.nameKo}(${creator.organizationKo})`),
                managers: ['DataON 큐레이션 담당자'],
                keywords: detail.keywords,
                badges: detail.badges,
                fileTypes: ['PNG', 'ZIP'],
                license: detail.license.code,
                dataType: '데이터셋',
                createdYear: detail.createdAt.slice(0, 4),
                domesticOrInternational: detail.classification.domesticOrInternational,
                subject: detail.classification.subject,
                publisher: detail.provider.name,
                contributors: ['한국과학기술정보연구원', detail.relatedProject.organization],
                projectName: detail.relatedProject.titleKo,
                principalInvestigator: detail.relatedProject.principalInvestigator.nameKo,
                performingOrganization: detail.relatedProject.organization,
                ministry: detail.relatedProject.ministry,
                researcherNumber: 'R-2026-0001434',
                ntisProjectNumber: 'NTIS-2026-DEF-1434',
                totalFiles: detail.composition.totalFiles,
                totalSamples: detail.composition.totalSamples,
                views: detail.stats.views,
                downloads: detail.stats.downloads,
            },
            ...this.supplementalDatasetSearchResults,
        ];
    }

    public get currentSearchMenuPage() {
        return this.findSearchMenuPageByPath(this.currentPath) || this.searchMenuPages[0];
    }

    public get officialSearchTopMode(): ContentTopSearchModeId {
        const currentId = this.currentSearchMenuPage.id;
        if (currentId === 'detail') return 'detail';
        if (currentId === 'semantic') return 'semantic';
        return 'integrated';
    }

    public get isOfficialProviderSearchPage() {
        return this.currentSearchMenuPage.id === 'providers';
    }

    public get isOfficialSemanticSearchPage() {
        return this.currentSearchMenuPage.id === 'semantic';
    }

    public get isOfficialDetailSearchPage() {
        return this.currentSearchMenuPage.id === 'detail';
    }

    public get currentSearchChips() {
        return this.currentSearchMenuPage.chips.length ? this.currentSearchMenuPage.chips : this.searchChips;
    }

    public get searchMenuScopedResults(): DatasetSearchResult[] {
        const page = this.currentSearchMenuPage;
        return this.datasetSearchResults.filter((result) => this.matchesSearchMenuPage(result, page));
    }

    public get officialSearchResultCountLabel() {
        if (this.currentSearchMenuPage.id === 'software') return '110건';
        if (this.currentSearchMenuPage.id === 'datasets') return '7,519,026건';
        if (this.currentSearchMenuPage.id === 'issues') return '3건';
        if (this.currentSearchMenuPage.id.startsWith('issue-')) return `${this.formatNumber(this.searchMenuScopedResults.length)}건`;
        return '7,519,136건';
    }

    public get officialResultGroupTitle() {
        return this.currentSearchMenuPage.id === 'software' ? '소프트웨어' : '데이터셋';
    }

    public get isOfficialSoftwareSearchPage() {
        return this.currentSearchMenuPage.id === 'software';
    }

    public get isOfficialIntegratedSearchPage() {
        return this.currentSearchMenuPage.id === 'integrated';
    }

    public get officialIntegratedResultCountLabel() {
        return this.filteredDatasetSearchResults.length ? '7,519,136건' : '0건';
    }

    public get officialDatasetTotalResultCount() {
        return this.filteredDatasetSearchResults.filter((result) => this.isOfficialDatasetResult(result)).length;
    }

    public get officialSoftwareTotalResultCount() {
        return this.filteredDatasetSearchResults.filter((result) => this.isOfficialSoftwareResult(result)).length;
    }

    public get officialDatasetResultCountLabel() {
        return this.officialDatasetTotalResultCount ? '7,519,026건' : '0건';
    }

    public get officialSoftwareResultCountLabel() {
        return this.officialSoftwareTotalResultCount ? '110건' : '0건';
    }

    public get showOfficialEmptyFilterNotice() {
        return this.filteredDatasetSearchResults.length === 0;
    }

    public get officialDisplayedSearchText() {
        return this.appliedSearchText.trim();
    }

    public get officialRelatedSearchTerms(): OfficialRelatedSearchTerm[] {
        const keyword = this.appliedSearchText.trim();
        if (!keyword) return [];

        const normalizedKeyword = this.normalizeDatasetSearchToken(keyword);
        const relatedTerms = new Map<string, OfficialRelatedSearchTerm>();

        for (const rule of this.getDatasetSearchRuleMatches(keyword)) {
            const terms = rule.related.length ? rule.related : [...rule.terms, rule.canonical];
            for (const term of terms) {
                const displayTerm = this.cleanOfficialMetaValue(term).replace(/^#/, '');
                const normalizedTerm = this.normalizeDatasetSearchToken(displayTerm);
                if (!displayTerm || !normalizedTerm || normalizedTerm === normalizedKeyword) continue;
                if (!relatedTerms.has(normalizedTerm)) {
                    relatedTerms.set(normalizedTerm, {
                        label: displayTerm,
                        value: displayTerm,
                    });
                }
            }
        }

        return [...relatedTerms.values()].slice(0, 5);
    }

    public get officialDatasetSectionResults() {
        const results = this.filteredDatasetSearchResults.filter((result) => this.isOfficialDatasetResult(result));
        if (this.isOfficialIntegratedSearchPage) return results.slice(0, 5);
        if (this.currentSearchMenuPage.id === 'datasets') return this.paginatedDatasetSearchResults.filter((result) => this.isOfficialDatasetResult(result));
        return [];
    }

    public get officialSoftwareSectionResults() {
        const results = this.filteredDatasetSearchResults.filter((result) => this.isOfficialSoftwareResult(result));
        if (this.isOfficialIntegratedSearchPage) return results.slice(0, 4);
        if (this.isOfficialSoftwareSearchPage) return this.paginatedDatasetSearchResults.filter((result) => this.isOfficialSoftwareResult(result));
        return [];
    }

    public get showOfficialDatasetResultBlock() {
        return this.isOfficialIntegratedSearchPage
            || this.currentSearchMenuPage.id === 'datasets'
            || this.officialDatasetSectionResults.length > 0;
    }

    public get showOfficialSoftwareResultBlock() {
        return this.isOfficialIntegratedSearchPage
            || this.isOfficialSoftwareSearchPage
            || this.officialSoftwareSectionResults.length > 0;
    }

    public get showOfficialNoResultFallback() {
        return !this.showOfficialDatasetResultBlock && !this.showOfficialSoftwareResultBlock;
    }

    public async navigateOfficialSearchTab(path: string) {
        const keyword = this.appliedSearchText.trim() || this.searchText.trim();
        const nextPath = keyword ? this.appendSearchQuery(path, keyword) : path;
        this.datasetSearchPage = 1;
        await this.go(nextPath);
    }

    public async applyRelatedSearchTerm(term: string | OfficialRelatedSearchTerm) {
        const keyword = this.cleanOfficialMetaValue(term);
        if (!keyword) return;

        this.searchText = keyword;
        await this.submitSearch();
    }

    public isOfficialSearchFacetExpanded(title: string) {
        return Boolean(this.officialSearchFacetExpanded[title]);
    }

    public async toggleOfficialSearchFacetGroup(title: string) {
        this.officialSearchFacetExpanded = {
            ...this.officialSearchFacetExpanded,
            [title]: !this.isOfficialSearchFacetExpanded(title),
        };
        await this.renderSafely();
    }

    public async toggleOfficialMobileInnerSearch() {
        this.officialMobileInnerSearchOpen = !this.officialMobileInnerSearchOpen;
        await this.renderSafely();
    }

    public getOfficialResultPrimaryFileType(result: DatasetSearchResult) {
        return (result.fileTypes[0] || 'pdf').toLowerCase();
    }

    private isOfficialDatasetResult(result: DatasetSearchResult) {
        return result.searchTarget === '데이터셋' || result.dataType === '데이터셋';
    }

    private isOfficialSoftwareResult(result: DatasetSearchResult) {
        return result.searchTarget === '소프트웨어' || result.dataType === '소프트웨어';
    }

    public getOfficialResultEnglishLine(result: DatasetSearchResult, index: number) {
        if (result.titleEn.startsWith('[')) return result.titleEn;
        return `[Research ${Math.max(1, 25 - index)}] "${result.titleEn}"`;
    }

    public getOfficialResultCreator(result: DatasetSearchResult) {
        const creators = result.creators
            .map((creator) => this.cleanOfficialMetaValue(creator.replace(/\(.+\)$/, '')))
            .filter(Boolean);
        const fallback = this.cleanOfficialMetaValue(result.principalInvestigator.replace(/\(.+\)$/, ''));
        return creators.length ? creators.join(', ') : fallback;
    }

    public getOfficialResultDoi(result: DatasetSearchResult, index: number) {
        return result.researcherNumber.startsWith('10.') ? result.researcherNumber : '';
    }

    public getOfficialResultVersion(result: DatasetSearchResult) {
        return result.ntisProjectNumber.match(/^\d+\.\d+\.\d+$/) ? result.ntisProjectNumber : '';
    }

    public getOfficialResultMetaRows(result: DatasetSearchResult, index: number) {
        const doi = this.getOfficialResultDoi(result, index);
        const isOfficialCaptured = result.id.startsWith('official-');
        const repository = !isOfficialCaptured && result.repository !== 'DataON' ? result.repository : '';
        const projectName = !isOfficialCaptured && !/^Research\s+\d+$/i.test(result.projectName) ? result.projectName : '';
        const researcherNumber = result.researcherNumber && !result.researcherNumber.startsWith('10.') ? result.researcherNumber : '';
        const ntisProjectNumber = result.ntisProjectNumber && !result.ntisProjectNumber.match(/^\d+\.\d+\.\d+$/) ? result.ntisProjectNumber : '';

        const rows = [
            { label: '데이터 제공처', value: result.provider },
            { label: '데이터 리포지터리', value: repository },
            { label: '생성자', value: this.getOfficialResultCreator(result) },
            { label: '국가연구자번호', value: isOfficialCaptured ? '' : researcherNumber },
            { label: 'ntis과제번호', value: isOfficialCaptured ? '' : ntisProjectNumber },
            { label: '과제명', value: projectName },
            { label: '과제책임자', value: isOfficialCaptured ? '' : result.principalInvestigator },
            { label: '과제수행기관', value: isOfficialCaptured ? '' : result.performingOrganization },
            { label: '부처', value: isOfficialCaptured ? '' : result.ministry },
            { label: '라이센스유형', value: isOfficialCaptured ? '' : result.license },
            { label: '주제분류', value: result.subject },
            { label: '인용횟수', value: '0' },
            { label: 'doi', value: doi, href: doi ? `https://doi.org/${doi}` : '' },
            { label: '버전', value: this.getOfficialResultVersion(result) },
        ];

        return rows
            .map((row) => ({
                ...row,
                value: this.cleanOfficialMetaValue(row.value),
            }))
            .filter((row) => row.value);
    }

    public getOfficialSoftwareThumbnail(result: DatasetSearchResult, index: number) {
        const officialThumbnailIds = ['382', '389', '386', '390', '385', '379', '359', '369', '315', '312'];
        const thumbnailId = officialThumbnailIds[index % officialThumbnailIds.length];
        return `https://dataon.kisti.re.kr/canvas/rest/app/software/${thumbnailId}/thumbnail`;
    }

    public getOfficialSoftwareKeywords(result: DatasetSearchResult) {
        return result.keywords
            .map((keyword) => this.cleanOfficialMetaValue(keyword.replace(/^#/, '')))
            .filter(Boolean)
            .slice(0, 6);
    }

    public getOfficialSoftwareCreatorsLine(result: DatasetSearchResult) {
        return result.creators
            .map((creator) => this.cleanOfficialMetaValue(creator.replace(/\(.+\)$/, '')))
            .filter(Boolean)
            .join(', ');
    }

    private cleanOfficialMetaValue(value: unknown) {
        if (value && typeof value === 'object') {
            const record = value as Record<string, unknown>;
            for (const key of ['label', 'value', 'keyword', 'term', 'name', 'title']) {
                const displayValue = this.cleanOfficialMetaValue(record[key]);
                if (displayValue) return displayValue;
            }

            return '';
        }

        return `${value ?? ''}`.replace(/\s*;\s*$/, '').trim();
    }

    public get officialSemanticResultCards() {
        return this.semanticDatasetSearchResults.slice(0, 5).map((result, index) => {
            const score = Math.max(64, Math.min(98, this.getSemanticRecommendation(result).score || (92 - index * 7)));
            const label = score >= 90 ? '매우 높음' : score >= 78 ? '높음' : score >= 66 ? '보통' : '낮음';
            const tone = score >= 90 ? 'exact' : score >= 78 ? 'similar' : score >= 66 ? 'partial' : 'low';

            return {
                result,
                score,
                label,
                tone,
                dots: [1, 2, 3, 4, 5],
                fillCount: Math.max(1, Math.ceil(score / 20)),
            };
        });
    }

    public get keywordDatasetSearchResults() {
        const keyword = this.appliedSearchText.trim();
        const results = this.searchMenuScopedResults.filter((result) => {
            return this.matchesDatasetSearchQuery(result, keyword)
                && this.matchesDatasetResultWithinSearch(result)
                && this.matchesDatasetAdvancedSearch(result)
                && this.matchesRegisteredYearFilter(result);
        });

        return this.sortDatasetSearchResults(results, (result) => this.getDatasetKeywordRelevanceScore(result, keyword));
    }

    public get semanticDatasetSearchResults() {
        const keyword = this.appliedSearchText.trim();
        const results = this.searchMenuScopedResults.filter((result) => {
            const semanticRecommendation = this.getSemanticRecommendation(result);
            const hasSemanticMatch = !keyword || semanticRecommendation.score > 0;

            return hasSemanticMatch
                && this.matchesDatasetResultWithinSearch(result)
                && this.matchesDatasetAdvancedSearch(result)
                && this.matchesRegisteredYearFilter(result);
        });

        return this.sortDatasetSearchResults(results, (result) => this.getSemanticRecommendation(result).score);
    }

    public get filteredDatasetSearchResults() {
        if (this.semanticSearchMode === 'semantic') return this.semanticDatasetSearchResults;
        return this.keywordDatasetSearchResults;
    }

    public get datasetSearchTotalPages() {
        return Math.max(1, Math.ceil(this.filteredDatasetSearchResults.length / this.datasetSearchPageSize));
    }

    public get clampedDatasetSearchPage() {
        return Math.min(Math.max(this.datasetSearchPage, 1), this.datasetSearchTotalPages);
    }

    public get paginatedDatasetSearchResults() {
        const startIndex = (this.clampedDatasetSearchPage - 1) * this.datasetSearchPageSize;
        return this.filteredDatasetSearchResults.slice(startIndex, startIndex + this.datasetSearchPageSize);
    }

    public get showDatasetSearchPagination() {
        if (this.isOfficialIntegratedSearchPage) return false;
        return this.filteredDatasetSearchResults.length > this.datasetSearchPageSize;
    }

    public get isDatasetSearchLastPage() {
        return this.clampedDatasetSearchPage >= this.datasetSearchTotalPages;
    }

    public get datasetSearchPaginationPages() {
        const totalPages = this.datasetSearchTotalPages;
        const currentPage = this.clampedDatasetSearchPage;
        const pages = new Set<number>([1, totalPages, currentPage, currentPage - 1, currentPage + 1]);

        if (currentPage <= 3) {
            pages.add(2);
            pages.add(3);
            pages.add(4);
        }

        if (currentPage >= totalPages - 2) {
            pages.add(totalPages - 1);
            pages.add(totalPages - 2);
            pages.add(totalPages - 3);
        }

        return [...pages]
            .filter((page) => page >= 1 && page <= totalPages)
            .sort((left, right) => left - right);
    }

    public get datasetSearchPaginationRangeLabel() {
        const resultCount = this.filteredDatasetSearchResults.length;
        if (!resultCount) return '0건';

        const start = (this.clampedDatasetSearchPage - 1) * this.datasetSearchPageSize + 1;
        const end = Math.min(start + this.datasetSearchPageSize - 1, resultCount);
        return `${this.formatNumber(start)}-${this.formatNumber(end)} / ${this.formatNumber(resultCount)}건`;
    }

    public get keywordDatasetSearchResultCount() {
        return this.keywordDatasetSearchResults.length;
    }

    public get semanticDatasetSearchResultCount() {
        return this.semanticDatasetSearchResults.length;
    }

    public get datasetSearchResultCount() {
        return this.filteredDatasetSearchResults.length;
    }

    public get resultFilterGroups(): DatasetSearchAdvancedField[] {
        const facetResults = this.filteredDatasetSearchResults;
        return this.resultFilterFieldDefinitions
            .map((field) => ({
                ...field,
                options: this.createResultFilterOptions(field.key, facetResults),
            }))
            .filter((field) => Boolean(field.options.length));
    }

    public get datasetSearchAppliedFilters(): DatasetSearchAppliedFilter[] {
        return this.getAdvancedSearchFilters(this.appliedAdvancedSearch);
    }

    public get advancedSearchAppliedFilters() {
        return this.datasetSearchAppliedFilters;
    }

    public get advancedSearchDraftFilters() {
        return this.getAdvancedSearchFilters(this.advancedSearchDraft);
    }

    public get advancedSearchDraftSummaryFilters(): DatasetSearchSummaryFilter[] {
        return this.groupAdvancedSearchFilters(this.advancedSearchDraftFilters);
    }

    public get advancedSearchDraftCount() {
        return this.countAdvancedSearchValues(this.advancedSearchDraft);
    }

    public get advancedSearchToggleCount() {
        return this.advancedSearchOpen
            ? this.advancedSearchDraftCount
            : this.advancedSearchAppliedFilters.length;
    }

    public get advancedSearchProjectDraftCount() {
        return this.advancedSearchProjectFields.reduce((total, field) => {
            return total + this.getEffectiveAdvancedValues(this.advancedSearchDraft, field.key).length;
        }, 0);
    }

    public get advancedOrganizationDraftCount() {
        return this.advancedSearchOrganizationFields.reduce((total, field) => {
            return total + this.getEffectiveAdvancedValues(this.advancedSearchDraft, field.key).length;
        }, 0);
    }

    public get advancedProjectIdentifierDraftCount() {
        return this.advancedSearchProjectIdentityFields.reduce((total, field) => {
            return total + this.getEffectiveAdvancedValues(this.advancedSearchDraft, field.key).length;
        }, 0);
    }

    public get advancedSearchHasAppliedFilters() {
        return this.advancedSearchAppliedFilters.length > 0;
    }

    public get resultFilterAppliedCount() {
        const hasRegisteredYearFilter = Boolean(this.appliedRegisteredYearStart || this.appliedRegisteredYearEnd);
        return this.advancedSearchAppliedFilters.length
            + (hasRegisteredYearFilter ? 1 : 0);
    }

    public get resultFilterDraftItems(): ResultFilterReviewItem[] {
        const items: ResultFilterReviewItem[] = [];

        items.push(...this.getAdvancedSearchFilters(this.advancedSearchDraft).map((filter) => ({
            key: filter.key,
            label: filter.label,
            value: filter.value,
            displayValue: filter.displayValue,
        })));

        if (this.registeredYearStart || this.registeredYearEnd) {
            items.push({
                key: 'registeredYear',
                label: '등록년도',
                value: 'registeredYear',
                displayValue: `${this.registeredYearStart || '시작'}~${this.registeredYearEnd || '종료'}`,
            });
        }

        return items;
    }

    public get resultFilterDraftCount() {
        return this.resultFilterDraftItems.length;
    }

    public get advancedSearchModeLabel() {
        return this.appliedAdvancedSearchMatchMode === 'all' ? '모든 조건 충족' : '하나 이상의 조건 충족';
    }

    public get searchAssistItems(): DatasetSearchAssistItem[] {
        return this.getDatasetSearchAssistItems(this.appliedSearchText);
    }

    public get correctedSearchText() {
        return this.getCorrectedDatasetSearchText(this.appliedSearchText);
    }

    public get datasetSearchModeLabel() {
        if (this.semanticSearchMode === 'semantic') return '의미검색 결과';
        return '일반 키워드 검색 결과';
    }

    public get datasetSearchSummaryLabel() {
        const keyword = this.appliedSearchText.trim();
        if (!keyword) return this.currentSearchMenuPage.allResultsLabel;
        const correctedKeyword = this.correctedSearchText;
        const displayKeyword = correctedKeyword && correctedKeyword !== keyword
            ? `"${keyword}" → "${correctedKeyword}"`
            : `"${keyword}"`;

        if (this.semanticSearchMode === 'semantic') return `${displayKeyword} 의미검색 결과`;

        return `${displayKeyword} 검색 결과`;
    }

    public get datasetSearchResultTitleLabel() {
        const keyword = this.appliedSearchText.trim();
        const correctedKeyword = this.correctedSearchText;
        const displayKeyword = keyword
            ? (correctedKeyword && correctedKeyword !== keyword ? `'${keyword}' -> '${correctedKeyword}'` : `'${keyword}'`)
            : this.currentSearchMenuPage.allResultsLabel;
        const countLabel = `${this.formatNumber(this.datasetSearchResultCount)}건`;

        if (this.semanticSearchMode === 'semantic') return `${displayKeyword} 의미검색 결과 ${countLabel}`;

        return `${displayKeyword} 검색 결과 ${countLabel}`;
    }

    public isCurrentSearchMenuPath(path: string) {
        const pathname = this.normalizePath(path);
        if (this.isMapSearchPath(pathname)) return this.isMapSearchPage;
        if (!this.isDatasetSearchPage) return false;

        const currentPage = this.currentSearchMenuPage;
        const page = this.findSearchMenuPageByPath(pathname);
        return Boolean(page && page.id === currentPage.id);
    }

    public get resultFilterChipCount() {
        return this.advancedSearchAppliedFilters.length + (this.hasAppliedRegisteredYearFilter ? 1 : 0);
    }

    public get hasAppliedRegisteredYearFilter() {
        return Boolean(this.appliedRegisteredYearStart || this.appliedRegisteredYearEnd);
    }

    public get appliedRegisteredYearFilterLabel() {
        if (!this.hasAppliedRegisteredYearFilter) return '';
        return `${this.appliedRegisteredYearStart || '시작'}~${this.appliedRegisteredYearEnd || '종료'}`;
    }

    public get selectedSearchScope() {
        return this.appliedAdvancedSearch.searchScope[0] || 'all';
    }

    public get datasetPreviewFiles() {
        return this.datasetDetail.files.filter((file) => file.type === 'image');
    }

    public get selectedDatasetFile(): DatasetFile {
        const selected = this.datasetDetail.files.find((file) => file.id === this.selectedDatasetFileId);
        if (selected) return selected;

        const previewFile = this.datasetPreviewFiles[0];
        if (previewFile) return previewFile;

        return this.datasetDetail.files[0];
    }

    public get selectedDatasetFileIndex() {
        return this.datasetPreviewFiles.findIndex((file) => file.id === this.selectedDatasetFile.id);
    }

    public get datasetPreviewTransform() {
        return `scale(${this.datasetPreviewZoom}) rotate(${this.datasetPreviewRotation}deg)`;
    }

    public get datasetPreviewClass() {
        const folder = this.selectedDatasetFile.folder || '';
        if (folder.includes('label')) return 'is-label';
        if (folder.includes('Sen2')) return 'is-sentinel';
        return 'is-kompsat';
    }

    public get datasetCoordinateText() {
        const coordinates = this.selectedDatasetFile.coordinates;
        if (!coordinates) return '좌표 정보 없음';

        return `${coordinates.latitude.toFixed(2)}, ${coordinates.longitude.toFixed(2)}`;
    }

    public get datasetPairingItems() {
        const pairing = this.datasetDetail.composition.pairing;
        return [
            { label: 'KOMPSAT·Sentinel-2 완전 매칭', value: pairing.fullyPaired, tone: 'strong' },
            { label: 'KOMPSAT·Sentinel-2 라벨 매칭', value: pairing.kompsatAndSen2LabelOnly, tone: 'medium' },
            { label: 'KOMPSAT 단독', value: pairing.kompsatOnly, tone: 'light' },
        ];
    }

    public get datasetMetadataRows() {
        return [
            { label: '데이터셋 ID', value: this.datasetDetail.datasetId },
            { label: 'DOI', value: this.datasetDetail.doi },
            { label: '제공처', value: this.datasetDetail.provider.name },
            { label: '리포지터리', value: this.datasetDetail.provider.repository },
            { label: '라이선스', value: `${this.datasetDetail.license.code} (${this.datasetDetail.license.label})` },
            { label: '분류 코드', value: this.datasetDetail.classification.nationalScienceTechnologyCode },
            { label: '과학기술표준분류', value: this.datasetDetail.classification.nationalScienceTechnologyLabel },
            { label: '주제분야', value: this.datasetDetail.classification.subject },
            { label: '국내외구분', value: this.datasetDetail.classification.domesticOrInternational },
            { label: '생성일', value: this.datasetDetail.createdAt },
            { label: '수정일', value: this.datasetDetail.updatedAt },
            { label: '미리보기 유형', value: this.datasetDetail.preview.viewerType },
        ];
    }

    public get isLoggedIn() {
        try {
            return Boolean(this.service.auth?.check?.());
        } catch (e) {
            return false;
        }
    }

    public get mobileUtilityLinks(): LinkItem[] {
        return this.utilityLinks;
    }

    public async ngOnInit() {
        await this.syncCurrentRoute(window.location.pathname + window.location.search);
        if (this.service.auth) {
            await this.service.init(null);
            await this.renderSafely();
        }
        await this.loadDatasetPrototype();
        await this.syncCurrentRoute(window.location.pathname + window.location.search);
        this.startHomeBoardAutoRolling();
        this.startHomeLogoAutoRolling();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        window.removeEventListener('dataon-locationchange', this.handleHistoryRouteChange);
        this.stopHomeBoardAutoRolling();
        this.stopHomeLogoAutoRolling();
        this.clearQuickMenuFollowTimer();
        this.clearQuickMenuCloseTimer();
    }

    @HostListener('window:popstate')
    public async handlePopState() {
        await this.syncCurrentRoute(window.location.pathname + window.location.search);
    }

    @HostListener('window:resize')
    public async handleWindowResize() {
        this.updateMobileQuickMenuVisibility();
        await this.renderSafely();
    }

    @HostListener('window:scroll')
    public async handleWindowScroll() {
        const visibilityChanged = this.updateMobileQuickMenuVisibility();
        const followChanged = this.updateQuickMenuScrollFollow();

        if (visibilityChanged || followChanged) {
            await this.renderSafely();
        }
    }

    @HostListener('document:click', ['$event'])
    public async handleDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement | null;

        if (this.advancedSearchOpen && !target?.closest?.('.dataon-search-block, .dataon-results-search-block')) {
            await this.cancelAdvancedSearchConditions();
        }

        if (this.mobileQuickMenuOpen && !target?.closest?.('.dataon-floating-quick')) {
            this.startMobileQuickMenuCloseAnimation();
            await this.renderSafely();
        }
    }

    public async changeLanguage(language: LanguageCode) {
        this.applyLanguage(language);
        this.searchHelpOpen = false;
        this.contentTopSearchOpen = false;
        this.advancedSearchOpen = false;
        this.mobileMenuOpen = false;
        this.sitemapOpen = false;
        this.mobileQuickMenuOpen = false;
        this.mobileQuickMenuClosing = false;
        this.mobileQuickMenuVisible = false;
        this.clearQuickMenuCloseTimer();
        this.hideQuickMenuAfterClose = false;
        this.resetQuickMenuFollowOffset();

        const nextPath = language === 'en' ? '/en' : '/';
        this.setCurrentPage(nextPath);
        await this.router.navigateByUrl(nextPath);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        await this.renderSafely();
    }

    public async go(path: string) {
        if (!path) return;

        if (/^(https?:)?\/\//.test(path)) {
            window.location.href = path;
            return;
        }

        const nextLanguage = this.getLanguageFromPath(path);
        if (nextLanguage) {
            await this.changeLanguage(nextLanguage);
            return;
        }

        this.searchHelpOpen = false;
        this.contentTopSearchOpen = false;
        this.advancedSearchOpen = false;
        this.mobileMenuOpen = false;
        this.sitemapOpen = false;
        this.mobileQuickMenuOpen = false;
        this.mobileQuickMenuClosing = false;
        this.clearQuickMenuCloseTimer();
        this.hideQuickMenuAfterClose = false;
        this.resetQuickMenuFollowOffset();
        this.setCurrentPage(path);
        this.updateMobileQuickMenuVisibility();
        await this.renderSafely();
        await this.router.navigateByUrl(path);
        await this.syncCurrentRoute(path);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    public async goUtility(item: LinkItem) {
        if (item.path === '/auth/logout') {
            window.location.href = item.path;
            return;
        }

        await this.go(item.path);
    }

    public async toggleContentTopSearch(event?: MouseEvent) {
        event?.stopPropagation();
        this.contentTopSearchOpen = !this.contentTopSearchOpen;
        this.searchHelpOpen = false;
        this.advancedSearchOpen = false;

        if (this.contentTopSearchOpen) {
            this.activeContentTopSearchMode = this.getContentTopSearchModeForCurrentPage();
            this.mobileMenuOpen = false;
            this.sitemapOpen = false;
            this.activeNavIndex = null;
            this.suppressedNavIndex = null;
        }

        await this.renderSafely();
    }

    public async setContentTopSearchMode(mode: ContentTopSearchModeId) {
        this.activeContentTopSearchMode = mode;
        await this.renderSafely();
    }

    public async submitContentTopSearch() {
        const keyword = this.searchText.trim();
        const query = keyword ? `?q=${encodeURIComponent(keyword)}` : '';
        const mode = this.activeContentTopSearchModeData;

        this.datasetSearchPage = 1;
        this.appliedSearchText = keyword;
        this.contentTopSearchOpen = false;
        this.semanticSearchMode = mode.id === 'semantic' ? 'semantic' : 'keyword';

        await this.go(`${mode.path}${query}`);
    }

    public async submitOfficialTopSearch() {
        this.activeContentTopSearchMode = this.officialSearchTopMode;
        await this.submitContentTopSearch();
    }

    public async toggleMenu() {
        const nextOpen = !this.menuOpen;
        if (nextOpen) {
            this.searchHelpOpen = false;
            this.contentTopSearchOpen = false;
            this.advancedSearchOpen = false;
            this.activeNavIndex = null;
            this.suppressedNavIndex = null;
        }

        this.mobileMenuOpen = nextOpen;
        this.sitemapOpen = nextOpen;
        await this.renderSafely();
    }

    public async closeMenu() {
        this.mobileMenuOpen = false;
        this.sitemapOpen = false;
        await this.renderSafely();
    }

    public async selectMenu(index: number) {
        this.selectedMenuIndex = index;
        await this.renderSafely();
    }

    public async setSubmitStep(step: SubmitStepId) {
        this.activeSubmitStep = step;
        this.submitFormMessage = '';
        await this.renderSafely();
    }

    public async continueSubmitNotice() {
        if (!this.submitAgreement.required) {
            this.submitFormMessage = '필수 유의사항 동의 후 다음 단계로 이동할 수 있습니다.';
            await this.renderSafely();
            return;
        }

        this.activeSubmitStep = 'collection';
        this.submitFormMessage = '';
        await this.renderSafely();
    }

    public async selectSubmitCollection(collectionId: string) {
        this.selectedSubmitCollectionId = collectionId;
        this.submitFormMessage = '등록 기관을 선택했습니다. 하단 다음 단계 버튼을 눌러 계속 진행하세요.';
        await this.renderSafely();
    }

    public async continueSubmitInstitution() {
        if (!this.selectedSubmitCollectionId) {
            this.submitFormMessage = '등록 기관을 먼저 선택해 주세요.';
            await this.renderSafely();
            return;
        }

        this.activeSubmitStep = 'form';
        this.submitFormMessage = '';
        await this.renderSafely();
    }

    public async saveSubmitDraft() {
        this.submitFormMessage = '임시 저장되었습니다.';
        await this.renderSafely();
    }

    public async moveSubmitReview() {
        if (!this.submitForm.titleKo.trim() || !this.submitForm.descriptionKo.trim()) {
            this.submitFormMessage = '제목과 설명은 필수 입력 항목입니다.';
            await this.renderSafely();
            return;
        }

        this.activeSubmitStep = 'review';
        this.submitFormMessage = '';
        await this.renderSafely();
    }

    public async requestSubmitApproval() {
        this.submitFormMessage = '관리자에게 승인요청이 전송되었습니다.';
        await this.renderSafely();
    }

    public async setSubmitManageTab(tab: SubmitManageTabId) {
        this.activeSubmitManageTab = tab;
        this.selectedSubmitManageIds = [];
        this.submitManageMessage = '';
        await this.renderSafely();
    }

    public isSubmitManageRecordSelected(record: SubmitRecord) {
        return this.selectedSubmitManageIds.includes(record.id);
    }

    public async toggleSubmitManageRecord(record: SubmitRecord, checked: boolean) {
        const ids = new Set(this.selectedSubmitManageIds);
        if (checked) {
            ids.add(record.id);
        } else {
            ids.delete(record.id);
        }

        this.selectedSubmitManageIds = Array.from(ids);
        await this.renderSafely();
    }

    public async toggleAllSubmitManageRecords(checked: boolean) {
        const visibleIds = this.submitManageRecords.map((record) => record.id);
        if (checked) {
            this.selectedSubmitManageIds = Array.from(new Set([...this.selectedSubmitManageIds, ...visibleIds]));
        } else {
            this.selectedSubmitManageIds = this.selectedSubmitManageIds.filter((id) => !visibleIds.includes(id));
        }

        await this.renderSafely();
    }

    public async handleSubmitManageRecordAction(record: SubmitRecord) {
        if (record.tool === '회수') {
            record.status = '임시저장';
            record.statusClass = 'workspace';
            record.tool = '삭제';
            record.modifiedAt = '2026-06-23';
            this.submitManageMessage = `${record.title} 데이터를 회수하여 임시저장 상태로 변경했습니다.`;
        } else if (record.tool === '삭제') {
            this.removeSubmitManageRecord(record.id);
            this.submitManageMessage = `${record.title} 데이터를 삭제했습니다.`;
        } else {
            this.submitManageMessage = `${record.title} 데이터의 이력을 확인했습니다.`;
        }

        this.selectedSubmitManageIds = this.selectedSubmitManageIds.filter((id) => id !== record.id);
        await this.renderSafely();
    }

    public async deleteSelectedSubmitManageRecords() {
        if (!this.selectedSubmitManageIds.length) {
            this.submitManageMessage = '삭제할 데이터를 선택해 주세요.';
            await this.renderSafely();
            return;
        }

        const count = this.selectedSubmitManageIds.length;
        this.submitDraftRecords = this.submitDraftRecords.filter((record) => !this.selectedSubmitManageIds.includes(record.id));
        this.submitArchivedRecords = this.submitArchivedRecords.filter((record) => !this.selectedSubmitManageIds.includes(record.id));
        this.selectedSubmitManageIds = [];
        this.submitManageMessage = `선택한 ${count}건의 데이터를 삭제했습니다.`;
        await this.renderSafely();
    }

    public async setSubmitApprovalTab(tab: SubmitApprovalTabId) {
        this.activeSubmitApprovalTab = tab;
        const firstRecord = this.submitApprovalRecords.find((record) => record.status === tab);
        if (firstRecord) this.selectedSubmitApprovalId = firstRecord.id;
        await this.renderSafely();
    }

    public async selectSubmitApproval(record: SubmitApprovalRecord) {
        this.selectedSubmitApprovalId = record.id;
        await this.renderSafely();
    }

    public async setHomeProviderTab(tab: HomeProviderTabId) {
        this.activeHomeProviderTab = tab;
        this.homeProviderSlideIndex = 0;
        await this.renderSafely();
    }

    public async moveHomeProviderSlide(delta: number) {
        const total = this.activeHomeProviderTabData.items.length;
        if (!total) return;

        this.homeProviderSlideIndex = (this.homeProviderSlideIndex + delta + total) % total;
        await this.renderSafely();
    }

    public async moveScienceSlide(delta: number) {
        const total = this.scienceFields.length;
        if (!total) return;

        this.scienceSlideIndex = (this.scienceSlideIndex + delta + total) % total;
        await this.renderSafely();
    }

    public async openScienceFieldSearch(field: HomeScienceField) {
        const subject = field.label.trim();
        if (!subject) return;

        this.searchText = '';
        this.appliedSearchText = '';
        this.semanticSearchMode = 'keyword';
        this.applyDatasetSubjectFilter(subject);

        await this.go(`/search/datasets?subject=${encodeURIComponent(subject)}`);
    }

    public async setHomeBoardTab(tab: HomeBoardTabId, restartAutoRolling = false) {
        this.activeHomeBoardTab = tab;
        if (restartAutoRolling) this.startHomeBoardAutoRolling();
        await this.renderSafely();
    }

    public async setHomeDataTab(tab: HomeDataTabId) {
        this.activeHomeDataTab = tab;
        await this.renderSafely();
    }

    public async moveHomeLogoSlide(delta: number) {
        const total = this.homeLogoSlides.length;
        if (!total) return;

        this.activeHomeLinkSlideIndex = (this.activeHomeLinkSlideIndex + delta + total) % total;
        this.startHomeLogoAutoRolling();
        await this.renderSafely();
    }

    private startHomeBoardAutoRolling() {
        this.stopHomeBoardAutoRolling();
        this.homeBoardAutoRollTimer = setInterval(() => {
            const currentIndex = this.boardTabs.findIndex((tab) => tab.id === this.activeHomeBoardTab);
            const nextTab = this.boardTabs[(currentIndex + 1) % this.boardTabs.length];
            this.activeHomeBoardTab = nextTab.id;
            void this.renderSafely();
        }, 5000);
    }

    private stopHomeBoardAutoRolling() {
        if (!this.homeBoardAutoRollTimer) return;

        clearInterval(this.homeBoardAutoRollTimer);
        this.homeBoardAutoRollTimer = null;
    }

    private startHomeLogoAutoRolling() {
        this.stopHomeLogoAutoRolling();
        this.homeLinkAutoRollTimer = setInterval(() => {
            const total = this.homeLogoSlides.length;
            if (!total) return;

            this.activeHomeLinkSlideIndex = (this.activeHomeLinkSlideIndex + 1) % total;
            void this.renderSafely();
        }, 3000);
    }

    private stopHomeLogoAutoRolling() {
        if (!this.homeLinkAutoRollTimer) return;

        clearInterval(this.homeLinkAutoRollTimer);
        this.homeLinkAutoRollTimer = null;
    }

    public async toggleMobileQuickMenu(event?: MouseEvent) {
        event?.stopPropagation();

        if (this.mobileQuickMenuOpen) {
            this.startMobileQuickMenuCloseAnimation();
        } else {
            this.clearQuickMenuCloseTimer();
            this.hideQuickMenuAfterClose = false;
            this.mobileQuickMenuClosing = false;
            this.mobileQuickMenuOpen = true;
        }

        this.resetQuickMenuFollowOffset();
        this.lastQuickMenuScrollY = typeof window === 'undefined' ? 0 : window.scrollY;
        await this.renderSafely();
    }

    public async closeMobileQuickMenu(event?: MouseEvent) {
        event?.stopPropagation();
        this.startMobileQuickMenuCloseAnimation();
        await this.renderSafely();
    }

    public async scrollToTop() {
        if (this.mobileQuickMenuOpen) {
            this.startMobileQuickMenuCloseAnimation(true);
        } else {
            this.mobileQuickMenuOpen = false;
            this.mobileQuickMenuClosing = false;
            this.clearQuickMenuCloseTimer();
            this.hideQuickMenuAfterClose = false;
            this.resetQuickMenuFollowOffset();
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
        await this.renderSafely();
    }

    private startMobileQuickMenuCloseAnimation(hideAfterClose = false) {
        const shouldAnimate = this.mobileQuickMenuVisible && this.mobileQuickMenuOpen;

        this.mobileQuickMenuOpen = false;
        this.mobileQuickMenuClosing = shouldAnimate;
        this.hideQuickMenuAfterClose = shouldAnimate && hideAfterClose;
        this.resetQuickMenuFollowOffset();
        this.clearQuickMenuCloseTimer();

        if (!shouldAnimate) {
            this.hideQuickMenuAfterClose = false;
            return;
        }

        this.quickMenuCloseTimer = setTimeout(() => {
            this.quickMenuCloseTimer = null;
            if (!this.mobileQuickMenuClosing) return;

            this.mobileQuickMenuClosing = false;
            if (this.hideQuickMenuAfterClose) {
                this.mobileQuickMenuVisible = false;
                this.hideQuickMenuAfterClose = false;
            }

            void this.renderSafely();
        }, 380);
    }

    private updateQuickMenuScrollFollow() {
        if (typeof window === 'undefined') return false;

        const currentY = window.scrollY;
        const delta = currentY - this.lastQuickMenuScrollY;
        this.lastQuickMenuScrollY = currentY;

        if (!this.shouldAnimateQuickMenuFollow()) {
            return this.resetQuickMenuFollowOffset();
        }

        if (Math.abs(delta) < 2) return false;

        const nextOffset = Math.max(-22, Math.min(22, delta * 0.28));
        if (Math.abs(nextOffset - this.quickMenuFollowOffset) < 0.5) return false;

        this.quickMenuFollowOffset = nextOffset;
        this.scheduleQuickMenuFollowReset();
        return true;
    }

    private scheduleQuickMenuFollowReset() {
        this.clearQuickMenuFollowTimer();
        this.quickMenuFollowTimer = setTimeout(() => {
            this.quickMenuFollowTimer = null;
            if (this.quickMenuFollowOffset === 0) return;

            this.quickMenuFollowOffset = 0;
            void this.renderSafely();
        }, 170);
    }

    private resetQuickMenuFollowOffset() {
        this.clearQuickMenuFollowTimer();
        if (this.quickMenuFollowOffset === 0) return false;

        this.quickMenuFollowOffset = 0;
        return true;
    }

    private clearQuickMenuFollowTimer() {
        if (!this.quickMenuFollowTimer) return;

        clearTimeout(this.quickMenuFollowTimer);
        this.quickMenuFollowTimer = null;
    }

    private clearQuickMenuCloseTimer() {
        if (!this.quickMenuCloseTimer) return;

        clearTimeout(this.quickMenuCloseTimer);
        this.quickMenuCloseTimer = null;
    }

    private shouldAnimateQuickMenuFollow() {
        if (!this.isHomePage || typeof window === 'undefined') return false;

        if (window.matchMedia('(max-width: 1757px)').matches) {
            return this.mobileQuickMenuVisible && this.mobileQuickMenuOpen;
        }

        return false;
    }

    private updateMobileQuickMenuVisibility() {
        let nextVisible = this.shouldShowMobileQuickMenu();
        const nextOfficialFixed = this.shouldFixOfficialDesktopQuickMenu();
        const wasOpen = this.mobileQuickMenuOpen;
        const wasOfficialFixed = this.quickMenuOfficialFixed;
        const wasFollowOffset = this.quickMenuFollowOffset;

        if (!nextVisible) {
            if (this.mobileQuickMenuOpen && this.mobileQuickMenuVisible) {
                this.startMobileQuickMenuCloseAnimation(true);
                nextVisible = true;
            } else if (this.mobileQuickMenuClosing) {
                nextVisible = true;
            } else {
                this.mobileQuickMenuOpen = false;
                this.mobileQuickMenuClosing = false;
                this.hideQuickMenuAfterClose = false;
                this.clearQuickMenuCloseTimer();
                this.resetQuickMenuFollowOffset();
            }
        }

        const changed = this.mobileQuickMenuVisible !== nextVisible || wasOpen !== this.mobileQuickMenuOpen || wasOfficialFixed !== nextOfficialFixed || wasFollowOffset !== this.quickMenuFollowOffset;
        this.mobileQuickMenuVisible = nextVisible;
        this.quickMenuOfficialFixed = nextOfficialFixed;
        return changed;
    }

    private shouldShowMobileQuickMenu() {
        if (!this.isHomePage || typeof window === 'undefined') return false;
        if (!window.matchMedia('(max-width: 1757px)').matches) return false;

        return window.scrollY >= this.getQuickMenuRevealOffset();
    }

    private shouldFixOfficialDesktopQuickMenu() {
        if (!this.isHomePage || typeof window === 'undefined') return false;

        return window.scrollY >= 920;
    }

    private getQuickMenuRevealOffset() {
        return 720;
    }

    public isAssetIcon(icon?: string) {
        return Boolean(icon && icon.startsWith('/'));
    }

    public async activateNavPanel(index: number) {
        if (this.suppressedNavIndex === index || this.activeNavIndex === index) return;

        this.activeNavIndex = index;
        await this.renderSafely();
    }

    public async clearActiveNavPanel() {
        if (this.activeNavIndex === null && this.suppressedNavIndex === null) return;

        this.activeNavIndex = null;
        this.suppressedNavIndex = null;
        await this.renderSafely();
    }

    public async suppressNavPanel(event: MouseEvent, index: number) {
        event.preventDefault();
        event.stopPropagation();
        this.activeNavIndex = null;
        this.suppressedNavIndex = index;

        const target = event.currentTarget as HTMLElement | null;
        target?.blur();

        await this.renderSafely();
    }

    public async clearNavPanelSuppression(index: number) {
        if (this.suppressedNavIndex !== index) return;

        this.suppressedNavIndex = null;
        await this.renderSafely();
    }

    public async submitSearch() {
        const keyword = this.searchText.trim();
        const query = keyword ? `?q=${encodeURIComponent(keyword)}` : '';
        this.datasetSearchPage = 1;
        this.appliedSearchText = keyword;
        const searchPath = this.getSearchSubmitPath();
        await this.go(`${searchPath}${query}`);
        if (searchPath === '/search/semantic') {
            this.semanticSearchMode = 'semantic';
            await this.renderSafely();
        }
    }

    private getSearchSubmitPath() {
        if (!this.isDatasetSearchPage) {
            return this.semanticSearchMode === 'semantic' ? '/search/semantic' : '/search/datasets';
        }

        const currentPage = this.currentSearchMenuPage;
        if (currentPage.id === 'semantic' || (this.semanticSearchMode === 'semantic' && ['datasets', 'integrated', 'detail'].includes(currentPage.id))) {
            return '/search/semantic';
        }

        return currentPage.path;
    }

    private appendSearchQuery(path: string, keyword: string) {
        const delimiter = path.includes('?') ? '&' : '?';
        return `${path}${delimiter}q=${encodeURIComponent(keyword)}`;
    }

    public async openMapSearchFromHero() {
        const keyword = this.searchText.trim();
        const query = keyword ? `?q=${encodeURIComponent(keyword)}` : '';
        await this.go(`/search/map${query}`);
    }

    public async runSearchAction(action: LinkItem) {
        if (action.path === '/search/detail') {
            await this.toggleAdvancedSearchPanel();
            return;
        }

        await this.go(action.path);
    }

    public async clearDatasetSearchQuery() {
        this.searchText = '';
        this.appliedSearchText = '';
        this.resultWithinSearchText = '';
        this.appliedResultWithinSearchText = '';
        this.datasetSearchPage = 1;
        await this.go(this.isDatasetSearchPage ? this.currentSearchMenuPage.path : '/search/datasets');
    }

    public async applyResultWithinKeywordSearch() {
        this.appliedResultWithinSearchText = this.resultWithinSearchText.trim();
        this.datasetSearchPage = 1;
        await this.renderSafely();
    }

    public async clearResultWithinKeywordSearch() {
        this.resultWithinSearchText = '';
        this.appliedResultWithinSearchText = '';
        this.datasetSearchPage = 1;
        await this.renderSafely();
    }

    public async toggleAdvancedSearchPanel() {
        if (!this.advancedSearchOpen) {
            this.syncAdvancedSearchDraftFromApplied();
        }

        this.advancedSearchOpen = !this.advancedSearchOpen;
        this.searchHelpOpen = false;
        await this.renderSafely();
    }

    public async cancelAdvancedSearchConditions() {
        this.syncAdvancedSearchDraftFromApplied();
        this.advancedSearchOpen = false;
        await this.renderSafely();
    }

    public async setAdvancedSearchDraftMatchMode(mode: DatasetSearchConditionMode) {
        this.advancedSearchDraftMatchMode = mode;
        await this.renderSafely();
    }

    public isResultFilterOptionSelected(fieldKey: DatasetSearchAdvancedFieldKey, optionValue: string) {
        return (this.advancedSearchDraft[fieldKey] || []).includes(optionValue);
    }

    public isResultFilterGroupOpen(groupKey: string) {
        return this.resultFilterAccordionOpen[groupKey] !== false;
    }

    public async toggleResultFilterGroup(groupKey: string) {
        this.resultFilterAccordionOpen = {
            ...this.resultFilterAccordionOpen,
            [groupKey]: !this.isResultFilterGroupOpen(groupKey),
        };
        await this.renderSafely();
    }

    public async openResultFiltersPanel() {
        this.mobileResultFiltersOpen = true;
        await this.renderSafely();
    }

    public async closeResultFiltersPanel() {
        this.mobileResultFiltersOpen = false;
        await this.renderSafely();
    }

    public async setDatasetSearchPage(page: number) {
        const nextPage = Math.min(Math.max(page, 1), this.datasetSearchTotalPages);
        if (nextPage === this.datasetSearchPage) return;

        this.datasetSearchPage = nextPage;
        await this.renderSafely();
    }

    public hasDatasetSearchPaginationGap(page: number, index: number) {
        if (index <= 0) return false;
        return page - this.datasetSearchPaginationPages[index - 1] > 1;
    }

    public async toggleResultFilterOption(fieldKey: DatasetSearchAdvancedFieldKey, optionValue: string) {
        const field = this.getResultFilterField(fieldKey);
        if (!field) return;

        const nextDraft = this.cloneAdvancedSearchValues(this.advancedSearchDraft);
        const currentValues = nextDraft[fieldKey] || [];
        const selected = currentValues.includes(optionValue);

        if (field.type === 'single') {
            nextDraft[fieldKey] = selected
                ? (this.isDefaultableAdvancedField(fieldKey) ? ['all'] : [])
                : [optionValue];
            if (fieldKey === 'createdYear' && nextDraft[fieldKey][0] !== 'custom') {
                nextDraft.createdYearStart = [];
                nextDraft.createdYearEnd = [];
            }
        } else {
            const currentEffectiveValues = currentValues.filter((value) => !this.isDefaultAdvancedValue(fieldKey, value));
            nextDraft[fieldKey] = selected
                ? currentEffectiveValues.filter((value) => value !== optionValue)
                : [...currentEffectiveValues, optionValue];

            if (this.isDefaultableAdvancedField(fieldKey) && nextDraft[fieldKey].length === 0) {
                nextDraft[fieldKey] = ['all'];
            }
        }

        this.advancedSearchDraft = nextDraft;
        await this.renderSafely();
    }

    public async applyCreatedYearSidebarFilter() {
        const startYear = this.getCreatedYearRangeDraftValue('createdYearStart');
        const endYear = this.getCreatedYearRangeDraftValue('createdYearEnd');

        this.advancedSearchDraft.createdYearStart = startYear ? [startYear] : [];
        this.advancedSearchDraft.createdYearEnd = endYear ? [endYear] : [];
        this.advancedSearchDraft.createdYear = startYear || endYear ? ['custom'] : ['all'];
        await this.renderSafely();
    }

    public async applyRegisteredYearSidebarFilter() {
        await this.renderSafely();
    }

    public async setResultCreatedYearRangeDraftValue(fieldKey: 'createdYearStart' | 'createdYearEnd', value: string) {
        this.setCreatedYearRangeDraftValue(fieldKey, value);
        const hasCreatedYearRange = Boolean(this.getCreatedYearRangeDraftValue('createdYearStart') || this.getCreatedYearRangeDraftValue('createdYearEnd'));
        this.advancedSearchDraft.createdYear = hasCreatedYearRange ? ['custom'] : ['all'];
        await this.renderSafely();
    }

    public async setResultRegisteredYearRangeDraftValue(fieldKey: 'start' | 'end', value: string) {
        this.setRegisteredYearRangeDraftValue(fieldKey, value);
        await this.renderSafely();
    }

    public async applyResultSidebarFilters() {
        this.appliedAdvancedSearch = this.cloneAdvancedSearchValues(this.advancedSearchDraft);
        this.appliedAdvancedSearchMatchMode = this.advancedSearchDraftMatchMode;
        this.appliedRegisteredYearStart = this.registeredYearStart;
        this.appliedRegisteredYearEnd = this.registeredYearEnd;
        this.datasetSearchPage = 1;
        this.mobileResultFiltersOpen = false;
        await this.renderSafely();
    }

    public async setSearchScope(value: string) {
        const nextValue = this.searchScopeOptions.some((option) => option.value === value) ? value : 'all';
        this.appliedAdvancedSearch.searchScope = [nextValue];
        this.advancedSearchDraft.searchScope = [nextValue];
        this.datasetSearchPage = 1;
        await this.renderSafely();
    }

    public async toggleAdvancedOrganizationFields() {
        this.advancedOrganizationFieldsOpen = !this.advancedOrganizationFieldsOpen;
        await this.renderSafely();
    }

    public async toggleAdvancedProjectIdentifierFields() {
        this.advancedProjectIdentifierFieldsOpen = !this.advancedProjectIdentifierFieldsOpen;
        await this.renderSafely();
    }

    public async toggleAdvancedOptionDraft(fieldKey: DatasetSearchAdvancedFieldKey, optionValue: string) {
        const field = this.getAdvancedSearchField(fieldKey);
        if (!field || field.type === 'text') return;

        if (optionValue === 'all' && this.isDefaultableAdvancedField(fieldKey)) {
            this.advancedSearchDraft[fieldKey] = ['all'];
            if (fieldKey === 'createdYear') {
                this.advancedSearchDraft.createdYearStart = [];
                this.advancedSearchDraft.createdYearEnd = [];
            }
            await this.renderSafely();
            return;
        }

        if (field.type === 'single') {
            this.advancedSearchDraft[fieldKey] = [optionValue];
            if (fieldKey === 'createdYear' && optionValue !== 'custom') {
                this.advancedSearchDraft.createdYearStart = [];
                this.advancedSearchDraft.createdYearEnd = [];
            }
            await this.renderSafely();
            return;
        }

        const currentValues = (this.advancedSearchDraft[fieldKey] || []).filter((value) => !this.isDefaultAdvancedValue(fieldKey, value));
        const nextValues = currentValues.includes(optionValue)
            ? currentValues.filter((value) => value !== optionValue)
            : [...currentValues, optionValue];

        this.advancedSearchDraft[fieldKey] = nextValues.length
            ? nextValues
            : (this.isDefaultableAdvancedField(fieldKey) ? ['all'] : []);
        await this.renderSafely();
    }

    public setCreatedYearRangeDraftValue(fieldKey: 'createdYearStart' | 'createdYearEnd', value: string) {
        const normalizedValue = value.replace(/[^\d]/g, '').slice(0, 4);
        this.advancedSearchDraft[fieldKey] = normalizedValue ? [normalizedValue] : [];
    }

    public getCreatedYearRangeDraftValue(fieldKey: 'createdYearStart' | 'createdYearEnd') {
        return this.advancedSearchDraft[fieldKey]?.[0] || '';
    }

    public setRegisteredYearRangeDraftValue(fieldKey: 'start' | 'end', value: string) {
        const normalizedValue = value.replace(/[^\d]/g, '').slice(0, 4);
        if (fieldKey === 'start') {
            this.registeredYearStart = normalizedValue;
            return;
        }

        this.registeredYearEnd = normalizedValue;
    }

    public getRegisteredYearRangeDraftValue(fieldKey: 'start' | 'end') {
        return fieldKey === 'start' ? this.registeredYearStart : this.registeredYearEnd;
    }

    public setAdvancedTextDraftValue(fieldKey: DatasetSearchAdvancedFieldKey, value: string) {
        this.advancedSearchDraft[fieldKey] = value.trim() ? [value] : [];
    }

    public getAdvancedTextDraftValue(fieldKey: DatasetSearchAdvancedFieldKey) {
        return this.advancedSearchDraft[fieldKey]?.[0] || '';
    }

    public isAdvancedOptionDraftSelected(fieldKey: DatasetSearchAdvancedFieldKey, optionValue: string) {
        return (this.advancedSearchDraft[fieldKey] || []).includes(optionValue);
    }

    public getAdvancedSearchOptions(field: DatasetSearchAdvancedField) {
        const options = field.options || [];
        if (field.type === 'text' || !this.isDefaultableAdvancedField(field.key)) return options;
        if (options.some((option) => option.value === 'all')) return options;

        return [{ label: '전체', value: 'all' }, ...options];
    }

    public isAdvancedAutocompleteField(fieldKey: DatasetSearchAdvancedFieldKey) {
        return !['researcherNumber', 'ntisProjectNumber'].includes(fieldKey)
            && this.advancedSearchProjectFields.some((field) => field.key === fieldKey);
    }

    public async applyAdvancedSearchConditions() {
        this.appliedAdvancedSearch = this.cloneAdvancedSearchValues(this.advancedSearchDraft);
        this.appliedAdvancedSearchMatchMode = this.advancedSearchDraftMatchMode;
        this.advancedSearchOpen = false;
        this.datasetSearchPage = 1;
        await this.renderSafely();
    }

    public async removeAdvancedSearchDraftFilter(fieldKey: DatasetSearchAdvancedFieldKey, optionValue: string) {
        const nextDraft = this.cloneAdvancedSearchValues(this.advancedSearchDraft);
        nextDraft[fieldKey] = nextDraft[fieldKey].filter((value) => value !== optionValue);

        if (this.isDefaultableAdvancedField(fieldKey) && nextDraft[fieldKey].length === 0) {
            nextDraft[fieldKey] = ['all'];
        }

        if (fieldKey === 'createdYear') {
            nextDraft.createdYearStart = [];
            nextDraft.createdYearEnd = [];
        }

        this.advancedSearchDraft = nextDraft;
        await this.renderSafely();
    }

    public async removeAdvancedSearchDraftGroup(fieldKey: DatasetSearchAdvancedFieldKey) {
        const nextDraft = this.cloneAdvancedSearchValues(this.advancedSearchDraft);
        nextDraft[fieldKey] = this.isDefaultableAdvancedField(fieldKey) ? ['all'] : [];

        if (fieldKey === 'createdYear') {
            nextDraft.createdYearStart = [];
            nextDraft.createdYearEnd = [];
        }

        this.advancedSearchDraft = nextDraft;
        await this.renderSafely();
    }

    public async removeDatasetFacetOption(fieldKey: DatasetSearchAdvancedFieldKey, optionValue: string) {
        const nextApplied = this.cloneAdvancedSearchValues(this.appliedAdvancedSearch);
        const nextDraft = this.cloneAdvancedSearchValues(this.advancedSearchDraft);

        nextApplied[fieldKey] = nextApplied[fieldKey].filter((value) => value !== optionValue);
        nextDraft[fieldKey] = nextDraft[fieldKey].filter((value) => value !== optionValue);

        if (this.isDefaultableAdvancedField(fieldKey) && nextApplied[fieldKey].length === 0) {
            nextApplied[fieldKey] = ['all'];
            nextDraft[fieldKey] = ['all'];
        }

        if (fieldKey === 'createdYear') {
            nextApplied.createdYearStart = [];
            nextApplied.createdYearEnd = [];
            nextDraft.createdYearStart = [];
            nextDraft.createdYearEnd = [];
        }

        this.appliedAdvancedSearch = nextApplied;
        this.advancedSearchDraft = nextDraft;
        this.datasetSearchPage = 1;
        await this.renderSafely();
    }

    public async removeRegisteredYearFilter() {
        this.registeredYearStart = '';
        this.registeredYearEnd = '';
        this.appliedRegisteredYearStart = '';
        this.appliedRegisteredYearEnd = '';
        this.datasetSearchPage = 1;
        await this.renderSafely();
    }

    private applyDatasetSubjectFilter(subject: string) {
        const normalizedSubject = subject.trim();
        if (!normalizedSubject) return;

        const nextSearchValues = this.createEmptyAdvancedSearchValues();
        nextSearchValues.subject = [normalizedSubject];

        this.advancedSearchDraft = this.cloneAdvancedSearchValues(nextSearchValues);
        this.appliedAdvancedSearch = this.cloneAdvancedSearchValues(nextSearchValues);
        this.advancedSearchDraftMatchMode = 'all';
        this.appliedAdvancedSearchMatchMode = 'all';
        this.registeredYearStart = '';
        this.registeredYearEnd = '';
        this.appliedRegisteredYearStart = '';
        this.appliedRegisteredYearEnd = '';
        this.mobileResultFiltersOpen = false;
        this.datasetSearchPage = 1;
    }

    public async resetDatasetSearchFilters() {
        this.advancedSearchDraft = this.createEmptyAdvancedSearchValues();
        this.appliedAdvancedSearch = this.createEmptyAdvancedSearchValues();
        this.advancedSearchDraftMatchMode = 'all';
        this.appliedAdvancedSearchMatchMode = 'all';
        this.resultWithinSearchText = '';
        this.appliedResultWithinSearchText = '';
        this.registeredYearStart = '';
        this.registeredYearEnd = '';
        this.appliedRegisteredYearStart = '';
        this.appliedRegisteredYearEnd = '';
        this.mobileResultFiltersOpen = false;
        this.datasetSearchPage = 1;
        await this.renderSafely();
    }

    public async resetResultSidebarFilters() {
        await this.resetDatasetSearchFilters();
    }

    public async setDatasetSearchSort(sort: DatasetSearchSort) {
        this.datasetSearchSort = sort;
        this.datasetSearchPage = 1;
        await this.renderSafely();
    }

    public async setSemanticSearchMode(mode: SemanticSearchMode) {
        this.semanticSearchMode = mode;
        this.datasetSearchPage = 1;
        await this.renderSafely();
    }

    public async submitLogin() {
        this.loginFieldMessages = { userId: '', password: '' };
        const userId = this.loginForm.userId.trim();
        if (!userId) {
            this.loginFieldMessages.userId = '아이디를 입력하세요.';
        }

        if (!this.loginForm.password) {
            this.loginFieldMessages.password = '비밀번호를 입력하세요.';
        }

        if (this.loginFieldMessages.userId || this.loginFieldMessages.password) {
            await this.renderSafely();
            return;
        }

        await this.renderSafely();
    }

    public async requestJoinEmailCode() {
        this.clearJoinFieldMessages(['email']);
        const email = this.joinEmail.address.trim();
        if (!this.isValidEmail(email)) {
            this.joinFieldMessages.email = '이메일 주소를 바르게 입력해 주세요.';
            this.joinFieldMessageTone.email = 'error';
            await this.renderSafely();
            return;
        }

        this.joinEmailCodeSent = true;
        this.joinFieldMessages.email = '인증번호 이메일을 발송했습니다. 발송된 이메일을 확인해 주세요.';
        this.joinFieldMessageTone.email = 'success';
        await this.renderSafely();
    }

    public async continueJoinTerms() {
        if (!this.canContinueTerms()) {
            this.joinMessage = '필수 약관에 동의해 주세요.';
            await this.renderSafely();
            return;
        }

        this.joinStep = 'verify';
        this.joinMessage = '';
        await this.renderSafely();
    }

    public async continueJoinRole() {
        this.joinStep = 'terms';
        this.joinMessage = '';
        await this.renderSafely();
    }

    public async setJoinStep(step: JoinStepId) {
        this.joinStep = step;
        this.joinMessage = '';
        this.clearJoinFieldMessages();
        await this.renderSafely();
    }

    public async selectJoinRole(role: JoinRoleId) {
        this.joinRole = role;
        this.submitUserRole = role;
        this.persistSubmitUserRole(role);
        this.joinMessage = '';
        await this.renderSafely();
    }

    public async submitJoinApproval() {
        this.clearJoinFieldMessages();
        const email = this.joinEmail.address.trim();
        let hasError = false;

        if (!this.joinProfile.name.trim()) {
            this.joinFieldMessages.name = '이름을 입력하세요.';
            this.joinFieldMessageTone.name = 'error';
            hasError = true;
        }

        if (!this.joinProfile.organization.trim()) {
            this.joinFieldMessages.organization = '소속기관을 입력하세요.';
            this.joinFieldMessageTone.organization = 'error';
            hasError = true;
        }

        if (!this.isValidEmail(email)) {
            this.joinFieldMessages.email = '이메일 주소를 바르게 입력해 주세요.';
            this.joinFieldMessageTone.email = 'error';
            hasError = true;
        } else if (!this.joinEmailCodeSent) {
            this.joinFieldMessages.email = '인증번호 요청을 먼저 진행해 주세요.';
            this.joinFieldMessageTone.email = 'error';
            hasError = true;
        }

        if (!this.joinEmail.code.trim()) {
            this.joinFieldMessages.code = '인증번호를 입력해 주세요.';
            this.joinFieldMessageTone.code = 'error';
            hasError = true;
        }

        if (hasError) {
            await this.renderSafely();
            return;
        }

        await this.go('/join/complete');
    }

    public async restartJoin() {
        this.resetJoinFlow();
        this.go('/join');
        await this.renderSafely();
    }

    public isJoinStepComplete(stepId: JoinStepId) {
        const order = this.joinSteps.findIndex((step) => step.id === stepId);
        const current = this.joinSteps.findIndex((step) => step.id === this.joinStep);
        return order > -1 && current > -1 && order < current;
    }

    public canContinueTerms() {
        return this.joinAgreement.terms && this.joinAgreement.privacy && this.joinAgreement.rolePolicy;
    }

    public get allTermsAgreed() {
        return this.canContinueTerms();
    }

    public async setAllTerms(checked: boolean) {
        this.joinAgreement = {
            terms: checked,
            privacy: checked,
            rolePolicy: checked,
        };
        this.joinMessage = '';
        await this.renderSafely();
    }

    public get joinIdentityLabel() {
        return this.joinEmail.address.trim() || '이메일 인증';
    }

    public get selectedJoinRoleLabel() {
        return this.joinRole === 'manager' ? '기관 데이터 관리자' : '일반 사용자';
    }

    public async toggleSearchHelp() {
        await this.setSearchHelpOpen(!this.searchHelpOpen);
    }

    public async setSearchHelpOpen(open: boolean) {
        this.searchHelpOpen = open;
        await this.renderSafely();
    }

    public async loadDatasetPrototype() {
        try {
            const response = await fetch(this.datasetPrototypeUrl, { cache: 'no-store' });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            this.datasetPrototype = await response.json();
            this.datasetPrototypeRawJson = JSON.stringify(this.datasetPrototype, null, 2);
            this.activeDatasetTab = (this.prototypeTabs[0]?.id || 'overview') as DatasetTabId;
            this.selectedDatasetFileId = this.datasetPrototype?.files?.previewViewer?.defaultFileId || this.prototypeSampleFiles[0]?.id || 'file-001';
            this.selectedCitationStyle = this.datasetPrototype?.citationAndSharing?.citationGenerator?.defaultStyle || 'BibTeX';
            this.selectedRelationNodeId = this.relationNodes[0]?.id || 'dataset';
            this.activeRecommendationTab = (this.datasetPrototype?.recommendations?.tabs?.[0] || '논문') as DatasetRecommendationTab;
            this.datasetPrototypeLoadError = '';
        } catch (error) {
            this.datasetPrototypeLoadError = '데이터셋 목데이터를 불러오지 못했습니다.';
        }
    }

    public get mapSearchProviderOptions() {
        return this.buildMapSearchOptions('provider', '제공기관 전체');
    }

    public get mapSearchDataTypeOptions() {
        return this.buildMapSearchOptions('dataType', '데이터 유형 전체');
    }

    public get mapSearchRegisteredYearOptions() {
        return this.buildMapSearchOptions('registeredYear', '등록연도 전체')
            .map((option) => option.value === 'all' ? option : { ...option, label: `${option.label}년` });
    }

    public get filteredMapSearchResults() {
        if (this.mapSearchLoadState !== 'ready') return [];

        const bounds = this.activeMapSearchBounds;
        const results = this.mapSearchDatasets
            .filter((item) => this.isMapSearchDatasetInBounds(item, bounds))
            .filter((item) => this.mapSearchProvider === 'all' || item.provider === this.mapSearchProvider)
            .filter((item) => this.mapSearchDataType === 'all' || item.dataType === this.mapSearchDataType)
            .filter((item) => this.mapSearchRegisteredYear === 'all' || item.registeredYear === this.mapSearchRegisteredYear);

        return this.sortMapSearchResults(results);
    }

    public get mapSearchResultCount() {
        return this.filteredMapSearchResults.length;
    }

    public get selectedMapSearchDataset() {
        return this.mapSearchDatasets.find((item) => item.id === this.mapSearchSelectedId) || null;
    }

    public get mapSearchResultSummary() {
        return `${this.mapSearchAppliedRegion} 영역 ${this.formatNumber(this.mapSearchResultCount)}건`;
    }

    public get mapSearchHasActiveFilters() {
        return this.mapSearchProvider !== 'all'
            || this.mapSearchDataType !== 'all'
            || this.mapSearchRegisteredYear !== 'all';
    }

    public get mapSearchLocationButtonLabel() {
        return this.mapSearchLocationState === 'locating' ? '확인 중' : '내 위치';
    }

    public get mapSearchHasUserLocation() {
        return Boolean(this.mapSearchUserLocation);
    }

    public async loadMapSearchDatasets(force = false) {
        if (!force && (this.mapSearchLoadState === 'loading' || this.mapSearchLoadState === 'ready')) return;

        this.mapSearchLoadState = 'loading';
        this.mapSearchError = '';
        await this.renderSafely();

        try {
            const response = await fetch(this.mapSearchDataUrl, { cache: 'no-store' });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const payload = await response.json();
            const items = Array.isArray(payload) ? payload : payload.datasets;
            if (!Array.isArray(items)) throw new Error('Invalid map dataset payload');

            this.mapSearchDatasets = items
                .map((item) => this.normalizeMapSearchDataset(item))
                .filter((item) => Number.isFinite(item.latitude) && Number.isFinite(item.longitude));
            this.mapSearchBounds = this.mapSearchBounds || this.koreaMapBounds;
            this.mapSearchLoadState = 'ready';
            this.syncMapSearchSelection();
            this.updateKakaoMapSearchMarkers();
        } catch (error) {
            this.mapSearchLoadState = 'error';
            this.mapSearchError = '지도 검색 샘플 데이터를 불러오지 못했습니다.';
            this.mapSearchDatasets = [];
            this.mapSearchSelectedId = '';
        }

        await this.renderSafely();
    }

    public async searchMapRegion() {
        const query = this.mapSearchQuery.trim();
        this.mapSearchError = '';

        if (!query) {
            await this.resetMapSearchView();
            return;
        }

        const region = this.findMapSearchRegion(query);
        if (region) {
            await this.centerMapSearchToRegion(region);
            return;
        }

        const geocoded = await this.centerMapSearchByKakaoAddress(query);
        if (geocoded) return;

        this.mapSearchError = '검색한 지역을 찾지 못했습니다.';
        await this.renderSafely();
    }

    public async setMapSearchFilter(key: MapSearchFilterKey, value: string) {
        if (key === 'provider') this.mapSearchProvider = value;
        if (key === 'dataType') this.mapSearchDataType = value;
        if (key === 'registeredYear') this.mapSearchRegisteredYear = value;

        this.syncMapSearchSelection();
        this.updateKakaoMapSearchMarkers();
        this.updateKakaoMapSearchUserMarker();
        await this.renderSafely();
    }

    public async setMapSearchSort(value: string) {
        this.mapSearchSort = value === 'latest' || value === 'title' ? value : 'relevance';
        this.syncMapSearchSelection();
        await this.renderSafely();
    }

    private async applyMapSearchUserLocation(latitude: number, longitude: number, accuracy: number) {
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
            this.mapSearchLocationState = 'error';
            this.mapSearchLocationMessage = '현재 위치 좌표를 확인하지 못했습니다.';
            await this.renderSafely();
            return;
        }

        const normalizedAccuracy = Number.isFinite(accuracy) ? Math.max(0, Math.round(accuracy)) : 0;
        this.mapSearchUserLocation = {
            latitude,
            longitude,
            accuracy: normalizedAccuracy,
        };
        this.mapSearchLocationState = 'ready';
        this.mapSearchLocationMessage = normalizedAccuracy
            ? `내 위치 기준으로 이동했습니다. 오차 약 ${this.formatMapSearchAccuracy(normalizedAccuracy)}`
            : '내 위치 기준으로 이동했습니다.';
        this.mapSearchAppliedRegion = '내 위치';
        this.mapSearchQuery = '';

        await this.centerMapSearchToCoordinate(
            latitude,
            longitude,
            this.getMapSearchLocationLevel(normalizedAccuracy),
            this.createMapSearchBoundsFromCenter(latitude, longitude, this.getMapSearchLocationBoundsSpan(normalizedAccuracy)),
        );
    }

    private getMapSearchGeolocationErrorMessage(error: GeolocationPositionError) {
        if (error.code === error.PERMISSION_DENIED) {
            return '브라우저 위치 권한이 차단되어 현재 위치를 확인할 수 없습니다.';
        }
        if (error.code === error.POSITION_UNAVAILABLE) {
            return '기기에서 현재 위치 정보를 받을 수 없습니다.';
        }
        if (error.code === error.TIMEOUT) {
            return '현재 위치 확인 시간이 초과되었습니다. 다시 시도해 주세요.';
        }
        return '현재 위치를 확인하지 못했습니다.';
    }

    private getMapSearchLocationLevel(accuracy: number) {
        if (!accuracy || accuracy <= 80) return 4;
        if (accuracy <= 500) return 5;
        if (accuracy <= 2000) return 6;
        return 7;
    }

    private getMapSearchLocationBoundsSpan(accuracy: number) {
        if (!accuracy) return 0.08;
        return this.clampNumber((accuracy / 111000) * 2.5, 0.04, 0.5);
    }

    private formatMapSearchAccuracy(accuracy: number) {
        if (accuracy >= 1000) {
            const kilometers = accuracy / 1000;
            return `${kilometers >= 10 ? Math.round(kilometers) : kilometers.toFixed(1)}km`;
        }
        return `${Math.max(1, Math.round(accuracy))}m`;
    }

    public async resetMapSearchFilters() {
        this.mapSearchProvider = 'all';
        this.mapSearchDataType = 'all';
        this.mapSearchRegisteredYear = 'all';
        this.syncMapSearchSelection();
        this.updateKakaoMapSearchMarkers();
        this.updateKakaoMapSearchUserMarker();
        await this.renderSafely();
    }

    public async toggleMapSearchFilters() {
        this.mapSearchFiltersOpen = !this.mapSearchFiltersOpen;
        await this.renderSafely();
    }

    public async refreshMapSearchData() {
        await this.loadMapSearchDatasets(true);
        await this.activateMapSearchIfNeeded();
    }

    public async searchCurrentMapBounds() {
        this.mapSearchError = '';
        this.updateMapSearchBoundsFromKakaoMap();
        this.syncMapSearchSelection();
        this.updateKakaoMapSearchMarkers();
        await this.renderSafely();
    }

    public async locateMapSearchUser() {
        this.mapSearchError = '';
        this.mapSearchLocationMessage = '';

        if (typeof navigator === 'undefined' || !navigator.geolocation) {
            this.mapSearchLocationState = 'error';
            this.mapSearchLocationMessage = '이 브라우저에서는 현재 위치를 확인할 수 없습니다.';
            await this.renderSafely();
            return;
        }

        const hostname = window.location?.hostname || '';
        const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
        if ((window as any).isSecureContext === false && !isLocalhost) {
            this.mapSearchLocationState = 'error';
            this.mapSearchLocationMessage = '현재 위치는 HTTPS 환경에서만 사용할 수 있습니다.';
            await this.renderSafely();
            return;
        }

        this.mapSearchLocationState = 'locating';
        this.mapSearchLocationMessage = '현재 위치를 확인하고 있습니다.';
        await this.renderSafely();

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                await this.applyMapSearchUserLocation(
                    position.coords.latitude,
                    position.coords.longitude,
                    position.coords.accuracy,
                );
            },
            async (error) => {
                this.mapSearchLocationState = 'error';
                this.mapSearchLocationMessage = this.getMapSearchGeolocationErrorMessage(error);
                await this.renderSafely();
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 60000,
            },
        );
    }

    public async zoomMapSearch(delta: number) {
        const kakaoObject = (window as any).kakao;
        if (this.mapSearchMapReady && this.mapSearchMap && kakaoObject?.maps) {
            const currentLevel = this.mapSearchMap.getLevel();
            this.mapSearchMap.setLevel(Math.max(1, Math.min(14, currentLevel + delta)));
            this.updateMapSearchBoundsFromKakaoMap();
        } else {
            this.zoomFallbackMapSearchBounds(delta);
        }

        this.syncMapSearchSelection();
        this.updateKakaoMapSearchMarkers();
        await this.renderSafely();
    }

    public async resetMapSearchView() {
        this.mapSearchQuery = '';
        this.mapSearchAppliedRegion = '전국';
        this.mapSearchError = '';
        this.mapSearchBounds = this.koreaMapBounds;

        const kakaoObject = (window as any).kakao;
        if (this.mapSearchMapReady && this.mapSearchMap && kakaoObject?.maps) {
            this.mapSearchMap.setCenter(new kakaoObject.maps.LatLng(this.defaultMapSearchCenter.latitude, this.defaultMapSearchCenter.longitude));
            this.mapSearchMap.setLevel(13);
            this.updateMapSearchBoundsFromKakaoMap();
        }

        this.syncMapSearchSelection();
        this.updateKakaoMapSearchMarkers();
        await this.renderSafely();
    }

    public async selectMapSearchDataset(dataset: MapSearchDataset, openInfo = true) {
        this.mapSearchSelectedId = dataset.id;

        if (this.mapSearchMapReady && this.mapSearchMap) {
            const kakaoObject = (window as any).kakao;
            const marker = this.mapSearchMarkers.find((item) => item.__dataonDatasetId === dataset.id);
            if (kakaoObject?.maps) {
                const position = new kakaoObject.maps.LatLng(dataset.latitude, dataset.longitude);
                this.mapSearchMap.panTo(position);
            }
            if (openInfo && marker) this.openMapSearchInfoWindow(dataset, marker);
        }

        await this.renderSafely();
    }

    public async openMapSearchDatasetDetail(dataset: MapSearchDataset) {
        await this.go(dataset.path || '/search/datasets/detail');
    }

    public getFallbackMapMarkerLeft(dataset: MapSearchDataset) {
        return this.getFallbackMapCoordinateLeft(dataset.longitude);
    }

    public getFallbackMapMarkerTop(dataset: MapSearchDataset) {
        return this.getFallbackMapCoordinateTop(dataset.latitude);
    }

    public getFallbackMapUserLocationLeft() {
        if (!this.mapSearchUserLocation) return 50;
        return this.getFallbackMapCoordinateLeft(this.mapSearchUserLocation.longitude);
    }

    public getFallbackMapUserLocationTop() {
        if (!this.mapSearchUserLocation) return 50;
        return this.getFallbackMapCoordinateTop(this.mapSearchUserLocation.latitude);
    }

    public getMapSearchUserLocationLabel() {
        if (!this.mapSearchUserLocation?.accuracy) return '내 위치';
        return `내 위치, 오차 약 ${this.formatMapSearchAccuracy(this.mapSearchUserLocation.accuracy)}`;
    }

    private getFallbackMapCoordinateLeft(longitude: number) {
        const bounds = this.activeMapSearchBounds;
        const span = Math.max(0.0001, bounds.east - bounds.west);
        return this.clampNumber(((longitude - bounds.west) / span) * 100, 5, 95);
    }

    private getFallbackMapCoordinateTop(latitude: number) {
        const bounds = this.activeMapSearchBounds;
        const span = Math.max(0.0001, bounds.north - bounds.south);
        return this.clampNumber((1 - ((latitude - bounds.south) / span)) * 100, 7, 93);
    }

    public getMapSearchMarkerLabel(dataset: MapSearchDataset) {
        return dataset.region.slice(0, 2);
    }

    public async activateMapSearchIfNeeded() {
        if (!this.isMapSearchPage) return;

        await this.loadMapSearchDatasets();
        if (this.mapSearchLoadState === 'error') return;

        if (this.mapSearchMap) {
            this.relayoutKakaoMapSearch();
            this.updateMapSearchBoundsFromKakaoMap();
            this.updateKakaoMapSearchMarkers();
            this.updateKakaoMapSearchUserMarker();
            await this.applyMapSearchRouteQueryIfNeeded();
            return;
        }

        if (this.mapSearchInitializationRequested) return;
        this.mapSearchInitializationRequested = true;

        await new Promise<void>((resolve) => {
            window.setTimeout(async () => {
                try {
                    await this.initializeMapSearchMap();
                } finally {
                    this.mapSearchInitializationRequested = false;
                    resolve();
                }
            }, 0);
        });

        await this.applyMapSearchRouteQueryIfNeeded();
    }

    private async applyMapSearchRouteQueryIfNeeded() {
        const query = this.mapSearchRouteQuery.trim();
        if (!this.isMapSearchPage || !query || this.mapSearchAppliedRouteQuery === query) return;

        this.mapSearchAppliedRouteQuery = query;
        this.mapSearchQuery = query;
        await this.searchMapRegion();
    }

    private get activeMapSearchBounds() {
        return this.mapSearchBounds || this.koreaMapBounds;
    }

    private normalizeMapSearchDataset(item: any): MapSearchDataset {
        return {
            id: `${item.id || ''}`,
            title: `${item.title || ''}`,
            provider: `${item.provider || ''}`,
            region: `${item.region || ''}`,
            address: `${item.address || ''}`,
            latitude: Number(item.latitude),
            longitude: Number(item.longitude),
            dataType: `${item.dataType || ''}`,
            registeredYear: `${item.registeredYear || ''}`,
            createdYear: `${item.createdYear || ''}`,
            summary: `${item.summary || ''}`,
            keywords: Array.isArray(item.keywords) ? item.keywords.map((keyword: any) => `${keyword}`) : [],
            path: `${item.path || '/search/datasets/detail'}`,
            views: Number(item.views || 0),
            downloads: Number(item.downloads || 0),
        };
    }

    private buildMapSearchOptions(field: MapSearchFilterKey, defaultLabel: string) {
        const counts = new Map<string, number>();
        this.mapSearchDatasets.forEach((item) => {
            const value = `${item[field] || ''}`;
            if (!value) return;
            counts.set(value, (counts.get(value) || 0) + 1);
        });

        const options = Array.from(counts.entries())
            .sort(([left], [right]) => left.localeCompare(right, 'ko-KR'))
            .map(([value, count]) => ({ label: value, value, count }));

        return [{ label: defaultLabel, value: 'all', count: this.mapSearchDatasets.length }, ...options];
    }

    private sortMapSearchResults(results: MapSearchDataset[]) {
        const items = [...results];

        if (this.mapSearchSort === 'latest') {
            return items.sort((left, right) => {
                const yearDiff = Number(right.registeredYear) - Number(left.registeredYear);
                return yearDiff || right.id.localeCompare(left.id, 'ko-KR');
            });
        }

        if (this.mapSearchSort === 'title') {
            return items.sort((left, right) => left.title.localeCompare(right.title, 'ko-KR'));
        }

        return items;
    }

    private isMapSearchDatasetInBounds(dataset: MapSearchDataset, bounds: MapSearchBounds) {
        return this.isMapSearchCoordinateInBounds(dataset.latitude, dataset.longitude, bounds);
    }

    private isMapSearchCoordinateInBounds(latitude: number, longitude: number, bounds: MapSearchBounds) {
        return latitude >= bounds.south
            && latitude <= bounds.north
            && longitude >= bounds.west
            && longitude <= bounds.east;
    }

    private syncMapSearchSelection() {
        const results = this.filteredMapSearchResults;
        if (!results.length) {
            this.mapSearchSelectedId = '';
            return;
        }

        if (!results.some((item) => item.id === this.mapSearchSelectedId)) {
            this.mapSearchSelectedId = results[0].id;
        }
    }

    private findMapSearchRegion(query: string) {
        const normalizedQuery = this.normalizeMapSearchRegionText(query);
        return this.mapSearchRegions.find((region) => {
            const labels = [region.label, ...region.aliases];
            return labels.some((label) => this.normalizeMapSearchRegionText(label) === normalizedQuery);
        }) || null;
    }

    private normalizeMapSearchRegionText(text: string) {
        return `${text || ''}`.replace(/\s+/g, '').toLowerCase();
    }

    private async centerMapSearchToRegion(region: MapSearchRegion) {
        this.mapSearchAppliedRegion = region.label;
        this.mapSearchQuery = region.label === '전국' ? '' : region.label;
        await this.centerMapSearchToCoordinate(region.latitude, region.longitude, region.level, region.bounds);
    }

    private async centerMapSearchByKakaoAddress(query: string) {
        const kakaoObject = (window as any).kakao;
        if (!this.mapSearchMapReady || !kakaoObject?.maps?.services?.Geocoder) return false;

        return await new Promise<boolean>((resolve) => {
            const geocoder = new kakaoObject.maps.services.Geocoder();
            geocoder.addressSearch(query, async (results: any[], status: string) => {
                const successStatus = kakaoObject.maps.services.Status.OK;
                const firstResult = results?.[0];
                if (status !== successStatus || !firstResult) {
                    resolve(false);
                    return;
                }

                const latitude = Number(firstResult.y);
                const longitude = Number(firstResult.x);
                if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
                    resolve(false);
                    return;
                }

                this.mapSearchAppliedRegion = query;
                await this.centerMapSearchToCoordinate(latitude, longitude, 7, this.createMapSearchBoundsFromCenter(latitude, longitude, 0.18));
                resolve(true);
            });
        });
    }

    private async centerMapSearchToCoordinate(latitude: number, longitude: number, level: number, bounds: MapSearchBounds) {
        const kakaoObject = (window as any).kakao;
        this.mapSearchBounds = bounds;

        if (this.mapSearchMapReady && this.mapSearchMap && kakaoObject?.maps) {
            this.mapSearchMap.setCenter(new kakaoObject.maps.LatLng(latitude, longitude));
            this.mapSearchMap.setLevel(level);
            this.updateMapSearchBoundsFromKakaoMap();
        }

        this.syncMapSearchSelection();
        this.updateKakaoMapSearchMarkers();
        this.updateKakaoMapSearchUserMarker();
        await this.renderSafely();
    }

    private async initializeMapSearchMap() {
        if (!this.isMapSearchPage) return;

        const container = document.getElementById('dataon-map-search-canvas');
        if (!container) return;

        const appKey = this.getKakaoMapAppKey();
        if (!appKey) {
            this.mapSearchMapReady = false;
            this.mapSearchMap = null;
            this.mapSearchMapMessage = 'Kakao Maps API 키가 설정되지 않아 샘플 좌표 보기를 표시합니다.';
            this.mapSearchBounds = this.mapSearchBounds || this.koreaMapBounds;
            this.clearKakaoMapSearchUserMarker();
            this.syncMapSearchSelection();
            await this.renderSafely();
            return;
        }

        try {
            await this.loadKakaoMapsSdk(appKey);
            const kakaoObject = (window as any).kakao;
            if (!kakaoObject?.maps?.Map) throw new Error('Kakao maps SDK is not ready');

            this.mapSearchMap = new kakaoObject.maps.Map(container, {
                center: new kakaoObject.maps.LatLng(this.defaultMapSearchCenter.latitude, this.defaultMapSearchCenter.longitude),
                level: 13,
            });
            this.mapSearchClusterer = new kakaoObject.maps.MarkerClusterer({
                map: this.mapSearchMap,
                averageCenter: true,
                minLevel: 7,
                disableClickZoom: false,
            });
            this.mapSearchInfoWindow = new kakaoObject.maps.InfoWindow({ zIndex: 4 });

            kakaoObject.maps.event.addListener(this.mapSearchMap, 'idle', async () => {
                this.updateMapSearchBoundsFromKakaoMap();
                this.syncMapSearchSelection();
                this.updateKakaoMapSearchMarkers();
                await this.renderSafely();
            });

            this.mapSearchMapReady = true;
            this.mapSearchMapMessage = '';
            this.relayoutKakaoMapSearch();
            this.updateMapSearchBoundsFromKakaoMap();
            this.syncMapSearchSelection();
            this.updateKakaoMapSearchMarkers();
            this.updateKakaoMapSearchUserMarker();
        } catch (error) {
            this.mapSearchMapReady = false;
            this.mapSearchMap = null;
            this.mapSearchMapMessage = 'Kakao 지도를 불러오지 못했습니다. 키 또는 지도/로컬 서비스 설정을 확인해 주세요. 샘플 좌표 보기를 표시합니다.';
            this.mapSearchBounds = this.mapSearchBounds || this.koreaMapBounds;
            this.clearKakaoMapSearchUserMarker();
            this.syncMapSearchSelection();
        }

        await this.renderSafely();
    }

    private getKakaoMapAppKey() {
        const urlKey = this.getKakaoMapKeyFromUrl();
        if (urlKey) this.persistKakaoMapKey(urlKey);

        const runtimeEnv = (window as any).__DATAON_ENV__ || {};
        const secondaryEnv = (window as any).__ENV__ || (window as any).env || {};
        const candidates = [
            urlKey,
            runtimeEnv.KAKAO_MAPS_APP_KEY,
            runtimeEnv.KAKAO_MAPS_API_KEY,
            runtimeEnv.KAKAO_MAP_API_KEY,
            runtimeEnv.KAKAO_MAPS_JAVASCRIPT_KEY,
            secondaryEnv.KAKAO_MAPS_APP_KEY,
            secondaryEnv.KAKAO_MAPS_API_KEY,
            secondaryEnv.KAKAO_MAP_API_KEY,
            secondaryEnv.KAKAO_MAPS_JAVASCRIPT_KEY,
            (window as any).DATAON_KAKAO_MAP_KEY,
            (window as any).KAKAO_MAPS_APP_KEY,
            this.getKakaoMapKeyFromMeta('kakao-maps-app-key'),
            this.getKakaoMapKeyFromMeta('kakao-map-app-key'),
            this.getKakaoMapKeyFromStorage(),
        ];

        for (const candidate of candidates) {
            const value = `${candidate || ''}`.trim();
            if (value && value.indexOf('__') !== 0) return value;
        }

        return '';
    }

    private getKakaoMapKeyFromUrl() {
        try {
            const params = new URLSearchParams(window.location.search);
            return `${params.get('kakaoMapKey')
                || params.get('kakao_map_key')
                || params.get('KAKAO_MAPS_APP_KEY')
                || ''}`.trim();
        } catch (error) {
            return '';
        }
    }

    private getKakaoMapKeyFromMeta(name: string) {
        const meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
        return `${meta?.content || ''}`.trim();
    }

    private getKakaoMapKeyFromStorage() {
        const keys = ['DATAON_KAKAO_MAP_KEY', 'KAKAO_MAPS_APP_KEY', 'KAKAO_MAPS_JAVASCRIPT_KEY'];
        for (const key of keys) {
            try {
                const sessionValue = window.sessionStorage?.getItem(key);
                if (sessionValue) return sessionValue;
            } catch (error) {}

            try {
                const localValue = window.localStorage?.getItem(key);
                if (localValue) return localValue;
            } catch (error) {}
        }

        return '';
    }

    private persistKakaoMapKey(appKey: string) {
        try {
            window.sessionStorage?.setItem('DATAON_KAKAO_MAP_KEY', appKey);
        } catch (error) {}
    }

    private loadKakaoMapsSdk(appKey: string) {
        const kakaoObject = (window as any).kakao;
        if (kakaoObject?.maps?.Map) return Promise.resolve();
        if (kakaoObject?.maps?.load) {
            return new Promise<void>((resolve) => kakaoObject.maps.load(resolve));
        }

        if (this.mapSearchKakaoSdkPromise && this.mapSearchKakaoSdkAppKey === appKey) return this.mapSearchKakaoSdkPromise;
        this.mapSearchKakaoSdkAppKey = appKey;

        this.mapSearchKakaoSdkPromise = new Promise<void>((resolve, reject) => {
            const scriptId = 'dataon-kakao-map-sdk';
            const existingScript = document.getElementById(scriptId) as HTMLScriptElement | null;
            const onLoad = () => {
                const loadedKakao = (window as any).kakao;
                if (loadedKakao?.maps?.load) {
                    loadedKakao.maps.load(resolve);
                } else {
                    reject(new Error('Kakao maps SDK load failed'));
                }
            };

            if (existingScript) {
                const currentKey = this.getKakaoMapScriptAppKey(existingScript);
                if (currentKey && currentKey !== appKey) {
                    existingScript.remove();
                } else {
                    if ((existingScript as any).__dataonLoaded) {
                        onLoad();
                        return;
                    }
                    existingScript.addEventListener('load', onLoad, { once: true });
                    existingScript.addEventListener('error', () => reject(new Error('Kakao maps SDK load failed')), { once: true });
                    return;
                }
            }

            const script = document.createElement('script');
            script.id = scriptId;
            script.async = true;
            script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${encodeURIComponent(appKey)}&autoload=false&libraries=services,clusterer`;
            script.onload = () => {
                (script as any).__dataonLoaded = true;
                onLoad();
            };
            script.onerror = () => reject(new Error('Kakao maps SDK load failed'));
            document.head.appendChild(script);
        }).catch((error) => {
            this.mapSearchKakaoSdkPromise = null;
            this.mapSearchKakaoSdkAppKey = '';
            throw error;
        });

        return this.mapSearchKakaoSdkPromise;
    }

    private getKakaoMapScriptAppKey(script: HTMLScriptElement) {
        try {
            const url = new URL(script.src, window.location.origin);
            return `${url.searchParams.get('appkey') || ''}`.trim();
        } catch (error) {
            return '';
        }
    }

    private relayoutKakaoMapSearch() {
        if (!this.mapSearchMapReady || !this.mapSearchMap) return;

        const kakaoObject = (window as any).kakao;
        if (!kakaoObject?.maps) return;

        window.setTimeout(() => {
            this.mapSearchMap.relayout();
            this.updateMapSearchBoundsFromKakaoMap();
            this.updateKakaoMapSearchMarkers();
            this.updateKakaoMapSearchUserMarker();
        }, 0);
    }

    private updateMapSearchBoundsFromKakaoMap() {
        if (!this.mapSearchMapReady || !this.mapSearchMap?.getBounds) return;

        const bounds = this.mapSearchMap.getBounds();
        const southWest = bounds.getSouthWest();
        const northEast = bounds.getNorthEast();
        this.mapSearchBounds = {
            south: southWest.getLat(),
            north: northEast.getLat(),
            west: southWest.getLng(),
            east: northEast.getLng(),
        };
    }

    private updateKakaoMapSearchMarkers() {
        if (!this.mapSearchMapReady || !this.mapSearchMap) return;

        const kakaoObject = (window as any).kakao;
        if (!kakaoObject?.maps?.Marker) return;

        this.clearKakaoMapSearchMarkers();

        this.mapSearchMarkers = this.filteredMapSearchResults.map((dataset) => {
            const marker = new kakaoObject.maps.Marker({
                position: new kakaoObject.maps.LatLng(dataset.latitude, dataset.longitude),
                title: dataset.title,
            });
            marker.__dataonDatasetId = dataset.id;
            kakaoObject.maps.event.addListener(marker, 'click', () => {
                this.selectMapSearchDataset(dataset, true);
            });
            return marker;
        });

        if (this.mapSearchClusterer?.addMarkers) {
            this.mapSearchClusterer.addMarkers(this.mapSearchMarkers);
        } else {
            this.mapSearchMarkers.forEach((marker) => marker.setMap(this.mapSearchMap));
        }
    }

    private updateKakaoMapSearchUserMarker() {
        if (!this.mapSearchUserLocation || !this.mapSearchMapReady || !this.mapSearchMap) {
            this.clearKakaoMapSearchUserMarker();
            return;
        }

        const kakaoObject = (window as any).kakao;
        if (!kakaoObject?.maps?.LatLng || !kakaoObject?.maps?.Marker) return;

        const position = new kakaoObject.maps.LatLng(
            this.mapSearchUserLocation.latitude,
            this.mapSearchUserLocation.longitude,
        );

        if (!this.mapSearchUserMarker) {
            this.mapSearchUserMarker = new kakaoObject.maps.Marker({
                title: '내 위치',
                zIndex: 5,
            });
        }

        this.mapSearchUserMarker.setPosition(position);
        this.mapSearchUserMarker.setMap(this.mapSearchMap);

        if (!kakaoObject.maps.Circle) return;

        const radius = Math.max(30, this.mapSearchUserLocation.accuracy || 80);
        if (!this.mapSearchUserAccuracyCircle) {
            this.mapSearchUserAccuracyCircle = new kakaoObject.maps.Circle({
                strokeWeight: 1,
                strokeColor: '#0A7B6F',
                strokeOpacity: 0.7,
                fillColor: '#0A7B6F',
                fillOpacity: 0.14,
                zIndex: 3,
            });
        }

        this.mapSearchUserAccuracyCircle.setPosition(position);
        this.mapSearchUserAccuracyCircle.setRadius(radius);
        this.mapSearchUserAccuracyCircle.setMap(this.mapSearchMap);
    }

    private clearKakaoMapSearchMarkers() {
        if (this.mapSearchClusterer?.clear) this.mapSearchClusterer.clear();
        this.mapSearchMarkers.forEach((marker) => marker.setMap?.(null));
        this.mapSearchMarkers = [];
    }

    private clearKakaoMapSearchUserMarker() {
        this.mapSearchUserMarker?.setMap?.(null);
        this.mapSearchUserAccuracyCircle?.setMap?.(null);
    }

    private openMapSearchInfoWindow(dataset: MapSearchDataset, marker: any) {
        if (!this.mapSearchInfoWindow || !this.mapSearchMap) return;

        const title = this.escapeHtml(dataset.title);
        const provider = this.escapeHtml(dataset.provider);
        const region = this.escapeHtml(dataset.region);
        const dataType = this.escapeHtml(dataset.dataType);
        const path = this.escapeHtml(dataset.path || '/search/datasets/detail');

        this.mapSearchInfoWindow.setContent(`
            <div class="dataon-map-info-window">
                <strong>${title}</strong>
                <span>${provider}</span>
                <em>${region} · ${dataType}</em>
                <a href="${path}">상세보기</a>
            </div>
        `);
        this.mapSearchInfoWindow.open(this.mapSearchMap, marker);
    }

    private zoomFallbackMapSearchBounds(delta: number) {
        const bounds = this.activeMapSearchBounds;
        const centerLatitude = (bounds.south + bounds.north) / 2;
        const centerLongitude = (bounds.west + bounds.east) / 2;
        const factor = delta < 0 ? 0.65 : 1.35;
        const latitudeSpan = Math.min(5.72, Math.max(0.06, (bounds.north - bounds.south) * factor));
        const longitudeSpan = Math.min(7.6, Math.max(0.06, (bounds.east - bounds.west) * factor));
        const nextBounds = {
            south: centerLatitude - latitudeSpan / 2,
            north: centerLatitude + latitudeSpan / 2,
            west: centerLongitude - longitudeSpan / 2,
            east: centerLongitude + longitudeSpan / 2,
        };

        if (!this.isMapSearchCoordinateInBounds(centerLatitude, centerLongitude, this.koreaMapBounds)) {
            this.mapSearchBounds = {
                south: this.clampNumber(nextBounds.south, -85, 85),
                north: this.clampNumber(nextBounds.north, -85, 85),
                west: this.clampNumber(nextBounds.west, -180, 180),
                east: this.clampNumber(nextBounds.east, -180, 180),
            };
            return;
        }

        this.mapSearchBounds = {
            south: Math.max(this.koreaMapBounds.south, nextBounds.south),
            north: Math.min(this.koreaMapBounds.north, nextBounds.north),
            west: Math.max(this.koreaMapBounds.west, nextBounds.west),
            east: Math.min(this.koreaMapBounds.east, nextBounds.east),
        };
    }

    private createMapSearchBoundsFromCenter(latitude: number, longitude: number, span: number) {
        return {
            south: latitude - span,
            north: latitude + span,
            west: longitude - span,
            east: longitude + span,
        };
    }

    private clampNumber(value: number, min: number, max: number) {
        return Math.min(max, Math.max(min, value));
    }

    private escapeHtml(value: string) {
        return `${value || ''}`
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    public async selectPrototypeTab(tabId: DatasetTabId) {
        this.activeDatasetTab = tabId;
        this.datasetActionMessage = '';
        await this.renderSafely();
    }

    public async toggleDatasetDescription() {
        this.datasetDescriptionExpanded = !this.datasetDescriptionExpanded;
        await this.renderSafely();
    }

    public async setDatasetFileFilter(filter: DatasetFileFilter) {
        this.datasetFileFilter = filter;
        await this.renderSafely();
    }

    public async setDatasetFileViewMode(mode: DatasetFileViewMode) {
        this.datasetFileViewMode = mode;
        await this.renderSafely();
    }

    public async selectPrototypeFile(file: DatasetLooseRecord) {
        this.selectedDatasetFileId = file.id || this.selectedDatasetFileId;
        this.datasetPreviewZoom = 1;
        this.datasetPreviewRotation = 0;
        this.datasetActionMessage = file.previewAvailable === false ? '선택한 파일은 미리보기를 지원하지 않습니다.' : `${file.name || '파일'} 미리보기`;
        await this.renderSafely();
    }

    public async previousPrototypeFile() {
        const files = (this.prototypeFileExplorer.sampleFiles || []) as DatasetLooseRecord[];
        if (!files.length) return;

        const nextIndex = (this.selectedPrototypeFileIndex - 1 + files.length) % files.length;
        await this.selectPrototypeFile(files[nextIndex]);
    }

    public async nextPrototypeFile() {
        const files = (this.prototypeFileExplorer.sampleFiles || []) as DatasetLooseRecord[];
        if (!files.length) return;

        const nextIndex = (this.selectedPrototypeFileIndex + 1) % files.length;
        await this.selectPrototypeFile(files[nextIndex]);
    }

    public async zoomPrototypePreview(delta: number) {
        this.datasetPreviewZoom = Math.min(1.8, Math.max(0.65, Number((this.datasetPreviewZoom + delta).toFixed(2))));
        await this.renderSafely();
    }

    public async fitPrototypePreview() {
        this.datasetPreviewZoom = 1;
        this.datasetPreviewRotation = 0;
        await this.renderSafely();
    }

    public async rotatePrototypePreview() {
        this.datasetPreviewRotation = (this.datasetPreviewRotation + 90) % 360;
        await this.renderSafely();
    }

    public async togglePrototypeFullscreen() {
        this.datasetFullscreenEnabled = !this.datasetFullscreenEnabled;
        await this.renderSafely();
    }

    public async togglePrototypeComparison() {
        this.datasetComparisonEnabled = !this.datasetComparisonEnabled;
        await this.renderSafely();
    }

    public async runPrototypeAction(action: string) {
        if (action === '파일 미리보기') {
            this.activeDatasetTab = 'files';
            this.datasetActionMessage = '파일·미리보기 탭으로 이동했습니다.';
        } else {
            this.datasetActionMessage = `${action} 요청을 준비했습니다.`;
        }
        await this.renderSafely();
    }

    public async selectRelationNode(node: DatasetLooseRecord) {
        this.selectedRelationNodeId = node.id || this.selectedRelationNodeId;
        await this.renderSafely();
    }

    public async setKnowledgeGraphFilter(filter: KnowledgeGraphFilterType) {
        this.knowledgeGraphFilter = filter;
        this.selectedKnowledgeGraphNodeId = this.knowledgeGraphCenterNode.id;
        this.selectedKnowledgeGraphEdgeId = '';
        await this.renderSafely();
    }

    public async selectKnowledgeGraphNode(node: KnowledgeGraphNode) {
        this.selectedKnowledgeGraphNodeId = node.id || this.selectedKnowledgeGraphNodeId;
        this.selectedKnowledgeGraphEdgeId = '';
        this.knowledgeGraphActionMessage = '';
        await this.renderSafely();
    }

    public async selectKnowledgeGraphEdge(edge: KnowledgeGraphEdge) {
        this.selectedKnowledgeGraphEdgeId = edge.id || '';
        const adjacentNodeId = this.getKnowledgeGraphOtherNodeId(edge, this.knowledgeGraphCenterNode.id);
        this.selectedKnowledgeGraphNodeId = adjacentNodeId || edge.target || edge.source || this.selectedKnowledgeGraphNodeId;
        this.knowledgeGraphActionMessage = `${edge.label} 관계를 선택했습니다.`;
        await this.renderSafely();
    }

    public async centerKnowledgeGraphOnSelectedNode() {
        await this.centerKnowledgeGraphOnNode(this.selectedKnowledgeGraphNode);
    }

    public async centerKnowledgeGraphPathNode(node: KnowledgeGraphNode) {
        const index = this.knowledgeGraphPathIds.indexOf(node.id);
        this.knowledgeGraphPathIds = index >= 0 ? this.knowledgeGraphPathIds.slice(0, index + 1) : [...this.knowledgeGraphPathIds, node.id];
        await this.centerKnowledgeGraphOnNode(node, false);
    }

    public async zoomKnowledgeGraph(delta: number) {
        this.knowledgeGraphZoom = Math.min(1.5, Math.max(0.7, Number((this.knowledgeGraphZoom + delta).toFixed(2))));
        await this.renderSafely();
    }

    public async resetKnowledgeGraphView() {
        this.knowledgeGraphCenterNodeId = 'kg-dataset-climate';
        this.selectedKnowledgeGraphNodeId = 'kg-dataset-climate';
        this.selectedKnowledgeGraphEdgeId = '';
        this.knowledgeGraphFilter = 'all';
        this.knowledgeGraphZoom = 1;
        this.knowledgeGraphFullscreen = false;
        this.knowledgeGraphPathIds = ['kg-dataset-climate'];
        this.knowledgeGraphActionMessage = '처음 진입 상태로 1단계 관계를 다시 표시합니다.';
        await this.renderSafely();
    }

    public async toggleKnowledgeGraphFullscreen() {
        this.knowledgeGraphFullscreen = !this.knowledgeGraphFullscreen;
        await this.renderSafely();
    }

    public async openKnowledgeGraphDetail() {
        this.knowledgeGraphActionMessage = `${this.selectedKnowledgeGraphNode.label} 상세보기 화면으로 이동할 준비를 완료했습니다.`;
        await this.renderSafely();
    }

    public getKnowledgeGraphNodeById(id: string) {
        return this.knowledgeGraphNodes.find((node) => node.id === id);
    }

    public getKnowledgeGraphTypeLabel(type: KnowledgeGraphNodeType | string) {
        if (type === 'dataset') return '연구데이터';
        if (type === 'project') return '과제';
        if (type === 'paper') return '논문';
        if (type === 'researcher') return '연구자';
        if (type === 'organization') return '기관';
        if (type === 'keyword') return '키워드';
        if (type === 'equipment') return '기기';
        return `${type || '-'}`;
    }

    public getKnowledgeGraphNodeIcon(type: KnowledgeGraphNodeType | string) {
        if (type === 'dataset') return 'fa-database';
        if (type === 'project') return 'fa-diagram-project';
        if (type === 'paper') return 'fa-file-lines';
        if (type === 'researcher') return 'fa-user';
        if (type === 'organization') return 'fa-building-columns';
        if (type === 'keyword') return 'fa-hashtag';
        if (type === 'equipment') return 'fa-satellite-dish';
        return 'fa-circle-nodes';
    }

    public getKnowledgeGraphNodeRelationCount(node: KnowledgeGraphNode) {
        return this.knowledgeGraphEdges.filter((edge) => edge.source === node.id || edge.target === node.id).length;
    }

    public getKnowledgeGraphNodeShortLabel(node: KnowledgeGraphNode) {
        return node.shortLabel || this.getKnowledgeGraphTypeLabel(node.type);
    }

    public getKnowledgeGraphNodeRadius(node: KnowledgeGraphNode) {
        if (node.id === this.knowledgeGraphCenterNode.id) return 68;
        if (node.type === 'keyword') return 50;
        return 56;
    }

    public getKnowledgeGraphNodeTransform(node: KnowledgeGraphNode) {
        const point = this.getKnowledgeGraphNodePosition(node);
        return `translate(${point.x} ${point.y})`;
    }

    public getKnowledgeGraphNodePosition(node: KnowledgeGraphNode): KnowledgeGraphPoint {
        if (node.id === this.knowledgeGraphCenterNode.id) {
            return { x: 480, y: 300 };
        }

        const nodes = this.visibleRelatedKnowledgeGraphNodes;
        const index = Math.max(0, nodes.findIndex((item) => item.id === node.id));
        const positions = [
            { x: 480, y: 104 },
            { x: 710, y: 170 },
            { x: 735, y: 405 },
            { x: 520, y: 514 },
            { x: 280, y: 472 },
            { x: 214, y: 256 },
            { x: 338, y: 138 },
            { x: 650, y: 506 },
        ];

        return positions[index % positions.length];
    }

    public getKnowledgeGraphEdgePath(edge: KnowledgeGraphEdge) {
        const sourceNode = this.getKnowledgeGraphNodeById(edge.source);
        const targetNode = this.getKnowledgeGraphNodeById(edge.target);
        if (!sourceNode || !targetNode) return '';

        const source = this.getKnowledgeGraphNodePosition(sourceNode);
        const target = this.getKnowledgeGraphNodePosition(targetNode);
        return `M ${source.x} ${source.y} L ${target.x} ${target.y}`;
    }

    public getKnowledgeGraphEdgeLabelX(edge: KnowledgeGraphEdge) {
        const sourceNode = this.getKnowledgeGraphNodeById(edge.source);
        const targetNode = this.getKnowledgeGraphNodeById(edge.target);
        if (!sourceNode || !targetNode) return 0;

        const source = this.getKnowledgeGraphNodePosition(sourceNode);
        const target = this.getKnowledgeGraphNodePosition(targetNode);
        return Math.round((source.x + target.x) / 2);
    }

    public getKnowledgeGraphEdgeLabelY(edge: KnowledgeGraphEdge) {
        const sourceNode = this.getKnowledgeGraphNodeById(edge.source);
        const targetNode = this.getKnowledgeGraphNodeById(edge.target);
        if (!sourceNode || !targetNode) return 0;

        const source = this.getKnowledgeGraphNodePosition(sourceNode);
        const target = this.getKnowledgeGraphNodePosition(targetNode);
        return Math.round((source.y + target.y) / 2) - 8;
    }

    public getKnowledgeGraphEdgeEndpointLabel(edge: KnowledgeGraphEdge, endpoint: 'source' | 'target') {
        return this.getKnowledgeGraphNodeById(edge[endpoint])?.label || '-';
    }

    private async centerKnowledgeGraphOnNode(node: KnowledgeGraphNode, appendPath = true) {
        this.knowledgeGraphCenterNodeId = node.id;
        this.selectedKnowledgeGraphNodeId = node.id;
        this.selectedKnowledgeGraphEdgeId = '';
        this.knowledgeGraphZoom = 1;
        this.knowledgeGraphActionMessage = `${node.label}을 중심으로 직접 연결된 1단계 관계를 표시합니다.`;

        if (appendPath) {
            const existingIndex = this.knowledgeGraphPathIds.indexOf(node.id);
            this.knowledgeGraphPathIds = existingIndex >= 0
                ? this.knowledgeGraphPathIds.slice(0, existingIndex + 1)
                : [...this.knowledgeGraphPathIds, node.id];
        }

        await this.renderSafely();
    }

    private matchesKnowledgeGraphFilter(edge: KnowledgeGraphEdge) {
        if (this.knowledgeGraphFilter === 'all') return true;

        const otherNodeId = this.getKnowledgeGraphOtherNodeId(edge, this.knowledgeGraphCenterNode.id);
        const otherNode = this.getKnowledgeGraphNodeById(otherNodeId);
        return otherNode?.type === this.knowledgeGraphFilter;
    }

    private getKnowledgeGraphOtherNodeId(edge: KnowledgeGraphEdge, nodeId: string) {
        if (edge.source === nodeId) return edge.target;
        if (edge.target === nodeId) return edge.source;
        return edge.target;
    }

    public async selectCitationStyle(style: string) {
        this.selectedCitationStyle = style as DatasetCitationStyle;
        this.copiedCitationMessage = '';
        await this.renderSafely();
    }

    public async copyCitation() {
        await this.copyText(this.selectedCitationText);
        this.copiedCitationMessage = '인용정보를 복사했습니다.';
        await this.renderSafely();
    }

    public async copyShareUrl() {
        await this.copyText(this.prototypeCitation.share?.shareUrl || window.location.href);
        this.copiedCitationMessage = '공유 URL을 복사했습니다.';
        await this.renderSafely();
    }

    public async toggleRawMetadata() {
        this.rawMetadataOpen = !this.rawMetadataOpen;
        await this.renderSafely();
    }

    public async selectRecommendationTab(tab: string) {
        this.activeRecommendationTab = tab as DatasetRecommendationTab;
        await this.renderSafely();
    }

    public getPrototypeFolderLabel(folder: string) {
        const folders = (this.prototypeFileExplorer.folders || []) as DatasetLooseRecord[];
        return folders.find((item) => item.name === folder)?.label || folder || '';
    }

    public getPrototypeFileIcon(file: DatasetLooseRecord) {
        if (file.type === 'archive') return 'fa-file-zipper';
        if (file.type === 'folder') return 'fa-folder';
        return 'fa-image';
    }

    public getPrototypeActionIcon(action: string) {
        if (action.includes('다운로드')) return 'fa-download';
        if (action.includes('분석')) return 'fa-chart-line';
        if (action.includes('드라이브') || action.includes('저장')) return 'fa-folder-plus';
        if (action.includes('관심')) return 'fa-star';
        return 'fa-eye';
    }

    public getPreviewClass(file: DatasetLooseRecord) {
        const folder = `${file.folder || ''}`;
        if (folder.includes('label')) return 'is-label';
        if (folder.includes('Sen2')) return 'is-sentinel';
        if (file.type === 'archive') return 'is-archive';
        return 'is-kompsat';
    }

    public getRelationNodeIcon(type: string) {
        if (type === 'dataset') return 'fa-database';
        if (type === 'person') return 'fa-user';
        if (type === 'project') return 'fa-diagram-project';
        if (type === 'organization') return 'fa-building-columns';
        if (type === 'repository') return 'fa-box-archive';
        return 'fa-circle-nodes';
    }

    private getInitialLanguage(): LanguageCode {
        if (typeof window !== 'undefined') {
            const routeLanguage = this.getLanguageFromPath(window.location.pathname);
            if (routeLanguage) return routeLanguage;
        }

        try {
            const savedLanguage = window.localStorage?.getItem(DATAON_LANGUAGE_STORAGE_KEY);
            if (savedLanguage === 'ko' || savedLanguage === 'en') return savedLanguage;
        } catch (e) {
            return 'ko';
        }

        return 'ko';
    }

    private getInitialSubmitUserRole(): JoinRoleId {
        try {
            const savedRole = window.localStorage?.getItem(DATAON_SUBMIT_ROLE_STORAGE_KEY);
            if (savedRole === 'manager' || savedRole === 'general') return savedRole;
        } catch (e) {
            return 'general';
        }

        return 'general';
    }

    private persistSubmitUserRole(role: JoinRoleId) {
        if (typeof window === 'undefined') return;

        try {
            window.localStorage?.setItem(DATAON_SUBMIT_ROLE_STORAGE_KEY, role);
        } catch (e) {
            // Local storage can be unavailable in restricted browser contexts.
        }
    }

    private getLanguageFromPath(path: string): LanguageCode | null {
        const pathname = this.normalizePath(path);
        const firstSegment = pathname.split('/').filter(Boolean)[0]?.toLowerCase();
        if (firstSegment === 'en' || firstSegment === 'eng') return 'en';
        if (firstSegment === 'ko' || firstSegment === 'kor') return 'ko';
        return null;
    }

    private stripLanguageFromPath(path: string) {
        const pathname = this.normalizePath(path);
        const segments = pathname.split('/').filter(Boolean);
        const firstSegment = segments[0]?.toLowerCase();
        if (!['en', 'eng', 'ko', 'kor'].includes(firstSegment)) return pathname;

        const nextPath = segments.slice(1).join('/');
        return nextPath ? `/${nextPath}` : '/';
    }

    private applyLanguage(language: LanguageCode, persist = true) {
        this.currentLanguage = language;

        if (typeof document !== 'undefined') {
            document.documentElement.lang = language;
        }

        if (persist && typeof window !== 'undefined') {
            try {
                window.localStorage?.setItem(DATAON_LANGUAGE_STORAGE_KEY, language);
            } catch (e) {
                // Local storage can be unavailable in restricted browser contexts.
            }
        }

        const app = this.service?.app as any;
        app?.translate?.use?.(language);
        if (this.service?.lang) this.service.lang.value = language;
    }

    private applyRuntimeLanguage() {
        if (typeof document === 'undefined') return;

        const root = document.querySelector('.dataon-page');
        if (!root) return;

        root.setAttribute('data-language', this.currentLanguage);
        this.applyRuntimeTextTranslations(root);
        this.applyRuntimeAttributeTranslations(root);
    }

    private applyRuntimeTextTranslations(root: Element) {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
            acceptNode: (node) => {
                const text = node as Text;
                const parent = text.parentElement;
                if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(parent.tagName)) {
                    return NodeFilter.FILTER_REJECT;
                }

                if (this.runtimeTextTranslations.has(text) || this.hasRuntimeTranslatableText(text.textContent || '')) {
                    return NodeFilter.FILTER_ACCEPT;
                }

                return NodeFilter.FILTER_REJECT;
            },
        });

        let node = walker.nextNode() as Text | null;
        while (node) {
            this.applyRuntimeTextTranslation(node);
            node = walker.nextNode() as Text | null;
        }
    }

    private applyRuntimeTextTranslation(node: Text) {
        const current = node.textContent || '';
        const previous = this.runtimeTextTranslations.get(node);
        const original = previous && (current === previous.translated || current === previous.original)
            ? previous.original
            : current;
        const translated = this.currentLanguage === 'en'
            ? this.translateRuntimeText(original)
            : original;

        this.runtimeTextTranslations.set(node, { original, translated });
        if (current !== translated) node.textContent = translated;
    }

    private applyRuntimeAttributeTranslations(root: Element) {
        const attributes = ['aria-label', 'title', 'alt', 'placeholder'];
        const elements: Element[] = [root, ...Array.from(root.querySelectorAll('*'))];

        for (const element of elements) {
            for (const attribute of attributes) {
                const current = element.getAttribute(attribute);
                if (!current) continue;

                const previousMap = this.runtimeAttributeTranslations.get(element) || {};
                const previous = previousMap[attribute];
                if (!previous && !this.hasRuntimeTranslatableText(current)) continue;

                const original = previous && (current === previous.translated || current === previous.original)
                    ? previous.original
                    : current;
                const translated = this.currentLanguage === 'en'
                    ? this.translateRuntimeText(original)
                    : original;

                previousMap[attribute] = { original, translated };
                this.runtimeAttributeTranslations.set(element, previousMap);
                if (current !== translated) element.setAttribute(attribute, translated);
            }
        }
    }

    private hasRuntimeTranslatableText(value: string) {
        const normalized = this.normalizeRuntimeText(value);
        return /[가-힣]/.test(normalized) || Object.prototype.hasOwnProperty.call(DATAON_EN_TRANSLATIONS, normalized);
    }

    private translateRuntimeText(value: string) {
        if (!value.trim()) return value;

        const leading = value.match(/^\s*/)?.[0] || '';
        const trailing = value.match(/\s*$/)?.[0] || '';
        const body = value.slice(leading.length, value.length - trailing.length);
        const normalized = this.normalizeRuntimeText(body);
        if (!normalized) return value;

        const translated = this.translateNormalizedRuntimeText(normalized);
        if (translated === normalized) return value;

        return `${leading}${translated}${trailing}`;
    }

    private normalizeRuntimeText(value: string) {
        return value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    }

    private translateNormalizedRuntimeText(value: string): string {
        const exact = DATAON_EN_TRANSLATIONS[value];
        if (exact !== undefined) return exact;

        const appliedFilterMatch = value.match(/^(.+): (.+)$/);
        if (appliedFilterMatch) {
            const label = this.translateNormalizedRuntimeText(appliedFilterMatch[1]);
            const displayValue = this.translateNormalizedRuntimeText(appliedFilterMatch[2]);
            if (label !== appliedFilterMatch[1] || displayValue !== appliedFilterMatch[2]) {
                return `${label}: ${displayValue}`;
            }
        }

        const nodeRelationMatch = value.match(/^([\d,]+)개 노드 \/ ([\d,]+)개 관계$/);
        if (nodeRelationMatch) return `${nodeRelationMatch[1]} nodes / ${nodeRelationMatch[2]} relationships`;

        const areaCountMatch = value.match(/^(.+) 영역 ([\d,]+)건$/);
        if (areaCountMatch) return `${areaCountMatch[2]} results in ${this.translateNormalizedRuntimeText(areaCountMatch[1])}`;

        const moreCountMatch = value.match(/^(.+) 외 ([\d,]+)개$/);
        if (moreCountMatch) return `${this.translateNormalizedRuntimeText(moreCountMatch[1])} and ${moreCountMatch[2]} more`;

        const selectedCountMatch = value.match(/^(.+) ([\d,]+)개$/);
        if (selectedCountMatch) {
            const label = this.translateNormalizedRuntimeText(selectedCountMatch[1]);
            if (label !== selectedCountMatch[1]) return `${label} ${selectedCountMatch[2]}`;
        }

        return value;
    }

    public formatPrototypeValue(value: any) {
        if (value === null || value === undefined || value === '') return '-';
        if (typeof value === 'boolean') return this.formatBoolean(value);
        if (Array.isArray(value)) return value.join(', ');
        if (typeof value === 'object') return JSON.stringify(value);
        return value;
    }

    public formatBoolean(value: any) {
        if (value === true) return '동의';
        if (value === false) return '미동의';
        return '-';
    }

    public formatCurrencyKRW(value: number) {
        if (!value && value !== 0) return '-';
        if (this.currentLanguage === 'en') return `KRW ${value.toLocaleString('en-US')}`;
        return `${value.toLocaleString('ko-KR')}원`;
    }

    public getDescriptionText(language: 'ko' | 'en') {
        const text = `${this.prototypeDescription[language] || ''}`;
        if (this.datasetDescriptionExpanded) return text;

        return text.split('\n').slice(0, 7).join('\n');
    }

    private extractCapturedAt(fileName: string) {
        const match = `${fileName || ''}`.match(/_(\d{8})(\d{6})?_/);
        if (!match) return '';

        if (!match[2]) return match[1];
        return `${match[1].slice(0, 4)}-${match[1].slice(4, 6)}-${match[1].slice(6, 8)} ${match[2].slice(0, 2)}:${match[2].slice(2, 4)}:${match[2].slice(4, 6)}`;
    }

    private extractCoordinate(fileName: string, index: number) {
        const matches = `${fileName || ''}`.match(/(-?\d+\.\d+)/g) || [];
        const coordinates = matches.slice(-2).map((value) => Number(value));
        return Number.isFinite(coordinates[index]) ? coordinates[index] : null;
    }

    private async copyText(text: string) {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return;
        }

        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    public async selectDatasetTab(tabId: DatasetTabId) {
        this.activeDatasetTab = tabId;
        this.datasetActionMessage = '';
        await this.renderSafely();
    }

    public async selectDatasetFile(file: DatasetFile) {
        if (file.type !== 'image') {
            this.datasetActionMessage = file.type === 'archive'
                ? 'ZIP 파일은 다운로드 후 확인할 수 있습니다.'
                : '폴더 하위 파일을 선택해 미리보기를 확인하세요.';
            await this.renderSafely();
            return;
        }

        this.selectedDatasetFileId = file.id;
        this.datasetPreviewZoom = 1;
        this.datasetPreviewRotation = 0;
        this.datasetActionMessage = `${file.folder || '파일'} 미리보기를 표시합니다.`;
        await this.renderSafely();
    }

    public async previewDatasetFile(file: DatasetFile) {
        this.activeDatasetTab = 'files';
        await this.selectDatasetFile(file);
    }

    public async previousDatasetFile() {
        const files = this.datasetPreviewFiles;
        if (!files.length) return;

        const currentIndex = Math.max(0, this.selectedDatasetFileIndex);
        const nextIndex = (currentIndex - 1 + files.length) % files.length;
        await this.selectDatasetFile(files[nextIndex]);
    }

    public async nextDatasetFile() {
        const files = this.datasetPreviewFiles;
        if (!files.length) return;

        const currentIndex = Math.max(0, this.selectedDatasetFileIndex);
        const nextIndex = (currentIndex + 1) % files.length;
        await this.selectDatasetFile(files[nextIndex]);
    }

    public async zoomDatasetPreview(delta: number) {
        this.datasetPreviewZoom = Math.min(1.8, Math.max(0.65, Number((this.datasetPreviewZoom + delta).toFixed(2))));
        this.datasetActionMessage = `배율 ${Math.round(this.datasetPreviewZoom * 100)}%`;
        await this.renderSafely();
    }

    public async fitDatasetPreview() {
        this.datasetPreviewZoom = 1;
        this.datasetPreviewRotation = 0;
        this.datasetActionMessage = '화면 맞춤을 적용했습니다.';
        await this.renderSafely();
    }

    public async rotateDatasetPreview() {
        this.datasetPreviewRotation = (this.datasetPreviewRotation + 90) % 360;
        this.datasetActionMessage = `이미지를 ${this.datasetPreviewRotation}도로 회전했습니다.`;
        await this.renderSafely();
    }

    public async runDatasetAction(action: string) {
        if (action === '파일 미리보기') {
            this.activeDatasetTab = 'files';
            this.datasetActionMessage = '파일 미리보기 탭으로 이동했습니다.';
        } else if (action === '바로 분석') {
            this.datasetActionMessage = 'CANVAS 분석 작업을 준비했습니다.';
        } else if (action === '마이드라이브 저장') {
            this.datasetActionMessage = '마이드라이브 저장 요청을 준비했습니다.';
        } else if (action === '다운로드') {
            this.datasetActionMessage = '다운로드 요청을 준비했습니다.';
        } else {
            this.datasetActionMessage = `${action} 요청을 준비했습니다.`;
        }

        await this.renderSafely();
    }

    public formatNumber(value: number) {
        return value.toLocaleString(this.currentLanguage === 'en' ? 'en-US' : 'ko-KR');
    }

    public formatSimilarity(value: number) {
        return `${Math.round(value * 100)}%`;
    }

    public getDatasetFileIcon(file: DatasetFile) {
        if (file.type === 'folder') return 'fa-folder';
        if (file.type === 'archive') return 'fa-file-zipper';
        return 'fa-image';
    }

    public getDatasetNodeIcon(type: string) {
        if (type === 'dataset') return 'fa-database';
        if (type === 'person') return 'fa-user';
        if (type === 'project') return 'fa-diagram-project';
        if (type === 'organization') return 'fa-building-columns';
        return 'fa-box-archive';
    }

    private createSubmitInstitutionGroups(): SubmitCollectionGroup[] {
        const domesticProviders = this.providerTabs.find((tab) => tab.id === 'domestic')?.items || [];
        const providers = new Map(domesticProviders.map((provider, index) => [this.getSubmitInstitutionId(provider, index), provider]));
        const createInstitution = (id: string, fallbackName: string, fallbackField = '과학기술 전분야', fallbackDatasets = '0'): SubmitCollection => {
            const provider = providers.get(id);
            const field = provider?.field || fallbackField;
            return {
                id,
                name: provider?.name || fallbackName,
                shortName: this.getSubmitInstitutionShortName(provider?.name || fallbackName),
                description: `${field} 연구데이터 등록 기관`,
                field,
                datasets: provider?.datasets || fallbackDatasets,
                files: provider?.files,
                logo: this.getSubmitInstitutionLogo(id),
            };
        };

        return [
            {
                label: '정부출연연구기관',
                items: [
                    createInstitution('kasi', '한국천문연구원', '천문학'),
                    createInstitution('kigam', '한국지질자원연구원', '지구과학'),
                    createInstitution('kriss', '한국표준연구원 국가참조표준센터', '참조표준'),
                    createInstitution('kisti', '한국과학기술정보연구원'),
                    createInstitution('kimm', '한국기계연구원'),
                    createInstitution('kiom', '한국한의학연구원', '보건의료'),
                    createInstitution('kaeri', '한국원자력연구원'),
                    createInstitution('etri', '한국전자통신연구원'),
                    createInstitution('kbsi', '한국기초과학지원연구원'),
                    createInstitution('kfe', '한국핵융합에너지연구원'),
                    createInstitution('kict', '한국건설기술연구원'),
                    createInstitution('nigt', '국가녹색기술연구소', '보건/기후'),
                    createInstitution('kitech', '한국생산기술연구원'),
                    createInstitution('krict', '한국화학연구원'),
                    createInstitution('kfri', '한국식품연구원', '사회과학'),
                    createInstitution('kist', '한국과학기술연구원'),
                ],
            },
            {
                label: '4대 과학기술원',
                items: [
                    createInstitution('kaist', '한국과학기술원'),
                    createInstitution('dgist', '대구경북과학기술원'),
                    createInstitution('gist', '광주과학기술원'),
                    createInstitution('unist', '울산과학기술원'),
                ],
            },
            {
                label: '직할연구기관',
                items: [
                    createInstitution('kias', '고등과학원', '수학·물리 기초과학', '4'),
                    createInstitution('ibs', '기초과학연구원', '기초과학', '8'),
                    createInstitution('kbri', '한국뇌연구원', '뇌과학', '6'),
                ],
            },
            {
                label: '우주항공청 산하 기관',
                items: [
                    createInstitution('kari', '한국항공우주연구원', '항공우주과학'),
                ],
            },
            {
                label: '해양수산부 산하 기관',
                items: [
                    createInstitution('kopri', '극지연구소', '극지관측'),
                    createInstitution('kiost', '한국해양과학기술원', '해양과학'),
                ],
            },
            {
                label: '기타',
                items: [
                    createInstitution('dataon', '국가연구데이터플랫폼'),
                    createInstitution('nifos', '국립산림과학원', '산림과학'),
                    createInstitution('ecobank', '국립생태원 Ecobank', '전분야'),
                    createInstitution('kcrc', '한국이산화탄소포집및처리연구개발센터', '대기/환경'),
                    createInstitution('jeju-basic-science', '제주대학교 기초과학연구소', '전분야'),
                    createInstitution('ml', 'KISTI 기계학습 데이터 공유 활용 서비스', '기계학습'),
                    createInstitution('daegu-edu-data', '대구교육데이터연구소', '전분야'),
                    createInstitution('aihub', 'AI 허브', '인공지능'),
                    createInstitution('nit', '국가독성과학연구소', '독성'),
                    createInstitution('kei', '한국환경연구원 데이터 포탈', '전분야'),
                    createInstitution('geoai', 'GeoAI 데이터학회', '전분야'),
                    createInstitution('kirams', '한국원자력의학원'),
                    createInstitution('nsr', '국가보안기술연구소', '전분야'),
                    createInstitution('global-bigdata-hub', '글로벌 대용량실험 데이터 허브센터', '생명과학'),
                    createInstitution('kipo', '특허청', '전분야'),
                ],
            },
        ];
    }

    private getSubmitInstitutionId(provider: HomeProvider, index: number) {
        const pathId = provider.path.split('/').filter(Boolean).pop();
        if (pathId) return pathId.replace(/[^a-z0-9-]/gi, '').toLowerCase();
        return `institution-${index + 1}`;
    }

    private getSubmitInstitutionShortName(name: string) {
        const englishName = name.match(/[A-Za-z0-9]+/g)?.join('');
        if (englishName) return englishName.slice(0, 10).toUpperCase();
        return name.replace(/\s+/g, '').slice(0, 4);
    }

    private getSubmitInstitutionLogo(id: string) {
        const logos: Record<string, string> = {
            dataon: '/assets/dataon/main_logo_ori.svg',
            openaire: '/assets/dataon/official/main/logo_track1_1.gif',
            ardc: '/assets/dataon/official/main/logo_track1_2.gif',
            irdb: '/assets/dataon/official/main/logo_track1_3.gif',
            fsd: '/assets/dataon/official/main/logo_track1_4.png',
            'data-govt-nz': '/assets/dataon/official/main/logo_track1_5.png',
            'harvard-dataverse': '/assets/dataon/official/main/logo_track1_6.png',
            frdr: '/assets/dataon/official/main/logo_track1_7.png',
            '4tu': '/assets/dataon/official/main/logo_track1_8.png',
            'dataon-global': '/assets/dataon/main_logo_ori.svg',
            kigam: '/assets/dataon/official/main/logo_track2_1.gif',
            kriss: '/assets/dataon/official/main/logo_track2_2.gif',
            kisti: '/assets/dataon/official/main/logo_track2_3.gif',
            'global-bigdata-hub': '/assets/dataon/official/main/logo_track2_4.gif',
            kitech: '/assets/dataon/official/main/logo_track2_10.gif',
            aihub: '/assets/dataon/official/main/logo_track2_6.png',
            kasi: '/assets/dataon/official/main/logo_track2_8.png',
            kiom: '/assets/dataon/official/main/logo_track2_7.gif',
            kari: '/assets/dataon/official/main/logo_track2_9.png',
            nifos: '/assets/dataon/official/main/logo_track2_17.png',
            kcrc: '/assets/dataon/official/contents/1-4-3_logo_18.gif',
            etri: '/assets/dataon/official/main/logo_track2_10.png',
            kopri: '/assets/dataon/official/contents/1-4-3_logo_19.gif',
            kfri: '/assets/dataon/official/main/logo_track2_14.png',
            kiost: '/assets/dataon/official/contents/1-4-3_logo_22.png',
            kei: '/assets/dataon/official/main/logo_track2_12.png',
            'daegu-edu-data': '/assets/dataon/official/main/logo_track2_13.png',
            ecobank: '/assets/dataon/official/main/logo_track2_11.png',
            kipo: '/assets/dataon/official/main/logo_track2_15.png',
        };

        return logos[id];
    }

    private removeSubmitManageRecord(recordId: number) {
        this.submitDraftRecords = this.submitDraftRecords.filter((record) => record.id !== recordId);
        this.submitArchivedRecords = this.submitArchivedRecords.filter((record) => record.id !== recordId);
    }

    private async renderSafely() {
        await Promise.resolve();
        try {
            this.ref.detectChanges();
        } catch (e) {
            this.ref.markForCheck();
        }

        const app = this.service.app as any;
        if (app?.ref?.detectChanges && app.ref !== this.ref) {
            try {
                await this.service.render();
            } catch (e) {
                app.ref.markForCheck?.();
            }
        }

        this.applyRuntimeLanguage();
    }

    private async syncCurrentRoute(path: string) {
        this.setCurrentPage(path || window.location.pathname + window.location.search);
        this.updateMobileQuickMenuVisibility();
        await this.renderSafely();
        await this.activateMapSearchIfNeeded();
    }

    private installHistoryRouteSync() {
        const win = window as typeof window & { __dataonHistoryRouteSyncInstalled?: boolean };
        if (win.__dataonHistoryRouteSyncInstalled) return;

        const dispatchLocationChange = () => {
            window.dispatchEvent(new Event('dataon-locationchange'));
        };

        (['pushState', 'replaceState'] as const).forEach((method) => {
            const original = history[method];
            history[method] = function (...args: Parameters<History[typeof method]>) {
                const result = original.apply(this, args);
                dispatchLocationChange();
                return result;
            } as History[typeof method];
        });

        window.addEventListener('popstate', dispatchLocationChange);
        win.__dataonHistoryRouteSyncInstalled = true;
    }

    private setCurrentPage(path: string) {
        const routeSearchMenuPage = this.findSearchMenuPageByPath(path, true);
        const candidates = this.resolvePathCandidates(path);
        let pathname = candidates.find((candidate) => this.isDatasetDetailPath(candidate)) || candidates[0] || '/';
        const routeLanguage = this.getLanguageFromPath(pathname);
        if (routeLanguage) {
            this.applyLanguage(routeLanguage);
            pathname = this.stripLanguageFromPath(pathname);
        }

        const isDatasetDetail = this.isDatasetDetailPath(pathname);
        const isMapSearch = !isDatasetDetail && this.isMapSearchPath(pathname);
        const isDatasetSearch = !isDatasetDetail && !isMapSearch && (Boolean(routeSearchMenuPage) || this.isDatasetSearchPath(pathname, true));
        const isSubmit = !isDatasetDetail && !isMapSearch && !isDatasetSearch && this.isSubmitPath(pathname);
        const servicePage = !isDatasetDetail && !isMapSearch && !isDatasetSearch && !isSubmit
            ? this.findServicePageByPath(pathname)
            : null;
        const isHome = !isDatasetDetail && !isMapSearch && !isDatasetSearch && !isSubmit && !servicePage && (pathname === '/' || pathname === '/dashboard');
        const isLogin = pathname === '/login' || pathname === '/user/userLogin.do';
        const isJoin = pathname === '/join' || pathname === '/signup' || pathname === '/user/userEmailSend.do' || pathname === '/join/complete';
        const searchMenuPage = isDatasetSearch ? routeSearchMenuPage || this.findSearchMenuPageByPath(pathname, true) : null;
        const currentPathname = searchMenuPage?.path || pathname;
        this.currentPath = currentPathname;
        this.isHomePage = isHome;
        this.isLoginPage = isLogin;
        this.isJoinPage = isJoin;
        this.isAuthPage = isLogin || isJoin;
        this.isDatasetSearchPage = isDatasetSearch;
        this.isDatasetDetailPage = isDatasetDetail;
        this.isMapSearchPage = isMapSearch;
        this.isSubmitPage = isSubmit;

        if (isDatasetSearch) {
            const normalizedDatasetSearchPath = this.normalizePath(currentPathname);
            const query = this.extractSearchQuery(path);
            const subject = this.extractDatasetSubjectQuery(path);
            const nextDatasetSearchRouteState = `${normalizedDatasetSearchPath}|${query}|${subject}`;
            const datasetSearchRouteChanged = this.lastDatasetSearchRouteState !== nextDatasetSearchRouteState;

            if (datasetSearchRouteChanged) {
                this.lastDatasetSearchRouteState = nextDatasetSearchRouteState;
                this.datasetSearchPage = 1;
                this.mobileResultFiltersOpen = false;
                this.resultWithinSearchText = '';
                this.appliedResultWithinSearchText = '';
                this.advancedSearchOpen = false;

                if (!subject) {
                    this.advancedSearchDraft = this.createEmptyAdvancedSearchValues();
                    this.appliedAdvancedSearch = this.createEmptyAdvancedSearchValues();
                    this.advancedSearchDraftMatchMode = 'all';
                    this.appliedAdvancedSearchMatchMode = 'all';
                    this.registeredYearStart = '';
                    this.registeredYearEnd = '';
                    this.appliedRegisteredYearStart = '';
                    this.appliedRegisteredYearEnd = '';
                }
            }

            this.searchText = query;
            this.appliedSearchText = query;
            this.semanticSearchMode = searchMenuPage?.forceSemantic || normalizedDatasetSearchPath === '/search/semantic' ? 'semantic' : 'keyword';
            if (subject) {
                this.applyDatasetSubjectFilter(subject);
            }
            if (searchMenuPage?.openAdvanced || normalizedDatasetSearchPath === '/search/detail') {
                this.advancedSearchOpen = true;
            }
        }

        if (!isDatasetSearch) {
            this.lastDatasetSearchRouteState = '';
        }

        if (isMapSearch) {
            const query = this.extractSearchQuery(path);
            if (query !== this.mapSearchRouteQuery) {
                this.mapSearchAppliedRouteQuery = '';
            }
            this.mapSearchRouteQuery = query;
            this.mapSearchQuery = query;
        }

        if (pathname === '/join/complete') {
            this.joinStep = 'complete';
        } else if (isJoin && this.joinStep === 'complete') {
            this.resetJoinFlow();
        }

        this.currentPage = isHome
            ? { label: '메인', path: '/', description: 'DataON 메인 페이지입니다.' }
            : isLogin
                ? { label: '로그인', path: '/login', description: 'DataON 로그인 페이지입니다.' }
                : isJoin
                    ? { label: pathname === '/join/complete' ? '관리자 승인 요청 완료' : '회원가입', path: pathname, description: 'DataON 회원가입 페이지입니다.' }
                    : isDatasetSearch
                        ? { label: searchMenuPage?.label || '검색', path: pathname, description: searchMenuPage?.description || '검색 조건에 맞는 목록을 확인하는 페이지입니다.' }
                    : isMapSearch
                        ? { label: '지도 검색', path: pathname, description: '지도 영역과 위치 조건으로 연구데이터를 탐색하는 페이지입니다.' }
                    : isSubmit
                        ? this.findPage(pathname)
                    : servicePage
                        ? { label: servicePage.label, path: servicePage.path, description: servicePage.description }
                    : isDatasetDetail
                        ? { label: this.datasetDetail.title.ko, path: pathname, description: this.datasetDetail.summary }
            : this.findPage(pathname);
    }

    private resolveCurrentPath(path: string) {
        return this.resolvePathCandidates(path)[0] || '/';
    }

    private resolvePathCandidates(path: string) {
        const wizRoutePath = (window as any).WizRoute?.path;
        const candidates = [
            path,
            window.location.pathname + window.location.search,
            wizRoutePath ? `/${wizRoutePath}` : '',
        ];

        return candidates
            .map((candidate) => this.normalizePath(candidate))
            .filter((candidate, index, list) => candidate && list.indexOf(candidate) === index);
    }

    private normalizePath(path: string) {
        const normalized = `${path || '/'}`.split('?')[0] || '/';
        const withSlash = normalized.startsWith('/') ? normalized : `/${normalized}`;
        return withSlash.length > 1 ? withSlash.replace(/\/+$/, '') : withSlash;
    }

    private findServicePageByPath(path: string) {
        const pathname = this.normalizePath(path);
        return this.servicePages.find((page) => {
            const paths = page.paths?.length ? page.paths : [page.path];
            return paths.some((item) => this.normalizePath(item) === pathname);
        }) || null;
    }

    private getSearchMenuPageById(id: SearchMenuPageId) {
        return this.searchMenuPages.find((page) => page.id === id) || null;
    }

    private findSearchMenuPageByOfficialQuery(path: string, includeLocation = false) {
        const candidates = includeLocation
            ? [
                path,
                window.location.pathname + window.location.search,
                window.location.href,
            ]
            : [path];

        for (const candidate of candidates) {
            try {
                const base = window.location.origin || 'https://prototype.dataon.seasonai.net';
                const url = new URL(candidate, base);
                const pathname = this.normalizePath(url.pathname);
                if (pathname !== '/search/index.do' && !pathname.endsWith('/search/index.do')) continue;

                const params = url.searchParams;
                if (params.get('covidMode') === 'Y') return this.getSearchMenuPageById('issue-covid');
                if (params.get('gpccMode') === 'Y') return this.getSearchMenuPageById('issue-gpcc');
                if (params.get('kaggleMode') === 'Y') return this.getSearchMenuPageById('issue-kaggle');

                const mode = (params.get('mode') || 'inout').toLowerCase();
                if (mode === 'soft') return this.getSearchMenuPageById('software');
                if (mode === 'all') return this.getSearchMenuPageById('integrated');
                if (mode === 'inout') return this.getSearchMenuPageById('datasets');
            } catch (e) {
                continue;
            }
        }

        return null;
    }

    private findSearchMenuPageByPath(path: string, includeLocation = false) {
        const officialQueryPage = this.findSearchMenuPageByOfficialQuery(path, includeLocation);
        if (officialQueryPage) return officialQueryPage;

        const pathname = this.normalizePath(path);
        return this.searchMenuPages.find((page) => {
            const paths = [page.path, ...(page.aliases || [])];
            return paths.some((item) => {
                const itemPath = this.normalizePath(item);
                return pathname === itemPath || pathname.endsWith(itemPath);
            });
        }) || null;
    }

    private isDatasetDetailPath(path: string) {
        const pathname = this.normalizePath(path);
        return pathname === '/search/datasets/detail'
            || pathname === `/dataset/${this.datasetDetail.datasetId}`
            || pathname.endsWith('/search/datasets/detail');
    }

    private isDatasetSearchPath(path: string, includeLocation = false) {
        return Boolean(this.findSearchMenuPageByPath(path, includeLocation));
    }

    private isMapSearchPath(path: string) {
        const pathname = this.normalizePath(path);
        return pathname === '/search/map'
            || pathname === '/search/mapSearchIndex.do'
            || pathname.endsWith('/search/map')
            || pathname.endsWith('/search/mapSearchIndex.do');
    }

    private isSubmitPath(path: string) {
        const pathname = this.normalizePath(path);
        return pathname === '/submit'
            || pathname === '/submit/manage'
            || pathname === '/submit/statistics'
            || pathname === '/submit/approval'
            || pathname.endsWith('/submit')
            || pathname.endsWith('/submit/manage')
            || pathname.endsWith('/submit/statistics')
            || pathname.endsWith('/submit/approval');
    }

    private extractSearchQuery(path: string) {
        const candidates = [
            path,
            window.location.pathname + window.location.search,
            window.location.href,
        ];

        for (const candidate of candidates) {
            const query = this.getQueryParam(candidate, 'q');
            if (query) return query;
        }

        return '';
    }

    private extractDatasetSubjectQuery(path: string) {
        const candidates = [
            path,
            window.location.pathname + window.location.search,
            window.location.href,
        ];

        for (const candidate of candidates) {
            const subject = this.getQueryParam(candidate, 'subject');
            if (subject) return subject;
        }

        return '';
    }

    private getQueryParam(path: string, key: string) {
        try {
            const base = window.location.origin || 'https://prototype.dataon.seasonai.net';
            const url = new URL(path, base);
            return url.searchParams.get(key)?.trim() || '';
        } catch (e) {
            return '';
        }
    }

    private sortDatasetSearchResults(results: DatasetSearchResult[], scoreGetter: (result: DatasetSearchResult) => number) {
        const items = [...results];

        if (this.datasetSearchSort === 'latest') {
            return items.sort((left, right) => {
                const dateCompare = right.updatedAt.localeCompare(left.updatedAt);
                return dateCompare || right.downloads - left.downloads || right.views - left.views;
            });
        }

        if (this.datasetSearchSort === 'created') {
            return items.sort((left, right) => {
                const dateCompare = right.createdAt.localeCompare(left.createdAt);
                return dateCompare
                    || right.updatedAt.localeCompare(left.updatedAt)
                    || right.downloads - left.downloads
                    || right.views - left.views;
            });
        }

        if (this.datasetSearchSort === 'downloads') {
            return items.sort((left, right) => {
                return right.downloads - left.downloads
                    || right.updatedAt.localeCompare(left.updatedAt)
                    || right.views - left.views;
            });
        }

        return items.sort((left, right) => {
            const scoreCompare = scoreGetter(right) - scoreGetter(left);
            return scoreCompare
                || right.downloads - left.downloads
                || right.updatedAt.localeCompare(left.updatedAt)
                || right.views - left.views;
        });
    }

    public getKeywordComparisonScore(result: DatasetSearchResult) {
        const score = this.getDatasetKeywordRelevanceScore(result, this.appliedSearchText.trim());
        return Math.min(98, Math.max(0, Math.round(score)));
    }

    public getKeywordMatchKeywords(result: DatasetSearchResult) {
        const keyword = this.appliedSearchText.trim();
        const haystack = this.normalizeDatasetSearchText(this.getDatasetSearchAllHaystack(result));
        const matched = new Set<string>();

        for (const group of this.getDatasetKeywordTermGroups(keyword)) {
            for (const term of group) {
                if (this.datasetSearchTextIncludes(haystack, term)) matched.add(term);
            }
        }

        result.keywords.forEach((term) => {
            if (this.datasetSearchTextIncludes(haystack, term)) matched.add(term);
        });

        return [...matched].filter((term) => term.length > 1).slice(0, 6);
    }

    public getKeywordMatchReason(result: DatasetSearchResult) {
        const keywords = this.getKeywordMatchKeywords(result);
        if (keywords.length) return `입력 검색어와 ${keywords.slice(0, 3).join(', ')} 키워드가 일치합니다.`;
        return `${result.subject} 분야의 키워드와 메타데이터를 기준으로 정렬된 결과입니다.`;
    }

    private getDatasetKeywordRelevanceScore(result: DatasetSearchResult, keyword: string) {
        const termGroups = this.getDatasetKeywordTermGroups(keyword);
        if (!termGroups.length) return result.downloads * 0.01 + result.views * 0.001;

        const haystack = this.normalizeDatasetSearchText(this.getDatasetSearchQueryHaystack(result));
        return termGroups.reduce((score, group) => {
            const matchedTerms = group.filter((term) => this.datasetSearchTextIncludes(haystack, term));
            if (!matchedTerms.length) return score;
            return score + 20 + Math.min(matchedTerms.length * 4, 16);
        }, 0);
    }

    public getSemanticRecommendation(result: DatasetSearchResult): DatasetSemanticRecommendation {
        const keyword = this.appliedSearchText.trim();
        const haystack = this.normalizeDatasetSearchText(this.getDatasetSearchAllHaystack(result));
        const activeRules = this.getDatasetSearchRuleMatches(keyword);
        const matchedKeywords = new Set<string>();
        const matchedReasons: string[] = [];
        let score = 0;

        if (!keyword) {
            return {
                score: Math.min(88, 42 + Math.round(result.downloads / 20)),
                reason: `${result.subject} 분야에서 활용도가 높은 샘플 데이터입니다.`,
                keywords: result.keywords.slice(0, 5),
            };
        }

        for (const rule of activeRules) {
            const ruleTerms = [rule.canonical, ...rule.terms, ...rule.related];
            const matchedTerms = ruleTerms.filter((term) => this.datasetSearchTextIncludes(haystack, term));
            if (!matchedTerms.length) continue;

            score += 32 + Math.min(matchedTerms.length * 7, 28);
            matchedKeywords.add(rule.canonical);
            matchedTerms.slice(0, 3).forEach((term) => matchedKeywords.add(term));
            if (!matchedReasons.includes(rule.reason)) matchedReasons.push(rule.reason);
        }

        const tokens = this.getDatasetSearchTokens(keyword);
        for (const token of tokens) {
            if (token.length < 2) continue;
            if (this.datasetSearchTextIncludes(haystack, token)) {
                score += 7;
                matchedKeywords.add(token);
            }
        }

        if (result.title.includes(keyword) || result.summary.includes(keyword)) score += 12;

        const keywords = [...matchedKeywords]
            .filter((value) => value.length > 1)
            .slice(0, 6);

        return {
            score: Math.min(98, Math.round(score)),
            reason: matchedReasons[0] || (keywords.length
                ? `입력 문장과 ${keywords.slice(0, 2).join(', ')} 키워드가 겹칩니다.`
                : '입력 문장과 직접 연결되는 의미 단서가 적습니다.'),
            keywords: keywords.length ? keywords : result.keywords.slice(0, 4),
        };
    }

    private getDatasetSearchAssistItems(keyword: string): DatasetSearchAssistItem[] {
        const tokens = this.normalizeDatasetSearchText(keyword)
            .split(/\s+/)
            .map((token) => ({
                raw: token.replace(/\s+/g, ''),
                normalized: this.normalizeDatasetSearchToken(token),
            }))
            .filter((token) => token.normalized.length > 0);
        const items: DatasetSearchAssistItem[] = [];
        const seen = new Set<string>();

        for (const token of tokens) {
            const correctionMatch = this.findDatasetSearchCorrection(token.raw);
            if (correctionMatch) {
                const key = `correction:${token.raw}:${correctionMatch.candidate.normalized}`;
                if (!seen.has(key)) {
                    seen.add(key);
                    items.push({
                        type: 'correction',
                        label: '오탈자 보정',
                        value: `${token.raw} → ${correctionMatch.candidate.term}`,
                    });
                }
            }

            const synonymToken = correctionMatch?.candidate.normalized || token.normalized;
            for (const rule of this.getDatasetSearchSynonymRules()) {
                const synonymMatched = [rule.canonical, ...rule.terms].some((term) => this.isDatasetSearchTermMatch(synonymToken, term));
                if (synonymMatched) {
                    const related = [rule.canonical, ...rule.terms, ...rule.related]
                        .filter((value) => !this.isDatasetSearchTermMatch(synonymToken, value))
                        .slice(0, 3);
                    const key = `synonym:${rule.canonical}`;
                    if (related.length && !seen.has(key)) {
                        seen.add(key);
                        items.push({
                            type: 'synonym',
                            label: '유의어 확장',
                            value: `${rule.canonical}: ${related.join(', ')}`,
                        });
                    }
                }
            }
        }

        return items.slice(0, 6);
    }

    private getDatasetKeywordTermGroups(keyword: string) {
        return this.getDatasetSearchTokens(keyword).map((token) => {
            const terms = new Set<string>([token]);
            const correctionMatch = this.findDatasetSearchCorrection(token);
            const synonymToken = correctionMatch?.candidate.normalized || token;

            if (correctionMatch) terms.add(correctionMatch.candidate.normalized);

            for (const rule of this.getDatasetSearchSynonymRules()) {
                const matched = [rule.canonical, ...rule.terms]
                    .some((term) => this.isDatasetSearchTermMatch(synonymToken, term));
                if (!matched) continue;
                [rule.canonical, ...rule.terms].forEach((term) => {
                    const normalized = this.normalizeDatasetSearchToken(term);
                    if (normalized) terms.add(normalized);
                });
            }

            return [...terms].filter((term) => term.length > 0);
        }).filter((group) => group.length > 0);
    }

    private getDatasetSearchRuleMatches(keyword: string) {
        const tokens = this.getDatasetSearchTokens(keyword);
        if (!tokens.length) return [];

        return this.getDatasetSearchSynonymRules().filter((rule) => {
            return tokens.some((token) => {
                const correctionMatch = this.findDatasetSearchCorrection(token);
                const synonymToken = correctionMatch?.candidate.normalized || token;
                return [rule.canonical, ...rule.terms]
                    .some((term) => this.isDatasetSearchTermMatch(synonymToken, term));
            });
        });
    }

    private getDatasetSearchSynonymRules(): DatasetSearchSynonymRule[] {
        return this.datasetSearchSynonymEntries
            .filter((entry) => entry.status === 'approved')
            .map((entry) => ({
                canonical: entry.canonical,
                terms: this.getUniqueDatasetSearchTerms(entry.synonyms),
                related: this.getUniqueDatasetSearchTerms(entry.related),
                reason: entry.reason,
                source: entry.source,
                status: entry.status,
            }));
    }

    private getDatasetSearchCandidateTerms(): DatasetSearchTermCandidate[] {
        if (this.datasetSearchTermCandidateCache) return this.datasetSearchTermCandidateCache;

        const candidates = new Map<string, DatasetSearchTermCandidate>();
        const addCandidate = (term: string, source: DatasetSearchTermSource, weight: number) => {
            const normalized = this.normalizeDatasetSearchToken(term);
            if (!this.canUseDatasetSearchTermCandidate(normalized)) return;

            const displayTerm = this.getDatasetSearchCandidateDisplayTerm(term, normalized);
            const existing = candidates.get(normalized);
            if (existing) {
                existing.count += 1;
                existing.weight += weight;
                if (!existing.sources.includes(source)) existing.sources.push(source);
                if (displayTerm.length < existing.term.length || existing.term === existing.normalized) {
                    existing.term = displayTerm;
                }
                return;
            }

            candidates.set(normalized, {
                term: displayTerm,
                normalized,
                sources: [source],
                weight,
                count: 1,
            });
        };

        for (const result of this.datasetSearchResults) {
            this.extractDatasetSearchCandidateTerms(result.title, true).forEach((term) => addCandidate(term, 'title', 14));
            this.extractDatasetSearchCandidateTerms(result.titleEn, true).forEach((term) => addCandidate(term, 'title', 8));
            result.keywords.forEach((keyword) => {
                this.extractDatasetSearchCandidateTerms(keyword, true).forEach((term) => addCandidate(term, 'keyword', 18));
            });
            this.extractDatasetSearchOrganizationTerms(result).forEach((term) => {
                this.extractDatasetSearchCandidateTerms(term, false).forEach((candidate) => addCandidate(candidate, 'organization', 10));
            });
        }

        this.datasetSearchTermCandidateCache = [...candidates.values()]
            .sort((left, right) => right.weight - left.weight || right.count - left.count || left.term.localeCompare(right.term, 'ko'));

        return this.datasetSearchTermCandidateCache;
    }

    private extractDatasetSearchCandidateTerms(text: string, includeAdjacentTerms: boolean) {
        const normalizedTokens = this.normalizeDatasetSearchText(text)
            .split(/\s+/)
            .map((token) => this.normalizeDatasetSearchToken(token))
            .filter((token, index, list) => this.canUseDatasetSearchTermCandidate(token) && list.indexOf(token) === index);
        const terms = new Set<string>(normalizedTokens);

        if (includeAdjacentTerms) {
            for (const size of [2, 3]) {
                for (let index = 0; index <= normalizedTokens.length - size; index += 1) {
                    const term = normalizedTokens.slice(index, index + size).join('');
                    if (this.canUseDatasetSearchTermCandidate(term)) terms.add(term);
                }
            }
        }

        return [...terms];
    }

    private extractDatasetSearchOrganizationTerms(result: DatasetSearchResult) {
        const terms = [
            result.provider,
            result.repository,
            result.publisher,
            result.performingOrganization,
            result.ministry,
            ...result.managers,
            ...result.contributors,
        ];

        for (const creator of result.creators) {
            const organizationMatch = creator.match(/\(([^)]+)\)/);
            if (organizationMatch?.[1]) terms.push(organizationMatch[1]);
        }

        return terms.filter((term) => term.trim().length > 0);
    }

    private getUniqueDatasetSearchTerms(terms: string[]) {
        const seen = new Set<string>();
        const uniqueTerms: string[] = [];

        for (const term of terms) {
            const normalized = this.normalizeDatasetSearchToken(term);
            if (!normalized || seen.has(normalized)) continue;
            seen.add(normalized);
            uniqueTerms.push(term);
        }

        return uniqueTerms;
    }

    private getDatasetSearchCandidateDisplayTerm(term: string, normalized: string) {
        const displayTerm = `${term || ''}`.replace(/\s+/g, ' ').trim();
        if (!displayTerm || displayTerm.length > 30) return normalized;
        return displayTerm;
    }

    private canUseDatasetSearchTermCandidate(term: string) {
        const normalized = this.normalizeDatasetSearchToken(term);
        const length = Array.from(normalized).length;
        const stopWords = this.datasetSearchCandidateStopWords.map((word) => this.normalizeDatasetSearchToken(word));

        if (!normalized || length < 2 || length > 24) return false;
        if (/^\d+$/.test(normalized)) return false;
        return !stopWords.includes(normalized);
    }

    private getCorrectedDatasetSearchText(keyword: string) {
        const rawTokens = this.normalizeDatasetSearchText(keyword)
            .split(/\s+/)
            .map((token) => token.replace(/\s+/g, ''))
            .filter((token) => token.length > 0);

        if (!rawTokens.length) return '';

        let changed = false;
        const correctedTokens = rawTokens.map((token) => {
            const correctionMatch = this.findDatasetSearchCorrection(token);
            if (!correctionMatch) return token;

            changed = true;
            return correctionMatch.candidate.term;
        });

        return changed ? correctedTokens.join(' ') : keyword.trim();
    }

    private findDatasetSearchCorrection(rawToken: string): DatasetSearchCorrectionMatch | null {
        const normalizedRawToken = this.normalizeDatasetSearchText(rawToken).replace(/\s+/g, '');
        const normalizedToken = this.normalizeDatasetSearchToken(rawToken);
        if (!normalizedRawToken || !normalizedToken) return null;

        let bestMatch: DatasetSearchCorrectionMatch | null = null;

        for (const candidate of this.getDatasetSearchCandidateTerms()) {
            if (normalizedToken === candidate.normalized) {
                if (normalizedRawToken === candidate.normalized) continue;
                return {
                    candidate,
                    score: 120 + candidate.weight,
                    editDistance: 0,
                    jamoSimilarity: 1,
                };
            }

            const match = this.getDatasetSearchCorrectionMatch(normalizedToken, candidate);
            if (!match) continue;
            if (!bestMatch || match.score > bestMatch.score) bestMatch = match;
        }

        return bestMatch;
    }

    private getDatasetSearchCorrectionMatch(token: string, candidate: DatasetSearchTermCandidate): DatasetSearchCorrectionMatch | null {
        if (!this.canCompareDatasetSearchCorrection(token, candidate.normalized)) return null;

        const editDistance = this.getDatasetSearchEditDistance(token, candidate.normalized);
        const maxLength = Math.max(Array.from(token).length, Array.from(candidate.normalized).length);
        const maxEditDistance = maxLength >= 8 ? 2 : 1;
        if (editDistance > maxEditDistance) return null;

        const jamoSimilarity = this.getDatasetSearchJamoSimilarity(token, candidate.normalized);
        const characterSimilarity = 1 - editDistance / maxLength;
        const containsHangul = this.containsDatasetSearchHangul(token) || this.containsDatasetSearchHangul(candidate.normalized);
        const similarityThreshold = containsHangul ? 0.78 : 0.74;

        if (jamoSimilarity < similarityThreshold && characterSimilarity < 0.82) return null;
        if (!this.hasCompatibleDatasetSearchPrefix(token, candidate.normalized, jamoSimilarity)) return null;

        return {
            candidate,
            score: jamoSimilarity * 100 + characterSimilarity * 40 + candidate.weight - editDistance * 12,
            editDistance,
            jamoSimilarity,
        };
    }

    private canCompareDatasetSearchCorrection(token: string, term: string) {
        if (!token || !term || token === term) return false;

        const tokenLength = Array.from(token).length;
        const termLength = Array.from(term).length;
        const maxLength = Math.max(tokenLength, termLength);
        const maxLengthGap = maxLength >= 8 ? 2 : 1;

        if (Math.min(tokenLength, termLength) < 3) return false;
        return Math.abs(tokenLength - termLength) <= maxLengthGap;
    }

    private hasCompatibleDatasetSearchPrefix(token: string, term: string, jamoSimilarity: number) {
        const tokenChars = Array.from(token);
        const termChars = Array.from(term);

        if (tokenChars[0] === termChars[0]) return true;
        return jamoSimilarity >= 0.9;
    }

    private getDatasetSearchEditDistance(left: string, right: string) {
        return this.getDatasetSearchUnitEditDistance(Array.from(left), Array.from(right));
    }

    private getDatasetSearchJamoSimilarity(left: string, right: string) {
        const leftUnits = this.getHangulJamoSearchUnits(left);
        const rightUnits = this.getHangulJamoSearchUnits(right);
        const maxLength = Math.max(leftUnits.length, rightUnits.length);
        if (!maxLength) return 0;
        return 1 - this.getDatasetSearchUnitEditDistance(leftUnits, rightUnits) / maxLength;
    }

    private getDatasetSearchUnitEditDistance(leftUnits: string[], rightUnits: string[]) {
        const previous = Array.from({ length: rightUnits.length + 1 }, (_, index) => index);

        for (let leftIndex = 0; leftIndex < leftUnits.length; leftIndex += 1) {
            const current = [leftIndex + 1];
            for (let rightIndex = 0; rightIndex < rightUnits.length; rightIndex += 1) {
                const cost = leftUnits[leftIndex] === rightUnits[rightIndex] ? 0 : 1;
                current[rightIndex + 1] = Math.min(
                    current[rightIndex] + 1,
                    previous[rightIndex + 1] + 1,
                    previous[rightIndex] + cost,
                );
            }
            previous.splice(0, previous.length, ...current);
        }

        return previous[rightUnits.length];
    }

    private getHangulJamoSearchUnits(text: string) {
        const units: string[] = [];

        for (const char of Array.from(text)) {
            const code = char.charCodeAt(0);
            if (code < 0xac00 || code > 0xd7a3) {
                units.push(char);
                continue;
            }

            const hangulIndex = code - 0xac00;
            const initial = Math.floor(hangulIndex / 588);
            const medial = Math.floor((hangulIndex % 588) / 28);
            const final = hangulIndex % 28;
            units.push(`i${initial}`, `m${medial}`);
            if (final > 0) units.push(`f${final}`);
        }

        return units;
    }

    private containsDatasetSearchHangul(text: string) {
        return /[가-힣]/.test(text);
    }

    private getDatasetSearchTokens(text: string) {
        return this.normalizeDatasetSearchText(text)
            .split(/\s+/)
            .map((token) => this.normalizeDatasetSearchToken(token))
            .filter((token, index, list) => token.length > 0 && list.indexOf(token) === index);
    }

    private normalizeDatasetSearchText(text: string) {
        return `${text || ''}`
            .toLowerCase()
            .replace(/데이타/g, '데이터')
            .replace(/[^\p{L}\p{N}.+-]+/gu, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    private normalizeDatasetSearchToken(token: string) {
        let normalized = this.normalizeDatasetSearchText(token).replace(/\s+/g, '');
        const suffixes = ['으로', '에서', '에게', '부터', '까지', '하고', '하며', '하는', '관련', '데이터', '자료', '을', '를', '이', '가', '은', '는', '의', '와', '과', '로'];
        let changed = true;

        while (changed) {
            changed = false;
            for (const suffix of suffixes) {
                if (normalized.endsWith(suffix) && normalized.length > suffix.length + 1) {
                    normalized = normalized.slice(0, -suffix.length);
                    changed = true;
                    break;
                }
            }
        }

        return normalized;
    }

    private isDatasetSearchTermMatch(token: string, term: string) {
        const normalizedTerm = this.normalizeDatasetSearchToken(term);
        if (!token || !normalizedTerm) return false;
        if (token === normalizedTerm) return true;
        return token.length >= 2 && normalizedTerm.includes(token)
            || normalizedTerm.length >= 2 && token.includes(normalizedTerm);
    }

    private datasetSearchTextIncludes(haystack: string, term: string) {
        const normalizedTerm = this.normalizeDatasetSearchToken(term);
        if (!normalizedTerm) return false;
        return haystack.replace(/\s+/g, '').includes(normalizedTerm);
    }

    private matchesDatasetSearchQuery(result: DatasetSearchResult, keyword: string) {
        const termGroups = this.getDatasetKeywordTermGroups(keyword);

        if (termGroups.length === 0) return true;

        const haystack = this.normalizeDatasetSearchText(this.getDatasetSearchQueryHaystack(result));

        return termGroups.every((group) => {
            return group.some((term) => this.datasetSearchTextIncludes(haystack, term));
        });
    }

    private matchesDatasetResultWithinSearch(result: DatasetSearchResult) {
        const keyword = this.appliedResultWithinSearchText.trim();
        if (!keyword) return true;

        const termGroups = this.getDatasetKeywordTermGroups(keyword);
        if (termGroups.length === 0) return true;

        const haystack = this.normalizeDatasetSearchText(this.getDatasetSearchAllHaystack(result));
        return termGroups.every((group) => group.some((term) => this.datasetSearchTextIncludes(haystack, term)));
    }

    private matchesSearchMenuPage(result: DatasetSearchResult, page: SearchMenuPageConfig) {
        if (page.searchTargets?.length) {
            const targetMatched = page.searchTargets.includes(result.searchTarget) || page.searchTargets.includes(result.dataType);
            if (!targetMatched) return false;
        }

        if (page.requiredKeywords?.length) {
            const haystack = this.normalizeDatasetSearchText(this.getDatasetSearchAllHaystack(result));
            return page.requiredKeywords.some((keyword) => this.datasetSearchTextIncludes(haystack, keyword));
        }

        return true;
    }

    private matchesDatasetAdvancedSearch(result: DatasetSearchResult) {
        const fields = [...this.advancedSearchPrimaryFields, ...this.advancedSearchProjectFields];
        const conditionMatches: boolean[] = [];

        for (const field of fields) {
            const selectedValues = this.getEffectiveAdvancedValues(this.appliedAdvancedSearch, field.key);
            if (selectedValues.length === 0) continue;

            if (field.key === 'createdYear') {
                conditionMatches.push(this.matchesDatasetCreatedYear(result, selectedValues));
                continue;
            }

            const resultValues = this.getDatasetAdvancedFieldValues(result, field.key);
            const normalizedResultValues = resultValues.map((value) => value.toLowerCase());
            const matched = field.type === 'text'
                ? selectedValues.some((value) => normalizedResultValues.some((resultValue) => resultValue.includes(value.toLowerCase())))
                : selectedValues.some((value) => resultValues.includes(value));

            conditionMatches.push(matched);
        }

        if (conditionMatches.length === 0) return true;
        return this.appliedAdvancedSearchMatchMode === 'all'
            ? conditionMatches.every(Boolean)
            : conditionMatches.some(Boolean);
    }

    private getDatasetSearchQueryHaystack(result: DatasetSearchResult) {
        const scope = this.appliedAdvancedSearch.searchScope[0] || 'all';

        if (scope === 'title') return [result.title, result.titleEn].join(' ');
        if (scope === 'summary') return result.summary;
        if (scope === 'keywords') return result.keywords.join(' ');
        if (scope === 'provider') return [result.provider, result.repository, result.publisher].join(' ');

        return this.getDatasetSearchAllHaystack(result);
    }

    private getDatasetSearchAllHaystack(result: DatasetSearchResult) {
        return [
            result.title,
            result.titleEn,
            result.summary,
            result.searchTarget,
            result.accessRight,
            result.provider,
            result.repository,
            result.publisher,
            result.projectName,
            result.principalInvestigator,
            result.performingOrganization,
            result.ministry,
            result.researcherNumber,
            result.ntisProjectNumber,
            result.license,
            result.subject,
            result.domesticOrInternational,
            ...result.creators,
            ...result.managers,
            ...result.contributors,
            ...result.keywords,
            ...result.badges,
            ...result.fileTypes,
        ].join(' ');
    }

    private getDatasetAdvancedFieldValues(result: DatasetSearchResult, key: DatasetSearchAdvancedFieldKey) {
        if (key === 'searchTarget') return [result.searchTarget];
        if (key === 'subject') return [result.subject];
        if (key === 'fileType') return this.getDatasetFileTypeCategories(result);
        if (key === 'createdYear') return [result.createdYear];
        if (key === 'accessRight') return [result.accessRight];
        if (key === 'publisher') return [result.publisher];
        if (key === 'creator') return result.creators;
        if (key === 'contributor') return result.contributors;
        if (key === 'manager') return result.managers;
        if (key === 'provider') return [result.provider];
        if (key === 'repository') return [result.repository];
        if (key === 'projectName') return [result.projectName];
        if (key === 'principalInvestigator') return [result.principalInvestigator];
        if (key === 'performingOrganization') return [result.performingOrganization];
        if (key === 'ministry') return [result.ministry];
        if (key === 'researcherNumber') return [result.researcherNumber];
        if (key === 'ntisProjectNumber') return [result.ntisProjectNumber];
        return [];
    }

    private matchesDatasetCreatedYear(result: DatasetSearchResult, selectedValues: string[]) {
        const selectedValue = selectedValues[0];
        const resultYear = Number(result.createdYear);
        const currentYear = new Date().getFullYear();

        if (!Number.isFinite(resultYear)) return false;
        if (selectedValue === 'recent1') return resultYear >= currentYear;
        if (selectedValue === 'recent3') return resultYear >= currentYear - 2;
        if (selectedValue === 'recent5') return resultYear >= currentYear - 4;

        if (selectedValue === 'custom') {
            const startYear = Number(this.appliedAdvancedSearch.createdYearStart[0]);
            const endYear = Number(this.appliedAdvancedSearch.createdYearEnd[0]);
            const hasStartYear = Number.isFinite(startYear) && startYear > 0;
            const hasEndYear = Number.isFinite(endYear) && endYear > 0;

            if (!hasStartYear && !hasEndYear) return true;
            if (hasStartYear && resultYear < startYear) return false;
            if (hasEndYear && resultYear > endYear) return false;
            return true;
        }

        return selectedValues.includes(result.createdYear);
    }

    private matchesRegisteredYearFilter(result: DatasetSearchResult) {
        const resultYear = Number(result.createdAt.slice(0, 4));
        const startYear = Number(this.appliedRegisteredYearStart);
        const endYear = Number(this.appliedRegisteredYearEnd);
        const hasStartYear = Number.isFinite(startYear) && startYear > 0;
        const hasEndYear = Number.isFinite(endYear) && endYear > 0;

        if (!hasStartYear && !hasEndYear) return true;
        if (!Number.isFinite(resultYear)) return false;
        if (hasStartYear && resultYear < startYear) return false;
        if (hasEndYear && resultYear > endYear) return false;
        return true;
    }

    private getAdvancedSearchField(key: DatasetSearchAdvancedFieldKey) {
        return [...this.advancedSearchPrimaryFields, ...this.advancedSearchProjectFields].find((field) => field.key === key);
    }

    private getResultFilterField(key: DatasetSearchAdvancedFieldKey) {
        return this.resultFilterFieldDefinitions.find((field) => field.key === key) || this.getAdvancedSearchField(key);
    }

    private createResultFilterOptions(key: DatasetSearchAdvancedFieldKey, results: DatasetSearchResult[]) {
        const counts = new Map<string, number>();

        for (const result of results) {
            for (const value of this.getDatasetAdvancedFieldValues(result, key)) {
                const normalizedValue = value.trim();
                if (!normalizedValue || this.isDefaultAdvancedValue(key, normalizedValue)) continue;

                counts.set(normalizedValue, (counts.get(normalizedValue) || 0) + 1);
            }
        }

        for (const selectedValue of [
            ...this.getEffectiveAdvancedValues(this.advancedSearchDraft, key),
            ...this.getEffectiveAdvancedValues(this.appliedAdvancedSearch, key),
        ]) {
            if (!counts.has(selectedValue)) counts.set(selectedValue, 0);
        }

        return [...counts.entries()]
            .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], 'ko'))
            .map(([value, count]) => ({
                label: this.getResultFilterOptionLabel(key, value),
                value,
                count,
            }));
    }

    private getResultFilterOptionLabel(key: DatasetSearchAdvancedFieldKey, value: string) {
        const advancedField = this.getAdvancedSearchField(key);
        return advancedField?.options?.find((option) => option.value === value)?.label || value;
    }

    private getAdvancedSearchValueLabel(field: DatasetSearchAdvancedField, value: string, values?: DatasetSearchAdvancedValues) {
        if (field.key === 'createdYear' && value === 'custom') {
            const startYear = values?.createdYearStart?.[0] || '';
            const endYear = values?.createdYearEnd?.[0] || '';
            if (startYear || endYear) return `${startYear || '시작'}~${endYear || '종료'}`;
        }

        return field.options?.find((option) => option.value === value)?.label || value;
    }

    private getAdvancedSearchFilters(values: DatasetSearchAdvancedValues): DatasetSearchAppliedFilter[] {
        const fields = [...this.advancedSearchPrimaryFields, ...this.advancedSearchProjectFields];

        return fields.flatMap((field) => {
            const fieldValues = values[field.key] || [];
            return fieldValues
                .filter((value) => !this.isDefaultAdvancedValue(field.key, value))
                .filter((value) => value.trim().length > 0)
                .map((value) => ({
                    key: field.key,
                    label: field.label,
                    value,
                    displayValue: this.getAdvancedSearchValueLabel(field, value, values),
                }));
        });
    }

    private groupAdvancedSearchFilters(filters: DatasetSearchAppliedFilter[]): DatasetSearchSummaryFilter[] {
        const groupedFilters = new Map<DatasetSearchAdvancedFieldKey, DatasetSearchSummaryFilter>();

        for (const filter of filters) {
            const currentFilter = groupedFilters.get(filter.key);

            if (currentFilter) {
                currentFilter.values.push(filter.value);
                currentFilter.displayValue = `${currentFilter.displayValue}, ${filter.displayValue}`;
            } else {
                groupedFilters.set(filter.key, {
                    key: filter.key,
                    label: filter.label,
                    values: [filter.value],
                    displayValue: filter.displayValue,
                });
            }
        }

        return [...groupedFilters.values()];
    }

    private getAdvancedFieldsByKeys(keys: DatasetSearchAdvancedFieldKey[]) {
        const fields = this.advancedSearchProjectFields;
        return keys
            .map((key) => fields.find((field) => field.key === key))
            .filter((field): field is DatasetSearchAdvancedField => Boolean(field));
    }

    private getAdvancedGroupDraftSummary(fields: DatasetSearchAdvancedField[]) {
        const fieldKeys = new Set(fields.map((field) => field.key));
        const filters = this.advancedSearchDraftFilters.filter((filter) => fieldKeys.has(filter.key));

        if (!filters.length) return '선택 없음';

        const summary = filters
            .slice(0, 2)
            .map((filter) => `${filter.label}: ${filter.displayValue}`)
            .join(' · ');

        return filters.length > 2 ? `${summary} 외 ${filters.length - 2}개` : `${summary} ${filters.length}개`;
    }

    private countAdvancedSearchValues(values: DatasetSearchAdvancedValues) {
        const keys = Object.keys(values) as DatasetSearchAdvancedFieldKey[];
        return keys
            .filter((key) => !['searchScope', 'createdYearStart', 'createdYearEnd'].includes(key))
            .reduce((total, key) => total + this.getEffectiveAdvancedValues(values, key).length, 0);
    }

    private getEffectiveAdvancedValues(values: DatasetSearchAdvancedValues, key: DatasetSearchAdvancedFieldKey) {
        return (values[key] || [])
            .map((value) => value.trim())
            .filter((value) => value.length > 0)
            .filter((value) => !this.isDefaultAdvancedValue(key, value));
    }

    private isDefaultAdvancedValue(key: DatasetSearchAdvancedFieldKey, value: string) {
        return this.isDefaultableAdvancedField(key) && value === 'all';
    }

    private isDefaultableAdvancedField(key: DatasetSearchAdvancedFieldKey) {
        return ['searchScope', 'searchTarget', 'subject', 'fileType', 'createdYear', 'accessRight'].includes(key);
    }

    private getDatasetFileTypeCategories(result: DatasetSearchResult) {
        const categories = new Set<string>();

        for (const type of result.fileTypes) {
            const normalizedType = type.trim().toUpperCase();
            if (!normalizedType) continue;

            if (['PNG', 'JPG', 'JPEG', 'GIF', 'BMP', 'TIF', 'TIFF', 'WEBP'].includes(normalizedType)) {
                categories.add('이미지');
            } else if (['PDF', 'DOC', 'DOCX', 'HWP', 'HWPX', 'TXT', 'XLS', 'XLSX', 'PPT', 'PPTX'].includes(normalizedType)) {
                categories.add('문서');
            } else if (['MP4', 'MOV', 'AVI', 'MPEG', 'MPG', 'WEBM'].includes(normalizedType)) {
                categories.add('영상');
            } else if (['ZIP', '7Z', 'RAR', 'TAR', 'GZ'].includes(normalizedType)) {
                categories.add('압축파일');
            } else {
                categories.add(normalizedType);
            }
        }

        return [...categories];
    }

    private syncAdvancedSearchDraftFromApplied() {
        this.advancedSearchDraft = this.cloneAdvancedSearchValues(this.appliedAdvancedSearch);
        this.advancedSearchDraftMatchMode = this.appliedAdvancedSearchMatchMode;
    }

    private isAdvancedSearchValuesEqual(left: DatasetSearchAdvancedValues, right: DatasetSearchAdvancedValues) {
        const keys = Object.keys(left) as DatasetSearchAdvancedFieldKey[];
        return keys.every((key) => this.isStringArrayEqual(left[key], right[key]));
    }

    private isStringArrayEqual(left: string[], right: string[]) {
        if (left.length !== right.length) return false;
        return left.every((value, index) => value === right[index]);
    }

    private cloneAdvancedSearchValues(values: DatasetSearchAdvancedValues): DatasetSearchAdvancedValues {
        return {
            searchScope: [...values.searchScope],
            searchTarget: [...values.searchTarget],
            subject: [...values.subject],
            fileType: [...values.fileType],
            createdYear: [...values.createdYear],
            createdYearStart: [...values.createdYearStart],
            createdYearEnd: [...values.createdYearEnd],
            accessRight: [...values.accessRight],
            publisher: [...values.publisher],
            creator: [...values.creator],
            contributor: [...values.contributor],
            manager: [...values.manager],
            provider: [...values.provider],
            repository: [...values.repository],
            projectName: [...values.projectName],
            principalInvestigator: [...values.principalInvestigator],
            performingOrganization: [...values.performingOrganization],
            ministry: [...values.ministry],
            researcherNumber: [...values.researcherNumber],
            ntisProjectNumber: [...values.ntisProjectNumber],
        };
    }

    private createEmptyAdvancedSearchValues(): DatasetSearchAdvancedValues {
        return {
            searchScope: ['all'],
            searchTarget: ['all'],
            subject: ['all'],
            fileType: ['all'],
            createdYear: ['all'],
            createdYearStart: [],
            createdYearEnd: [],
            accessRight: ['all'],
            publisher: [],
            creator: [],
            contributor: [],
            manager: [],
            provider: [],
            repository: [],
            projectName: [],
            principalInvestigator: [],
            performingOrganization: [],
            ministry: [],
            researcherNumber: [],
            ntisProjectNumber: [],
        };
    }

    private resetJoinFlow() {
        this.joinStep = 'role';
        this.joinEmail = { address: '', code: '' };
        this.joinEmailCodeSent = false;
        this.joinAgreement = {
            terms: false,
            privacy: false,
            rolePolicy: false,
        };
        this.joinRole = 'general';
        this.joinProfile = {
            name: '',
            organization: '',
            department: '',
            purpose: '',
        };
        this.joinMessage = '';
        this.clearJoinFieldMessages();
    }

    private isValidEmail(email: string) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    private clearJoinFieldMessages(fields?: JoinFieldKey[]) {
        const targetFields: JoinFieldKey[] = fields || ['name', 'organization', 'email', 'code'];
        for (const field of targetFields) {
            this.joinFieldMessages[field] = '';
            this.joinFieldMessageTone[field] = '';
        }
    }

    private findPage(pathname: string): LinkItem {
        const links: LinkItem[] = [
            ...this.utilityLinks,
            ...this.searchActions,
            ...this.serviceCards,
            ...this.fields,
            ...this.notices.map((notice) => ({ label: notice.title, path: notice.path })),
            ...this.bottomLinks,
            ...this.footerLinks,
            ...this.extraPages,
        ];

        for (const group of this.navItems) {
            links.push(group);
            links.push(...group.children);
        }

        const found = links.find((item) => item.path === pathname);
        if (found) return found;

        return {
            label: this.toPathTitle(pathname),
            path: pathname,
            description: '선택한 메뉴의 상세 콘텐츠가 표시될 예정인 페이지입니다.',
        };
    }

    private toPathTitle(pathname: string) {
        const lastSegment = pathname.split('/').filter(Boolean).pop();
        if (!lastSegment) return '페이지';

        return decodeURIComponent(lastSegment)
            .replace(/[-_]/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase());
    }
}

export default PageDashboardComponent;